// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3E%3Cpath fill=%27%23ffffff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 4%27%3E%3Cpath stroke=%27%23ffffff%27 d=%27M0 2h4%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3E%3Ccircle r=%273%27 fill=%27%23ffffff%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 5%27%3E%3Cpath fill=%27%2332325d%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml %21default;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%2834, 42, 66, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28255, 255, 255, 0.95%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23ffffff%27 viewBox=%270 0 8 8%27%3E%3Cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23ffffff%27 viewBox=%270 0 8 8%27%3E%3Cpath d=%27M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
 =========================================================
 * Black Dashboard React v1.1.0 based on Black Dashboard - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/black-dashboard-react
 * Copyright 2020 Creative Tim (https://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

 * Coded by Creative Tim

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
/*     brand Colors              */
/* navbar color */
:root {
  --blue: #5e72e4;
  --indigo: #5603ad;
  --purple: #8965e0;
  --pink: #f3a4b5;
  --red: #f5365c;
  --orange: #fb6340;
  --yellow: #ffd600;
  --green: #2dce89;
  --teal: #11cdef;
  --cyan: #2bffc6;
  --white: #ffffff;
  --gray: #6c757d;
  --gray-dark: #32325d;
  --light: #ced4da;
  --lighter: #e9ecef;
  --primary: #e14eca;
  --secondary: #f4f5f7;
  --success: #00f2c3;
  --info: #1d8cf8;
  --warning: #ff8d72;
  --danger: #fd5d93;
  --light: #adb5bd;
  --dark: #212529;
  --default: #344675;
  --white: #ffffff;
  --neutral: #ffffff;
  --darker: black;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: rgba(34, 42, 66, 0);
}
article,
aside,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
  display: block;
}

body {
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #525f7f;
  text-align: left;
  background-color: #1e1e2f;
}

[tabindex="-1"]:focus {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

dfn {
  font-style: italic;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #e14eca;
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
}
a:hover {
  color: rgb(75.9505541347%, 12.8729752771%, 66.0812730889%);
  text-decoration: none;
}

a:not([href]):not([tabindex]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([tabindex]):hover, a:not([href]):not([tabindex]):focus {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([tabindex]):focus {
  outline: 0;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 1rem;
  padding-bottom: 1rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

button,
html [type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

input[type=date],
input[type=time],
input[type=datetime-local],
input[type=month] {
  -webkit-appearance: listbox;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-cancel-button,
[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.2;
  color: #32325d;
}

h1, .h1 {
  font-size: 2.0624999938rem;
}

h2, .h2 {
  font-size: 1.687499975rem;
}

h3, .h3 {
  font-size: 1.437499875rem;
}

h4, .h4 {
  font-size: 1.0624999875rem;
}

h5, .h5 {
  font-size: 0.812499975rem;
}

h6, .h6 {
  font-size: 0.74999995rem;
}

.lead {
  font-size: 0.78125rem;
  font-weight: 300;
}

.display-1 {
  font-size: 3.3rem;
  font-weight: 600;
  line-height: 1.2;
}

.display-2 {
  font-size: 2.75rem;
  font-weight: 600;
  line-height: 1.2;
}

.display-3 {
  font-size: 2.1875rem;
  font-weight: 600;
  line-height: 1.2;
}

.display-4 {
  font-size: 1.6275rem;
  font-weight: 600;
  line-height: 1.2;
}

hr {
  margin-top: 2rem;
  margin-bottom: 2rem;
  border: 0;
  border-top: 0.0625rem solid rgba(34, 42, 66, 0.1);
}

small,
.small {
  font-size: 80%;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 0.9625rem;
}

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #1e1e2f;
  border: 0.0625rem solid #e3e3e3;
  border-radius: 0.25rem;
  box-shadow: 0 1px 2px rgba(34, 42, 66, 0.075);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #6c757d;
}

code {
  font-size: 87.5%;
  color: #f3a4b5;
  word-break: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #ffffff;
  background-color: #212529;
  border-radius: 0.2857rem;
  box-shadow: inset 0 -0.1rem 0 rgba(34, 42, 66, 0.25);
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 600;
  box-shadow: none;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

.container-fluid {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  margin-top: 15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: none;
}

.col-1 {
  flex: 0 0 8.3333333333%;
  max-width: 8.3333333333%;
}

.col-2 {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.col-5 {
  flex: 0 0 41.6666666667%;
  max-width: 41.6666666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.3333333333%;
  max-width: 58.3333333333%;
}

.col-8 {
  flex: 0 0 66.6666666667%;
  max-width: 66.6666666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.3333333333%;
  max-width: 83.3333333333%;
}

.col-11 {
  flex: 0 0 91.6666666667%;
  max-width: 91.6666666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.3333333333%;
}

.offset-2 {
  margin-left: 16.6666666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.3333333333%;
}

.offset-5 {
  margin-left: 41.6666666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.3333333333%;
}

.offset-8 {
  margin-left: 66.6666666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.3333333333%;
}

.offset-11 {
  margin-left: 91.6666666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .col-sm-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.3333333333%;
  }
  .offset-sm-2 {
    margin-left: 16.6666666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.3333333333%;
  }
  .offset-sm-5 {
    margin-left: 41.6666666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.3333333333%;
  }
  .offset-sm-8 {
    margin-left: 66.6666666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.3333333333%;
  }
  .offset-sm-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .col-md-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-md-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-md-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-md-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-md-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.3333333333%;
  }
  .offset-md-2 {
    margin-left: 16.6666666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.3333333333%;
  }
  .offset-md-5 {
    margin-left: 41.6666666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.3333333333%;
  }
  .offset-md-8 {
    margin-left: 66.6666666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.3333333333%;
  }
  .offset-md-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .col-lg-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.3333333333%;
  }
  .offset-lg-2 {
    margin-left: 16.6666666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.3333333333%;
  }
  .offset-lg-5 {
    margin-left: 41.6666666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.3333333333%;
  }
  .offset-lg-8 {
    margin-left: 66.6666666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.3333333333%;
  }
  .offset-lg-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .col-xl-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.3333333333%;
  }
  .offset-xl-2 {
    margin-left: 16.6666666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.3333333333%;
  }
  .offset-xl-5 {
    margin-left: 41.6666666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.3333333333%;
  }
  .offset-xl-8 {
    margin-left: 66.6666666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.3333333333%;
  }
  .offset-xl-11 {
    margin-left: 91.6666666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}
.table th,
.table td {
  padding: 1rem;
  vertical-align: top;
  border-top: 0.0625rem solid #e3e3e3;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 0.125rem solid #e3e3e3;
}
.table tbody + tbody {
  border-top: 0.125rem solid #e3e3e3;
}
.table .table {
  background-color: #1e1e2f;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 0.0625rem solid #e3e3e3;
}
.table-bordered th,
.table-bordered td {
  border: 0.0625rem solid #e3e3e3;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 0.125rem;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(34, 42, 66, 0.05);
}

.table-hover tbody tr:hover {
  background-color: rgba(34, 42, 66, 0.075);
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: rgb(96.7058823529%, 80.5647058824%, 94.1803921569%);
}

.table-hover .table-primary:hover {
  background-color: rgb(95.2566069906%, 72.0139812447%, 91.6200056834%);
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: rgb(95.2566069906%, 72.0139812447%, 91.6200056834%);
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: rgb(98.7921568627%, 98.9019607843%, 99.1215686275%);
}

.table-hover .table-secondary:hover {
  background-color: rgb(93.0026831785%, 93.6388028896%, 94.9110423117%);
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: rgb(93.0026831785%, 93.6388028896%, 94.9110423117%);
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: rgb(72%, 98.5725490196%, 93.4117647059%);
}

.table-hover .table-success:hover {
  background-color: rgb(62.4850746269%, 98.0874743927%, 91.1729587357%);
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: rgb(62.4850746269%, 98.0874743927%, 91.1729587357%);
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: rgb(75.1843137255%, 87.3725490196%, 99.231372549%);
}

.table-hover .table-info:hover {
  background-color: rgb(65.48474291%, 82.436926702%, 98.9309433645%);
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: rgb(65.48474291%, 82.436926702%, 98.9309433645%);
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: rgb(100%, 87.4823529412%, 84.5176470588%);
}

.table-hover .table-warning:hover {
  background-color: rgb(100%, 79.3972465582%, 74.5176470588%);
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: rgb(100%, 79.3972465582%, 74.5176470588%);
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: rgb(99.7803921569%, 82.2117647059%, 88.1411764706%);
}

.table-hover .table-danger:hover {
  background-color: rgb(99.6584409374%, 72.3337159254%, 81.5558106169%);
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: rgb(99.6584409374%, 72.3337159254%, 81.5558106169%);
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: rgb(90.9960784314%, 91.8745098039%, 92.7529411765%);
}

.table-hover .table-light:hover {
  background-color: rgb(85.4555378908%, 86.8745098039%, 88.293481717%);
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: rgb(85.4555378908%, 86.8745098039%, 88.293481717%);
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: rgb(75.6235294118%, 76.062745098%, 76.5019607843%);
}

.table-hover .table-dark:hover {
  background-color: rgb(70.5317862925%, 71.062745098%, 71.5937039036%);
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: rgb(70.5317862925%, 71.062745098%, 71.5937039036%);
}

.table-default,
.table-default > th,
.table-default > td {
  background-color: rgb(77.7098039216%, 79.6862745098%, 84.8470588235%);
}

.table-hover .table-default:hover {
  background-color: rgb(71.7567247427%, 74.2610545685%, 80.8001380024%);
}
.table-hover .table-default:hover > td,
.table-hover .table-default:hover > th {
  background-color: rgb(71.7567247427%, 74.2610545685%, 80.8001380024%);
}

.table-white,
.table-white > th,
.table-white > td {
  background-color: white;
}

.table-hover .table-white:hover {
  background-color: rgb(95%, 95%, 95%);
}
.table-hover .table-white:hover > td,
.table-hover .table-white:hover > th {
  background-color: rgb(95%, 95%, 95%);
}

.table-neutral,
.table-neutral > th,
.table-neutral > td {
  background-color: white;
}

.table-hover .table-neutral:hover {
  background-color: rgb(95%, 95%, 95%);
}
.table-hover .table-neutral:hover > td,
.table-hover .table-neutral:hover > th {
  background-color: rgb(95%, 95%, 95%);
}

.table-darker,
.table-darker > th,
.table-darker > td {
  background-color: rgb(72%, 72%, 72%);
}

.table-hover .table-darker:hover {
  background-color: rgb(67%, 67%, 67%);
}
.table-hover .table-darker:hover > td,
.table-hover .table-darker:hover > th {
  background-color: rgb(67%, 67%, 67%);
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(34, 42, 66, 0.075);
}

.table-hover .table-active:hover {
  background-color: rgba(9.9333333333%, 12.2705882353%, 19.2823529412%, 0.075);
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(9.9333333333%, 12.2705882353%, 19.2823529412%, 0.075);
}

.table .thead-dark th {
  color: #1e1e2f;
  background-color: #212529;
  border-color: rgb(19.6303656598%, 22.0098039216%, 24.3892421834%);
}
.table .thead-light th {
  color: #525f7f;
  background-color: #e9ecef;
  border-color: #e3e3e3;
}

.table-dark {
  color: #1e1e2f;
  background-color: #212529;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: rgb(19.6303656598%, 22.0098039216%, 24.3892421834%);
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(2.249999625rem + 2px);
  padding: 0.5rem 0.7rem;
  font-size: 0.875rem;
  line-height: 1.428571;
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
  background-clip: padding-box;
  border: 1px solid #cad1d7;
  border-radius: 0.25rem;
  box-shadow: none;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
@media screen and (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: rgba(255, 255, 255, 0.8);
  background-color: #ffffff;
  border-color: rgba(50, 151, 211, 0.25);
  outline: 0;
  box-shadow: none, none;
}
.form-control::placeholder {
  color: #adb5bd;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

select.form-control:focus::-ms-value {
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.875rem + 1px);
  padding-bottom: calc(0.875rem + 1px);
  font-size: 0.99925rem;
  line-height: 1.35;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.7500000025rem;
  line-height: 1.35;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  margin-bottom: 0;
  line-height: 1.428571;
  color: #525f7f;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.5125000034rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.7500000025rem;
  line-height: 1.35;
  border-radius: 0.2857rem;
}

.form-control-lg {
  height: calc(3.0989875rem + 2px);
  padding: 0.875rem 1rem;
  font-size: 0.99925rem;
  line-height: 1.35;
  border-radius: 0.4285rem;
}

select.form-control[size], select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input:disabled ~ .form-check-label {
  color: #6c757d;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #00f2c3;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.7500000025rem;
  line-height: 1.5;
  color: #ffffff;
  background-color: rgba(0, 242, 195, 0.9);
  border-radius: 0.25rem;
}

.was-validated .form-control:valid, .form-control.is-valid,
.was-validated .custom-select:valid,
.custom-select.is-valid {
  border-color: #00f2c3;
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus,
.was-validated .custom-select:valid:focus,
.custom-select.is-valid:focus {
  border-color: #00f2c3;
  box-shadow: 0 0 0 0 rgba(0, 242, 195, 0.25);
}
.was-validated .form-control:valid ~ .valid-feedback,
.was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,
.form-control.is-valid ~ .valid-tooltip,
.was-validated .custom-select:valid ~ .valid-feedback,
.was-validated .custom-select:valid ~ .valid-tooltip,
.custom-select.is-valid ~ .valid-feedback,
.custom-select.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control-file:valid ~ .valid-feedback,
.was-validated .form-control-file:valid ~ .valid-tooltip, .form-control-file.is-valid ~ .valid-feedback,
.form-control-file.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #00f2c3;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #00f2c3;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  background-color: rgb(44.9019607843%, 100%, 89.2991411441%);
}
.was-validated .custom-control-input:valid ~ .valid-feedback,
.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,
.custom-control-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  background-color: rgb(14.9019607843%, 100%, 83.4726948631%);
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #1e1e2f, 0 0 0 0 rgba(0, 242, 195, 0.25);
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #00f2c3;
}
.was-validated .custom-file-input:valid ~ .custom-file-label::after, .custom-file-input.is-valid ~ .custom-file-label::after {
  border-color: inherit;
}
.was-validated .custom-file-input:valid ~ .valid-feedback,
.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,
.custom-file-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0 rgba(0, 242, 195, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #ff8d72;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.7500000025rem;
  line-height: 1.5;
  color: #ffffff;
  background-color: rgba(255, 141, 114, 0.9);
  border-radius: 0.25rem;
}

.was-validated .form-control:invalid, .form-control.is-invalid,
.was-validated .custom-select:invalid,
.custom-select.is-invalid {
  border-color: #ff8d72;
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus,
.was-validated .custom-select:invalid:focus,
.custom-select.is-invalid:focus {
  border-color: #ff8d72;
  box-shadow: 0 0 0 0 rgba(255, 141, 114, 0.25);
}
.was-validated .form-control:invalid ~ .invalid-feedback,
.was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,
.form-control.is-invalid ~ .invalid-tooltip,
.was-validated .custom-select:invalid ~ .invalid-feedback,
.was-validated .custom-select:invalid ~ .invalid-tooltip,
.custom-select.is-invalid ~ .invalid-feedback,
.custom-select.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control-file:invalid ~ .invalid-feedback,
.was-validated .form-control-file:invalid ~ .invalid-tooltip, .form-control-file.is-invalid ~ .invalid-feedback,
.form-control-file.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #ff8d72;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #ff8d72;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  background-color: rgb(100%, 95.719649562%, 94.7058823529%);
}
.was-validated .custom-control-input:invalid ~ .invalid-feedback,
.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,
.custom-control-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  background-color: rgb(100%, 71.464330413%, 64.7058823529%);
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #1e1e2f, 0 0 0 0 rgba(255, 141, 114, 0.25);
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #ff8d72;
}
.was-validated .custom-file-input:invalid ~ .custom-file-label::after, .custom-file-input.is-invalid ~ .custom-file-label::after {
  border-color: inherit;
}
.was-validated .custom-file-input:invalid ~ .invalid-feedback,
.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,
.custom-file-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0 rgba(255, 141, 114, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid transparent;
  padding: 11px 40px;
  font-size: 0.875rem;
  line-height: 1.35em;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media screen and (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover, .btn:focus {
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}
.btn.disabled, .btn:disabled {
  opacity: 0.65;
  box-shadow: none;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {
  box-shadow: none;
}
.btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus {
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08), none;
}

a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #ffffff;
  background-color: #e14eca;
  border-color: #e14eca;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-primary:hover {
  color: #ffffff;
  background-color: rgb(86.0613810742%, 17.7621483376%, 75.3751065644%);
  border-color: rgb(84.5012787724%, 14.3222506394%, 73.5208866155%);
}
.btn-primary:focus, .btn-primary.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(225, 78, 202, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #ffffff;
  background-color: #e14eca;
  border-color: #e14eca;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #ffffff;
  background-color: rgb(84.5012787724%, 14.3222506394%, 73.5208866155%);
  border-color: rgb(80.2259164535%, 13.5976129582%, 69.8010798522%);
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(225, 78, 202, 0.5);
}

.btn-secondary {
  color: #212529;
  background-color: #f4f5f7;
  border-color: #f4f5f7;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-secondary:hover {
  color: #212529;
  background-color: rgb(87.0020639835%, 88.1836945304%, 90.5469556244%);
  border-color: rgb(84.1073271414%, 85.5521155831%, 88.4416924665%);
}
.btn-secondary:focus, .btn-secondary.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(244, 245, 247, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #212529;
  background-color: #f4f5f7;
  border-color: #f4f5f7;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #212529;
  background-color: rgb(84.1073271414%, 85.5521155831%, 88.4416924665%);
  border-color: rgb(81.2125902993%, 82.9205366357%, 86.3364293086%);
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(244, 245, 247, 0.5);
}

.btn-success {
  color: #ffffff;
  background-color: #00f2c3;
  border-color: #00f2c3;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-success:hover {
  color: #ffffff;
  background-color: rgb(0%, 79.9019607843%, 64.3838113758%);
  border-color: rgb(0%, 74.9019607843%, 60.354885756%);
}
.btn-success:focus, .btn-success.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(0, 242, 195, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #ffffff;
  background-color: #00f2c3;
  border-color: #00f2c3;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #ffffff;
  background-color: rgb(0%, 74.9019607843%, 60.354885756%);
  border-color: rgb(0%, 69.9019607843%, 56.3259601361%);
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(0, 242, 195, 0.5);
}

.btn-info {
  color: #ffffff;
  background-color: #1d8cf8;
  border-color: #1d8cf8;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-info:hover {
  color: #ffffff;
  background-color: rgb(2.8128418749%, 47.4164773205%, 90.8146091054%);
  border-color: rgb(2.6626272827%, 44.8842884793%, 85.9648236977%);
}
.btn-info:focus, .btn-info.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(29, 140, 248, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #ffffff;
  background-color: #1d8cf8;
  border-color: #1d8cf8;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #ffffff;
  background-color: rgb(2.6626272827%, 44.8842884793%, 85.9648236977%);
  border-color: rgb(2.5124126904%, 42.3520996381%, 81.11503829%);
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(29, 140, 248, 0.5);
}

.btn-warning {
  color: #ffffff;
  background-color: #ff8d72;
  border-color: #ff8d72;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-warning:hover {
  color: #ffffff;
  background-color: rgb(100%, 43.1664580726%, 29.7058823529%);
  border-color: rgb(100%, 39.1239048811%, 24.7058823529%);
}
.btn-warning:focus, .btn-warning.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(255, 141, 114, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #ffffff;
  background-color: #ff8d72;
  border-color: #ff8d72;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #ffffff;
  background-color: rgb(100%, 39.1239048811%, 24.7058823529%);
  border-color: rgb(100%, 35.0813516896%, 19.7058823529%);
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(255, 141, 114, 0.5);
}

.btn-danger {
  color: #ffffff;
  background-color: #fd5d93;
  border-color: #fd5d93;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-danger:hover {
  color: #ffffff;
  background-color: rgb(99.0327594452%, 21.6535150646%, 47.769010043%);
  border-color: rgb(98.9717838355%, 16.7144906743%, 44.4763271162%);
}
.btn-danger:focus, .btn-danger.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(253, 93, 147, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #ffffff;
  background-color: #fd5d93;
  border-color: #fd5d93;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #ffffff;
  background-color: rgb(98.9717838355%, 16.7144906743%, 44.4763271162%);
  border-color: rgb(98.9108082257%, 11.7754662841%, 41.1836441894%);
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(253, 93, 147, 0.5);
}

.btn-light {
  color: #ffffff;
  background-color: #adb5bd;
  border-color: #adb5bd;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-light:hover {
  color: #ffffff;
  background-color: rgb(59.5323264441%, 63.4803921569%, 67.4284578696%);
  border-color: rgb(56.7620561738%, 60.9803921569%, 65.1987281399%);
}
.btn-light:focus, .btn-light.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(173, 181, 189, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #ffffff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #ffffff;
  background-color: rgb(56.7620561738%, 60.9803921569%, 65.1987281399%);
  border-color: rgb(53.9917859036%, 58.4803921569%, 62.9689984102%);
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(173, 181, 189, 0.5);
}

.btn-dark {
  color: #ffffff;
  background-color: #212529;
  border-color: #212529;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-dark:hover {
  color: #ffffff;
  background-color: rgb(6.2519872814%, 7.0098039216%, 7.7676205617%);
  border-color: rgb(4.0222575517%, 4.5098039216%, 4.9973502915%);
}
.btn-dark:focus, .btn-dark.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(33, 37, 41, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #ffffff;
  background-color: #212529;
  border-color: #212529;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #ffffff;
  background-color: rgb(4.0222575517%, 4.5098039216%, 4.9973502915%);
  border-color: rgb(1.7925278219%, 2.0098039216%, 2.2270800212%);
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(33, 37, 41, 0.5);
}

.btn-default {
  color: #ffffff;
  background-color: #344675;
  border-color: #344675;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-default:hover {
  color: #ffffff;
  background-color: rgb(15.7767722474%, 21.2379626407%, 35.4977375566%);
  border-color: rgb(14.2383107089%, 19.1669567235%, 32.036199095%);
}
.btn-default:focus, .btn-default.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(52, 70, 117, 0.5);
}
.btn-default.disabled, .btn-default:disabled {
  color: #ffffff;
  background-color: #344675;
  border-color: #344675;
}
.btn-default:not(:disabled):not(.disabled):active, .btn-default:not(:disabled):not(.disabled).active, .show > .btn-default.dropdown-toggle {
  color: #ffffff;
  background-color: rgb(14.2383107089%, 19.1669567235%, 32.036199095%);
  border-color: rgb(12.6998491704%, 17.0959508064%, 28.5746606335%);
}
.btn-default:not(:disabled):not(.disabled):active:focus, .btn-default:not(:disabled):not(.disabled).active:focus, .show > .btn-default.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(52, 70, 117, 0.5);
}

.btn-white {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-white:hover {
  color: #212529;
  background-color: rgb(92.5%, 92.5%, 92.5%);
  border-color: rgb(90%, 90%, 90%);
}
.btn-white:focus, .btn-white.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-white.disabled, .btn-white:disabled {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-white:not(:disabled):not(.disabled):active, .btn-white:not(:disabled):not(.disabled).active, .show > .btn-white.dropdown-toggle {
  color: #212529;
  background-color: rgb(90%, 90%, 90%);
  border-color: rgb(87.5%, 87.5%, 87.5%);
}
.btn-white:not(:disabled):not(.disabled):active:focus, .btn-white:not(:disabled):not(.disabled).active:focus, .show > .btn-white.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-neutral {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-neutral:hover {
  color: #212529;
  background-color: rgb(92.5%, 92.5%, 92.5%);
  border-color: rgb(90%, 90%, 90%);
}
.btn-neutral:focus, .btn-neutral.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-neutral.disabled, .btn-neutral:disabled {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-neutral:not(:disabled):not(.disabled):active, .btn-neutral:not(:disabled):not(.disabled).active, .show > .btn-neutral.dropdown-toggle {
  color: #212529;
  background-color: rgb(90%, 90%, 90%);
  border-color: rgb(87.5%, 87.5%, 87.5%);
}
.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn-neutral:not(:disabled):not(.disabled).active:focus, .show > .btn-neutral.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-darker {
  color: #ffffff;
  background-color: black;
  border-color: black;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-darker:hover {
  color: #ffffff;
  background-color: black;
  border-color: black;
}
.btn-darker:focus, .btn-darker.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(0, 0, 0, 0.5);
}
.btn-darker.disabled, .btn-darker:disabled {
  color: #ffffff;
  background-color: black;
  border-color: black;
}
.btn-darker:not(:disabled):not(.disabled):active, .btn-darker:not(:disabled):not(.disabled).active, .show > .btn-darker.dropdown-toggle {
  color: #ffffff;
  background-color: black;
  border-color: black;
}
.btn-darker:not(:disabled):not(.disabled):active:focus, .btn-darker:not(:disabled):not(.disabled).active:focus, .show > .btn-darker.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(0, 0, 0, 0.5);
}

.btn-outline-primary {
  color: #e14eca;
  background-color: transparent;
  background-image: none;
  border-color: #e14eca;
}
.btn-outline-primary:hover {
  color: #ffffff;
  background-color: #e14eca;
  border-color: #e14eca;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0 rgba(225, 78, 202, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #e14eca;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #ffffff;
  background-color: #e14eca;
  border-color: #e14eca;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(225, 78, 202, 0.5);
}

.btn-outline-secondary {
  color: #f4f5f7;
  background-color: transparent;
  background-image: none;
  border-color: #f4f5f7;
}
.btn-outline-secondary:hover {
  color: #212529;
  background-color: #f4f5f7;
  border-color: #f4f5f7;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0 rgba(244, 245, 247, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #f4f5f7;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #212529;
  background-color: #f4f5f7;
  border-color: #f4f5f7;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(244, 245, 247, 0.5);
}

.btn-outline-success {
  color: #00f2c3;
  background-color: transparent;
  background-image: none;
  border-color: #00f2c3;
}
.btn-outline-success:hover {
  color: #ffffff;
  background-color: #00f2c3;
  border-color: #00f2c3;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0 rgba(0, 242, 195, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #00f2c3;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #ffffff;
  background-color: #00f2c3;
  border-color: #00f2c3;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(0, 242, 195, 0.5);
}

.btn-outline-info {
  color: #1d8cf8;
  background-color: transparent;
  background-image: none;
  border-color: #1d8cf8;
}
.btn-outline-info:hover {
  color: #ffffff;
  background-color: #1d8cf8;
  border-color: #1d8cf8;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0 rgba(29, 140, 248, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #1d8cf8;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #ffffff;
  background-color: #1d8cf8;
  border-color: #1d8cf8;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(29, 140, 248, 0.5);
}

.btn-outline-warning {
  color: #ff8d72;
  background-color: transparent;
  background-image: none;
  border-color: #ff8d72;
}
.btn-outline-warning:hover {
  color: #ffffff;
  background-color: #ff8d72;
  border-color: #ff8d72;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0 rgba(255, 141, 114, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #ff8d72;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #ffffff;
  background-color: #ff8d72;
  border-color: #ff8d72;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 141, 114, 0.5);
}

.btn-outline-danger {
  color: #fd5d93;
  background-color: transparent;
  background-image: none;
  border-color: #fd5d93;
}
.btn-outline-danger:hover {
  color: #ffffff;
  background-color: #fd5d93;
  border-color: #fd5d93;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0 rgba(253, 93, 147, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #fd5d93;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #ffffff;
  background-color: #fd5d93;
  border-color: #fd5d93;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(253, 93, 147, 0.5);
}

.btn-outline-light {
  color: #adb5bd;
  background-color: transparent;
  background-image: none;
  border-color: #adb5bd;
}
.btn-outline-light:hover {
  color: #ffffff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #adb5bd;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #ffffff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);
}

.btn-outline-dark {
  color: #212529;
  background-color: transparent;
  background-image: none;
  border-color: #212529;
}
.btn-outline-dark:hover {
  color: #ffffff;
  background-color: #212529;
  border-color: #212529;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #212529;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #ffffff;
  background-color: #212529;
  border-color: #212529;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);
}

.btn-outline-default {
  color: #344675;
  background-color: transparent;
  background-image: none;
  border-color: #344675;
}
.btn-outline-default:hover {
  color: #ffffff;
  background-color: #344675;
  border-color: #344675;
}
.btn-outline-default:focus, .btn-outline-default.focus {
  box-shadow: 0 0 0 0 rgba(52, 70, 117, 0.5);
}
.btn-outline-default.disabled, .btn-outline-default:disabled {
  color: #344675;
  background-color: transparent;
}
.btn-outline-default:not(:disabled):not(.disabled):active, .btn-outline-default:not(:disabled):not(.disabled).active, .show > .btn-outline-default.dropdown-toggle {
  color: #ffffff;
  background-color: #344675;
  border-color: #344675;
}
.btn-outline-default:not(:disabled):not(.disabled):active:focus, .btn-outline-default:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-default.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(52, 70, 117, 0.5);
}

.btn-outline-white {
  color: #ffffff;
  background-color: transparent;
  background-image: none;
  border-color: #ffffff;
}
.btn-outline-white:hover {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-outline-white:focus, .btn-outline-white.focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-outline-white.disabled, .btn-outline-white:disabled {
  color: #ffffff;
  background-color: transparent;
}
.btn-outline-white:not(:disabled):not(.disabled):active, .btn-outline-white:not(:disabled):not(.disabled).active, .show > .btn-outline-white.dropdown-toggle {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-outline-white:not(:disabled):not(.disabled):active:focus, .btn-outline-white:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-white.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-outline-neutral {
  color: #ffffff;
  background-color: transparent;
  background-image: none;
  border-color: #ffffff;
}
.btn-outline-neutral:hover {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-outline-neutral:focus, .btn-outline-neutral.focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-outline-neutral.disabled, .btn-outline-neutral:disabled {
  color: #ffffff;
  background-color: transparent;
}
.btn-outline-neutral:not(:disabled):not(.disabled):active, .btn-outline-neutral:not(:disabled):not(.disabled).active, .show > .btn-outline-neutral.dropdown-toggle {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-outline-neutral:not(:disabled):not(.disabled):active:focus, .btn-outline-neutral:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-neutral.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-outline-darker {
  color: black;
  background-color: transparent;
  background-image: none;
  border-color: black;
}
.btn-outline-darker:hover {
  color: #ffffff;
  background-color: black;
  border-color: black;
}
.btn-outline-darker:focus, .btn-outline-darker.focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}
.btn-outline-darker.disabled, .btn-outline-darker:disabled {
  color: black;
  background-color: transparent;
}
.btn-outline-darker:not(:disabled):not(.disabled):active, .btn-outline-darker:not(:disabled):not(.disabled).active, .show > .btn-outline-darker.dropdown-toggle {
  color: #ffffff;
  background-color: black;
  border-color: black;
}
.btn-outline-darker:not(:disabled):not(.disabled):active:focus, .btn-outline-darker:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-darker.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #e14eca;
  background-color: transparent;
}
.btn-link:hover {
  color: rgb(75.9505541347%, 12.8729752771%, 66.0812730889%);
  text-decoration: none;
  background-color: transparent;
  border-color: transparent;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: none;
  border-color: transparent;
  box-shadow: none;
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 15px 48px;
  font-size: 0.99925rem;
  line-height: 1.35;
  border-radius: 0.4285rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 5px 15px;
  font-size: 0.7500000025rem;
  line-height: 1.35;
  border-radius: 0.25rem;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}
@media screen and (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media screen and (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.875rem;
  color: #525f7f;
  text-align: left;
  list-style: none;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 0 solid rgba(34, 42, 66, 0.15);
  border-radius: 0.1428rem;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  width: 0;
  height: 0;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: rgb(8.4817170111%, 9.5098039216%, 10.537890832%);
  text-decoration: none;
  background-color: #f6f9fc;
}
.dropdown-item.active, .dropdown-item:active {
  color: #ffffff;
  text-decoration: none;
  background-color: #e14eca;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #6c757d;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.7500000025rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 0 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}
.btn-group .btn + .btn,
.btn-group .btn + .btn-group,
.btn-group .btn-group + .btn,
.btn-group .btn-group + .btn-group,
.btn-group-vertical .btn + .btn,
.btn-group-vertical .btn + .btn-group,
.btn-group-vertical .btn-group + .btn,
.btn-group-vertical .btn-group + .btn-group {
  margin-left: -1px;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:first-child {
  margin-left: 0;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 30px;
  padding-left: 30px;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 11.25px;
  padding-left: 11.25px;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 36px;
  padding-left: 36px;
}

.btn-group.show .dropdown-toggle {
  box-shadow: none;
}
.btn-group.show .dropdown-toggle.btn-link {
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical .btn,
.btn-group-vertical .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn + .btn,
.btn-group-vertical > .btn + .btn-group,
.btn-group-vertical > .btn-group + .btn,
.btn-group-vertical > .btn-group + .btn-group {
  margin-top: -1px;
  margin-left: 0;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:last-child),
.input-group > .custom-select:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.7rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.428571;
  color: #adb5bd;
  text-align: center;
  white-space: nowrap;
  background-color: transparent;
  border: 1px solid #cad1d7;
  border-radius: 0.25rem;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group-lg > .form-control,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  height: calc(3.0989875rem + 2px);
  padding: 0.875rem 1rem;
  font-size: 0.99925rem;
  line-height: 1.35;
  border-radius: 0.4285rem;
}

.input-group-sm > .form-control,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  height: calc(1.5125000034rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.7500000025rem;
  line-height: 1.35;
  border-radius: 0.2857rem;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group > .input-group-append:not(:last-child) > .btn,
.input-group > .input-group-append:not(:last-child) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  display: block;
  min-height: 1.3125rem;
  padding-left: 1.75rem;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #ffffff;
  background-color: #e14eca;
  box-shadow: none;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none;
}
.custom-control-input:active ~ .custom-control-label::before {
  color: #ffffff;
  background-color: #e14eca;
  box-shadow: none;
}
.custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}
.custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
}
.custom-control-label::before {
  position: absolute;
  top: 0.03125rem;
  left: -1.75rem;
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  pointer-events: none;
  content: "";
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  box-shadow: none;
}
.custom-control-label::after {
  position: absolute;
  top: 0.03125rem;
  left: -1.75rem;
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  content: "";
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.2857rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #e14eca;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  background-color: #e14eca;
  box-shadow: none;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(225, 78, 202, 0.5);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(225, 78, 202, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #e14eca;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(225, 78, 202, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(2.249999625rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  line-height: 1.428571;
  color: rgba(255, 255, 255, 0.8);
  vertical-align: middle;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat right 0.75rem center;
  background-size: 8px 10px;
  border: 1px solid #cad1d7;
  border-radius: 0.25rem;
  box-shadow: inset 0 1px 2px rgba(34, 42, 66, 0.075);
  appearance: none;
}
.custom-select:focus {
  border-color: rgba(50, 151, 211, 0.25);
  outline: 0;
  box-shadow: inset 0 1px 2px rgba(34, 42, 66, 0.075), 0 0 0 0 rgba(50, 151, 211, 0.5);
}
.custom-select:focus::-ms-value {
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}
.custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}
.custom-select::-ms-expand {
  opacity: 0;
}

.custom-select-sm {
  height: calc(1.5125000034rem + 2px);
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 75%;
}

.custom-select-lg {
  height: calc(3.0989875rem + 2px);
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 125%;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(2.249999625rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(2.249999625rem + 2px);
  margin: 0;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: rgba(50, 151, 211, 0.25);
  box-shadow: none;
}
.custom-file-input:focus ~ .custom-file-label::after {
  border-color: rgba(50, 151, 211, 0.25);
}
.custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(2.249999625rem + 2px);
  padding: 0.5rem 0.7rem;
  line-height: 1.428571;
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
  border: 1px solid #cad1d7;
  border-radius: 0.25rem;
  box-shadow: none;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: 2.249999625rem;
  padding: 0.5rem 0.7rem;
  line-height: 1.428571;
  color: rgba(255, 255, 255, 0.8);
  content: "Browse";
  background-color: transparent;
  border-left: 1px solid #cad1d7;
  border-radius: 0 0.25rem 0.25rem 0;
}

.custom-range {
  width: 100%;
  padding-left: 0;
  background-color: transparent;
  appearance: none;
}
.custom-range:focus {
  outline: none;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #1e1e2f, none;
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #1e1e2f, none;
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #1e1e2f, none;
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #e14eca;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(34, 42, 66, 0.1);
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media screen and (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb {
  appearance: none;
}
.custom-range::-webkit-slider-thumb:active {
  background-color: rgb(98.3802216539%, 90.4433077579%, 97.1383915885%);
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #e3e3e3;
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(34, 42, 66, 0.1);
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #e14eca;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(34, 42, 66, 0.1);
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media screen and (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.custom-range::-moz-range-thumb {
  appearance: none;
}
.custom-range::-moz-range-thumb:active {
  background-color: rgb(98.3802216539%, 90.4433077579%, 97.1383915885%);
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #e3e3e3;
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(34, 42, 66, 0.1);
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0;
  margin-left: 0;
  background-color: #e14eca;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(34, 42, 66, 0.1);
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media screen and (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}
.custom-range::-ms-thumb {
  appearance: none;
}
.custom-range::-ms-thumb:active {
  background-color: rgb(98.3802216539%, 90.4433077579%, 97.1383915885%);
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(34, 42, 66, 0.1);
}
.custom-range::-ms-fill-lower {
  background-color: #e3e3e3;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #e3e3e3;
  border-radius: 1rem;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media screen and (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #6c757d;
}

.nav-tabs {
  border-bottom: 0.0625rem solid #e3e3e3;
}
.nav-tabs .nav-item {
  margin-bottom: -0.0625rem;
}
.nav-tabs .nav-link {
  border: 0.0625rem solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  border-color: #e9ecef #e9ecef #e3e3e3;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #525f7f;
  background-color: #1e1e2f;
  border-color: #e3e3e3 #e3e3e3 #1e1e2f;
}
.nav-tabs .dropdown-menu {
  margin-top: -0.0625rem;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  border-radius: 0.25rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #ffffff;
  background-color: #e14eca;
}

.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.625rem 0.9375rem;
}
.navbar > .container,
.navbar > .container-fluid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  display: inline-block;
  padding-top: 0.4068125rem;
  padding-bottom: 0.4068125rem;
  margin-right: 0.9375rem;
  font-size: 0.99925rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 0.99925rem;
  line-height: 1;
  background-color: transparent;
  border: 0.0625rem solid transparent;
  border-radius: 0.25rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}
.navbar-toggler:not(:disabled):not(.disabled) {
  cursor: pointer;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat center center;
  background-size: 100% 100%;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand > .container,
.navbar-expand > .container-fluid {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 1rem;
  padding-left: 1rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(34, 42, 66, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(34, 42, 66, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(34, 42, 66, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(34, 42, 66, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(34, 42, 66, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(34, 42, 66, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(34, 42, 66, 0.5);
  border-color: transparent;
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.navbar-light .navbar-text {
  color: rgba(34, 42, 66, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(34, 42, 66, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(34, 42, 66, 0.9);
}

.navbar-dark .navbar-brand {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.95);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.95);
  border-color: transparent;
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.95);
}
.navbar-dark .navbar-text a {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: rgba(255, 255, 255, 0.65);
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 0.0625rem solid rgba(34, 42, 66, 0.05);
  border-radius: 0.2857rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group:first-child .list-group-item:first-child {
  border-top-left-radius: 0.2857rem;
  border-top-right-radius: 0.2857rem;
}
.card > .list-group:last-child .list-group-item:last-child {
  border-bottom-right-radius: 0.2857rem;
  border-bottom-left-radius: 0.2857rem;
}

.card-body {
  flex: 1 1 auto;
  padding: 1.5rem;
}

.card-title {
  margin-bottom: 1.25rem;
}

.card-subtitle {
  margin-top: -0.625rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.5rem;
}

.card-header {
  padding: 1.25rem 1.5rem;
  margin-bottom: 0;
  background-color: #f6f9fc;
  border-bottom: 0.0625rem solid rgba(34, 42, 66, 0.05);
}
.card-header:first-child {
  border-radius: calc(0.2857rem - 0.0625rem) calc(0.2857rem - 0.0625rem) 0 0;
}
.card-header + .list-group .list-group-item:first-child {
  border-top: 0;
}

.card-footer {
  padding: 1.25rem 1.5rem;
  background-color: #f6f9fc;
  border-top: 0.0625rem solid rgba(34, 42, 66, 0.05);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.2857rem - 0.0625rem) calc(0.2857rem - 0.0625rem);
}

.card-header-tabs {
  margin-right: -0.75rem;
  margin-bottom: -1.25rem;
  margin-left: -0.75rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.75rem;
  margin-left: -0.75rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
}

.card-img {
  width: 100%;
  border-radius: calc(0.2857rem - 0.0625rem);
}

.card-img-top {
  width: 100%;
  border-top-left-radius: calc(0.2857rem - 0.0625rem);
  border-top-right-radius: calc(0.2857rem - 0.0625rem);
}

.card-img-bottom {
  width: 100%;
  border-bottom-right-radius: calc(0.2857rem - 0.0625rem);
  border-bottom-left-radius: calc(0.2857rem - 0.0625rem);
}

.card-deck {
  display: flex;
  flex-direction: column;
}
.card-deck .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-deck {
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    display: flex;
    flex: 1 0;
    flex-direction: column;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group {
  display: flex;
  flex-direction: column;
}
.card-group > .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-group {
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:first-child .card-img-top,
  .card-group > .card:first-child .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:first-child .card-img-bottom,
  .card-group > .card:first-child .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:last-child .card-img-top,
  .card-group > .card:last-child .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:last-child .card-img-bottom,
  .card-group > .card:last-child .card-footer {
    border-bottom-left-radius: 0;
  }
  .card-group > .card:only-child {
    border-radius: 0.2857rem;
  }
  .card-group > .card:only-child .card-img-top,
  .card-group > .card:only-child .card-header {
    border-top-left-radius: 0.2857rem;
    border-top-right-radius: 0.2857rem;
  }
  .card-group > .card:only-child .card-img-bottom,
  .card-group > .card:only-child .card-footer {
    border-bottom-right-radius: 0.2857rem;
    border-bottom-left-radius: 0.2857rem;
  }
  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) {
    border-radius: 0;
  }
  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-top,
  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,
  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-header,
  .card-group > .card:not(:first-child):not(:last-child):not(:only-child) .card-footer {
    border-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 1.25rem;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion .card:not(:first-of-type):not(:last-of-type) {
  border-bottom: 0;
  border-radius: 0;
}
.accordion .card:not(:first-of-type) .card-header:first-child {
  border-radius: 0;
}
.accordion .card:first-of-type {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion .card:last-of-type {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #1d253b;
  border-radius: 0.25rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  color: #ffffff;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #ffffff;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0 0.6875rem;
  margin-left: -0.0625rem;
  line-height: 1.25;
  color: #ffffff;
  background-color: transparent;
  border: 0.0625rem solid #e3e3e3;
}
.page-link:hover {
  z-index: 2;
  color: #6c757d;
  text-decoration: none;
  background-color: #e3e3e3;
  border-color: #e3e3e3;
}
.page-link:focus {
  z-index: 2;
  outline: 0;
  box-shadow: none;
}
.page-link:not(:disabled):not(.disabled) {
  cursor: pointer;
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.page-item.active .page-link {
  z-index: 1;
  color: #ffffff;
  background-color: #e14eca;
  border-color: #e14eca;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: transparent;
  border-color: #e3e3e3;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 0.99925rem;
  line-height: 1.625rem;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.4285rem;
  border-bottom-left-radius: 0.4285rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.4285rem;
  border-bottom-right-radius: 0.4285rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.7500000025rem;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2857rem;
  border-bottom-left-radius: 0.2857rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2857rem;
  border-bottom-right-radius: 0.2857rem;
}

.badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  font-size: 0.62475rem;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.875em;
  padding-left: 0.875em;
  border-radius: 0.875rem;
}

.badge-primary {
  color: #ffffff;
  background-color: #e14eca;
}
.badge-primary[href]:hover, .badge-primary[href]:focus {
  color: #ffffff;
  text-decoration: none;
  background-color: rgb(84.5012787724%, 14.3222506394%, 73.5208866155%);
}

.badge-secondary {
  color: #212529;
  background-color: #f4f5f7;
}
.badge-secondary[href]:hover, .badge-secondary[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: rgb(84.1073271414%, 85.5521155831%, 88.4416924665%);
}

.badge-success {
  color: #ffffff;
  background-color: #00f2c3;
}
.badge-success[href]:hover, .badge-success[href]:focus {
  color: #ffffff;
  text-decoration: none;
  background-color: rgb(0%, 74.9019607843%, 60.354885756%);
}

.badge-info {
  color: #ffffff;
  background-color: #1d8cf8;
}
.badge-info[href]:hover, .badge-info[href]:focus {
  color: #ffffff;
  text-decoration: none;
  background-color: rgb(2.6626272827%, 44.8842884793%, 85.9648236977%);
}

.badge-warning {
  color: #ffffff;
  background-color: #ff8d72;
}
.badge-warning[href]:hover, .badge-warning[href]:focus {
  color: #ffffff;
  text-decoration: none;
  background-color: rgb(100%, 39.1239048811%, 24.7058823529%);
}

.badge-danger {
  color: #ffffff;
  background-color: #fd5d93;
}
.badge-danger[href]:hover, .badge-danger[href]:focus {
  color: #ffffff;
  text-decoration: none;
  background-color: rgb(98.9717838355%, 16.7144906743%, 44.4763271162%);
}

.badge-light {
  color: #ffffff;
  background-color: #adb5bd;
}
.badge-light[href]:hover, .badge-light[href]:focus {
  color: #ffffff;
  text-decoration: none;
  background-color: rgb(56.7620561738%, 60.9803921569%, 65.1987281399%);
}

.badge-dark {
  color: #ffffff;
  background-color: #212529;
}
.badge-dark[href]:hover, .badge-dark[href]:focus {
  color: #ffffff;
  text-decoration: none;
  background-color: rgb(4.0222575517%, 4.5098039216%, 4.9973502915%);
}

.badge-default {
  color: #ffffff;
  background-color: #344675;
}
.badge-default[href]:hover, .badge-default[href]:focus {
  color: #ffffff;
  text-decoration: none;
  background-color: rgb(14.2383107089%, 19.1669567235%, 32.036199095%);
}

.badge-white {
  color: #212529;
  background-color: #ffffff;
}
.badge-white[href]:hover, .badge-white[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: rgb(90%, 90%, 90%);
}

.badge-neutral {
  color: #212529;
  background-color: #ffffff;
}
.badge-neutral[href]:hover, .badge-neutral[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: rgb(90%, 90%, 90%);
}

.badge-darker {
  color: #ffffff;
  background-color: black;
}
.badge-darker[href]:hover, .badge-darker[href]:focus {
  color: #ffffff;
  text-decoration: none;
  background-color: black;
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.4285rem;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.9rem 1.25rem;
  margin-bottom: 1rem;
  border: 0.0625rem solid transparent;
  border-radius: 0.2857rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
}

.alert-dismissible {
  padding-right: 3.8125rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.9rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: #e14eca;
  background-color: rgb(90.1176470588%, 41.6941176471%, 82.5411764706%);
  border-color: rgb(90.1176470588%, 41.6941176471%, 82.5411764706%);
}
.alert-primary hr {
  border-top-color: rgb(88.6683716965%, 33.1433930094%, 79.9807899972%);
}
.alert-primary .alert-link {
  color: rgb(84.5012787724%, 14.3222506394%, 73.5208866155%);
}

.alert-secondary {
  color: #f4f5f7;
  background-color: rgb(96.3764705882%, 96.7058823529%, 97.3647058824%);
  border-color: rgb(96.3764705882%, 96.7058823529%, 97.3647058824%);
}
.alert-secondary hr {
  border-top-color: rgb(90.586996904%, 91.4427244582%, 93.1541795666%);
}
.alert-secondary .alert-link {
  color: rgb(84.1073271414%, 85.5521155831%, 88.4416924665%);
}

.alert-success {
  color: #00f2c3;
  background-color: rgb(16%, 95.7176470588%, 80.2352941176%);
  border-color: rgb(16%, 95.7176470588%, 80.2352941176%);
}
.alert-success hr {
  border-top-color: rgb(6.4850746269%, 95.232572432%, 77.9964881475%);
}
.alert-success .alert-link {
  color: rgb(0%, 74.9019607843%, 60.354885756%);
}

.alert-info {
  color: #1d8cf8;
  background-color: rgb(25.5529411765%, 62.1176470588%, 97.6941176471%);
  border-color: rgb(25.5529411765%, 62.1176470588%, 97.6941176471%);
}
.alert-info hr {
  border-top-color: rgb(15.853370361%, 57.1820247412%, 97.3936884625%);
}
.alert-info .alert-link {
  color: rgb(2.6626272827%, 44.8842884793%, 85.9648236977%);
}

.alert-warning {
  color: #ff8d72;
  background-color: rgb(100%, 62.4470588235%, 53.5529411765%);
  border-color: rgb(100%, 62.4470588235%, 53.5529411765%);
}
.alert-warning hr {
  border-top-color: rgb(100%, 54.3619524406%, 43.5529411765%);
}
.alert-warning .alert-link {
  color: rgb(100%, 39.1239048811%, 24.7058823529%);
}

.alert-danger {
  color: #fd5d93;
  background-color: rgb(99.3411764706%, 46.6352941176%, 64.4235294118%);
  border-color: rgb(99.3411764706%, 46.6352941176%, 64.4235294118%);
}
.alert-danger hr {
  border-top-color: rgb(99.2192252511%, 36.7572453372%, 57.8381635581%);
}
.alert-danger .alert-link {
  color: rgb(98.9717838355%, 16.7144906743%, 44.4763271162%);
}

.alert-light {
  color: #adb5bd;
  background-color: rgb(72.9882352941%, 75.6235294118%, 78.2588235294%);
  border-color: rgb(72.9882352941%, 75.6235294118%, 78.2588235294%);
}
.alert-light hr {
  border-top-color: rgb(67.4476947536%, 70.6235294118%, 73.79936407%);
}
.alert-light .alert-link {
  color: rgb(56.7620561738%, 60.9803921569%, 65.1987281399%);
}

.alert-dark {
  color: #212529;
  background-color: rgb(26.8705882353%, 28.1882352941%, 29.5058823529%);
  border-color: rgb(26.8705882353%, 28.1882352941%, 29.5058823529%);
}
.alert-dark hr {
  border-top-color: rgb(22.1043111067%, 23.1882352941%, 24.2721594815%);
}
.alert-dark .alert-link {
  color: rgb(4.0222575517%, 4.5098039216%, 4.9973502915%);
}

.alert-default {
  color: #344675;
  background-color: rgb(33.1294117647%, 39.0588235294%, 54.5411764706%);
  border-color: rgb(33.1294117647%, 39.0588235294%, 54.5411764706%);
}
.alert-default hr {
  border-top-color: rgb(29.3505604496%, 34.6036437119%, 48.3200277857%);
}
.alert-default .alert-link {
  color: rgb(14.2383107089%, 19.1669567235%, 32.036199095%);
}

.alert-white {
  color: white;
  background-color: white;
  border-color: white;
}
.alert-white hr {
  border-top-color: rgb(95%, 95%, 95%);
}
.alert-white .alert-link {
  color: rgb(90%, 90%, 90%);
}

.alert-neutral {
  color: white;
  background-color: white;
  border-color: white;
}
.alert-neutral hr {
  border-top-color: rgb(95%, 95%, 95%);
}
.alert-neutral .alert-link {
  color: rgb(90%, 90%, 90%);
}

.alert-darker {
  color: black;
  background-color: rgb(16%, 16%, 16%);
  border-color: rgb(16%, 16%, 16%);
}
.alert-darker hr {
  border-top-color: rgb(11%, 11%, 11%);
}
.alert-darker .alert-link {
  color: black;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 0.5rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 0.5rem;
  overflow: hidden;
  font-size: 0.65625rem;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 0.875rem;
  box-shadow: 0px 0px 0px 3px rgba(0, 0, 0, 0.3);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #ffffff;
  text-align: center;
  white-space: nowrap;
  background-color: #e14eca;
  transition: width 0.6s ease;
}
@media screen and (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 0.5rem 0.5rem;
}

.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite;
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}

.list-group-item-action {
  width: 100%;
  color: #525f7f;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  color: #525f7f;
  text-decoration: none;
  background-color: #f6f9fc;
}
.list-group-item-action:active {
  color: #525f7f;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 1rem 1rem;
  margin-bottom: -0.0625rem;
  background-color: #ffffff;
  border: 0.0625rem solid #e9ecef;
}
.list-group-item:first-child {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.list-group-item:last-child {
  margin-bottom: 0;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.list-group-item:hover, .list-group-item:focus {
  z-index: 1;
  text-decoration: none;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  background-color: #ffffff;
}
.list-group-item.active {
  z-index: 2;
  color: #ffffff;
  background-color: #e14eca;
  border-color: #e14eca;
}

.list-group-flush .list-group-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.list-group-flush:first-child .list-group-item:first-child {
  border-top: 0;
}
.list-group-flush:last-child .list-group-item:last-child {
  border-bottom: 0;
}

.list-group-item-primary {
  color: rgb(52.2823529412%, 23.8117647059%, 53.6156862745%);
  background-color: rgb(96.7058823529%, 80.5647058824%, 94.1803921569%);
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: rgb(52.2823529412%, 23.8117647059%, 53.6156862745%);
  background-color: rgb(95.2566069906%, 72.0139812447%, 91.6200056834%);
}
.list-group-item-primary.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(52.2823529412%, 23.8117647059%, 53.6156862745%);
  border-color: rgb(52.2823529412%, 23.8117647059%, 53.6156862745%);
}

.list-group-item-secondary {
  color: rgb(56.1568627451%, 57.8666666667%, 62.7921568627%);
  background-color: rgb(98.7921568627%, 98.9019607843%, 99.1215686275%);
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: rgb(56.1568627451%, 57.8666666667%, 62.7921568627%);
  background-color: rgb(93.0026831785%, 93.6388028896%, 94.9110423117%);
}
.list-group-item-secondary.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(56.1568627451%, 57.8666666667%, 62.7921568627%);
  border-color: rgb(56.1568627451%, 57.8666666667%, 62.7921568627%);
}

.list-group-item-success {
  color: rgb(6.4%, 57.2549019608%, 52.1882352941%);
  background-color: rgb(72%, 98.5725490196%, 93.4117647059%);
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: rgb(6.4%, 57.2549019608%, 52.1882352941%);
  background-color: rgb(62.4850746269%, 98.0874743927%, 91.1729587357%);
}
.list-group-item-success.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(6.4%, 57.2549019608%, 52.1882352941%);
  border-color: rgb(6.4%, 57.2549019608%, 52.1882352941%);
}

.list-group-item-info {
  color: rgb(12.3137254902%, 36.4549019608%, 62.9960784314%);
  background-color: rgb(75.1843137255%, 87.3725490196%, 99.231372549%);
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: rgb(12.3137254902%, 36.4549019608%, 62.9960784314%);
  background-color: rgb(65.48474291%, 82.436926702%, 98.9309433645%);
}
.list-group-item-info.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(12.3137254902%, 36.4549019608%, 62.9960784314%);
  border-color: rgb(12.3137254902%, 36.4549019608%, 62.9960784314%);
}

.list-group-item-warning {
  color: rgb(58.4%, 36.6588235294%, 35.6705882353%);
  background-color: rgb(100%, 87.4823529412%, 84.5176470588%);
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: rgb(58.4%, 36.6588235294%, 35.6705882353%);
  background-color: rgb(100%, 79.3972465582%, 74.5176470588%);
}
.list-group-item-warning.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(58.4%, 36.6588235294%, 35.6705882353%);
  border-color: rgb(58.4%, 36.6588235294%, 35.6705882353%);
}

.list-group-item-danger {
  color: rgb(57.9921568627%, 26.8705882353%, 42.4%);
  background-color: rgb(99.7803921569%, 82.2117647059%, 88.1411764706%);
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: rgb(57.9921568627%, 26.8705882353%, 42.4%);
  background-color: rgb(99.6584409374%, 72.3337159254%, 81.5558106169%);
}
.list-group-item-danger.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(57.9921568627%, 26.8705882353%, 42.4%);
  border-color: rgb(57.9921568627%, 26.8705882353%, 42.4%);
}

.list-group-item-light {
  color: rgb(41.6784313725%, 44.8156862745%, 50.9647058824%);
  background-color: rgb(90.9960784314%, 91.8745098039%, 92.7529411765%);
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: rgb(41.6784313725%, 44.8156862745%, 50.9647058824%);
  background-color: rgb(85.4555378908%, 86.8745098039%, 88.293481717%);
}
.list-group-item-light.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(41.6784313725%, 44.8156862745%, 50.9647058824%);
  border-color: rgb(41.6784313725%, 44.8156862745%, 50.9647058824%);
}

.list-group-item-dark {
  color: rgb(13.1294117647%, 15.4509803922%, 20.7843137255%);
  background-color: rgb(75.6235294118%, 76.062745098%, 76.5019607843%);
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: rgb(13.1294117647%, 15.4509803922%, 20.7843137255%);
  background-color: rgb(70.5317862925%, 71.062745098%, 71.5937039036%);
}
.list-group-item-dark.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(13.1294117647%, 15.4509803922%, 20.7843137255%);
  border-color: rgb(13.1294117647%, 15.4509803922%, 20.7843137255%);
}

.list-group-item-default {
  color: rgb(17.0039215686%, 22.1803921569%, 36.2823529412%);
  background-color: rgb(77.7098039216%, 79.6862745098%, 84.8470588235%);
}
.list-group-item-default.list-group-item-action:hover, .list-group-item-default.list-group-item-action:focus {
  color: rgb(17.0039215686%, 22.1803921569%, 36.2823529412%);
  background-color: rgb(71.7567247427%, 74.2610545685%, 80.8001380024%);
}
.list-group-item-default.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(17.0039215686%, 22.1803921569%, 36.2823529412%);
  border-color: rgb(17.0039215686%, 22.1803921569%, 36.2823529412%);
}

.list-group-item-white {
  color: rgb(58.4%, 59.9058823529%, 64.4235294118%);
  background-color: white;
}
.list-group-item-white.list-group-item-action:hover, .list-group-item-white.list-group-item-action:focus {
  color: rgb(58.4%, 59.9058823529%, 64.4235294118%);
  background-color: rgb(95%, 95%, 95%);
}
.list-group-item-white.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(58.4%, 59.9058823529%, 64.4235294118%);
  border-color: rgb(58.4%, 59.9058823529%, 64.4235294118%);
}

.list-group-item-neutral {
  color: rgb(58.4%, 59.9058823529%, 64.4235294118%);
  background-color: white;
}
.list-group-item-neutral.list-group-item-action:hover, .list-group-item-neutral.list-group-item-action:focus {
  color: rgb(58.4%, 59.9058823529%, 64.4235294118%);
  background-color: rgb(95%, 95%, 95%);
}
.list-group-item-neutral.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(58.4%, 59.9058823529%, 64.4235294118%);
  border-color: rgb(58.4%, 59.9058823529%, 64.4235294118%);
}

.list-group-item-darker {
  color: rgb(6.4%, 7.9058823529%, 12.4235294118%);
  background-color: rgb(72%, 72%, 72%);
}
.list-group-item-darker.list-group-item-action:hover, .list-group-item-darker.list-group-item-action:focus {
  color: rgb(6.4%, 7.9058823529%, 12.4235294118%);
  background-color: rgb(67%, 67%, 67%);
}
.list-group-item-darker.list-group-item-action.active {
  color: #ffffff;
  background-color: rgb(6.4%, 7.9058823529%, 12.4235294118%);
  border-color: rgb(6.4%, 7.9058823529%, 12.4235294118%);
}

.close {
  float: right;
  font-size: 1.3125rem;
  font-weight: 600;
  line-height: 1;
  color: rgba(0, 0, 0, 0.6);
  text-shadow: none;
  opacity: 0.5;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  color: rgba(0, 0, 0, 0.6);
  text-decoration: none;
  opacity: 0.75;
}
.close:not(:disabled):not(.disabled) {
  cursor: pointer;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
  -webkit-appearance: none;
}

.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
@media screen and (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.fade .modal-dialog {
  transform: translate(0, -25%);
}
.modal.show .modal-dialog {
  transform: translate(0, 0);
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 0.5rem * 2);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 0.5rem * 2);
  content: "";
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid rgba(34, 42, 66, 0.2);
  border-radius: 0.2857rem;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.5);
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #222a42;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.16;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 24px 0 24px;
  border-bottom: 1px solid #e9ecef;
  border-top-left-radius: 0.2857rem;
  border-top-right-radius: 0.2857rem;
}
.modal-header .close {
  padding: 24px 24px 0 24px;
  margin: -24px 24px 0 24px -24px 24px 0 24px -24px 24px 0 24px auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.1;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 24px 24px 16px 24px;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 24px 24px 16px 24px;
  border-top: 1px solid #e9ecef;
}
.modal-footer > :not(:first-child) {
  margin-left: 0.25rem;
}
.modal-footer > :not(:last-child) {
  margin-right: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-centered {
    min-height: calc(100% - 1.75rem * 2);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 1.75rem * 2);
  }
  .modal-content {
    box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
  }
  .modal-sm {
    max-width: 380px;
  }
}
@media (min-width: 992px) {
  .modal-lg {
    max-width: 80%;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.7500000025rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #ffffff;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #ffffff;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #ffffff;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #ffffff;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #222a42;
  text-align: center;
  background-color: #ffffff;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.7500000025rem;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid rgba(34, 42, 66, 0.05);
  border-radius: 0.4285rem;
  box-shadow: 0px 0.5rem 2rem 0px rgba(34, 42, 66, 0.2);
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1.5rem;
  height: 0.75rem;
  margin: 0 0.4285rem;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.75rem;
}
.bs-popover-top .arrow, .bs-popover-auto[x-placement^=top] .arrow {
  bottom: calc((0.75rem + 1px) * -1);
}
.bs-popover-top .arrow::before, .bs-popover-auto[x-placement^=top] .arrow::before,
.bs-popover-top .arrow::after,
.bs-popover-auto[x-placement^=top] .arrow::after {
  border-width: 0.75rem 0.75rem 0;
}
.bs-popover-top .arrow::before, .bs-popover-auto[x-placement^=top] .arrow::before {
  bottom: 0;
  border-top-color: transparent;
}
.bs-popover-top .arrow::after, .bs-popover-auto[x-placement^=top] .arrow::after {
  bottom: 1px;
  border-top-color: #ffffff;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.75rem;
}
.bs-popover-right .arrow, .bs-popover-auto[x-placement^=right] .arrow {
  left: calc((0.75rem + 1px) * -1);
  width: 0.75rem;
  height: 1.5rem;
  margin: 0.4285rem 0;
}
.bs-popover-right .arrow::before, .bs-popover-auto[x-placement^=right] .arrow::before,
.bs-popover-right .arrow::after,
.bs-popover-auto[x-placement^=right] .arrow::after {
  border-width: 0.75rem 0.75rem 0.75rem 0;
}
.bs-popover-right .arrow::before, .bs-popover-auto[x-placement^=right] .arrow::before {
  left: 0;
  border-right-color: transparent;
}
.bs-popover-right .arrow::after, .bs-popover-auto[x-placement^=right] .arrow::after {
  left: 1px;
  border-right-color: #ffffff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.75rem;
}
.bs-popover-bottom .arrow, .bs-popover-auto[x-placement^=bottom] .arrow {
  top: calc((0.75rem + 1px) * -1);
}
.bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^=bottom] .arrow::before,
.bs-popover-bottom .arrow::after,
.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-width: 0 0.75rem 0.75rem 0.75rem;
}
.bs-popover-bottom .arrow::before, .bs-popover-auto[x-placement^=bottom] .arrow::before {
  top: 0;
  border-bottom-color: transparent;
}
.bs-popover-bottom .arrow::after, .bs-popover-auto[x-placement^=bottom] .arrow::after {
  top: 1px;
  border-bottom-color: #ffffff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1.5rem;
  margin-left: -0.75rem;
  content: "";
  border-bottom: 1px solid #ffffff;
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.75rem;
}
.bs-popover-left .arrow, .bs-popover-auto[x-placement^=left] .arrow {
  right: calc((0.75rem + 1px) * -1);
  width: 0.75rem;
  height: 1.5rem;
  margin: 0.4285rem 0;
}
.bs-popover-left .arrow::before, .bs-popover-auto[x-placement^=left] .arrow::before,
.bs-popover-left .arrow::after,
.bs-popover-auto[x-placement^=left] .arrow::after {
  border-width: 0.75rem 0 0.75rem 0.75rem;
}
.bs-popover-left .arrow::before, .bs-popover-auto[x-placement^=left] .arrow::before {
  right: 0;
  border-left-color: transparent;
}
.bs-popover-left .arrow::after, .bs-popover-auto[x-placement^=left] .arrow::after {
  right: 1px;
  border-left-color: #ffffff;
}

.popover-header {
  padding: 0.75rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #32325d;
  background-color: #ffffff;
  border-bottom: 1px solid rgb(95%, 95%, 95%);
  border-top-left-radius: calc(0.4285rem - 1px);
  border-top-right-radius: calc(0.4285rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.75rem 0.75rem;
  color: #525f7f;
}

.carousel {
  position: relative;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-item {
  position: relative;
  display: none;
  align-items: center;
  width: 100%;
  backface-visibility: hidden;
  perspective: 1000px;
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
  transition: transform 0.6s ease;
}
@media screen and (prefers-reduced-motion: reduce) {
  .carousel-item.active,
  .carousel-item-next,
  .carousel-item-prev {
    transition: none;
  }
}

.carousel-item-next,
.carousel-item-prev {
  position: absolute;
  top: 0;
}

.carousel-item-next.carousel-item-left,
.carousel-item-prev.carousel-item-right {
  transform: translateX(0);
}
@supports (transform-style: preserve-3d) {
  .carousel-item-next.carousel-item-left,
  .carousel-item-prev.carousel-item-right {
    transform: translate3d(0, 0, 0);
  }
}

.carousel-item-next,
.active.carousel-item-right {
  transform: translateX(100%);
}
@supports (transform-style: preserve-3d) {
  .carousel-item-next,
  .active.carousel-item-right {
    transform: translate3d(100%, 0, 0);
  }
}

.carousel-item-prev,
.active.carousel-item-left {
  transform: translateX(-100%);
}
@supports (transform-style: preserve-3d) {
  .carousel-item-prev,
  .active.carousel-item-left {
    transform: translate3d(-100%, 0, 0);
  }
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-duration: 0.6s;
  transition-property: opacity;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  opacity: 0;
}
.carousel-fade .carousel-item-next,
.carousel-fade .carousel-item-prev,
.carousel-fade .carousel-item.active,
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-prev {
  transform: translateX(0);
}
@supports (transform-style: preserve-3d) {
  .carousel-fade .carousel-item-next,
  .carousel-fade .carousel-item-prev,
  .carousel-fade .carousel-item.active,
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-prev {
    transform: translate3d(0, 0, 0);
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #ffffff;
  text-align: center;
  opacity: 0.5;
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #ffffff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: transparent no-repeat center center;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 10px;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  position: relative;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.5);
}
.carousel-indicators li::before {
  position: absolute;
  top: -10px;
  left: 0;
  display: inline-block;
  width: 100%;
  height: 10px;
  content: "";
}
.carousel-indicators li::after {
  position: absolute;
  bottom: -10px;
  left: 0;
  display: inline-block;
  width: 100%;
  height: 10px;
  content: "";
}
.carousel-indicators .active {
  background-color: #ffffff;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #ffffff;
  text-align: center;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #e14eca !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: rgb(84.5012787724%, 14.3222506394%, 73.5208866155%) !important;
}

.bg-secondary {
  background-color: #f4f5f7 !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: rgb(84.1073271414%, 85.5521155831%, 88.4416924665%) !important;
}

.bg-success {
  background-color: #00f2c3 !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: rgb(0%, 74.9019607843%, 60.354885756%) !important;
}

.bg-info {
  background-color: #1d8cf8 !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: rgb(2.6626272827%, 44.8842884793%, 85.9648236977%) !important;
}

.bg-warning {
  background-color: #ff8d72 !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: rgb(100%, 39.1239048811%, 24.7058823529%) !important;
}

.bg-danger {
  background-color: #fd5d93 !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: rgb(98.9717838355%, 16.7144906743%, 44.4763271162%) !important;
}

.bg-light {
  background-color: #adb5bd !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: rgb(56.7620561738%, 60.9803921569%, 65.1987281399%) !important;
}

.bg-dark {
  background-color: #212529 !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: rgb(4.0222575517%, 4.5098039216%, 4.9973502915%) !important;
}

.bg-default {
  background-color: #344675 !important;
}

a.bg-default:hover, a.bg-default:focus,
button.bg-default:hover,
button.bg-default:focus {
  background-color: rgb(14.2383107089%, 19.1669567235%, 32.036199095%) !important;
}

.bg-white {
  background-color: #ffffff !important;
}

a.bg-white:hover, a.bg-white:focus,
button.bg-white:hover,
button.bg-white:focus {
  background-color: rgb(90%, 90%, 90%) !important;
}

.bg-neutral {
  background-color: #ffffff !important;
}

a.bg-neutral:hover, a.bg-neutral:focus,
button.bg-neutral:hover,
button.bg-neutral:focus {
  background-color: rgb(90%, 90%, 90%) !important;
}

.bg-darker {
  background-color: black !important;
}

a.bg-darker:hover, a.bg-darker:focus,
button.bg-darker:hover,
button.bg-darker:focus {
  background-color: black !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 0.0625rem solid #e9ecef !important;
}

.border-top {
  border-top: 0.0625rem solid #e9ecef !important;
}

.border-right {
  border-right: 0.0625rem solid #e9ecef !important;
}

.border-bottom {
  border-bottom: 0.0625rem solid #e9ecef !important;
}

.border-left {
  border-left: 0.0625rem solid #e9ecef !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #e14eca !important;
}

.border-secondary {
  border-color: #f4f5f7 !important;
}

.border-success {
  border-color: #00f2c3 !important;
}

.border-info {
  border-color: #1d8cf8 !important;
}

.border-warning {
  border-color: #ff8d72 !important;
}

.border-danger {
  border-color: #fd5d93 !important;
}

.border-light {
  border-color: #adb5bd !important;
}

.border-dark {
  border-color: #212529 !important;
}

.border-default {
  border-color: #344675 !important;
}

.border-white {
  border-color: #ffffff !important;
}

.border-neutral {
  border-color: #ffffff !important;
}

.border-darker {
  border-color: black !important;
}

.border-white {
  border-color: #ffffff !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.8571428571%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(34, 42, 66, 0.075) !important;
}

.shadow {
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(34, 42, 66, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.m-sm {
  margin: 2rem !important;
}

.mt-sm,
.my-sm {
  margin-top: 2rem !important;
}

.mr-sm,
.mx-sm {
  margin-right: 2rem !important;
}

.mb-sm,
.my-sm {
  margin-bottom: 2rem !important;
}

.ml-sm,
.mx-sm {
  margin-left: 2rem !important;
}

.m-md {
  margin: 4rem !important;
}

.mt-md,
.my-md {
  margin-top: 4rem !important;
}

.mr-md,
.mx-md {
  margin-right: 4rem !important;
}

.mb-md,
.my-md {
  margin-bottom: 4rem !important;
}

.ml-md,
.mx-md {
  margin-left: 4rem !important;
}

.m-lg {
  margin: 6rem !important;
}

.mt-lg,
.my-lg {
  margin-top: 6rem !important;
}

.mr-lg,
.mx-lg {
  margin-right: 6rem !important;
}

.mb-lg,
.my-lg {
  margin-bottom: 6rem !important;
}

.ml-lg,
.mx-lg {
  margin-left: 6rem !important;
}

.m-xl {
  margin: 8rem !important;
}

.mt-xl,
.my-xl {
  margin-top: 8rem !important;
}

.mr-xl,
.mx-xl {
  margin-right: 8rem !important;
}

.mb-xl,
.my-xl {
  margin-bottom: 8rem !important;
}

.ml-xl,
.mx-xl {
  margin-left: 8rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.p-sm {
  padding: 2rem !important;
}

.pt-sm,
.py-sm {
  padding-top: 2rem !important;
}

.pr-sm,
.px-sm {
  padding-right: 2rem !important;
}

.pb-sm,
.py-sm {
  padding-bottom: 2rem !important;
}

.pl-sm,
.px-sm {
  padding-left: 2rem !important;
}

.p-md {
  padding: 4rem !important;
}

.pt-md,
.py-md {
  padding-top: 4rem !important;
}

.pr-md,
.px-md {
  padding-right: 4rem !important;
}

.pb-md,
.py-md {
  padding-bottom: 4rem !important;
}

.pl-md,
.px-md {
  padding-left: 4rem !important;
}

.p-lg {
  padding: 6rem !important;
}

.pt-lg,
.py-lg {
  padding-top: 6rem !important;
}

.pr-lg,
.px-lg {
  padding-right: 6rem !important;
}

.pb-lg,
.py-lg {
  padding-bottom: 6rem !important;
}

.pl-lg,
.px-lg {
  padding-left: 6rem !important;
}

.p-xl {
  padding: 8rem !important;
}

.pt-xl,
.py-xl {
  padding-top: 8rem !important;
}

.pr-xl,
.px-xl {
  padding-right: 8rem !important;
}

.pb-xl,
.py-xl {
  padding-bottom: 8rem !important;
}

.pl-xl,
.px-xl {
  padding-left: 8rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }
  .m-sm-sm {
    margin: 2rem !important;
  }
  .mt-sm-sm,
  .my-sm-sm {
    margin-top: 2rem !important;
  }
  .mr-sm-sm,
  .mx-sm-sm {
    margin-right: 2rem !important;
  }
  .mb-sm-sm,
  .my-sm-sm {
    margin-bottom: 2rem !important;
  }
  .ml-sm-sm,
  .mx-sm-sm {
    margin-left: 2rem !important;
  }
  .m-sm-md {
    margin: 4rem !important;
  }
  .mt-sm-md,
  .my-sm-md {
    margin-top: 4rem !important;
  }
  .mr-sm-md,
  .mx-sm-md {
    margin-right: 4rem !important;
  }
  .mb-sm-md,
  .my-sm-md {
    margin-bottom: 4rem !important;
  }
  .ml-sm-md,
  .mx-sm-md {
    margin-left: 4rem !important;
  }
  .m-sm-lg {
    margin: 6rem !important;
  }
  .mt-sm-lg,
  .my-sm-lg {
    margin-top: 6rem !important;
  }
  .mr-sm-lg,
  .mx-sm-lg {
    margin-right: 6rem !important;
  }
  .mb-sm-lg,
  .my-sm-lg {
    margin-bottom: 6rem !important;
  }
  .ml-sm-lg,
  .mx-sm-lg {
    margin-left: 6rem !important;
  }
  .m-sm-xl {
    margin: 8rem !important;
  }
  .mt-sm-xl,
  .my-sm-xl {
    margin-top: 8rem !important;
  }
  .mr-sm-xl,
  .mx-sm-xl {
    margin-right: 8rem !important;
  }
  .mb-sm-xl,
  .my-sm-xl {
    margin-bottom: 8rem !important;
  }
  .ml-sm-xl,
  .mx-sm-xl {
    margin-left: 8rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }
  .p-sm-sm {
    padding: 2rem !important;
  }
  .pt-sm-sm,
  .py-sm-sm {
    padding-top: 2rem !important;
  }
  .pr-sm-sm,
  .px-sm-sm {
    padding-right: 2rem !important;
  }
  .pb-sm-sm,
  .py-sm-sm {
    padding-bottom: 2rem !important;
  }
  .pl-sm-sm,
  .px-sm-sm {
    padding-left: 2rem !important;
  }
  .p-sm-md {
    padding: 4rem !important;
  }
  .pt-sm-md,
  .py-sm-md {
    padding-top: 4rem !important;
  }
  .pr-sm-md,
  .px-sm-md {
    padding-right: 4rem !important;
  }
  .pb-sm-md,
  .py-sm-md {
    padding-bottom: 4rem !important;
  }
  .pl-sm-md,
  .px-sm-md {
    padding-left: 4rem !important;
  }
  .p-sm-lg {
    padding: 6rem !important;
  }
  .pt-sm-lg,
  .py-sm-lg {
    padding-top: 6rem !important;
  }
  .pr-sm-lg,
  .px-sm-lg {
    padding-right: 6rem !important;
  }
  .pb-sm-lg,
  .py-sm-lg {
    padding-bottom: 6rem !important;
  }
  .pl-sm-lg,
  .px-sm-lg {
    padding-left: 6rem !important;
  }
  .p-sm-xl {
    padding: 8rem !important;
  }
  .pt-sm-xl,
  .py-sm-xl {
    padding-top: 8rem !important;
  }
  .pr-sm-xl,
  .px-sm-xl {
    padding-right: 8rem !important;
  }
  .pb-sm-xl,
  .py-sm-xl {
    padding-bottom: 8rem !important;
  }
  .pl-sm-xl,
  .px-sm-xl {
    padding-left: 8rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }
  .m-md-sm {
    margin: 2rem !important;
  }
  .mt-md-sm,
  .my-md-sm {
    margin-top: 2rem !important;
  }
  .mr-md-sm,
  .mx-md-sm {
    margin-right: 2rem !important;
  }
  .mb-md-sm,
  .my-md-sm {
    margin-bottom: 2rem !important;
  }
  .ml-md-sm,
  .mx-md-sm {
    margin-left: 2rem !important;
  }
  .m-md-md {
    margin: 4rem !important;
  }
  .mt-md-md,
  .my-md-md {
    margin-top: 4rem !important;
  }
  .mr-md-md,
  .mx-md-md {
    margin-right: 4rem !important;
  }
  .mb-md-md,
  .my-md-md {
    margin-bottom: 4rem !important;
  }
  .ml-md-md,
  .mx-md-md {
    margin-left: 4rem !important;
  }
  .m-md-lg {
    margin: 6rem !important;
  }
  .mt-md-lg,
  .my-md-lg {
    margin-top: 6rem !important;
  }
  .mr-md-lg,
  .mx-md-lg {
    margin-right: 6rem !important;
  }
  .mb-md-lg,
  .my-md-lg {
    margin-bottom: 6rem !important;
  }
  .ml-md-lg,
  .mx-md-lg {
    margin-left: 6rem !important;
  }
  .m-md-xl {
    margin: 8rem !important;
  }
  .mt-md-xl,
  .my-md-xl {
    margin-top: 8rem !important;
  }
  .mr-md-xl,
  .mx-md-xl {
    margin-right: 8rem !important;
  }
  .mb-md-xl,
  .my-md-xl {
    margin-bottom: 8rem !important;
  }
  .ml-md-xl,
  .mx-md-xl {
    margin-left: 8rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }
  .p-md-sm {
    padding: 2rem !important;
  }
  .pt-md-sm,
  .py-md-sm {
    padding-top: 2rem !important;
  }
  .pr-md-sm,
  .px-md-sm {
    padding-right: 2rem !important;
  }
  .pb-md-sm,
  .py-md-sm {
    padding-bottom: 2rem !important;
  }
  .pl-md-sm,
  .px-md-sm {
    padding-left: 2rem !important;
  }
  .p-md-md {
    padding: 4rem !important;
  }
  .pt-md-md,
  .py-md-md {
    padding-top: 4rem !important;
  }
  .pr-md-md,
  .px-md-md {
    padding-right: 4rem !important;
  }
  .pb-md-md,
  .py-md-md {
    padding-bottom: 4rem !important;
  }
  .pl-md-md,
  .px-md-md {
    padding-left: 4rem !important;
  }
  .p-md-lg {
    padding: 6rem !important;
  }
  .pt-md-lg,
  .py-md-lg {
    padding-top: 6rem !important;
  }
  .pr-md-lg,
  .px-md-lg {
    padding-right: 6rem !important;
  }
  .pb-md-lg,
  .py-md-lg {
    padding-bottom: 6rem !important;
  }
  .pl-md-lg,
  .px-md-lg {
    padding-left: 6rem !important;
  }
  .p-md-xl {
    padding: 8rem !important;
  }
  .pt-md-xl,
  .py-md-xl {
    padding-top: 8rem !important;
  }
  .pr-md-xl,
  .px-md-xl {
    padding-right: 8rem !important;
  }
  .pb-md-xl,
  .py-md-xl {
    padding-bottom: 8rem !important;
  }
  .pl-md-xl,
  .px-md-xl {
    padding-left: 8rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }
  .m-lg-sm {
    margin: 2rem !important;
  }
  .mt-lg-sm,
  .my-lg-sm {
    margin-top: 2rem !important;
  }
  .mr-lg-sm,
  .mx-lg-sm {
    margin-right: 2rem !important;
  }
  .mb-lg-sm,
  .my-lg-sm {
    margin-bottom: 2rem !important;
  }
  .ml-lg-sm,
  .mx-lg-sm {
    margin-left: 2rem !important;
  }
  .m-lg-md {
    margin: 4rem !important;
  }
  .mt-lg-md,
  .my-lg-md {
    margin-top: 4rem !important;
  }
  .mr-lg-md,
  .mx-lg-md {
    margin-right: 4rem !important;
  }
  .mb-lg-md,
  .my-lg-md {
    margin-bottom: 4rem !important;
  }
  .ml-lg-md,
  .mx-lg-md {
    margin-left: 4rem !important;
  }
  .m-lg-lg {
    margin: 6rem !important;
  }
  .mt-lg-lg,
  .my-lg-lg {
    margin-top: 6rem !important;
  }
  .mr-lg-lg,
  .mx-lg-lg {
    margin-right: 6rem !important;
  }
  .mb-lg-lg,
  .my-lg-lg {
    margin-bottom: 6rem !important;
  }
  .ml-lg-lg,
  .mx-lg-lg {
    margin-left: 6rem !important;
  }
  .m-lg-xl {
    margin: 8rem !important;
  }
  .mt-lg-xl,
  .my-lg-xl {
    margin-top: 8rem !important;
  }
  .mr-lg-xl,
  .mx-lg-xl {
    margin-right: 8rem !important;
  }
  .mb-lg-xl,
  .my-lg-xl {
    margin-bottom: 8rem !important;
  }
  .ml-lg-xl,
  .mx-lg-xl {
    margin-left: 8rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }
  .p-lg-sm {
    padding: 2rem !important;
  }
  .pt-lg-sm,
  .py-lg-sm {
    padding-top: 2rem !important;
  }
  .pr-lg-sm,
  .px-lg-sm {
    padding-right: 2rem !important;
  }
  .pb-lg-sm,
  .py-lg-sm {
    padding-bottom: 2rem !important;
  }
  .pl-lg-sm,
  .px-lg-sm {
    padding-left: 2rem !important;
  }
  .p-lg-md {
    padding: 4rem !important;
  }
  .pt-lg-md,
  .py-lg-md {
    padding-top: 4rem !important;
  }
  .pr-lg-md,
  .px-lg-md {
    padding-right: 4rem !important;
  }
  .pb-lg-md,
  .py-lg-md {
    padding-bottom: 4rem !important;
  }
  .pl-lg-md,
  .px-lg-md {
    padding-left: 4rem !important;
  }
  .p-lg-lg {
    padding: 6rem !important;
  }
  .pt-lg-lg,
  .py-lg-lg {
    padding-top: 6rem !important;
  }
  .pr-lg-lg,
  .px-lg-lg {
    padding-right: 6rem !important;
  }
  .pb-lg-lg,
  .py-lg-lg {
    padding-bottom: 6rem !important;
  }
  .pl-lg-lg,
  .px-lg-lg {
    padding-left: 6rem !important;
  }
  .p-lg-xl {
    padding: 8rem !important;
  }
  .pt-lg-xl,
  .py-lg-xl {
    padding-top: 8rem !important;
  }
  .pr-lg-xl,
  .px-lg-xl {
    padding-right: 8rem !important;
  }
  .pb-lg-xl,
  .py-lg-xl {
    padding-bottom: 8rem !important;
  }
  .pl-lg-xl,
  .px-lg-xl {
    padding-left: 8rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }
  .m-xl-sm {
    margin: 2rem !important;
  }
  .mt-xl-sm,
  .my-xl-sm {
    margin-top: 2rem !important;
  }
  .mr-xl-sm,
  .mx-xl-sm {
    margin-right: 2rem !important;
  }
  .mb-xl-sm,
  .my-xl-sm {
    margin-bottom: 2rem !important;
  }
  .ml-xl-sm,
  .mx-xl-sm {
    margin-left: 2rem !important;
  }
  .m-xl-md {
    margin: 4rem !important;
  }
  .mt-xl-md,
  .my-xl-md {
    margin-top: 4rem !important;
  }
  .mr-xl-md,
  .mx-xl-md {
    margin-right: 4rem !important;
  }
  .mb-xl-md,
  .my-xl-md {
    margin-bottom: 4rem !important;
  }
  .ml-xl-md,
  .mx-xl-md {
    margin-left: 4rem !important;
  }
  .m-xl-lg {
    margin: 6rem !important;
  }
  .mt-xl-lg,
  .my-xl-lg {
    margin-top: 6rem !important;
  }
  .mr-xl-lg,
  .mx-xl-lg {
    margin-right: 6rem !important;
  }
  .mb-xl-lg,
  .my-xl-lg {
    margin-bottom: 6rem !important;
  }
  .ml-xl-lg,
  .mx-xl-lg {
    margin-left: 6rem !important;
  }
  .m-xl-xl {
    margin: 8rem !important;
  }
  .mt-xl-xl,
  .my-xl-xl {
    margin-top: 8rem !important;
  }
  .mr-xl-xl,
  .mx-xl-xl {
    margin-right: 8rem !important;
  }
  .mb-xl-xl,
  .my-xl-xl {
    margin-bottom: 8rem !important;
  }
  .ml-xl-xl,
  .mx-xl-xl {
    margin-left: 8rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }
  .p-xl-sm {
    padding: 2rem !important;
  }
  .pt-xl-sm,
  .py-xl-sm {
    padding-top: 2rem !important;
  }
  .pr-xl-sm,
  .px-xl-sm {
    padding-right: 2rem !important;
  }
  .pb-xl-sm,
  .py-xl-sm {
    padding-bottom: 2rem !important;
  }
  .pl-xl-sm,
  .px-xl-sm {
    padding-left: 2rem !important;
  }
  .p-xl-md {
    padding: 4rem !important;
  }
  .pt-xl-md,
  .py-xl-md {
    padding-top: 4rem !important;
  }
  .pr-xl-md,
  .px-xl-md {
    padding-right: 4rem !important;
  }
  .pb-xl-md,
  .py-xl-md {
    padding-bottom: 4rem !important;
  }
  .pl-xl-md,
  .px-xl-md {
    padding-left: 4rem !important;
  }
  .p-xl-lg {
    padding: 6rem !important;
  }
  .pt-xl-lg,
  .py-xl-lg {
    padding-top: 6rem !important;
  }
  .pr-xl-lg,
  .px-xl-lg {
    padding-right: 6rem !important;
  }
  .pb-xl-lg,
  .py-xl-lg {
    padding-bottom: 6rem !important;
  }
  .pl-xl-lg,
  .px-xl-lg {
    padding-left: 6rem !important;
  }
  .p-xl-xl {
    padding: 8rem !important;
  }
  .pt-xl-xl,
  .py-xl-xl {
    padding-top: 8rem !important;
  }
  .pr-xl-xl,
  .px-xl-xl {
    padding-right: 8rem !important;
  }
  .pb-xl-xl,
  .py-xl-xl {
    padding-bottom: 8rem !important;
  }
  .pl-xl-xl,
  .px-xl-xl {
    padding-left: 8rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}
.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.text-justify {
  text-align: justify !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 600 !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #ffffff !important;
}

.text-primary {
  color: #e14eca !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: rgb(84.5012787724%, 14.3222506394%, 73.5208866155%) !important;
}

.text-secondary {
  color: #f4f5f7 !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: rgb(84.1073271414%, 85.5521155831%, 88.4416924665%) !important;
}

.text-success {
  color: #00f2c3 !important;
}

a.text-success:hover, a.text-success:focus {
  color: rgb(0%, 74.9019607843%, 60.354885756%) !important;
}

.text-info {
  color: #1d8cf8 !important;
}

a.text-info:hover, a.text-info:focus {
  color: rgb(2.6626272827%, 44.8842884793%, 85.9648236977%) !important;
}

.text-warning {
  color: #ff8d72 !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: rgb(100%, 39.1239048811%, 24.7058823529%) !important;
}

.text-danger {
  color: #fd5d93 !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: rgb(98.9717838355%, 16.7144906743%, 44.4763271162%) !important;
}

.text-light {
  color: #adb5bd !important;
}

a.text-light:hover, a.text-light:focus {
  color: rgb(56.7620561738%, 60.9803921569%, 65.1987281399%) !important;
}

.text-dark {
  color: #212529 !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: rgb(4.0222575517%, 4.5098039216%, 4.9973502915%) !important;
}

.text-default {
  color: #344675 !important;
}

a.text-default:hover, a.text-default:focus {
  color: rgb(14.2383107089%, 19.1669567235%, 32.036199095%) !important;
}

.text-white {
  color: #ffffff !important;
}

a.text-white:hover, a.text-white:focus {
  color: rgb(90%, 90%, 90%) !important;
}

.text-neutral {
  color: #ffffff !important;
}

a.text-neutral:hover, a.text-neutral:focus {
  color: rgb(90%, 90%, 90%) !important;
}

.text-darker {
  color: black !important;
}

a.text-darker:hover, a.text-darker:focus {
  color: black !important;
}

.text-body {
  color: #525f7f !important;
}

.text-muted {
  color: #6c757d !important;
}

.text-black-50 {
  color: rgba(34, 42, 66, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
  blockquote {
    border: 0.0625rem solid #adb5bd;
    page-break-inside: avoid;
  }
  thead {
    display: table-header-group;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 0.0625rem solid #222a42;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
  .table th {
    background-color: #ffffff !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #e3e3e3 !important;
  }
  .table-dark {
    color: inherit;
  }
  .table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody + tbody {
    border-color: #e3e3e3;
  }
  .table .thead-dark th {
    color: inherit;
    border-color: #e3e3e3;
  }
}
.alert {
  border: 0;
  color: #ffffff;
}
.alert .alert-link {
  color: #ffffff;
}
.alert.alert-success {
  background-color: rgb(0%, 74.9019607843%, 60.354885756%);
}
.alert i.fa,
.alert i.tim-icons {
  font-size: 1rem;
}
.alert .close {
  color: #ffffff;
  opacity: 0.9;
  text-shadow: none;
  line-height: 0;
  outline: 0;
}
.alert .close::after {
  display: inline-block;
  font: normal normal normal 1em/1 "Nucleo";
  vertical-align: middle;
  speak: none;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  font-size: 1rem;
  content: "\\ea48";
}
.alert .close span {
  display: none !important;
}
.alert span[data-notify=icon] {
  font-size: 22px;
  display: block;
  left: 19px;
  position: absolute;
  top: 50%;
  margin-top: -11px;
}
.alert button.close {
  position: absolute;
  right: 15px;
  top: 50%;
  margin-top: -13px;
  width: 25px;
  height: 25px;
  padding: 3px;
}
.alert .close ~ span {
  display: block;
  max-width: 89%;
}
.alert.alert-with-icon {
  padding-left: 65px;
}

.alert-dismissible {
  padding-right: 1.25rem;
}
.alert-dismissible .close:hover, .alert-dismissible .close:focus {
  color: rgba(255, 255, 255, 0.9);
  opacity: 1 !important;
}
@media (max-width: 575.98px) {
  .alert-dismissible .close {
    top: 1rem;
    right: 0.5rem;
  }
}
.alert-dismissible .close > span:not(.sr-only) {
  font-size: 1.5rem;
  background-color: transparent;
  color: rgba(255, 255, 255, 0.6);
}
.alert-dismissible .close:hover > span:not(.sr-only), .alert-dismissible .close:focus > span:not(.sr-only) {
  background-color: transparent;
  color: rgba(255, 255, 255, 0.9);
}
.alert-dismissible.animated {
  z-index: 9999;
}
.alert-dismissible.animated .close {
  right: 10px;
}

.badge + .badge {
  margin-left: 5px;
}

.btn,
.navbar .navbar-nav > a.btn {
  border-width: 2px;
  border: none;
  position: relative;
  overflow: hidden;
  margin: 4px 1px;
  border-radius: 0.4285rem;
  cursor: pointer;
  background: #344675;
  background-image: linear-gradient(to bottom left, #344675, #263148, #344675);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #344675;
  transition: all 0.15s ease;
  box-shadow: none;
}
.btn.animation-on-hover:hover,
.navbar .navbar-nav > a.btn.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn:hover, .btn:focus, .btn:active, .btn.active, .btn:active:focus, .btn:active:hover, .btn.active:focus, .btn.active:hover,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus,
.navbar .navbar-nav > a.btn:active,
.navbar .navbar-nav > a.btn.active,
.navbar .navbar-nav > a.btn:active:focus,
.navbar .navbar-nav > a.btn:active:hover,
.navbar .navbar-nav > a.btn.active:focus,
.navbar .navbar-nav > a.btn.active:hover {
  color: #ffffff;
  box-shadow: none;
}
.btn:active,
.navbar .navbar-nav > a.btn:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn:not([data-action]):hover,
.navbar .navbar-nav > a.btn:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn.disabled, .btn.disabled:hover, .btn.disabled:focus, .btn.disabled.focus, .btn.disabled:active, .btn.disabled.active, .btn:disabled, .btn:disabled:hover, .btn:disabled:focus, .btn:disabled.focus, .btn:disabled:active, .btn:disabled.active, .btn[disabled], .btn[disabled]:hover, .btn[disabled]:focus, .btn[disabled].focus, .btn[disabled]:active, .btn[disabled].active, fieldset[disabled] .btn, fieldset[disabled] .btn:hover, fieldset[disabled] .btn:focus, fieldset[disabled] .btn.focus, fieldset[disabled] .btn:active, fieldset[disabled] .btn.active,
.navbar .navbar-nav > a.btn.disabled,
.navbar .navbar-nav > a.btn.disabled:hover,
.navbar .navbar-nav > a.btn.disabled:focus,
.navbar .navbar-nav > a.btn.disabled.focus,
.navbar .navbar-nav > a.btn.disabled:active,
.navbar .navbar-nav > a.btn.disabled.active,
.navbar .navbar-nav > a.btn:disabled,
.navbar .navbar-nav > a.btn:disabled:hover,
.navbar .navbar-nav > a.btn:disabled:focus,
.navbar .navbar-nav > a.btn:disabled.focus,
.navbar .navbar-nav > a.btn:disabled:active,
.navbar .navbar-nav > a.btn:disabled.active,
.navbar .navbar-nav > a.btn[disabled],
.navbar .navbar-nav > a.btn[disabled]:hover,
.navbar .navbar-nav > a.btn[disabled]:focus,
.navbar .navbar-nav > a.btn[disabled].focus,
.navbar .navbar-nav > a.btn[disabled]:active,
.navbar .navbar-nav > a.btn[disabled].active,
fieldset[disabled] .navbar .navbar-nav > a.btn,
fieldset[disabled] .navbar .navbar-nav > a.btn:hover,
fieldset[disabled] .navbar .navbar-nav > a.btn:focus,
fieldset[disabled] .navbar .navbar-nav > a.btn.focus,
fieldset[disabled] .navbar .navbar-nav > a.btn:active,
fieldset[disabled] .navbar .navbar-nav > a.btn.active {
  background-color: #344675;
  border-color: #344675;
}
.btn,
.navbar .navbar-nav > a.btn {
  color: #ffffff;
}
.btn.btn-simple,
.navbar .navbar-nav > a.btn.btn-simple {
  color: #344675;
  border-color: #344675;
  background: transparent;
}
.btn.btn-simple:hover, .btn.btn-simple:focus, .btn.btn-simple:active, .btn.btn-simple:not(:disabled):not(.disabled):active,
.navbar .navbar-nav > a.btn.btn-simple:hover,
.navbar .navbar-nav > a.btn.btn-simple:focus,
.navbar .navbar-nav > a.btn.btn-simple:active,
.navbar .navbar-nav > a.btn.btn-simple:not(:disabled):not(.disabled):active {
  color: #344675;
  border-color: #344675;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn.btn-simple.active,
.navbar .navbar-nav > a.btn.btn-simple.active {
  border-color: #344675 !important;
}
.btn.btn-simple.active:hover, .btn.btn-simple.active:focus, .btn.btn-simple.active:active, .btn.btn-simple.active:not(:disabled):not(.disabled):active,
.navbar .navbar-nav > a.btn.btn-simple.active:hover,
.navbar .navbar-nav > a.btn.btn-simple.active:focus,
.navbar .navbar-nav > a.btn.btn-simple.active:active,
.navbar .navbar-nav > a.btn.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #344675;
  background-image: linear-gradient(to bottom left, #344675, #263148, #344675) !important;
  background-image: -moz-linear-gradient(to bottom left, #344675, #263148, #344675) !important;
  background-color: #263148 !important;
  box-shadow: none;
}
.btn.btn-link,
.navbar .navbar-nav > a.btn.btn-link {
  color: #344675;
}
.btn.btn-link:hover, .btn.btn-link:focus, .btn.btn-link:active,
.navbar .navbar-nav > a.btn.btn-link:hover,
.navbar .navbar-nav > a.btn.btn-link:focus,
.navbar .navbar-nav > a.btn.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}
.btn:hover, .btn:focus,
.navbar .navbar-nav > a.btn:hover,
.navbar .navbar-nav > a.btn:focus {
  opacity: 1;
  filter: alpha(opacity=100);
  outline: 0 !important;
}
.btn:active, .btn.active, .open > .btn.dropdown-toggle,
.navbar .navbar-nav > a.btn:active,
.navbar .navbar-nav > a.btn.active,
.open > .navbar .navbar-nav > a.btn.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}
.btn .badge,
.navbar .navbar-nav > a.btn .badge {
  margin: 0;
}
.btn.btn-icon,
.navbar .navbar-nav > a.btn.btn-icon {
  height: 2.375rem;
  min-width: 2.375rem;
  width: 2.375rem;
  padding: 0;
  font-size: 0.9375rem;
  overflow: hidden;
  position: relative;
  line-height: normal;
}
.btn.btn-icon.btn-simple,
.navbar .navbar-nav > a.btn.btn-icon.btn-simple {
  padding: 0;
}
.btn.btn-icon.btn-sm, .btn-group-sm > .btn.btn-icon,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm {
  height: 1.875rem;
  min-width: 1.875rem;
  width: 1.875rem;
}
.btn.btn-icon.btn-sm .fa, .btn-group-sm > .btn.btn-icon .fa,
.btn.btn-icon.btn-sm .far,
.btn-group-sm > .btn.btn-icon .far,
.btn.btn-icon.btn-sm .fas,
.btn-group-sm > .btn.btn-icon .fas,
.btn.btn-icon.btn-sm .tim-icons,
.btn-group-sm > .btn.btn-icon .tim-icons,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fa,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .far,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .fas,
.navbar .navbar-nav > a.btn.btn-icon.btn-sm .tim-icons {
  font-size: 0.6875rem;
}
.btn.btn-icon.btn-lg, .btn-group-lg > .btn.btn-icon,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg {
  height: 3.6rem;
  min-width: 3.6rem;
  width: 3.6rem;
}
.btn.btn-icon.btn-lg .fa, .btn-group-lg > .btn.btn-icon .fa,
.btn.btn-icon.btn-lg .far,
.btn-group-lg > .btn.btn-icon .far,
.btn.btn-icon.btn-lg .fas,
.btn-group-lg > .btn.btn-icon .fas,
.btn.btn-icon.btn-lg .tim-icons,
.btn-group-lg > .btn.btn-icon .tim-icons,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fa,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .far,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .fas,
.navbar .navbar-nav > a.btn.btn-icon.btn-lg .tim-icons {
  font-size: 1.325rem;
}
.btn.btn-icon:not(.btn-footer) .tim-icons, .btn.btn-icon:not(.btn-footer) .fa, .btn.btn-icon:not(.btn-footer) .far, .btn.btn-icon:not(.btn-footer) .fas,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .tim-icons,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fa,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .far,
.navbar .navbar-nav > a.btn.btn-icon:not(.btn-footer) .fas {
  position: absolute;
  font-size: 1em;
  top: 50%;
  left: 50%;
  transform: translate(-12px, -12px);
  line-height: 1.5626rem;
  width: 24px;
}
.btn:not(.btn-icon) .tim-icons,
.navbar .navbar-nav > a.btn:not(.btn-icon) .tim-icons {
  position: relative;
  top: 1px;
}
.btn span,
.navbar .navbar-nav > a.btn span {
  position: relative;
  display: block;
}
.btn.btn-link.dropdown-toggle,
.navbar .navbar-nav > a.btn.btn-link.dropdown-toggle {
  color: #9a9a9a;
}
.btn.dropdown-toggle:after,
.navbar .navbar-nav > a.btn.dropdown-toggle:after {
  margin-left: 30px !important;
}

.btn-primary {
  background: #e14eca;
  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #e14eca;
  transition: all 0.15s ease;
  box-shadow: none;
}
.btn-primary.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .btn-primary:active:focus, .btn-primary:active:hover, .btn-primary.active:focus, .btn-primary.active:hover {
  color: #ffffff;
  box-shadow: none;
}
.btn-primary:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-primary:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-primary.disabled, .btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled.focus, .btn-primary.disabled:active, .btn-primary.disabled.active, .btn-primary:disabled, .btn-primary:disabled:hover, .btn-primary:disabled:focus, .btn-primary:disabled.focus, .btn-primary:disabled:active, .btn-primary:disabled.active, .btn-primary[disabled], .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled].focus, .btn-primary[disabled]:active, .btn-primary[disabled].active, fieldset[disabled] .btn-primary, fieldset[disabled] .btn-primary:hover, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary.focus, fieldset[disabled] .btn-primary:active, fieldset[disabled] .btn-primary.active {
  background-color: #e14eca;
  border-color: #e14eca;
}
.btn-primary {
  color: #ffffff;
}
.btn-primary.btn-simple {
  color: #e14eca;
  border-color: #e14eca;
  background: transparent;
}
.btn-primary.btn-simple:hover, .btn-primary.btn-simple:focus, .btn-primary.btn-simple:active, .btn-primary.btn-simple:not(:disabled):not(.disabled):active {
  color: #e14eca;
  border-color: #e14eca;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-primary.btn-simple.active {
  border-color: #e14eca !important;
}
.btn-primary.btn-simple.active:hover, .btn-primary.btn-simple.active:focus, .btn-primary.btn-simple.active:active, .btn-primary.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #e14eca;
  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca) !important;
  background-image: -moz-linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca) !important;
  background-color: #ba54f5 !important;
  box-shadow: none;
}
.btn-primary.btn-link {
  color: #e14eca;
}
.btn-primary.btn-link:hover, .btn-primary.btn-link:focus, .btn-primary.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.btn-success {
  background: #00f2c3;
  background-image: linear-gradient(to bottom left, #00f2c3, #0098f0, #00f2c3);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #00f2c3;
  transition: all 0.15s ease;
  box-shadow: none;
}
.btn-success.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-success:hover, .btn-success:focus, .btn-success:active, .btn-success.active, .btn-success:active:focus, .btn-success:active:hover, .btn-success.active:focus, .btn-success.active:hover {
  color: #ffffff;
  box-shadow: none;
}
.btn-success:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-success:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-success.disabled, .btn-success.disabled:hover, .btn-success.disabled:focus, .btn-success.disabled.focus, .btn-success.disabled:active, .btn-success.disabled.active, .btn-success:disabled, .btn-success:disabled:hover, .btn-success:disabled:focus, .btn-success:disabled.focus, .btn-success:disabled:active, .btn-success:disabled.active, .btn-success[disabled], .btn-success[disabled]:hover, .btn-success[disabled]:focus, .btn-success[disabled].focus, .btn-success[disabled]:active, .btn-success[disabled].active, fieldset[disabled] .btn-success, fieldset[disabled] .btn-success:hover, fieldset[disabled] .btn-success:focus, fieldset[disabled] .btn-success.focus, fieldset[disabled] .btn-success:active, fieldset[disabled] .btn-success.active {
  background-color: #00f2c3;
  border-color: #00f2c3;
}
.btn-success {
  color: #ffffff;
}
.btn-success.btn-simple {
  color: #00f2c3;
  border-color: #00f2c3;
  background: transparent;
}
.btn-success.btn-simple:hover, .btn-success.btn-simple:focus, .btn-success.btn-simple:active, .btn-success.btn-simple:not(:disabled):not(.disabled):active {
  color: #00f2c3;
  border-color: #00f2c3;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-success.btn-simple.active {
  border-color: #00f2c3 !important;
}
.btn-success.btn-simple.active:hover, .btn-success.btn-simple.active:focus, .btn-success.btn-simple.active:active, .btn-success.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #00f2c3;
  background-image: linear-gradient(to bottom left, #00f2c3, #0098f0, #00f2c3) !important;
  background-image: -moz-linear-gradient(to bottom left, #00f2c3, #0098f0, #00f2c3) !important;
  background-color: #0098f0 !important;
  box-shadow: none;
}
.btn-success.btn-link {
  color: #00f2c3;
}
.btn-success.btn-link:hover, .btn-success.btn-link:focus, .btn-success.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.btn-info {
  background: #1d8cf8;
  background-image: linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #1d8cf8;
  transition: all 0.15s ease;
  box-shadow: none;
}
.btn-info.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active, .btn-info:active:focus, .btn-info:active:hover, .btn-info.active:focus, .btn-info.active:hover {
  color: #ffffff;
  box-shadow: none;
}
.btn-info:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-info:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-info.disabled, .btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled.focus, .btn-info.disabled:active, .btn-info.disabled.active, .btn-info:disabled, .btn-info:disabled:hover, .btn-info:disabled:focus, .btn-info:disabled.focus, .btn-info:disabled:active, .btn-info:disabled.active, .btn-info[disabled], .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled].focus, .btn-info[disabled]:active, .btn-info[disabled].active, fieldset[disabled] .btn-info, fieldset[disabled] .btn-info:hover, fieldset[disabled] .btn-info:focus, fieldset[disabled] .btn-info.focus, fieldset[disabled] .btn-info:active, fieldset[disabled] .btn-info.active {
  background-color: #1d8cf8;
  border-color: #1d8cf8;
}
.btn-info {
  color: #ffffff;
}
.btn-info.btn-simple {
  color: #1d8cf8;
  border-color: #1d8cf8;
  background: transparent;
}
.btn-info.btn-simple:hover, .btn-info.btn-simple:focus, .btn-info.btn-simple:active, .btn-info.btn-simple:not(:disabled):not(.disabled):active {
  color: #1d8cf8;
  border-color: #1d8cf8;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-info.btn-simple.active {
  border-color: #1d8cf8 !important;
}
.btn-info.btn-simple.active:hover, .btn-info.btn-simple.active:focus, .btn-info.btn-simple.active:active, .btn-info.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #1d8cf8;
  background-image: linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8) !important;
  background-image: -moz-linear-gradient(to bottom left, #1d8cf8, #3358f4, #1d8cf8) !important;
  background-color: #3358f4 !important;
  box-shadow: none;
}
.btn-info.btn-link {
  color: #1d8cf8;
}
.btn-info.btn-link:hover, .btn-info.btn-link:focus, .btn-info.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.btn-warning {
  background: #ff8d72;
  background-image: linear-gradient(to bottom left, #ff8d72, #ff6491, #ff8d72);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #ff8d72;
  transition: all 0.15s ease;
  box-shadow: none;
}
.btn-warning.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-warning:hover, .btn-warning:focus, .btn-warning:active, .btn-warning.active, .btn-warning:active:focus, .btn-warning:active:hover, .btn-warning.active:focus, .btn-warning.active:hover {
  color: #ffffff;
  box-shadow: none;
}
.btn-warning:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-warning:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-warning.disabled, .btn-warning.disabled:hover, .btn-warning.disabled:focus, .btn-warning.disabled.focus, .btn-warning.disabled:active, .btn-warning.disabled.active, .btn-warning:disabled, .btn-warning:disabled:hover, .btn-warning:disabled:focus, .btn-warning:disabled.focus, .btn-warning:disabled:active, .btn-warning:disabled.active, .btn-warning[disabled], .btn-warning[disabled]:hover, .btn-warning[disabled]:focus, .btn-warning[disabled].focus, .btn-warning[disabled]:active, .btn-warning[disabled].active, fieldset[disabled] .btn-warning, fieldset[disabled] .btn-warning:hover, fieldset[disabled] .btn-warning:focus, fieldset[disabled] .btn-warning.focus, fieldset[disabled] .btn-warning:active, fieldset[disabled] .btn-warning.active {
  background-color: #ff8d72;
  border-color: #ff8d72;
}
.btn-warning {
  color: #ffffff;
}
.btn-warning.btn-simple {
  color: #ff8d72;
  border-color: #ff8d72;
  background: transparent;
}
.btn-warning.btn-simple:hover, .btn-warning.btn-simple:focus, .btn-warning.btn-simple:active, .btn-warning.btn-simple:not(:disabled):not(.disabled):active {
  color: #ff8d72;
  border-color: #ff8d72;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-warning.btn-simple.active {
  border-color: #ff8d72 !important;
}
.btn-warning.btn-simple.active:hover, .btn-warning.btn-simple.active:focus, .btn-warning.btn-simple.active:active, .btn-warning.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #ff8d72;
  background-image: linear-gradient(to bottom left, #ff8d72, #ff6491, #ff8d72) !important;
  background-image: -moz-linear-gradient(to bottom left, #ff8d72, #ff6491, #ff8d72) !important;
  background-color: #ff6491 !important;
  box-shadow: none;
}
.btn-warning.btn-link {
  color: #ff8d72;
}
.btn-warning.btn-link:hover, .btn-warning.btn-link:focus, .btn-warning.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}
.btn-warning:not(:disabled):not(.disabled):active {
  color: #ffffff;
}

.btn-danger {
  background: #fd5d93;
  background-image: linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #fd5d93;
  transition: all 0.15s ease;
  box-shadow: none;
}
.btn-danger.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-danger:hover, .btn-danger:focus, .btn-danger:active, .btn-danger.active, .btn-danger:active:focus, .btn-danger:active:hover, .btn-danger.active:focus, .btn-danger.active:hover {
  color: #ffffff;
  box-shadow: none;
}
.btn-danger:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-danger:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-danger.disabled, .btn-danger.disabled:hover, .btn-danger.disabled:focus, .btn-danger.disabled.focus, .btn-danger.disabled:active, .btn-danger.disabled.active, .btn-danger:disabled, .btn-danger:disabled:hover, .btn-danger:disabled:focus, .btn-danger:disabled.focus, .btn-danger:disabled:active, .btn-danger:disabled.active, .btn-danger[disabled], .btn-danger[disabled]:hover, .btn-danger[disabled]:focus, .btn-danger[disabled].focus, .btn-danger[disabled]:active, .btn-danger[disabled].active, fieldset[disabled] .btn-danger, fieldset[disabled] .btn-danger:hover, fieldset[disabled] .btn-danger:focus, fieldset[disabled] .btn-danger.focus, fieldset[disabled] .btn-danger:active, fieldset[disabled] .btn-danger.active {
  background-color: #fd5d93;
  border-color: #fd5d93;
}
.btn-danger {
  color: #ffffff;
}
.btn-danger.btn-simple {
  color: #fd5d93;
  border-color: #fd5d93;
  background: transparent;
}
.btn-danger.btn-simple:hover, .btn-danger.btn-simple:focus, .btn-danger.btn-simple:active, .btn-danger.btn-simple:not(:disabled):not(.disabled):active {
  color: #fd5d93;
  border-color: #fd5d93;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-danger.btn-simple.active {
  border-color: #fd5d93 !important;
}
.btn-danger.btn-simple.active:hover, .btn-danger.btn-simple.active:focus, .btn-danger.btn-simple.active:active, .btn-danger.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #fd5d93;
  background-image: linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93) !important;
  background-image: -moz-linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93) !important;
  background-color: #ec250d !important;
  box-shadow: none;
}
.btn-danger.btn-link {
  color: #fd5d93;
}
.btn-danger.btn-link:hover, .btn-danger.btn-link:focus, .btn-danger.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.btn-neutral {
  background: #ffffff;
  background-image: linear-gradient(to bottom left, #ffffff, #ffffff, #ffffff);
  background-size: 210% 210%;
  background-position: top right;
  background-color: #ffffff;
  transition: all 0.15s ease;
  box-shadow: none;
}
.btn-neutral.animation-on-hover:hover {
  background-position: bottom left;
  transition: 0.3s ease-in-out;
}
.btn-neutral:hover, .btn-neutral:focus, .btn-neutral:active, .btn-neutral.active, .btn-neutral:active:focus, .btn-neutral:active:hover, .btn-neutral.active:focus, .btn-neutral.active:hover {
  color: #ffffff;
  box-shadow: none;
}
.btn-neutral:active {
  box-shadow: none !important;
  transform: translateY(1px) !important;
  transition: all 0.15s ease;
}
.btn-neutral:not([data-action]):hover {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}
.btn-neutral.disabled, .btn-neutral.disabled:hover, .btn-neutral.disabled:focus, .btn-neutral.disabled.focus, .btn-neutral.disabled:active, .btn-neutral.disabled.active, .btn-neutral:disabled, .btn-neutral:disabled:hover, .btn-neutral:disabled:focus, .btn-neutral:disabled.focus, .btn-neutral:disabled:active, .btn-neutral:disabled.active, .btn-neutral[disabled], .btn-neutral[disabled]:hover, .btn-neutral[disabled]:focus, .btn-neutral[disabled].focus, .btn-neutral[disabled]:active, .btn-neutral[disabled].active, fieldset[disabled] .btn-neutral, fieldset[disabled] .btn-neutral:hover, fieldset[disabled] .btn-neutral:focus, fieldset[disabled] .btn-neutral.focus, fieldset[disabled] .btn-neutral:active, fieldset[disabled] .btn-neutral.active {
  background-color: #ffffff;
  border-color: #ffffff;
}
.btn-neutral {
  color: #e14eca;
}
.btn-neutral.btn-danger {
  color: #fd5d93;
}
.btn-neutral.btn-danger:hover, .btn-neutral.btn-danger:focus, .btn-neutral.btn-danger:active, .btn-neutral.btn-danger:active:focus {
  color: #ec250d;
}
.btn-neutral.btn-info {
  color: #1d8cf8;
}
.btn-neutral.btn-info:hover, .btn-neutral.btn-info:focus, .btn-neutral.btn-info:active, .btn-neutral.btn-info:active:focus {
  color: #3358f4;
}
.btn-neutral.btn-warning {
  color: #ff8d72;
}
.btn-neutral.btn-warning:hover, .btn-neutral.btn-warning:focus, .btn-neutral.btn-warning:active, .btn-neutral.btn-warning:active:focus {
  color: #ff6491;
}
.btn-neutral.btn-success {
  color: #00f2c3;
}
.btn-neutral.btn-success:hover, .btn-neutral.btn-success:focus, .btn-neutral.btn-success:active, .btn-neutral.btn-success:active:focus {
  color: #0098f0;
}
.btn-neutral.btn-default {
  color: #344675;
}
.btn-neutral.btn-default:hover, .btn-neutral.btn-default:focus, .btn-neutral.btn-default:active, .btn-neutral.btn-default:active:focus {
  color: #263148;
}
.btn-neutral.active, .btn-neutral:active, .btn-neutral:active:focus, .btn-neutral:active:hover, .btn-neutral.active:focus, .btn-neutral.active:hover, .show > .btn-neutral.dropdown-toggle, .show > .btn-neutral.dropdown-toggle:focus, .show > .btn-neutral.dropdown-toggle:hover {
  background-color: #ffffff;
  color: #ba54f5;
  box-shadow: none;
}
.btn-neutral:hover, .btn-neutral:focus {
  color: #ba54f5;
}
.btn-neutral:hover:not(.nav-link), .btn-neutral:focus:not(.nav-link) {
  box-shadow: none;
}
.btn-neutral.btn-simple {
  color: #ffffff;
  border-color: #ffffff;
  background: transparent;
}
.btn-neutral.btn-simple:hover, .btn-neutral.btn-simple:focus, .btn-neutral.btn-simple:active, .btn-neutral.btn-simple:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #ffffff;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none;
}
.btn-neutral.btn-simple.active {
  border-color: #ffffff !important;
}
.btn-neutral.btn-simple.active:hover, .btn-neutral.btn-simple.active:focus, .btn-neutral.btn-simple.active:active, .btn-neutral.btn-simple.active:not(:disabled):not(.disabled):active {
  color: #ffffff;
  border-color: #ffffff;
  background-image: linear-gradient(to bottom left, #ffffff, #ffffff, #ffffff) !important;
  background-image: -moz-linear-gradient(to bottom left, #ffffff, #ffffff, #ffffff) !important;
  background-color: #ffffff !important;
  box-shadow: none;
}
.btn-neutral.btn-link {
  color: #ffffff;
}
.btn-neutral.btn-link:hover, .btn-neutral.btn-link:focus, .btn-neutral.btn-link:active {
  background-color: transparent !important;
  background-image: none !important;
  color: #ffffff !important;
  text-decoration: none;
  box-shadow: none;
}

.btn:disabled, .btn[disabled], .btn.disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
  pointer-events: none;
}

.btn-simple {
  border: 1px solid;
  border-color: #344675;
  box-shadow: none;
  padding: 10px 22px;
  background-color: transparent;
}

.btn-simple.disabled, .btn-simple.disabled:hover, .btn-simple.disabled:focus, .btn-simple.disabled.focus, .btn-simple.disabled:active, .btn-simple.disabled.active, .btn-simple:disabled, .btn-simple:disabled:hover, .btn-simple:disabled:focus, .btn-simple:disabled.focus, .btn-simple:disabled:active, .btn-simple:disabled.active, .btn-simple[disabled], .btn-simple[disabled]:hover, .btn-simple[disabled]:focus, .btn-simple[disabled].focus, .btn-simple[disabled]:active, .btn-simple[disabled].active, fieldset[disabled] .btn-simple, fieldset[disabled] .btn-simple:hover, fieldset[disabled] .btn-simple:focus, fieldset[disabled] .btn-simple.focus, fieldset[disabled] .btn-simple:active, fieldset[disabled] .btn-simple.active,
.btn-link.disabled,
.btn-link.disabled:hover,
.btn-link.disabled:focus,
.btn-link.disabled.focus,
.btn-link.disabled:active,
.btn-link.disabled.active,
.btn-link:disabled,
.btn-link:disabled:hover,
.btn-link:disabled:focus,
.btn-link:disabled.focus,
.btn-link:disabled:active,
.btn-link:disabled.active,
.btn-link[disabled],
.btn-link[disabled]:hover,
.btn-link[disabled]:focus,
.btn-link[disabled].focus,
.btn-link[disabled]:active,
.btn-link[disabled].active,
fieldset[disabled] .btn-link,
fieldset[disabled] .btn-link:hover,
fieldset[disabled] .btn-link:focus,
fieldset[disabled] .btn-link.focus,
fieldset[disabled] .btn-link:active,
fieldset[disabled] .btn-link.active {
  background: transparent;
}

.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
}

.btn-link {
  border: 0;
  box-shadow: none;
  padding: 0.5rem 0.7rem;
  background: transparent;
  color: #e3e3e3;
  font-weight: 600;
}
.btn-link:hover {
  box-shadow: none !important;
  transform: none !important;
}

.btn-lg, .btn-group-lg > .btn {
  font-size: 0.875rem;
  border-radius: 0.4285rem;
  padding: 15px 48px;
}
.btn-lg.btn-simple, .btn-group-lg > .btn-simple.btn {
  padding: 14px 47px;
}

.btn-sm, .btn-group-sm > .btn {
  font-size: 0.875rem;
  border-radius: 0.2857rem;
  padding: 5px 15px;
}
.btn-sm.btn-simple, .btn-group-sm > .btn-simple.btn {
  padding: 4px 14px;
}

.btn-wd {
  min-width: 140px;
}

.btn-group.select {
  width: 100%;
}

.btn-group .btn.active {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}

.btn-group.select .btn {
  text-align: left;
}

.btn-group.select .caret {
  position: absolute;
  top: 50%;
  margin-top: -1px;
  right: 8px;
}

.btn-group .btn.active {
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  -webkit-transform: translateY(-1px);
}

.btn-round {
  border-width: 1px;
  border-radius: 30px;
}
.btn-round.btn-simple {
  padding: 10px 22px;
}

.no-caret.dropdown-toggle::after {
  display: none;
}

.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
  color: #ffffff;
}

.btn-group label.btn.active {
  transform: translateY(0);
  -webkit-transform: translateY(0);
}

.btn + .btn {
  margin-left: 5px;
}

.dropdown-menu {
  border: 0;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  border-radius: 0.1428rem;
  transition: all 150ms linear;
}
.dropdown-menu.dropdown-menu-right:before, .dropdown-menu.dropdown-menu-right:after {
  left: auto;
  right: 10px;
}
.dropdown-menu.dropdown-black {
  background: linear-gradient(to bottom, #222a42 0%, #1d253b 100%);
  border: 1px solid #344675;
}
.dropdown-menu.dropdown-black .dropdown-item {
  color: rgba(255, 255, 255, 0.7);
}
.dropdown-menu.dropdown-black .dropdown-divider {
  border-color: #344675;
}
.dropdown-menu.dropdown-black:before {
  color: #222a42;
  z-index: 2;
}
.dropdown-menu.dropdown-black:after {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  z-index: 1;
  vertical-align: middle;
  content: "";
  top: -6px;
  left: 10px;
  right: auto;
  color: #344675;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.dropdown-menu.dropdown-black.dropdown-menu-right:after {
  left: auto;
  right: 10px;
}
.dropup .dropdown-menu.dropdown-black:after {
  color: #1d253b;
  z-index: 2;
}
.dropup .dropdown-menu.dropdown-black:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: auto;
  bottom: -6px;
  right: auto;
  left: 10px;
  color: #555555;
  border-top: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
  border-bottom: none;
  z-index: 1;
}
.dropdown-menu i {
  margin-right: 5px;
  position: relative;
  top: 1px;
}
.dropdown-menu .tim-icons {
  margin-right: 10px;
  position: relative;
  top: 4px;
  font-size: 18px;
  margin-top: -5px;
  opacity: 0.5;
}
.dropdown-menu .dropdown-item.active, .dropdown-menu .dropdown-item:active {
  color: inherit;
}
.dropup .dropdown-menu:before {
  display: none;
}
.dropup .dropdown-menu:after {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: auto;
  bottom: -5px;
  right: auto;
  left: 10px;
  color: #ffffff;
  border-top: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
  border-bottom: none;
}
.dropup .dropdown-menu.dropdown-menu-right:after, .dropup .dropdown-menu.dropdown-menu-right:before {
  right: 10px;
  left: auto;
}
.dropdown-menu:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: -5px;
  left: 10px;
  right: auto;
  color: #ffffff;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.dropdown-menu.dropdown-menu-right {
  right: 0 !important;
  left: auto !important;
}
.dropdown-menu .dropdown-item, .bootstrap-select .dropdown-menu.inner li a {
  font-size: 0.7500000025rem;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  margin-top: 5px;
  transition: all 150ms linear;
}
.dropdown-menu .dropdown-item:hover, .dropdown-menu .dropdown-item:focus, .bootstrap-select .dropdown-menu.inner li a:hover, .bootstrap-select .dropdown-menu.inner li a:focus {
  background-color: rgba(222, 222, 222, 0.3);
}
.dropdown-menu .dropdown-item.disabled, .dropdown-menu .dropdown-item:disabled, .bootstrap-select .dropdown-menu.inner li a.disabled, .bootstrap-select .dropdown-menu.inner li a:disabled {
  color: rgba(182, 182, 182, 0.6);
}
.dropdown-menu .dropdown-item.disabled:hover, .dropdown-menu .dropdown-item.disabled:focus, .dropdown-menu .dropdown-item:disabled:hover, .dropdown-menu .dropdown-item:disabled:focus, .bootstrap-select .dropdown-menu.inner li a.disabled:hover, .bootstrap-select .dropdown-menu.inner li a.disabled:focus, .bootstrap-select .dropdown-menu.inner li a:disabled:hover, .bootstrap-select .dropdown-menu.inner li a:disabled:focus {
  background-color: transparent;
  box-shadow: none;
}
.dropdown-menu .dropdown-divider {
  background-color: rgba(222, 222, 222, 0.5);
}
.dropdown-menu .dropdown-header:not([href]) {
  color: rgba(182, 182, 182, 0.6);
  font-size: 0.62475rem;
  text-transform: uppercase;
  font-weight: 600;
}
.dropdown-menu.dropdown-primary {
  background-color: rgb(87.3657289003%, 25.4578005115%, 77.6794543905%);
}
.dropdown-menu.dropdown-primary:before {
  color: rgb(87.3657289003%, 25.4578005115%, 77.6794543905%);
}
.dropdown-menu.dropdown-primary .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-primary .dropdown-item {
  color: #ffffff;
}
.dropdown-menu.dropdown-primary .dropdown-item:hover, .dropdown-menu.dropdown-primary .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-primary .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-info {
  background-color: rgb(5.5528065303%, 51.9405873938%, 97.0746444501%);
}
.dropdown-menu.dropdown-info:before {
  color: rgb(5.5528065303%, 51.9405873938%, 97.0746444501%);
}
.dropdown-menu.dropdown-info .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-info .dropdown-item {
  color: #ffffff;
}
.dropdown-menu.dropdown-info .dropdown-item:hover, .dropdown-menu.dropdown-info .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-info .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-danger {
  background-color: rgb(99.1425155428%, 30.543758967%, 53.6958393113%);
}
.dropdown-menu.dropdown-danger:before {
  color: rgb(99.1425155428%, 30.543758967%, 53.6958393113%);
}
.dropdown-menu.dropdown-danger .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-danger .dropdown-item {
  color: #ffffff;
}
.dropdown-menu.dropdown-danger .dropdown-item:hover, .dropdown-menu.dropdown-danger .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-danger .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-success {
  background-color: rgb(0%, 88.9019607843%, 71.6358774915%);
}
.dropdown-menu.dropdown-success:before {
  color: rgb(0%, 88.9019607843%, 71.6358774915%);
}
.dropdown-menu.dropdown-success .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-success .dropdown-item {
  color: #ffffff;
}
.dropdown-menu.dropdown-success .dropdown-item:hover, .dropdown-menu.dropdown-success .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-success .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-warning {
  background-color: rgb(100%, 50.4430538173%, 38.7058823529%);
}
.dropdown-menu.dropdown-warning:before {
  color: rgb(100%, 50.4430538173%, 38.7058823529%);
}
.dropdown-menu.dropdown-warning .dropdown-header:not([href]):not([tabindex]) {
  color: rgba(255, 255, 255, 0.8);
}
.dropdown-menu.dropdown-warning .dropdown-item {
  color: #ffffff;
}
.dropdown-menu.dropdown-warning .dropdown-item:hover, .dropdown-menu.dropdown-warning .dropdown-item:focus {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown-menu.dropdown-warning .dropdown-divider {
  background-color: rgba(255, 255, 255, 0.2);
}
.dropdown .dropdown-menu, .dropup:not(.bootstrap-select) .dropdown-menu, .bootstrap-select .dropdown-menu:not(.inner), .dropdown-menu.bootstrap-datetimepicker-widget.bottom {
  transform: translate3d(0, -20px, 0) !important;
  visibility: hidden;
  display: block;
  opacity: 0;
  filter: alpha(opacity=0);
  top: 100% !important;
}
.dropdown-menu.bootstrap-datetimepicker-widget.top {
  transform: translate3d(0, -20px, 0) !important;
  visibility: hidden;
  display: block;
  opacity: 0;
  filter: alpha(opacity=0);
}
.dropdown-menu.bootstrap-datetimepicker-widget.top, .dropdown-menu.bootstrap-datetimepicker-widget.bottom {
  transform: translate3d(0, -20px, 0) !important;
}
.bootstrap-select.dropup .dropdown-menu:not(.inner) {
  transform: translate3d(0, 25px, 0) !important;
}
.dropup:not(.bootstrap-select) .dropdown-menu {
  transform: translate3d(0, 20px, 0) !important;
  top: auto !important;
  bottom: 100%;
}
.dropdown.show .dropdown-menu, .bootstrap-select.show .dropdown-menu:not(.inner), .dropdown-menu.bootstrap-datetimepicker-widget.top.open, .dropdown-menu.bootstrap-datetimepicker-widget.bottom.open, .dropup.show:not(.bootstrap-select) .dropdown-menu, .navbar .dropdown.show .dropdown-menu {
  opacity: 1;
  filter: alpha(opacity=100);
  visibility: visible;
  transform: translate3d(0, 1px, 0) !important;
}
.dropdown-menu.bootstrap-datetimepicker-widget.top.open, .dropdown-menu.bootstrap-datetimepicker-widget.bottom.open {
  transform: translate3d(0, 0px, 0) !important;
}
.dropup.show:not(.bootstrap-select) .dropdown-menu {
  transform: translate3d(0, -2px, 0) !important;
}
.dropdown-menu.dropdown-navbar {
  left: -80px;
}
.dropdown-menu.dropdown-navbar:before, .dropdown-menu.dropdown-navbar:after {
  left: auto;
  right: 17px;
}

.btn {
  cursor: pointer;
}
.btn.dropdown-toggle[data-toggle=dropdown] {
  padding: 10px;
  margin: 0;
  margin-bottom: 5px;
}
.btn.dropdown-toggle[data-toggle=dropdown]:after {
  content: "";
  margin-left: 5px;
}
.btn span.bs-caret {
  display: none;
}
.btn.btn-link.dropdown-toggle {
  height: 22px;
  padding: 0;
  margin-right: 5px;
}

.dropdown-toggle:after {
  content: normal;
  content: initial;
}

.btn:not(:disabled):not(.disabled).active:focus,
.btn:not(:disabled):not(.disabled):active:focus,
.show > .btn.dropdown-toggle:focus {
  box-shadow: none;
}

.dropdown-menu-sm {
  min-width: 100px;
  border: 0.4285rem;
}

.dropdown-menu-lg {
  min-width: 260px;
  border-radius: 0.4285rem;
}

.dropdown-menu-xl {
  min-width: 450px;
  border-radius: 0.4285rem;
}

@media screen and (max-width: 991px) {
  .dropdown-toggle:after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }
}
@media screen and (min-width: 992px) {
  .dropdown-menu .dropdown-item {
    color: #9a9a9a;
  }
}
.footer {
  padding: 24px 0 24px 250px;
}
.footer [class*=container-] {
  padding: 0;
}
.footer .nav {
  display: inline-block;
  float: left;
  margin-bottom: 0;
  padding-left: 30px;
  list-style: none;
}
.footer .nav-item {
  display: inline-block;
}
.footer .nav-item:first-child a {
  padding-left: 0;
}
.footer .nav-link {
  color: #ffffff;
  padding: 0 0.5rem;
  font-size: 0.7500000025rem;
  text-transform: uppercase;
  text-decoration: none;
}
.footer .nav-link:hover {
  text-decoration: none;
}
.footer .copyright {
  font-size: 0.7500000025rem;
  line-height: 1.8;
  color: #ffffff;
}
.footer:after {
  display: table;
  clear: both;
  content: " ";
}

@media screen and (max-width: 991px) {
  .footer {
    padding-left: 0px;
  }
  .footer .copyright {
    text-align: right;
    margin-right: 15px;
  }
}
@media screen and (min-width: 992px) {
  .footer .copyright {
    float: right;
    padding-right: 30px;
  }
}
@media screen and (max-width: 768px) {
  .footer nav {
    display: block;
    margin-bottom: 5px;
    float: none;
  }
}
@media screen and (max-width: 576px) {
  .footer {
    text-align: center;
  }
  .footer .copyright {
    text-align: center;
  }
  .footer .nav {
    float: none;
    padding-left: 0;
  }
}
/* Form controls */
.form-control::-moz-placeholder {
  color: #6c757c;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control:-moz-placeholder {
  color: #6c757c;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control::-webkit-input-placeholder {
  color: #6c757c;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control:-ms-input-placeholder {
  color: #6c757c;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control {
  border-color: rgb(16.7333333333%, 20.6705882353%, 32.4823529412%);
  border-radius: 0.4285rem;
  font-size: 0.7500000025rem;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
}
.form-control:focus {
  border-color: #e14eca;
  background-color: transparent;
  box-shadow: none;
}
.form-control:focus + .input-group-append .input-group-text, .form-control:focus ~ .input-group-append .input-group-text, .form-control:focus + .input-group-prepend .input-group-text, .form-control:focus ~ .input-group-prepend .input-group-text {
  border: 1px solid #e14eca;
  border-left: none;
  background-color: transparent;
}
.has-success .form-control, .has-error .form-control, .has-success .form-control:focus, .has-error .form-control:focus {
  box-shadow: none;
}
.has-danger .form-control.form-control-success, .has-danger .form-control.form-control-danger, .has-success .form-control.form-control-success, .has-success .form-control.form-control-danger {
  background-image: none;
}
.form-control + .form-control-feedback {
  border-radius: 0.4285rem;
  margin-top: -7px;
  position: absolute;
  right: 10px;
  top: 50%;
  vertical-align: middle;
}
.open .form-control {
  border-radius: 0.4285rem 0.4285rem 0 0;
  border-bottom-color: transparent;
}
.form-control + .input-group-append .input-group-text, .form-control + .input-group-prepend .input-group-text {
  background-color: #ffffff;
}

.has-success .input-group-append .input-group-text,
.has-success .input-group-prepend .input-group-text,
.has-success .form-control {
  border-color: rgb(16.7333333333%, 20.6705882353%, 32.4823529412%);
}

.has-success .form-control:focus,
.has-success.input-group-focus .input-group-append .input-group-text,
.has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: rgb(0%, 74.9019607843%, 60.354885756%);
}

.has-danger .form-control,
.has-danger .input-group-append .input-group-text,
.has-danger .input-group-prepend .input-group-text,
.has-danger.input-group-focus .input-group-prepend .input-group-text,
.has-danger.input-group-focus .input-group-append .input-group-text {
  border-color: rgb(95.1783605008%, 21.3701866289%, 12.4686983227%);
  color: #ec250d;
  background-color: rgba(222, 222, 222, 0.1);
}
.has-danger .form-control:focus,
.has-danger .input-group-append .input-group-text:focus,
.has-danger .input-group-prepend .input-group-text:focus,
.has-danger.input-group-focus .input-group-prepend .input-group-text:focus,
.has-danger.input-group-focus .input-group-append .input-group-text:focus {
  background-color: transparent;
}

.has-success:after,
.has-danger:after {
  font-family: "nucleo";
  content: "\\ea1b";
  display: inline-block;
  position: absolute;
  right: 20px;
  top: 13px;
  color: #00f2c3;
  font-size: 11px;
}
.has-success.form-control-lg:after,
.has-danger.form-control-lg:after {
  font-size: 13px;
  top: 24px;
}
.has-success.has-label:after,
.has-danger.has-label:after {
  top: 37px;
}
.has-success.form-check:after,
.has-danger.form-check:after {
  display: none !important;
}
.has-success.form-check .form-check-label,
.has-danger.form-check .form-check-label {
  color: #00f2c3;
}

.has-danger:after {
  content: "\\ea48";
  color: #ec250d;
}
.has-danger.form-check .form-check-label {
  color: #ec250d;
}

img {
  max-width: 100%;
  border-radius: 0.2857rem;
}

.img-raised {
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}

.modal-content {
  border: 0;
}
.modal-content .modal-header {
  border-bottom: none;
}
.modal-content .modal-header button {
  position: absolute;
  right: 27px;
  top: 24px;
  outline: 0;
  padding: 1rem;
  margin: -1rem -1rem -1rem auto;
}
.modal-content .modal-header .title {
  color: #222a42;
  margin-top: 5px;
  margin-bottom: 0;
}
.modal-content .modal-header .modal-title {
  color: #222a42;
}
.modal-content .modal-header i.tim-icons {
  font-size: 16px;
}
.modal-content .modal-body {
  line-height: 1.9;
}
.modal-content .modal-body p {
  color: #222a42;
}
.modal-content .modal-footer {
  border-top: 0; /* Safari 6.1+ */
  justify-content: space-between;
}
.modal-content .modal-footer button {
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  width: auto;
}
.modal-content .modal-footer button.pull-left {
  padding-left: 5px;
  padding-right: 5px;
  position: relative;
  left: -5px;
}
.modal-content .modal-body + .modal-footer {
  padding-top: 0;
}

.modal-backdrop {
  background: rgba(0, 0, 0, 0.3);
}

.modal.modal-default .modal-content {
  background-color: #ffffff;
  color: #222a42;
}
.modal.modal-default .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-default .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-default .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-default .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-default .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-default .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-default .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-default .has-success:after,
.modal.modal-default .has-danger:after {
  color: #ffffff;
}
.modal.modal-default .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-default .input-group-prepend {
  margin-right: 0;
}
.modal.modal-default .input-group-prepend .input-group-text,
.modal.modal-default .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-default .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-default .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-default .form-group.no-border .form-control,
.modal.modal-default .input-group.no-border .form-control {
  background-color: rgba(30, 30, 47, 0.2);
  color: #ffffff;
}
.modal.modal-default .form-group.no-border .form-control:focus, .modal.modal-default .form-group.no-border .form-control:active, .modal.modal-default .form-group.no-border .form-control:active,
.modal.modal-default .input-group.no-border .form-control:focus,
.modal.modal-default .input-group.no-border .form-control:active,
.modal.modal-default .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-default .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-default .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-default .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-default .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
}
.modal.modal-default .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-default .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-default .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-default .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-default .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-default .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-default .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-default .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-default .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-default .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-default .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-default .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-default .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-default .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-default .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-default .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-default .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-default .form-group.no-border .input-group-append .input-group-text,
.modal.modal-default .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-default .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-default .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-default .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-default .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-default .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-primary .modal-content {
  background-color: #e14eca;
  color: #ffffff;
}
.modal.modal-primary .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-primary .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-primary .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-primary .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-primary .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-primary .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-primary .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-primary .has-success:after,
.modal.modal-primary .has-danger:after {
  color: #ffffff;
}
.modal.modal-primary .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-primary .input-group-prepend {
  margin-right: 0;
}
.modal.modal-primary .input-group-prepend .input-group-text,
.modal.modal-primary .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-primary .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-primary .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border .form-control,
.modal.modal-primary .input-group.no-border .form-control {
  background-color: rgba(30, 30, 47, 0.2);
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border .form-control:focus, .modal.modal-primary .form-group.no-border .form-control:active, .modal.modal-primary .form-group.no-border .form-control:active,
.modal.modal-primary .input-group.no-border .form-control:focus,
.modal.modal-primary .input-group.no-border .form-control:active,
.modal.modal-primary .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-primary .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-primary .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-primary .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
}
.modal.modal-primary .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-primary .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-primary .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-primary .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-primary .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-primary .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-primary .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-primary .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-primary .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-primary .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-primary .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-primary .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-primary .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-primary .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-primary .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-primary .form-group.no-border .input-group-append .input-group-text,
.modal.modal-primary .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-primary .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-primary .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-primary .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-primary .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-primary .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-danger .modal-content {
  background-color: #fd5d93;
  color: #ffffff;
}
.modal.modal-danger .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-danger .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-danger .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-danger .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-danger .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-danger .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-danger .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-danger .has-success:after,
.modal.modal-danger .has-danger:after {
  color: #ffffff;
}
.modal.modal-danger .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-danger .input-group-prepend {
  margin-right: 0;
}
.modal.modal-danger .input-group-prepend .input-group-text,
.modal.modal-danger .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-danger .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-danger .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border .form-control,
.modal.modal-danger .input-group.no-border .form-control {
  background-color: rgba(30, 30, 47, 0.2);
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border .form-control:focus, .modal.modal-danger .form-group.no-border .form-control:active, .modal.modal-danger .form-group.no-border .form-control:active,
.modal.modal-danger .input-group.no-border .form-control:focus,
.modal.modal-danger .input-group.no-border .form-control:active,
.modal.modal-danger .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-danger .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-danger .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-danger .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
}
.modal.modal-danger .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-danger .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-danger .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-danger .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-danger .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-danger .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-danger .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-danger .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-danger .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-danger .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-danger .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-danger .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-danger .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-danger .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-danger .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-danger .form-group.no-border .input-group-append .input-group-text,
.modal.modal-danger .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-danger .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-danger .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-danger .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-danger .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-danger .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-warning .modal-content {
  background-color: #ff8d72;
  color: #ffffff;
}
.modal.modal-warning .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-warning .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-warning .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-warning .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-warning .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-warning .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-warning .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-warning .has-success:after,
.modal.modal-warning .has-danger:after {
  color: #ffffff;
}
.modal.modal-warning .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-warning .input-group-prepend {
  margin-right: 0;
}
.modal.modal-warning .input-group-prepend .input-group-text,
.modal.modal-warning .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-warning .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-warning .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border .form-control,
.modal.modal-warning .input-group.no-border .form-control {
  background-color: rgba(30, 30, 47, 0.2);
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border .form-control:focus, .modal.modal-warning .form-group.no-border .form-control:active, .modal.modal-warning .form-group.no-border .form-control:active,
.modal.modal-warning .input-group.no-border .form-control:focus,
.modal.modal-warning .input-group.no-border .form-control:active,
.modal.modal-warning .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-warning .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-warning .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-warning .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
}
.modal.modal-warning .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-warning .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-warning .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-warning .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-warning .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-warning .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-warning .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-warning .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-warning .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-warning .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-warning .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-warning .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-warning .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-warning .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-warning .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-warning .form-group.no-border .input-group-append .input-group-text,
.modal.modal-warning .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-warning .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-warning .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-warning .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-warning .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-warning .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-success .modal-content {
  background-color: #00f2c3;
  color: #ffffff;
}
.modal.modal-success .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-success .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-success .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-success .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-success .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-success .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-success .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-success .has-success:after,
.modal.modal-success .has-danger:after {
  color: #ffffff;
}
.modal.modal-success .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-success .input-group-prepend {
  margin-right: 0;
}
.modal.modal-success .input-group-prepend .input-group-text,
.modal.modal-success .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-success .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-success .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-success .form-group.no-border .form-control,
.modal.modal-success .input-group.no-border .form-control {
  background-color: rgba(30, 30, 47, 0.2);
  color: #ffffff;
}
.modal.modal-success .form-group.no-border .form-control:focus, .modal.modal-success .form-group.no-border .form-control:active, .modal.modal-success .form-group.no-border .form-control:active,
.modal.modal-success .input-group.no-border .form-control:focus,
.modal.modal-success .input-group.no-border .form-control:active,
.modal.modal-success .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-success .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-success .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-success .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-success .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
}
.modal.modal-success .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-success .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-success .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-success .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-success .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-success .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-success .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-success .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-success .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-success .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-success .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-success .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-success .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-success .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-success .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-success .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-success .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-success .form-group.no-border .input-group-append .input-group-text,
.modal.modal-success .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-success .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-success .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-success .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-success .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-success .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-info .modal-content {
  background-color: #1d8cf8;
  color: #ffffff;
}
.modal.modal-info .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-info .form-control::-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-info .form-control:-moz-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-info .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-info .form-control:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.modal.modal-info .form-control {
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-info .form-control:focus {
  border-color: #ffffff;
  background-color: transparent;
  color: #ffffff;
}
.modal.modal-info .has-success:after,
.modal.modal-info .has-danger:after {
  color: #ffffff;
}
.modal.modal-info .has-danger .form-control {
  background-color: transparent;
}
.modal.modal-info .input-group-prepend {
  margin-right: 0;
}
.modal.modal-info .input-group-prepend .input-group-text,
.modal.modal-info .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: #ffffff;
}
.modal.modal-info .input-group-focus .input-group-prepend .input-group-text,
.modal.modal-info .input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  border-color: #ffffff;
  color: #ffffff;
}
.modal.modal-info .form-group.no-border .form-control,
.modal.modal-info .input-group.no-border .form-control {
  background-color: rgba(30, 30, 47, 0.2);
  color: #ffffff;
}
.modal.modal-info .form-group.no-border .form-control:focus, .modal.modal-info .form-group.no-border .form-control:active, .modal.modal-info .form-group.no-border .form-control:active,
.modal.modal-info .input-group.no-border .form-control:focus,
.modal.modal-info .input-group.no-border .form-control:active,
.modal.modal-info .input-group.no-border .form-control:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-info .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-info .form-group.no-border .form-control + .input-group-append .input-group-text,
.modal.modal-info .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.modal.modal-info .input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
}
.modal.modal-info .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus, .modal.modal-info .form-group.no-border .form-control + .input-group-prepend .input-group-text:active, .modal.modal-info .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-info .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-info .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-info .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-info .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.modal.modal-info .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-info .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.modal.modal-info .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.modal.modal-info .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.modal.modal-info .input-group.no-border .form-control + .input-group-append .input-group-text:active {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-info .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .modal.modal-info .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.modal.modal-info .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.modal.modal-info .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal.modal-info .form-group.no-border .input-group-prepend .input-group-text,
.modal.modal-info .form-group.no-border .input-group-append .input-group-text,
.modal.modal-info .input-group.no-border .input-group-prepend .input-group-text,
.modal.modal-info .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.2);
  border: none;
  color: #ffffff;
}
.modal.modal-info .form-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-info .form-group.no-border.input-group-focus .input-group-append .input-group-text,
.modal.modal-info .input-group.no-border.input-group-focus .input-group-prepend .input-group-text,
.modal.modal-info .input-group.no-border.input-group-focus .input-group-append .input-group-text {
  background-color: rgba(30, 30, 47, 0.3);
  color: #ffffff;
}
.modal .modal-header .close {
  color: #fd5d93;
  text-shadow: none;
}
.modal .modal-header .close:hover, .modal .modal-header .close:focus {
  opacity: 1;
}
.modal.modal-black .modal-content {
  background: linear-gradient(to bottom, #222a42 0%, #1d253b 100%);
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-black .modal-content .modal-header .modal-title, .modal.modal-black .modal-content .modal-header .title {
  color: rgba(255, 255, 255, 0.9);
}
.modal.modal-black .modal-content .modal-body p {
  color: rgba(255, 255, 255, 0.8);
}
.modal.modal-black h1, .modal.modal-black h2, .modal.modal-black h3, .modal.modal-black h4, .modal.modal-black h5, .modal.modal-black h6, .modal.modal-black p {
  color: #ffffff;
}

.modal-search .modal-dialog {
  margin: 20px auto;
  max-width: 650px;
}
.modal-search .modal-dialog input {
  border: none;
  font-size: 17px;
  font-weight: 100;
}
.modal-search .modal-dialog span {
  font-size: 35px;
  color: #b7b7b7;
}
.modal-search .modal-content .modal-header {
  padding: 24px;
}
.modal-search .modal-header .close {
  color: #555555;
  top: 30px !important;
}
.modal-search .modal-footer {
  border-top: 2px solid #f9f9f9;
  margin: 0px 25px 20px;
}

.navbar {
  padding: 10px 30px 10px 15px;
  width: 100%;
  z-index: 1050;
  background: #1a1e34;
}
.navbar .photo {
  display: inline-block;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  vertical-align: middle;
  overflow: hidden;
}
.navbar .photo img {
  width: 100%;
}
.navbar .navbar-wrapper {
  display: flex;
  align-items: center;
}
.navbar .navbar-text {
  color: #ffffff;
}
.navbar .btn {
  margin: 0 5px 0 10px;
}
.navbar.navbar-absolute {
  position: absolute;
  z-index: 1050;
}
.navbar.navbar-transparent {
  background: transparent !important;
}
.navbar.bg-white .navbar-nav .search-bar.input-group i {
  color: #222a42;
}
.navbar.bg-white .navbar-nav .search-bar.input-group .form-control {
  background: rgba(34, 42, 66, 0.1);
  border-radius: 4px;
}
.navbar.bg-white .navbar-nav a.nav-link {
  color: #222a42 !important;
}
.navbar.bg-white .navbar-nav a.nav-link p {
  color: #222a42;
}
.navbar.bg-white .navbar-text, .navbar.bg-white .navbar-brand {
  color: #222a42;
}
.navbar.bg-white .form-control {
  color: #222a42 !important;
}
.navbar.bg-white .form-control::placeholder {
  color: #9a9a9a !important;
}
.navbar.bg-dark {
  background: #222a42 !important;
}
.navbar.bg-primary {
  background-color: #e14eca !important;
}
.navbar.bg-warning {
  background-color: #ff8d72 !important;
}
.navbar.bg-info {
  background-color: #1d8cf8 !important;
}
.navbar.bg-success {
  background-color: rgb(0%, 74.9019607843%, 60.354885756%) !important;
}
.navbar.bg-danger {
  background-color: #fd5d93 !important;
}
.navbar .navbar-brand {
  position: fixed;
  padding-top: 0;
  padding-bottom: 0;
  color: #ffffff;
  margin-left: 0px;
  margin-top: 3px;
  text-transform: uppercase;
  font-size: 1rem;
}
.navbar .navbar-toggle button:focus, .navbar .navbar-toggler {
  outline: none;
}

.navbar-minimize-fixed {
  position: fixed;
  margin-left: 40px;
  margin-top: 14px;
  transition: 0.3s ease;
  color: white;
  z-index: 20;
  opacity: 0;
  transition: 0.2s ease;
}
.navbar-minimize-fixed button i {
  font-size: 20px;
}

.notification {
  background: #fd5d93;
  color: #ffffff;
  border-radius: 0.875rem;
  height: 6px;
  width: 6px;
  position: absolute;
  text-align: center;
  font-size: 12px;
  font-weight: 800;
  top: 10px;
  right: 10px;
  border: 1px solid #fd5d93;
}

.navbar-nav li {
  padding: 0 10px;
}
.navbar-nav li a {
  color: #ffffff;
}
.navbar-nav li i {
  vertical-align: middle;
  font-size: 20px;
}

@media screen and (max-width: 991px) {
  .navbar .container-fluid {
    padding-right: 15px;
    padding-left: 15px;
  }
  .navbar .navbar-collapse .input-group {
    margin: 0;
    margin-top: 5px;
  }
  .navbar .navbar-nav .btn {
    margin-left: -3px;
    display: flex;
  }
  .navbar .navbar-nav .btn i {
    margin-right: 12px;
  }
  .navbar .navbar-nav .btn span {
    margin: 0;
    text-transform: uppercase;
    font-weight: 300;
  }
  .navbar .navbar-nav .btn span, .navbar .navbar-nav .btn span:hover, .navbar .navbar-nav .btn span:focus, .navbar .navbar-nav .btn span:active, .navbar .navbar-nav .btn span:active:focus {
    color: #222a42 !important;
  }
  .navbar .navbar-nav a.nav-link i {
    opacity: 1;
    margin-left: 4px;
    margin-right: 5px;
  }
  .navbar .navbar-nav a.nav-link p {
    display: inline-block;
    text-transform: uppercase;
    margin-left: 7px;
  }
  .navbar .navbar-nav .modal-search .modal-dialog {
    padding: 0 40px;
  }
  .navbar .navbar-nav .dropdown {
    margin: 5px 0;
  }
  .navbar .navbar-nav .dropdown .nav-link {
    padding-bottom: 0;
  }
  .navbar .navbar-nav .dropdown .dropdown-menu .dropdown-item {
    margin-top: 0;
    padding-left: 24px;
  }
  .navbar .dropdown.show .dropdown-menu {
    display: block;
  }
  .navbar .dropdown .dropdown-menu {
    display: none;
  }
  .navbar .dropdown .dropdown-menu li a {
    color: #222a42;
  }
  .navbar .dropdown.show .dropdown-menu,
  .navbar .dropdown .dropdown-menu {
    background-color: transparent;
    border: 0;
    transition: none;
    box-shadow: none;
    width: auto;
    margin: 0px 1rem;
    margin-top: 0px;
  }
  .navbar .dropdown.show .dropdown-menu:before,
  .navbar .dropdown .dropdown-menu:before {
    display: none;
  }
  .navbar .dropdown-menu .dropdown-item:focus,
  .navbar .dropdown-menu .dropdown-item:hover {
    color: #ffffff;
  }
  .navbar.bg-white .dropdown-menu .dropdown-item:focus, .navbar.bg-white .dropdown-menu .dropdown-item:hover {
    color: #344675;
  }
  .navbar button.navbar-toggler[data-target="#navigation"] {
    padding-top: 0;
  }
  .navbar .navbar-toggler-bar {
    display: block;
    position: relative;
    width: 22px;
    height: 1px;
    border-radius: 1px;
    background: #ffffff;
  }
  .navbar .navbar-toggler-bar.navbar-kebab {
    height: 4px;
    width: 4px;
    margin-bottom: 3px;
    border-radius: 50%;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 7px;
  }
  .navbar .navbar-toggler-bar + .navbar-toggler-bar.navbar-kebab {
    margin-top: 0px;
  }
  .navbar .navbar-toggler-bar.bar2 {
    width: 17px;
    transition: width 0.2s linear;
  }
  .navbar.bg-white:not(.navbar-transparent) .navbar-toggler-bar {
    background-color: #344675;
  }
  .navbar .toggled .navbar-toggler-bar {
    width: 24px;
  }
  .navbar .toggled .navbar-toggler-bar + .navbar-toggler-bar {
    margin-top: 5px;
  }
  .navbar .navbar-brand {
    margin-left: 20px;
    position: relative;
  }
  .navbar-nav .nav-link i.fa,
  .navbar-nav .nav-link i.tim-icons {
    opacity: 0.5;
  }
  .bar1,
  .bar2,
  .bar3 {
    outline: 1px solid transparent;
  }
  .bar1 {
    top: 0px;
    animation: topbar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .bar2 {
    opacity: 1;
  }
  .bar3 {
    bottom: 0px;
    animation: bottombar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar1 {
    top: 6px;
    animation: topbar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar2 {
    opacity: 0;
  }
  .toggled .bar3 {
    bottom: 6px;
    animation: bottombar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  @keyframes topbar-x {
    0% {
      top: 0px;
      transform: rotate(0deg);
    }
    45% {
      top: 6px;
      transform: rotate(145deg);
    }
    75% {
      transform: rotate(130deg);
    }
    100% {
      transform: rotate(135deg);
    }
  }
  @keyframes topbar-back {
    0% {
      top: 6px;
      transform: rotate(135deg);
    }
    45% {
      transform: rotate(-10deg);
    }
    75% {
      transform: rotate(5deg);
    }
    100% {
      top: 0px;
      transform: rotate(0);
    }
  }
  @keyframes bottombar-x {
    0% {
      bottom: 0px;
      transform: rotate(0deg);
    }
    45% {
      bottom: 6px;
      transform: rotate(-145deg);
    }
    75% {
      transform: rotate(-130deg);
    }
    100% {
      transform: rotate(-135deg);
    }
  }
  @keyframes bottombar-back {
    0% {
      bottom: 6px;
      transform: rotate(-135deg);
    }
    45% {
      transform: rotate(10deg);
    }
    75% {
      transform: rotate(-5deg);
    }
    100% {
      bottom: 0px;
      transform: rotate(0);
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}
@media screen and (min-width: 992px) {
  .navbar-collapse {
    background: none !important;
  }
  .navbar .navbar-toggle {
    display: none;
  }
  .navbar-nav .nav-link.profile-photo {
    padding: 0;
    margin: 7px 0.7rem;
  }
  .navbar .caret {
    position: absolute;
    left: 80%;
    top: 55%;
    margin-left: 0;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
}
@media screen and (max-width: 576px) {
  .navbar[class*=navbar-toggleable-] .container {
    margin-left: 0;
    margin-right: 0;
  }
  .navbar .navbar-wrapper .navbar-toggle {
    transition: all 1s;
  }
  .navbar .navbar-wrapper .navbar-toggle.toggled {
    left: -20px;
    position: relative;
    right: auto;
    right: initial;
    transition: all 1s;
  }
  .rtl .navbar .navbar-wrapper .navbar-toggle.toggled {
    right: -35px;
    position: relative;
    left: auto;
    left: initial;
    transition: all 1s;
  }
}
body {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  line-height: 1.2;
}

p {
  font-weight: 300;
}

button,
input,
optgroup,
select,
textarea {
  font-family: "Poppins", sans-serif;
}

.card h1, .card h2, .card h3, .card h4, .card h5, .card h6, .card p {
  color: rgba(255, 255, 255, 0.8);
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
}

a {
  color: #ba54f5;
  font-weight: 300;
}
a:hover, a:focus {
  color: #e14eca;
}

h1, .h1 {
  line-height: 1.05;
  margin-bottom: 30px;
}
h1 small, .h1 small {
  font-weight: 600;
  text-transform: uppercase;
  opacity: 0.8;
}

h2, .h2 {
  margin-bottom: 30px;
  line-height: 1.2;
}

h3, .h3 {
  margin-bottom: 30px;
  line-height: 1.4em;
}

h4, .h4 {
  line-height: 1.45em;
  margin-bottom: 15px;
}
h4 + .category, h4.title + .category, .h4 + .category, .h4.title + .category {
  margin-top: -10px;
}

h5, .h5 {
  line-height: 1.4em;
  margin-bottom: 15px;
}

h6, .h6 {
  text-transform: uppercase;
  font-weight: 600;
}

p {
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 5px;
}
p.description {
  font-size: 1.14em;
}

.title {
  font-weight: 600;
}
.title.title-up {
  text-transform: uppercase;
}
.title.title-up a {
  color: #222a42;
  text-decoration: none;
}
.title + .category {
  margin-top: -10px;
}

.description,
.card-description,
.footer-big p,
.card .footer .stats {
  color: #9a9a9a;
  font-weight: 300;
}

.category,
.card-category {
  text-transform: capitalize;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.7500000025rem;
}

.card-category {
  font-size: 0.7500000025rem;
}

.blockquote {
  border-left: none;
  border: 1px solid #344675;
  padding: 20px;
  font-size: 0.9625rem;
  line-height: 1.8;
}
.blockquote small {
  color: #344675;
  font-size: 0.7500000025rem;
  text-transform: uppercase;
}
.blockquote.blockquote-primary {
  border-color: #e14eca;
  color: #e14eca;
}
.blockquote.blockquote-primary small {
  color: #e14eca;
}
.blockquote.blockquote-danger {
  border-color: #fd5d93;
  color: #fd5d93;
}
.blockquote.blockquote-danger small {
  color: #fd5d93;
}
.blockquote.blockquote-white {
  border-color: rgba(255, 255, 255, 0.8);
  color: #ffffff;
}
.blockquote.blockquote-white small {
  color: rgba(255, 255, 255, 0.8);
}

ul li, ol li {
  color: #ffffff;
}

pre {
  color: rgba(255, 255, 255, 0.8);
}

hr {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.table > tbody > tr > td {
  color: rgba(255, 255, 255, 0.7) !important;
}
.table > tbody > tr > td .photo {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
}
.table > tbody > tr > td .photo img {
  width: 100%;
}
.table > tbody > tr.table-success > td {
  background-color: rgb(0%, 74.9019607843%, 60.354885756%);
}
.table > tbody > tr.table-info > td {
  background-color: #1d8cf8;
}
.table > tbody > tr.table-primary > td {
  background-color: #e14eca;
}
.table > tbody > tr.table-warning > td {
  background-color: #ff8d72;
}
.table > tbody > tr.table-danger > td {
  background-color: #fd5d93;
}
.table .img-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
}
.table .img-row {
  max-width: 60px;
  width: 60px;
}
.table .form-check {
  margin: 0;
  margin-top: 5px;
}
.table .form-check label .form-check-sign::before, .table .form-check label .form-check-sign::after {
  top: -17px;
  left: 4px;
}
.table .btn {
  margin: 0;
}
.table small, .table .small {
  font-weight: 300;
}
.card-tasks .card-body .table {
  margin-bottom: 0;
}
.card-tasks .card-body .table > thead > tr > th,
.card-tasks .card-body .table > tbody > tr > th,
.card-tasks .card-body .table > tfoot > tr > th,
.card-tasks .card-body .table > thead > tr > td,
.card-tasks .card-body .table > tbody > tr > td,
.card-tasks .card-body .table > tfoot > tr > td {
  padding-top: 5px;
  padding-bottom: 5px;
}
.table > thead > tr > th {
  border-bottom-width: 1px;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 700;
  border: 0;
  color: rgba(255, 255, 255, 0.7);
}
.table .radio,
.table .checkbox {
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  width: 15px;
}
.table .radio .icons,
.table .checkbox .icons {
  position: relative;
}
.table .radio label:after, .table .radio label:before,
.table .checkbox label:after,
.table .checkbox label:before {
  top: -17px;
  left: -3px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-color: rgba(255, 255, 255, 0.1);
  padding: 12px 7px;
  vertical-align: middle;
}
.table.table-shopping tbody tr:last-child td {
  border: none;
}
.table .th-description {
  max-width: 150px;
}
.table .td-price {
  font-size: 26px;
  font-weight: 300;
  margin-top: 5px;
  position: relative;
  top: 4px;
  text-align: right;
}
.table .td-total {
  font-weight: 600;
  font-size: 0.812499975rem;
  padding-top: 20px;
  text-align: right;
}
.table .td-actions .btn {
  margin: 0px;
}
.table > tbody > tr {
  position: relative;
}
.table > tfoot > tr {
  color: hsla(0, 0%, 100%, 0.7);
  text-transform: uppercase;
}

.table-responsive {
  overflow: scroll;
  padding-bottom: 10px;
}

#tables .table-responsive {
  margin-bottom: 30px;
}

.form-check {
  margin-top: 0.5rem;
  padding-left: 0;
}

.form-check .form-check-label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding-left: 25px;
  line-height: 18px;
  margin-bottom: 0;
  transition: color 0.3s linear;
}

.radio .form-check-sign {
  padding-left: 28px;
}

.form-check-radio.form-check-inline .form-check-label {
  padding-left: 5px;
  margin-right: 10px;
}

.form-check .form-check-sign::before,
.form-check .form-check-sign::after {
  content: " ";
  display: inline-block;
  position: absolute;
  width: 17px;
  height: 17px;
  left: 0;
  cursor: pointer;
  border-radius: 3px;
  top: 0;
  border: 1px solid rgb(50.3921568627%, 50.3921568627%, 50.3921568627%);
  transition: opacity 0.3s linear;
}

.form-check input[type=checkbox]:checked + .form-check-sign::before,
.form-check input[type=checkbox]:checked + .form-check-sign::before {
  border: none;
  background-color: #e14eca;
}

.form-check .form-check-sign::after {
  font-family: "nucleo";
  content: "\\ea1b";
  top: 0px;
  text-align: center;
  font-size: 14px;
  opacity: 0;
  color: #ffffff;
  font-weight: 600;
  border: 0;
  background-color: inherit;
}

.form-check.disabled .form-check-label,
.form-check.disabled .form-check-label {
  color: #9a9a9a;
  opacity: 0.5;
  cursor: not-allowed;
}

.form-check input[type=checkbox],
.radio input[type=radio] {
  opacity: 0;
  position: absolute;
  visibility: hidden;
}

.form-check input[type=checkbox]:checked + .form-check-sign::after {
  opacity: 1;
  font-size: 10px;
  margin-top: 0;
}

.form-check input[type=checkbox] + .form-check-sign::after {
  opacity: 0;
  font-size: 10px;
  margin-top: 0;
}

.form-control input[type=checkbox]:disabled + .form-check-sign::before,
.checkbox input[type=checkbox]:disabled + .form-check-sign::after {
  cursor: not-allowed;
}

.form-check input[type=checkbox]:disabled + .form-check-sign,
.form-check input[type=radio]:disabled + .form-check-sign {
  pointer-events: none;
}

.form-check-radio .form-check-label {
  padding-top: 3px;
}

.form-check-radio .form-check-sign::before,
.form-check-radio .form-check-sign::after {
  content: " ";
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid rgb(50.3921568627%, 50.3921568627%, 50.3921568627%);
  display: inline-block;
  position: absolute;
  left: 0px;
  top: 3px;
  padding: 1px;
  transition: opacity 0.3s linear;
}

.form-check-radio input[type=radio] + .form-check-sign:after,
.form-check-radio input[type=radio] {
  opacity: 0;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  width: 6px;
  height: 6px;
  background-color: #e14eca;
  border-color: #e14eca;
  top: 9px;
  left: 6px;
  opacity: 1;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::before {
  border-color: #e14eca;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-check-radio input[type=radio]:disabled + .form-check-sign {
  color: #9a9a9a;
}

.form-check-radio input[type=radio]:disabled + .form-check-sign::before,
.form-check-radio input[type=radio]:disabled + .form-check-sign::after {
  color: #9a9a9a;
}

.fixed-plugin {
  position: fixed;
  right: 0;
  width: 64px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1031;
  border-radius: 8px 0 0 8px;
  text-align: center;
  top: 130px;
}
.fixed-plugin li > a,
.fixed-plugin .badge {
  transition: all 0.34s;
  -webkit-transition: all 0.34s;
  -moz-transition: all 0.34s;
}
.fixed-plugin .fa-cog {
  color: #ffffff;
  padding: 10px;
  border-radius: 0 0 6px 6px;
  width: auto;
}
.fixed-plugin .dropdown-menu {
  right: 80px;
  left: auto !important;
  top: -52px !important;
  width: 290px;
  border-radius: 0.1875rem;
  padding: 0 10px;
  background: linear-gradient(#222a42, #1d253b);
}
.fixed-plugin .dropdown .dropdown-menu .tim-icons {
  top: 5px;
}
.fixed-plugin .dropdown-menu:after,
.fixed-plugin .dropdown-menu:before {
  right: 10px;
  margin-left: auto;
  left: auto;
}
.fixed-plugin .fa-circle-thin {
  color: #ffffff;
}
.fixed-plugin .active .fa-circle-thin {
  color: #00bbff;
}
.fixed-plugin .dropdown-menu > .active > a,
.fixed-plugin .dropdown-menu > .active > a:hover,
.fixed-plugin .dropdown-menu > .active > a:focus {
  color: #777777;
  text-align: center;
}
.fixed-plugin img {
  border-radius: 0;
  width: 100%;
  height: 100px;
  margin: 0 auto;
}
.fixed-plugin .dropdown-menu li > a:hover,
.fixed-plugin .dropdown-menu li > a:focus {
  box-shadow: none;
}
.fixed-plugin .badge {
  border: 2px solid #ffffff;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  height: 23px;
  margin-right: 5px;
  position: relative;
  width: 23px;
}
.fixed-plugin .badge.active,
.fixed-plugin .badge:hover {
  border-color: #1d253b;
}
.fixed-plugin .light-badge, .fixed-plugin .dark-badge {
  margin: 0;
  border: 1px solid #1d8cf8;
}
.fixed-plugin .light-badge:hover, .fixed-plugin .dark-badge:hover {
  border: 1px solid #1d8cf8;
}
.fixed-plugin .light-badge {
  background: #ffffff;
}
.fixed-plugin .light-badge:hover {
  background: #ffffff;
}
.fixed-plugin .dark-badge {
  background: #222a42;
}
.fixed-plugin .dark-badge:hover {
  background: #222a42;
}
.fixed-plugin h5 {
  margin: 10px;
}
.fixed-plugin .dropdown-menu li {
  display: block;
  padding: 18px 2px;
  width: 25%;
  float: left;
}
.fixed-plugin li.adjustments-line,
.fixed-plugin li.header-title,
.fixed-plugin li.button-container {
  width: 100%;
  height: 50px;
  min-height: inherit;
}
.fixed-plugin li.button-container {
  height: auto;
}
.fixed-plugin li.button-container div {
  margin-bottom: 5px;
}
.fixed-plugin #sharrreTitle {
  text-align: center;
  padding: 10px 0;
  height: 50px;
}
.fixed-plugin li.header-title {
  color: #ffffff;
  height: 30px;
  line-height: 25px;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
}
.fixed-plugin .adjustments-line a {
  color: transparent;
}
.fixed-plugin .adjustments-line a .badge-colors {
  position: relative;
  top: -2px;
}
.fixed-plugin .adjustments-line a a:hover,
.fixed-plugin .adjustments-line a a:focus {
  color: transparent;
}
.fixed-plugin .adjustments-line .togglebutton {
  text-align: center;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch {
  position: relative;
  left: -10px;
  font-size: 0.62475rem;
  color: #ffffff;
}
.fixed-plugin .adjustments-line .togglebutton .label-switch.label-right {
  left: 10px;
}
.fixed-plugin .adjustments-line .togglebutton .toggle {
  margin-right: 0;
}
.fixed-plugin .adjustments-line .color-label {
  position: relative;
  top: -7px;
  font-size: 0.62475rem;
  color: #ffffff;
}
.fixed-plugin .adjustments-line .dropdown-menu > li.adjustments-line > a {
  padding-right: 0;
  padding-left: 0;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
  margin: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder {
  font-size: 1rem;
  text-align: center;
  border-radius: 10px;
  background-color: #ffffff;
  border: 3px solid #ffffff;
  padding-left: 0;
  padding-right: 0;
  opacity: 1;
  cursor: pointer;
  display: block;
  max-height: 100px;
  overflow: hidden;
  padding: 0;
}
.fixed-plugin .dropdown-menu > li > a.img-holder img {
  margin-top: auto;
}
.fixed-plugin .dropdown-menu > li a.switch-trigger:hover, .fixed-plugin .dropdown-menu > li > a.switch-trigger:focus {
  background-color: transparent;
}
.fixed-plugin .dropdown-menu > li:hover > a.img-holder, .fixed-plugin .dropdown-menu > li:focus > a.img-holder {
  border-color: rgba(0, 187, 255, 0.53);
}
.fixed-plugin .dropdown-menu > .active > a.img-holder,
.fixed-plugin .dropdown-menu > .active > a.img-holder {
  border-color: #00bbff;
  background-color: #ffffff;
}
.fixed-plugin .btn-social {
  width: 50%;
  display: block;
  width: 48%;
  float: left;
  font-weight: 600;
}
.fixed-plugin .btn-social i {
  margin-right: 5px;
}
.fixed-plugin .btn-social:first-child {
  margin-right: 2%;
}
.fixed-plugin .dropdown .dropdown-menu {
  transform: translateY(-15%);
  top: 27px;
  opacity: 0;
  transform-origin: 0 0;
}
.fixed-plugin .dropdown .dropdown-menu:before {
  border-bottom: 0.4em solid rgba(0, 0, 0, 0);
  border-left: 0.4em solid rgba(0, 0, 0, 0.2);
  border-top: 0.4em solid rgba(0, 0, 0, 0);
  right: -16px;
  top: 46px;
}
.fixed-plugin .dropdown .dropdown-menu:after {
  border-bottom: 0.4em solid rgba(0, 0, 0, 0);
  border-left: 0.4em solid #222a42;
  border-top: 0.4em solid rgba(0, 0, 0, 0);
  right: -16px;
}
.fixed-plugin .dropdown .dropdown-menu:before, .fixed-plugin .dropdown .dropdown-menu:after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 74px;
  width: 16px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
}
.fixed-plugin .dropdown.show .dropdown-menu {
  opacity: 1;
  transform: translateY(-13%);
  transform-origin: 0 0;
}
.fixed-plugin .bootstrap-switch {
  margin: 0;
}

.wrapper {
  top: 0;
  min-height: 100vh;
}
.wrapper.wrapper-full-page {
  min-height: 100vh;
  height: auto;
}

.sidebar-wrapper ul li div.collapse ul li div.collapse ul li a,
.sidebar-wrapper ul li div.collapse ul li div.collapsing ul li a,
.sidebar-wrapper ul li div.collapsing ul li div.collapse ul li a {
  margin-left: 25px;
}

.sidebar,
.off-canvas-sidebar {
  background: #ba54f5;
  background: linear-gradient(0deg, #ba54f5 0%, #e14eca 100%);
  height: calc(100vh - 90px);
  width: 230px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  background-size: cover;
  background-position: center center;
  display: block;
  box-shadow: 0px 0px 45px 0px rgba(0, 0, 0, 0.6);
  margin-top: 70px;
  border-radius: 5px;
}
.sidebar .sidebar-wrapper,
.off-canvas-sidebar .sidebar-wrapper {
  width: 100%;
  min-height: 100%;
  max-height: calc(100vh - 705px);
  z-index: 4;
  position: relative;
  overflow: auto;
}
.sidebar .sidebar-wrapper .dropdown .dropdown-backdrop,
.off-canvas-sidebar .sidebar-wrapper .dropdown .dropdown-backdrop {
  display: none !important;
}
.sidebar .sidebar-wrapper .navbar-form,
.off-canvas-sidebar .sidebar-wrapper .navbar-form {
  border: none;
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a span,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a span,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a span,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a span {
  display: inline-block;
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal {
  margin: 0;
  position: relative;
  transform: translateX(0px);
  opacity: 1;
  white-space: nowrap;
  display: block;
  line-height: 23px;
  z-index: 1;
  color: rgba(255, 255, 255, 0.8);
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
  text-transform: uppercase;
  width: 34px;
  margin-right: 10px;
  margin-left: 0px;
  font-size: 12px;
  text-align: center;
  line-height: 25px;
  position: relative;
  float: left;
  z-index: 1;
  display: inherit;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);
}
.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a i,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a i,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a i,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a i {
  font-size: 17px;
  line-height: 20px;
  width: 26px;
}
.sidebar .sidebar-wrapper [data-toggle=collapse] ~ div > ul > li:hover > a .sidebar-mini-icon,
.sidebar .sidebar-wrapper [data-toggle=collapse] ~ div > ul > li:hover > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper [data-toggle=collapse] ~ div > ul > li:hover > a .sidebar-mini-icon,
.off-canvas-sidebar .sidebar-wrapper [data-toggle=collapse] ~ div > ul > li:hover > a .sidebar-normal {
  color: #ffffff;
}
.sidebar .sidebar-wrapper .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.off-canvas-sidebar .sidebar-wrapper .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
  opacity: 0;
}
.sidebar .navbar-minimize,
.off-canvas-sidebar .navbar-minimize {
  position: absolute;
  right: 20px;
  top: 2px;
  opacity: 1;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar .nav,
.off-canvas-sidebar .nav {
  margin-top: 20px;
  display: block;
}
.sidebar .nav .caret,
.off-canvas-sidebar .nav .caret {
  top: 14px;
  position: absolute;
  right: 10px;
}
.sidebar .nav li > a + div .nav,
.off-canvas-sidebar .nav li > a + div .nav {
  margin-top: 5px;
}
.sidebar .nav li > a + div .nav li > a,
.off-canvas-sidebar .nav li > a + div .nav li > a {
  margin-top: 0px;
  padding: 8px 8px;
}
.sidebar .nav li > a,
.off-canvas-sidebar .nav li > a {
  margin: 10px 15px 0;
  border-radius: 30px;
  color: #ffffff;
  display: block;
  text-decoration: none;
  position: relative;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 0.62475rem;
  padding: 10px 8px;
  line-height: 1.625rem;
}
.sidebar .nav li:first-child > a,
.off-canvas-sidebar .nav li:first-child > a {
  margin: 0 15px;
}
.sidebar .nav li:hover:not(.active) > a p,
.sidebar .nav li:hover:not(.active) > a i, .sidebar .nav li:focus:not(.active) > a p,
.sidebar .nav li:focus:not(.active) > a i,
.off-canvas-sidebar .nav li:hover:not(.active) > a p,
.off-canvas-sidebar .nav li:hover:not(.active) > a i,
.off-canvas-sidebar .nav li:focus:not(.active) > a p,
.off-canvas-sidebar .nav li:focus:not(.active) > a i {
  color: #ffffff;
}
.sidebar .nav li:hover:not(.active) > a i, .sidebar .nav li:focus:not(.active) > a i,
.off-canvas-sidebar .nav li:hover:not(.active) > a i,
.off-canvas-sidebar .nav li:focus:not(.active) > a i {
  color: #ffffff;
}
.sidebar .nav li.active > a:not([data-toggle=collapse]),
.off-canvas-sidebar .nav li.active > a:not([data-toggle=collapse]) {
  background: transparent;
}
.sidebar .nav li.active > a:not([data-toggle=collapse]) i,
.sidebar .nav li.active > a:not([data-toggle=collapse]) p,
.off-canvas-sidebar .nav li.active > a:not([data-toggle=collapse]) i,
.off-canvas-sidebar .nav li.active > a:not([data-toggle=collapse]) p {
  color: white;
}
.sidebar .nav li.active > a:not([data-toggle=collapse]):before,
.off-canvas-sidebar .nav li.active > a:not([data-toggle=collapse]):before {
  content: " ";
  position: absolute;
  height: 6px;
  width: 6px;
  top: 22px;
  left: -4px;
  background: #ffffff;
  border-radius: 50%;
}
.sidebar .nav li.active > a[data-toggle=collapse],
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] {
  background: transparent;
  box-shadow: none;
  color: #ffffff;
}
.sidebar .nav li.active > a[data-toggle=collapse] i,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] i {
  color: #ffffff;
}
.sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a {
  box-shadow: none;
}
.sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a .sidebar-mini-icon,
.sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a .sidebar-normal,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a .sidebar-mini-icon,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a .sidebar-normal {
  color: #ffffff;
  font-weight: 400;
}
.sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a:before,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse] + div .nav .active a:before {
  content: " ";
  position: absolute;
  height: 6px;
  width: 6px;
  top: 17px;
  left: -4px;
  background: #ffffff;
  border-radius: 50%;
}
.sidebar .nav li.active > a[data-toggle=collapse]:before,
.off-canvas-sidebar .nav li.active > a[data-toggle=collapse]:before {
  content: " ";
  position: absolute;
  height: 6px;
  width: 6px;
  top: 22px;
  left: -4px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 50%;
}
.sidebar .nav p,
.off-canvas-sidebar .nav p {
  margin: 0;
  line-height: 30px;
  position: relative;
  display: block;
  height: auto;
  white-space: nowrap;
}
.sidebar .nav i,
.off-canvas-sidebar .nav i {
  font-size: 20px;
  float: left;
  margin-right: 12px;
  line-height: 30px;
  width: 34px;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  position: relative;
}
.sidebar .logo,
.off-canvas-sidebar .logo {
  position: relative;
  padding: 0.5rem 0.7rem;
  z-index: 4;
}
.sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-mini {
  opacity: 1;
  float: left;
  width: 34px;
  text-align: center;
  margin-left: 12px;
  margin-right: 12px;
}
.sidebar .logo a.logo-mini img,
.off-canvas-sidebar .logo a.logo-mini img {
  border-radius: 50%;
  width: 30px;
}
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-normal {
  display: block;
  opacity: 1;
  transform: translate3d(0px, 0, 0);
}
.sidebar .logo:after,
.off-canvas-sidebar .logo:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background: rgba(255, 255, 255, 0.5);
}
.sidebar .logo p,
.off-canvas-sidebar .logo p {
  float: left;
  font-size: 20px;
  margin: 10px 10px;
  color: #ffffff;
  line-height: 20px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.sidebar .logo .simple-text,
.off-canvas-sidebar .logo .simple-text {
  text-transform: uppercase;
  padding: 0.5rem 0;
  display: block;
  white-space: nowrap;
  color: #ffffff;
  text-decoration: none;
  font-weight: 400;
  line-height: 30px;
  overflow: hidden;
}
.sidebar .logo-tim,
.off-canvas-sidebar .logo-tim {
  border-radius: 50%;
  border: 1px solid #333;
  display: block;
  height: 61px;
  width: 61px;
  float: left;
  overflow: hidden;
}
.sidebar .logo-tim img,
.off-canvas-sidebar .logo-tim img {
  width: 60px;
  height: 60px;
}
.sidebar[data=blue],
.off-canvas-sidebar[data=blue] {
  background: #3358f4;
  background: linear-gradient(0deg, #3358f4 0%, #1d8cf8 100%);
}
.sidebar[data=green],
.off-canvas-sidebar[data=green] {
  background: #0098f0;
  background: linear-gradient(0deg, #0098f0 0%, #00f2c3 100%);
}
.sidebar .user,
.off-canvas-sidebar .user {
  padding-bottom: 20px;
  margin: 20px auto 0;
  position: relative;
}
.sidebar .user:after,
.off-canvas-sidebar .user:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 15px;
  height: 1px;
  width: calc(100% - 30px);
  background: rgba(255, 255, 255, 0.5);
}
.sidebar .user .photo,
.off-canvas-sidebar .user .photo {
  width: 34px;
  height: 34px;
  overflow: hidden;
  float: left;
  z-index: 5;
  margin-right: 10px;
  border-radius: 50%;
  margin-left: 23px;
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);
}
.sidebar .user .photo img,
.off-canvas-sidebar .user .photo img {
  width: 100%;
}
.sidebar .user a,
.off-canvas-sidebar .user a {
  color: #ffffff;
  text-decoration: none;
  padding: 0.5rem 15px;
  white-space: nowrap;
}
.sidebar .user .info > a,
.off-canvas-sidebar .user .info > a {
  display: block;
  line-height: 18px;
}
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span {
  display: block;
  position: relative;
  opacity: 1;
}
.sidebar .user .info .caret,
.off-canvas-sidebar .user .info .caret {
  position: absolute;
  top: 8px;
  right: 18px;
}
.sidebar,
.off-canvas-sidebar {
  transition: 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
}

.visible-on-sidebar-regular {
  display: inline-block !important;
}

.visible-on-sidebar-mini {
  display: none !important;
}

.off-canvas-sidebar .nav > li > a,
.off-canvas-sidebar .nav > li > a:hover {
  color: #ffffff;
}
.off-canvas-sidebar .nav > li > a:focus {
  background: rgba(200, 200, 200, 0.2);
}

.main-panel {
  position: relative;
  float: right;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(#1e1e2f, #1e1e24);
  transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
}
.main-panel > .navbar {
  margin-bottom: 0;
}
.main-panel .header {
  margin-bottom: 50px;
}

.perfect-scrollbar-on .main-panel {
  height: 100%;
  max-height: 100%;
}

.sidebar,
.main-panel,
.sidebar-wrapper {
  -webkit-overflow-scrolling: touch;
}

@media (min-width: 991px) {
  .sidebar,
  .main-panel,
  .sidebar-wrapper {
    transition-property: top, bottom, width;
    transition-duration: 0.2s, 0.2s, 0.35s;
    transition-timing-function: linear, linear, ease;
  }
  .sidebar-mini .visible-on-sidebar-regular {
    display: none !important;
  }
  .sidebar-mini .visible-on-sidebar-mini {
    display: inline-block !important;
  }
  .sidebar-mini .sidebar {
    width: 80px;
  }
  .sidebar-mini .sidebar .sidebar-wrapper {
    width: 100% !important;
  }
  .sidebar-mini .sidebar {
    display: block;
    z-index: 1030;
    box-shadow: 0px 2px 22px 0 rgba(0, 0, 0, 0.2), 0px 2px 30px 0 rgba(0, 0, 0, 0.35);
  }
  .sidebar-mini .sidebar .logo a.logo-normal {
    opacity: 0;
    transform: translate3d(-25px, 0, 0);
  }
  .sidebar-mini .sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,
  .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {
    transform: translate3d(-25px, 0, 0);
    opacity: 0;
  }
  .sidebar-mini .sidebar .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .logo a.logo-normal {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  .sidebar-mini .sidebar:hover .navbar-minimize {
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a p,
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar:hover .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar:hover .sidebar-wrapper .user .info > a > span {
    transform: translate3d(0px, 0, 0);
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
    opacity: 0;
  }
  .sidebar-mini .main-panel > .content {
    padding-left: 130px;
    padding-right: 50px;
  }
  .sidebar-mini footer {
    padding-left: 0px;
  }
  .navbar-minimize button {
    margin-left: 10px;
  }
  .navbar-minimize button i {
    color: #ffffff;
    font-size: 20px;
  }
}
.panel-header {
  height: 260px;
  padding-top: 80px;
  padding-bottom: 45px;
  position: relative;
  overflow: hidden;
}
.panel-header .header .title {
  color: #ffffff;
}
.panel-header .header .category {
  max-width: 600px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 auto;
  font-size: 13px;
}
.panel-header .header .category a {
  color: #ffffff;
}

.panel-header-sm {
  height: 135px;
}

.panel-header-lg {
  height: 380px;
}

@media screen and (max-width: 991px) {
  .sidebar {
    position: fixed;
    display: block;
    top: 0;
    height: 100%;
    width: 260px;
    right: auto;
    left: 0;
    margin: 0;
    border-radius: 0;
    z-index: 1032;
    visibility: visible;
    overflow-y: visible;
    padding: 0;
    transition: 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
    transform: translate3d(-260px, 0, 0);
  }
}
@media screen and (max-width: 991px) and (prefers-reduced-motion: reduce) {
  .sidebar {
    transition: none;
  }
}
@media screen and (max-width: 991px) {
  .wrapper {
    transition: 0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
}
@media screen and (max-width: 991px) and (prefers-reduced-motion: reduce) {
  .wrapper {
    transition: none;
  }
}
@media screen and (max-width: 991px) {
  .main-panel {
    width: 100%;
  }
  .main-panel .content {
    padding-left: 30px;
  }
  .nav-open .main-panel {
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
  .nav-open .sidebar {
    transition: 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
    transform: translate3d(0px, 0, 0);
  }
}
@media screen and (max-width: 991px) and (prefers-reduced-motion: reduce) {
  .nav-open .sidebar {
    transition: none;
  }
}
@media screen and (max-width: 991px) {
  .nav-open .sidebar:before {
    content: normal;
    content: initial;
  }
  .nav-open body {
    position: relative;
    overflow-x: hidden;
  }
  .nav-open .menu-on-right .main-panel {
    transform: translate3d(-260px, 0, 0);
  }
  .nav-open .menu-on-right .navbar-collapse,
  .nav-open .menu-on-right .sidebar {
    transform: translate3d(0px, 0, 0);
  }
  .nav-open .menu-on-right #bodyClick {
    right: 260px;
    left: auto;
  }
  .nav-open .fixed-plugin {
    display: none;
  }
  .menu-on-right .sidebar {
    left: auto;
    right: 0;
    transform: translate3d(260px, 0, 0);
  }
  #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 1;
    top: 0;
    right: 0;
    left: 260px;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
    background-color: transparent;
    transition: 0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
}
@media screen and (max-width: 991px) and (prefers-reduced-motion: reduce) {
  #bodyClick {
    transition: none;
  }
}
@media screen and (max-width: 991px) {
  .navbar .dropdown-menu {
    position: static !important;
  }
}
@media screen and (max-width: 768px) {
  .main-panel .content {
    padding-left: 15px;
    padding-right: 15px;
  }
}
/* Animations */
.nav-pills .nav-link,
.navbar,
.nav-tabs .nav-link,
.sidebar .nav a,
.sidebar .nav a i,
.sidebar .nav p,
.navbar-collapse .navbar-nav .nav-link,
.animation-transition-general,
.off-canvas-sidebar .nav p,
.sidebar .logo a.logo-mini,
.sidebar .logo a.logo-normal,
.off-canvas-sidebar .logo a.logo-mini,
.off-canvas-sidebar .logo a.logo-normal,
.sidebar .user .photo,
.off-canvas-sidebar .user .photo,
.sidebar .user a,
.off-canvas-sidebar .user a,
.sidebar .user .info > a > span,
.off-canvas-sidebar .user .info > a > span,
.tag,
.tag [data-role=remove],
.off-canvas-sidebar .nav p,
.off-canvas-sidebar .logo a.logo-normal,
.sidebar .user a,
.off-canvas-sidebar .user a,
.off-canvas-sidebar .user .info > a > span {
  transition: all 300ms ease 0s;
}

.bootstrap-switch-label:before,
.caret {
  transition: all 150ms ease 0s;
}

.dropdown-toggle[aria-expanded=true]:after,
a[data-toggle=collapse][aria-expanded=true] .caret,
.card-collapse .card a[data-toggle=collapse][aria-expanded=true] i,
.card-collapse .card a[data-toggle=collapse].expanded i {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.caret {
  width: 0;
  height: 0;
  vertical-align: middle;
  border-top: 4px dashed;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  margin-top: -5px;
  position: absolute;
  top: 30px;
  margin-left: 5px;
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.card form label + .form-control {
  margin-bottom: 20px;
}

.card .map-title {
  color: #ffffff;
}
.card.card-chart .gmnoprint,
.card.card-chart .gm-style-cc {
  display: none !important;
}

.bd-docs h1, .bd-docs h2, .bd-docs h3, .bd-docs h4, .bd-docs h5, .bd-docs h6, .bd-docs p, .bd-docs ul li, .bd-docs ol li {
  color: #2c2c2c;
}
.bd-docs .bd-content > table > thead > tr > th {
  color: #222a42;
}
.bd-docs .blockquote, .bd-docs .blockquote p, .bd-docs .card p {
  color: rgba(255, 255, 255, 0.8);
}
.bd-docs .bd-example {
  background: linear-gradient(#1e1e2f, #1e1e24);
}
.bd-docs .navbar {
  border-top: none;
}
.bd-docs .navbar .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.8) !important;
}
.bd-docs .bd-example .btn {
  margin: 4px 0;
}
.bd-docs .bd-example .btn .badge {
  display: inline-block;
}
.bd-docs .bd-example .tim-icons {
  color: #ffffff;
}
.bd-docs .bd-example .popover .popover-header {
  color: hsla(0, 0%, 71%, 0.6);
}
.bd-docs .bd-example .popover-body p {
  color: #212529;
}
.bd-docs .bd-example.tooltip-demo p {
  color: rgba(255, 255, 255, 0.8);
}
.bd-docs .card.card-body,
.bd-docs .card .card-body {
  color: hsla(0, 0%, 100%, 0.8);
}
.bd-docs label,
.bd-docs .form-check {
  color: hsla(0, 0%, 100%, 0.8);
}
.bd-docs .form-check + .btn {
  margin-top: 20px;
}
.bd-docs .bd-example thead th,
.bd-docs table thead th {
  color: hsla(0, 0%, 100%, 0.8);
}
.bd-docs .bd-example h1, .bd-docs .bd-example h2, .bd-docs .bd-example h3, .bd-docs .bd-example h4, .bd-docs .bd-example h5, .bd-docs .bd-example h6,
.bd-docs .bd-example .h1, .bd-docs .bd-example .h2, .bd-docs .bd-example .h3, .bd-docs .bd-example .h4, .bd-docs .bd-example .h5, .bd-docs .bd-example .h6,
.bd-docs table h1,
.bd-docs table h2,
.bd-docs table h3,
.bd-docs table h4,
.bd-docs table h5,
.bd-docs table h6,
.bd-docs table .h1,
.bd-docs table .h2,
.bd-docs table .h3,
.bd-docs table .h4,
.bd-docs table .h5,
.bd-docs table .h6 {
  color: hsla(0, 0%, 100%, 0.8);
}
.bd-docs .bd-example .datepicker thead th, .bd-docs .bd-example .datepicker table thead th, .bd-docs .bd-example .datepicker .tim-icons,
.bd-docs table .datepicker thead th,
.bd-docs table .datepicker table thead th,
.bd-docs table .datepicker .tim-icons {
  color: #e14eca;
}
.bd-docs .bd-example .picker-switch .tim-icons,
.bd-docs table .picker-switch .tim-icons {
  color: #e14eca;
}
.bd-docs .footer .container-fluid > nav {
  display: inline-block;
}

.modal.show .modal-dialog {
  transform: translate(0, 30%);
}

code {
  color: #f3a4b5;
}

@media screen and (max-width: 991px) {
  .profile-photo .profile-photo-small {
    margin-left: -2px;
  }
  .button-dropdown {
    display: none;
  }
  #searchModal .modal-dialog {
    margin: 20px;
  }
  #minimizeSidebar {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .landing-page .section-story-overview .image-container:nth-child(2) {
    margin-left: 0;
    margin-bottom: 30px;
  }
}
@media screen and (max-width: 576px) {
  .page-header .container h6.category-absolute {
    width: 90%;
  }
  .form-horizontal .col-form-label, .form-horizontal .label-on-right {
    text-align: inherit;
    padding-top: 0;
  }
  .form-horizontal .col-form-label code, .form-horizontal .label-on-right code {
    padding: 0 10px;
  }
}
.rtl .sidebar,
.rtl .bootstrap-navbar {
  right: 0;
  left: auto;
  margin-right: 20px;
  margin-left: 0;
}
.rtl .sidebar .nav i,
.rtl .bootstrap-navbar .nav i {
  float: right;
  margin-left: 15px;
  margin-right: 0;
}
.rtl .sidebar .nav p,
.rtl .bootstrap-navbar .nav p {
  margin-right: 45px;
  text-align: right;
}
.rtl .sidebar .nav .caret,
.rtl .bootstrap-navbar .nav .caret {
  left: 11px;
  right: auto;
}
.rtl .sidebar .logo a.logo-mini,
.rtl .bootstrap-navbar .logo a.logo-mini {
  float: right;
  margin-right: 20px;
  margin-left: 10px;
}
.rtl .sidebar .logo .simple-text,
.rtl .bootstrap-navbar .logo .simple-text {
  text-align: right;
}
.rtl .sidebar .sidebar-wrapper .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.rtl .sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.rtl .bootstrap-navbar .sidebar-wrapper .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon,
.rtl .bootstrap-navbar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini-icon {
  float: right;
  margin-left: 15px;
  margin-right: 0;
}
.rtl .sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.rtl .sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.rtl .bootstrap-navbar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.rtl .bootstrap-navbar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal {
  text-align: right;
}
.rtl .sidebar:before,
.rtl .bootstrap-navbar:before {
  right: 30px;
  left: auto;
}
.rtl .main-panel .content {
  padding: 80px 280px 30px 30px;
}
.rtl .footer {
  padding: 24px 300px 24px 0;
}
.rtl .dropdown-toggle:after {
  margin-right: 0.255em;
  margin-left: 0;
}
.rtl .dropdown-menu.dropdown-menu-right.dropdown-navbar {
  right: -220px !important;
  left: auto;
}
.rtl .dropdown-menu.dropdown-menu-right.dropdown-navbar:before {
  right: auto;
  left: 35px;
}
.rtl .notification {
  left: 40px;
  right: auto;
}
.rtl .dropdown-menu {
  right: auto;
  left: 0;
}
.rtl .minimize-sidebar {
  float: right;
}
.rtl .alert {
  left: 0;
  margin-left: 0;
  margin-right: 0;
}
.rtl .alert button.close {
  left: 10px !important;
  right: auto !important;
}
.rtl .alert span[data-notify=icon] {
  right: 15px;
  left: auto;
}
.rtl .alert.alert-with-icon {
  padding-right: 65px;
  padding-left: 15px;
}
.rtl .alert.alert-with-icon i[data-notify=icon] {
  right: 15px;
  left: auto;
}
.rtl .search-bar {
  margin-left: 0;
}
.rtl .modal-search .modal-header .close {
  margin-right: auto;
  left: 10px;
}
@media (min-width: 991px) {
  .rtl.sidebar-mini .main-panel .content {
    padding-right: 130px;
    padding-left: 50px;
  }
  .rtl.sidebar-mini footer {
    padding-right: 130px;
    padding-left: 50px;
  }
  .rtl .navbar-minimize button {
    margin-right: -5px;
  }
}
@media screen and (max-width: 991px) {
  .rtl .sidebar {
    margin-right: 0;
  }
  .rtl .main-panel .content {
    padding-right: 50px;
  }
  .rtl #bodyClick {
    right: 260px;
    left: auto;
  }
  .rtl .footer {
    padding-right: 15px;
  }
}
.rtl .navbar .navbar-nav {
  padding-right: 0;
}
.rtl .navbar .navbar-nav a.nav-link {
  text-align: right;
}
.rtl .navbar .navbar-nav a.nav-link p {
  margin-right: 7px;
}
.rtl .navbar .navbar-nav .btn {
  margin-right: 0;
  padding: 0;
}
.rtl .navbar .navbar-nav .btn i {
  margin-left: 4px;
  margin-right: 5px;
}
.rtl .navbar .navbar-nav .search-bar span {
  margin-right: 10px;
}
.rtl .ps__rail-y {
  right: auto !important;
  left: 0;
}
.rtl .main-panel {
  position: fixed;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
.rtl .fixed-plugin {
  border-radius: 0 8px 8px 0;
  left: 0;
  right: auto;
  right: initial;
}
.rtl .fixed-plugin .dropdown-menu {
  left: 80px !important;
  right: auto !important;
}
.rtl .fixed-plugin .dropdown-menu:before, .rtl .fixed-plugin .dropdown-menu:after {
  left: 10px;
  margin-right: auto;
  right: auto;
}
.rtl .fixed-plugin .dropdown-menu:before {
  right: auto;
  right: initial;
  left: -16px;
  border-left: 0;
  border-left: initial;
  border-right: 0.4em solid rgba(0, 0, 0, 0.2);
}
.rtl .fixed-plugin .dropdown-menu:after {
  right: auto;
  right: initial;
  left: -16px;
  border-left: 0;
  border-left: initial;
  border-right: 0.4em solid #222a42;
}
.rtl .sidebar .nav li.active > a:not([data-toggle=collapse]):before, .rtl .off-canvas-sidebar .nav li.active > a:not([data-toggle=collapse]):before {
  left: auto;
  left: initial;
  right: -4px;
}

@media screen and (max-width: 768px) {
  .rtl .main-panel .content {
    padding-left: 15px;
    padding-right: 15px;
  }
}
.form-group.has-danger .error,
.input-group.has-danger .error {
  color: #ec250d;
}

.form-group.has-success .error,
.input-group.has-success .error {
  color: #00f2c3;
}

.form-group.no-border.form-control-lg .input-group-append .input-group-text,
.input-group.no-border.form-control-lg .input-group-append .input-group-text {
  padding: 15px 0 15px 19px;
}
.form-group.no-border.form-control-lg .form-control,
.input-group.no-border.form-control-lg .form-control {
  padding: 15px 19px;
}
.form-group.no-border.form-control-lg .form-control + .input-group-prepend .input-group-text, .form-group.no-border.form-control-lg .form-control + .input-group-append .input-group-text,
.input-group.no-border.form-control-lg .form-control + .input-group-prepend .input-group-text,
.input-group.no-border.form-control-lg .form-control + .input-group-append .input-group-text {
  padding: 15px 19px 15px 0;
}

.form-group.form-control-lg .form-control,
.input-group.form-control-lg .form-control {
  padding: 14px 18px;
  height: 100%;
}
.form-group.form-control-lg .form-control + .input-group-prepend .input-group-text, .form-group.form-control-lg .form-control + .input-group-append .input-group-text,
.input-group.form-control-lg .form-control + .input-group-prepend .input-group-text,
.input-group.form-control-lg .form-control + .input-group-append .input-group-text {
  padding: 14px 18px 14px 0;
}
.form-group.form-control-lg .input-group-prepend .input-group-text,
.form-group.form-control-lg .input-group-append .input-group-text,
.input-group.form-control-lg .input-group-prepend .input-group-text,
.input-group.form-control-lg .input-group-append .input-group-text {
  padding: 14px 0 15px 18px;
}
.form-group.form-control-lg .input-group-prepend .input-group-text + .form-control,
.form-group.form-control-lg .input-group-append .input-group-text + .form-control,
.input-group.form-control-lg .input-group-prepend .input-group-text + .form-control,
.input-group.form-control-lg .input-group-append .input-group-text + .form-control {
  padding: 15px 18px 15px 16px;
}

.form-group.no-border .form-control,
.input-group.no-border .form-control {
  padding: 11px 19px;
}
.form-group.no-border .form-control + .input-group-prepend .input-group-text, .form-group.no-border .form-control + .input-group-append .input-group-text,
.input-group.no-border .form-control + .input-group-prepend .input-group-text,
.input-group.no-border .form-control + .input-group-append .input-group-text {
  padding: 11px 19px 11px 0;
}
.form-group.no-border .input-group-prepend .input-group-text,
.form-group.no-border .input-group-append .input-group-text,
.input-group.no-border .input-group-prepend .input-group-text,
.input-group.no-border .input-group-append .input-group-text {
  padding: 11px 0 11px 19px;
}

.form-group .form-control,
.input-group .form-control {
  padding: 10px 18px 10px 18px;
}
.form-group .form-control + .input-group-prepend .input-group-text, .form-group .form-control + .input-group-append .input-group-text,
.input-group .form-control + .input-group-prepend .input-group-text,
.input-group .form-control + .input-group-append .input-group-text {
  padding: 10px 18px 10px 0;
}
.form-group .input-group-prepend .input-group-text,
.form-group .input-group-append .input-group-text,
.input-group .input-group-prepend .input-group-text,
.input-group .input-group-append .input-group-text {
  padding: 10px 0 10px 18px;
}
.form-group .input-group-prepend .input-group-text + .form-control, .form-group .input-group-prepend .input-group-text ~ .form-control,
.form-group .input-group-append .input-group-text + .form-control,
.form-group .input-group-append .input-group-text ~ .form-control,
.input-group .input-group-prepend .input-group-text + .form-control,
.input-group .input-group-prepend .input-group-text ~ .form-control,
.input-group .input-group-append .input-group-text + .form-control,
.input-group .input-group-append .input-group-text ~ .form-control {
  padding: 10px 19px 11px 16px;
}

.form-group.no-border .form-control,
.form-group.no-border .form-control + .input-group-prepend .input-group-text,
.form-group.no-border .form-control + .input-group-append .input-group-text,
.input-group.no-border .form-control,
.input-group.no-border .form-control + .input-group-prepend .input-group-text,
.input-group.no-border .form-control + .input-group-append .input-group-text {
  background-color: rgb(14.0133333333%, 17.3105882353%, 27.2023529412%);
  border: medium none;
}
.form-group.no-border .form-control:focus, .form-group.no-border .form-control:active, .form-group.no-border .form-control:active,
.form-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.form-group.no-border .form-control + .input-group-append .input-group-text:active,
.form-group.no-border .form-control + .input-group-append .input-group-text:active,
.input-group.no-border .form-control:focus,
.input-group.no-border .form-control:active,
.input-group.no-border .form-control:active,
.input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.input-group.no-border .form-control + .input-group-append .input-group-text:active,
.input-group.no-border .form-control + .input-group-append .input-group-text:active {
  border: medium none;
  background-color: rgb(14.6933333333%, 18.1505882353%, 28.5223529412%);
}
.form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: rgb(14.6933333333%, 18.1505882353%, 28.5223529412%);
}
.form-group.no-border .input-group-prepend .input-group-text,
.form-group.no-border .input-group-append .input-group-text,
.input-group.no-border .input-group-prepend .input-group-text,
.input-group.no-border .input-group-append .input-group-text {
  background-color: rgb(14.0133333333%, 17.3105882353%, 27.2023529412%);
  border: none;
}

.has-error .form-control-feedback, .has-error .control-label {
  color: #ec250d;
}

.has-success .form-control-feedback, .has-success .control-label {
  color: #00f2c3;
}

.input-group-append .input-group-text,
.input-group-prepend .input-group-text {
  background-color: transparent;
  border: 1px solid rgb(16.7333333333%, 20.6705882353%, 32.4823529412%);
  border-radius: 0.4285rem;
  color: #ffffff;
}
.input-group-append .input-group-text i,
.input-group-prepend .input-group-text i {
  opacity: 0.5;
}
.input-group-append .input-group-text,
.input-group-prepend .input-group-text {
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
}
.has-danger.input-group-focus .input-group-append .input-group-text,
.has-danger.input-group-focus .input-group-prepend .input-group-text {
  background-color: transparent;
}
.has-success .input-group-append .input-group-text,
.has-success .input-group-prepend .input-group-text {
  background-color: transparent;
}
.has-danger .form-control:focus + .input-group-append .input-group-text,
.has-danger .form-control:focus + .input-group-prepend .input-group-text {
  color: #ec250d;
}
.has-success .form-control:focus + .input-group-append .input-group-text,
.has-success .form-control:focus + .input-group-prepend .input-group-text {
  color: #00f2c3;
}
.input-group-append .input-group-text + .form-control, .input-group-append .input-group-text ~ .form-control,
.input-group-prepend .input-group-text + .form-control,
.input-group-prepend .input-group-text ~ .form-control {
  padding: -0.5rem 0.7rem;
  padding-left: 18px;
}
.input-group-append .input-group-text i,
.input-group-prepend .input-group-text i {
  width: 17px;
}

.input-group-append,
.input-group-prepend .input-group-text,
.input-group-prepend .input-group-text {
  background-color: transparent;
  border: 1px solid rgb(16.7333333333%, 20.6705882353%, 32.4823529412%);
  border-radius: 0.4285rem;
  color: #ffffff;
  margin: 0;
}

.input-group-append .input-group-text {
  border-left: none;
}

.input-group-prepend .input-group-text {
  border-right: none;
}

.input-group-focus .input-group-prepend .input-group-text,
.input-group-focus .input-group-append .input-group-text {
  background-color: #ffffff;
  border-color: #e14eca;
  background-color: transparent;
  border-color: #e14eca;
}
.input-group-focus.no-border .input-group-prepend .input-group-text,
.input-group-focus.no-border .input-group-append .input-group-text {
  background-color: rgb(14.6933333333%, 18.1505882353%, 28.5223529412%);
}

.input-group,
.form-group {
  margin-bottom: 10px;
  position: relative;
}
.input-group .form-control-static,
.form-group .form-control-static {
  margin-top: 9px;
}

.input-group[disabled] .input-group-prepend .input-group-text,
.input-group[disabled] .input-group-append .input-group-text {
  background-color: #e3e3e3;
}

.input-group .form-control:not(:first-child):not(:last-child), .input-group-btn:not(:first-child):not(:last-child) {
  border-radius: 0.4285rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0 none;
}

.input-group .form-control:first-child,
.input-group-btn:first-child > .dropdown-toggle,
.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
  border-right: 0 none;
}

.input-group .form-control:last-child,
.input-group-btn:last-child > .dropdown-toggle,
.input-group-btn:first-child > .btn:not(:first-child) {
  border-left: 0 none;
}

.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
  background-color: #1d253b;
  color: #344675;
  cursor: not-allowed;
}

.input-group-btn .btn {
  border-width: 1px;
  padding: 11px 0.7rem;
}

.input-group-btn .btn-default:not(.btn-fill) {
  border-color: #dddddd;
}

.input-group-btn:last-child > .btn {
  margin-left: 0;
}

textarea.form-control {
  max-width: 100%;
  max-height: 80px;
  padding: 10px 10px 0 0;
  resize: none;
  line-height: 2;
}

.has-success.form-group .form-control, .has-success.form-group.no-border .form-control,
.has-danger.form-group .form-control,
.has-danger.form-group.no-border .form-control {
  padding-right: 40px;
}

.form.form-newsletter .form-group {
  float: left;
  width: 78%;
  margin-right: 2%;
  margin-top: 9px;
}

.input-group .input-group-btn {
  padding: 0 12px;
}

.form-group input[type=file] {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.form-text {
  font-size: 0.7500000025rem;
  color: rgba(255, 255, 255, 0.8);
}

.form-control-lg {
  padding: 0;
  font-size: inherit;
  line-height: 0;
  border-radius: 0;
}
.form-control-lg .form-control {
  height: calc(2.875rem + 2px);
}

.form-horizontal .col-form-label,
.form-horizontal .label-on-right {
  padding: 10px 5px 0 15px;
  text-align: right;
  max-width: 180px;
}
.form-horizontal .checkbox-radios {
  margin-bottom: 15px;
}
.form-horizontal .checkbox-radios .form-check:first-child {
  margin-top: 8px;
}
.form-horizontal .label-on-right {
  text-align: left;
  padding: 10px 15px 0 5px;
}
.form-horizontal .form-check-inline {
  margin-top: 6px;
}
.form-horizontal .form-check-inline .form-check-label {
  margin-right: 1.5rem;
}

.search-bar {
  margin-left: 30px;
}
.search-bar .btn {
  margin: 0;
}
.search-bar.input-group {
  border-radius: 25px;
  z-index: 4;
  margin-bottom: 0;
  height: 43px;
  padding-right: 5px;
}
.search-bar.input-group .input-group-addon {
  padding: 10px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.7);
}
.search-bar.input-group i {
  font-size: 20px;
  color: #ffffff;
  margin-top: 0 !important;
}
.search-bar.input-group input {
  background: transparent;
  border: none !important;
  border-radius: 0;
  padding: 12px !important;
  font-size: 12px;
  opacity: 0.5;
}
.search-bar.input-group input:focus {
  background: transparent;
}
.search-bar.input-group .form-control {
  opacity: 1;
  color: #ffffff;
}
.search-bar.input-group .form-control::placeholder {
  color: white;
}

.modal-search .modal-dialog {
  max-width: 1000px;
  margin: 20px auto;
}
.modal-search .modal-dialog .form-control {
  border: none;
  color: #222a42;
}
.modal-search .modal-dialog .form-control::placeholder {
  color: #222a42;
}

.input-group-prepend {
  margin-right: 0;
}

.input-group-prepend .tim-icons,
.input-group-append .tim-icons {
  font-size: 1rem;
}

/*
 * Container style
 */
.ps {
  overflow: hidden !important;
  overflow-anchor: none;
  -ms-overflow-style: none;
  touch-action: auto;
  -ms-touch-action: auto;
}

/*
 * Scrollbar rail styles
 */
.ps__rail-x {
  display: none;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
  height: 15px;
  /* there must be 'bottom' or 'top' for ps__rail-x */
  bottom: 0px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__rail-y {
  display: none;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
  width: 15px;
  /* there must be 'right' or 'left' for ps__rail-y */
  right: 0;
  /* please don't change 'position' */
  position: absolute;
}

.ps--active-x > .ps__rail-x,
.ps--active-y > .ps__rail-y {
  display: block;
  background-color: transparent;
}

.ps:hover > .ps__rail-x,
.ps:hover > .ps__rail-y,
.ps--focus > .ps__rail-x,
.ps--focus > .ps__rail-y,
.ps--scrolling-x > .ps__rail-x,
.ps--scrolling-y > .ps__rail-y {
  opacity: 0.6;
}

.ps .ps__rail-x:hover,
.ps .ps__rail-y:hover,
.ps .ps__rail-x:focus,
.ps .ps__rail-y:focus,
.ps .ps__rail-x.ps--clicking,
.ps .ps__rail-y.ps--clicking {
  background-color: #eee;
  opacity: 0.9;
}

/*
 * Scrollbar thumb styles
 */
.ps__thumb-x {
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color 0.2s linear, height 0.2s ease-in-out;
  -webkit-transition: background-color 0.2s linear, height 0.2s ease-in-out;
  height: 6px;
  /* there must be 'bottom' for ps__thumb-x */
  bottom: 2px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__thumb-y {
  background-color: #aaa;
  border-radius: 6px;
  transition: background-color 0.2s linear, width 0.2s ease-in-out;
  -webkit-transition: background-color 0.2s linear, width 0.2s ease-in-out;
  width: 6px;
  /* there must be 'right' for ps__thumb-y */
  right: 2px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__rail-x:hover > .ps__thumb-x,
.ps__rail-x:focus > .ps__thumb-x,
.ps__rail-x.ps--clicking .ps__thumb-x {
  background-color: #999;
  height: 11px;
}

.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y {
  background-color: #999;
  width: 11px;
}

/* MS supports */
@supports (-ms-overflow-style: none) {
  .ps {
    overflow: auto !important;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ps {
    overflow: auto !important;
  }
}
.react-notification-alert-container {
  z-index: 1051;
  position: fixed;
}

.white-content {
  background: #f5f6fa;
}
.white-content .navbar.navbar-transparent .navbar-brand {
  color: #1d253b;
}
.white-content .navbar.navbar-transparent .navbar-toggler-bar {
  background: #1d253b;
}
.white-content .navbar.navbar-transparent .navbar-nav li a:not(.dropdown-item) {
  color: #1d253b;
}
.white-content .navbar.navbar-transparent .navbar-nav li a:not(.dropdown-item) i {
  color: #1d253b;
}
.white-content .navbar.navbar-transparent .navbar-minimize button i {
  color: #1d253b;
}
.white-content .navbar.navbar-transparent .search-bar.input-group i {
  color: #1d253b;
}
.white-content .navbar.navbar-transparent .search-bar.input-group .form-control {
  color: #344675;
}
.white-content .navbar.navbar-transparent .search-bar.input-group .form-control::placeholder {
  color: #9a9a9a;
}
.white-content .sidebar {
  box-shadow: 0 2px 22px 0 rgba(0, 0, 0, 0.1), 0 4px 20px 0 rgba(0, 0, 0, 0.15);
}
.white-content .sidebar p {
  color: rgba(255, 255, 255, 0.8);
}
.white-content .main-panel {
  background: #f5f6fa;
}
.white-content h1, .white-content h2, .white-content h3, .white-content h4, .white-content h5, .white-content h6, .white-content p, .white-content ol li, .white-content ul li, .white-content pre {
  color: #1d253b;
}
.white-content .font-icon-detail i {
  color: #222a42;
}
.white-content .btn:not([data-action]):hover {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.white-content .btn-neutral.btn-link {
  color: rgba(34, 42, 66, 0.7);
}
.white-content .form-control::-moz-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.white-content .form-control:-moz-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.white-content .form-control::-webkit-input-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.white-content .form-control:-ms-input-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.white-content .has-danger .form-control, .white-content .has-danger .input-group-prepend .input-group-text {
  border-color: #ec250d;
}
.white-content .input-group-prepend .input-group-text {
  border-color: rgba(29, 37, 59, 0.5);
  color: #1d253b;
}
.white-content .form-control {
  color: #222a42;
  border-color: rgba(29, 37, 59, 0.5);
}
.white-content .form-control:focus {
  border-color: #e14eca;
}
.white-content .form-group.no-border .form-control,
.white-content .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.white-content .form-group.no-border .form-control + .input-group-append .input-group-text,
.white-content .form-group.no-border .input-group-prepend .input-group-text,
.white-content .form-group.no-border .input-group-append .input-group-text,
.white-content .input-group.no-border .form-control,
.white-content .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.white-content .input-group.no-border .form-control + .input-group-append .input-group-text,
.white-content .input-group.no-border .input-group-prepend .input-group-text,
.white-content .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
}
.white-content .form-group.no-border .form-control:focus, .white-content .form-group.no-border .form-control:active, .white-content .form-group.no-border .form-control:active,
.white-content .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.white-content .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.white-content .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .form-group.no-border .input-group-prepend .input-group-text:focus,
.white-content .form-group.no-border .input-group-prepend .input-group-text:active,
.white-content .form-group.no-border .input-group-prepend .input-group-text:active,
.white-content .form-group.no-border .input-group-append .input-group-text:focus,
.white-content .form-group.no-border .input-group-append .input-group-text:active,
.white-content .form-group.no-border .input-group-append .input-group-text:active,
.white-content .input-group.no-border .form-control:focus,
.white-content .input-group.no-border .form-control:active,
.white-content .input-group.no-border .form-control:active,
.white-content .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.white-content .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.white-content .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.white-content .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.white-content .input-group.no-border .input-group-prepend .input-group-text:focus,
.white-content .input-group.no-border .input-group-prepend .input-group-text:active,
.white-content .input-group.no-border .input-group-prepend .input-group-text:active,
.white-content .input-group.no-border .input-group-append .input-group-text:focus,
.white-content .input-group.no-border .input-group-append .input-group-text:active,
.white-content .input-group.no-border .input-group-append .input-group-text:active {
  background-color: rgba(222, 222, 222, 0.5);
}
.white-content .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .white-content .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.white-content .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.white-content .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: transparent;
}
.white-content .input-group[disabled] .input-group-prepend .input-group-text,
.white-content .input-group[disabled] .input-group-append .input-group-text {
  background-color: #222a42;
}
.white-content .form-control[disabled], .white-content .form-control[readonly], .white-content fieldset[disabled] .form-control {
  background: #e3e3e3;
  border-color: rgba(29, 37, 59, 0.3);
}
.white-content .input-group-focus .input-group-prepend .input-group-text,
.white-content .input-group-focus .input-group-append .input-group-text,
.white-content .input-group-focus .form-control {
  border-color: #e14eca;
}
.white-content .input-group-focus.no-border .input-group-prepend .input-group-text,
.white-content .input-group-focus.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}
.white-content .input-group-prepend .input-group-text {
  border-right: none;
}
.white-content .input-group-append .input-group-text {
  border-left: none;
}
.white-content .has-danger .form-control:focus, .white-content .has-success.input-group-focus .input-group-append .input-group-text, .white-content .has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: #ec250d;
}
.white-content .has-success .form-control:focus, .white-content .has-success.input-group-focus .input-group-append .input-group-text, .white-content .has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: rgb(0%, 74.9019607843%, 60.354885756%);
}
.white-content .btn.btn-link:hover, .white-content .btn.btn-link:active, .white-content .btn.btn-link:focus {
  color: #9a9a9a !important;
}
.white-content .btn-group .btn.active {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.white-content .card:not(.card-white) {
  background: #ffffff;
  box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.05);
}
.white-content .card:not(.card-white) .card-header {
  color: #222a42;
}
.white-content .card:not(.card-white) .card-header a[data-toggle=collapse] {
  color: #222a42;
}
.white-content .card:not(.card-white) .card-header .card-title, .white-content .card:not(.card-white) .card-body .card-title {
  color: #1d253b;
}
.white-content .card:not(.card-white) .card-body .card-category, .white-content .card:not(.card-white) .card-body .card-description {
  color: #1d253b;
}
.white-content .card:not(.card-white) label:not(.btn) {
  color: #344675;
}
.white-content .card:not(.card-white).nav-pills .nav-item .nav-link {
  color: #444444;
  background-color: hsla(0, 0%, 87%, 0.3);
}
.white-content .card:not(.card-white).nav-pills .nav-item .nav-link:not(.active):hover {
  background: hsla(0, 0%, 87%, 0.5);
}
.white-content .card:not(.card-white).nav-pills .nav-item .nav-link.active {
  color: #ffffff;
}
.white-content .card:not(.card-white) .tab-content .tab-pane {
  color: #444444;
}
.white-content .card:not(.card-white) .card {
  box-shadow: none;
}
.white-content .card:not(.card-white).card-plain {
  background: transparent;
  box-shadow: none;
}
.white-content .card:not(.card-white).card-tasks .card-body i {
  color: rgba(34, 42, 66, 0.7);
}
.white-content .card:not(.card-white).card-tasks .card-body i:hover {
  color: #222a42;
}
.white-content .table > tbody > tr > td {
  color: rgba(34, 42, 66, 0.7) !important;
}
.white-content .table > thead > tr > th,
.white-content .table > tbody > tr > th,
.white-content .table > tfoot > tr > th,
.white-content .table > thead > tr > td,
.white-content .table > tbody > tr > td,
.white-content .table > tfoot > tr > td {
  border-color: rgba(34, 42, 66, 0.2);
  padding: 12px 7px;
  vertical-align: middle;
}
.white-content .table > thead > tr > th, .white-content .table button.btn-neutral.btn-link {
  color: rgba(34, 42, 66, 0.7);
}
.white-content .footer ul li a {
  color: #1d253b;
}
.white-content .footer .copyright {
  color: #1d253b;
}
.white-content .progress-container .progress, .white-content .progress-container.progress.sm .progress {
  background: rgba(34, 42, 66, 0.1);
  box-shadow: 0 0 0 3px rgba(34, 42, 66, 0.1);
}
.white-content .progress-container .progress .progress-value, .white-content .progress-container.progress.sm .progress .progress-value {
  color: #344675;
}
.white-content .progress-container .progress-badge, .white-content .progress-container.progress.sm .progress-badge {
  color: #1d253b;
}
.white-content .full-page {
  background: #f5f6fa;
}
.white-content .full-page h1, .white-content .full-page h2, .white-content .full-page h3, .white-content .full-page h4, .white-content .full-page h5, .white-content .full-page h6, .white-content .full-page p, .white-content .full-page ol li, .white-content .full-page ul li, .white-content .full-page pre {
  color: #1d253b;
}
.white-content .full-page .description {
  color: #9a9a9a;
}
.white-content .full-page .footer ul li a {
  color: #1d253b;
}
.white-content .full-page .footer .copyright {
  color: #1d253b;
}
.white-content .nav-pills .nav-item .nav-link:not(.active) {
  background: rgb(82.7450980392%, 84.4705882353%, 91.3725490196%);
  color: #1d253b;
}
.white-content .nav-pills .nav-item .nav-link:not(.active):hover {
  background: #cccccc;
}

.card {
  background: #27293d;
  border: 0;
  position: relative;
  width: 100%;
  margin-bottom: 30px;
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);
}
.card label {
  color: rgba(255, 255, 255, 0.6);
}
.card .card-title {
  margin-bottom: 0.75rem;
}
.card .card-body {
  padding: 15px;
}
.card .card-body.table-full-width {
  padding-left: 0;
  padding-right: 0;
}
.card .card-body .card-title {
  color: #ffffff;
  text-transform: inherit;
  font-weight: 300;
  margin-bottom: 0.75rem;
}
.card .card-body .card-description, .card .card-body .card-category {
  color: rgba(255, 255, 255, 0.6);
}
.card .card-header:not([data-background-color]) {
  background-color: transparent;
}
.card .card-header {
  padding: 15px 15px 0;
  border: 0;
  color: rgba(255, 255, 255, 0.8);
}
.card .card-header .card-title {
  color: #ffffff;
  font-weight: 100;
}
.card .card-header .card-category {
  color: #9a9a9a;
  margin-bottom: 5px;
  font-weight: 300;
}
.card .map {
  border-radius: 0.2857rem;
}
.card .map.map-big {
  height: 420px;
}
.card.card-white {
  background: #ffffff;
}
.card.card-white .card-title {
  color: #222a42;
}
.card.card-white .card-category, .card.card-white .stats {
  color: #808080;
}
.card.card-white .form-control::-moz-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.card.card-white .form-control:-moz-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.card.card-white .form-control::-webkit-input-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.card.card-white .form-control:-ms-input-placeholder {
  color: rgba(34, 42, 66, 0.4);
  opacity: 1;
  filter: alpha(opacity=100);
}
.card.card-white .has-danger .form-control, .card.card-white .has-danger .input-group-prepend .input-group-text {
  border-color: #ec250d;
}
.card.card-white .input-group-prepend .input-group-text {
  border-color: rgba(29, 37, 59, 0.2);
  color: #1d253b;
}
.card.card-white .form-control {
  color: #222a42;
  border-color: rgba(29, 37, 59, 0.2);
}
.card.card-white .form-control:focus {
  border-color: #e14eca;
}
.card.card-white label:not(.btn) {
  color: #344675;
}
.card.card-white .form-group.no-border .form-control,
.card.card-white .form-group.no-border .form-control + .input-group-prepend .input-group-text,
.card.card-white .form-group.no-border .form-control + .input-group-append .input-group-text,
.card.card-white .form-group.no-border .input-group-prepend .input-group-text,
.card.card-white .form-group.no-border .input-group-append .input-group-text,
.card.card-white .input-group.no-border .form-control,
.card.card-white .input-group.no-border .form-control + .input-group-prepend .input-group-text,
.card.card-white .input-group.no-border .form-control + .input-group-append .input-group-text,
.card.card-white .input-group.no-border .input-group-prepend .input-group-text,
.card.card-white .input-group.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.3);
}
.card.card-white .form-group.no-border .form-control:focus, .card.card-white .form-group.no-border .form-control:active, .card.card-white .form-group.no-border .form-control:active,
.card.card-white .form-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.card.card-white .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.card.card-white .form-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.card.card-white .form-group.no-border .form-control + .input-group-append .input-group-text:focus,
.card.card-white .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.card.card-white .form-group.no-border .form-control + .input-group-append .input-group-text:active,
.card.card-white .form-group.no-border .input-group-prepend .input-group-text:focus,
.card.card-white .form-group.no-border .input-group-prepend .input-group-text:active,
.card.card-white .form-group.no-border .input-group-prepend .input-group-text:active,
.card.card-white .form-group.no-border .input-group-append .input-group-text:focus,
.card.card-white .form-group.no-border .input-group-append .input-group-text:active,
.card.card-white .form-group.no-border .input-group-append .input-group-text:active,
.card.card-white .input-group.no-border .form-control:focus,
.card.card-white .input-group.no-border .form-control:active,
.card.card-white .input-group.no-border .form-control:active,
.card.card-white .input-group.no-border .form-control + .input-group-prepend .input-group-text:focus,
.card.card-white .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.card.card-white .input-group.no-border .form-control + .input-group-prepend .input-group-text:active,
.card.card-white .input-group.no-border .form-control + .input-group-append .input-group-text:focus,
.card.card-white .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.card.card-white .input-group.no-border .form-control + .input-group-append .input-group-text:active,
.card.card-white .input-group.no-border .input-group-prepend .input-group-text:focus,
.card.card-white .input-group.no-border .input-group-prepend .input-group-text:active,
.card.card-white .input-group.no-border .input-group-prepend .input-group-text:active,
.card.card-white .input-group.no-border .input-group-append .input-group-text:focus,
.card.card-white .input-group.no-border .input-group-append .input-group-text:active,
.card.card-white .input-group.no-border .input-group-append .input-group-text:active {
  background-color: rgba(222, 222, 222, 0.5);
}
.card.card-white .form-group.no-border .form-control:focus + .input-group-prepend .input-group-text, .card.card-white .form-group.no-border .form-control:focus + .input-group-append .input-group-text,
.card.card-white .input-group.no-border .form-control:focus + .input-group-prepend .input-group-text,
.card.card-white .input-group.no-border .form-control:focus + .input-group-append .input-group-text {
  background-color: transparent;
}
.card.card-white .input-group[disabled] .input-group-prepend .input-group-text,
.card.card-white .input-group[disabled] .input-group-append .input-group-text {
  background-color: #222a42;
}
.card.card-white .form-control[disabled], .card.card-white .form-control[readonly], .card.card-white fieldset[disabled] .form-control {
  background: #e3e3e3;
  border-color: rgba(29, 37, 59, 0.3);
}
.card.card-white .input-group-focus .input-group-prepend .input-group-text,
.card.card-white .input-group-focus .input-group-append .input-group-text,
.card.card-white .input-group-focus .form-control {
  background-color: #ffffff;
  border-color: #e14eca;
}
.card.card-white .input-group-focus.no-border .input-group-prepend .input-group-text,
.card.card-white .input-group-focus.no-border .input-group-append .input-group-text {
  background-color: rgba(222, 222, 222, 0.5);
}
.card.card-white .input-group-prepend .input-group-text {
  border-right: none;
}
.card.card-white .input-group-append .input-group-text {
  border-left: none;
}
.card.card-white .has-danger .form-control:focus, .card.card-white .has-success.input-group-focus .input-group-append .input-group-text, .card.card-white .has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: #ec250d;
}
.card.card-white .has-success .form-control:focus, .card.card-white .has-success.input-group-focus .input-group-append .input-group-text, .card.card-white .has-success.input-group-focus .input-group-prepend .input-group-text {
  border-color: rgb(0%, 74.9019607843%, 60.354885756%);
}
.card.card-plain {
  background: transparent;
  box-shadow: none;
}
.card .image {
  overflow: hidden;
  height: 200px;
  position: relative;
}
.card .avatar {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  margin-bottom: 15px;
}
.card label {
  font-size: 0.7500000025rem;
  margin-bottom: 5px;
}
.card .card-footer {
  background-color: transparent;
  border: 0;
  padding: 15px;
}
.card .card-footer .stats i {
  margin-right: 5px;
  position: relative;
}
.card .card-footer h6 {
  margin-bottom: 0;
  padding: 7px 0;
}

.card-body {
  padding: 1.25rem;
}

@media (max-width: 767.98px) {
  .card.card-chart .card-header .btn-group-toggle .tim-icons {
    font-size: 0.875rem;
    top: -1px;
  }
}
.card-chart {
  overflow: hidden;
}
.card-chart .card-header .card-title i {
  font-size: 16px;
  margin-right: 5px;
  margin-bottom: 3px;
}
.card-chart .card-header .card-category {
  margin-bottom: 5px;
}
.card-chart .card-body {
  padding-left: 5px;
  padding-right: 5px;
}
.card-chart .card-body .tab-space {
  padding: 0;
}
.card-chart .table {
  margin-bottom: 0;
}
.card-chart .table td {
  border-top: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.card-chart .card-progress {
  margin-top: 30px;
  padding: 0 10px;
}
.card-chart .chart-area {
  width: 100%;
}
.card-chart .card-footer {
  margin-top: 15px;
}
.card-chart .card-footer .stats {
  color: #9a9a9a;
}
.card-chart .dropdown {
  position: absolute;
  right: 20px;
  top: 20px;
}
.card-chart .dropdown .btn {
  margin: 0;
}
.card-chart.card-chart-pie .chart-area {
  padding: 10px 0 25px;
  height: auto;
}
.card-chart.card-chart-pie .card-title {
  margin-bottom: 10px;
}
.card-chart.card-chart-pie .card-title i {
  font-size: 1rem;
}

.map {
  height: 500px;
}

.card-user {
  overflow: hidden;
}
.card-user .image {
  height: 120px;
}
.card-user .author {
  text-align: center;
  text-transform: none;
  margin-top: 25px;
}
.card-user .author a + p.description {
  margin-top: -7px;
}
.card-user .author .block {
  position: absolute;
  height: 100px;
  width: 250px;
}
.card-user .author .block.block-one {
  background: rgba(225, 78, 202, 0.6);
  background: linear-gradient(to right, rgba(225, 78, 202, 0.6) 0%, rgba(225, 78, 202, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=10);
  transform: rotate(150deg);
  margin-top: -90px;
  margin-left: -50px;
}
.card-user .author .block.block-two {
  background: rgba(225, 78, 202, 0.6);
  background: linear-gradient(to right, rgba(225, 78, 202, 0.6) 0%, rgba(225, 78, 202, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=10);
  transform: rotate(30deg);
  margin-top: -40px;
  margin-left: -100px;
}
.card-user .author .block.block-three {
  background: rgba(225, 78, 202, 0.6);
  background: linear-gradient(to right, rgba(225, 78, 202, 0.6) 0%, rgba(225, 78, 202, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=10);
  transform: rotate(170deg);
  margin-top: -70px;
  right: -45px;
}
.card-user .author .block.block-four {
  background: rgba(225, 78, 202, 0.6);
  background: linear-gradient(to right, rgba(225, 78, 202, 0.6) 0%, rgba(225, 78, 202, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=10);
  transform: rotate(150deg);
  margin-top: -25px;
  right: -45px;
}
.card-user .avatar {
  width: 124px;
  height: 124px;
  border: 5px solid rgb(16.7333333333%, 20.6705882353%, 32.4823529412%);
  border-bottom-color: transparent;
  background-color: transparent;
  position: relative;
}
.card-user .card-body {
  min-height: 240px;
}
.card-user hr {
  margin: 5px 15px;
}
.card-user .button-container {
  margin-bottom: 6px;
  text-align: center;
}
.card-user .card-description {
  margin-top: 30px;
}

.card-tasks {
  height: 473px;
}
.card-tasks .table-full-width {
  max-height: 410px;
  position: relative;
}
.card-tasks .card-header .title {
  margin-right: 20px;
  font-weight: 400;
}
.card-tasks .card-header .dropdown {
  float: right;
  color: #cccccc;
}
.card-tasks .card-body i {
  color: #9a9a9a;
  font-size: 1.4em;
}
.card-tasks .card-body i:hover {
  color: #ffffff;
}

.card-plain {
  background: transparent;
  box-shadow: none;
}
.card-plain .card-header,
.card-plain .card-footer {
  margin-left: 0;
  margin-right: 0;
  background-color: transparent;
}
.card-plain:not(.card-subcategories).card-body {
  padding-left: 0;
  padding-right: 0;
}

select.form-control option {
  color: #888;
}

.uploadfiles {
  padding: 0;
  margin-right: -8px;
  margin-left: -8px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  grid-gap: 15px;
}
.uploadfiles li {
  text-align: center;
  list-style: none;
  position: relative;
}
.uploadfiles li.fileUoloadButton {
  border-color: transparent;
}
.uploadfiles li.noData {
  width: 100%;
  height: auto;
  display: block;
  margin: 0;
  padding: 0;
  border: none;
  color: #333 !important;
}
.uploadfiles li.noData:first-child {
  grid-column: 1/-1;
}
.uploadfiles li .storage_file {
  border-radius: 4px;
  border: 1px solid #ddd;
  width: 100px;
  height: 100px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  overflow: hidden;
}
.uploadfiles li .storage_file.not_image {
  background-color: rgba(177, 177, 177, 0.1490196078) !important;
}
.uploadfiles li .storage_file img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 0.5s ease-in-out;
}
.uploadfiles li .storage_file i {
  font-size: 30px;
  color: #222a42;
  transition: 0.5s ease-in-out;
}
.uploadfiles li .storage_file i.fa-times {
  position: absolute;
  top: -5px;
  right: -3px;
  z-index: 9;
  width: 20px;
  height: 20px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  font-size: 12px;
  cursor: pointer;
  box-shadow: 3px -3px 5px 0 rgba(0, 0, 0, 0.1), -3px 3px 5px 0 rgba(0, 0, 0, 0.1);
}
.uploadfiles li .storage_file i.fa-times:hover {
  color: red !important;
}
.uploadfiles li .storage_file i.fa-times::after {
  display: none;
}
.uploadfiles li .storage_file:hover img,
.uploadfiles li .storage_file:hover i {
  transform: scale(1.2);
}
.uploadfiles li .content p {
  margin: 0;
  padding-top: 6px;
  font-weight: 500;
}
.uploadfiles li .ChooseFile {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ddd;
  margin: 0;
  border-radius: 4px;
  cursor: pointer;
}
.uploadfiles li .ChooseFile i {
  font-size: 20px;
  color: #222a42;
  color: gray;
}

.truncate {
  word-break: break-all;
}

.btn-outline-primary {
  background: transparent !important;
  color: #eb8a0d !important;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:active:focus {
  background: #eb8a0d !important;
  color: #ffffff !important;
}

.modal-content .modal-header {
  position: relative;
}

.modal-minimize {
  background: transparent;
  height: auto;
  padding: 10px !important;
  position: absolute !important;
  right: 60px !important;
  top: 24px !important;
  color: #222a42;
  border-radius: 0;
}
.modal-minimize:hover, .modal-minimize:focus, .modal-minimize:active:focus, .modal-minimize:active {
  background: transparent !important;
  color: #222a42 !important;
}

.minmize_modal_list {
  position: absolute;
  bottom: 0;
  overflow-x: auto;
  right: 0;
  left: 0;
  width: calc(100% - 280px);
  margin-left: auto;
  direction: rtl;
}
.minmize_modal_list .minmize_item {
  background-color: #ffffff;
  padding: 14px 12px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  width: 200px;
  margin: 0 4px;
  justify-content: space-between;
  direction: ltr;
}
.minmize_modal_list .minmize_item .title h1 {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  margin: 0 !important;
  max-width: 120px;
  white-space: nowrap;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.minmize_modal_list .minmize_item .minimize_icon {
  margin-left: 20px;
  display: flex;
}
.minmize_modal_list .minmize_item .minimize_icon button {
  padding: 0px 0 0 15px !important;
  line-height: 0;
  background: transparent !important;
  margin: 0;
}
.minmize_modal_list .minmize_item .minimize_icon button:first-child {
  padding-left: 0 !important;
}
.minmize_modal_list .minmize_item .minimize_icon button i {
  font-size: 12px;
  color: #222a42;
}
.minmize_modal_list .minmize_item .minimize_icon button i::after {
  display: none;
}

.checkBox_inline {
  display: flex;
  align-items: center;
  height: 100%;
  margin-left: 15px;
}

.checkBox_inline .form-group {
  font-size: 30px;
  margin-bottom: 6px !important;
}

.checkBox_inline .form-group:nth-child(1) {
  margin-right: 35px;
}

.nodrag_inner .draggable {
  transform: translate(0, 0) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/black-dashboard-react.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_variables.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_root.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_reboot.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_variables.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_hover.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_type.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_lists.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_images.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_image.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_border-radius.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_box-shadow.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_code.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_grid.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_grid.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_breakpoints.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_grid-framework.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_tables.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_table-row.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_forms.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_transition.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_forms.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_gradients.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_buttons.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_buttons.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_transitions.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_dropdown.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_caret.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_nav-divider.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_button-group.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_input-group.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_custom-forms.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_nav.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_navbar.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_card.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_breadcrumb.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_pagination.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_pagination.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_badge.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_badge.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_jumbotron.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_alert.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_alert.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_progress.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_media.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_list-group.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_list-group.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_close.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_modal.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_tooltip.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_reset-text.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_popover.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_carousel.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/utilities/_align.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_background-variant.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/utilities/_background.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/utilities/_borders.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_clearfix.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/utilities/_display.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/utilities/_embed.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/utilities/_flex.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/utilities/_float.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_float.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/utilities/_position.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/utilities/_screenreaders.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_screen-reader.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/utilities/_shadows.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/utilities/_sizing.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/utilities/_spacing.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/utilities/_text.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_text-truncate.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_text-emphasis.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_text-hide.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/utilities/_visibility.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/mixins/_visibility.scss","webpack://./src/assets/scss/black-dashboard-react/bootstrap/_print.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_alerts.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_badges.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_buttons.scss","webpack://./src/assets/scss/black-dashboard-react/custom/mixins/_vendor-prefixes.scss","webpack://./src/assets/scss/black-dashboard-react/custom/mixins/_buttons.scss","webpack://./src/assets/scss/black-dashboard-react/custom/mixins/opacity.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_dropdown.scss","webpack://./src/assets/scss/black-dashboard-react/custom/mixins/_dropdown.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_footer.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_forms.scss","webpack://./src/assets/scss/black-dashboard-react/custom/mixins/_inputs.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_images.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_modal.scss","webpack://./src/assets/scss/black-dashboard-react/custom/mixins/_modals.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_navbar.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_type.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_tables.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_checkboxes-radio.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_fixed-plugin.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_sidebar-and-main-panel.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_misc.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_rtl.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_input-group.scss","webpack://./src/assets/scss/black-dashboard-react/custom/vendor/_plugin-perfect-scrollbar.scss","webpack://./src/assets/scss/black-dashboard-react/custom/vendor/_plugin-react-notification-alert.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_white-content.scss","webpack://./src/assets/scss/black-dashboard-react/custom/_card.scss","webpack://./src/assets/scss/black-dashboard-react/custom/cards/_card-chart.scss","webpack://./src/assets/scss/black-dashboard-react/custom/cards/_card-map.scss","webpack://./src/assets/scss/black-dashboard-react/custom/cards/_card-user.scss","webpack://./src/assets/scss/black-dashboard-react/custom/cards/_card-task.scss","webpack://./src/assets/scss/black-dashboard-react/custom/cards/_card-plain.scss","webpack://./src/assets/scss/black-dashboard-react/react-differences/_inputs.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;;;;;;;;;;EAAA;ACyMA,kCAAA;AAqiBA,iBAAA;AC9uBA;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,gBAAA;EAAA,kBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,eAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAKF,kMAAA;EACA,6GAAA;AFqCF;;AGnCA;;;EAGE,sBAAA;AHsCF;;AGnCA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6BAAA;EACA,gDAAA;AHsCF;AG1BA;;;;;;;;;;EAUE,cAAA;AHgCF;;AGrBA;EACE,SAAA;EACA,kCF2UiB;EE1UjB,mBF6Ue;EE5Uf,gBF4VmB;EE3VnB,gBCmM4B;EDlM5B,cFnDS;EEoDT,gBAAA;EACA,yBF0CiB;ADlBnB;;AGhBA;EACE,qBAAA;AHmBF;;AGXA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AHcF;;AGFA;;;;;;EAME,aAAA;EACA,qBF0TuB;ADrTzB;;AGGA;EACE,aAAA;EACA,mBCuD0B;AJvD5B;;AGUA;;EAGE,0BAAA;EACA,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,gBAAA;AHRF;;AGWA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AHRF;;AGWA;;;EAGE,aAAA;EACA,mBAAA;AHRF;;AGWA;;;;EAIE,gBAAA;AHRF;;AGWA;EACE,gBFgQiB;ADxQnB;;AGWA;EACE,qBAAA;EACA,cAAA;AHRF;;AGWA;EACE,gBAAA;AHRF;;AGWA;EACE,kBAAA;AHRF;;AGYA;;EAEE,mBAAA;AHTF;;AGaA;EACE,cAAA;AHVF;;AGkBA;;EAEE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,wBAAA;AHfF;;AGkBA;EACE,eAAA;AHfF;;AGiBA;EACE,WAAA;AHdF;;AGqBA;EACE,cFpHQ;EEqHR,qBFyCgB;EExChB,6BAAA;EACA,qCAAA;AHlBF;AK1LE;EF+ME,0DFqCe;EEpCf,qBFqCoB;ADvDxB;;AG4BA;EACE,cAAA;EACA,qBAAA;AHzBF;AK/LE;EF2NE,cAAA;EACA,qBAAA;AHzBJ;AG4BE;EACE,UAAA;AH1BJ;;AGkCA;;;;EAIE,iGCD4B;EDE5B,cAAA;AH/BF;;AGkCA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AHpCF;;AG2CA;EAEE,gBAAA;AHzCF;;AGgDA;EACE,sBAAA;EACA,kBAAA;AH7CF;;AGgDA;EAGE,gBAAA;EACA,sBAAA;AH/CF;;AGsDA;EACE,yBAAA;AHnDF;;AGsDA;EACE,iBFmMmB;EElMnB,oBFkMmB;EEjMnB,cF9RS;EE+RT,gBAAA;EACA,oBAAA;AHnDF;;AGsDA;EAGE,mBAAA;AHrDF;;AG4DA;EAEE,qBAAA;EACA,qBCqFsC;AJ/IxC;;AGgEA;EACE,gBAAA;AH7DF;;AGyEA;;;;;EAKE,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AHtEF;;AGyEA;;EAEE,iBAAA;AHtEF;;AGyEA;;EAEE,oBAAA;AHtEF;;AG4EA;;;;EAIE,0BAAA;AHzEF;;AG6EA;;;;EAIE,UAAA;EACA,kBAAA;AH1EF;;AG6EA;;EAEE,sBAAA;EACA,UAAA;AH1EF;;AG6EA;;;;EASE,2BAAA;AH/EF;;AGkFA;EACE,cAAA;EAEA,gBAAA;AHhFF;;AGmFA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AHtFF;;AG2FA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;AHxFF;;AG2FA;EACE,wBAAA;AHxFF;;AG4FA;;EAEE,YAAA;AHzFF;;AG4FA;EAKE,oBAAA;EACA,wBAAA;AH7FF;;AGoGA;;EAEE,wBAAA;AHjGF;;AGyGA;EACE,aAAA;EACA,0BAAA;AHtGF;;AG6GA;EACE,qBAAA;AH1GF;;AG6GA;EACE,kBAAA;EACA,eAAA;AH1GF;;AG6GA;EACE,aAAA;AH1GF;;AG+GA;EACE,wBAAA;AH5GF;;AMxXA;;EAEE,qBLiauB;EKhavB,oBLiaqB;EKharB,gBLsZmB;EKrZnB,gBLiaqB;EKharB,cLQS;ADmXX;;AMxXA;EAAU,0BLyYK;ADbf;;AM3XA;EAAU,yBLyYK;ADVf;;AM9XA;EAAU,yBLyYK;ADPf;;AMjYA;EAAU,0BLyYK;ADJf;;AMpYA;EAAU,yBLyYK;ADDf;;AMvYA;EAAU,wBLyYK;ADEf;;AMzYA;EACE,qBLsbe;EKrbf,gBLsbiB;AD1CnB;;AMxYA;EACE,iBLiac;EKhad,gBLmYiB;EKlYjB,gBL6YqB;ADFvB;;AMzYA;EACE,kBL6Zc;EK5Zd,gBL8XiB;EK7XjB,gBLwYqB;ADIvB;;AM1YA;EACE,oBLyZc;EKxZd,gBLyXiB;EKxXjB,gBLmYqB;ADUvB;;AM3YA;EACE,oBLqZc;EKpZd,gBLoXiB;EKnXjB,gBL8XqB;ADgBvB;;AMtYA;EACE,gBL2aY;EK1aZ,mBL0aY;EKzaZ,SAAA;EACA,iDAAA;ANyYF;;AMjYA;;EAEE,cL4YgB;EK3YhB,gBL2VmB;ADyCrB;;AMjYA;;EAEE,cLgZa;EK/Yb,yBLqZQ;ADjBV;;AM5XA;EC/EE,eAAA;EACA,gBAAA;AP+cF;;AM5XA;ECpFE,eAAA;EACA,gBAAA;APodF;;AM9XA;EACE,qBAAA;ANiYF;AM/XE;EACE,oBL+XkB;ADEtB;;AMvXA;EACE,cAAA;EACA,yBAAA;AN0XF;;AMtXA;EACE,mBLsKO;EKrKP,oBLoWqB;ADqBvB;;AMtXA;EACE,cAAA;EACA,cAAA;EACA,cLrGS;AD8dX;AMvXE;EACE,aAAA;ANyXJ;;AQ5eA;ECIE,eAAA;EAGA,YAAA;AT0eF;;AQ3eA;EACE,gBJ61BkC;EI51BlC,yBPmGiB;EOlGjB,+BAAA;EEZE,sBT8VY;EUhWZ,6CHgBF;ECPA,eAAA;EAGA,YAAA;ATofF;;AQteA;EAEE,qBAAA;ARweF;;AQreA;EACE,qBAAA;EACA,cAAA;ARweF;;AQreA;EACE,cJ80BkC;EI70BlC,cPtBS;AD8fX;;AY/gBA;EACE,gBRs6BkC;EQr6BlC,cX2CK;EW1CL,sBAAA;AZkhBF;AY/gBE;EACE,cAAA;AZihBJ;;AY5gBA;EACE,sBAAA;EACA,gBRy5BkC;EQx5BlC,cXJM;EWKN,yBXIS;ESjBP,wBTiWe;EUnWf,oDCiBF;AZ+gBF;AY7gBE;EACE,UAAA;EACA,eAAA;EACA,gBXyYe;EU/Zf,gBCuBA;AZ+gBJ;;AY1gBA;EACE,cAAA;EACA,gBRw4BkC;EQv4BlC,cXZS;ADyhBX;AY1gBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AZ4gBJ;;AYvgBA;EACE,iBRq4BkC;EQp4BlC,kBAAA;AZ0gBF;;AanjBE;ECAA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AdujBF;AepgBI;EFvDF;ICWI,gBVwLiB;EJ4XrB;AACF;AezgBI;EFvDF;ICWI,gBVwLiB;EJiYrB;AACF;Ae9gBI;EFvDF;ICWI,gBVwLiB;EJsYrB;AACF;AenhBI;EFvDF;ICWI,iBVwLiB;EJ2YrB;AACF;;AankBE;ECZA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AdmlBF;;AajkBE;ECLA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;Ad0kBF;;AankBE;EACE,eAAA;EACA,cAAA;AbskBJ;AapkBI;;EAEE,gBAAA;EACA,eAAA;AbskBN;;AgBvmBE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AhB+mBJ;;AgB5lBM;EACE,aAAA;EACA,YAAA;EACA,eAAA;AhB+lBR;;AgB7lBM;EACE,cAAA;EACA,WAAA;EACA,eAAA;AhBgmBR;;AgB5lBQ;EFFN,uBAAA;EAIA,wBAAA;Ad+lBF;;AgBjmBQ;EFFN,wBAAA;EAIA,yBAAA;AdomBF;;AgBtmBQ;EFFN,aAAA;EAIA,cAAA;AdymBF;;AgB3mBQ;EFFN,wBAAA;EAIA,yBAAA;Ad8mBF;;AgBhnBQ;EFFN,wBAAA;EAIA,yBAAA;AdmnBF;;AgBrnBQ;EFFN,aAAA;EAIA,cAAA;AdwnBF;;AgB1nBQ;EFFN,wBAAA;EAIA,yBAAA;Ad6nBF;;AgB/nBQ;EFFN,wBAAA;EAIA,yBAAA;AdkoBF;;AgBpoBQ;EFFN,aAAA;EAIA,cAAA;AduoBF;;AgBzoBQ;EFFN,wBAAA;EAIA,yBAAA;Ad4oBF;;AgB9oBQ;EFFN,wBAAA;EAIA,yBAAA;AdipBF;;AgBnpBQ;EFFN,cAAA;EAIA,eAAA;AdspBF;;AgBnpBM;EAAwB,SAAA;AhBupB9B;;AgBrpBM;EAAuB,SAAA;AhBypB7B;;AgBtpBQ;EAAwB,QADb;AhB2pBnB;;AgB1pBQ;EAAwB,QADb;AhB+pBnB;;AgB9pBQ;EAAwB,QADb;AhBmqBnB;;AgBlqBQ;EAAwB,QADb;AhBuqBnB;;AgBtqBQ;EAAwB,QADb;AhB2qBnB;;AgB1qBQ;EAAwB,QADb;AhB+qBnB;;AgB9qBQ;EAAwB,QADb;AhBmrBnB;;AgBlrBQ;EAAwB,QADb;AhBurBnB;;AgBtrBQ;EAAwB,QADb;AhB2rBnB;;AgB1rBQ;EAAwB,QADb;AhB+rBnB;;AgB9rBQ;EAAwB,SADb;AhBmsBnB;;AgBlsBQ;EAAwB,SADb;AhBusBnB;;AgBtsBQ;EAAwB,SADb;AhB2sBnB;;AgBpsBU;EFTR,0BAAA;AditBF;;AgBxsBU;EFTR,2BAAA;AdqtBF;;AgB5sBU;EFTR,gBAAA;AdytBF;;AgBhtBU;EFTR,2BAAA;Ad6tBF;;AgBptBU;EFTR,2BAAA;AdiuBF;;AgBxtBU;EFTR,gBAAA;AdquBF;;AgB5tBU;EFTR,2BAAA;AdyuBF;;AgBhuBU;EFTR,2BAAA;Ad6uBF;;AgBpuBU;EFTR,gBAAA;AdivBF;;AgBxuBU;EFTR,2BAAA;AdqvBF;;AgB5uBU;EFTR,2BAAA;AdyvBF;;Ae/uBI;EC7BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhBgxBN;EgB9wBI;IACE,cAAA;IACA,WAAA;IACA,eAAA;EhBgxBN;EgB5wBM;IFFN,uBAAA;IAIA,wBAAA;Ed8wBA;EgBhxBM;IFFN,wBAAA;IAIA,yBAAA;EdkxBA;EgBpxBM;IFFN,aAAA;IAIA,cAAA;EdsxBA;EgBxxBM;IFFN,wBAAA;IAIA,yBAAA;Ed0xBA;EgB5xBM;IFFN,wBAAA;IAIA,yBAAA;Ed8xBA;EgBhyBM;IFFN,aAAA;IAIA,cAAA;EdkyBA;EgBpyBM;IFFN,wBAAA;IAIA,yBAAA;EdsyBA;EgBxyBM;IFFN,wBAAA;IAIA,yBAAA;Ed0yBA;EgB5yBM;IFFN,aAAA;IAIA,cAAA;Ed8yBA;EgBhzBM;IFFN,wBAAA;IAIA,yBAAA;EdkzBA;EgBpzBM;IFFN,wBAAA;IAIA,yBAAA;EdszBA;EgBxzBM;IFFN,cAAA;IAIA,eAAA;Ed0zBA;EgBvzBI;IAAwB,SAAA;EhB0zB5B;EgBxzBI;IAAuB,SAAA;EhB2zB3B;EgBxzBM;IAAwB,QADb;EhB4zBjB;EgB3zBM;IAAwB,QADb;EhB+zBjB;EgB9zBM;IAAwB,QADb;EhBk0BjB;EgBj0BM;IAAwB,QADb;EhBq0BjB;EgBp0BM;IAAwB,QADb;EhBw0BjB;EgBv0BM;IAAwB,QADb;EhB20BjB;EgB10BM;IAAwB,QADb;EhB80BjB;EgB70BM;IAAwB,QADb;EhBi1BjB;EgBh1BM;IAAwB,QADb;EhBo1BjB;EgBn1BM;IAAwB,QADb;EhBu1BjB;EgBt1BM;IAAwB,SADb;EhB01BjB;EgBz1BM;IAAwB,SADb;EhB61BjB;EgB51BM;IAAwB,SADb;EhBg2BjB;EgBz1BQ;IFTR,cAAA;Edq2BA;EgB51BQ;IFTR,0BAAA;Edw2BA;EgB/1BQ;IFTR,2BAAA;Ed22BA;EgBl2BQ;IFTR,gBAAA;Ed82BA;EgBr2BQ;IFTR,2BAAA;Edi3BA;EgBx2BQ;IFTR,2BAAA;Edo3BA;EgB32BQ;IFTR,gBAAA;Edu3BA;EgB92BQ;IFTR,2BAAA;Ed03BA;EgBj3BQ;IFTR,2BAAA;Ed63BA;EgBp3BQ;IFTR,gBAAA;Edg4BA;EgBv3BQ;IFTR,2BAAA;Edm4BA;EgB13BQ;IFTR,2BAAA;Eds4BA;AACF;Ae73BI;EC7BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhB65BN;EgB35BI;IACE,cAAA;IACA,WAAA;IACA,eAAA;EhB65BN;EgBz5BM;IFFN,uBAAA;IAIA,wBAAA;Ed25BA;EgB75BM;IFFN,wBAAA;IAIA,yBAAA;Ed+5BA;EgBj6BM;IFFN,aAAA;IAIA,cAAA;Edm6BA;EgBr6BM;IFFN,wBAAA;IAIA,yBAAA;Edu6BA;EgBz6BM;IFFN,wBAAA;IAIA,yBAAA;Ed26BA;EgB76BM;IFFN,aAAA;IAIA,cAAA;Ed+6BA;EgBj7BM;IFFN,wBAAA;IAIA,yBAAA;Edm7BA;EgBr7BM;IFFN,wBAAA;IAIA,yBAAA;Edu7BA;EgBz7BM;IFFN,aAAA;IAIA,cAAA;Ed27BA;EgB77BM;IFFN,wBAAA;IAIA,yBAAA;Ed+7BA;EgBj8BM;IFFN,wBAAA;IAIA,yBAAA;Edm8BA;EgBr8BM;IFFN,cAAA;IAIA,eAAA;Edu8BA;EgBp8BI;IAAwB,SAAA;EhBu8B5B;EgBr8BI;IAAuB,SAAA;EhBw8B3B;EgBr8BM;IAAwB,QADb;EhBy8BjB;EgBx8BM;IAAwB,QADb;EhB48BjB;EgB38BM;IAAwB,QADb;EhB+8BjB;EgB98BM;IAAwB,QADb;EhBk9BjB;EgBj9BM;IAAwB,QADb;EhBq9BjB;EgBp9BM;IAAwB,QADb;EhBw9BjB;EgBv9BM;IAAwB,QADb;EhB29BjB;EgB19BM;IAAwB,QADb;EhB89BjB;EgB79BM;IAAwB,QADb;EhBi+BjB;EgBh+BM;IAAwB,QADb;EhBo+BjB;EgBn+BM;IAAwB,SADb;EhBu+BjB;EgBt+BM;IAAwB,SADb;EhB0+BjB;EgBz+BM;IAAwB,SADb;EhB6+BjB;EgBt+BQ;IFTR,cAAA;Edk/BA;EgBz+BQ;IFTR,0BAAA;Edq/BA;EgB5+BQ;IFTR,2BAAA;Edw/BA;EgB/+BQ;IFTR,gBAAA;Ed2/BA;EgBl/BQ;IFTR,2BAAA;Ed8/BA;EgBr/BQ;IFTR,2BAAA;EdigCA;EgBx/BQ;IFTR,gBAAA;EdogCA;EgB3/BQ;IFTR,2BAAA;EdugCA;EgB9/BQ;IFTR,2BAAA;Ed0gCA;EgBjgCQ;IFTR,gBAAA;Ed6gCA;EgBpgCQ;IFTR,2BAAA;EdghCA;EgBvgCQ;IFTR,2BAAA;EdmhCA;AACF;Ae1gCI;EC7BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhB0iCN;EgBxiCI;IACE,cAAA;IACA,WAAA;IACA,eAAA;EhB0iCN;EgBtiCM;IFFN,uBAAA;IAIA,wBAAA;EdwiCA;EgB1iCM;IFFN,wBAAA;IAIA,yBAAA;Ed4iCA;EgB9iCM;IFFN,aAAA;IAIA,cAAA;EdgjCA;EgBljCM;IFFN,wBAAA;IAIA,yBAAA;EdojCA;EgBtjCM;IFFN,wBAAA;IAIA,yBAAA;EdwjCA;EgB1jCM;IFFN,aAAA;IAIA,cAAA;Ed4jCA;EgB9jCM;IFFN,wBAAA;IAIA,yBAAA;EdgkCA;EgBlkCM;IFFN,wBAAA;IAIA,yBAAA;EdokCA;EgBtkCM;IFFN,aAAA;IAIA,cAAA;EdwkCA;EgB1kCM;IFFN,wBAAA;IAIA,yBAAA;Ed4kCA;EgB9kCM;IFFN,wBAAA;IAIA,yBAAA;EdglCA;EgBllCM;IFFN,cAAA;IAIA,eAAA;EdolCA;EgBjlCI;IAAwB,SAAA;EhBolC5B;EgBllCI;IAAuB,SAAA;EhBqlC3B;EgBllCM;IAAwB,QADb;EhBslCjB;EgBrlCM;IAAwB,QADb;EhBylCjB;EgBxlCM;IAAwB,QADb;EhB4lCjB;EgB3lCM;IAAwB,QADb;EhB+lCjB;EgB9lCM;IAAwB,QADb;EhBkmCjB;EgBjmCM;IAAwB,QADb;EhBqmCjB;EgBpmCM;IAAwB,QADb;EhBwmCjB;EgBvmCM;IAAwB,QADb;EhB2mCjB;EgB1mCM;IAAwB,QADb;EhB8mCjB;EgB7mCM;IAAwB,QADb;EhBinCjB;EgBhnCM;IAAwB,SADb;EhBonCjB;EgBnnCM;IAAwB,SADb;EhBunCjB;EgBtnCM;IAAwB,SADb;EhB0nCjB;EgBnnCQ;IFTR,cAAA;Ed+nCA;EgBtnCQ;IFTR,0BAAA;EdkoCA;EgBznCQ;IFTR,2BAAA;EdqoCA;EgB5nCQ;IFTR,gBAAA;EdwoCA;EgB/nCQ;IFTR,2BAAA;Ed2oCA;EgBloCQ;IFTR,2BAAA;Ed8oCA;EgBroCQ;IFTR,gBAAA;EdipCA;EgBxoCQ;IFTR,2BAAA;EdopCA;EgB3oCQ;IFTR,2BAAA;EdupCA;EgB9oCQ;IFTR,gBAAA;Ed0pCA;EgBjpCQ;IFTR,2BAAA;Ed6pCA;EgBppCQ;IFTR,2BAAA;EdgqCA;AACF;AevpCI;EC7BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhBurCN;EgBrrCI;IACE,cAAA;IACA,WAAA;IACA,eAAA;EhBurCN;EgBnrCM;IFFN,uBAAA;IAIA,wBAAA;EdqrCA;EgBvrCM;IFFN,wBAAA;IAIA,yBAAA;EdyrCA;EgB3rCM;IFFN,aAAA;IAIA,cAAA;Ed6rCA;EgB/rCM;IFFN,wBAAA;IAIA,yBAAA;EdisCA;EgBnsCM;IFFN,wBAAA;IAIA,yBAAA;EdqsCA;EgBvsCM;IFFN,aAAA;IAIA,cAAA;EdysCA;EgB3sCM;IFFN,wBAAA;IAIA,yBAAA;Ed6sCA;EgB/sCM;IFFN,wBAAA;IAIA,yBAAA;EditCA;EgBntCM;IFFN,aAAA;IAIA,cAAA;EdqtCA;EgBvtCM;IFFN,wBAAA;IAIA,yBAAA;EdytCA;EgB3tCM;IFFN,wBAAA;IAIA,yBAAA;Ed6tCA;EgB/tCM;IFFN,cAAA;IAIA,eAAA;EdiuCA;EgB9tCI;IAAwB,SAAA;EhBiuC5B;EgB/tCI;IAAuB,SAAA;EhBkuC3B;EgB/tCM;IAAwB,QADb;EhBmuCjB;EgBluCM;IAAwB,QADb;EhBsuCjB;EgBruCM;IAAwB,QADb;EhByuCjB;EgBxuCM;IAAwB,QADb;EhB4uCjB;EgB3uCM;IAAwB,QADb;EhB+uCjB;EgB9uCM;IAAwB,QADb;EhBkvCjB;EgBjvCM;IAAwB,QADb;EhBqvCjB;EgBpvCM;IAAwB,QADb;EhBwvCjB;EgBvvCM;IAAwB,QADb;EhB2vCjB;EgB1vCM;IAAwB,QADb;EhB8vCjB;EgB7vCM;IAAwB,SADb;EhBiwCjB;EgBhwCM;IAAwB,SADb;EhBowCjB;EgBnwCM;IAAwB,SADb;EhBuwCjB;EgBhwCQ;IFTR,cAAA;Ed4wCA;EgBnwCQ;IFTR,0BAAA;Ed+wCA;EgBtwCQ;IFTR,2BAAA;EdkxCA;EgBzwCQ;IFTR,gBAAA;EdqxCA;EgB5wCQ;IFTR,2BAAA;EdwxCA;EgB/wCQ;IFTR,2BAAA;Ed2xCA;EgBlxCQ;IFTR,gBAAA;Ed8xCA;EgBrxCQ;IFTR,2BAAA;EdiyCA;EgBxxCQ;IFTR,2BAAA;EdoyCA;EgB3xCQ;IFTR,gBAAA;EduyCA;EgB9xCQ;IFTR,2BAAA;Ed0yCA;EgBjyCQ;IFTR,2BAAA;Ed6yCA;AACF;AiB51CA;EACE,WAAA;EACA,mBhBgRO;EgB/QP,6BhB6eS;ADi3BX;AiB51CE;;EAEE,ahBseiB;EgBrejB,mBAAA;EACA,mCAAA;AjB81CJ;AiB31CE;EACE,sBAAA;EACA,qCAAA;AjB61CJ;AiB11CE;EACE,kCAAA;AjB41CJ;AiBz1CE;EACE,yBhBwFe;ADmwCnB;;AiBj1CE;;EAEE,ehB4coB;ADw4BxB;;AiB30CA;EACE,+BAAA;AjB80CF;AiB50CE;;EAEE,+BAAA;AjB80CJ;AiB10CI;;EAEE,6BAAA;AjB40CN;;AiBt0CE;;;;EAIE,SAAA;AjBy0CJ;;AiBh0CE;EACE,wChBuac;AD45BlB;;AKr4CE;EY8EI,yChB4ZW;AD+5BjB;;AkB/4CI;;;EAGE,qED6F+B;AjBqzCrC;;AK/4CE;EaQM,qEAJe;AlB+4CvB;AkBz4CQ;;EAEE,qEARa;AlBm5CvB;;AkB75CI;;;EAGE,qED6F+B;AjBm0CrC;;AK75CE;EaQM,qEAJe;AlB65CvB;AkBv5CQ;;EAEE,qEARa;AlBi6CvB;;AkB36CI;;;EAGE,0DD6F+B;AjBi1CrC;;AK36CE;EaQM,qEAJe;AlB26CvB;AkBr6CQ;;EAEE,qEARa;AlB+6CvB;;AkBz7CI;;;EAGE,oED6F+B;AjB+1CrC;;AKz7CE;EaQM,kEAJe;AlBy7CvB;AkBn7CQ;;EAEE,kEARa;AlB67CvB;;AkBv8CI;;;EAGE,2DD6F+B;AjB62CrC;;AKv8CE;EaQM,2DAJe;AlBu8CvB;AkBj8CQ;;EAEE,2DARa;AlB28CvB;;AkBr9CI;;;EAGE,qED6F+B;AjB23CrC;;AKr9CE;EaQM,qEAJe;AlBq9CvB;AkB/8CQ;;EAEE,qEARa;AlBy9CvB;;AkBn+CI;;;EAGE,qED6F+B;AjBy4CrC;;AKn+CE;EaQM,oEAJe;AlBm+CvB;AkB79CQ;;EAEE,oEARa;AlBu+CvB;;AkBj/CI;;;EAGE,oED6F+B;AjBu5CrC;;AKj/CE;EaQM,oEAJe;AlBi/CvB;AkB3+CQ;;EAEE,oEARa;AlBq/CvB;;AkB//CI;;;EAGE,qED6F+B;AjBq6CrC;;AK//CE;EaQM,qEAJe;AlB+/CvB;AkBz/CQ;;EAEE,qEARa;AlBmgDvB;;AkB7gDI;;;EAGE,uBD6F+B;AjBm7CrC;;AK7gDE;EaQM,oCAJe;AlB6gDvB;AkBvgDQ;;EAEE,oCARa;AlBihDvB;;AkB3hDI;;;EAGE,uBD6F+B;AjBi8CrC;;AK3hDE;EaQM,oCAJe;AlB2hDvB;AkBrhDQ;;EAEE,oCARa;AlB+hDvB;;AkBziDI;;;EAGE,oCD6F+B;AjB+8CrC;;AKziDE;EaQM,oCAJe;AlByiDvB;AkBniDQ;;EAEE,oCARa;AlB6iDvB;;AkBvjDI;;;EAGE,yCjB6eW;AD6kCjB;;AKvjDE;EaQM,4EAJe;AlBujDvB;AkBjjDQ;;EAEE,4EARa;AlB2jDvB;;AiBx9CI;EACE,chBFa;EgBGb,yBhBhGK;EgBiGL,iEhB4YoB;AD+kC1B;AiBt9CI;EACE,chBzGK;EgB0GL,yBhB/GK;EgBgHL,qBhB/GK;ADukDX;;AiBn9CA;EACE,chBlBiB;EgBmBjB,yBhBhHS;ADskDX;AiBp9CE;;;EAGE,iEhBwXsB;AD8lC1B;AiBn9CE;EACE,SAAA;AjBq9CJ;AiBj9CI;EACE,2ChB6WiB;ADsmCvB;AK1lDE;EY8IM,4ChBuWc;ADwmCtB;;AehiDI;EEkGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;IACA,4CAAA;EjBi8CN;EiB97CM;IACE,SAAA;EjBg8CR;AACF;Ae7iDI;EEkGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;IACA,4CAAA;EjB68CN;EiB18CM;IACE,SAAA;EjB48CR;AACF;AezjDI;EEkGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;IACA,4CAAA;EjBy9CN;EiBt9CM;IACE,SAAA;EjBw9CR;AACF;AerkDI;EEkGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;IACA,4CAAA;EjBq+CN;EiBl+CM;IACE,SAAA;EjBo+CR;AACF;AiB/+CI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;EACA,4CAAA;AjBg/CR;AiB7+CQ;EACE,SAAA;AjB++CV;;AmB9pDA;EACE,cAAA;EACA,WAAA;EACA,kClB+lBa;EkB9lBb,sBAAA;EACA,mBlBqYe;EkBpYf,qBlB2ZkB;EkB1ZlB,+BlBmDU;EkBlDV,6BlBSe;EkBRf,4BAAA;EACA,yBAAA;EAKE,sBlB6UY;EUhWZ,gBQyBF;ECtBI,2DDuBJ;AnBwpDF;AoB3qDE;EDHF;ICII,gBAAA;EpB8qDF;AACF;AmB1pDE;EACE,6BAAA;EACA,SAAA;AnB4pDJ;AqBhrDE;EACE,+BpBkDQ;EoBjDR,yBpBHI;EoBIJ,sCpB8kBuB;EoB7kBvB,UAAA;EAGE,sBAAA;ArBgrDN;AmB5pDE;EACE,clBxBO;EkB0BP,UAAA;AnB6pDJ;AmBrpDE;EAEE,yBlBvCO;EkByCP,UAAA;AnBqpDJ;;AmBhpDE;EAME,+BlBFQ;EkBGR,6BlB5Ca;AD0rDjB;;AmBzoDA;;EAEE,cAAA;EACA,WAAA;AnB4oDF;;AmBloDA;EACE,+BAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBlBnCe;ADwqDjB;;AmBloDA;EACE,iCAAA;EACA,oCAAA;EACA,qBlBoTa;EkBnTb,iBlBqbyB;ADgtC3B;;AmBloDA;EACE,gCAAA;EACA,mCAAA;EACA,0BlB8Sa;EkB7Sb,iBlB0ayB;AD2tC3B;;AmB5nDA;EACE,cAAA;EACA,WAAA;EACA,mBlBmZoB;EkBlZpB,sBlBkZoB;EkBjZpB,gBAAA;EACA,qBlBgTkB;EkB/SlB,clBrGS;EkBsGT,6BAAA;EACA,yBAAA;EACA,mBAAA;AnB+nDF;AmB7nDE;EAEE,gBAAA;EACA,eAAA;AnB8nDJ;;AmBlnDA;EACE,mCfmTsC;EelTtC,uBAAA;EACA,0BlBsQa;EkBrQb,iBlBkYyB;ES9gBvB,wBTiWe;ADi6CnB;;AmBlnDA;EACE,gCf8SsC;Ee7StC,sBAAA;EACA,qBlB6Pa;EkB5Pb,iBlB8XyB;ESlhBvB,wBTgWe;AD06CnB;;AmBhnDE;EAEE,YAAA;AnBknDJ;;AmB9mDA;EACE,YAAA;AnBinDF;;AmBxmDA;EACE,mBfiSsC;AJ00CxC;;AmBxmDA;EACE,cAAA;EACA,mBfmRsC;AJw1CxC;;AmBnmDA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AnBsmDF;AmBpmDE;;EAEE,kBAAA;EACA,iBAAA;AnBsmDJ;;AmB7lDA;EACE,kBAAA;EACA,cAAA;EACA,qBfwPsC;AJw2CxC;;AmB7lDA;EACE,kBAAA;EACA,kBfoPsC;EenPtC,qBAAA;AnBgmDF;AmB9lDE;EACE,clBxMO;ADwyDX;;AmB5lDA;EACE,gBAAA;AnB+lDF;;AmB5lDA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBfuOsC;AJw3CxC;AmB5lDE;EACE,gBAAA;EACA,aAAA;EACA,uBfkOoC;EejOpC,cAAA;AnB8lDJ;;AqB9yDE;EACE,aAAA;EACA,WAAA;EACA,mBjBuaoC;EiBtapC,cpB+ac;EoB9ad,cpB4nBwB;ADqrC5B;;AqB9yDE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,0BpBwWW;EoBvWX,gBjB0N0B;EiBzN1B,cAAA;EACA,wCAAA;EX5CA,sBT8VY;ADggDhB;;AqB5yDI;;;EAEE,qBpBsmBsB;AD0sC5B;AqB9yDM;;;EACE,qBpBmmBoB;EoBlmBpB,2CAAA;ArBkzDR;AqB/yDM;;;;;;;EAEE,cAAA;ArBszDR;;AqB9yDM;;;EAEE,cAAA;ArBkzDR;;AqB1yDM;EACE,cpB0kBoB;ADmuC5B;AqB1yDM;;;EAEE,cAAA;ArB6yDR;;AqBryDM;EACE,cpB4jBoB;AD4uC5B;AqBtyDQ;EACE,2DAAA;ArBwyDV;AqBpyDM;;;EAEE,cAAA;ArBuyDR;AqBnyDQ;ECzGJ,2DD0G2B;ArBqyD/B;AqBhyDQ;EACE,8DAAA;ArBkyDV;;AqBxxDM;EACE,qBpB6hBoB;AD8vC5B;AqBzxDQ;EAAW,qBAAA;ArB4xDnB;AqBzxDM;;;EAEE,cAAA;ArB4xDR;AqBxxDQ;EACE,2CAAA;ArB0xDV;;AqB14DE;EACE,aAAA;EACA,WAAA;EACA,mBjBuaoC;EiBtapC,cpB+ac;EoB9ad,cpB8nB0B;AD+wC9B;;AqB14DE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,0BpBwWW;EoBvWX,gBjB0N0B;EiBzN1B,cAAA;EACA,0CAAA;EX5CA,sBT8VY;AD4lDhB;;AqBx4DI;;;EAEE,qBpBwmBwB;ADoyC9B;AqB14DM;;;EACE,qBpBqmBsB;EoBpmBtB,6CAAA;ArB84DR;AqB34DM;;;;;;;EAEE,cAAA;ArBk5DR;;AqB14DM;;;EAEE,cAAA;ArB84DR;;AqBt4DM;EACE,cpB4kBsB;AD6zC9B;AqBt4DM;;;EAEE,cAAA;ArBy4DR;;AqBj4DM;EACE,cpB8jBsB;ADs0C9B;AqBl4DQ;EACE,0DAAA;ArBo4DV;AqBh4DM;;;EAEE,cAAA;ArBm4DR;AqB/3DQ;ECzGJ,0DD0G2B;ArBi4D/B;AqB53DQ;EACE,gEAAA;ArB83DV;;AqBp3DM;EACE,qBpB+hBsB;ADw1C9B;AqBr3DQ;EAAW,qBAAA;ArBw3DnB;AqBr3DM;;;EAEE,cAAA;ArBw3DR;AqBp3DQ;EACE,6CAAA;ArBs3DV;;AmB9vDA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AnBiwDF;AmB5vDE;EACE,WAAA;AnB8vDJ;Aeh9DI;EIuNA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EnB4vDJ;EmBxvDE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;EnB0vDJ;EmBtvDE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;EnBwvDJ;EmBpvDE;IACE,qBAAA;EnBsvDJ;EmBnvDE;;IAEE,WAAA;EnBqvDJ;EmBhvDE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;EnBkvDJ;EmBhvDE;IACE,kBAAA;IACA,aAAA;IACA,qBf2IkC;Ie1IlC,cAAA;EnBkvDJ;EmB/uDE;IACE,mBAAA;IACA,uBAAA;EnBivDJ;EmB/uDE;IACE,gBAAA;EnBivDJ;AACF;;AuBrjEA;EACE,qBAAA;EACA,gBtB0iBgB;EsBziBhB,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;ECsFA,kBAAA;EACA,mBvB4Se;EuB3Sf,mBvB7CY;EuBgDV,sBvB0PY;EmB7VV,qIGUJ;AvB2jEF;AoBjkEE;EGHF;IHII,gBAAA;EpBokEF;AACF;AK/jEE;EkBGE,qBAAA;AvB+jEJ;AuB5jEE;EAEE,UAAA;EACA,2EtB6hBmB;ADgiDvB;AuBzjEE;EAEE,anBuW0B;EOpY1B,gBY8BA;AvB0jEJ;AuBtjEE;EACE,eAAA;AvBwjEJ;AuBrjEE;EZtCE,gBYwCA;AvBsjEJ;AuBpjEI;EZ1CA,iFY2CE;AvBsjEN;;AuBhjEA;;EAEE,oBAAA;AvBmjEF;;AuB1iEE;ECxDA,cAAA;EFAE,yBlB6EW;EoB3Eb,qBpB2Ea;EOjFX,2EaOF;AxBsmEF;AKnmEE;EmBAE,cAAA;EFNA,qEED2D;EAS3D,iEATqG;AxB+mEzG;AwBnmEE;EAII,4GAAA;AxBkmEN;AwB3lEE;EAEE,cAAA;EACA,yBpBoDW;EoBnDX,qBpBmDW;AJyiEf;AwBzlEE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;AxB4nE7L;AwBplEI;EAGI,iDAAA;AxBolER;;AuBtkEE;ECxDA,cAAA;EFAE,yBlB6EW;EoB3Eb,qBpB2Ea;EOjFX,2EaOF;AxBkoEF;AK/nEE;EmBAE,cAAA;EFNA,qEED2D;EAS3D,iEATqG;AxB2oEzG;AwB/nEE;EAII,6GAAA;AxB8nEN;AwBvnEE;EAEE,cAAA;EACA,yBpBoDW;EoBnDX,qBpBmDW;AJqkEf;AwBrnEE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;AxBwpE7L;AwBhnEI;EAGI,kDAAA;AxBgnER;;AuBlmEE;ECxDA,cAAA;EFAE,yBlB6EW;EoB3Eb,qBpB2Ea;EOjFX,2EaOF;AxB8pEF;AK3pEE;EmBAE,cAAA;EFNA,yDED2D;EAS3D,oDATqG;AxBuqEzG;AwB3pEE;EAII,2GAAA;AxB0pEN;AwBnpEE;EAEE,cAAA;EACA,yBpBoDW;EoBnDX,qBpBmDW;AJimEf;AwBjpEE;EAGE,cAAA;EACA,wDAlC+I;EAsC/I,qDAtCyL;AxBorE7L;AwB5oEI;EAGI,gDAAA;AxB4oER;;AuB9nEE;ECxDA,cAAA;EFAE,yBlB6EW;EoB3Eb,qBpB2Ea;EOjFX,2EaOF;AxB0rEF;AKvrEE;EmBAE,cAAA;EFNA,oEED2D;EAS3D,gEATqG;AxBmsEzG;AwBvrEE;EAII,4GAAA;AxBsrEN;AwB/qEE;EAEE,cAAA;EACA,yBpBoDW;EoBnDX,qBpBmDW;AJ6nEf;AwB7qEE;EAGE,cAAA;EACA,oEAlC+I;EAsC/I,8DAtCyL;AxBgtE7L;AwBxqEI;EAGI,iDAAA;AxBwqER;;AuB1pEE;ECxDA,cAAA;EFAE,yBlB6EW;EoB3Eb,qBpB2Ea;EOjFX,2EaOF;AxBstEF;AKntEE;EmBAE,cAAA;EFNA,2DED2D;EAS3D,uDATqG;AxB+tEzG;AwBntEE;EAII,6GAAA;AxBktEN;AwB3sEE;EAEE,cAAA;EACA,yBpBoDW;EoBnDX,qBpBmDW;AJypEf;AwBzsEE;EAGE,cAAA;EACA,2DAlC+I;EAsC/I,uDAtCyL;AxB4uE7L;AwBpsEI;EAGI,kDAAA;AxBosER;;AuBtrEE;ECxDA,cAAA;EFAE,yBlB6EW;EoB3Eb,qBpB2Ea;EOjFX,2EaOF;AxBkvEF;AK/uEE;EmBAE,cAAA;EFNA,oEED2D;EAS3D,iEATqG;AxB2vEzG;AwB/uEE;EAII,4GAAA;AxB8uEN;AwBvuEE;EAEE,cAAA;EACA,yBpBoDW;EoBnDX,qBpBmDW;AJqrEf;AwBruEE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;AxBwwE7L;AwBhuEI;EAGI,iDAAA;AxBguER;;AuBltEE;ECxDA,cAAA;EFAE,yBlB6EW;EoB3Eb,qBpB2Ea;EOjFX,2EaOF;AxB8wEF;AK3wEE;EmBAE,cAAA;EFNA,qEED2D;EAS3D,iEATqG;AxBuxEzG;AwB3wEE;EAII,6GAAA;AxB0wEN;AwBnwEE;EAEE,cAAA;EACA,yBpBoDW;EoBnDX,qBpBmDW;AJitEf;AwBjwEE;EAGE,cAAA;EACA,qEAlC+I;EAsC/I,iEAtCyL;AxBoyE7L;AwB5vEI;EAGI,kDAAA;AxB4vER;;AuB9uEE;ECxDA,cAAA;EFAE,yBlB6EW;EoB3Eb,qBpB2Ea;EOjFX,2EaOF;AxB0yEF;AKvyEE;EmBAE,cAAA;EFNA,kEED2D;EAS3D,8DATqG;AxBmzEzG;AwBvyEE;EAII,0GAAA;AxBsyEN;AwB/xEE;EAEE,cAAA;EACA,yBpBoDW;EoBnDX,qBpBmDW;AJ6uEf;AwB7xEE;EAGE,cAAA;EACA,kEAlC+I;EAsC/I,8DAtCyL;AxBg0E7L;AwBxxEI;EAGI,+CAAA;AxBwxER;;AuB1wEE;ECxDA,cAAA;EFAE,yBlB6EW;EoB3Eb,qBpB2Ea;EOjFX,2EaOF;AxBs0EF;AKn0EE;EmBAE,cAAA;EFNA,qEED2D;EAS3D,gEATqG;AxB+0EzG;AwBn0EE;EAII,2GAAA;AxBk0EN;AwB3zEE;EAEE,cAAA;EACA,yBpBoDW;EoBnDX,qBpBmDW;AJywEf;AwBzzEE;EAGE,cAAA;EACA,oEAlC+I;EAsC/I,iEAtCyL;AxB41E7L;AwBpzEI;EAGI,gDAAA;AxBozER;;AuBtyEE;ECxDA,cAAA;EFAE,yBlB6EW;EoB3Eb,qBpB2Ea;EOjFX,2EaOF;AxBk2EF;AK/1EE;EmBAE,cAAA;EFNA,0CED2D;EAS3D,gCATqG;AxB22EzG;AwB/1EE;EAII,6GAAA;AxB81EN;AwBv1EE;EAEE,cAAA;EACA,yBpBoDW;EoBnDX,qBpBmDW;AJqyEf;AwBr1EE;EAGE,cAAA;EACA,oCAlC+I;EAsC/I,sCAtCyL;AxBw3E7L;AwBh1EI;EAGI,kDAAA;AxBg1ER;;AuBl0EE;ECxDA,cAAA;EFAE,yBlB6EW;EoB3Eb,qBpB2Ea;EOjFX,2EaOF;AxB83EF;AK33EE;EmBAE,cAAA;EFNA,0CED2D;EAS3D,gCATqG;AxBu4EzG;AwB33EE;EAII,6GAAA;AxB03EN;AwBn3EE;EAEE,cAAA;EACA,yBpBoDW;EoBnDX,qBpBmDW;AJi0Ef;AwBj3EE;EAGE,cAAA;EACA,oCAlC+I;EAsC/I,sCAtCyL;AxBo5E7L;AwB52EI;EAGI,kDAAA;AxB42ER;;AuB91EE;ECxDA,cAAA;EFAE,uBlB6EW;EoB3Eb,mBpB2Ea;EOjFX,2EaOF;AxB05EF;AKv5EE;EmBAE,cAAA;EFNA,uBED2D;EAS3D,mBATqG;AxBm6EzG;AwBv5EE;EAII,uGAAA;AxBs5EN;AwB/4EE;EAEE,cAAA;EACA,uBpBoDW;EoBnDX,mBpBmDW;AJ61Ef;AwB74EE;EAGE,cAAA;EACA,uBAlC+I;EAsC/I,mBAtCyL;AxBg7E7L;AwBx4EI;EAGI,4CAAA;AxBw4ER;;AuBp3EE;ECXA,cpB0Ba;EoBzBb,6BAAA;EACA,sBAAA;EACA,qBpBuBa;AJ42Ef;AwBj4EE;EACE,cAPgD;EAQhD,yBpBmBW;EoBlBX,qBpBkBW;AJi3Ef;AwBh4EE;EAEE,2CAAA;AxBi4EJ;AwB93EE;EAEE,cpBQW;EoBPX,6BAAA;AxB+3EJ;AwB53EE;EAGE,cAAA;EACA,yBAAA;EACA,qBpBDW;AJ63Ef;AwB13EI;EAKI,2CAAA;AxBw3ER;;AuB/4EE;ECXA,cpB0Ba;EoBzBb,6BAAA;EACA,sBAAA;EACA,qBpBuBa;AJu4Ef;AwB55EE;EACE,cAPgD;EAQhD,yBpBmBW;EoBlBX,qBpBkBW;AJ44Ef;AwB35EE;EAEE,4CAAA;AxB45EJ;AwBz5EE;EAEE,cpBQW;EoBPX,6BAAA;AxB05EJ;AwBv5EE;EAGE,cAAA;EACA,yBAAA;EACA,qBpBDW;AJw5Ef;AwBr5EI;EAKI,4CAAA;AxBm5ER;;AuB16EE;ECXA,cpB0Ba;EoBzBb,6BAAA;EACA,sBAAA;EACA,qBpBuBa;AJk6Ef;AwBv7EE;EACE,cAPgD;EAQhD,yBpBmBW;EoBlBX,qBpBkBW;AJu6Ef;AwBt7EE;EAEE,0CAAA;AxBu7EJ;AwBp7EE;EAEE,cpBQW;EoBPX,6BAAA;AxBq7EJ;AwBl7EE;EAGE,cAAA;EACA,yBAAA;EACA,qBpBDW;AJm7Ef;AwBh7EI;EAKI,0CAAA;AxB86ER;;AuBr8EE;ECXA,cpB0Ba;EoBzBb,6BAAA;EACA,sBAAA;EACA,qBpBuBa;AJ67Ef;AwBl9EE;EACE,cAPgD;EAQhD,yBpBmBW;EoBlBX,qBpBkBW;AJk8Ef;AwBj9EE;EAEE,2CAAA;AxBk9EJ;AwB/8EE;EAEE,cpBQW;EoBPX,6BAAA;AxBg9EJ;AwB78EE;EAGE,cAAA;EACA,yBAAA;EACA,qBpBDW;AJ88Ef;AwB38EI;EAKI,2CAAA;AxBy8ER;;AuBh+EE;ECXA,cpB0Ba;EoBzBb,6BAAA;EACA,sBAAA;EACA,qBpBuBa;AJw9Ef;AwB7+EE;EACE,cAPgD;EAQhD,yBpBmBW;EoBlBX,qBpBkBW;AJ69Ef;AwB5+EE;EAEE,4CAAA;AxB6+EJ;AwB1+EE;EAEE,cpBQW;EoBPX,6BAAA;AxB2+EJ;AwBx+EE;EAGE,cAAA;EACA,yBAAA;EACA,qBpBDW;AJy+Ef;AwBt+EI;EAKI,4CAAA;AxBo+ER;;AuB3/EE;ECXA,cpB0Ba;EoBzBb,6BAAA;EACA,sBAAA;EACA,qBpBuBa;AJm/Ef;AwBxgFE;EACE,cAPgD;EAQhD,yBpBmBW;EoBlBX,qBpBkBW;AJw/Ef;AwBvgFE;EAEE,2CAAA;AxBwgFJ;AwBrgFE;EAEE,cpBQW;EoBPX,6BAAA;AxBsgFJ;AwBngFE;EAGE,cAAA;EACA,yBAAA;EACA,qBpBDW;AJogFf;AwBjgFI;EAKI,2CAAA;AxB+/ER;;AuBthFE;ECXA,cpB0Ba;EoBzBb,6BAAA;EACA,sBAAA;EACA,qBpBuBa;AJ8gFf;AwBniFE;EACE,cAPgD;EAQhD,yBpBmBW;EoBlBX,qBpBkBW;AJmhFf;AwBliFE;EAEE,4CAAA;AxBmiFJ;AwBhiFE;EAEE,cpBQW;EoBPX,6BAAA;AxBiiFJ;AwB9hFE;EAGE,cAAA;EACA,yBAAA;EACA,qBpBDW;AJ+hFf;AwB5hFI;EAKI,4CAAA;AxB0hFR;;AuBjjFE;ECXA,cpB0Ba;EoBzBb,6BAAA;EACA,sBAAA;EACA,qBpBuBa;AJyiFf;AwB9jFE;EACE,cAPgD;EAQhD,yBpBmBW;EoBlBX,qBpBkBW;AJ8iFf;AwB7jFE;EAEE,yCAAA;AxB8jFJ;AwB3jFE;EAEE,cpBQW;EoBPX,6BAAA;AxB4jFJ;AwBzjFE;EAGE,cAAA;EACA,yBAAA;EACA,qBpBDW;AJ0jFf;AwBvjFI;EAKI,yCAAA;AxBqjFR;;AuB5kFE;ECXA,cpB0Ba;EoBzBb,6BAAA;EACA,sBAAA;EACA,qBpBuBa;AJokFf;AwBzlFE;EACE,cAPgD;EAQhD,yBpBmBW;EoBlBX,qBpBkBW;AJykFf;AwBxlFE;EAEE,0CAAA;AxBylFJ;AwBtlFE;EAEE,cpBQW;EoBPX,6BAAA;AxBulFJ;AwBplFE;EAGE,cAAA;EACA,yBAAA;EACA,qBpBDW;AJqlFf;AwBllFI;EAKI,0CAAA;AxBglFR;;AuBvmFE;ECXA,cpB0Ba;EoBzBb,6BAAA;EACA,sBAAA;EACA,qBpBuBa;AJ+lFf;AwBpnFE;EACE,cAPgD;EAQhD,yBpBmBW;EoBlBX,qBpBkBW;AJomFf;AwBnnFE;EAEE,4CAAA;AxBonFJ;AwBjnFE;EAEE,cpBQW;EoBPX,6BAAA;AxBknFJ;AwB/mFE;EAGE,cAAA;EACA,yBAAA;EACA,qBpBDW;AJgnFf;AwB7mFI;EAKI,4CAAA;AxB2mFR;;AuBloFE;ECXA,cpB0Ba;EoBzBb,6BAAA;EACA,sBAAA;EACA,qBpBuBa;AJ0nFf;AwB/oFE;EACE,cAPgD;EAQhD,yBpBmBW;EoBlBX,qBpBkBW;AJ+nFf;AwB9oFE;EAEE,4CAAA;AxB+oFJ;AwB5oFE;EAEE,cpBQW;EoBPX,6BAAA;AxB6oFJ;AwB1oFE;EAGE,cAAA;EACA,yBAAA;EACA,qBpBDW;AJ2oFf;AwBxoFI;EAKI,4CAAA;AxBsoFR;;AuB7pFE;ECXA,YpB0Ba;EoBzBb,6BAAA;EACA,sBAAA;EACA,mBpBuBa;AJqpFf;AwB1qFE;EACE,cAPgD;EAQhD,uBpBmBW;EoBlBX,mBpBkBW;AJ0pFf;AwBzqFE;EAEE,sCAAA;AxB0qFJ;AwBvqFE;EAEE,YpBQW;EoBPX,6BAAA;AxBwqFJ;AwBrqFE;EAGE,cAAA;EACA,uBAAA;EACA,mBpBDW;AJsqFf;AwBnqFI;EAKI,sCAAA;AxBiqFR;;AuB7qFA;EACE,gBtBgVmB;EsB/UnB,ctBgBQ;EsBfR,6BAAA;AvBgrFF;AKtvFE;EkByEE,0DtB2Ke;EsB1Kf,qBtB2KoB;EsB1KpB,6BAAA;EACA,yBAAA;AvBgrFJ;AuB7qFE;EAEE,qBtBoKoB;EsBnKpB,yBAAA;EACA,gBAAA;AvB8qFJ;AuB3qFE;EAEE,ctBlFO;EsBmFP,oBAAA;AvB4qFJ;;AuBjqFA;ECbE,kBAAA;EACA,qBvBgTa;EuB/Sb,iBvBibyB;EuB9avB,wBvB4Pe;ADo7EnB;;AuBpqFA;ECjBE,iBAAA;EACA,0BvBiTa;EuBhTb,iBvB6ayB;EuB1avB,sBvB0PY;AD67EhB;;AuBlqFA;EACE,cAAA;EACA,WAAA;AvBqqFF;AuBlqFE;EACE,kBnBwQ0B;AJ45E9B;;AuB5pFE;;;EACE,WAAA;AvBiqFJ;;AyB3yFA;ELGM,gCKFJ;AzB8yFF;AoBxyFE;EKPF;ILQI,gBAAA;EpB2yFF;AACF;AyBjzFE;EACE,UAAA;AzBmzFJ;;AyB9yFE;EACE,aAAA;AzBizFJ;;AyB7yFA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ELdI,6BKeJ;AzBgzFF;AoB3zFE;EKOF;ILNI,gBAAA;EpB8zFF;AACF;;A0Bx0FA;;;;EAIE,kBAAA;A1B20FF;;A2BnzFI;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EAlCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A3By1FF;A2BhyFI;EACE,cAAA;A3BkyFN;;A0Bl1FA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,atBklBkC;EsBjlBlC,aAAA;EACA,WAAA;EACA,gBtBijBkC;EsBhjBlC,iBAAA;EACA,oBAAA;EACA,mBzBwXe;EyBvXf,czBNS;EyBOT,gBAAA;EACA,gBAAA;EACA,yBzBhBM;EyBiBN,4BAAA;EACA,sCAAA;EhB1BE,wBTkWe;EUpWf,iHe8BF;A1Bq1FF;;A0Bl1FA;EACE,QAAA;EACA,UAAA;A1Bq1FF;;A0B/0FE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBtByhBgC;AJyzEpC;A2Bp2FI;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EA3BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A3Bk4FF;A2Bh1FI;EACE,cAAA;A3Bk1FN;;A0Bx1FE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qBtB2gBgC;AJg1EpC;A2B33FI;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;EApBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;A3Bk5FF;A2Bv2FI;EACE,cAAA;A3By2FN;A0Br2FI;EACE,iBAAA;A1Bu2FN;;A0Bj2FE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBtB0fgC;AJ02EpC;A2Br5FI;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,WAAA;A3Bu5FN;A2B54FM;EACE,aAAA;A3B84FR;A2B34FM;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;EACA,uBAAA;EACA,WAAA;EAlCN,mCAAA;EACA,yBAAA;EACA,sCAAA;A3Bg7FF;A2B34FI;EACE,cAAA;A3B64FN;A0Bx3FI;EACE,iBAAA;A1B03FN;;A0Bl3FE;EAIE,WAAA;EACA,YAAA;A1Bk3FJ;;A0B52FA;EElGE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;A5Bk9FF;;A0B52FA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBzB6SmB;EyB5SnB,czB/FS;EyBgGT,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;A1B+2FF;AKv9FE;EqB2GE,uDtBsdgC;EsBrdhC,qBAAA;EJtHA,yBrBOO;AD+9FX;A0B52FE;EAEE,czBtHI;EyBuHJ,qBAAA;EJ7HA,yBrB+WkB;AD4nFtB;A0B12FE;EAEE,czBvHO;EyBwHP,6BAAA;A1B22FJ;;A0Bn2FA;EACE,cAAA;A1Bs2FF;;A0Bl2FA;EACE,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,0BzB0Pa;EyBzPb,czB1IS;EyB2IT,mBAAA;A1Bq2FF;;A0Bj2FA;EACE,cAAA;EACA,uBAAA;EACA,czB/IS;ADm/FX;;A6BrgGA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A7BwgGF;A6BtgGE;;EACE,kBAAA;EACA,cAAA;A7BygGJ;AKxgGE;;EwBII,UAAA;A7BwgGN;A6BtgGI;;;;EAGE,UAAA;A7BygGN;A6BpgGE;;;;;;;;EAIE,iBAAA;A7B0gGJ;;A6BrgGA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A7BwgGF;A6BtgGE;EACE,WAAA;A7BwgGJ;;A6BngGE;EACE,cAAA;A7BsgGJ;A6BlgGE;;EnBlCE,0BmBoC6B;EnBnC7B,6BmBmC6B;A7BqgGjC;A6BlgGE;;EnBzBE,yBmB2B4B;EnB1B5B,4BmB0B4B;A7BqgGhC;;A6Br/FA;EACE,mBAAA;EACA,kBAAA;A7Bw/FF;A6Bt/FE;EAGE,cAAA;A7Bs/FJ;A6Bn/FE;EACE,eAAA;A7Bq/FJ;;A6Bj/FA;EACE,sBAAA;EACA,qBAAA;A7Bo/FF;;A6Bj/FA;EACE,mBAAA;EACA,kBAAA;A7Bo/FF;;A6B9+FA;ElBpGI,gBkBqGF;A7Bi/FF;A6B9+FE;ElBxGE,gBkByGA;A7Bg/FJ;;A6Bv+FA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A7B0+FF;A6Bx+FE;;EAEE,WAAA;A7B0+FJ;A6Bv+FE;;;;EAIE,gBAAA;EACA,cAAA;A7By+FJ;A6Br+FE;;EnB/GE,6BmBiH8B;EnBhH9B,4BmBgH8B;A7Bw+FlC;A6Br+FE;;EnBlIE,yBmBoI2B;EnBnI3B,0BmBmI2B;A7Bw+F/B;;A6Bt9FE;;EAEE,gBAAA;A7By9FJ;A6Bv9FI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;A7B29FN;;A8B7nGA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A9BgoGF;A8B9nGE;;;EAGE,kBAAA;EACA,cAAA;EAGA,SAAA;EACA,gBAAA;A9B8nGJ;A8B5nGI;;;;;;;;;EAGE,iBAAA;A9BooGN;A8B/nGE;;;EAGE,UAAA;A9BioGJ;A8B7nGE;EACE,UAAA;A9B+nGJ;A8B1nGI;;EpB3BA,0BoB2BkD;EpB1BlD,6BoB0BkD;A9B+nGtD;A8B9nGI;;EpBdA,yBoBckD;EpBblD,4BoBakD;A9BmoGtD;A8B9nGE;EACE,aAAA;EACA,mBAAA;A9BgoGJ;A8B9nGI;EpBrCA,0BoBsC4E;EpBrC5E,6BoBqC4E;A9BioGhF;A8BhoGI;EpBzBA,yBoByBqE;EpBxBrE,4BoBwBqE;A9BooGzE;;A8BznGA;;EAEE,aAAA;A9B4nGF;A8BvnGE;;EACE,kBAAA;EACA,UAAA;A9B0nGJ;A8BvnGE;;;;;;;;EAIE,iBAAA;A9B6nGJ;;A8BznGA;EAAuB,kBAAA;A9B6nGvB;;A8B5nGA;EAAsB,iBAAA;A9BgoGtB;;A8BxnGA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mB7B2Se;E6B1Sf,gB7B0TmB;E6BzTnB,qB7BgUkB;E6B/TlB,c7BvFS;E6BwFT,kBAAA;EACA,mBAAA;EACA,6B7BpFe;E6BqFf,yBAAA;EpBxGE,sBT8VY;ADs4FhB;A8BxnGE;;EAEE,aAAA;A9B0nGJ;;A8BhnGA;;;;;EAKE,gC1BkUsC;E0BjUtC,sBAAA;EACA,qB7BiRa;E6BhRb,iB7BkZyB;ESlhBvB,wBTgWe;ADo5FnB;;A8BhnGA;;;;;EAKE,mC1BmTsC;E0BlTtC,uBAAA;EACA,0B7BsQa;E6BrQb,iB7BkYyB;ES9gBvB,wBTiWe;AD+5FnB;;A8BxmGA;;;;;;EpB3II,0BoBiJ2B;EpBhJ3B,6BoBgJ2B;A9B4mG/B;;A8BzmGA;;;;;;EpBtII,yBoB4I0B;EpB3I1B,4BoB2I0B;A9B6mG9B;;A+B/wGA;EACE,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,qB9B2mBsB;ADuqFxB;;A+B/wGA;EACE,oBAAA;EACA,kB9BumBwB;AD2qF1B;;A+B/wGA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;A/BkxGF;A+BhxGE;EACE,c9BfI;EqBNJ,yBrB+WkB;EUnXlB,gBoB2BA;A/BkxGJ;A+B/wGE;EAEE,gB9B6lBkC;ADmrFtC;A+B7wGE;EACE,c9B1BI;E8B2BJ,yB9B8UkB;EUnXlB,gBoBsCA;A/B+wGJ;A+B3wGI;EACE,c9B3BK;ADwyGX;A+B3wGM;EACE,yB9BlCG;AD+yGX;;A+BnwGA;EACE,kBAAA;EACA,gBAAA;A/BswGF;A+BnwGE;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,c9BsjB4B;E8BrjB5B,e9BqjB4B;E8BpjB5B,oBAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6B9BlDa;EUrBb,gBoBwEA;A/BqwGJ;A+BjwGE;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,c9BuiB4B;E8BtiB5B,e9BsiB4B;E8BriB5B,WAAA;EACA,4BAAA;EACA,kCAAA;EACA,wB3BqYoC;AJ83FxC;;A+BzvGE;ErB9FE,wBTiWe;AD0/FnB;A+BxvGI;ETjGA,yBrB+WkB;AD6+FtB;A+BxvGI;EACE,yD3BoY0C;AJs3FhD;A+BrvGI;ET1GA,yBrB+WkB;EUnXlB,gBoBgHE;A/BuvGN;A+BrvGI;EACE,yD3B8XgD;AJy3FtD;A+BlvGI;EACE,yC9BqhByC;AD+tF/C;A+BlvGI;EACE,yC9BkhByC;ADkuF/C;;A+B1uGE;EACE,kB3B6W4C;AJg4FhD;A+BzuGI;ETvIA,yBrB+WkB;ADogGtB;A+BzuGI;EACE,yD3BsW0C;AJq4FhD;A+BtuGI;EACE,yC9ByfyC;AD+uF/C;;A+B5tGA;EACE,qBAAA;EACA,WAAA;EACA,kC9Bkca;E8Bjcb,0CAAA;EACA,qB9B+PkB;E8B9PlB,+B9BzGU;E8B0GV,sBAAA;EACA,8FAAA;EACA,yB3BsVkC;E2BrVlC,yBAAA;EAEE,sB9BmLY;EUhWZ,mDoBiLF;EACA,gBAAA;A/B2tGF;A+BztGE;EACE,sC9BuauB;E8BtavB,UAAA;EAEE,oFAAA;A/B0tGN;A+BrtGI;EAME,+B9BrIM;E8BsIN,6B9B/KW;ADi4GjB;A+B9sGE;EAEE,YAAA;EACA,sB3B6SgC;E2B5ShC,sBAAA;A/B+sGJ;A+B5sGE;EACE,c9BhMO;E8BiMP,yB9BrMO;ADm5GX;A+B1sGE;EACE,UAAA;A/B4sGJ;;A+BxsGA;EACE,mC3BmOsC;E2BlOtC,qB3B2RkC;E2B1RlC,wB3B0RkC;E2BzRlC,c3B8SkC;AJ65FpC;;A+BxsGA;EACE,gC3B+NsC;E2B9NtC,qB3BoRkC;E2BnRlC,wB3BmRkC;E2BlRlC,e3B0SkC;AJi6FpC;;A+BnsGA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,kC9BqXa;E8BpXb,gBAAA;A/BssGF;;A+BnsGA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kC9B6Wa;E8B5Wb,SAAA;EACA,UAAA;A/BssGF;A+BpsGE;EACE,sC9B8VuB;E8B7VvB,gB9B6QyB;ADy7F7B;A+BpsGI;EACE,sC9B0VqB;AD42F3B;A+BlsGE;EACE,yB9B3PO;AD+7GX;A+BhsGI;EACE,iB3BwSa;AJ05FnB;;A+B7rGA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,kC9B+Ua;E8B9Ub,sBAAA;EACA,qB9B4IkB;E8B3IlB,+B9B5NU;E8B6NV,6B9BtQe;E8BuQf,yBAAA;ErB1RE,sBT8VY;EUhWZ,gBoB8RF;A/BgsGF;A+B9rGE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,sB9B8TiB;E8B7TjB,sBAAA;EACA,qB9B4HgB;E8B3HhB,+B9B5OQ;E8B6OR,iBAAA;ETvSA,6BrBiBa;E8BwRb,8BAAA;ErB3SA,kCqB4SuB;A/BgsG3B;;A+BtrGA;EACE,WAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;A/ByrGF;A+BvrGE;EACE,aAAA;A/ByrGJ;A+BrrGI;EAA0B,mC3B4Ne;AJ49F7C;A+BvrGI;EAA0B,mC3B2Ne;AJ+9F7C;A+BzrGI;EAA0B,mC3B0Ne;AJk+F7C;A+BzrGE;EACE,SAAA;A/B2rGJ;A+BxrGE;EACE,W3B4MyC;E2B3MzC,Y3B2MyC;E2B1MzC,oBAAA;ET3UA,yBrB+WkB;E8BlClB,S3B2MyC;EM1hBzC,mBN2hByC;EO7hBzC,kDoBmVA;EXhVE,oHWiVF;EXjVE,4GWiVF;A/B0rGJ;AoBvgHE;EWqUA;IXpUE,wBAAA;IAAA,gBAAA;EpB0gHF;AACF;A+BvsGE;EASE,gBAAA;A/BisGJ;A+B/rGI;ETnVA,qElB6hByC;AJw/F7C;A+B7rGE;EACE,W3BqLgC;E2BpLhC,c3BqLgC;E2BpLhC,kBAAA;EACA,e3BoLgC;E2BnLhC,yB9BpVO;E8BqVP,yBAAA;ErBhWA,mBNohBgC;EOthBhC,yDoBoWA;A/B+rGJ;A+B5rGE;EACE,W3BiLyC;E2BhLzC,Y3BgLyC;EkBrhBzC,yBrB+WkB;E8BRlB,S3BiLyC;EM1hBzC,mBN2hByC;EO7hBzC,kDoB6WA;EX1WE,iHW2WF;EX3WE,4GW2WF;A/B8rGJ;AoBriHE;EWgWA;IX/VE,qBAAA;IAAA,gBAAA;EpBwiHF;AACF;A+B1sGE;EAQE,gBAAA;A/BqsGJ;A+BnsGI;ET7WA,qElB6hByC;AJshG7C;A+BjsGE;EACE,W3B2JgC;E2B1JhC,c3B2JgC;E2B1JhC,kBAAA;EACA,e3B0JgC;E2BzJhC,yB9B9WO;E8B+WP,yBAAA;ErB1XA,mBNohBgC;EOthBhC,yDoB8XA;A/BmsGJ;A+BhsGE;EACE,W3BuJyC;E2BtJzC,Y3BsJyC;E2BrJzC,aAAA;EACA,e9BoIoB;E8BnIpB,c9BmIoB;EqBrgBpB,yBrB+WkB;E8BqBlB,S3BoJyC;EM1hBzC,mBN2hByC;EO7hBzC,kDoB0YA;EXvYE,gHWwYF;EXxYE,4GWwYF;A/BksGJ;AoBtkHE;EW0XA;IXzXE,oBAAA;IAAA,gBAAA;EpBykHF;AACF;A+BjtGE;EAWE,gBAAA;A/BysGJ;A+BvsGI;ET1YA,qElB6hByC;AJujG7C;A+BrsGE;EACE,W3B8HgC;E2B7HhC,c3B8HgC;E2B7HhC,kBAAA;EACA,e3B6HgC;E2B5HhC,6BAAA;EACA,yBAAA;EACA,oBAAA;EpB1ZA,yDoB2ZA;A/BusGJ;A+BpsGE;EACE,yB9BlZO;ESXP,mBNohBgC;AJglGpC;A+BnsGE;EACE,kBAAA;EACA,yB9BxZO;ESXP,mBNohBgC;AJqlGpC;;A+BjsGA;;;EXvaM,4GW0aJ;A/BosGF;AoB1mHE;EWmaF;;;IXlaI,gBAAA;EpB+mHF;AACF;;AgCrnHA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AhCwnHF;;AgCrnHA;EACE,cAAA;EACA,oBAAA;AhCwnHF;AKvnHE;E2BEE,qBAAA;AhCwnHJ;AgCpnHE;EACE,c/BLO;AD2nHX;;AgC9mHA;EACE,sCAAA;AhCinHF;AgC/mHE;EACE,yBAAA;AhCinHJ;AgC9mHE;EACE,mCAAA;EtB7BA,+BTwVY;ESvVZ,gCTuVY;ADuzGhB;AKzoHE;E2B2BI,qC5B0kB8B;AJuiGpC;AgC9mHI;EACE,c/B7BK;E+B8BL,6BAAA;EACA,yBAAA;AhCgnHN;AgC5mHE;;EAEE,c/BpCO;E+BqCP,yB/B0De;E+BzDf,qC5B+jBgC;AJ+iGpC;AgC3mHE;EAEE,sBAAA;EtBpDA,yBsBsD2B;EtBrD3B,0BsBqD2B;AhC4mH/B;;AgClmHE;EtBtEE,sBT8VY;AD80GhB;AgClmHE;;EAEE,c/B0oB0B;E+BzoB1B,yB/B0oBuB;AD09F3B;;AgC1lHE;EACE,cAAA;EACA,kBAAA;AhC6lHJ;;AgCxlHE;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AhC2lHJ;;AgCjlHE;EACE,aAAA;AhColHJ;AgCllHE;EACE,cAAA;AhColHJ;;AiCtrHA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,2BAAA;AjCyrHF;AiCrrHE;;EAEE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AjCurHJ;;AiC9qHA;EACE,qBAAA;EACA,yB7BimBkC;E6BhmBlC,4B7BgmBkC;E6B/lBlC,uBhCqrBiB;EgCprBjB,qBhCsWa;EgCrWb,oBAAA;EACA,mBAAA;AjCirHF;AKjtHE;E4BmCE,qBAAA;AjCirHJ;;AiCxqHA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AjC2qHF;AiCzqHE;EACE,gBAAA;EACA,eAAA;AjC2qHJ;AiCxqHE;EACE,gBAAA;EACA,WAAA;AjC0qHJ;;AiCjqHA;EACE,qBAAA;EACA,mBhConBmB;EgCnnBnB,sBhCmnBmB;ADijGrB;;AiCxpHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AjCypHF;;AiCrpHA;EACE,wBAAA;EACA,qBhCuSa;EgCtSb,cAAA;EACA,6BAAA;EACA,mCAAA;EvB5GE,sBT8VY;ADu6GhB;AKzvHE;E4BoGE,qBAAA;AjCwpHJ;AiCppHE;EACE,eAAA;AjCspHJ;;AiChpHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;EACA,0BAAA;AjCmpHF;;AehtHI;EkByEI;;IAEE,gBAAA;IACA,eAAA;EjC2oHR;AACF;AeruHI;EkBoFA;IAUI,qBAAA;IACA,2BAAA;EjC2oHN;EiCzoHM;IACE,mBAAA;EjC2oHR;EiCzoHQ;IACE,kBAAA;EjC2oHV;EiCxoHQ;IACE,mBhC+jBgB;IgC9jBhB,kBhC8jBgB;ED4kG1B;EiCroHM;;IAEE,iBAAA;EjCuoHR;EiCpoHM;IACE,wBAAA;IAGA,gBAAA;EjCooHR;EiCjoHM;IACE,aAAA;EjCmoHR;AACF;AenvHI;EkByEI;;IAEE,gBAAA;IACA,eAAA;EjC6qHR;AACF;AevwHI;EkBoFA;IAUI,qBAAA;IACA,2BAAA;EjC6qHN;EiC3qHM;IACE,mBAAA;EjC6qHR;EiC3qHQ;IACE,kBAAA;EjC6qHV;EiC1qHQ;IACE,mBhC+jBgB;IgC9jBhB,kBhC8jBgB;ED8mG1B;EiCvqHM;;IAEE,iBAAA;EjCyqHR;EiCtqHM;IACE,wBAAA;IAGA,gBAAA;EjCsqHR;EiCnqHM;IACE,aAAA;EjCqqHR;AACF;AerxHI;EkByEI;;IAEE,gBAAA;IACA,eAAA;EjC+sHR;AACF;AezyHI;EkBoFA;IAUI,qBAAA;IACA,2BAAA;EjC+sHN;EiC7sHM;IACE,mBAAA;EjC+sHR;EiC7sHQ;IACE,kBAAA;EjC+sHV;EiC5sHQ;IACE,mBhC+jBgB;IgC9jBhB,kBhC8jBgB;EDgpG1B;EiCzsHM;;IAEE,iBAAA;EjC2sHR;EiCxsHM;IACE,wBAAA;IAGA,gBAAA;EjCwsHR;EiCrsHM;IACE,aAAA;EjCusHR;AACF;AevzHI;EkByEI;;IAEE,gBAAA;IACA,eAAA;EjCivHR;AACF;Ae30HI;EkBoFA;IAUI,qBAAA;IACA,2BAAA;EjCivHN;EiC/uHM;IACE,mBAAA;EjCivHR;EiC/uHQ;IACE,kBAAA;EjCivHV;EiC9uHQ;IACE,mBhC+jBgB;IgC9jBhB,kBhC8jBgB;EDkrG1B;EiC3uHM;;IAEE,iBAAA;EjC6uHR;EiC1uHM;IACE,wBAAA;IAGA,gBAAA;EjC0uHR;EiCvuHM;IACE,aAAA;EjCyuHR;AACF;AiChxHQ;;EAEE,gBAAA;EACA,eAAA;AjCkxHV;AiCvxHI;EAUI,qBAAA;EACA,2BAAA;AjCgxHR;AiC9wHQ;EACE,mBAAA;AjCgxHV;AiC9wHU;EACE,kBAAA;AjCgxHZ;AiC7wHU;EACE,mBhC+jBgB;EgC9jBhB,kBhC8jBgB;ADitG5B;AiC1wHQ;;EAEE,iBAAA;AjC4wHV;AiCzwHQ;EACE,wBAAA;EAGA,gBAAA;AjCywHV;AiCtwHQ;EACE,aAAA;AjCwwHV;;AiC1vHE;EACE,4BhCujBwB;ADssG5B;AKp7HE;E4B0LI,4BhCojBsB;ADysG5B;AiCxvHI;EACE,4BhC4iBe;AD8sGrB;AK17HE;E4BmMM,4BhC0iBmB;ADgtG3B;AiCvvHM;EACE,4BhCwiBsB;ADitG9B;AiCrvHI;;;;EAIE,4BhC+hBsB;ADwtG5B;AiCnvHE;EACE,4BhCwhBiB;EgCvhBjB,yBhC4hBgC;ADytGpC;AiClvHE;EACE,yDhCuhB2B;AD6tG/B;AiCjvHE;EACE,4BhC+gBiB;ADouGrB;AiClvHI;EACE,4BhC+gBsB;ADquG5B;AKn9HE;E4BkOM,4BhC4gBoB;ADwuG5B;;AiC5uHE;EACE,gChC0fuB;ADqvG3B;AK19HE;E4B8OI,gChCufqB;ADwvG3B;AiC1uHI;EACE,gChC+ec;AD6vGpB;AKh+HE;E4BuPM,gChC6ekB;AD+vG1B;AiCzuHM;EACE,gChC2eqB;ADgwG7B;AiCvuHI;;;;EAIE,gChCkeqB;ADuwG3B;AiCruHE;EACE,gChC2dgB;EgC1dhB,yBhC8d+B;ADywGnC;AiCpuHE;EACE,yD7B0XgC;AJ42GpC;AiCnuHE;EACE,gChCkdgB;ADmxGpB;AiCpuHI;EACE,gChCkdqB;ADoxG3B;AKz/HE;E4BsRM,gChC+cmB;ADuxG3B;;AkCxgIA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,yBjCEM;EiCDN,2BAAA;EACA,8CAAA;ExBRE,wBTiWe;ADmrHnB;AkCzgIE;EACE,eAAA;EACA,cAAA;AlC2gIJ;AkCvgII;ExBXA,iCT2Ve;ES1Vf,kCT0Ve;AD2rHnB;AkCrgII;ExBHA,qCT6Ue;ES5Uf,oCT4Ue;AD+rHnB;;AkCngIA;EAGE,cAAA;EACA,ejCq1Bc;AD+qGhB;;AkCjgIA;EACE,sBjCg1Bc;ADorGhB;;AkCjgIA;EACE,qBAAA;EACA,gBAAA;AlCogIF;;AkCjgIA;EACE,gBAAA;AlCogIF;;AK1iIE;E6B2CE,qBAAA;AlCmgIJ;AkChgIE;EACE,mBjC+zBY;ADmsGhB;;AkC1/HA;EACE,uBAAA;EACA,gBAAA;EACA,yBjCzDS;EiC0DT,qDAAA;AlC6/HF;AkC3/HE;ExBrEE,0EwBsEuB;AlC6/H3B;AkCz/HI;EACE,aAAA;AlC2/HN;;AkCt/HA;EACE,uBAAA;EACA,yBjCzES;EiC0ET,kDAAA;AlCy/HF;AkCv/HE;ExBrFE,0EwBsFuB;AlCy/H3B;;AkCh/HA;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;AlCm/HF;;AkCh/HA;EACE,sBAAA;EACA,qBAAA;AlCm/HF;;AkC/+HA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gBjC4wByB;ADsuG3B;;AkC/+HA;EACE,WAAA;ExBtHE,0CT03BuB;AD+uG3B;;AkC9+HA;EACE,WAAA;ExBtHE,mDTo3BuB;ESn3BvB,oDTm3BuB;ADqvG3B;;AkC/+HA;EACE,WAAA;ExB7GE,uDTs2BuB;ESr2BvB,sDTq2BuB;AD2vG3B;;AkC7+HA;EACE,aAAA;EACA,sBAAA;AlCg/HF;AkC9+HE;EACE,mB9BkkBgC;AJ86GpC;AerkII;EmBgFJ;IASI,mBAAA;IACA,mBAAA;IACA,kBAAA;ElCg/HF;EkC9+HE;IACE,aAAA;IAEA,SAAA;IACA,sBAAA;IACA,kB9BqjB8B;I8BpjB9B,gBAAA;IACA,iB9BmjB8B;EJ47GlC;AACF;;AkCt+HA;EACE,aAAA;EACA,sBAAA;AlCy+HF;AkCr+HE;EACE,mB9BkiBgC;AJq8GpC;Ae5lII;EmB8GJ;IAWI,mBAAA;ElCu+HF;EkCp+HE;IAEE,SAAA;IACA,gBAAA;ElCq+HJ;EkCn+HI;IACE,cAAA;IACA,cAAA;ElCq+HN;EkCh+HM;IxBnLJ,0BwBoLmC;IxBnLnC,6BwBmLmC;ElCm+HrC;EkCj+HQ;;IAEE,0BAAA;ElCm+HV;EkCj+HQ;;IAEE,6BAAA;ElCm+HV;EkC/9HM;IxBlLJ,yBwBmLkC;IxBlLlC,4BwBkLkC;ElCk+HpC;EkCh+HQ;;IAEE,yBAAA;ElCk+HV;EkCh+HQ;;IAEE,4BAAA;ElCk+HV;EkC99HM;IxB1NJ,wBTiWe;ED01HjB;EkC99HQ;;IxBvNN,iCT2Ve;IS1Vf,kCT0Ve;ED+1HjB;EkC/9HQ;;IxB7MN,qCT6Ue;IS5Uf,oCT4Ue;EDo2HjB;EkC99HM;IxBvOJ,gBwBwO6B;ElCg+H/B;EkC99HQ;;;;IxB1ON,gBwB8O+B;ElCg+HjC;AACF;;AkCn9HE;EACE,sBjCwnBY;AD81GhB;Ae3pII;EmBmMJ;IAMI,ejCkoBiB;IiCjoBjB,mBjCkoBe;IiCjoBf,UAAA;IACA,SAAA;ElCs9HF;EkCp9HE;IACE,qBAAA;IACA,WAAA;ElCs9HJ;AACF;;AkC58HE;EACE,gBAAA;EACA,gBAAA;AlC+8HJ;AkC38HI;EACE,gBAAA;AlC68HN;AkCz8HE;EACE,gBAAA;EACA,6BAAA;EACA,4BAAA;AlC28HJ;AkCx8HE;EACE,yBAAA;EACA,0BAAA;AlC08HJ;;AmCpvIA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mB/B23BkC;E+B13BlC,gBAAA;EACA,yBlC0Ga;ES5GX,sBT8VY;AD45HhB;;AmClvIE;EACE,oB/Bg3BgC;AJq4GpC;AmCnvII;EACE,qBAAA;EACA,qB/B42B8B;E+B32B9B,clCNE;EkCOF,Y/Bi3B8B;AJo4GpC;AmC3uIE;EACE,0BAAA;AnC6uIJ;AmC1uIE;EACE,qBAAA;AnC4uIJ;AmCzuIE;EACE,clC1BI;ADqwIR;;AoCjxIA;EACE,aAAA;E7BGA,eAAA;EACA,gBAAA;EGDE,sBT8VY;ADs7HhB;;AoClxIA;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,uBAAA;EACA,iBhC8pBkC;EgC7pBlC,cAAA;EACA,6BnCu1Bc;EmCt1Bd,+BAAA;ApCqxIF;AoCnxIE;EACE,UAAA;EACA,cAAA;EACA,qBAAA;EACA,yBnCLO;EmCMP,qBnCNO;AD2xIX;AoClxIE;EACE,UAAA;EACA,UhCupBgC;EgCtpBhC,gBnCmfyB;ADiyH7B;AoChxIE;EACE,eAAA;ApCkxIJ;;AoC5wII;EACE,cAAA;E1BRF,+BTmUY;ESlUZ,kCTkUY;ADs9HhB;AoC5wII;E1B3BA,gCTiVY;EShVZ,mCTgVY;AD09HhB;AoC3wIE;EACE,UAAA;EACA,cnCvCI;EmCwCJ,yBnCiUkB;EmChUlB,qBnCgUkB;AD68HtB;AoC1wIE;EACE,cnCvCO;EmCwCP,oBAAA;EAEA,YAAA;EACA,6BnCuzBqB;EmCtzBrB,qBnC/CO;AD0zIX;;AqCt0IE;EACE,uBAAA;EACA,qBpC+YW;EoC9YX,qBpCgDa;ADyxIjB;AqCp0IM;E3BoBF,iCTqUe;ESpUf,oCToUe;AD++HnB;AqCn0IM;E3BCF,kCTmVe;ESlVf,qCTkVe;ADm/HnB;;AqCp1IE;EACE,uBAAA;EACA,0BpCgZW;EoC/YX,gBpCiDa;ADsyIjB;AqCl1IM;E3BoBF,iCTsUe;ESrUf,oCTqUe;AD4/HnB;AqCj1IM;E3BCF,kCToVe;ESnVf,qCTmVe;ADggInB;;AsCh2IA;EACE,qBAAA;EACA,uBAAA;EACA,qBrC8Ya;EqC7Yb,gBrCyZuB;EqCxZvB,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E5BTE,sBT8VY;AD+gIhB;AsCh2IE;EACE,aAAA;AtCk2IJ;;AsC71IA;EACE,kBAAA;EACA,SAAA;AtCg2IF;;AsCz1IA;EACE,sBrCwzBqB;EqCvzBrB,qBrCuzBqB;ESr1BnB,uBT+Ve;AD4hInB;;AsCp1IE;EC1CA,cAAA;EACA,yBnCiFa;AJizIf;AKp3IE;EkCVI,cAAA;EACA,qBAAA;EACA,qEAAA;AvCi4IN;;AsC91IE;EC1CA,cAAA;EACA,yBnCiFa;AJ2zIf;AK93IE;EkCVI,cAAA;EACA,qBAAA;EACA,qEAAA;AvC24IN;;AsCx2IE;EC1CA,cAAA;EACA,yBnCiFa;AJq0If;AKx4IE;EkCVI,cAAA;EACA,qBAAA;EACA,wDAAA;AvCq5IN;;AsCl3IE;EC1CA,cAAA;EACA,yBnCiFa;AJ+0If;AKl5IE;EkCVI,cAAA;EACA,qBAAA;EACA,oEAAA;AvC+5IN;;AsC53IE;EC1CA,cAAA;EACA,yBnCiFa;AJy1If;AK55IE;EkCVI,cAAA;EACA,qBAAA;EACA,2DAAA;AvCy6IN;;AsCt4IE;EC1CA,cAAA;EACA,yBnCiFa;AJm2If;AKt6IE;EkCVI,cAAA;EACA,qBAAA;EACA,qEAAA;AvCm7IN;;AsCh5IE;EC1CA,cAAA;EACA,yBnCiFa;AJ62If;AKh7IE;EkCVI,cAAA;EACA,qBAAA;EACA,qEAAA;AvC67IN;;AsC15IE;EC1CA,cAAA;EACA,yBnCiFa;AJu3If;AK17IE;EkCVI,cAAA;EACA,qBAAA;EACA,kEAAA;AvCu8IN;;AsCp6IE;EC1CA,cAAA;EACA,yBnCiFa;AJi4If;AKp8IE;EkCVI,cAAA;EACA,qBAAA;EACA,oEAAA;AvCi9IN;;AsC96IE;EC1CA,cAAA;EACA,yBnCiFa;AJ24If;AK98IE;EkCVI,cAAA;EACA,qBAAA;EACA,oCAAA;AvC29IN;;AsCx7IE;EC1CA,cAAA;EACA,yBnCiFa;AJq5If;AKx9IE;EkCVI,cAAA;EACA,qBAAA;EACA,oCAAA;AvCq+IN;;AsCl8IE;EC1CA,cAAA;EACA,uBnCiFa;AJ+5If;AKl+IE;EkCVI,cAAA;EACA,qBAAA;EACA,uBAAA;AvC++IN;;AwCv/IA;EACE,kBAAA;EACA,mBpCgsBkC;EoC/rBlC,yBvCWS;ESVP,wBTgWe;AD0pInB;Ael8II;EyB5DJ;IAOI,kBAAA;ExC2/IF;AACF;;AwCx/IA;EACE,gBAAA;EACA,eAAA;E9BTE,gB8BUqB;AxC2/IzB;;AyCrgJA;EACE,kBAAA;EACA,uBAAA;EACA,mBrCmzBkC;EqClzBlC,mCAAA;E/BJE,wBTiWe;AD4qInB;;AyCpgJA;EAEE,cAAA;AzCsgJF;;AyClgJA;EACE,gBxC6YiB;ADwnInB;;AyC7/IA;EACE,wBAAA;AzCggJF;AyC7/IE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,uBAAA;EACA,cAAA;AzC+/IJ;;AyCr/IE;EC9CA,cD+CqH;EnB1CnH,qEmB0CuB;EC7CzB,iED6CqE;AzC0/IvE;A0CriJE;EACE,qEAAA;A1CuiJJ;A0CpiJE;EACE,0DAAA;A1CsiJJ;;AyCjgJE;EC9CA,cD+CqH;EnB1CnH,qEmB0CuB;EC7CzB,iED6CqE;AzCsgJvE;A0CjjJE;EACE,oEAAA;A1CmjJJ;A0ChjJE;EACE,0DAAA;A1CkjJJ;;AyC7gJE;EC9CA,cD+CqH;EnB1CnH,0DmB0CuB;EC7CzB,sDD6CqE;AzCkhJvE;A0C7jJE;EACE,mEAAA;A1C+jJJ;A0C5jJE;EACE,6CAAA;A1C8jJJ;;AyCzhJE;EC9CA,cD+CqH;EnB1CnH,qEmB0CuB;EC7CzB,iED6CqE;AzC8hJvE;A0CzkJE;EACE,oEAAA;A1C2kJJ;A0CxkJE;EACE,yDAAA;A1C0kJJ;;AyCriJE;EC9CA,cD+CqH;EnB1CnH,2DmB0CuB;EC7CzB,uDD6CqE;AzC0iJvE;A0CrlJE;EACE,2DAAA;A1CulJJ;A0CplJE;EACE,gDAAA;A1CslJJ;;AyCjjJE;EC9CA,cD+CqH;EnB1CnH,qEmB0CuB;EC7CzB,iED6CqE;AzCsjJvE;A0CjmJE;EACE,qEAAA;A1CmmJJ;A0ChmJE;EACE,0DAAA;A1CkmJJ;;AyC7jJE;EC9CA,cD+CqH;EnB1CnH,qEmB0CuB;EC7CzB,iED6CqE;AzCkkJvE;A0C7mJE;EACE,mEAAA;A1C+mJJ;A0C5mJE;EACE,0DAAA;A1C8mJJ;;AyCzkJE;EC9CA,cD+CqH;EnB1CnH,qEmB0CuB;EC7CzB,iED6CqE;AzC8kJvE;A0CznJE;EACE,qEAAA;A1C2nJJ;A0CxnJE;EACE,uDAAA;A1C0nJJ;;AyCrlJE;EC9CA,cD+CqH;EnB1CnH,qEmB0CuB;EC7CzB,iED6CqE;AzC0lJvE;A0CroJE;EACE,qEAAA;A1CuoJJ;A0CpoJE;EACE,yDAAA;A1CsoJJ;;AyCjmJE;EC9CA,YD+CqH;EnB1CnH,uBmB0CuB;EC7CzB,mBD6CqE;AzCsmJvE;A0CjpJE;EACE,oCAAA;A1CmpJJ;A0ChpJE;EACE,yBAAA;A1CkpJJ;;AyC7mJE;EC9CA,YD+CqH;EnB1CnH,uBmB0CuB;EC7CzB,mBD6CqE;AzCknJvE;A0C7pJE;EACE,oCAAA;A1C+pJJ;A0C5pJE;EACE,yBAAA;A1C8pJJ;;AyCznJE;EC9CA,YD+CqH;EnB1CnH,oCmB0CuB;EC7CzB,gCD6CqE;AzC8nJvE;A0CzqJE;EACE,oCAAA;A1C2qJJ;A0CxqJE;EACE,YAAA;A1C0qJJ;;A2CprJA;EACE;IAAO,6BAAA;E3CwrJP;E2CvrJA;IAAK,wBAAA;E3C0rJL;AACF;A2CxrJA;EACE,aAAA;EACA,c1C66BgB;E0C56BhB,gBAAA;EACA,qBvC8zBkC;EuC7zBlC,oC1C26BY;ESj7BV,uBT+Ve;EUjWf,8CgCUF;A3C0rJF;;A2CvrJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,c1CPM;E0CQN,kBAAA;EACA,mBAAA;EACA,yBvCszBkC;EgBv0B9B,2BuBkBJ;A3C0rJF;AoBxsJE;EuBMF;IvBLI,gBAAA;EpB2sJF;AACF;;A2C5rJA;ErBiBE,qMAAA;EqBfA,8BAAA;A3C+rJF;;A2C5rJA;EACE,kDAAA;A3C+rJF;;A4C/tJA;EACE,aAAA;EACA,uBAAA;A5CkuJF;;A4C/tJA;EACE,SAAA;A5CkuJF;;A6CpuJA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;A7CquJF;;A6C5tJA;EACE,WAAA;EACA,c5CFS;E4CGT,mBAAA;A7C+tJF;AKruJE;EwCUE,c5CPO;E4CQP,qBAAA;EACA,yB5CfO;AD6uJX;A6C3tJE;EACE,c5CbO;E4CcP,yB5CnBO;ADgvJX;;A6CptJA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EAEA,yBAAA;EACA,yB5CpCM;E4CqCN,+BAAA;A7CstJF;A6CptJE;EnCzCE,+BTwVY;ESvVZ,gCTuVY;ADy6IhB;A6CptJE;EACE,gBAAA;EnChCA,mCT0UY;ESzUZ,kCTyUY;AD86IhB;AKhwJE;EwC6CE,UAAA;EACA,qBAAA;A7CstJJ;A6CntJE;EAEE,c5CjDO;E4CkDP,yB5CxDI;AD4wJR;A6ChtJE;EACE,UAAA;EACA,c5C9DI;E4C+DJ,yB5C0SkB;E4CzSlB,qB5CySkB;ADy6ItB;;A6CvsJE;EACE,eAAA;EACA,cAAA;EnCrFA,gBmCsFuB;A7C0sJ3B;A6CtsJI;EACE,aAAA;A7CwsJN;A6CnsJI;EACE,gBAAA;A7CqsJN;;A8CvyJE;EACE,0DD6GsE;EC5GtE,qED4GuC;A7C8rJ3C;AK/xJE;EyCPM,0DDwGkE;ECvGlE,qEAAA;A9CyyJR;A8CtyJM;EACE,c7CFA;E6CGA,qEDkGkE;ECjGlE,iEDiGkE;A7CusJ1E;;A8CrzJE;EACE,0DD6GsE;EC5GtE,qED4GuC;A7C4sJ3C;AK7yJE;EyCPM,0DDwGkE;ECvGlE,qEAAA;A9CuzJR;A8CpzJM;EACE,c7CFA;E6CGA,qEDkGkE;ECjGlE,iEDiGkE;A7CqtJ1E;;A8Cn0JE;EACE,gDD6GsE;EC5GtE,0DD4GuC;A7C0tJ3C;AK3zJE;EyCPM,gDDwGkE;ECvGlE,qEAAA;A9Cq0JR;A8Cl0JM;EACE,c7CFA;E6CGA,2DDkGkE;ECjGlE,uDDiGkE;A7CmuJ1E;;A8Cj1JE;EACE,0DD6GsE;EC5GtE,oED4GuC;A7CwuJ3C;AKz0JE;EyCPM,0DDwGkE;ECvGlE,kEAAA;A9Cm1JR;A8Ch1JM;EACE,c7CFA;E6CGA,qEDkGkE;ECjGlE,iEDiGkE;A7CivJ1E;;A8C/1JE;EACE,iDD6GsE;EC5GtE,2DD4GuC;A7CsvJ3C;AKv1JE;EyCPM,iDDwGkE;ECvGlE,2DAAA;A9Ci2JR;A8C91JM;EACE,c7CFA;E6CGA,4DDkGkE;ECjGlE,wDDiGkE;A7C+vJ1E;;A8C72JE;EACE,iDD6GsE;EC5GtE,qED4GuC;A7CowJ3C;AKr2JE;EyCPM,iDDwGkE;ECvGlE,qEAAA;A9C+2JR;A8C52JM;EACE,c7CFA;E6CGA,4DDkGkE;ECjGlE,wDDiGkE;A7C6wJ1E;;A8C33JE;EACE,0DD6GsE;EC5GtE,qED4GuC;A7CkxJ3C;AKn3JE;EyCPM,0DDwGkE;ECvGlE,oEAAA;A9C63JR;A8C13JM;EACE,c7CFA;E6CGA,qEDkGkE;ECjGlE,iEDiGkE;A7C2xJ1E;;A8Cz4JE;EACE,0DD6GsE;EC5GtE,oED4GuC;A7CgyJ3C;AKj4JE;EyCPM,0DDwGkE;ECvGlE,oEAAA;A9C24JR;A8Cx4JM;EACE,c7CFA;E6CGA,qEDkGkE;ECjGlE,iEDiGkE;A7CyyJ1E;;A8Cv5JE;EACE,0DD6GsE;EC5GtE,qED4GuC;A7C8yJ3C;AK/4JE;EyCPM,0DDwGkE;ECvGlE,qEAAA;A9Cy5JR;A8Ct5JM;EACE,c7CFA;E6CGA,qEDkGkE;ECjGlE,iEDiGkE;A7CuzJ1E;;A8Cr6JE;EACE,iDD6GsE;EC5GtE,uBD4GuC;A7C4zJ3C;AK75JE;EyCPM,iDDwGkE;ECvGlE,oCAAA;A9Cu6JR;A8Cp6JM;EACE,c7CFA;E6CGA,4DDkGkE;ECjGlE,wDDiGkE;A7Cq0J1E;;A8Cn7JE;EACE,iDD6GsE;EC5GtE,uBD4GuC;A7C00J3C;AK36JE;EyCPM,iDDwGkE;ECvGlE,oCAAA;A9Cq7JR;A8Cl7JM;EACE,c7CFA;E6CGA,4DDkGkE;ECjGlE,wDDiGkE;A7Cm1J1E;;A8Cj8JE;EACE,+CD6GsE;EC5GtE,oCD4GuC;A7Cw1J3C;AKz7JE;EyCPM,+CDwGkE;ECvGlE,oCAAA;A9Cm8JR;A8Ch8JM;EACE,c7CFA;E6CGA,0DDkGkE;ECjGlE,sDDiGkE;A7Ci2J1E;;A+Cl9JA;EACE,YAAA;EACA,oB9CuyBgB;E8CtyBhB,gB9C8ZiB;E8C7ZjB,cAAA;EACA,yB9CwyBY;E8CvyBZ,iB9CyyBkB;E8CxyBlB,YAAA;A/Cq9JF;AK58JE;E0CJI,yB9CiyBQ;E8ChyBR,qBAAA;EACA,aAAA;A/Cm9JN;A+Cx9JE;EASE,eAAA;A/Ck9JJ;;A+Cx8JA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;EACA,wBAAA;A/C28JF;;AgDr+JA;EAEE,gBAAA;AhDu+JF;AgDr+JE;EACE,kBAAA;EACA,gBAAA;AhDu+JJ;;AgDl+JA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a5CilBkC;E4ChlBlC,aAAA;EACA,gBAAA;EAGA,UAAA;AhDm+JF;;AgD59JA;EACE,kBAAA;EACA,WAAA;EACA,c5CmvBkC;E4CjvBlC,oBAAA;AhD89JF;AgD39JE;E5BtCI,mC4BuCF;AhD69JJ;AoBhgKE;E4BkCA;I5BjCE,gBAAA;EpBmgKF;AACF;AgDn+JE;EAEE,6BAAA;AhDo+JJ;AgDl+JE;EACE,0BAAA;AhDo+JJ;;AgDh+JA;EACE,aAAA;EACA,mBAAA;EACA,mCAAA;AhDm+JF;AgDh+JE;EACE,cAAA;EACA,gCAAA;EACA,WAAA;AhDk+JJ;;AgD79JA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,oBAAA;EACA,yB/C7DM;E+C8DN,4BAAA;EACA,uCAAA;EtCvEE,wBTiWe;EUnWf,gDqC2EF;EAEA,UAAA;AhD89JF;;AgD19JA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a5C8gBkC;E4C7gBlC,yB/CaM;ADg9JR;AgD19JE;EAAS,UAAA;AhD69JX;AgD59JE;EAAS,a/C60Bc;ADkpIzB;;AgD19JA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,yB/Cy0BqB;E+Cx0BrB,gCAAA;EtC9FE,iCT2Ve;ES1Vf,kCT0Ve;ADkuJnB;AgD59JE;EACE,yB/Co0BmB;E+Cl0BnB,kEAAA;AhD69JJ;;AgDx9JA;EACE,gBAAA;EACA,gB/C6yBwB;AD8qI1B;;AgDt9JA;EACE,kBAAA;EAGA,cAAA;EACA,4B/C8xBoB;ADyrItB;;AgDn9JA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,4B/CsxBoB;E+CrxBpB,6BAAA;AhDs9JF;AgDn9JE;EAAuB,oBAAA;AhDs9JzB;AgDr9JE;EAAsB,qBAAA;AhDw9JxB;;AgDp9JA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AhDu9JF;;AehjKI;EiC+FF;IACE,gB/CowBO;I+CnwBP,oBAAA;EhDq9JF;EgDl9JA;IACE,oCAAA;EhDo9JF;EgDl9JE;IACE,iCAAA;EhDo9JJ;EgD/8JA;IrCvKE,6EqCwKA;EhDi9JF;EgD98JA;IAAY,gB/CovBH;ED6tIT;AACF;AenkKI;EiCsHF;IAAY,c/C6uBH;EDouIT;AACF;AiDnoKA;EACE,kBAAA;EACA,a7CumBkC;E6CtmBlC,cAAA;EACA,ShDg5Be;EiDp5Bf,kCjD4YiB;EiD1YjB,kBAAA;EACA,gBjD4ZmB;EiD3ZnB,gB9CmQ4B;E8ClQ5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EDNA,0BhD4Ya;EgD1Yb,qBAAA;EACA,UAAA;AjD+oKF;AiD7oKE;EAAS,YhDo4BO;AD4wIlB;AiD9oKE;EACE,kBAAA;EACA,cAAA;EACA,ahDo4BkB;EgDn4BlB,chDo4BmB;AD4wIvB;AiD9oKI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AjDgpKN;;AiD3oKA;EACE,iBAAA;AjD8oKF;AiD5oKE;EACE,SAAA;AjD8oKJ;AiD5oKI;EACE,MAAA;EACA,6BAAA;EACA,yBhD5BE;AD0qKR;;AiDzoKA;EACE,iBAAA;AjD4oKF;AiD1oKE;EACE,OAAA;EACA,ahDs2BmB;EgDr2BnB,chDo2BkB;ADwyItB;AiD1oKI;EACE,QAAA;EACA,oCAAA;EACA,2BhD5CE;ADwrKR;;AiDvoKA;EACE,iBAAA;AjD0oKF;AiDxoKE;EACE,MAAA;AjD0oKJ;AiDxoKI;EACE,SAAA;EACA,6BAAA;EACA,4BhD1DE;ADosKR;;AiDroKA;EACE,iBAAA;AjDwoKF;AiDtoKE;EACE,QAAA;EACA,ahDw0BmB;EgDv0BnB,chDs0BkB;ADk0ItB;AiDtoKI;EACE,OAAA;EACA,oCAAA;EACA,0BhD1EE;ADktKR;;AiDnnKA;EACE,gBhDkyBkB;EgDjyBlB,uBAAA;EACA,chDPM;EgDQN,kBAAA;EACA,yBhDpGM;ESRJ,sBT8VY;ADq4JhB;;AmDvuKA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,a/CqmBkC;E+CpmBlC,cAAA;EACA,gBlD+yBkB;EiDpzBlB,kCjD4YiB;EiD1YjB,kBAAA;EACA,gBjD4ZmB;EiD3ZnB,gB9CmQ4B;E8ClQ5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;ECLA,0BlD2Ya;EkDzYb,qBAAA;EACA,yBlDDM;EkDEN,4BAAA;EACA,wCAAA;EzCXE,wBTgWe;EUlWf,qDwCeF;AnDovKF;AmDlvKE;EACE,kBAAA;EACA,cAAA;EACA,alD8yBkB;EkD7yBlB,elD8yBmB;EkD7yBnB,mBAAA;AnDovKJ;AmDlvKI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnDmvKN;;AmD9uKA;EACE,sBlD+xBqB;ADk9IvB;AmD/uKE;EACE,kCAAA;AnDivKJ;AmD9uKE;;;EAEE,+BAAA;AnDivKJ;AmD9uKE;EACE,SAAA;EACA,6BlDqxBwB;AD29I5B;AmD7uKE;EACE,WlD+vBmB;EkD9vBnB,yBlD5CI;AD2xKR;;AmD3uKA;EACE,oBlDwwBqB;ADs+IvB;AmD5uKE;EACE,gCAAA;EACA,clDowBmB;EkDnwBnB,clDkwBkB;EkDjwBlB,mBAAA;AnD8uKJ;AmD3uKE;;;EAEE,uCAAA;AnD8uKJ;AmD3uKE;EACE,OAAA;EACA,+BlD2vBwB;ADk/I5B;AmD1uKE;EACE,SlDquBmB;EkDpuBnB,2BlDtEI;ADkzKR;;AmDxuKA;EACE,mBlD8uBqB;AD6/IvB;AmDzuKE;EACE,+BAAA;AnD2uKJ;AmDxuKE;;;EAEE,uCAAA;AnD2uKJ;AmDxuKE;EACE,MAAA;EACA,gClDouBwB;ADsgJ5B;AmDvuKE;EACE,QlD8sBmB;EkD7sBnB,4BlD7FI;ADs0KR;AmDruKE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,alDktBkB;EkDjtBlB,qBAAA;EACA,WAAA;EACA,gCAAA;AnDuuKJ;;AmDnuKA;EACE,qBlD2sBqB;AD2hJvB;AmDpuKE;EACE,iCAAA;EACA,clDusBmB;EkDtsBnB,clDqsBkB;EkDpsBlB,mBAAA;AnDsuKJ;AmDnuKE;;;EAEE,uCAAA;AnDsuKJ;AmDnuKE;EACE,QAAA;EACA,8BlD8rBwB;ADuiJ5B;AmDluKE;EACE,UlDwqBmB;EkDvqBnB,0BlDnII;ADu2KR;;AmD/sKA;EACE,wBAAA;EACA,gBAAA;EACA,mBlDyOe;EkDxOf,clDpJS;EkDqJT,yBlD7JM;EkD8JN,2CAAA;EzChKE,6CyCiKoB;EzChKpB,8CyCgKoB;AnDmtKxB;AmDhtKE;EACE,aAAA;AnDktKJ;;AmD9sKA;EACE,wBAAA;EACA,clDlKS;ADm3KX;;AoD53KA;EACE,kBAAA;ApD+3KF;;AoD53KA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;ApD+3KF;;AoD53KA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,2BAAA;EACA,mBAAA;ApD+3KF;;AoD53KA;;;EAGE,cAAA;EhC3BI,+BgC4BJ;ApD+3KF;AoBv5KE;EgCoBF;;;IhCnBI,gBAAA;EpB45KF;AACF;;AoDn4KA;;EAEE,kBAAA;EACA,MAAA;ApDs4KF;;AoDn4KA;;EAEE,wBAAA;ApDs4KF;AoDp4KE;EAJF;;IAKI,+BAAA;EpDw4KF;AACF;;AoDr4KA;;EAEE,2BAAA;ApDw4KF;AoDt4KE;EAJF;;IAKI,kCAAA;EpD04KF;AACF;;AoDv4KA;;EAEE,4BAAA;ApD04KF;AoDx4KE;EAJF;;IAKI,mCAAA;EpD44KF;AACF;;AoDn4KE;EACE,UAAA;EACA,yBAAA;EACA,4BAAA;ApDs4KJ;AoDn4KE;;;EAGE,UAAA;ApDq4KJ;AoDl4KE;;EAEE,UAAA;ApDo4KJ;AoDj4KE;;;;;EAKE,wBAAA;ApDm4KJ;AoDj4KI;EAPF;;;;;IAQI,+BAAA;EpDw4KJ;AACF;;AoD/3KA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDqxBkC;EgDpxBlC,cnD5GM;EmD6GN,kBAAA;EACA,YhDmxBkC;AJ8mJpC;AK3+KE;;;E+CgHE,cnDpHI;EmDqHJ,qBAAA;EACA,UAAA;EACA,YAAA;ApDg4KJ;;AoD73KA;EACE,OAAA;ApDg4KF;;AoD33KA;EACE,QAAA;ApD83KF;;AoDv3KA;;EAEE,qBAAA;EACA,WhDgwBkC;EgD/vBlC,YhD+vBkC;EgD9vBlC,+CAAA;EACA,0BAAA;ApD03KF;;AoDx3KA;EACE,yDhD4vBkC;AJ+nJpC;;AoDz3KA;EACE,yDhD0vBkC;AJkoJpC;;AoDn3KA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iBhDytBkC;EgDxtBlC,gBhDwtBkC;EgDvtBlC,gBAAA;ApDq3KF;AoDn3KE;EACE,kBAAA;EACA,cAAA;EACA,WhDqtBgC;EgDptBhC,WhDqtBgC;EgDptBhC,iBhDqtBgC;EgDptBhC,gBhDotBgC;EgDntBhC,mBAAA;EACA,eAAA;EACA,0CAAA;ApDq3KJ;AoDl3KI;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;ApDo3KN;AoDl3KI;EACE,kBAAA;EACA,aAAA;EACA,OAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;ApDo3KN;AoDh3KE;EACE,yBnD5MI;AD8jLR;;AoDz2KA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,cnD7NM;EmD8NN,kBAAA;ApD42KF;;AqDplLA;EAAqB,mCAAA;ArDwlLrB;;AqDvlLA;EAAqB,8BAAA;ArD2lLrB;;AqD1lLA;EAAqB,iCAAA;ArD8lLrB;;AqD7lLA;EAAqB,iCAAA;ArDimLrB;;AqDhmLA;EAAqB,sCAAA;ArDomLrB;;AqDnmLA;EAAqB,mCAAA;ArDumLrB;;AsDzmLE;EACE,oCAAA;AtD4mLJ;;AKlmLE;;;EiDLI,gFAAA;AtD6mLN;;AsDnnLE;EACE,oCAAA;AtDsnLJ;;AK5mLE;;;EiDLI,gFAAA;AtDunLN;;AsD7nLE;EACE,oCAAA;AtDgoLJ;;AKtnLE;;;EiDLI,mEAAA;AtDioLN;;AsDvoLE;EACE,oCAAA;AtD0oLJ;;AKhoLE;;;EiDLI,+EAAA;AtD2oLN;;AsDjpLE;EACE,oCAAA;AtDopLJ;;AK1oLE;;;EiDLI,sEAAA;AtDqpLN;;AsD3pLE;EACE,oCAAA;AtD8pLJ;;AKppLE;;;EiDLI,gFAAA;AtD+pLN;;AsDrqLE;EACE,oCAAA;AtDwqLJ;;AK9pLE;;;EiDLI,gFAAA;AtDyqLN;;AsD/qLE;EACE,oCAAA;AtDkrLJ;;AKxqLE;;;EiDLI,6EAAA;AtDmrLN;;AsDzrLE;EACE,oCAAA;AtD4rLJ;;AKlrLE;;;EiDLI,+EAAA;AtD6rLN;;AsDnsLE;EACE,oCAAA;AtDssLJ;;AK5rLE;;;EiDLI,+CAAA;AtDusLN;;AsD7sLE;EACE,oCAAA;AtDgtLJ;;AKtsLE;;;EiDLI,+CAAA;AtDitLN;;AsDvtLE;EACE,kCAAA;AtD0tLJ;;AKhtLE;;;EiDLI,kCAAA;AtD2tLN;;AuD1tLA;EACE,oCAAA;AvD6tLF;;AuD1tLA;EACE,wCAAA;AvD6tLF;;AwDxuLA;EAAkB,0CAAA;AxD4uLlB;;AwD3uLA;EAAkB,8CAAA;AxD+uLlB;;AwD9uLA;EAAkB,gDAAA;AxDkvLlB;;AwDjvLA;EAAkB,iDAAA;AxDqvLlB;;AwDpvLA;EAAkB,+CAAA;AxDwvLlB;;AwDtvLA;EAAmB,oBAAA;AxD0vLnB;;AwDzvLA;EAAmB,wBAAA;AxD6vLnB;;AwD5vLA;EAAmB,0BAAA;AxDgwLnB;;AwD/vLA;EAAmB,2BAAA;AxDmwLnB;;AwDlwLA;EAAmB,yBAAA;AxDswLnB;;AwDnwLE;EACE,gCAAA;AxDswLJ;;AwDvwLE;EACE,gCAAA;AxD0wLJ;;AwD3wLE;EACE,gCAAA;AxD8wLJ;;AwD/wLE;EACE,gCAAA;AxDkxLJ;;AwDnxLE;EACE,gCAAA;AxDsxLJ;;AwDvxLE;EACE,gCAAA;AxD0xLJ;;AwD3xLE;EACE,gCAAA;AxD8xLJ;;AwD/xLE;EACE,gCAAA;AxDkyLJ;;AwDnyLE;EACE,gCAAA;AxDsyLJ;;AwDvyLE;EACE,gCAAA;AxD0yLJ;;AwD3yLE;EACE,gCAAA;AxD8yLJ;;AwD/yLE;EACE,8BAAA;AxDkzLJ;;AwD9yLA;EACE,gCAAA;AxDizLF;;AwD1yLA;EACE,iCAAA;AxD6yLF;;AwD3yLA;EACE,0CAAA;EACA,2CAAA;AxD8yLF;;AwD5yLA;EACE,2CAAA;EACA,8CAAA;AxD+yLF;;AwD7yLA;EACE,8CAAA;EACA,6CAAA;AxDgzLF;;AwD9yLA;EACE,0CAAA;EACA,6CAAA;AxDizLF;;AwD9yLA;EACE,6BAAA;AxDizLF;;AwD9yLA;EACE,2BAAA;AxDizLF;;AyDz2LE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AzD42LJ;;A0Dt2LI;EAA2B,wBAAA;A1D02L/B;;A0Dz2LI;EAA2B,0BAAA;A1D62L/B;;A0D52LI;EAA2B,gCAAA;A1Dg3L/B;;A0D/2LI;EAA2B,yBAAA;A1Dm3L/B;;A0Dl3LI;EAA2B,yBAAA;A1Ds3L/B;;A0Dr3LI;EAA2B,6BAAA;A1Dy3L/B;;A0Dx3LI;EAA2B,8BAAA;A1D43L/B;;A0D33LI;EAA2B,wBAAA;A1D+3L/B;;A0D93LI;EAA2B,+BAAA;A1Dk4L/B;;Aex1LI;E2ClDA;IAA2B,wBAAA;E1D+4L7B;E0D94LE;IAA2B,0BAAA;E1Di5L7B;E0Dh5LE;IAA2B,gCAAA;E1Dm5L7B;E0Dl5LE;IAA2B,yBAAA;E1Dq5L7B;E0Dp5LE;IAA2B,yBAAA;E1Du5L7B;E0Dt5LE;IAA2B,6BAAA;E1Dy5L7B;E0Dx5LE;IAA2B,8BAAA;E1D25L7B;E0D15LE;IAA2B,wBAAA;E1D65L7B;E0D55LE;IAA2B,+BAAA;E1D+5L7B;AACF;Aet3LI;E2ClDA;IAA2B,wBAAA;E1D46L7B;E0D36LE;IAA2B,0BAAA;E1D86L7B;E0D76LE;IAA2B,gCAAA;E1Dg7L7B;E0D/6LE;IAA2B,yBAAA;E1Dk7L7B;E0Dj7LE;IAA2B,yBAAA;E1Do7L7B;E0Dn7LE;IAA2B,6BAAA;E1Ds7L7B;E0Dr7LE;IAA2B,8BAAA;E1Dw7L7B;E0Dv7LE;IAA2B,wBAAA;E1D07L7B;E0Dz7LE;IAA2B,+BAAA;E1D47L7B;AACF;Aen5LI;E2ClDA;IAA2B,wBAAA;E1Dy8L7B;E0Dx8LE;IAA2B,0BAAA;E1D28L7B;E0D18LE;IAA2B,gCAAA;E1D68L7B;E0D58LE;IAA2B,yBAAA;E1D+8L7B;E0D98LE;IAA2B,yBAAA;E1Di9L7B;E0Dh9LE;IAA2B,6BAAA;E1Dm9L7B;E0Dl9LE;IAA2B,8BAAA;E1Dq9L7B;E0Dp9LE;IAA2B,wBAAA;E1Du9L7B;E0Dt9LE;IAA2B,+BAAA;E1Dy9L7B;AACF;Aeh7LI;E2ClDA;IAA2B,wBAAA;E1Ds+L7B;E0Dr+LE;IAA2B,0BAAA;E1Dw+L7B;E0Dv+LE;IAA2B,gCAAA;E1D0+L7B;E0Dz+LE;IAA2B,yBAAA;E1D4+L7B;E0D3+LE;IAA2B,yBAAA;E1D8+L7B;E0D7+LE;IAA2B,6BAAA;E1Dg/L7B;E0D/+LE;IAA2B,8BAAA;E1Dk/L7B;E0Dj/LE;IAA2B,wBAAA;E1Do/L7B;E0Dn/LE;IAA2B,+BAAA;E1Ds/L7B;AACF;A0D9+LA;EACE;IAAwB,wBAAA;E1Di/LxB;E0Dh/LA;IAAwB,0BAAA;E1Dm/LxB;E0Dl/LA;IAAwB,gCAAA;E1Dq/LxB;E0Dp/LA;IAAwB,yBAAA;E1Du/LxB;E0Dt/LA;IAAwB,yBAAA;E1Dy/LxB;E0Dx/LA;IAAwB,6BAAA;E1D2/LxB;E0D1/LA;IAAwB,8BAAA;E1D6/LxB;E0D5/LA;IAAwB,wBAAA;E1D+/LxB;E0D9/LA;IAAwB,+BAAA;E1DigMxB;AACF;A2DpiMA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;A3DsiMF;A2DpiME;EACE,cAAA;EACA,WAAA;A3DsiMJ;A2DniME;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A3DqiMJ;;A2DhiME;EACE,2BAAA;A3DmiMJ;;A2D9hME;EACE,mBAAA;A3DiiMJ;;A2D5hME;EACE,gBAAA;A3D+hMJ;;A2D1hME;EACE,iBAAA;A3D6hMJ;;A4DpkMI;EAAgC,8BAAA;A5DwkMpC;;A4DvkMI;EAAgC,iCAAA;A5D2kMpC;;A4D1kMI;EAAgC,sCAAA;A5D8kMpC;;A4D7kMI;EAAgC,yCAAA;A5DilMpC;;A4D/kMI;EAA8B,0BAAA;A5DmlMlC;;A4DllMI;EAA8B,4BAAA;A5DslMlC;;A4DrlMI;EAA8B,kCAAA;A5DylMlC;;A4DxlMI;EAA8B,yBAAA;A5D4lMlC;;A4D3lMI;EAA8B,uBAAA;A5D+lMlC;;A4D9lMI;EAA8B,uBAAA;A5DkmMlC;;A4DjmMI;EAA8B,yBAAA;A5DqmMlC;;A4DpmMI;EAA8B,yBAAA;A5DwmMlC;;A4DtmMI;EAAoC,sCAAA;A5D0mMxC;;A4DzmMI;EAAoC,oCAAA;A5D6mMxC;;A4D5mMI;EAAoC,kCAAA;A5DgnMxC;;A4D/mMI;EAAoC,yCAAA;A5DmnMxC;;A4DlnMI;EAAoC,wCAAA;A5DsnMxC;;A4DpnMI;EAAiC,kCAAA;A5DwnMrC;;A4DvnMI;EAAiC,gCAAA;A5D2nMrC;;A4D1nMI;EAAiC,8BAAA;A5D8nMrC;;A4D7nMI;EAAiC,gCAAA;A5DioMrC;;A4DhoMI;EAAiC,+BAAA;A5DooMrC;;A4DloMI;EAAkC,oCAAA;A5DsoMtC;;A4DroMI;EAAkC,kCAAA;A5DyoMtC;;A4DxoMI;EAAkC,gCAAA;A5D4oMtC;;A4D3oMI;EAAkC,uCAAA;A5D+oMtC;;A4D9oMI;EAAkC,sCAAA;A5DkpMtC;;A4DjpMI;EAAkC,iCAAA;A5DqpMtC;;A4DnpMI;EAAgC,2BAAA;A5DupMpC;;A4DtpMI;EAAgC,iCAAA;A5D0pMpC;;A4DzpMI;EAAgC,+BAAA;A5D6pMpC;;A4D5pMI;EAAgC,6BAAA;A5DgqMpC;;A4D/pMI;EAAgC,+BAAA;A5DmqMpC;;A4DlqMI;EAAgC,8BAAA;A5DsqMpC;;Ae1pMI;E6ClDA;IAAgC,8BAAA;E5DitMlC;E4DhtME;IAAgC,iCAAA;E5DmtMlC;E4DltME;IAAgC,sCAAA;E5DqtMlC;E4DptME;IAAgC,yCAAA;E5DutMlC;E4DrtME;IAA8B,0BAAA;E5DwtMhC;E4DvtME;IAA8B,4BAAA;E5D0tMhC;E4DztME;IAA8B,kCAAA;E5D4tMhC;E4D3tME;IAA8B,yBAAA;E5D8tMhC;E4D7tME;IAA8B,uBAAA;E5DguMhC;E4D/tME;IAA8B,uBAAA;E5DkuMhC;E4DjuME;IAA8B,yBAAA;E5DouMhC;E4DnuME;IAA8B,yBAAA;E5DsuMhC;E4DpuME;IAAoC,sCAAA;E5DuuMtC;E4DtuME;IAAoC,oCAAA;E5DyuMtC;E4DxuME;IAAoC,kCAAA;E5D2uMtC;E4D1uME;IAAoC,yCAAA;E5D6uMtC;E4D5uME;IAAoC,wCAAA;E5D+uMtC;E4D7uME;IAAiC,kCAAA;E5DgvMnC;E4D/uME;IAAiC,gCAAA;E5DkvMnC;E4DjvME;IAAiC,8BAAA;E5DovMnC;E4DnvME;IAAiC,gCAAA;E5DsvMnC;E4DrvME;IAAiC,+BAAA;E5DwvMnC;E4DtvME;IAAkC,oCAAA;E5DyvMpC;E4DxvME;IAAkC,kCAAA;E5D2vMpC;E4D1vME;IAAkC,gCAAA;E5D6vMpC;E4D5vME;IAAkC,uCAAA;E5D+vMpC;E4D9vME;IAAkC,sCAAA;E5DiwMpC;E4DhwME;IAAkC,iCAAA;E5DmwMpC;E4DjwME;IAAgC,2BAAA;E5DowMlC;E4DnwME;IAAgC,iCAAA;E5DswMlC;E4DrwME;IAAgC,+BAAA;E5DwwMlC;E4DvwME;IAAgC,6BAAA;E5D0wMlC;E4DzwME;IAAgC,+BAAA;E5D4wMlC;E4D3wME;IAAgC,8BAAA;E5D8wMlC;AACF;AenwMI;E6ClDA;IAAgC,8BAAA;E5DyzMlC;E4DxzME;IAAgC,iCAAA;E5D2zMlC;E4D1zME;IAAgC,sCAAA;E5D6zMlC;E4D5zME;IAAgC,yCAAA;E5D+zMlC;E4D7zME;IAA8B,0BAAA;E5Dg0MhC;E4D/zME;IAA8B,4BAAA;E5Dk0MhC;E4Dj0ME;IAA8B,kCAAA;E5Do0MhC;E4Dn0ME;IAA8B,yBAAA;E5Ds0MhC;E4Dr0ME;IAA8B,uBAAA;E5Dw0MhC;E4Dv0ME;IAA8B,uBAAA;E5D00MhC;E4Dz0ME;IAA8B,yBAAA;E5D40MhC;E4D30ME;IAA8B,yBAAA;E5D80MhC;E4D50ME;IAAoC,sCAAA;E5D+0MtC;E4D90ME;IAAoC,oCAAA;E5Di1MtC;E4Dh1ME;IAAoC,kCAAA;E5Dm1MtC;E4Dl1ME;IAAoC,yCAAA;E5Dq1MtC;E4Dp1ME;IAAoC,wCAAA;E5Du1MtC;E4Dr1ME;IAAiC,kCAAA;E5Dw1MnC;E4Dv1ME;IAAiC,gCAAA;E5D01MnC;E4Dz1ME;IAAiC,8BAAA;E5D41MnC;E4D31ME;IAAiC,gCAAA;E5D81MnC;E4D71ME;IAAiC,+BAAA;E5Dg2MnC;E4D91ME;IAAkC,oCAAA;E5Di2MpC;E4Dh2ME;IAAkC,kCAAA;E5Dm2MpC;E4Dl2ME;IAAkC,gCAAA;E5Dq2MpC;E4Dp2ME;IAAkC,uCAAA;E5Du2MpC;E4Dt2ME;IAAkC,sCAAA;E5Dy2MpC;E4Dx2ME;IAAkC,iCAAA;E5D22MpC;E4Dz2ME;IAAgC,2BAAA;E5D42MlC;E4D32ME;IAAgC,iCAAA;E5D82MlC;E4D72ME;IAAgC,+BAAA;E5Dg3MlC;E4D/2ME;IAAgC,6BAAA;E5Dk3MlC;E4Dj3ME;IAAgC,+BAAA;E5Do3MlC;E4Dn3ME;IAAgC,8BAAA;E5Ds3MlC;AACF;Ae32MI;E6ClDA;IAAgC,8BAAA;E5Di6MlC;E4Dh6ME;IAAgC,iCAAA;E5Dm6MlC;E4Dl6ME;IAAgC,sCAAA;E5Dq6MlC;E4Dp6ME;IAAgC,yCAAA;E5Du6MlC;E4Dr6ME;IAA8B,0BAAA;E5Dw6MhC;E4Dv6ME;IAA8B,4BAAA;E5D06MhC;E4Dz6ME;IAA8B,kCAAA;E5D46MhC;E4D36ME;IAA8B,yBAAA;E5D86MhC;E4D76ME;IAA8B,uBAAA;E5Dg7MhC;E4D/6ME;IAA8B,uBAAA;E5Dk7MhC;E4Dj7ME;IAA8B,yBAAA;E5Do7MhC;E4Dn7ME;IAA8B,yBAAA;E5Ds7MhC;E4Dp7ME;IAAoC,sCAAA;E5Du7MtC;E4Dt7ME;IAAoC,oCAAA;E5Dy7MtC;E4Dx7ME;IAAoC,kCAAA;E5D27MtC;E4D17ME;IAAoC,yCAAA;E5D67MtC;E4D57ME;IAAoC,wCAAA;E5D+7MtC;E4D77ME;IAAiC,kCAAA;E5Dg8MnC;E4D/7ME;IAAiC,gCAAA;E5Dk8MnC;E4Dj8ME;IAAiC,8BAAA;E5Do8MnC;E4Dn8ME;IAAiC,gCAAA;E5Ds8MnC;E4Dr8ME;IAAiC,+BAAA;E5Dw8MnC;E4Dt8ME;IAAkC,oCAAA;E5Dy8MpC;E4Dx8ME;IAAkC,kCAAA;E5D28MpC;E4D18ME;IAAkC,gCAAA;E5D68MpC;E4D58ME;IAAkC,uCAAA;E5D+8MpC;E4D98ME;IAAkC,sCAAA;E5Di9MpC;E4Dh9ME;IAAkC,iCAAA;E5Dm9MpC;E4Dj9ME;IAAgC,2BAAA;E5Do9MlC;E4Dn9ME;IAAgC,iCAAA;E5Ds9MlC;E4Dr9ME;IAAgC,+BAAA;E5Dw9MlC;E4Dv9ME;IAAgC,6BAAA;E5D09MlC;E4Dz9ME;IAAgC,+BAAA;E5D49MlC;E4D39ME;IAAgC,8BAAA;E5D89MlC;AACF;Aen9MI;E6ClDA;IAAgC,8BAAA;E5DygNlC;E4DxgNE;IAAgC,iCAAA;E5D2gNlC;E4D1gNE;IAAgC,sCAAA;E5D6gNlC;E4D5gNE;IAAgC,yCAAA;E5D+gNlC;E4D7gNE;IAA8B,0BAAA;E5DghNhC;E4D/gNE;IAA8B,4BAAA;E5DkhNhC;E4DjhNE;IAA8B,kCAAA;E5DohNhC;E4DnhNE;IAA8B,yBAAA;E5DshNhC;E4DrhNE;IAA8B,uBAAA;E5DwhNhC;E4DvhNE;IAA8B,uBAAA;E5D0hNhC;E4DzhNE;IAA8B,yBAAA;E5D4hNhC;E4D3hNE;IAA8B,yBAAA;E5D8hNhC;E4D5hNE;IAAoC,sCAAA;E5D+hNtC;E4D9hNE;IAAoC,oCAAA;E5DiiNtC;E4DhiNE;IAAoC,kCAAA;E5DmiNtC;E4DliNE;IAAoC,yCAAA;E5DqiNtC;E4DpiNE;IAAoC,wCAAA;E5DuiNtC;E4DriNE;IAAiC,kCAAA;E5DwiNnC;E4DviNE;IAAiC,gCAAA;E5D0iNnC;E4DziNE;IAAiC,8BAAA;E5D4iNnC;E4D3iNE;IAAiC,gCAAA;E5D8iNnC;E4D7iNE;IAAiC,+BAAA;E5DgjNnC;E4D9iNE;IAAkC,oCAAA;E5DijNpC;E4DhjNE;IAAkC,kCAAA;E5DmjNpC;E4DljNE;IAAkC,gCAAA;E5DqjNpC;E4DpjNE;IAAkC,uCAAA;E5DujNpC;E4DtjNE;IAAkC,sCAAA;E5DyjNpC;E4DxjNE;IAAkC,iCAAA;E5D2jNpC;E4DzjNE;IAAgC,2BAAA;E5D4jNlC;E4D3jNE;IAAgC,iCAAA;E5D8jNlC;E4D7jNE;IAAgC,+BAAA;E5DgkNlC;E4D/jNE;IAAgC,6BAAA;E5DkkNlC;E4DjkNE;IAAgC,+BAAA;E5DokNlC;E4DnkNE;IAAgC,8BAAA;E5DskNlC;AACF;A6DnnNI;ECDF,sBAAA;A9DunNF;;A6DrnNI;ECCF,uBAAA;A9DwnNF;;A6DxnNI;ECGF,sBAAA;A9DynNF;;AetkNI;E8CxDA;ICDF,sBAAA;E9DooNA;E6DloNE;ICCF,uBAAA;E9DooNA;E6DpoNE;ICGF,sBAAA;E9DooNA;AACF;AellNI;E8CxDA;ICDF,sBAAA;E9D+oNA;E6D7oNE;ICCF,uBAAA;E9D+oNA;E6D/oNE;ICGF,sBAAA;E9D+oNA;AACF;Ae7lNI;E8CxDA;ICDF,sBAAA;E9D0pNA;E6DxpNE;ICCF,uBAAA;E9D0pNA;E6D1pNE;ICGF,sBAAA;E9D0pNA;AACF;AexmNI;E8CxDA;ICDF,sBAAA;E9DqqNA;E6DnqNE;ICCF,uBAAA;E9DqqNA;E6DrqNE;ICGF,sBAAA;E9DqqNA;AACF;A+DtqNE;EAAyB,2BAAA;A/DyqN3B;;A+DzqNE;EAAyB,6BAAA;A/D6qN3B;;A+D7qNE;EAAyB,6BAAA;A/DirN3B;;A+DjrNE;EAAyB,0BAAA;A/DqrN3B;;A+DrrNE;EAAyB,2BAAA;A/DyrN3B;;A+DprNA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a3DmlBkC;AJomMpC;;A+DprNA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a3D2kBkC;AJ4mMpC;;A+DnrNE;EADF;IAEI,gBAAA;IACA,MAAA;IACA,a3DmkBgC;EJonMlC;AACF;;AgEttNA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AjEwtNF;;AiE9sNE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AjEgtNJ;;AkE5uNA;EAAa,iEAAA;AlEgvNb;;AkE/uNA;EAAU,wDAAA;AlEmvNV;;AkElvNA;EAAa,0DAAA;AlEsvNb;;AkErvNA;EAAe,2BAAA;AlEyvNf;;AmExvNI;EAAuB,qBAAA;AnE4vN3B;;AmE5vNI;EAAuB,qBAAA;AnEgwN3B;;AmEhwNI;EAAuB,qBAAA;AnEowN3B;;AmEpwNI;EAAuB,sBAAA;AnEwwN3B;;AmExwNI;EAAuB,sBAAA;AnE4wN3B;;AmE5wNI;EAAuB,sBAAA;AnEgxN3B;;AmEhxNI;EAAuB,sBAAA;AnEoxN3B;;AmEpxNI;EAAuB,sBAAA;AnEwxN3B;;AmExxNI;EAAuB,uBAAA;AnE4xN3B;;AmE5xNI;EAAuB,uBAAA;AnEgyN3B;;AmE5xNA;EAAU,0BAAA;AnEgyNV;;AmE/xNA;EAAU,2BAAA;AnEmyNV;;AoEnyNQ;EAAgC,oBAAA;ApEuyNxC;;AoEtyNQ;;EAEE,wBAAA;ApEyyNV;;AoEvyNQ;;EAEE,0BAAA;ApE0yNV;;AoExyNQ;;EAEE,2BAAA;ApE2yNV;;AoEzyNQ;;EAEE,yBAAA;ApE4yNV;;AoE3zNQ;EAAgC,0BAAA;ApE+zNxC;;AoE9zNQ;;EAEE,8BAAA;ApEi0NV;;AoE/zNQ;;EAEE,gCAAA;ApEk0NV;;AoEh0NQ;;EAEE,iCAAA;ApEm0NV;;AoEj0NQ;;EAEE,+BAAA;ApEo0NV;;AoEn1NQ;EAAgC,yBAAA;ApEu1NxC;;AoEt1NQ;;EAEE,6BAAA;ApEy1NV;;AoEv1NQ;;EAEE,+BAAA;ApE01NV;;AoEx1NQ;;EAEE,gCAAA;ApE21NV;;AoEz1NQ;;EAEE,8BAAA;ApE41NV;;AoE32NQ;EAAgC,uBAAA;ApE+2NxC;;AoE92NQ;;EAEE,2BAAA;ApEi3NV;;AoE/2NQ;;EAEE,6BAAA;ApEk3NV;;AoEh3NQ;;EAEE,8BAAA;ApEm3NV;;AoEj3NQ;;EAEE,4BAAA;ApEo3NV;;AoEn4NQ;EAAgC,yBAAA;ApEu4NxC;;AoEt4NQ;;EAEE,6BAAA;ApEy4NV;;AoEv4NQ;;EAEE,+BAAA;ApE04NV;;AoEx4NQ;;EAEE,gCAAA;ApE24NV;;AoEz4NQ;;EAEE,8BAAA;ApE44NV;;AoE35NQ;EAAgC,uBAAA;ApE+5NxC;;AoE95NQ;;EAEE,2BAAA;ApEi6NV;;AoE/5NQ;;EAEE,6BAAA;ApEk6NV;;AoEh6NQ;;EAEE,8BAAA;ApEm6NV;;AoEj6NQ;;EAEE,4BAAA;ApEo6NV;;AoEn7NQ;EAAgC,uBAAA;ApEu7NxC;;AoEt7NQ;;EAEE,2BAAA;ApEy7NV;;AoEv7NQ;;EAEE,6BAAA;ApE07NV;;AoEx7NQ;;EAEE,8BAAA;ApE27NV;;AoEz7NQ;;EAEE,4BAAA;ApE47NV;;AoE38NQ;EAAgC,uBAAA;ApE+8NxC;;AoE98NQ;;EAEE,2BAAA;ApEi9NV;;AoE/8NQ;;EAEE,6BAAA;ApEk9NV;;AoEh9NQ;;EAEE,8BAAA;ApEm9NV;;AoEj9NQ;;EAEE,4BAAA;ApEo9NV;;AoEn+NQ;EAAgC,uBAAA;ApEu+NxC;;AoEt+NQ;;EAEE,2BAAA;ApEy+NV;;AoEv+NQ;;EAEE,6BAAA;ApE0+NV;;AoEx+NQ;;EAEE,8BAAA;ApE2+NV;;AoEz+NQ;;EAEE,4BAAA;ApE4+NV;;AoE3/NQ;EAAgC,uBAAA;ApE+/NxC;;AoE9/NQ;;EAEE,2BAAA;ApEigOV;;AoE//NQ;;EAEE,6BAAA;ApEkgOV;;AoEhgOQ;;EAEE,8BAAA;ApEmgOV;;AoEjgOQ;;EAEE,4BAAA;ApEogOV;;AoEnhOQ;EAAgC,qBAAA;ApEuhOxC;;AoEthOQ;;EAEE,yBAAA;ApEyhOV;;AoEvhOQ;;EAEE,2BAAA;ApE0hOV;;AoExhOQ;;EAEE,4BAAA;ApE2hOV;;AoEzhOQ;;EAEE,0BAAA;ApE4hOV;;AoE3iOQ;EAAgC,2BAAA;ApE+iOxC;;AoE9iOQ;;EAEE,+BAAA;ApEijOV;;AoE/iOQ;;EAEE,iCAAA;ApEkjOV;;AoEhjOQ;;EAEE,kCAAA;ApEmjOV;;AoEjjOQ;;EAEE,gCAAA;ApEojOV;;AoEnkOQ;EAAgC,0BAAA;ApEukOxC;;AoEtkOQ;;EAEE,8BAAA;ApEykOV;;AoEvkOQ;;EAEE,gCAAA;ApE0kOV;;AoExkOQ;;EAEE,iCAAA;ApE2kOV;;AoEzkOQ;;EAEE,+BAAA;ApE4kOV;;AoE3lOQ;EAAgC,wBAAA;ApE+lOxC;;AoE9lOQ;;EAEE,4BAAA;ApEimOV;;AoE/lOQ;;EAEE,8BAAA;ApEkmOV;;AoEhmOQ;;EAEE,+BAAA;ApEmmOV;;AoEjmOQ;;EAEE,6BAAA;ApEomOV;;AoEnnOQ;EAAgC,0BAAA;ApEunOxC;;AoEtnOQ;;EAEE,8BAAA;ApEynOV;;AoEvnOQ;;EAEE,gCAAA;ApE0nOV;;AoExnOQ;;EAEE,iCAAA;ApE2nOV;;AoEznOQ;;EAEE,+BAAA;ApE4nOV;;AoE3oOQ;EAAgC,wBAAA;ApE+oOxC;;AoE9oOQ;;EAEE,4BAAA;ApEipOV;;AoE/oOQ;;EAEE,8BAAA;ApEkpOV;;AoEhpOQ;;EAEE,+BAAA;ApEmpOV;;AoEjpOQ;;EAEE,6BAAA;ApEopOV;;AoEnqOQ;EAAgC,wBAAA;ApEuqOxC;;AoEtqOQ;;EAEE,4BAAA;ApEyqOV;;AoEvqOQ;;EAEE,8BAAA;ApE0qOV;;AoExqOQ;;EAEE,+BAAA;ApE2qOV;;AoEzqOQ;;EAEE,6BAAA;ApE4qOV;;AoE3rOQ;EAAgC,wBAAA;ApE+rOxC;;AoE9rOQ;;EAEE,4BAAA;ApEisOV;;AoE/rOQ;;EAEE,8BAAA;ApEksOV;;AoEhsOQ;;EAEE,+BAAA;ApEmsOV;;AoEjsOQ;;EAEE,6BAAA;ApEosOV;;AoEntOQ;EAAgC,wBAAA;ApEutOxC;;AoEttOQ;;EAEE,4BAAA;ApEytOV;;AoEvtOQ;;EAEE,8BAAA;ApE0tOV;;AoExtOQ;;EAEE,+BAAA;ApE2tOV;;AoEztOQ;;EAEE,6BAAA;ApE4tOV;;AoE3uOQ;EAAgC,wBAAA;ApE+uOxC;;AoE9uOQ;;EAEE,4BAAA;ApEivOV;;AoE/uOQ;;EAEE,8BAAA;ApEkvOV;;AoEhvOQ;;EAEE,+BAAA;ApEmvOV;;AoEjvOQ;;EAEE,6BAAA;ApEovOV;;AoE9uOI;EAAmB,uBAAA;ApEkvOvB;;AoEjvOI;;EAEE,2BAAA;ApEovON;;AoElvOI;;EAEE,6BAAA;ApEqvON;;AoEnvOI;;EAEE,8BAAA;ApEsvON;;AoEpvOI;;EAEE,4BAAA;ApEuvON;;Ae1uOI;EqDjDI;IAAgC,oBAAA;EpEgyOtC;EoE/xOM;;IAEE,wBAAA;EpEiyOR;EoE/xOM;;IAEE,0BAAA;EpEiyOR;EoE/xOM;;IAEE,2BAAA;EpEiyOR;EoE/xOM;;IAEE,yBAAA;EpEiyOR;EoEhzOM;IAAgC,0BAAA;EpEmzOtC;EoElzOM;;IAEE,8BAAA;EpEozOR;EoElzOM;;IAEE,gCAAA;EpEozOR;EoElzOM;;IAEE,iCAAA;EpEozOR;EoElzOM;;IAEE,+BAAA;EpEozOR;EoEn0OM;IAAgC,yBAAA;EpEs0OtC;EoEr0OM;;IAEE,6BAAA;EpEu0OR;EoEr0OM;;IAEE,+BAAA;EpEu0OR;EoEr0OM;;IAEE,gCAAA;EpEu0OR;EoEr0OM;;IAEE,8BAAA;EpEu0OR;EoEt1OM;IAAgC,uBAAA;EpEy1OtC;EoEx1OM;;IAEE,2BAAA;EpE01OR;EoEx1OM;;IAEE,6BAAA;EpE01OR;EoEx1OM;;IAEE,8BAAA;EpE01OR;EoEx1OM;;IAEE,4BAAA;EpE01OR;EoEz2OM;IAAgC,yBAAA;EpE42OtC;EoE32OM;;IAEE,6BAAA;EpE62OR;EoE32OM;;IAEE,+BAAA;EpE62OR;EoE32OM;;IAEE,gCAAA;EpE62OR;EoE32OM;;IAEE,8BAAA;EpE62OR;EoE53OM;IAAgC,uBAAA;EpE+3OtC;EoE93OM;;IAEE,2BAAA;EpEg4OR;EoE93OM;;IAEE,6BAAA;EpEg4OR;EoE93OM;;IAEE,8BAAA;EpEg4OR;EoE93OM;;IAEE,4BAAA;EpEg4OR;EoE/4OM;IAAgC,uBAAA;EpEk5OtC;EoEj5OM;;IAEE,2BAAA;EpEm5OR;EoEj5OM;;IAEE,6BAAA;EpEm5OR;EoEj5OM;;IAEE,8BAAA;EpEm5OR;EoEj5OM;;IAEE,4BAAA;EpEm5OR;EoEl6OM;IAAgC,uBAAA;EpEq6OtC;EoEp6OM;;IAEE,2BAAA;EpEs6OR;EoEp6OM;;IAEE,6BAAA;EpEs6OR;EoEp6OM;;IAEE,8BAAA;EpEs6OR;EoEp6OM;;IAEE,4BAAA;EpEs6OR;EoEr7OM;IAAgC,uBAAA;EpEw7OtC;EoEv7OM;;IAEE,2BAAA;EpEy7OR;EoEv7OM;;IAEE,6BAAA;EpEy7OR;EoEv7OM;;IAEE,8BAAA;EpEy7OR;EoEv7OM;;IAEE,4BAAA;EpEy7OR;EoEx8OM;IAAgC,uBAAA;EpE28OtC;EoE18OM;;IAEE,2BAAA;EpE48OR;EoE18OM;;IAEE,6BAAA;EpE48OR;EoE18OM;;IAEE,8BAAA;EpE48OR;EoE18OM;;IAEE,4BAAA;EpE48OR;EoE39OM;IAAgC,qBAAA;EpE89OtC;EoE79OM;;IAEE,yBAAA;EpE+9OR;EoE79OM;;IAEE,2BAAA;EpE+9OR;EoE79OM;;IAEE,4BAAA;EpE+9OR;EoE79OM;;IAEE,0BAAA;EpE+9OR;EoE9+OM;IAAgC,2BAAA;EpEi/OtC;EoEh/OM;;IAEE,+BAAA;EpEk/OR;EoEh/OM;;IAEE,iCAAA;EpEk/OR;EoEh/OM;;IAEE,kCAAA;EpEk/OR;EoEh/OM;;IAEE,gCAAA;EpEk/OR;EoEjgPM;IAAgC,0BAAA;EpEogPtC;EoEngPM;;IAEE,8BAAA;EpEqgPR;EoEngPM;;IAEE,gCAAA;EpEqgPR;EoEngPM;;IAEE,iCAAA;EpEqgPR;EoEngPM;;IAEE,+BAAA;EpEqgPR;EoEphPM;IAAgC,wBAAA;EpEuhPtC;EoEthPM;;IAEE,4BAAA;EpEwhPR;EoEthPM;;IAEE,8BAAA;EpEwhPR;EoEthPM;;IAEE,+BAAA;EpEwhPR;EoEthPM;;IAEE,6BAAA;EpEwhPR;EoEviPM;IAAgC,0BAAA;EpE0iPtC;EoEziPM;;IAEE,8BAAA;EpE2iPR;EoEziPM;;IAEE,gCAAA;EpE2iPR;EoEziPM;;IAEE,iCAAA;EpE2iPR;EoEziPM;;IAEE,+BAAA;EpE2iPR;EoE1jPM;IAAgC,wBAAA;EpE6jPtC;EoE5jPM;;IAEE,4BAAA;EpE8jPR;EoE5jPM;;IAEE,8BAAA;EpE8jPR;EoE5jPM;;IAEE,+BAAA;EpE8jPR;EoE5jPM;;IAEE,6BAAA;EpE8jPR;EoE7kPM;IAAgC,wBAAA;EpEglPtC;EoE/kPM;;IAEE,4BAAA;EpEilPR;EoE/kPM;;IAEE,8BAAA;EpEilPR;EoE/kPM;;IAEE,+BAAA;EpEilPR;EoE/kPM;;IAEE,6BAAA;EpEilPR;EoEhmPM;IAAgC,wBAAA;EpEmmPtC;EoElmPM;;IAEE,4BAAA;EpEomPR;EoElmPM;;IAEE,8BAAA;EpEomPR;EoElmPM;;IAEE,+BAAA;EpEomPR;EoElmPM;;IAEE,6BAAA;EpEomPR;EoEnnPM;IAAgC,wBAAA;EpEsnPtC;EoErnPM;;IAEE,4BAAA;EpEunPR;EoErnPM;;IAEE,8BAAA;EpEunPR;EoErnPM;;IAEE,+BAAA;EpEunPR;EoErnPM;;IAEE,6BAAA;EpEunPR;EoEtoPM;IAAgC,wBAAA;EpEyoPtC;EoExoPM;;IAEE,4BAAA;EpE0oPR;EoExoPM;;IAEE,8BAAA;EpE0oPR;EoExoPM;;IAEE,+BAAA;EpE0oPR;EoExoPM;;IAEE,6BAAA;EpE0oPR;EoEpoPE;IAAmB,uBAAA;EpEuoPrB;EoEtoPE;;IAEE,2BAAA;EpEwoPJ;EoEtoPE;;IAEE,6BAAA;EpEwoPJ;EoEtoPE;;IAEE,8BAAA;EpEwoPJ;EoEtoPE;;IAEE,4BAAA;EpEwoPJ;AACF;Ae5nPI;EqDjDI;IAAgC,oBAAA;EpEirPtC;EoEhrPM;;IAEE,wBAAA;EpEkrPR;EoEhrPM;;IAEE,0BAAA;EpEkrPR;EoEhrPM;;IAEE,2BAAA;EpEkrPR;EoEhrPM;;IAEE,yBAAA;EpEkrPR;EoEjsPM;IAAgC,0BAAA;EpEosPtC;EoEnsPM;;IAEE,8BAAA;EpEqsPR;EoEnsPM;;IAEE,gCAAA;EpEqsPR;EoEnsPM;;IAEE,iCAAA;EpEqsPR;EoEnsPM;;IAEE,+BAAA;EpEqsPR;EoEptPM;IAAgC,yBAAA;EpEutPtC;EoEttPM;;IAEE,6BAAA;EpEwtPR;EoEttPM;;IAEE,+BAAA;EpEwtPR;EoEttPM;;IAEE,gCAAA;EpEwtPR;EoEttPM;;IAEE,8BAAA;EpEwtPR;EoEvuPM;IAAgC,uBAAA;EpE0uPtC;EoEzuPM;;IAEE,2BAAA;EpE2uPR;EoEzuPM;;IAEE,6BAAA;EpE2uPR;EoEzuPM;;IAEE,8BAAA;EpE2uPR;EoEzuPM;;IAEE,4BAAA;EpE2uPR;EoE1vPM;IAAgC,yBAAA;EpE6vPtC;EoE5vPM;;IAEE,6BAAA;EpE8vPR;EoE5vPM;;IAEE,+BAAA;EpE8vPR;EoE5vPM;;IAEE,gCAAA;EpE8vPR;EoE5vPM;;IAEE,8BAAA;EpE8vPR;EoE7wPM;IAAgC,uBAAA;EpEgxPtC;EoE/wPM;;IAEE,2BAAA;EpEixPR;EoE/wPM;;IAEE,6BAAA;EpEixPR;EoE/wPM;;IAEE,8BAAA;EpEixPR;EoE/wPM;;IAEE,4BAAA;EpEixPR;EoEhyPM;IAAgC,uBAAA;EpEmyPtC;EoElyPM;;IAEE,2BAAA;EpEoyPR;EoElyPM;;IAEE,6BAAA;EpEoyPR;EoElyPM;;IAEE,8BAAA;EpEoyPR;EoElyPM;;IAEE,4BAAA;EpEoyPR;EoEnzPM;IAAgC,uBAAA;EpEszPtC;EoErzPM;;IAEE,2BAAA;EpEuzPR;EoErzPM;;IAEE,6BAAA;EpEuzPR;EoErzPM;;IAEE,8BAAA;EpEuzPR;EoErzPM;;IAEE,4BAAA;EpEuzPR;EoEt0PM;IAAgC,uBAAA;EpEy0PtC;EoEx0PM;;IAEE,2BAAA;EpE00PR;EoEx0PM;;IAEE,6BAAA;EpE00PR;EoEx0PM;;IAEE,8BAAA;EpE00PR;EoEx0PM;;IAEE,4BAAA;EpE00PR;EoEz1PM;IAAgC,uBAAA;EpE41PtC;EoE31PM;;IAEE,2BAAA;EpE61PR;EoE31PM;;IAEE,6BAAA;EpE61PR;EoE31PM;;IAEE,8BAAA;EpE61PR;EoE31PM;;IAEE,4BAAA;EpE61PR;EoE52PM;IAAgC,qBAAA;EpE+2PtC;EoE92PM;;IAEE,yBAAA;EpEg3PR;EoE92PM;;IAEE,2BAAA;EpEg3PR;EoE92PM;;IAEE,4BAAA;EpEg3PR;EoE92PM;;IAEE,0BAAA;EpEg3PR;EoE/3PM;IAAgC,2BAAA;EpEk4PtC;EoEj4PM;;IAEE,+BAAA;EpEm4PR;EoEj4PM;;IAEE,iCAAA;EpEm4PR;EoEj4PM;;IAEE,kCAAA;EpEm4PR;EoEj4PM;;IAEE,gCAAA;EpEm4PR;EoEl5PM;IAAgC,0BAAA;EpEq5PtC;EoEp5PM;;IAEE,8BAAA;EpEs5PR;EoEp5PM;;IAEE,gCAAA;EpEs5PR;EoEp5PM;;IAEE,iCAAA;EpEs5PR;EoEp5PM;;IAEE,+BAAA;EpEs5PR;EoEr6PM;IAAgC,wBAAA;EpEw6PtC;EoEv6PM;;IAEE,4BAAA;EpEy6PR;EoEv6PM;;IAEE,8BAAA;EpEy6PR;EoEv6PM;;IAEE,+BAAA;EpEy6PR;EoEv6PM;;IAEE,6BAAA;EpEy6PR;EoEx7PM;IAAgC,0BAAA;EpE27PtC;EoE17PM;;IAEE,8BAAA;EpE47PR;EoE17PM;;IAEE,gCAAA;EpE47PR;EoE17PM;;IAEE,iCAAA;EpE47PR;EoE17PM;;IAEE,+BAAA;EpE47PR;EoE38PM;IAAgC,wBAAA;EpE88PtC;EoE78PM;;IAEE,4BAAA;EpE+8PR;EoE78PM;;IAEE,8BAAA;EpE+8PR;EoE78PM;;IAEE,+BAAA;EpE+8PR;EoE78PM;;IAEE,6BAAA;EpE+8PR;EoE99PM;IAAgC,wBAAA;EpEi+PtC;EoEh+PM;;IAEE,4BAAA;EpEk+PR;EoEh+PM;;IAEE,8BAAA;EpEk+PR;EoEh+PM;;IAEE,+BAAA;EpEk+PR;EoEh+PM;;IAEE,6BAAA;EpEk+PR;EoEj/PM;IAAgC,wBAAA;EpEo/PtC;EoEn/PM;;IAEE,4BAAA;EpEq/PR;EoEn/PM;;IAEE,8BAAA;EpEq/PR;EoEn/PM;;IAEE,+BAAA;EpEq/PR;EoEn/PM;;IAEE,6BAAA;EpEq/PR;EoEpgQM;IAAgC,wBAAA;EpEugQtC;EoEtgQM;;IAEE,4BAAA;EpEwgQR;EoEtgQM;;IAEE,8BAAA;EpEwgQR;EoEtgQM;;IAEE,+BAAA;EpEwgQR;EoEtgQM;;IAEE,6BAAA;EpEwgQR;EoEvhQM;IAAgC,wBAAA;EpE0hQtC;EoEzhQM;;IAEE,4BAAA;EpE2hQR;EoEzhQM;;IAEE,8BAAA;EpE2hQR;EoEzhQM;;IAEE,+BAAA;EpE2hQR;EoEzhQM;;IAEE,6BAAA;EpE2hQR;EoErhQE;IAAmB,uBAAA;EpEwhQrB;EoEvhQE;;IAEE,2BAAA;EpEyhQJ;EoEvhQE;;IAEE,6BAAA;EpEyhQJ;EoEvhQE;;IAEE,8BAAA;EpEyhQJ;EoEvhQE;;IAEE,4BAAA;EpEyhQJ;AACF;Ae7gQI;EqDjDI;IAAgC,oBAAA;EpEkkQtC;EoEjkQM;;IAEE,wBAAA;EpEmkQR;EoEjkQM;;IAEE,0BAAA;EpEmkQR;EoEjkQM;;IAEE,2BAAA;EpEmkQR;EoEjkQM;;IAEE,yBAAA;EpEmkQR;EoEllQM;IAAgC,0BAAA;EpEqlQtC;EoEplQM;;IAEE,8BAAA;EpEslQR;EoEplQM;;IAEE,gCAAA;EpEslQR;EoEplQM;;IAEE,iCAAA;EpEslQR;EoEplQM;;IAEE,+BAAA;EpEslQR;EoErmQM;IAAgC,yBAAA;EpEwmQtC;EoEvmQM;;IAEE,6BAAA;EpEymQR;EoEvmQM;;IAEE,+BAAA;EpEymQR;EoEvmQM;;IAEE,gCAAA;EpEymQR;EoEvmQM;;IAEE,8BAAA;EpEymQR;EoExnQM;IAAgC,uBAAA;EpE2nQtC;EoE1nQM;;IAEE,2BAAA;EpE4nQR;EoE1nQM;;IAEE,6BAAA;EpE4nQR;EoE1nQM;;IAEE,8BAAA;EpE4nQR;EoE1nQM;;IAEE,4BAAA;EpE4nQR;EoE3oQM;IAAgC,yBAAA;EpE8oQtC;EoE7oQM;;IAEE,6BAAA;EpE+oQR;EoE7oQM;;IAEE,+BAAA;EpE+oQR;EoE7oQM;;IAEE,gCAAA;EpE+oQR;EoE7oQM;;IAEE,8BAAA;EpE+oQR;EoE9pQM;IAAgC,uBAAA;EpEiqQtC;EoEhqQM;;IAEE,2BAAA;EpEkqQR;EoEhqQM;;IAEE,6BAAA;EpEkqQR;EoEhqQM;;IAEE,8BAAA;EpEkqQR;EoEhqQM;;IAEE,4BAAA;EpEkqQR;EoEjrQM;IAAgC,uBAAA;EpEorQtC;EoEnrQM;;IAEE,2BAAA;EpEqrQR;EoEnrQM;;IAEE,6BAAA;EpEqrQR;EoEnrQM;;IAEE,8BAAA;EpEqrQR;EoEnrQM;;IAEE,4BAAA;EpEqrQR;EoEpsQM;IAAgC,uBAAA;EpEusQtC;EoEtsQM;;IAEE,2BAAA;EpEwsQR;EoEtsQM;;IAEE,6BAAA;EpEwsQR;EoEtsQM;;IAEE,8BAAA;EpEwsQR;EoEtsQM;;IAEE,4BAAA;EpEwsQR;EoEvtQM;IAAgC,uBAAA;EpE0tQtC;EoEztQM;;IAEE,2BAAA;EpE2tQR;EoEztQM;;IAEE,6BAAA;EpE2tQR;EoEztQM;;IAEE,8BAAA;EpE2tQR;EoEztQM;;IAEE,4BAAA;EpE2tQR;EoE1uQM;IAAgC,uBAAA;EpE6uQtC;EoE5uQM;;IAEE,2BAAA;EpE8uQR;EoE5uQM;;IAEE,6BAAA;EpE8uQR;EoE5uQM;;IAEE,8BAAA;EpE8uQR;EoE5uQM;;IAEE,4BAAA;EpE8uQR;EoE7vQM;IAAgC,qBAAA;EpEgwQtC;EoE/vQM;;IAEE,yBAAA;EpEiwQR;EoE/vQM;;IAEE,2BAAA;EpEiwQR;EoE/vQM;;IAEE,4BAAA;EpEiwQR;EoE/vQM;;IAEE,0BAAA;EpEiwQR;EoEhxQM;IAAgC,2BAAA;EpEmxQtC;EoElxQM;;IAEE,+BAAA;EpEoxQR;EoElxQM;;IAEE,iCAAA;EpEoxQR;EoElxQM;;IAEE,kCAAA;EpEoxQR;EoElxQM;;IAEE,gCAAA;EpEoxQR;EoEnyQM;IAAgC,0BAAA;EpEsyQtC;EoEryQM;;IAEE,8BAAA;EpEuyQR;EoEryQM;;IAEE,gCAAA;EpEuyQR;EoEryQM;;IAEE,iCAAA;EpEuyQR;EoEryQM;;IAEE,+BAAA;EpEuyQR;EoEtzQM;IAAgC,wBAAA;EpEyzQtC;EoExzQM;;IAEE,4BAAA;EpE0zQR;EoExzQM;;IAEE,8BAAA;EpE0zQR;EoExzQM;;IAEE,+BAAA;EpE0zQR;EoExzQM;;IAEE,6BAAA;EpE0zQR;EoEz0QM;IAAgC,0BAAA;EpE40QtC;EoE30QM;;IAEE,8BAAA;EpE60QR;EoE30QM;;IAEE,gCAAA;EpE60QR;EoE30QM;;IAEE,iCAAA;EpE60QR;EoE30QM;;IAEE,+BAAA;EpE60QR;EoE51QM;IAAgC,wBAAA;EpE+1QtC;EoE91QM;;IAEE,4BAAA;EpEg2QR;EoE91QM;;IAEE,8BAAA;EpEg2QR;EoE91QM;;IAEE,+BAAA;EpEg2QR;EoE91QM;;IAEE,6BAAA;EpEg2QR;EoE/2QM;IAAgC,wBAAA;EpEk3QtC;EoEj3QM;;IAEE,4BAAA;EpEm3QR;EoEj3QM;;IAEE,8BAAA;EpEm3QR;EoEj3QM;;IAEE,+BAAA;EpEm3QR;EoEj3QM;;IAEE,6BAAA;EpEm3QR;EoEl4QM;IAAgC,wBAAA;EpEq4QtC;EoEp4QM;;IAEE,4BAAA;EpEs4QR;EoEp4QM;;IAEE,8BAAA;EpEs4QR;EoEp4QM;;IAEE,+BAAA;EpEs4QR;EoEp4QM;;IAEE,6BAAA;EpEs4QR;EoEr5QM;IAAgC,wBAAA;EpEw5QtC;EoEv5QM;;IAEE,4BAAA;EpEy5QR;EoEv5QM;;IAEE,8BAAA;EpEy5QR;EoEv5QM;;IAEE,+BAAA;EpEy5QR;EoEv5QM;;IAEE,6BAAA;EpEy5QR;EoEx6QM;IAAgC,wBAAA;EpE26QtC;EoE16QM;;IAEE,4BAAA;EpE46QR;EoE16QM;;IAEE,8BAAA;EpE46QR;EoE16QM;;IAEE,+BAAA;EpE46QR;EoE16QM;;IAEE,6BAAA;EpE46QR;EoEt6QE;IAAmB,uBAAA;EpEy6QrB;EoEx6QE;;IAEE,2BAAA;EpE06QJ;EoEx6QE;;IAEE,6BAAA;EpE06QJ;EoEx6QE;;IAEE,8BAAA;EpE06QJ;EoEx6QE;;IAEE,4BAAA;EpE06QJ;AACF;Ae95QI;EqDjDI;IAAgC,oBAAA;EpEm9QtC;EoEl9QM;;IAEE,wBAAA;EpEo9QR;EoEl9QM;;IAEE,0BAAA;EpEo9QR;EoEl9QM;;IAEE,2BAAA;EpEo9QR;EoEl9QM;;IAEE,yBAAA;EpEo9QR;EoEn+QM;IAAgC,0BAAA;EpEs+QtC;EoEr+QM;;IAEE,8BAAA;EpEu+QR;EoEr+QM;;IAEE,gCAAA;EpEu+QR;EoEr+QM;;IAEE,iCAAA;EpEu+QR;EoEr+QM;;IAEE,+BAAA;EpEu+QR;EoEt/QM;IAAgC,yBAAA;EpEy/QtC;EoEx/QM;;IAEE,6BAAA;EpE0/QR;EoEx/QM;;IAEE,+BAAA;EpE0/QR;EoEx/QM;;IAEE,gCAAA;EpE0/QR;EoEx/QM;;IAEE,8BAAA;EpE0/QR;EoEzgRM;IAAgC,uBAAA;EpE4gRtC;EoE3gRM;;IAEE,2BAAA;EpE6gRR;EoE3gRM;;IAEE,6BAAA;EpE6gRR;EoE3gRM;;IAEE,8BAAA;EpE6gRR;EoE3gRM;;IAEE,4BAAA;EpE6gRR;EoE5hRM;IAAgC,yBAAA;EpE+hRtC;EoE9hRM;;IAEE,6BAAA;EpEgiRR;EoE9hRM;;IAEE,+BAAA;EpEgiRR;EoE9hRM;;IAEE,gCAAA;EpEgiRR;EoE9hRM;;IAEE,8BAAA;EpEgiRR;EoE/iRM;IAAgC,uBAAA;EpEkjRtC;EoEjjRM;;IAEE,2BAAA;EpEmjRR;EoEjjRM;;IAEE,6BAAA;EpEmjRR;EoEjjRM;;IAEE,8BAAA;EpEmjRR;EoEjjRM;;IAEE,4BAAA;EpEmjRR;EoElkRM;IAAgC,uBAAA;EpEqkRtC;EoEpkRM;;IAEE,2BAAA;EpEskRR;EoEpkRM;;IAEE,6BAAA;EpEskRR;EoEpkRM;;IAEE,8BAAA;EpEskRR;EoEpkRM;;IAEE,4BAAA;EpEskRR;EoErlRM;IAAgC,uBAAA;EpEwlRtC;EoEvlRM;;IAEE,2BAAA;EpEylRR;EoEvlRM;;IAEE,6BAAA;EpEylRR;EoEvlRM;;IAEE,8BAAA;EpEylRR;EoEvlRM;;IAEE,4BAAA;EpEylRR;EoExmRM;IAAgC,uBAAA;EpE2mRtC;EoE1mRM;;IAEE,2BAAA;EpE4mRR;EoE1mRM;;IAEE,6BAAA;EpE4mRR;EoE1mRM;;IAEE,8BAAA;EpE4mRR;EoE1mRM;;IAEE,4BAAA;EpE4mRR;EoE3nRM;IAAgC,uBAAA;EpE8nRtC;EoE7nRM;;IAEE,2BAAA;EpE+nRR;EoE7nRM;;IAEE,6BAAA;EpE+nRR;EoE7nRM;;IAEE,8BAAA;EpE+nRR;EoE7nRM;;IAEE,4BAAA;EpE+nRR;EoE9oRM;IAAgC,qBAAA;EpEipRtC;EoEhpRM;;IAEE,yBAAA;EpEkpRR;EoEhpRM;;IAEE,2BAAA;EpEkpRR;EoEhpRM;;IAEE,4BAAA;EpEkpRR;EoEhpRM;;IAEE,0BAAA;EpEkpRR;EoEjqRM;IAAgC,2BAAA;EpEoqRtC;EoEnqRM;;IAEE,+BAAA;EpEqqRR;EoEnqRM;;IAEE,iCAAA;EpEqqRR;EoEnqRM;;IAEE,kCAAA;EpEqqRR;EoEnqRM;;IAEE,gCAAA;EpEqqRR;EoEprRM;IAAgC,0BAAA;EpEurRtC;EoEtrRM;;IAEE,8BAAA;EpEwrRR;EoEtrRM;;IAEE,gCAAA;EpEwrRR;EoEtrRM;;IAEE,iCAAA;EpEwrRR;EoEtrRM;;IAEE,+BAAA;EpEwrRR;EoEvsRM;IAAgC,wBAAA;EpE0sRtC;EoEzsRM;;IAEE,4BAAA;EpE2sRR;EoEzsRM;;IAEE,8BAAA;EpE2sRR;EoEzsRM;;IAEE,+BAAA;EpE2sRR;EoEzsRM;;IAEE,6BAAA;EpE2sRR;EoE1tRM;IAAgC,0BAAA;EpE6tRtC;EoE5tRM;;IAEE,8BAAA;EpE8tRR;EoE5tRM;;IAEE,gCAAA;EpE8tRR;EoE5tRM;;IAEE,iCAAA;EpE8tRR;EoE5tRM;;IAEE,+BAAA;EpE8tRR;EoE7uRM;IAAgC,wBAAA;EpEgvRtC;EoE/uRM;;IAEE,4BAAA;EpEivRR;EoE/uRM;;IAEE,8BAAA;EpEivRR;EoE/uRM;;IAEE,+BAAA;EpEivRR;EoE/uRM;;IAEE,6BAAA;EpEivRR;EoEhwRM;IAAgC,wBAAA;EpEmwRtC;EoElwRM;;IAEE,4BAAA;EpEowRR;EoElwRM;;IAEE,8BAAA;EpEowRR;EoElwRM;;IAEE,+BAAA;EpEowRR;EoElwRM;;IAEE,6BAAA;EpEowRR;EoEnxRM;IAAgC,wBAAA;EpEsxRtC;EoErxRM;;IAEE,4BAAA;EpEuxRR;EoErxRM;;IAEE,8BAAA;EpEuxRR;EoErxRM;;IAEE,+BAAA;EpEuxRR;EoErxRM;;IAEE,6BAAA;EpEuxRR;EoEtyRM;IAAgC,wBAAA;EpEyyRtC;EoExyRM;;IAEE,4BAAA;EpE0yRR;EoExyRM;;IAEE,8BAAA;EpE0yRR;EoExyRM;;IAEE,+BAAA;EpE0yRR;EoExyRM;;IAEE,6BAAA;EpE0yRR;EoEzzRM;IAAgC,wBAAA;EpE4zRtC;EoE3zRM;;IAEE,4BAAA;EpE6zRR;EoE3zRM;;IAEE,8BAAA;EpE6zRR;EoE3zRM;;IAEE,+BAAA;EpE6zRR;EoE3zRM;;IAEE,6BAAA;EpE6zRR;EoEvzRE;IAAmB,uBAAA;EpE0zRrB;EoEzzRE;;IAEE,2BAAA;EpE2zRJ;EoEzzRE;;IAEE,6BAAA;EpE2zRJ;EoEzzRE;;IAEE,8BAAA;EpE2zRJ;EoEzzRE;;IAEE,4BAAA;EpE2zRJ;AACF;AqEr2RA;EAAkB,iGjEqPY;AJmnR9B;;AqEp2RA;EAAiB,8BAAA;ArEw2RjB;;AqEv2RA;EAAiB,8BAAA;ArE22RjB;;AqE12RA;ECRE,gBAAA;EACA,uBAAA;EACA,mBAAA;AtEs3RF;;AqEx2RI;EAAwB,2BAAA;ArE42R5B;;AqE32RI;EAAwB,4BAAA;ArE+2R5B;;AqE92RI;EAAwB,6BAAA;ArEk3R5B;;Ae50RI;EsDxCA;IAAwB,2BAAA;ErEy3R1B;EqEx3RE;IAAwB,4BAAA;ErE23R1B;EqE13RE;IAAwB,6BAAA;ErE63R1B;AACF;Aex1RI;EsDxCA;IAAwB,2BAAA;ErEo4R1B;EqEn4RE;IAAwB,4BAAA;ErEs4R1B;EqEr4RE;IAAwB,6BAAA;ErEw4R1B;AACF;Aen2RI;EsDxCA;IAAwB,2BAAA;ErE+4R1B;EqE94RE;IAAwB,4BAAA;ErEi5R1B;EqEh5RE;IAAwB,6BAAA;ErEm5R1B;AACF;Ae92RI;EsDxCA;IAAwB,2BAAA;ErE05R1B;EqEz5RE;IAAwB,4BAAA;ErE45R1B;EqE35RE;IAAwB,6BAAA;ErE85R1B;AACF;AqEz5RA;EAAmB,oCAAA;ArE45RnB;;AqE35RA;EAAmB,oCAAA;ArE+5RnB;;AqE95RA;EAAmB,qCAAA;ArEk6RnB;;AqE95RA;EAAsB,2BAAA;ArEk6RtB;;AqEj6RA;EAAsB,2BAAA;ArEq6RtB;;AqEp6RA;EAAsB,2BAAA;ArEw6RtB;;AqEv6RA;EAAsB,6BAAA;ArE26RtB;;AqEv6RA;EAAc,yBAAA;ArE26Rd;;AuE/8RE;EACE,yBAAA;AvEk9RJ;;AKx8RE;EkENI,qEAAA;AvEk9RN;;AuEv9RE;EACE,yBAAA;AvE09RJ;;AKh9RE;EkENI,qEAAA;AvE09RN;;AuE/9RE;EACE,yBAAA;AvEk+RJ;;AKx9RE;EkENI,wDAAA;AvEk+RN;;AuEv+RE;EACE,yBAAA;AvE0+RJ;;AKh+RE;EkENI,oEAAA;AvE0+RN;;AuE/+RE;EACE,yBAAA;AvEk/RJ;;AKx+RE;EkENI,2DAAA;AvEk/RN;;AuEv/RE;EACE,yBAAA;AvE0/RJ;;AKh/RE;EkENI,qEAAA;AvE0/RN;;AuE//RE;EACE,yBAAA;AvEkgSJ;;AKx/RE;EkENI,qEAAA;AvEkgSN;;AuEvgSE;EACE,yBAAA;AvE0gSJ;;AKhgSE;EkENI,kEAAA;AvE0gSN;;AuE/gSE;EACE,yBAAA;AvEkhSJ;;AKxgSE;EkENI,oEAAA;AvEkhSN;;AuEvhSE;EACE,yBAAA;AvE0hSJ;;AKhhSE;EkENI,oCAAA;AvE0hSN;;AuE/hSE;EACE,yBAAA;AvEkiSJ;;AKxhSE;EkENI,oCAAA;AvEkiSN;;AuEviSE;EACE,uBAAA;AvE0iSJ;;AKhiSE;EkENI,uBAAA;AvE0iSN;;AqErgSA;EAAa,yBAAA;ArEygSb;;AqExgSA;EAAc,yBAAA;ArE4gSd;;AqE1gSA;EAAiB,uCAAA;ArE8gSjB;;AqE7gSA;EAAiB,0CAAA;ArEihSjB;;AqE7gSA;EGpDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;AxEqkSF;;AyExkSA;ECCE,8BAAA;A1E2kSF;;AyExkSA;ECHE,6BAAA;A1E+kSF;;A2EzkSE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;E3EykSJ;E2ErkSI;IACE,0BAAA;E3EukSN;E2E9jSE;IACE,6BAAA;E3EgkSJ;E2EljSE;IACE,gCAAA;E3EojSJ;E2EljSE;;IAEE,+BAAA;IACA,wBAAA;E3EojSJ;E2E5iSE;IACE,2BAAA;E3E8iSJ;E2E3iSE;;IAEE,wBAAA;E3E6iSJ;E2E1iSE;;;IAGE,UAAA;IACA,SAAA;E3E4iSJ;E2EziSE;;IAEE,uBAAA;E3E2iSJ;E2EniSE;IACE,QvE61B8B;EJwsQlC;E2EniSE;IACE,2BAAA;E3EqiSJ;E2EniSE;IACE,2BAAA;E3EqiSJ;E2EjiSE;IACE,aAAA;E3EmiSJ;E2EjiSE;IACE,+BAAA;E3EmiSJ;E2EhiSE;IACE,oCAAA;E3EkiSJ;E2EhiSI;;IAEE,oCAAA;E3EkiSN;E2E7hSI;;IAEE,oCAAA;E3E+hSN;E2E3hSE;IACE,cAAA;E3E6hSJ;E2E3hSI;;;;IAIE,qB1ElHG;ED+oST;E2EzhSE;IACE,cAAA;IACA,qB1ExHK;EDmpST;AACF;A4EnqSA;EACI,SAAA;EACA,c3EUI;AD2pSR;A4EnqSI;EACE,c3EOE;AD8pSR;A4ElqSI;EACE,wDAAA;A5EoqSN;A4EjqSI;;EAEI,e3EsZS;AD6wRjB;A4EhqSI;EACI,c3ENA;E2EOA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;A5EkqSR;A4EjqSQ;EACE,qBAAA;EACA,yCAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;A5EmqSV;A4EjqSQ;EACE,wBAAA;A5EmqSV;A4E/pSI;EACE,eAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;A5EiqSN;A4E9pSI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;A5EgqSN;A4E7pSI;EACI,cAAA;EACA,cAAA;A5E+pSR;A4E5pSI;EACI,kBAAA;A5E8pSR;;A4E1pSA;EACI,sBAAA;A5E6pSJ;A4E1pSQ;EAEI,+BAAA;EACA,qBAAA;A5E2pSZ;Ae5pSI;E6DJA;IASQ,SAAA;IACA,aAAA;E5E2pSV;AACF;A4EzpSQ;EACI,iBAAA;EACA,6BAAA;EACA,+BAAA;A5E2pSZ;A4EtpSY;EACI,6BAAA;EACA,+BAAA;A5EwpShB;A4EppSI;EACE,aAAA;A5EspSN;A4ErpSM;EACE,WAAA;A5EupSR;;A6E1vSA;EACE,gBAAA;A7E6vSF;;A8E9vSA;;EAEI,iB7E4VW;E6E3VX,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,wB7E6Ve;E6E5Vf,eAAA;ECkBF,mB9EsEQ;E8ElER,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB/E8FM;E+E7FN,0BAAA;EACA,gBAAA;AhF+wSJ;AgF9wSI;;EACE,gCAAA;EACA,4BAAA;AhFixSN;AgF9wSI;;;;;;;;;EAcI,c/EZA;E+EaA,gBAAA;AhF2wSR;AgFxwSI;;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;AhF2wSN;AgFxwSI;;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;AhF0wSR;AgFnwSQ;;;;;;;;;;;;;;;;;;;;;;;;;EAMI,yB/E6CF;E+E5CE,qB/E4CF;AD4uSV;A8E50SA;;EE4IQ,c/EhIA;ADo0SR;AgFjsSI;;EACI,c/EhDE;E+EiDF,qB/EjDE;E+EkDF,uB/E3HS;AD+zSjB;AgFlsSQ;;;;;EAII,c/ExDF;E+EyDE,qB/EzDF;E+E0DE,wCAAA;EACA,iCAAA;EACA,gBAAA;AhFqsSZ;AgFlsSQ;;EACE,gCAAA;AhFqsSV;AgFpsSU;;;;;EAII,c/EzJN;E+E0JM,qB/EtEJ;E+EuEI,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;AhFusSd;AgFlsSI;;EACI,c/ElFE;ADuxSV;AgFpsSQ;;;;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AhFusSZ;A8Er3SI;;;EGTF,UHWuB;EGRvB,0BAAA;EHSM,qBAAA;A9Ey3SR;A8Ev3SI;;;;EnEfA,gBmEkBK;EACA,qBAAA;A9E03ST;A8Ev3SI;;EACE,SAAA;A9E03SN;A8Ev3SI;;EAEI,gB7EycY;E6ExcZ,mB7EwcY;E6EvcZ,e7EucY;E6EtcZ,UAAA;EACA,oB7EsciB;E6ErcjB,gBAAA;EACA,kBAAA;EACA,mBAAA;A9Ey3SR;A8Ev3SQ;;EACI,UAAA;A9E03SZ;A8Ev3SQ;;EACI,gB7E8bG;E6E7bH,mB7E6bG;E6E5bH,e7E4bG;AD87Rf;A8Ex3SY;;;;;;;;;;;EAII,oB7EqbI;AD48RpB;A8E73SQ;;EACI,c7EmbG;E6ElbH,iB7EkbG;E6EjbH,a7EibG;AD+8Rf;A8E93SY;;;;;;;;;;;EAII,mB7E0aI;AD69RpB;A8En4SQ;;;;;EAII,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,sBAAA;EACA,WAAA;A9Es4SZ;A8Ej4SI;;EACI,kBAAA;EACA,QAAA;A9Eo4SR;A8Ej4SI;;EACE,kBAAA;EACA,cAAA;A9Eo4SN;A8Ej4SE;;EACE,c7EgCQ;ADo2SZ;A8Ej4SE;;EACE,4BAAA;A9Eo4SJ;;A8E93SA;EC/EE,mB9EuEQ;E8EnER,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB/E+FM;E+E9FN,0BAAA;EACA,gBAAA;AhFg/SJ;AgF/+SI;EACE,gCAAA;EACA,4BAAA;AhFi/SN;AgF9+SI;EAcI,c/EZA;E+EaA,gBAAA;AhFm+SR;AgFh+SI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;AhFk+SN;AgF/9SI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;AhFg+SR;AgFz9SQ;EAMI,yB/E8CF;E+E7CE,qB/E6CF;ADy6SV;A8Ej6SA;EEmCQ,c/EhIA;ADigTR;AgF93SI;EACI,c/E/CE;E+EgDF,qB/EhDE;E+EiDF,uB/E3HS;AD2/SjB;AgF93SQ;EAII,c/EvDF;E+EwDE,qB/ExDF;E+EyDE,wCAAA;EACA,iCAAA;EACA,gBAAA;AhF63SZ;AgF13SQ;EACE,gCAAA;AhF43SV;AgF33SU;EAII,c/EzJN;E+E0JM,qB/ErEJ;E+EsEI,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;AhF03Sd;AgFr3SI;EACI,c/EjFE;ADw8SV;AgFt3SQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AhFs3SZ;;A8Ep8SA;EClFE,mB9EyEQ;E8ErER,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB/EiGM;E+EhGN,0BAAA;EACA,gBAAA;AhFyjTJ;AgFxjTI;EACE,gCAAA;EACA,4BAAA;AhF0jTN;AgFvjTI;EAcI,c/EZA;E+EaA,gBAAA;AhF4iTR;AgFziTI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;AhF2iTN;AgFxiTI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;AhFyiTR;AgFliTQ;EAMI,yB/EgDF;E+E/CE,qB/E+CF;ADg/SV;A8Ev+SA;EEgCQ,c/EhIA;AD0kTR;AgFv8SI;EACI,c/E7CE;E+E8CF,qB/E9CE;E+E+CF,uB/E3HS;ADokTjB;AgFv8SQ;EAII,c/ErDF;E+EsDE,qB/EtDF;E+EuDE,wCAAA;EACA,iCAAA;EACA,gBAAA;AhFs8SZ;AgFn8SQ;EACE,gCAAA;AhFq8SV;AgFp8SU;EAII,c/EzJN;E+E0JM,qB/EnEJ;E+EoEI,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;AhFm8Sd;AgF97SI;EACI,c/E/EE;AD+gTV;AgF/7SQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AhF+7SZ;;A8E1gTA;ECrFE,mB9E0EK;E8EtEL,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB/EkGG;E+EjGH,0BAAA;EACA,gBAAA;AhFkoTJ;AgFjoTI;EACE,gCAAA;EACA,4BAAA;AhFmoTN;AgFhoTI;EAcI,c/EZA;E+EaA,gBAAA;AhFqnTR;AgFlnTI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;AhFonTN;AgFjnTI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;AhFknTR;AgF3mTQ;EAMI,yB/EiDL;E+EhDK,qB/EgDL;ADwjTP;A8E7iTA;EE6BQ,c/EhIA;ADmpTR;AgFhhTI;EACI,c/E5CD;E+E6CC,qB/E7CD;E+E8CC,uB/E3HS;AD6oTjB;AgFhhTQ;EAII,c/EpDL;E+EqDK,qB/ErDL;E+EsDK,wCAAA;EACA,iCAAA;EACA,gBAAA;AhF+gTZ;AgF5gTQ;EACE,gCAAA;AhF8gTV;AgF7gTU;EAII,c/EzJN;E+E0JM,qB/ElEP;E+EmEO,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;AhF4gTd;AgFvgTI;EACI,c/E9ED;ADulTP;AgFxgTQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AhFwgTZ;;A8EhlTA;ECxFE,mB9E2EQ;E8EvER,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB/EmGM;E+ElGN,0BAAA;EACA,gBAAA;AhF2sTJ;AgF1sTI;EACE,gCAAA;EACA,4BAAA;AhF4sTN;AgFzsTI;EAcI,c/EZA;E+EaA,gBAAA;AhF8rTR;AgF3rTI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;AhF6rTN;AgF1rTI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;AhF2rTR;AgFprTQ;EAMI,yB/EkDF;E+EjDE,qB/EiDF;ADgoTV;A8EnnTA;EE0BQ,c/EhIA;AD4tTR;AgFzlTI;EACI,c/E3CE;E+E4CF,qB/E5CE;E+E6CF,uB/E3HS;ADstTjB;AgFzlTQ;EAII,c/EnDF;E+EoDE,qB/EpDF;E+EqDE,wCAAA;EACA,iCAAA;EACA,gBAAA;AhFwlTZ;AgFrlTQ;EACE,gCAAA;AhFulTV;AgFtlTU;EAII,c/EzJN;E+E0JM,qB/EjEJ;E+EkEI,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;AhFqlTd;AgFhlTI;EACI,c/E7EE;AD+pTV;AgFjlTQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AhFilTZ;A8ExpTgB;EACE,c7ExGV;ADkwTR;;A8EvpTA;EC7FE,mB9E4EO;E8ExEP,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB/EoGK;E+EnGL,0BAAA;EACA,gBAAA;AhFuxTJ;AgFtxTI;EACE,gCAAA;EACA,4BAAA;AhFwxTN;AgFrxTI;EAcI,c/EZA;E+EaA,gBAAA;AhF0wTR;AgFvwTI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;AhFywTN;AgFtwTI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;AhFuwTR;AgFhwTQ;EAMI,yB/EmDH;E+ElDG,qB/EkDH;AD2sTT;A8E1rTA;EEqBQ,c/EhIA;ADwyTR;AgFrqTI;EACI,c/E1CC;E+E2CD,qB/E3CC;E+E4CD,uB/E3HS;ADkyTjB;AgFrqTQ;EAII,c/ElDH;E+EmDG,qB/EnDH;E+EoDG,wCAAA;EACA,iCAAA;EACA,gBAAA;AhFoqTZ;AgFjqTQ;EACE,gCAAA;AhFmqTV;AgFlqTU;EAII,c/EzJN;E+E0JM,qB/EhEL;E+EiEK,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;AhFiqTd;AgF5pTI;EACI,c/E5EC;AD0uTT;AgF7pTQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AhF6pTZ;;A8E7tTA;EChGE,mB9EdM;E8EkBN,4EAAA;EACA,0BAAA;EACA,8BAAA;EC9BE,yB/EUI;E+ETJ,0BAAA;EACA,gBAAA;AhFg2TJ;AgF/1TI;EACE,gCAAA;EACA,4BAAA;AhFi2TN;AgF91TI;EAcI,c/EZA;E+EaA,gBAAA;AhFm1TR;AgFh1TI;EACE,2BAAA;EACA,qCAAA;EACA,0BAAA;AhFk1TN;AgF/0TI;EAEI,0CAAA;EACA,2BAAA;EACA,mCAAA;AhFg1TR;AgFz0TQ;EAMI,yB/EvCJ;E+EwCI,qB/ExCJ;AD82TR;A8EhwTA;EEhEQ,c/EuCE;AD4xTV;AgFj0TQ;EACI,c/EyCH;AD0xTT;AgFj0TY;EAII,c/E4CA;ADoxThB;AgF5zTQ;EACI,c/E4BL;ADkyTP;AgF5zTY;EAII,c/E+BF;AD4xTd;AgFvzTQ;EACI,c/EkBF;ADuyTV;AgFvzTY;EAII,c/EqBC;ADiyTjB;AgFlzTQ;EACI,c/EKF;AD+yTV;AgFlzTY;EAII,c/EQC;ADyyTjB;AgF7yTQ;EACI,c/ETF;ADwzTV;AgF7yTY;EAII,c/ELC;ADizTjB;AgFxyTQ;EASI,yB/EhHJ;E+EiHI,c/ElBK;E+EmBL,gBAAA;AhFkyTZ;AgF/xTQ;EAEI,c/ExBK;ADwzTjB;AgF9xTY;EACI,gBAAA;AhFgyThB;AgFvxTI;EACI,c/EpIA;E+EqIA,qB/ErIA;E+EsIA,uB/E3HS;ADo5TjB;AgFvxTQ;EAII,c/E5IJ;E+E6II,qB/E7IJ;E+E8II,wCAAA;EACA,iCAAA;EACA,gBAAA;AhFsxTZ;AgFnxTQ;EACE,gCAAA;AhFqxTV;AgFpxTU;EAII,c/EzJN;E+E0JM,qB/E1JN;E+E2JM,uFAAA;EAGA,4FAAA;EACA,oCAAA;EACA,gBAAA;AhFmxTd;AgF9wTI;EACI,c/EtKA;ADs7TR;AgF/wTQ;EAGI,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AhF+wTZ;;A8E50TK;EG1HH,YH6HuB;EG1HvB,yBAAA;EH2HM,oBAAA;A9E80TR;;A8E30TA;EACI,iB7EoOK;E6EnOL,qB7EtCM;E6EuCN,gBAAA;EACA,kBAAA;EACA,6B7ElHa;ADg8TjB;;A8Er0TQ;;;;;;;;;;;;;;;;;;;;;;;;;EAMI,uB7EjIK;AD49TjB;;A8Et1TA;EACE,0CAAA;A9Ey1TF;;A8Ev1TA;EACI,S7E2LG;E6E1LH,gBAAA;EACA,sBAAA;EACA,uB7E7Ia;E6E8Ib,c7EtJO;E6EuJP,gB7E2Pe;AD+lTnB;A8Ex1TE;EACE,2BAAA;EACA,0BAAA;A9E01TJ;;A8Et1TA;EEgHG,mB/EkHc;E+EjHd,wB/EqEgB;E+EpEhB,kBAAA;AhF0uTH;AgFxuTG;EACI,kBAAA;AhF0uTP;;A8E51TA;EE6GG,mB/EkHc;E+EjHd,wB/EsEgB;E+ErEhB,iBAAA;AhFmvTH;AgFjvTG;EACI,iBAAA;AhFmvTP;;A8Ej2TA;EACI,gBAAA;A9Eo2TJ;;A8El2TA;EACI,WAAA;A9Eq2TJ;;A8Ej2TE;EACE,0CAAA;EACA,2BAAA;EACA,mCAAA;A9Eo2TJ;;A8E/1TA;EACI,gBAAA;A9Ek2TJ;;A8Eh2TA;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;A9Em2TJ;;A8Eh2TA;EACI,0CAAA;EACA,2BAAA;EACA,mCAAA;A9Em2TJ;;A8Eh2TA;EACI,iB7EuIU;E6EtIV,mB7EoWe;AD+/SnB;A8Ej2TI;EACI,kBAAA;A9Em2TR;;A8E91TE;EACE,aAAA;A9Ei2TJ;;A8E71TA;;;EAGI,c7E3NI;AD2jUR;;A8E71TA;EACI,wBAAA;EACA,gCAAA;A9Eg2TJ;;A8E71TA;EACE,gBAAA;A9Eg2TF;;AkFhlUA;EACI,SAAA;EACA,gDAAA;EACA,wBjFmWe;E8EhVf,4BAAA;A/EqkUJ;AkFplUM;EACE,UAAA;EACA,WAAA;AlFslUR;AkFllUI;EACE,gEAAA;EACA,yBAAA;AlFolUN;AkFnlUM;EACE,+BAAA;AlFqlUR;AkFllUM;EACE,qBjF2EE;ADygUV;AkFjlUM;EACE,cjF8EA;EiF7EA,UAAA;AlFmlUR;AkFhlUM;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,cjFwDE;EiFvDF,0BAAA;EACA,qCAAA;EACA,oCAAA;AlFklUR;AkF9kUQ;EACE,UAAA;EACA,WAAA;AlFglUV;AkF3kUQ;EACE,cjFyDK;EiFxDL,UAAA;AlF6kUV;AkF1kUQ;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,cjF7CQ;EiF8CR,uBAAA;EACA,qCAAA;EACA,oCAAA;EACA,mBAAA;EACA,UAAA;AlF4kUV;AkFvkUI;EACI,iBAAA;EACA,kBAAA;EACA,QAAA;AlFykUR;AkFtkUI;EACI,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AlFwkUR;AkFpkUQ;EAEI,cAAA;AlFqkUZ;AkFhkUQ;EACI,aAAA;AlFkkUZ;AkF/jUQ;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,cjF1GF;EiF2GE,uBAAA;EACA,qCAAA;EACA,oCAAA;EACA,mBAAA;AlFikUV;AkF7jUU;EACE,WAAA;EACA,UAAA;AlF+jUZ;AkFxjUI;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,cjFrIE;EiFsIF,0BAAA;EACA,qCAAA;EACA,oCAAA;AlF0jUN;AkFrjUI;EACE,mBAAA;EACA,qBAAA;AlFujUN;AkFpjUI;EAEE,0BjFqPS;EiFpPT,mBAAA;EACA,sBAAA;EACA,eAAA;EH7IF,4BAAA;A/EusUJ;AkFvjUM;EAEE,0CjF9GS;ADsqUjB;AkFrjUM;EAEE,+BjFvDU;AD6mUlB;AkFpjUQ;EAEE,6BAAA;EACA,gBAAA;AlFqjUV;AkF/iUI;EACI,0CjF9HS;AD+qUjB;AkF9iUI;EACI,+BjFvEU;EiFwEV,qBjFwNO;EiFvNP,yBAAA;EACA,gBjFiOW;AD+0TnB;AkF7iUI;EClMA,qEDmM6B;AlF+iUjC;AmFhvUI;EACI,0DDgMyB;AlFkjUjC;AmF/uUI;EACI,+BlFwDI;ADyrUZ;AmF9uUI;EACI,cAAA;AnFgvUR;AmF9uUQ;EAEI,0ClFmDA;AD4rUZ;AmF3uUI;EACI,0ClF8CI;AD+rUZ;AkF3jUI;ECtMA,oEDuM6B;AlF6jUjC;AmFlwUI;EACI,yDDoMyB;AlFgkUjC;AmFjwUI;EACI,+BlFwDI;AD2sUZ;AmFhwUI;EACI,cAAA;AnFkwUR;AmFhwUQ;EAEI,0ClFmDA;AD8sUZ;AmF7vUI;EACI,0ClF8CI;ADitUZ;AkFzkUI;EC1MA,oED2M6B;AlF2kUjC;AmFpxUI;EACI,yDDwMyB;AlF8kUjC;AmFnxUI;EACI,+BlFwDI;AD6tUZ;AmFlxUI;EACI,cAAA;AnFoxUR;AmFlxUQ;EAEI,0ClFmDA;ADguUZ;AmF/wUI;EACI,0ClF8CI;ADmuUZ;AkFvlUI;EC9MA,yDD+M6B;AlFylUjC;AmFtyUI;EACI,8CD4MyB;AlF4lUjC;AmFryUI;EACI,+BlFwDI;AD+uUZ;AmFpyUI;EACI,cAAA;AnFsyUR;AmFpyUQ;EAEI,0ClFmDA;ADkvUZ;AmFjyUI;EACI,0ClF8CI;ADqvUZ;AkFrmUI;EClNA,2DDmN6B;AlFumUjC;AmFxzUI;EACI,gDDgNyB;AlF0mUjC;AmFvzUI;EACI,+BlFwDI;ADiwUZ;AmFtzUI;EACI,cAAA;AnFwzUR;AmFtzUQ;EAEI,0ClFmDA;ADowUZ;AmFnzUI;EACI,0ClF8CI;ADuwUZ;AkFnnUI;EH/JG,8CAAA;EGoKC,kBAAA;EACA,cAAA;ED1NN,UC2NuB;EDxNvB,wBAAA;ECyNM,oBAAA;AlFunUR;AkFpnUI;EH1KG,8CAAA;EG4KD,kBAAA;EACA,cAAA;EDlOJ,UCmOqB;EDhOrB,wBAAA;AjF21UF;AkFxnUI;EHjLG,8CAAA;A/EgzUP;AkF1nUI;EHtLG,6CAAA;A/EuzUP;AkF7nUI;EH1LG,6CAAA;EG4LC,oBAAA;EACA,YAAA;AlFmoUR;AkFhoUI;EDrPF,UC2PuB;EDxPvB,0BAAA;ECyPM,mBAAA;EHvMD,4CAAA;A/E00UP;AkF/nUI;EH3MG,4CAAA;A/Ei1UP;AkFjoUI;EHhNG,6CAAA;A/Ew1UP;AkFpoUI;EACE,WAAA;AlFsoUN;AkFroUM;EACE,UAAA;EACA,WAAA;AlFuoUR;;AkFhoUA;EACI,eAAA;AlFmoUJ;AkFjoUI;EACI,aAAA;EACA,SAAA;EACA,kBAAA;AlFmoUR;AkFjoUQ;EACE,WAAA;EACA,gBAAA;AlFmoUV;AkF9nUI;EACE,aAAA;AlFgoUN;AkF5nUM;EACE,YAAA;EACA,UAAA;EACA,iBAAA;AlF8nUR;;AkFznUA;EAEE,eAAA;EAAA,gBAAA;AlF2nUF;;AkFvnUA;;;EAGG,gBAAA;AlF0nUH;;AkFpnUA;EACI,gBAAA;EACA,iBjFgCe;ADulUnB;;AkFpnUA;EACI,gBAAA;EACA,wBjF2Be;AD4lUnB;;AkFpnUA;EACI,gBAAA;EACA,wBjFsBe;ADimUnB;;AkFpnUA;EACE;IACE,qBAAA;IACA,QAAA;IACA,SAAA;IACA,oBAAA;IACA,uBAAA;IACA,WAAA;IACA,uBAAA;IACA,qCAAA;IACA,gBAAA;IACA,oCAAA;ElFunUF;AACF;AkFlnUA;EACE;IACI,cjFrOM;EDy1UV;AACF;AoFz9UA;EACE,0BAAA;ApF29UF;AoFz9UE;EACE,UAAA;ApF29UJ;AoFx9UE;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;ApF09UJ;AoFv9UE;EACE,qBAAA;ApFy9UJ;AoFv9UI;EACE,eAAA;ApFy9UN;AoFr9UE;EACE,cnFZI;EmFaJ,iBAAA;EACA,0BnF2XW;EmF1XX,yBAAA;EACA,qBAAA;ApFu9UJ;AoFr9UI;EACE,qBAAA;ApFu9UN;AoFn9UE;EACE,0BnFiXW;EmFhXX,gBAAA;EACA,cnF1BI;AD++UR;AoFl9UE;EACE,cAAA;EACA,WAAA;EACA,YAAA;ApFo9UJ;;AoFh9UA;EACE;IACE,iBAAA;EpFm9UF;EoFj9UE;IACE,iBAAA;IACA,kBAAA;EpFm9UJ;AACF;AoF/8UA;EAEI;IACE,YAAA;IACA,mBAAA;EpFg9UJ;AACF;AoF58UA;EAEI;IACE,cAAA;IACA,kBAAA;IACA,WAAA;EpF68UJ;AACF;AoFz8UA;EACE;IACE,kBAAA;EpF28UF;EoF18UE;IACE,kBAAA;EpF48UJ;EoFz8UE;IACE,WAAA;IACA,eAAA;EpF28UJ;AACF;AqFniVA,kBAAA;ACKG;EACI,cDL2B;EJEhC,UKIsB;ELDtB,0BAAA;AjFmiVF;;AsFhiVG;EACI,cDT2B;EJEhC,UKQsB;ELLtB,0BAAA;AjFyiVF;;AsFliVG;EACI,cDb2B;EJEhC,UKYsB;ELTtB,0BAAA;AjF+iVF;;AsFpiVG;EACI,cDjB2B;EJEhC,UKgBsB;ELbtB,0BAAA;AjFqjVF;;AqFxjVA;EACE,iEAAA;EACA,wBpF+ViB;EoF9VjB,0BpF+Ya;E8EvTX,oGAAA;A/Ew+UJ;AqF5jVE;EACE,qBpFsFM;EoFrFN,6BpFWa;EUrBb,gB0EWA;ArF8jVJ;AqF5jVI;EAII,yBAAA;EACA,iBAAA;EACA,6BpFES;ADyjVjB;AqFvjVE;E1EvBE,gB0E2BE;ArFsjVN;AqFjjVM;EAEI,sBAAA;ArFkjVV;AqF9iVE;EACI,wBpF2Ta;EoF1Tb,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,sBAAA;ArFgjVN;AqF7iVE;EACI,sCAAA;EACA,gCpF5BW;AD2kVjB;AqF5iVE;EAEI,yBpF5CE;ADylVR;;AqFxiVA;;;EAGI,iEAAA;ArF2iVJ;;AqFxiVA;;;EAGE,oDAAA;ArF2iVF;;AqFxiVA;;;;;EAKI,iEAAA;EACA,cpFgCY;EoF/BZ,0CAAA;ArF2iVJ;AqFziVI;;;;;EACI,6BpF5DS;AD2mVjB;;AqFziVI;;EACI,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,cpFGE;EoFFF,eAAA;ArF6iVR;AqFziVM;;EACE,eAAA;EACA,SAAA;ArF4iVR;AqFviVM;;EACE,SAAA;ArF0iVR;AqFriVI;;EACE,wBAAA;ArFwiVN;AqFriVI;;EACE,cpFpBI;AD4jVV;;AqFniVE;EACE,gBAAA;EACA,cpFfY;ADqjVhB;AqFniVE;EACE,cpFnBY;ADwjVhB;;AuFvqVA;EACI,eAAA;EACA,wBtFmWe;ADu0UnB;;AuFxqVA;EACI,gDtF2WgB;ADg0UpB;;AwF7qVA;EACE,SAAA;AxFgrVF;AwF3qVE;EACE,mBAAA;AxF6qVJ;AwF3qVI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,8BAAA;AxF6qVR;AwF3qVI;EACI,cvFkFA;EuFjFA,eAAA;EACA,gBAAA;AxF6qVR;AwF1qVI;EACE,cvF4EE;ADgmVR;AwFzqVI;EACE,eAAA;AxF2qVN;AwFpqVE;EACE,gBAAA;AxFsqVJ;AwFpqVI;EACE,cvF6DE;ADymVR;AwFlqVE;EACE,aAAA,EACA,gBAAA;EACA,8BAAA;AxFoqVJ;AwFlqVI;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AxFoqVN;AwFlqVM;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AxFoqVR;AwF/pVE;EACE,cAAA;AxFiqVJ;;AwF9pVA;EACE,8BAAA;AxFiqVF;;AyFvuVI;EACI,yBxFUA;EwFTA,cxFoGA;ADsoVR;AyFvuVI;EACE,+BAAA;AzFyuVN;AsF3uVG;EACI,+BA+H+B;ELlIpC,UKIsB;ELDtB,0BAAA;AjF+uVF;AsF5uVG;EACI,+BA2H+B;ELlIpC,UKQsB;ELLtB,0BAAA;AjFovVF;AsF7uVG;EACI,+BAuH+B;ELlIpC,UKYsB;ELTtB,0BAAA;AjFyvVF;AsF9uVG;EACI,+BAmH+B;ELlIpC,UKgBsB;ELbtB,0BAAA;AjF8vVF;AsF7nVI;EACI,sCrF1EI;EqF2EJ,crF7HA;AD4vVR;AsF7nVQ;EACI,qBrFhIJ;EqFiII,6BrFtHK;EqFuHL,crFlIJ;ADiwVR;AsFznVQ;;EACI,crFzIJ;ADqwVR;AsFvnVQ;EACI,6BrFpIK;AD6vVjB;AsFrnVI;EACE,eAAA;AtFunVN;AsFpnVI;;EAEI,uCAAA;EACA,sCrFxGI;EqFyGJ,crF3JA;ADixVR;AsFhnVQ;;EAEI,uCAAA;EACA,qBrFpKJ;EqFqKI,crFrKJ;ADuxVR;AsF5mVQ;;EACI,uCAAA;EACA,crF7KJ;AD4xVR;AsF7mVY;;;;EAGI,uCAAA;EACA,crFnLR;ADmyVR;AsF5mVQ;;;;EAEI,uCAAA;AtFgnVZ;AsF9mVY;;;;;;;;;;EAGI,uCAAA;EACA,crF/LR;ADszVR;AsFjnVgB;;;EAEI,uCAAA;EACA,crFxMZ;AD4zVR;AsF/mVQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,crFjNJ;ADo0VR;AsF/mVY;;;;EAEI,uCAAA;EACA,crFxNR;AD20VR;AyFt1VI;EACI,yBxF+FE;EwF9FF,cxFSA;AD+0VR;AyFr1VI;EACE,+BAAA;AzFu1VN;AsFz1VG;EACI,+BA+H+B;ELlIpC,UKIsB;ELDtB,0BAAA;AjF61VF;AsF11VG;EACI,+BA2H+B;ELlIpC,UKQsB;ELLtB,0BAAA;AjFk2VF;AsF31VG;EACI,+BAuH+B;ELlIpC,UKYsB;ELTtB,0BAAA;AjFu2VF;AsF51VG;EACI,+BAmH+B;ELlIpC,UKgBsB;ELbtB,0BAAA;AjF42VF;AsF3uVI;EACI,sCrF1EI;EqF2EJ,crF7HA;AD02VR;AsF3uVQ;EACI,qBrFhIJ;EqFiII,6BrFtHK;EqFuHL,crFlIJ;AD+2VR;AsFvuVQ;;EACI,crFzIJ;ADm3VR;AsFruVQ;EACI,6BrFpIK;AD22VjB;AsFnuVI;EACE,eAAA;AtFquVN;AsFluVI;;EAEI,uCAAA;EACA,sCrFxGI;EqFyGJ,crF3JA;AD+3VR;AsF9tVQ;;EAEI,uCAAA;EACA,qBrFpKJ;EqFqKI,crFrKJ;ADq4VR;AsF1tVQ;;EACI,uCAAA;EACA,crF7KJ;AD04VR;AsF3tVY;;;;EAGI,uCAAA;EACA,crFnLR;ADi5VR;AsF1tVQ;;;;EAEI,uCAAA;AtF8tVZ;AsF5tVY;;;;;;;;;;EAGI,uCAAA;EACA,crF/LR;ADo6VR;AsF/tVgB;;;EAEI,uCAAA;EACA,crFxMZ;AD06VR;AsF7tVQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,crFjNJ;ADk7VR;AsF7tVY;;;;EAEI,uCAAA;EACA,crFxNR;ADy7VR;AyFp8VI;EACI,yBxFoGC;EwFnGD,cxFSA;AD67VR;AyFn8VI;EACE,+BAAA;AzFq8VN;AsFv8VG;EACI,+BA+H+B;ELlIpC,UKIsB;ELDtB,0BAAA;AjF28VF;AsFx8VG;EACI,+BA2H+B;ELlIpC,UKQsB;ELLtB,0BAAA;AjFg9VF;AsFz8VG;EACI,+BAuH+B;ELlIpC,UKYsB;ELTtB,0BAAA;AjFq9VF;AsF18VG;EACI,+BAmH+B;ELlIpC,UKgBsB;ELbtB,0BAAA;AjF09VF;AsFz1VI;EACI,sCrF1EI;EqF2EJ,crF7HA;ADw9VR;AsFz1VQ;EACI,qBrFhIJ;EqFiII,6BrFtHK;EqFuHL,crFlIJ;AD69VR;AsFr1VQ;;EACI,crFzIJ;ADi+VR;AsFn1VQ;EACI,6BrFpIK;ADy9VjB;AsFj1VI;EACE,eAAA;AtFm1VN;AsFh1VI;;EAEI,uCAAA;EACA,sCrFxGI;EqFyGJ,crF3JA;AD6+VR;AsF50VQ;;EAEI,uCAAA;EACA,qBrFpKJ;EqFqKI,crFrKJ;ADm/VR;AsFx0VQ;;EACI,uCAAA;EACA,crF7KJ;ADw/VR;AsFz0VY;;;;EAGI,uCAAA;EACA,crFnLR;AD+/VR;AsFx0VQ;;;;EAEI,uCAAA;AtF40VZ;AsF10VY;;;;;;;;;;EAGI,uCAAA;EACA,crF/LR;ADkhWR;AsF70VgB;;;EAEI,uCAAA;EACA,crFxMZ;ADwhWR;AsF30VQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,crFjNJ;ADgiWR;AsF30VY;;;;EAEI,uCAAA;EACA,crFxNR;ADuiWR;AyFljWI;EACI,yBxFmGE;EwFlGF,cxFSA;AD2iWR;AyFjjWI;EACE,+BAAA;AzFmjWN;AsFrjWG;EACI,+BA+H+B;ELlIpC,UKIsB;ELDtB,0BAAA;AjFyjWF;AsFtjWG;EACI,+BA2H+B;ELlIpC,UKQsB;ELLtB,0BAAA;AjF8jWF;AsFvjWG;EACI,+BAuH+B;ELlIpC,UKYsB;ELTtB,0BAAA;AjFmkWF;AsFxjWG;EACI,+BAmH+B;ELlIpC,UKgBsB;ELbtB,0BAAA;AjFwkWF;AsFv8VI;EACI,sCrF1EI;EqF2EJ,crF7HA;ADskWR;AsFv8VQ;EACI,qBrFhIJ;EqFiII,6BrFtHK;EqFuHL,crFlIJ;AD2kWR;AsFn8VQ;;EACI,crFzIJ;AD+kWR;AsFj8VQ;EACI,6BrFpIK;ADukWjB;AsF/7VI;EACE,eAAA;AtFi8VN;AsF97VI;;EAEI,uCAAA;EACA,sCrFxGI;EqFyGJ,crF3JA;AD2lWR;AsF17VQ;;EAEI,uCAAA;EACA,qBrFpKJ;EqFqKI,crFrKJ;ADimWR;AsFt7VQ;;EACI,uCAAA;EACA,crF7KJ;ADsmWR;AsFv7VY;;;;EAGI,uCAAA;EACA,crFnLR;AD6mWR;AsFt7VQ;;;;EAEI,uCAAA;AtF07VZ;AsFx7VY;;;;;;;;;;EAGI,uCAAA;EACA,crF/LR;ADgoWR;AsF37VgB;;;EAEI,uCAAA;EACA,crFxMZ;ADsoWR;AsFz7VQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,crFjNJ;AD8oWR;AsFz7VY;;;;EAEI,uCAAA;EACA,crFxNR;ADqpWR;AyFhqWI;EACI,yBxFiGE;EwFhGF,cxFSA;ADypWR;AyF/pWI;EACE,+BAAA;AzFiqWN;AsFnqWG;EACI,+BA+H+B;ELlIpC,UKIsB;ELDtB,0BAAA;AjFuqWF;AsFpqWG;EACI,+BA2H+B;ELlIpC,UKQsB;ELLtB,0BAAA;AjF4qWF;AsFrqWG;EACI,+BAuH+B;ELlIpC,UKYsB;ELTtB,0BAAA;AjFirWF;AsFtqWG;EACI,+BAmH+B;ELlIpC,UKgBsB;ELbtB,0BAAA;AjFsrWF;AsFrjWI;EACI,sCrF1EI;EqF2EJ,crF7HA;ADorWR;AsFrjWQ;EACI,qBrFhIJ;EqFiII,6BrFtHK;EqFuHL,crFlIJ;ADyrWR;AsFjjWQ;;EACI,crFzIJ;AD6rWR;AsF/iWQ;EACI,6BrFpIK;ADqrWjB;AsF7iWI;EACE,eAAA;AtF+iWN;AsF5iWI;;EAEI,uCAAA;EACA,sCrFxGI;EqFyGJ,crF3JA;ADysWR;AsFxiWQ;;EAEI,uCAAA;EACA,qBrFpKJ;EqFqKI,crFrKJ;AD+sWR;AsFpiWQ;;EACI,uCAAA;EACA,crF7KJ;ADotWR;AsFriWY;;;;EAGI,uCAAA;EACA,crFnLR;AD2tWR;AsFpiWQ;;;;EAEI,uCAAA;AtFwiWZ;AsFtiWY;;;;;;;;;;EAGI,uCAAA;EACA,crF/LR;AD8uWR;AsFziWgB;;;EAEI,uCAAA;EACA,crFxMZ;ADovWR;AsFviWQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,crFjNJ;AD4vWR;AsFviWY;;;;EAEI,uCAAA;EACA,crFxNR;ADmwWR;AyF9wWI;EACI,yBxFkGD;EwFjGC,cxFSA;ADuwWR;AyF7wWI;EACE,+BAAA;AzF+wWN;AsFjxWG;EACI,+BA+H+B;ELlIpC,UKIsB;ELDtB,0BAAA;AjFqxWF;AsFlxWG;EACI,+BA2H+B;ELlIpC,UKQsB;ELLtB,0BAAA;AjF0xWF;AsFnxWG;EACI,+BAuH+B;ELlIpC,UKYsB;ELTtB,0BAAA;AjF+xWF;AsFpxWG;EACI,+BAmH+B;ELlIpC,UKgBsB;ELbtB,0BAAA;AjFoyWF;AsFnqWI;EACI,sCrF1EI;EqF2EJ,crF7HA;ADkyWR;AsFnqWQ;EACI,qBrFhIJ;EqFiII,6BrFtHK;EqFuHL,crFlIJ;ADuyWR;AsF/pWQ;;EACI,crFzIJ;AD2yWR;AsF7pWQ;EACI,6BrFpIK;ADmyWjB;AsF3pWI;EACE,eAAA;AtF6pWN;AsF1pWI;;EAEI,uCAAA;EACA,sCrFxGI;EqFyGJ,crF3JA;ADuzWR;AsFtpWQ;;EAEI,uCAAA;EACA,qBrFpKJ;EqFqKI,crFrKJ;AD6zWR;AsFlpWQ;;EACI,uCAAA;EACA,crF7KJ;ADk0WR;AsFnpWY;;;;EAGI,uCAAA;EACA,crFnLR;ADy0WR;AsFlpWQ;;;;EAEI,uCAAA;AtFspWZ;AsFppWY;;;;;;;;;;EAGI,uCAAA;EACA,crF/LR;AD41WR;AsFvpWgB;;;EAEI,uCAAA;EACA,crFxMZ;ADk2WR;AsFrpWQ;;;;EAEI,uCAAA;EACA,YAAA;EACA,crFjNJ;AD02WR;AsFrpWY;;;;EAEI,uCAAA;EACA,crFxNR;ADi3WR;AwFzxWI;EACI,cvFCC;EuFAD,iBAAA;AxF2xWR;AwFzxWQ;EAEI,UAAA;AxF0xWZ;AwFrxWM;EACE,gEAAA;EACA,+BAAA;AxFuxWR;AwFrxWU;EACE,+BAAA;AxFuxWZ;AwFnxWU;EACE,+BAAA;AxFqxWZ;AwFjxWM;EACE,cvFlHA;ADq4WR;;AwF7wWE;EACE,iBAAA;EACA,gBAAA;AxFgxWJ;AwF/wWI;EACE,YAAA;EACA,eAAA;EACA,gBAAA;AxFixWN;AwF/wWI;EACE,eAAA;EACA,cvFXQ;AD4xWd;AwF7wWI;EACE,aAAA;AxF+wWN;AwF3wWE;EACE,cvF/Hc;EuFgId,oBAAA;AxF6wWJ;AwF1wWE;EACE,6BAAA;EACA,qBAAA;AxF4wWJ;;A0F16WA;EACE,4BAAA;EACA,WAAA;EACA,aAAA;EACA,mBzF2uBa;ADksVf;A0F36WE;EACE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;A1F66WJ;A0F56WM;EACE,WAAA;A1F86WR;A0F16WE;EACE,aAAA;EACA,mBAAA;A1F46WJ;A0Fz6WE;EACE,czFZI;ADu7WR;A0Fx6WE;EACE,oBAAA;A1F06WJ;A0Fv6WE;EACE,kBAAA;EACA,aAAA;A1Fy6WJ;A0Fr6WE;EACE,kCAAA;A1Fu6WJ;A0Fj6WQ;EACE,czF0DF;ADy2WR;A0F/5WM;EACE,iCAAA;EACA,kBAAA;A1Fi6WR;A0F95WM;EACE,yBAAA;A1Fg6WR;A0F/5WQ;EACE,czF8CF;ADm3WR;A0F35WI;EACE,czFuCE;ADs3WR;A0F15WI;EACE,yBAAA;A1F45WN;A0Fz5WI;EACE,yBAAA;A1F25WN;A0Ft5WE;EACE,8BAAA;A1Fw5WJ;A0Fr5WE;EACE,oCAAA;A1Fu5WJ;A0Fp5WE;EACE,oCAAA;A1Fs5WJ;A0Fn5WE;EACE,oCAAA;A1Fq5WJ;A0Fl5WE;EACE,mEAAA;A1Fo5WJ;A0Fj5WE;EACE,oCAAA;A1Fm5WJ;A0Fh5WE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,czF7FI;EyF8FJ,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,ezFuTa;AD2lWjB;A0F/4WE;EACE,aAAA;A1Fi5WJ;;A0F54WA;EACC,eAAA;EACC,iBAAA;EACA,gBAAA;EACD,qBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;A1F+4WD;A0F74WE;EACC,eAAA;A1F+4WH;;A0F14WA;EACE,mBzFjCO;EyFkCR,czF5HO;EyF6HP,uBzF0NkB;EyFzNlB,WAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACC,SAAA;EACA,WAAA;EACD,yBAAA;A1F64WD;;A0F14WA;EACE,eAAA;A1F64WF;A0F54WE;EACE,czF5II;AD0hXR;A0F54WE;EACE,sBAAA;EACA,eAAA;A1F84WJ;;A0F14WA;EAEM;IACI,mBAAA;IACA,kBAAA;E1F44WR;E0Fx4WM;IACE,SAAA;IACA,eAAA;E1F04WR;E0Fp4WM;IACE,iBAAA;IACA,aAAA;E1Fs4WR;E0Fp4WQ;IACE,kBAAA;E1Fs4WV;E0Fn4WQ;IACE,SAAA;IACA,yBAAA;IACA,gBAAA;E1Fq4WV;E0Fn4WU;IAKE,yBAAA;E1Fi4WZ;E0F33WU;IACE,UAAA;IACA,gBAAA;IACA,iBAAA;E1F63WZ;E0F33WU;IACE,qBAAA;IACA,yBAAA;IACA,gBAAA;E1F63WZ;E0Fz3WQ;IACE,eAAA;E1F23WV;E0Fz3WQ;IACE,aAAA;E1F23WV;E0F13WU;IACE,iBAAA;E1F43WZ;E0Fz3WY;IACE,aAAA;IACA,kBAAA;E1F23Wd;E0Fr3WI;IACI,cAAA;E1Fu3WR;E0Fn3WI;IACI,aAAA;E1Fq3WR;E0Fp3WQ;IACE,czFtIJ;ED4/WN;E0Fl3WI;;IAEI,6BAAA;IACA,SAAA;IACA,gBAAA;IAEA,gBAAA;IACA,WAAA;IACA,gBAAA;IACA,eAAA;E1Fo3WR;E0Fl3WQ;;IACI,aAAA;E1Fq3WZ;E0Fj3WI;;IAEI,czFvPF;ED0mXN;E0Fh3WI;IAEI,czFxKA;EDyhXR;E0F92WI;IACE,cAAA;E1Fg3WN;E0F72WI;IACI,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,mBzFzQF;EDwnXN;E0F72WQ;IACE,WAAA;IACA,UAAA;IACA,kBAAA;IACA,kBAAA;E1F+2WV;E0F52WQ;IACI,eAAA;E1F82WZ;E0F32WQ;IACI,eAAA;E1F62WZ;E0F12WQ;IACI,WAAA;IACA,6BAAA;E1F42WZ;E0Fx2WI;IACI,yBzF7MA;EDujXR;E0Fv2WI;IACI,WAAA;E1Fy2WR;E0Fv2WQ;IACI,eAAA;E1Fy2WZ;E0Fr2WI;IACE,iBAAA;IACA,kBAAA;E1Fu2WN;E0Fj2WQ;;IAEI,YAAA;E1Fm2WZ;E0F91WA;;;IAGE,8BAAA;E1Fg2WF;E0F91WA;IACE,QAAA;IXvSC,+BAAA;IAGA,6BAAA;E/E0oXH;E0Fn2WA;IACE,UAAA;E1Fq2WF;E0Fn2WA;IACE,WAAA;IX9SC,kCAAA;IAGA,6BAAA;E/EspXH;E0Fx2WA;IACE,QAAA;IXlTC,4BAAA;IAGA,6BAAA;E/E+pXH;E0F72WA;IACE,UAAA;E1F+2WF;E0F72WA;IACE,WAAA;IXzTC,+BAAA;IAGA,6BAAA;E/E2qXH;E+ElnXE;IACE;MAAI,QAAA;MAAU,uBAAA;I/EsnXhB;I+ErnXE;MAAK,QAAA;MAAU,yBAAA;I/EynXjB;I+ExnXE;MAAK,yBAAA;I/E2nXP;I+E1nXE;MAAM,yBAAA;I/E6nXR;EACF;E+E7mXE;IACE;MAAK,QAAA;MAAU,yBAAA;I/EipXjB;I+EhpXE;MAAM,yBAAA;I/EmpXR;I+ElpXE;MAAM,uBAAA;I/EqpXR;I+EppXE;MAAO,QAAA;MAAU,oBAAA;I/EwpXnB;EACF;E+EtoXE;IACE;MAAI,WAAA;MAAa,uBAAA;I/E0qXnB;I+EzqXE;MAAK,WAAA;MAAa,0BAAA;I/E6qXpB;I+E5qXE;MAAK,0BAAA;I/E+qXP;I+E9qXE;MAAM,0BAAA;I/EirXR;EACF;E+EjqXE;IACE;MAAK,WAAA;MAAY,0BAAA;I/EqsXnB;I+EpsXE;MAAM,wBAAA;I/EusXR;I+EtsXE;MAAM,wBAAA;I/EysXR;I+ExsXE;MAAO,WAAA;MAAY,oBAAA;I/E4sXrB;EACF;E0FpgXA;IACE;MAAI,UAAA;I1FujXJ;I0FtjXA;MAAM,UAAA;I1FyjXN;EACF;AACF;A0FtjXA;EACE;IACE,2BAAA;E1FwjXF;E0FrjXA;IACE,aAAA;E1FujXF;E0FljXI;IACE,UAAA;IACA,kBAAA;E1FojXN;E0F9iXE;IACE,kBAAA;IACA,SAAA;IACA,QAAA;IACA,cAAA;E1FgjXJ;E0F7iXE;IACE,qBAAA;IACA,oBAAA;E1F+iXJ;AACF;A0F5iXA;EACE;IACI,cAAA;IACA,eAAA;E1F8iXJ;E0F3iXE;IACE,kBAAA;E1F6iXJ;E0FziXE;IACE,WAAA;IACA,kBAAA;IACA,WAAA;IAAA,cAAA;IACA,kBAAA;E1F2iXJ;E0FtiXI;IACE,YAAA;IACA,kBAAA;IACA,UAAA;IAAA,aAAA;IACA,kBAAA;E1FwiXN;AACF;A2Fx9XA;EACE,kCAAA;EACA,mCAAA;A3F09XF;;A2Fv9XA;;EAEE,gB1FqaqB;ADqjXvB;;A2Fv9XA;EACE,gB1FoZkB;ADskXpB;;A2Fv9XA;;;;;EAKI,kC1F0Xe;ADgmXnB;;A2Fv9XE;EACE,+B1FyCQ;ADi7XZ;;A2Fv9XA;EACI,gB1FqYiB;E0FpYjB,+B1FoCQ;ADs7XZ;;A2Fv9XA;EACI,c1F2Ea;E0F1Eb,gB1F8XgB;AD4lXpB;A2Fz9XI;EAEI,c1F6DE;AD65XV;;A2Fv9XA;EACI,iBAAA;EACA,mBAAA;A3F09XJ;A2Fx9XI;EACI,gB1FqXW;E0FpXX,yBAAA;EACA,YAAA;A3F09XR;;A2Ft9XA;EACI,mBAAA;EACA,gBAAA;A3Fy9XJ;;A2Ft9XA;EACI,mBAAA;EACA,kBAAA;A3Fy9XJ;;A2Fv9XA;EACI,mBAAA;EACA,mB1FyQmB;ADitXvB;A2Fx9XI;EAEI,iBAAA;A3Fy9XR;;A2Ft9XA;EACI,kBAAA;EACA,mBAAA;A3Fy9XJ;;A2Fv9XA;EACI,yBAAA;EACA,gB1FuVe;ADmoXnB;;A2Fx9XA;EACI,+B1FbQ;E0FcR,kBAAA;A3F29XJ;A2Fz9XI;EACI,iBAAA;A3F29XR;;A2Ft9XA;EACI,gB1F0Ue;AD+oXnB;A2Fx9XI;EACI,yBAAA;A3F09XR;A2Fx9XQ;EACI,c1FWJ;E0FVI,qBAAA;A3F09XZ;A2Fv9XI;EACI,iBAAA;A3Fy9XR;;A2Fr9XA;;;;EAII,c1FsBQ;E0FrBR,gB1FqTgB;ADmqXpB;;A2Ft9XA;;EAEI,0BAAA;EACA,gB1FiTiB;E0FhTjB,+BAAA;EACA,0B1FoSW;ADqrXf;;A2Ft9XA;EACI,0B1FgSW;ADyrXf;;A2Ft9XA;EACI,iBAAA;EACA,yBAAA;EACA,aAAA;EACA,oB1FyVmB;E0FxVnB,gBAAA;A3Fy9XJ;A2Fv9XI;EACI,c1FhCE;E0FiCF,0B1FoRO;E0FnRP,yBAAA;A3Fy9XR;A2Ft9XI;EACI,qB1FrCE;E0FsCF,c1FtCE;AD8/XV;A2Ft9XQ;EACI,c1FzCF;ADigYV;A2Fp9XI;EACI,qB1FzCC;E0F0CD,c1F1CC;ADggYT;A2Fp9XQ;EACI,c1F7CH;ADmgYT;A2Fl9XI;EACI,sC1FxFI;E0FyFJ,c1F7IA;ADimYR;A2Fl9XQ;EACI,+B1F5FA;ADgjYZ;;A2F/8XA;EACE,c1FtJM;ADwmYR;;A2F/8XA;EACE,+B1FtGU;ADwjYZ;;A2F/8XA;EACE,wCAAA;EACA,gB1F2GO;E0F1GP,mB1F0GO;ADw2XT;;A4F7nYE;EACE,0CAAA;A5FgoYJ;A4F9nYI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;A5FgoYN;A4F9nYM;EACE,WAAA;A5FgoYR;A4F3nYE;EACE,wDAAA;A5F6nYJ;A4F1nYE;EACE,yB3F8EG;AD8iYP;A4FznYE;EACE,yB3FuEM;ADojYV;A4FxnYE;EACE,yB3FuEM;ADmjYV;A4FxnYE;EACE,yB3FqEK;ADqjYT;A4FvnYI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;A5FynYN;A4FtnYI;EACE,eAAA;EACA,WAAA;A5FwnYN;A4FrnYI;EACI,SAAA;EACA,eAAA;A5FunYR;A4FrnYQ;EAEI,UAAA;EACA,SAAA;A5FsnYZ;A4FlnYI;EACI,SAAA;A5FonYR;A4FjnYI;EACE,gBAAA;A5FmnYN;A4FhnYI;EACI,gBAAA;A5FknYR;A4FhnYQ;;;;;;EAMI,gBAAA;EACA,mBAAA;A5FknYZ;A4F9mYG;EACI,wBAAA;EACA,eAAA;EACA,yBAAA;EACA,gB3F4UkB;E2F3UlB,SAAA;EACA,+BAAA;A5FgnYP;A4F7mYG;;EAEI,aAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;A5F+mYP;A4F7mYO;;EACI,kBAAA;A5FgnYX;A4F5mYY;;;EAEI,UAAA;EACA,UAAA;A5F+mYhB;A4F3mYG;;;;;;EAMI,sCAAA;EACA,iBAAA;EACA,sBAAA;A5F6mYP;A4F1mYG;EACG,YAAA;A5F4mYN;A4FzmYG;EACI,gBAAA;A5F2mYP;A4FzmYG;EACI,eAAA;EACA,gB3F6Ra;E2F5Rb,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;A5F2mYP;A4FzmYG;EACK,gB3FwRW;E2FvRX,yB3FkRO;E2FjRP,iBAAA;EACA,iBAAA;A5F2mYR;A4FxmYG;EACC,WAAA;A5F0mYJ;A4FvmYI;EACI,kBAAA;A5FymYR;A4FtmYI;EACE,6BAAA;EACA,yBAAA;A5FwmYN;;A4FpmYA;EACE,gBAAA;EACA,oBAAA;A5FumYF;;A4FpmYA;EACI,mBAAA;A5FumYJ;;A6F1wYA;EACC,kBAAA;EACA,eAAA;A7F6wYD;;A6F1wYA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EAKA,6BAAA;A7F6wYF;;A6F3wYA;EACI,kBAAA;A7F8wYJ;;A6F3wYA;EACE,iBAAA;EACA,kBAAA;A7F8wYF;;A6F3wYA;;EAEE,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,qEAAA;EAKA,+BAAA;A7F8wYF;;A6F3wYA;;EAEE,YAAA;EACA,yB5FgDQ;AD8tYV;;A6F3wYC;EACC,qBAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,c5F/CM;E4FgDN,gB5FqWiB;E4FpWjB,SAAA;EACA,yBAAA;A7F8wYF;;A6F3wYA;;EAEI,c5F4DQ;E4F3DR,YAAA;EACA,mBAAA;A7F8wYJ;;A6F3wYA;;EAEE,UAAA;EACA,kBAAA;EACA,kBAAA;A7F8wYF;;A6F5wYA;EACE,UAAA;EACA,eAAA;EACA,aAAA;A7F+wYF;;A6F3wYA;EACE,UAAA;EACA,eAAA;EACA,aAAA;A7F8wYF;;A6F3wYA;;EAEI,mBAAA;A7F8wYJ;;A6F3wYA;;EAEI,oBAAA;A7F8wYJ;;A6F3wYA;EACE,gBAAA;A7F8wYF;;A6F5wYA;;EAEE,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qEAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EAKA,+BAAA;A7F+wYF;;A6F5wYA;;EAEI,UAAA;A7F+wYJ;;A6F7wYA;EACI,UAAA;EACA,WAAA;EACA,yB5FjCM;E4FkCN,qB5FlCM;E4FmCN,QAAA;EACA,SAAA;EACA,UAAA;A7FgxYJ;;A6F7wYA;EACE,qB5FzCQ;ADyzYV;;A6F5wYA;EACI,UAAA;A7F+wYJ;;A6F5wYA;EACE,c5FpBU;ADmyYZ;;A6F5wYA;;EAEE,c5FzBU;ADwyYZ;;A8Fv6YA;EACI,eAAA;EACA,QAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,UAAA;A9F06YJ;A8Fx6YI;;EAEI,qBAAA;EACA,6BAAA;EACA,0BAAA;A9F06YR;A8Fv6YI;EACI,c7FNA;E6FOA,aAAA;EACA,0BAAA;EACA,WAAA;A9Fy6YR;A8Ft6YI;EACI,WAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,6CAAA;A9Fw6YR;A8Fr6YI;EACE,QAAA;A9Fu6YN;A8Fp6YI;;EAEI,WAAA;EACA,iBAAA;EACA,UAAA;A9Fs6YR;A8Fn6YI;EACI,c7FlCA;ADu8YR;A8Fl6YI;EACI,c7FmFM;ADi1Yd;A8Fj6YI;;;EAGI,c7FyEM;E6FxEN,kBAAA;A9Fm6YR;A8Fh6YI;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;A9Fk6YR;A8F/5YI;;EAEI,gBAAA;A9Fi6YR;A8F95YI;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;A9Fg6YR;A8F75YI;;EAEI,qB7F2BO;ADo4Yf;A8F55YI;EACE,SAAA;EACA,yBAAA;A9F85YN;A8F75YM;EACE,yBAAA;A9F+5YR;A8F35YI;EACE,mB7FrFE;ADk/YR;A8F55YM;EACE,mB7FvFA;ADq/YR;A8F15YI;EACE,mB7FDE;AD65YR;A8F35YM;EACE,mB7FHA;ADg6YR;A8Fz5YI;EACE,YAAA;A9F25YN;A8Fx5YI;EACI,cAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;A9F05YR;A8Fv5YI;;;EAGI,WAAA;EACA,YAAA;EACA,mBAAA;A9Fy5YR;A8Ft5YI;EACI,YAAA;A9Fw5YR;A8Ft5YQ;EACI,kBAAA;A9Fw5YZ;A8Fp5YI;EACI,kBAAA;EACA,eAAA;EACA,YAAA;A9Fs5YR;A8Fn5YI;EACI,c7FpIA;E6FqIA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;A9Fq5YR;A8Fh5YQ;EACI,kBAAA;A9Fk5YZ;A8Fh5YY;EACI,kBAAA;EACA,SAAA;A9Fk5YhB;A8F/4YY;;EAEI,kBAAA;A9Fi5YhB;A8F74YQ;EACI,kBAAA;A9F+4YZ;A8F74YY;EACE,kBAAA;EACA,WAAA;EACA,qB7FuOC;E6FtOD,c7FpKN;ADmjZR;A8F74Yc;EACE,UAAA;A9F+4YhB;A8F34YY;EACI,eAAA;A9F64YhB;A8Fz4YQ;EACE,kBAAA;EACA,SAAA;EACA,qB7FuNK;E6FtNL,c7FpLF;AD+jZR;A8Fx4YQ;EACM,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,SAAA;A9F04Yd;A8Fl4YY;EACM,e7FmND;E6FlNC,kBAAA;EACA,mBAAA;EACA,yB7FxMV;E6FyMU,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;A9Fo4YlB;A8Fl4YkB;EACG,gBAAA;A9Fo4YrB;A8Fh4YY;EAEI,6BAAA;A9Fi4YhB;A8F53YgB;EACI,qCAAA;A9F83YpB;A8Fz3YQ;;EAEI,qB7F9GE;E6F+GF,yB7FxOJ;ADmmZR;A8Ft3YI;EACI,UAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;A9Fw3YR;A8Fp3YQ;EACI,iBAAA;A9Fs3YZ;A8Fn3YQ;EACI,gBAAA;A9Fq3YZ;A8Fh3YQ;EAKK,2BAAA;EACA,SAAA;EACA,UAAA;EAEA,qBAAA;A9Fi3Yb;A8F/2Ya;EACI,2CAAA;EACA,2CAAA;EACA,wCAAA;EACA,YAAA;EACA,SAAA;A9Fi3YjB;A8F92Ya;EACI,2CAAA;EACA,gCAAA;EACA,wCAAA;EACA,YAAA;A9Fg3YjB;A8F72Ya;EAEI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;A9F82YjB;A8F12YQ;EACK,UAAA;EAMA,2BAAA;EAEA,qBAAA;A9F02Yb;A8Ft2YI;EACI,SAAA;A9Fw2YR;;A+FzqZA;EAEE,MAAA;EAEA,iBAAA;A/F0qZF;A+FxqZE;EACE,iBAAA;EACA,YAAA;A/F0qZJ;;A+FtqZA;;;EAGE,iBAAA;A/FyqZF;;A+FvqZA;;EhB2CI,mB9E+Ca;E8E3Cb,2DAAA;EgB5CF,0BAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,sBAAA;EACA,kCAAA;EACA,cAAA;EACA,+CAAA;EACA,gBAAA;EAEA,kBAAA;A/F6qZF;A+F3qZE;;EACE,W9F+tBS;E8F9tBT,gBAAA;EACA,+BAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;A/F8qZJ;A+F5qZI;;EACE,wBAAA;A/F+qZN;A+F5qZI;;EACE,YAAA;A/F+qZN;A+FzqZQ;;;;EACE,qBAAA;A/F8qZV;A+F1qZQ;;;;EACE,SAAA;EACA,kBAAA;EACA,0BAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,+B9FHE;ADkrZZ;A+F5qZQ;;;;EACE,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,+B9FnBE;ADosZZ;A+F9qZQ;;;;EACE,eAAA;EACA,iBAAA;EACA,WAAA;A/FmrZV;A+F7qZM;;;;EAEE,c9FrFA;ADswZR;A+F7qZI;;EACE,UAAA;A/FgrZN;A+F5qZE;;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;A/F+qZJ;A+F3qZE;;EACE,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;A/F8qZJ;A+F5qZI;;EACE,WAAA;EACA,YAAA;A/F+qZN;A+F3qZE;;EACE,gBAAA;EACA,cAAA;A/F8qZJ;A+F5qZI;;EACE,SAAA;EACA,kBAAA;EACA,WAAA;A/F+qZN;A+F3qZM;;EACE,eAAA;A/F8qZR;A+F7qZQ;;EACE,eAAA;EACA,gBAAA;A/FgrZV;A+F5qZM;;EACE,mBAAA;EACA,mB9FqaW;E8FpaX,c9F3IA;E8F4IA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,qB9FyPO;E8FxPP,iBAAA;EACA,qB9FzGS;ADwxZjB;A+F5qZM;;EACE,cAAA;A/F+qZR;A+F1qZQ;;;;;;;EAEE,c9F9JF;AD+0ZR;A+F7qZM;;;EAEE,c9FpKA;ADo1ZR;A+F7qZM;;EACE,uBAAA;A/FgrZR;A+F9qZQ;;;;EAEE,YAAA;A/FkrZV;A+F/qZQ;;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,mB9FtLF;E8FuLE,kBAAA;A/FkrZV;A+F9qZM;;EACE,uBAAA;EACA,gBAAA;EACA,c9F9LA;AD+2ZR;A+F/qZQ;;EACE,c9FjMF;ADm3ZR;A+F/qZQ;;EACE,gBAAA;A/FkrZV;A+FjrZU;;;;EAEE,c9FxMJ;E8FyMI,gB9F2MS;AD0+YrB;A+FlrZU;;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,mB9FnNJ;E8FoNI,kBAAA;A/FqrZZ;A+FlrZQ;;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,oCAAA;EACA,kBAAA;A/FqrZV;A+FhrZI;;EACE,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;A/FmrZN;A+F/qZI;;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,+B9FjMM;E8FkMN,kBAAA;A/FkrZN;A+F9qZE;;EACE,kBAAA;EACA,sBAAA;EACA,UAAA;A/FirZJ;A+F1qZI;;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;A/F6qZN;A+F5qZM;;EACE,kBAAA;EACA,WAAA;A/F+qZR;A+F3qZI;;EACE,cAAA;EACA,UAAA;EhBzRE,iCAAA;A/E48ZR;A+F/qZI;;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,oC9F5OM;AD85ZZ;A+F/qZI;;EACE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,c9FrSE;E8FsSF,iBAAA;EACA,2DAAA;A/FkrZN;A+F/qZI;;EACE,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EAEA,c9FhTE;E8FiTF,qBAAA;EACA,gB9FkGe;E8FjGf,iBAAA;EACA,gBAAA;A/FirZN;A+F7qZE;;EACE,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;A/FgrZJ;A+F9qZI;;EACE,WAAA;EACA,YAAA;A/FirZN;A+F7qZE;;EhBvRE,mB9EiDU;E8E7CV,2DAAA;A/Ew8ZJ;A+FlrZE;;EhB1RE,mB9EgDa;E8E5Cb,2DAAA;A/Eg9ZJ;A+FtrZE;;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;A/FyrZJ;A+FvrZI;;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,oC9FxSM;ADk+ZZ;A+FvrZI;;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gD9FFc;AD4rZpB;A+FvrZM;;EACE,W9F4YK;AD8yYb;A+FtrZI;;EACE,c9F/WE;E8FgXF,qBAAA;EACA,oBAAA;EACA,mBAAA;A/FyrZN;A+FprZM;;EACE,cAAA;EACA,iBAAA;A/FurZR;A+FrrZQ;;EAEE,cAAA;EACA,kBAAA;EACA,UAAA;A/FurZV;A+FnrZM;;EACE,kBAAA;EACA,QAAA;EACA,WAAA;A/FsrZR;A+FvjaA;;EAsYE,sDAAA;A/FqrZF;;A+FlrZA;EACE,gCAAA;A/FqrZF;;A+FnrZA;EACE,wBAAA;A/FsrZF;;A+FjrZI;;EAEE,c9FzZE;AD6kaR;A+FjrZI;EACE,oCAAA;A/FmrZN;;A+F9qZA;EACE,kBAAA;EACA,YAAA;EACA,W9FiVW;E8FhVX,iBAAA;EAEA,6CAAA;EhB9ZE,0DAAA;A/EmlaJ;A+FhqZE;EACE,gBAAA;A/FkqZJ;A+F/pZE;EACE,mBAAA;A/FiqZJ;;A+F5pZE;EACE,YAAA;EACA,gBAAA;A/F+pZJ;;A+F3pZA;;;EAGE,iCAAA;A/F8pZF;;A+F3pZA;EACE;;;IAIE,uCAAA;IAEA,sCAAA;IAEA,gDAAA;E/F8pZF;E+F1pZE;IACE,wBAAA;E/F4pZJ;E+F1pZE;IACE,gCAAA;E/F4pZJ;E+FzpZE;IACE,WAAA;E/F2pZJ;E+FzpZI;IACE,sBAAA;E/F2pZN;E+FvpZE;IACE,cAAA;IACA,aAAA;IACA,iF9F5Ie;EDqyZnB;E+FtpZM;IACE,UAAA;IhB5fF,mCAAA;E/EypaN;E+FvpZM;;;;IhBlgBA,mCAAA;IgBugBE,UAAA;E/F6pZR;E+FzpZI;IACE,UAAA;E/F2pZN;E+FvpZE;IACE,YAAA;E/FypZJ;E+FtpZM;IACE,UAAA;IhBrhBF,+BAAA;E/EkraN;E+FxpZI;IACE,UAAA;E/F0pZN;E+FxpZI;IACE,YAAA;E/F0pZN;E+FxpZM;;;;IhBhiBA,iCAAA;IgBqiBE,UAAA;E/F8pZR;E+F1pZI;IACE,UAAA;E/F4pZN;E+FvpZI;IACE,mBAAA;IACA,mBAAA;E/FypZN;E+FrpZE;IACE,iBAAA;E/FupZJ;E+FlpZE;IACE,iBAAA;E/FopZJ;E+FnpZI;IACE,c9FxjBA;I8FyjBA,eAAA;E/FqpZN;AACF;A+FhpZA;EACE,aAAA;EACA,iBAAA;EACA,oBAAA;EAIA,kBAAA;EACA,gBAAA;A/F+oZF;A+F5oZI;EACE,c9F3kBE;ADytaR;A+F5oZI;EACE,gBAAA;EACA,+B9F7hBM;E8F8hBN,cAAA;EACA,eAAA;A/F8oZN;A+F5oZM;EACE,c9FplBA;ADkuaR;;A+FxoZA;EACE,aAAA;A/F2oZF;;A+FxoZA;EACE,aAAA;A/F2oZF;;A+FxoZA;EACE;IACE,eAAA;IACA,cAAA;IACA,MAAA;IACA,YAAA;IACA,YAAA;IACA,WAAA;IACA,OAAA;IACA,SAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,UAAA;I3EvnBE,sD2EwnBF;IhBvnBI,oCAAA;E/EuwaN;AACF;AoBrwaE;E2EsmBA;I3ErmBE,gBAAA;EpBwwaF;AACF;A+FrqZA;EAmBE;I3E5nBI,uD2E6nBF;E/FqpZF;AACF;AoB/waE;E2EwnBA;I3EvnBE,gBAAA;EpBkxaF;AACF;A+F/qZA;EAuBE;IACE,WAAA;E/F2pZF;E+F1pZE;IACE,kBAAA;E/F4pZJ;E+FvpZE;IACE,QAAA;IhBxoBE,mCAAA;E/EsyaN;E+F1pZE;I3E7oBE,sD2E8oBA;IhB7oBE,iCAAA;E/E8yaN;AACF;AoB5yaE;E2EyoBE;I3ExoBA,gBAAA;EpB+yaF;AACF;A+F5sZA;EAuCM;IACE,eAAA;IAAA,gBAAA;E/FwqZN;E+FpqZE;IACE,kBAAA;IACA,kBAAA;E/FsqZJ;E+FlqZI;IhB1pBE,oCAAA;E/Em0aN;E+FrqZI;;IhB9pBE,iCAAA;E/E20aN;E+FxqZI;IACE,YAAA;IACA,UAAA;E/F0qZN;E+FvqZE;IACE,aAAA;E/FyqZJ;E+FpqZE;IACE,UAAA;IACA,QAAA;IhBhrBE,mCAAA;E/E21aN;E+FtqZA;IACE,YAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,MAAA;IACA,QAAA;IACA,WAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;IACA,6BAAA;I3EjsBE,uD2EksBF;E/FwqZF;AACF;AoBv2aE;E2EkrBA;I3EjrBE,gBAAA;EpB02aF;AACF;A+FvwZA;EA2FE;IACE,2BAAA;E/F+qZF;AACF;A+F5qZA;EACE;IACE,kBAAA;IACA,mBAAA;E/F8qZF;AACF;AgG/3aA,eAAA;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;EjBoBI,6BAAA;A/E24aJ;;AgGh5aA;;EjBKI,6BAAA;A/Eo5aJ;;AgGp5aA;;;;EjBuBI,gEAAA;EAGA,yBAAA;A/Eo4aJ;;AgGv5aA;EACE,QAAA;EACA,SAAA;EACA,sBAAA;EACA,sBAAA;EACA,mCAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AhG05aF;;AgGv5aA;EACE,WAAA;AhG05aF;;AgGx5aA;EACE,YAAA;AhG25aF;;AgGn5aI;EACE,mBAAA;AhGs5aN;;AgGh5aE;EACE,c/FlDI;ADq8aR;AgG/4aI;;EAEE,wBAAA;AhGi5aN;;AgGx4aE;EACE,cAAA;AhG24aJ;AgGv4aE;EACE,c/FoBI;ADq3aR;AgGr4aE;EACE,+BAAA;AhGu4aJ;AgGr4aE;EACE,6CAAA;AhGu4aJ;AgGn4aE;EACE,gBAAA;AhGq4aJ;AgGn4aI;EACE,0CAAA;AhGq4aN;AgG/3aI;EACE,aAAA;AhGi4aN;AgG/3aI;EACE,qBAAA;AhGi4aN;AgG93aI;EACE,c/FrGE;ADq+aR;AgG73aI;EACA,4BAAA;AhG+3aJ;AgG13aM;EACE,c/FtGG;ADk+aX;AgGx3aI;EACE,+BAAA;AhG03aN;AgGt3aE;;EAEE,6BAAA;AhGw3aJ;AgGr3aE;;EAEE,6BAAA;AhGu3aJ;AgGp3aE;EACE,gBAAA;AhGs3aJ;AgGj3aI;;EACE,6BAAA;AhGo3aN;AgGj3aI;;;;;;;;;;;;;;EAEE,6BAAA;AhG+3aN;AgG33aM;;;;EACE,c/F9DE;AD87aV;AgG33aI;;EACE,c/FpEI;ADk8aV;AgGz3aI;EACE,qBAAA;AhG23aN;;AgGv3aA;EAEE,4BAAA;AhG03aF;;AgGv3aA;EACE,c/FvIK;ADigbP;;AgGv3aA;EACI;IACI,iBAAA;EhG03aN;EgGv3aE;IACI,aAAA;EhGy3aN;EgGt3aE;IACE,YAAA;EhGw3aJ;EgGr3aE;IACI,aAAA;EhGu3aN;AACF;AgGl3aA;EAEI;IACI,cAAA;IACA,mBAAA;EhGm3aN;AACF;AgG/2aA;EAEQ;IACI,UAAA;EhGg3aV;EgG52aE;IACE,mBAAA;IACA,cAAA;EhG82aJ;EgG72aI;IACE,eAAA;EhG+2aN;AACF;AiG/kbE;;EAEE,QAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AjGilbJ;AiG9kbQ;;EACE,YAAA;EACA,iBAAA;EACA,eAAA;AjGilbV;AiG9kbQ;;EACE,kBAAA;EACA,iBAAA;AjGilbV;AiG9kbQ;;EACE,UAAA;EACA,WAAA;AjGilbV;AiG5kbQ;;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;AjG+kbV;AiG5kbQ;;EACE,iBAAA;AjG+kbV;AiG3kbI;;;;EAEE,YAAA;EACA,iBAAA;EACA,eAAA;AjG+kbN;AiG5kbI;;;;EAEE,iBAAA;AjGglbN;AiG7kbI;;EACE,WAAA;EACA,UAAA;AjGglbN;AiG5kbE;EACE,6BAAA;AjG8kbJ;AiG3kbE;EACE,0BAAA;AjG6kbJ;AiG1kbE;EACE,qBAAA;EACA,cAAA;AjG4kbJ;AiGzkbE;EACE,wBAAA;EACA,UAAA;AjG2kbJ;AiGzkbI;EACE,WAAA;EACA,UAAA;AjG2kbN;AiGvkbE;EACE,UAAA;EACA,WAAA;AjGykbJ;AiGtkbE;EACE,WAAA;EACA,OAAA;AjGwkbJ;AiGpkbE;EACE,YAAA;AjGskbJ;AiGnkbE;EACE,OAAA;EACA,cAAA;EACA,eAAA;AjGqkbJ;AiGpkbM;EACE,qBAAA;EACA,sBAAA;AjGskbR;AiGnkbM;EACE,WAAA;EACA,UAAA;AjGqkbR;AiGhkbM;EACE,mBAAA;EACA,kBAAA;AjGkkbR;AiG/jbM;EACE,WAAA;EACA,UAAA;AjGikbR;AiG7jbE;EACE,cAAA;AjG+jbJ;AiG5jbE;EACE,kBAAA;EACA,UAAA;AjG8jbJ;AiG1jbE;EACE;IACE,oBAAA;IACA,kBAAA;EjG4jbJ;EiGzjbE;IACE,oBAAA;IACA,kBAAA;EjG2jbJ;EiGxjbE;IACE,kBAAA;EjG0jbJ;AACF;AiGrjbE;EAEE;IACE,eAAA;EjGsjbJ;EiGpjbE;IACE,mBAAA;EjGsjbJ;EiGnjbE;IACE,YAAA;IACA,UAAA;EjGqjbJ;EiGljbE;IACE,mBAAA;EjGojbJ;AACF;AiGhjbI;EACE,gBAAA;AjGkjbN;AiGjjbM;EACE,iBAAA;AjGmjbR;AiGljbQ;EACE,iBAAA;AjGojbV;AiGhjbM;EACE,eAAA;EACA,UAAA;AjGkjbR;AiGjjbQ;EACE,gBAAA;EACA,iBAAA;AjGmjbV;AiG/ibM;EACE,kBAAA;AjGijbR;AiG5ibE;EACE,sBAAA;EACA,OAAA;AjG8ibJ;AiG3ibE;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AjG6ibJ;AiG3ibE;EACE,0BAAA;EACA,OAAA;EACA,WAAA;EAAA,cAAA;AjG6ibJ;AiG5ibI;EACE,qBAAA;EACA,sBAAA;AjG8ibN;AiG7ibM;EACE,UAAA;EACA,kBAAA;EACA,WAAA;AjG+ibR;AiG7ibM;EACE,WAAA;EAAA,cAAA;EACA,WAAA;EACA,cAAA;EAAA,oBAAA;EACA,4CAAA;AjG+ibR;AiG7ibM;EACE,WAAA;EAAA,cAAA;EACA,WAAA;EACA,cAAA;EAAA,oBAAA;EACA,iCAAA;AjG+ibR;AiG3ibE;EACE,UAAA;EAAA,aAAA;EACA,WAAA;AjG6ibJ;;AiGxibA;EAEE;IACE,kBAAA;IACA,mBAAA;EjG0ibF;AACF;AkG5xbA;;EAEE,cjG6Gc;ADirbhB;;AkG1xbA;;EAEE,cjG2FQ;ADksbV;;AsF5vbQ;;EACI,yBAAA;AtFgwbZ;AsF7vbQ;;EACI,kBAAA;AtFgwbZ;AsF9vbY;;;EAEI,yBAAA;AtFiwbhB;;AsFxvbQ;;EACI,kBAAA;EACA,YAAA;AtF4vbZ;AsF1vbY;;;EAEI,yBAAA;AtF6vbhB;AsFzvbQ;;;;EAEI,yBAAA;AtF6vbZ;AsF3vbY;;;;EACI,4BAAA;AtFgwbhB;;AsFrvbQ;;EACI,kBAAA;AtFyvbZ;AsFvvbY;;;EAEI,yBAAA;AtF0vbhB;AsFtvbQ;;;;EAEI,yBAAA;AtF0vbZ;;AsFpvbQ;;EACI,4BAAA;AtFwvbZ;AsFtvbY;;;EAEI,yBAAA;AtFyvbhB;AsFrvbQ;;;;EAEI,yBAAA;AtFyvbZ;AsFvvbY;;;;;;;EAEI,4BAAA;AtF8vbhB;;AkGn2bI;;;;;;EAII,qEAAA;EACA,mBAAA;AlGw2bR;AkGv2bQ;;;;;;;;;;;;;;;;EAGI,mBAAA;EACA,qEAAA;AlGs3bZ;AkGh3bY;;;EAEI,qEAAA;AlGm3bhB;AkG92bI;;;;EAEI,qEAAA;EACA,YAAA;AlGk3bR;;AkG72bI;EACI,cjG+DQ;ADizbhB;;AkG52bI;EACI,cjG8CE;ADi0bV;;AkG32bA;;EAEI,6BAAA;EACA,qEAAA;EACA,wBjGuSe;EiGtSf,cjGlDI;ADg6bR;AkG52bI;;EACE,YAAA;AlG+2bN;AkGv3bA;;EnBqCI,oGAAA;A/E01bJ;AkGl3bI;;EACI,6BjGhDS;ADq6bjB;AkGl3bI;;EACI,6BjGpDS;ADy6bjB;AkGn3bI;;EACI,cjGiCQ;ADq1bhB;AkGp3bI;;EACI,cjGkBE;ADq2bV;AkGp3bI;;;EZnFA,uBAAA;EYsFI,kBAAA;AlGu3bR;AkGp3bI;;EACI,WAAA;AlGu3bR;;AkGn3bA;;;EAGI,6BAAA;EACA,qEAAA;EACA,wBjGgQe;EiG/Pf,cjGzFI;EiG0FJ,SAAA;AlGs3bJ;;AkGn3bA;EACE,iBAAA;AlGs3bF;;AkGp3bA;EACE,kBAAA;AlGu3bF;;AkGn3bI;;EAEI,yBjGvGA;EiGwGA,qBjGnBE;EiGoBF,6BjG9FS;EiG+FT,qBjGrBE;AD24bV;AkGl3bQ;;EAEI,qEAAA;AlGo3bZ;;AkG/2bA;;EAEI,mBAAA;EACA,kBAAA;AlGk3bJ;AkGh3bI;;EACI,eAAA;AlGm3bR;;AkG92bI;;EAEI,yBjGjBK;ADk4bb;;AkG72bA;EACI,wBjGiNe;EiGhNf,yBAAA;EACA,4BAAA;EACA,mBAAA;AlGg3bJ;;AkG72bA;;;EAGI,oBAAA;AlGg3bJ;;AkG92bA;;;EAGI,mBAAA;AlGi3bJ;;AkG/2bA;EACI,yBjGpDW;EiGqDX,cjGrEM;EiGsEN,mBAAA;AlGk3bJ;;AkG/2bA;EACI,iBjGmLU;EiGlLV,oBAAA;AlGk3bJ;;AkGh3bA;EACI,qBjGhDU;ADm6bd;;AkGh3bA;EACI,cAAA;AlGm3bJ;;AkGh3bA;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AlGm3bJ;;AkG72bI;;;EAEI,mBAAA;AlGi3bR;;AkG72bA;EACI,WAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AlGg3bJ;;AkG72bA;EACI,eAAA;AlGg3bJ;;AkG52bA;EACE,UAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AlG+2bF;;AkG52bA;EACI,0BjGsLW;EiGrLX,+BAAA;AlG+2bJ;;AkG52bA;EACI,UAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AlG+2bJ;AkG72bI;EACE,4BAAA;AlG+2bN;;AkG12bI;;EAEI,wBAAA;EACA,iBAAA;EACA,gBAAA;AlG62bR;AkG12bI;EACI,mBAAA;AlG42bR;AkG12bQ;EACG,eAAA;AlG42bX;AkGx2bI;EACI,gBAAA;EACA,wBAAA;AlG02bR;AkGv2bI;EACI,eAAA;AlGy2bR;AkGx2bQ;EACE,oBAAA;AlG02bV;;AkGr2bA;EACI,iBjGyDiB;AD+ybrB;AkGv2bM;EACE,SAAA;AlGy2bR;AkGv2bO;EACI,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AlGy2bX;AkGx2bW;EACG,aAAA;EACC,uBAAA;EACA,YAAA;EACA,+BAAA;AlG02bf;AkGt2bW;EACI,eAAA;EACA,cjGpRP;EiGqRO,wBAAA;AlGw2bf;AkGt2bW;EACI,uBAAA;EACA,uBAAA;EACA,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,YAAA;AlGw2bf;AkGv2be;EACI,uBAAA;AlGy2bnB;AkGt2bW;EACI,UAAA;EACA,cjGpSP;AD4ocR;AkGv2be;EACE,YAAA;AlGy2bjB;;AkGn2bG;EACE,iBAAA;EACA,iBAAA;AlGs2bL;AkGr2bK;EACE,YAAA;EACA,cjGtNC;AD6jcR;AkGt2bO;EACE,cjGxND;ADgkcR;;AkGn2bA;EACE,eAAA;AlGs2bF;;AkGl2bE;;EACE,ejG0Fa;AD4wbjB;;AmGhrcA;;EAAA;AAGA;EACE,2BAAA;EACA,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,sBAAA;AnGmrcF;;AmGhrcA;;EAAA;AAGA;EACE,aAAA;EACA,UAAA;EACA,6DAAA;EACA,qEAAA;EACA,YAAA;EACA,mDAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;AnGmrcF;;AmGhrcA;EACE,aAAA;EACA,UAAA;EACA,6DAAA;EACA,qEAAA;EACA,WAAA;EACA,mDAAA;EACA,QAAA;EACA,mCAAA;EACA,kBAAA;AnGmrcF;;AmGhrcA;;EAEE,cAAA;EACA,6BAAA;AnGmrcF;;AmGhrcA;;;;;;EAME,YAAA;AnGmrcF;;AmGhrcA;;;;;;EAME,sBAAA;EACA,YAAA;AnGmrcF;;AmGhrcA;;EAAA;AAGA;EACE,sBAAA;EACA,kBAAA;EACA,iEAAA;EACA,yEAAA;EACA,WAAA;EACA,2CAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;AnGmrcF;;AmGhrcA;EACE,sBAAA;EACA,kBAAA;EACA,gEAAA;EACA,wEAAA;EACA,UAAA;EACA,0CAAA;EACA,UAAA;EACA,mCAAA;EACA,kBAAA;AnGmrcF;;AmGhrcA;;;EAGE,sBAAA;EACA,YAAA;AnGmrcF;;AmGhrcA;;;EAGE,sBAAA;EACA,WAAA;AnGmrcF;;AmGhrcA,gBAAA;AACA;EACE;IACE,yBAAA;EnGmrcF;AACF;AmGhrcA;EACE;IACE,yBAAA;EnGkrcF;AACF;AoGpycA;EACE,aAAA;EACA,eAAA;ApGsycF;;AqGxycA;EAEE,mBpGsBS;ADoxcX;AqGxycE;EACE,cpG2GW;AD+rcf;AqGvycE;EACE,mBpGuGW;ADkscf;AqGvycE;EACI,cpGoGS;ADqscf;AqGxycM;EACE,cpGkGO;ADwscf;AqGtycE;EACE,cpG6FW;AD2scf;AqGrycE;EACE,cpGyFW;AD8scf;AqGrycE;EACE,cpGsEM;ADiucV;AqGtycI;EACE,cpGmGM;ADqscZ;AqGpycE;EACE,6EAAA;ArGsycJ;AqGrycI;EACE,+BpG6BM;AD0wcZ;AqGnycE;EACE,mBpGhBO;ADqzcX;AqGlycE;EACE,cpGoEW;ADgucf;AqGjycE;EACE,cpGuDI;AD4ucR;AqGhycE;EACE,2EAAA;ArGkycJ;AqG/xcE;EACE,4BAAA;ArGiycJ;AsFp1cG;EACI,4BeuD6B;EpB1DlC,UKIsB;ELDtB,0BAAA;AjFw1cF;AsFr1cG;EACI,4BemD6B;EpB1DlC,UKQsB;ELLtB,0BAAA;AjF61cF;AsFt1cG;EACI,4Be+C6B;EpB1DlC,UKYsB;ELTtB,0BAAA;AjFk2cF;AsFv1cG;EACI,4Be2C6B;EpB1DlC,UKgBsB;ELbtB,0BAAA;AjFu2cF;AqG9ycM;EACE,qBpG+CQ;ADiwchB;AqG5ycI;EACE,mCAAA;EACA,cpG0CS;ADowcf;AqG3ycI;EACE,cpG6BE;EoG5BF,mCAAA;ArG6ycN;AqG5ycM;EACE,qBpGoBE;AD0xcV;AqGxycM;;;;;;;;;;EAKI,0CpG9BO;AD60cjB;AqG9ycU;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGI,0CpGjCG;AD02cjB;AqGn0cc;;;EAGI,6BpG9ED;ADm5cjB;AqG5zcM;;EAEI,yBpGTF;ADu0cR;AqG1zcE;EACE,mBpGQS;EoGPT,mCAAA;ArG4zcJ;AqGxzcM;;;EAGE,qBpG5BE;ADs1cV;AqGtzcU;;EAGI,0CpGzEG;ADg4cjB;AqGnzcE;EACI,kBAAA;ArGqzcN;AqGlzcE;EACI,iBAAA;ArGozcN;AqGjzcE;EACE,qBpGlCY;ADq1chB;AqGhzcE;EACE,oDAAA;ArGkzcJ;AqG9ycI;EACE,yBAAA;ArGgzcN;AqG5ycE;EACE,2EAAA;ArG8ycJ;AqG3ycE;EACE,mBpGvJI;EoGwJJ,kDAAA;ArG6ycJ;AqG5ycI;EACE,cpG/DE;AD62cR;AqG7ycM;EACE,cpGjEA;ADg3cR;AqG5ycI;EACE,cpG5DS;AD02cf;AqG1ycM;EACE,cpGjEO;AD62cf;AqGvycI;EACE,cpGvFI;ADg4cV;AqGrycK;EACG,cpG1DG;EoG2DH,uCAAA;ArGuycR;AqGtycQ;EACE,iCAAA;ArGwycV;AqGtycQ;EACE,cpGtLF;AD89cR;AqGnycI;EACI,cpGtEG;AD22cX;AqGjycI;EACE,gBAAA;ArGmycN;AqGhycI;EACE,uBpG1LW;EoG2LX,gBAAA;ArGkycN;AqG7xcQ;EACE,4BAAA;ArG+xcV;AqG9xcU;EACE,cpGnHJ;ADm5cR;AqGvxcM;EACE,uCAAA;ArGyxcR;AqGrxcI;;;;;;EAMI,mCAAA;EACA,iBAAA;EACA,sBAAA;ArGuxcR;AqGpxcI;EACE,4BAAA;ArGsxcN;AqGlxcE;EACE,cpGzIW;AD65cf;AqGjxcE;EACE,cpG7IW;ADg6cf;AqG/wcM;EACE,iCAAA;EACA,2CAAA;ArGixcR;AqGhxcQ;EACE,cpGrKA;ADu7cV;AqG9wcM;EACE,cpG1JO;AD06cf;AqG5wcG;EACE,mBpGvPM;ADqgdX;AqG5wcK;EACE,cpGlKQ;ADg7cf;AqG3wcK;EACE,cpGvJK;ADo6cZ;AqG1wcK;EACE,cpG1KQ;ADs7cf;AqGzwcK;EACE,cpG9KQ;ADy7cf;AqGvwcG;EACE,+DAAA;EACA,cpGpLU;AD67cf;AqGxwcK;EACE,mBAAA;ArG0wcP;;AsGhjdA;EACI,mBrGg4BoB;EqG/3BpB,SAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,6CrG2WS;ADwscb;AsGhjdI;EACE,+BAAA;AtGkjdN;AsG/idI;EACE,sBAAA;AtGijdN;AsG9idI;EACE,aAAA;AtGgjdN;AsG9idM;EACE,eAAA;EACA,gBAAA;AtGgjdR;AsG7idM;EACE,crGdA;EqGeA,uBAAA;EACA,gBrGmYY;EqGlYZ,sBAAA;AtG+idR;AsG5idM;EACE,+BAAA;AtG8idR;AsGxidM;EACE,6BAAA;AtG0idR;AsG5idI;EAIE,oBAAA;EACA,SAAA;EACA,+BAAA;AtG2idN;AsGzidM;EACI,crGnCF;EqGoCE,gBAAA;AtG2idV;AsGxidM;EACE,crG2EI;EqG1EJ,kBAAA;EACA,gBAAA;AtG0idR;AsGtidI;EACI,wBrG0SW;AD8vcnB;AsGtidQ;EACE,aAAA;AtGwidV;AsGpidI;EACE,mBrGvDE;AD6ldR;AsGpidM;EACE,crGiCA;ADqgdR;AsGpidM;EACE,crGuDU;AD++clB;AsF1mdG;EACI,4BgBwEiC;ErB3EtC,UKIsB;ELDtB,0BAAA;AjF8mdF;AsF3mdG;EACI,4BgBoEiC;ErB3EtC,UKQsB;ELLtB,0BAAA;AjFmndF;AsF5mdG;EACI,4BgBgEiC;ErB3EtC,UKYsB;ELTtB,0BAAA;AjFwndF;AsF7mdG;EACI,4BgB4DiC;ErB3EtC,UKgBsB;ELbtB,0BAAA;AjF6ndF;AsGnjdU;EACE,qBrG8BI;ADuhdhB;AsGjjdQ;EACE,mCAAA;EACA,crGyBK;AD0hdf;AsGhjdQ;EACE,crGYF;EqGXE,mCAAA;AtGkjdV;AsGjjdU;EACE,qBrGGF;ADgjdV;AsGhjdQ;EACE,crGFA;ADojdV;AsG7idU;;;;;;;;;;EAKE,0CrGlDK;ADsmdjB;AsGnjdc;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,0CrGrDC;ADmodjB;AsGxkdkB;;;EAEE,6BrGjGH;AD4qdjB;AsGlkdU;;EAEI,yBrG5BN;ADgmdR;AsGhkdM;EACE,mBrGXK;EqGYL,mCAAA;AtGkkdR;AsG9jdU;;;EAGE,yBrGpIJ;EqGqII,qBrGhDF;ADgndV;AsG5jdc;;EAGI,0CrG7FD;AD0pdjB;AsGzjdM;EACI,kBAAA;AtG2jdV;AsGxjdM;EACI,iBAAA;AtG0jdV;AsGvjdM;EACE,qBrGtDQ;AD+mdhB;AsGtjdM;EACE,oDAAA;AtGwjdR;AsGnjdI;EACE,uBAAA;EACA,gBAAA;AtGqjdN;AsGljdI;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;AtGojdR;AsGjjdI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AtGmjdR;AsGhjdI;EACI,0BrGmNO;EqGlNP,kBAAA;AtGkjdR;AsG9idI;EACI,6BAAA;EACA,SAAA;EACA,aAAA;AtGgjdR;AsG5idY;EACI,iBAAA;EACA,kBAAA;AtG8idhB;AsGzidQ;EACE,gBAAA;EACA,cAAA;AtG2idV;;AsGtidA;EACE,gBrG4pBc;AD64bhB;;Ae7rdI;EuFyJA;IACE,mBAAA;IACA,SAAA;EtGwidJ;AACF;AuG7wdA;EACE,gBAAA;AvG+wdF;AuG5wdM;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AvG8wdR;AuG3wdI;EACE,kBAAA;AvG6wdN;AuG1wdE;EACE,iBAAA;EACA,kBAAA;AvG4wdJ;AuG3wdI;EACE,UAAA;AvG6wdN;AuG1wdE;EACE,gBAAA;AvG4wdJ;AuG1wdI;EACE,gBAAA;EACA,iDAAA;AvG4wdN;AuGxwdE;EACE,gBAAA;EACA,eAAA;AvG0wdJ;AuGvwdE;EAGE,WAAA;AvGuwdJ;AuGrwdE;EACE,gBAAA;AvGuwdJ;AuGrwdI;EACE,ctGmFM;ADordZ;AuGnwdE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AvGqwdJ;AuGnwdI;EACE,SAAA;AvGqwdN;AuGhwdI;EACE,oBAAA;EACA,YAAA;AvGkwdN;AuG/vdI;EACE,mBAAA;AvGiwdN;AuGhwdM;EACE,eAAA;AvGkwdR;;AwGr0dA;EACE,aAAA;AxGw0dF;;AyGz0dA;EACE,gBAAA;AzG40dF;AyG30dI;EACI,aAAA;AzG60dR;AyG10dI;EACI,kBAAA;EACA,oBAAA;EACA,gBAAA;AzG40dR;AyG10dQ;EACI,gBAAA;AzG40dZ;AyGz0dQ;EACE,kBAAA;EACA,aAAA;EACA,YAAA;AzG20dV;AyG10dU;E1BiDN,mC0BhDuC;E1BoDvC,6FAAA;EAkHF,iEAAA;EAKA,yBAAA;E0BzKU,iBAAA;EACA,kBAAA;AzGq1dZ;AyGl1dU;E1B0CN,mC0BzCuC;E1B6CvC,6FAAA;EAkHF,iEAAA;EAKA,wBAAA;E0BlKU,iBAAA;EACA,mBAAA;AzG61dZ;AyG11dU;E1BmCN,mC0BlCuC;E1BsCvC,6FAAA;EAkHF,iEAAA;EAKA,yBAAA;E0B3JU,iBAAA;EACA,YAAA;AzGq2dZ;AyGj2dU;E1B2BN,mC0B1BuC;E1B8BvC,6FAAA;EAkHF,iEAAA;EAKA,yBAAA;E0BnJU,iBAAA;EACA,YAAA;AzG42dZ;AyGt2dI;EACE,YAAA;EACA,aAAA;EACA,qEAAA;EACA,gCxGhCW;EwGiCX,6BxGjCW;EwGkCX,kBAAA;AzGw2dN;AyGr2dI;EACI,iBAAA;AzGu2dR;AyGp2dI;EACI,gBAAA;AzGs2dR;AyGn2dI;EACI,kBAAA;EACA,kBAAA;AzGq2dR;AyGl2dI;EACE,gBAAA;AzGo2dN;;A0G96dA;EACE,aAAA;A1Gi7dF;A0G/6dE;EACE,iBAAA;EACA,kBAAA;A1Gi7dJ;A0G76dI;EACE,kBAAA;EACA,gBzGqZe;AD0hdrB;A0G56dI;EACE,YAAA;EACA,cAAA;A1G86dN;A0Gz6dI;EACE,czGyGM;EyGxGN,gBAAA;A1G26dN;A0G16dM;EACE,czGbA;ADy7dR;;A2Gr8dA;EACE,uBAAA;EACA,gBAAA;A3Gw8dF;A2Gt8dE;;EAEE,cAAA;EACA,eAAA;EACA,6BAAA;A3Gw8dJ;A2Gr8dE;EACI,eAAA;EACA,gBAAA;A3Gu8dN;;A4Gp9dA;EACG,WAAA;A5Gu9dH;;AA72dA;EACI,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,4DAAA;EACA,cAAA;AAg3dJ;AA/2dI;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;AAi3dR;AA72dQ;EACI,yBAAA;AA+2dZ;AA72dQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;AA+2dZ;AA92dY;EACI,iBAAA;AAg3dhB;AA72dQ;EACI,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBCrIJ;EDsII,gBAAA;AA+2dZ;AA92dY;EACI,8DAAA;AAg3dhB;AA92dY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;AAg3dhB;AA92dY;EACI,eAAA;EACA,cCvDR;EDwDQ,4BAAA;AAg3dhB;AA92dY;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,yBC5JR;ED6JQ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gFAAA;AAg3dhB;AA92dgB;EACI,qBAAA;AAg3dpB;AA92dgB;EACI,aAAA;AAg3dpB;AA52dgB;;EAEI,qBAAA;AA82dpB;AAx2dY;EACI,SAAA;EACA,gBAAA;EACA,gBAAA;AA02dhB;AAt2dQ;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AAw2dZ;AAv2dY;EACI,eAAA;EACA,cC7GR;ED8GQ,WAAA;AAy2dhB;;AAn2dA;EACC,qBAAA;AAs2dD;;AAp2dA;EACI,kCAAA;EACA,yBAAA;AAu2dJ;AAt2dI;EAGI,8BAAA;EACA,yBAAA;AAs2dR;;AAn2dA;EACI,kBAAA;AAs2dJ;;AAp2dA;EACI,uBAAA;EACA,YAAA;EACA,wBAAA;EACA,6BAAA;EACA,sBAAA;EACA,oBAAA;EACA,cC3II;ED4IJ,gBAAA;AAu2dJ;AAt2dI;EAII,kCAAA;EACA,yBAAA;AAq2dR;;AAj2dA;EACI,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,QAAA;EACA,OAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;AAo2dJ;AAn1dI;EACI,yBC3QA;ED4QA,kBAAA;EACA,6BAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,cAAA;AAq1dR;AAl1dY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAo1dhB;AAj1dQ;EACI,iBAAA;EACA,aAAA;AAm1dZ;AAl1dY;EACI,gCAAA;EACA,cAAA;EACA,kCAAA;EACA,SAAA;AAo1dhB;AAn1dgB;EACI,0BAAA;AAq1dpB;AAn1dgB;EACI,eAAA;EACA,cCpNZ;ADyieR;AAp1doB;EACI,aAAA;AAs1dxB;;AA90dA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AAi1dJ;;AA90dA;EACI,eAAA;EACA,6BAAA;AAi1dJ;;AA90dA;EACI,kBAAA;AAi1dJ;;AA70dI;EACI,qCAAA;AAg1dR","sourcesContent":["/*\r\n =========================================================\r\n * Black Dashboard React v1.1.0 based on Black Dashboard - v1.1.0\r\n =========================================================\r\n\r\n * Product Page: https://www.creative-tim.com/product/black-dashboard-react\r\n * Copyright 2020 Creative Tim (https://www.creative-tim.com)\r\n * Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)\r\n\r\n * Coded by Creative Tim\r\n\r\n =========================================================\r\n\r\n * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\r\n\r\n */\r\n\r\n// Core\r\n\r\n@import \"black-dashboard-react/custom/functions\";\r\n@import \"black-dashboard-react/bootstrap/functions\";\r\n\r\n@import \"black-dashboard-react/custom/variables\";\r\n@import \"black-dashboard-react/bootstrap/variables\";\r\n\r\n@import \"black-dashboard-react/custom/mixins\";\r\n@import \"black-dashboard-react/bootstrap/mixins\";\r\n\r\n// Bootstrap components\r\n\r\n@import \"black-dashboard-react/bootstrap/root\";\r\n@import \"black-dashboard-react/bootstrap/reboot\";\r\n@import \"black-dashboard-react/bootstrap/type\";\r\n@import \"black-dashboard-react/bootstrap/images\";\r\n@import \"black-dashboard-react/bootstrap/code\";\r\n@import \"black-dashboard-react/bootstrap/grid\";\r\n@import \"black-dashboard-react/bootstrap/tables\";\r\n@import \"black-dashboard-react/bootstrap/forms\";\r\n@import \"black-dashboard-react/bootstrap/buttons\";\r\n@import \"black-dashboard-react/bootstrap/transitions\";\r\n@import \"black-dashboard-react/bootstrap/dropdown\";\r\n@import \"black-dashboard-react/bootstrap/button-group\";\r\n@import \"black-dashboard-react/bootstrap/input-group\";\r\n@import \"black-dashboard-react/bootstrap/custom-forms\";\r\n@import \"black-dashboard-react/bootstrap/nav\";\r\n@import \"black-dashboard-react/bootstrap/navbar\";\r\n@import \"black-dashboard-react/bootstrap/card\";\r\n@import \"black-dashboard-react/bootstrap/breadcrumb\";\r\n@import \"black-dashboard-react/bootstrap/pagination\";\r\n@import \"black-dashboard-react/bootstrap/badge\";\r\n@import \"black-dashboard-react/bootstrap/jumbotron\";\r\n@import \"black-dashboard-react/bootstrap/alert\";\r\n@import \"black-dashboard-react/bootstrap/progress\";\r\n@import \"black-dashboard-react/bootstrap/media\";\r\n@import \"black-dashboard-react/bootstrap/list-group\";\r\n@import \"black-dashboard-react/bootstrap/close\";\r\n@import \"black-dashboard-react/bootstrap/modal\";\r\n@import \"black-dashboard-react/bootstrap/tooltip\";\r\n@import \"black-dashboard-react/bootstrap/popover\";\r\n@import \"black-dashboard-react/bootstrap/carousel\";\r\n@import \"black-dashboard-react/bootstrap/utilities\";\r\n@import \"black-dashboard-react/bootstrap/print\";\r\n\r\n// Custom components\r\n\r\n@import \"black-dashboard-react/custom/alerts.scss\";\r\n@import \"black-dashboard-react/custom/badges.scss\";\r\n@import \"black-dashboard-react/custom/buttons.scss\";\r\n@import \"black-dashboard-react/custom/dropdown.scss\";\r\n@import \"black-dashboard-react/custom/footer.scss\";\r\n@import \"black-dashboard-react/custom/forms.scss\";\r\n@import \"black-dashboard-react/custom/images.scss\";\r\n@import \"black-dashboard-react/custom/modal.scss\";\r\n@import \"black-dashboard-react/custom/navbar.scss\";\r\n@import \"black-dashboard-react/custom/type.scss\";\r\n@import \"black-dashboard-react/custom/tables\";\r\n@import \"black-dashboard-react/custom/checkboxes-radio\";\r\n@import \"black-dashboard-react/custom/fixed-plugin\";\r\n@import \"black-dashboard-react/custom/sidebar-and-main-panel.scss\";\r\n@import \"black-dashboard-react/custom/misc.scss\";\r\n@import \"black-dashboard-react/custom/rtl.scss\";\r\n@import \"black-dashboard-react/custom/input-group.scss\";\r\n\r\n// Vendor / Plugins\r\n\r\n@import \"black-dashboard-react/custom/vendor/plugin-perfect-scrollbar.scss\";\r\n@import \"black-dashboard-react/custom/vendor/plugin-react-notification-alert.scss\";\r\n\r\n// light mode\r\n\r\n@import \"black-dashboard-react/custom/white-content.scss\";\r\n\r\n// Cards\r\n\r\n@import \"black-dashboard-react/custom/card\";\r\n@import \"black-dashboard-react/custom/cards/card-chart\";\r\n@import \"black-dashboard-react/custom/cards/card-map\";\r\n@import \"black-dashboard-react/custom/cards/card-user\";\r\n@import \"black-dashboard-react/custom/cards/card-task\";\r\n@import \"black-dashboard-react/custom/cards/card-plain\";\r\n\r\n// React differences\r\n@import \"black-dashboard-react/react-differences/react-differences\";\r\n\r\n// kailash\r\n\r\n$orange: #eb8a0d;\r\n.uploadfiles {\r\n    padding: 0;\r\n    margin-right: -8px;\r\n    margin-left: -8px;\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\r\n    grid-gap: 15px;\r\n    li {\r\n        text-align: center;\r\n        list-style: none;\r\n        position: relative;\r\n        // margin-right: 15px;\r\n        // margin-bottom: 15px;\r\n       \r\n        &.fileUoloadButton{\r\n            border-color: transparent;\r\n        }\r\n        &.noData{\r\n            width: 100%;\r\n            height: auto;\r\n            display: block;\r\n            margin: 0;\r\n            padding: 0;\r\n            border:none;\r\n            color: #333 !important;\r\n            &:first-child{\r\n                grid-column: 1 / -1;\r\n            }\r\n        }\r\n        .storage_file {\r\n            border-radius: 4px;\r\n            border: 1px solid #ddd;\r\n            width: 100px;\r\n            height: 100px;\r\n            margin:auto;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            background-color: $white;\r\n            overflow: hidden;\r\n            &.not_image {\r\n                background-color: #b1b1b126 !important;\r\n            }\r\n            img {\r\n                width: 100%;\r\n                height: 100%;\r\n                object-fit: cover;\r\n                transition: 0.5s ease-in-out;\r\n            }\r\n            i {\r\n                font-size: 30px;\r\n                color: $black;\r\n                transition: 0.5s ease-in-out;\r\n            }\r\n            i.fa-times {\r\n                position: absolute;\r\n                top: -5px;\r\n                right: -3px;\r\n                z-index: 9;\r\n                width: 20px;\r\n                height: 20px;\r\n                background-color: $white;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                border-radius: 50px;\r\n                font-size: 12px;\r\n                cursor: pointer;\r\n                box-shadow: 3px -3px 5px 0 rgba($color: #000000, $alpha: 0.1),\r\n                            -3px 3px 5px 0 rgba($color: #000000, $alpha: 0.1);\r\n                &:hover {\r\n                    color: red !important;\r\n                }\r\n                &::after {\r\n                    display: none;\r\n                }\r\n            }\r\n            &:hover {\r\n                img,\r\n                i {\r\n                    transform: scale(1.2);\r\n                }\r\n            }\r\n        }\r\n\r\n        .content {\r\n            p {\r\n                margin: 0;\r\n                padding-top: 6px;\r\n                font-weight: 500;\r\n            }\r\n        }\r\n\r\n        .ChooseFile {\r\n            width: 100px;\r\n            height: 100px;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            border: 1px solid #ddd;\r\n            margin: 0;\r\n            border-radius: 4px;\r\n            cursor: pointer;\r\n            i {\r\n                font-size: 20px;\r\n                color: $black;\r\n                color: gray;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.truncate {\r\n\tword-break: break-all;\r\n}\r\n.btn-outline-primary {\r\n    background: transparent !important;\r\n    color: $orange !important;\r\n    &:hover,\r\n    &:focus,\r\n    &:active:focus {\r\n        background: $orange !important;\r\n        color: $white !important;\r\n    }\r\n}\r\n.modal-content .modal-header {\r\n    position: relative;\r\n}\r\n.modal-minimize {\r\n    background: transparent;\r\n    height: auto;\r\n    padding: 10px !important;\r\n    position: absolute !important;\r\n    right: 60px !important;\r\n    top: 24px !important;\r\n    color: $black;\r\n    border-radius: 0;\r\n    &:hover,\r\n    &:focus,\r\n    &:active:focus,\r\n    &:active {\r\n        background: transparent !important;\r\n        color: $black !important;\r\n    }\r\n}\r\n\r\n.minmize_modal_list {\r\n    position: absolute;\r\n    bottom: 0;\r\n    overflow-x: auto;\r\n    right: 0;\r\n    left: 0;\r\n    width: calc(100% - 280px);\r\n    margin-left: auto;\r\n    direction: rtl;\r\n    // &::-webkit-scrollbar{\r\n    //     width: 2px;\r\n    // }\r\n    // &::-webkit-scrollbar-track{\r\n    //     background: #f1f1f1;\r\n    //     border-radius: 10px;\r\n    // }\r\n    // &::-webkit-scrollbar-thumb {\r\n    //         background: rgba($orange, 0.8);\r\n    //         height: 5px;\r\n    //         width: 6px;\r\n    //         border-radius: 10px;\r\n    //         &:hover {\r\n    //             background:$orange;\r\n    //         }\r\n    //     }\r\n    .minmize_item {\r\n        background-color: $white;\r\n        padding: 14px 12px;\r\n        border-top-right-radius: 10px;\r\n        border-top-left-radius: 10px;\r\n        width: 200px;\r\n        margin: 0 4px;\r\n        justify-content: space-between;\r\n        direction: ltr;\r\n\r\n        .title {\r\n            h1 {\r\n                font-size: 16px;\r\n                font-weight: 600;\r\n                letter-spacing: 0;\r\n                margin: 0 !important;\r\n                max-width: 120px;\r\n                white-space: nowrap;\r\n                -webkit-line-clamp: 1;\r\n                -webkit-box-orient: vertical;\r\n                overflow: hidden;\r\n                text-overflow: ellipsis;\r\n            }\r\n        }\r\n        .minimize_icon {\r\n            margin-left: 20px;\r\n            display: flex;\r\n            button {\r\n                padding: 0px 0 0 15px !important;\r\n                line-height: 0;\r\n                background: transparent !important;\r\n                margin: 0;\r\n                &:first-child {\r\n                    padding-left: 0 !important;\r\n                }\r\n                i {\r\n                    font-size: 12px;\r\n                    color: $black;\r\n                    &::after {\r\n                        display: none;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.checkBox_inline {\r\n    display: flex;\r\n    align-items: center;\r\n    height: 100%;\r\n    margin-left: 15px;\r\n}\r\n\r\n.checkBox_inline .form-group {\r\n    font-size: 30px;\r\n    margin-bottom: 6px !important;\r\n}\r\n\r\n.checkBox_inline .form-group:nth-child(1) {\r\n    margin-right: 35px;\r\n}\r\n\r\n.nodrag_inner {\r\n    .draggable {\r\n        transform: translate(0, 0) !important;\r\n    }\r\n}\r\n","// Global settings\r\n\r\n$enable-caret: true !default;\r\n$enable-rounded: true !default;\r\n$enable-shadows: true !default;\r\n$enable-gradients: false !default;\r\n$enable-transitions: true !default;\r\n$enable-grid-classes: true !default;\r\n$enable-print-styles: true !default;\r\n\r\n// Color system\r\n\r\n$white: #ffffff !default;\r\n$gray-100: #f6f9fc !default;\r\n$gray-200: #e9ecef !default;\r\n$gray-300: #e3e3e3 !default;\r\n$gray-400: #ced4da !default;\r\n$gray-500: #adb5bd !default;\r\n$gray-600: #6c757d !default; // Line footer color\r\n$gray-700: #525f7f !default; // Line p color\r\n$gray-800: #32325d !default; // Line heading color\r\n$gray-900: #212529 !default;\r\n$link-disabled: #666666 !default;\r\n$transparent-bg: transparent !default;\r\n$light-bg: #f5f6fa !default;\r\n$dark-background: #555555 !default;\r\n\r\n$grays: () !default;\r\n$grays: map-merge(\r\n  (\r\n    '100': $gray-100,\r\n    '200': $gray-200,\r\n    '300': $gray-300,\r\n    '400': $gray-400,\r\n    '500': $gray-500,\r\n    '600': $gray-600,\r\n    '700': $gray-700,\r\n    '800': $gray-800,\r\n    '900': $gray-900\r\n  ),\r\n  $grays\r\n);\r\n\r\n$blue: #5e72e4 !default;\r\n$indigo: #5603ad !default;\r\n$purple: #8965e0 !default;\r\n$pink: #f3a4b5 !default;\r\n$red: #f5365c !default;\r\n$orange: #fb6340 !default;\r\n$yellow: #ffd600 !default;\r\n$green: #2dce89 !default;\r\n$teal: #11cdef !default;\r\n$cyan: #2bffc6 !default;\r\n\r\n$line-height-lg: 1.625rem !default;\r\n$line-height-sm: 1.5 !default;\r\n$line-height: 1.35em !default;\r\n\r\n$opacity-gray-3: rgba(222, 222, 222, 0.3) !default;\r\n$opacity-gray-5: rgba(222, 222, 222, 0.5) !default;\r\n$opacity-gray-8: rgba(222, 222, 222, 0.8) !default;\r\n\r\n$opacity-5: rgba(255, 255, 255, 0.5) !default;\r\n$opacity-6: rgba(255, 255, 255, 0.6) !default;\r\n$opacity-8: rgba(255, 255, 255, 0.8) !default;\r\n\r\n$opacity-1: rgba(255, 255, 255, 0.1) !default;\r\n$opacity-2: rgba(255, 255, 255, 0.2) !default;\r\n\r\n// end beniamin\r\n\r\n$colors: () !default;\r\n$colors: map-merge(\r\n  (\r\n    'blue': $blue,\r\n    'indigo': $indigo,\r\n    'purple': $purple,\r\n    'pink': $pink,\r\n    'red': $red,\r\n    'orange': $orange,\r\n    'yellow': $yellow,\r\n    'green': $green,\r\n    'teal': $teal,\r\n    'cyan': $cyan,\r\n    'white': $white,\r\n    'gray': $gray-600,\r\n    'light': $gray-400,\r\n    'lighter': $gray-200,\r\n    'gray-dark': $gray-800\r\n  ),\r\n  $colors\r\n);\r\n\r\n$default-color-opacity: rgba(182, 182, 182, 0.6) !default;\r\n$orange-color: #f96332 !default;\r\n\r\n$default: #344675 !default;\r\n$primary: #e14eca !default;\r\n$secondary: #f4f5f7 !default;\r\n$success: #00f2c3 !default;\r\n$info: #1d8cf8 !default;\r\n$warning: #ff8d72 !default;\r\n$danger: #fd5d93 !default;\r\n$black: #222a42 !default;\r\n\r\n// gradient\r\n$default-states: #263148 !default;\r\n$primary-states: #ba54f5 !default;\r\n$success-states: #0098f0 !default;\r\n$info-states: #3358f4 !default;\r\n$warning-states: #ff6491 !default;\r\n$danger-states: #ec250d !default;\r\n$black-states: #1d253b !default;\r\n\r\n$background-black: #1e1e2f !default;\r\n$background-states-black: #1e1e24 !default;\r\n\r\n// opacity\r\n$default-opacity: rgba(182, 182, 182, 0.6) !default;\r\n$primary-opacity: rgba(249, 99, 50, 0.3) !default;\r\n$success-opacity: rgba(24, 206, 15, 0.3) !default;\r\n$info-opacity: rgba(44, 168, 255, 0.3) !default;\r\n$warning-opacity: rgba(255, 178, 54, 0.3) !default;\r\n$danger-opacity: rgba(255, 54, 54, 0.3) !default;\r\n\r\n$light-gray: #e3e3e3 !default;\r\n$medium-gray: #dddddd !default;\r\n$dark-gray: #9a9a9a !default;\r\n$card-stats-gray: #808080 !default;\r\n$active-gray: #777777 !default;\r\n$nav-gray: #444444 !default;\r\n$search-gray: #b7b7b7 !default;\r\n$calendar-gray: #9499a7 !default;\r\n$active-blue: #00bbff !default;\r\n\r\n$light: $gray-500 !default;\r\n$dark: $gray-900 !default;\r\n$darker: darken($gray-900, 15%) !default;\r\n\r\n$facebook: #3b5998 !default;\r\n$facebook-states: darken($facebook, 5%) !default;\r\n$twitter: #55acee !default;\r\n$twitter-states: darken($twitter, 5%) !default;\r\n$google-plus: #dd4b39 !default;\r\n$google-plus-states: darken($google-plus, 5%) !default;\r\n$instagram: #125688 !default;\r\n$instagram-states: lighten($instagram, 6%) !default;\r\n$linkedin: #0077b5 !default;\r\n$linkedin-states: darken($linkedin, 5%) !default;\r\n$pinterest: #cc2127 !default;\r\n$pinterest-states: lighten($pinterest, 6%) !default;\r\n$youtube: #e52d27 !default;\r\n$youtube-states: lighten($youtube, 6%) !default;\r\n$dribbble: #ea4c89 !default;\r\n$dribbble-states: lighten($dribbble, 6%) !default;\r\n$github: #333333 !default;\r\n$github-states: #ccc !default;\r\n$reddit: #ff4500 !default;\r\n$reddit-states: lighten($reddit, 6%) !default;\r\n$tumblr: #35465c !default;\r\n$tumblr-states: lighten($tumblr, 6%) !default;\r\n$behance: #1769ff !default;\r\n$behance-states: lighten($behance, 6%) !default;\r\n\r\n$theme-colors: () !default;\r\n$theme-colors: map-merge(\r\n  (\r\n    'default': $default,\r\n    'primary': $primary,\r\n    'secondary': $secondary,\r\n    'success': $success,\r\n    'info': $info,\r\n    'warning': $warning,\r\n    'danger': $danger,\r\n    'white': $white,\r\n    'neutral': $white,\r\n    'dark': $dark,\r\n    'darker': $darker\r\n  ),\r\n  $theme-colors\r\n);\r\n\r\n$brand-colors: () !default;\r\n$brand-colors: map-merge(\r\n  (\r\n    'facebook': $facebook,\r\n    'twitter': $twitter,\r\n    'google-plus': $google-plus,\r\n    'instagram': $instagram,\r\n    'pinterest': $pinterest,\r\n    'youtube': $youtube,\r\n    'dribbble': $dribbble,\r\n    'github': $github,\r\n    'reddit': $reddit,\r\n    'behance': $behance,\r\n    'tumblr': $tumblr,\r\n    'linkedin': $linkedin\r\n  ),\r\n  $brand-colors\r\n);\r\n\r\n/*     brand Colors              */\r\n$brand-primary: $primary !default;\r\n$brand-info: $info !default;\r\n$brand-success: $success !default;\r\n$brand-warning: $warning !default;\r\n$brand-danger: $danger !default;\r\n$brand-inverse: $black !default;\r\n\r\n$topbar-x: topbar-x !default;\r\n$topbar-back: topbar-back !default;\r\n$bottombar-x: bottombar-x !default;\r\n$bottombar-back: bottombar-back !default;\r\n\r\n// Set a specific jump point for requesting color jumps\r\n$theme-color-interval: 8% !default;\r\n\r\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\r\n$yiq-contrasted-threshold: 200 !default;\r\n\r\n// Customize the light and dark text colors for use in our YIQ color contrast function.\r\n$yiq-text-dark: $gray-900 !default;\r\n$yiq-text-light: $white !default;\r\n\r\n// Action colors\r\n\r\n$star-rating-color: $gray-400 !default;\r\n$star-rating-color-active: $yellow !default;\r\n\r\n$favorite-color: $yellow !default;\r\n$like-color: $blue !default;\r\n$love-color: $red !default;\r\n\r\n// Body\r\n\r\n$body-bg: $background-black !default;\r\n$body-color: $gray-700 !default;\r\n\r\n// Sections\r\n\r\n$section-colors: () !default;\r\n$section-colors: map-merge(\r\n  (\r\n    'primary': $body-bg,\r\n    'secondary': $secondary,\r\n    'light': $gray-400,\r\n    'dark': $dark,\r\n    'darker': $darker\r\n  ),\r\n  $section-colors\r\n);\r\n\r\n// Links\r\n\r\n$link-color: $primary !default;\r\n$link-decoration: none !default;\r\n$link-hover-color: darken($link-color, 15%);\r\n$link-hover-decoration: none !default;\r\n\r\n// Grid breakpoints\r\n\r\n$grid-breakpoints: (\r\n  xs: 0,\r\n  sm: 576px,\r\n  md: 768px,\r\n  lg: 992px,\r\n  xl: 1200px\r\n);\r\n\r\n@include _assert-ascending($grid-breakpoints, '$grid-breakpoints');\r\n@include _assert-starts-at-zero($grid-breakpoints);\r\n\r\n// Grid containers\r\n//\r\n// Define the maximum width of `.container` for different screen sizes.\r\n\r\n// Spacing\r\n\r\n$spacer: 1rem !default;\r\n$spacers: () !default;\r\n$spacers: map-merge(\r\n  (\r\n    0: 0,\r\n    1: (\r\n      $spacer * 0.25\r\n    ),\r\n    2: (\r\n      $spacer * 0.5\r\n    ),\r\n    3: $spacer,\r\n    4: (\r\n      $spacer * 1.5\r\n    ),\r\n    5: (\r\n      $spacer * 3\r\n    ),\r\n    'sm': (\r\n      $spacer * 2\r\n    ),\r\n    'md': (\r\n      $spacer * 4\r\n    ),\r\n    'lg': (\r\n      $spacer * 6\r\n    ),\r\n    'xl': (\r\n      $spacer * 8\r\n    )\r\n  ),\r\n  $spacers\r\n);\r\n\r\n$padding-base-vertical: 0.5rem !default;\r\n$padding-base-horizontal: 0.7rem !default;\r\n\r\n$padding-btn-vertical: 11px !default;\r\n$padding-btn-horizontal: 40px !default;\r\n\r\n$padding-round-horizontal: 23px !default;\r\n\r\n$padding-lg-vertical: 15px !default;\r\n\r\n$padding-input-vertical: 11px !default;\r\n$padding-input-horizontal: 19px !default;\r\n\r\n$margin-lg-vertical: 30px !default;\r\n$margin-base-vertical: 15px !default;\r\n\r\n// This variable affects the `.h-*` and `.w-*` classes.\r\n\r\n$sizes: () !default;\r\n$sizes: map-merge(\r\n  (\r\n    25: 25%,\r\n    50: 50%,\r\n    75: 75%,\r\n    100: 100%\r\n  ),\r\n  $sizes\r\n);\r\n\r\n// Components\r\n\r\n$shape-height-xl: 1.5 !default;\r\n$shape-height-lg: 1.5 !default;\r\n$shape-height-sm: 1.5 !default;\r\n\r\n// border\r\n$none: 0 !default;\r\n$border-thin: 1px !default;\r\n$border-thick: 2px !default;\r\n$border-width: 0.0625rem !default;\r\n$border-color: $gray-200 !default;\r\n\r\n$border-radius: 0.25rem !default;\r\n$border-radius-xl: 0.875rem !default;\r\n$border-radius-lg: 0.4285rem !default;\r\n$border-radius-sm: 0.2857rem !default;\r\n$border-radius-xs: 0.1428rem !default;\r\n\r\n$margin-bottom: 10px !default;\r\n$border: 1px solid !default;\r\n\r\n$box-shadow-sm: 0 0.125rem 0.25rem rgba($black, 0.075);\r\n$box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07);\r\n$box-shadow-lg: 0 1rem 3rem rgba($black, 0.175);\r\n\r\n$dropdown-shadow: 1px 2px 3px 0px rgba(0, 0, 0, 0.125);\r\n$box-shadow-raised: 0px 10px 25px 0px rgba(0, 0, 0, 0.3);\r\n$box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);\r\n$sidebar-box-shadow: 0px 2px 22px 0 rgba(0, 0, 0, 0.2), 0px 2px 30px 0 rgba(0, 0, 0, 0.35);\r\n\r\n$component-active-color: $white !default;\r\n$component-active-bg: theme-color('primary') !default;\r\n$component-active-border-color: theme-color('primary') !default;\r\n\r\n$component-hover-color: $gray-300 !default;\r\n$component-hover-bg: $gray-300 !default;\r\n$component-hover-border-color: $gray-300 !default;\r\n\r\n$caret-width: 0.3em !default;\r\n\r\n$transition-base: all 0.15s ease !default;\r\n$transition-fade: opacity 0.15s linear !default;\r\n$transition-collapse: height 0.35s ease !default;\r\n\r\n$fast-transition-time: 150ms !default;\r\n\r\n$transition-linear: linear !default;\r\n$transition-bezier: cubic-bezier(0.34, 1.61, 0.7, 1) !default;\r\n$transition-ease: ease 0s;\r\n\r\n$select-coordinates: 50% -40px !default;\r\n$general-transition-time: 300ms !default;\r\n\r\n// Fonts\r\n\r\n$font-family-base: 'Poppins', sans-serif !default;\r\n$font-family-alt: 'Poppins', sans-serif !default;\r\n\r\n$font-size-dash: 0.875rem !default;\r\n\r\n$font-size-base: $font-size-dash !default; // Assumes the browser default, typically `16px`\r\n$font-size-xl: ($font-size-base * 1.428);\r\n$font-size-lg: ($font-size-base * 1.142);\r\n$font-size-sm: ($font-size-base * 0.85714286);\r\n$font-size-xs: ($font-size-base * 0.714);\r\n\r\n$h1-font-size: $font-size-base * 2.35714285 !default; //2.1875rem\r\n$h2-font-size: $font-size-base * 1.9285714 !default;\r\n$h3-font-size: $font-size-base * 1.642857 !default;\r\n$h4-font-size: $font-size-base * 1.2142857 !default;\r\n$h5-font-size: $font-size-base * 0.9285714 !default;\r\n$h6-font-size: $font-size-base * 0.8571428 !default;\r\n\r\n$font-weight-light: 300 !default;\r\n$font-weight-normal: 400 !default;\r\n$font-weight-bold: 600 !default;\r\n$font-weight-extra-bold: 700 !default;\r\n\r\n$font-paragraph: 1rem !default;\r\n\r\n$font-weight-base: $font-weight-normal !default;\r\n$shape-height-base: 1.428571 !default;\r\n\r\n$headings-margin-bottom: ($spacer / 2);\r\n$headings-font-family: inherit !default;\r\n$headings-font-weight: $font-weight-normal !default;\r\n$headings-line-height: 1.2 !default;\r\n$headings-color: $gray-800 !default;\r\n\r\n$heading-letter-spacing: 0.025em !default;\r\n$heading-font-size: 0.95rem !default;\r\n$heading-text-transform: uppercase !default;\r\n$heading-font-weight: $headings-font-weight !default;\r\n\r\n$heading-title-letter-spacing: 0.025em !default;\r\n$heading-title-font-size: 1.375rem !default;\r\n$heading-title-font-weight: $font-weight-bold !default;\r\n$heading-title-text-transform: uppercase !default;\r\n\r\n$heading-section-letter-spacing: 0.025em !default;\r\n$heading-section-font-size: 1.375rem !default;\r\n$heading-section-font-weight: $font-weight-bold !default;\r\n$heading-section-text-transform: uppercase !default;\r\n\r\n$display1-size: 3.3rem !default;\r\n$display2-size: 2.75rem !default;\r\n$display3-size: 2.1875rem !default;\r\n$display4-size: 1.6275rem !default;\r\n\r\n$display1-weight: $font-weight-bold !default;\r\n$display2-weight: $font-weight-bold !default;\r\n$display3-weight: $font-weight-bold !default;\r\n$display4-weight: $font-weight-bold !default;\r\n$display-line-height: $headings-line-height !default;\r\n\r\n$paragraph-font-size: 0.625rem !default;\r\n$paragraph-font-weight: 300 !default;\r\n$paragraph-line-height: 1.7 !default;\r\n\r\n$lead-font-size: ($paragraph-font-size * 1.25);\r\n$lead-font-weight: 300 !default;\r\n\r\n$small-font-size: 80% !default;\r\n\r\n$text-muted: $gray-600 !default;\r\n\r\n$blockquote-small-color: $gray-600 !default;\r\n$blockquote-font-size: ($font-size-base * 1.1);\r\n\r\n$hr-border-color: rgba($black, 0.1);\r\n$hr-border-width: $border-width !default;\r\n\r\n$mark-padding: 0.2em !default;\r\n\r\n$dt-font-weight: $font-weight-bold !default;\r\n\r\n$list-inline-padding: 0.5rem !default;\r\n\r\n$mark-bg: #fcf8e3 !default;\r\n\r\n$hr-margin-y: $spacer * 2 !default;\r\n\r\n// Icons\r\n\r\n$icon-size: auto !default;\r\n$icon-size-regular: 2.375rem !default;\r\n$icon-font-size-regular: 0.9375rem !default;\r\n$icon-font-size-sm: 0.6875rem !default;\r\n$icon-size-sm: 1.875rem !default;\r\n$icon-font-size-lg: 1.325rem !default;\r\n$icon-size-lg: 3.6rem !default;\r\n$icon-size-xl: 5rem !default;\r\n\r\n// Tables\r\n\r\n$table-cell-padding: 1rem !default;\r\n$table-cell-padding-sm: 0.3rem !default;\r\n\r\n$table-bg: transparent !default;\r\n$table-accent-bg: rgba($black, 0.05);\r\n$table-hover-bg: rgba($black, 0.075);\r\n$table-active-bg: $table-hover-bg !default;\r\n\r\n$table-border-width: $border-width !default;\r\n$table-border-color: $gray-300 !default;\r\n\r\n$table-head-bg: $gray-200 !default;\r\n$table-head-color: $gray-700 !default;\r\n\r\n$table-dark-bg: $gray-900 !default;\r\n$table-dark-accent-bg: rgba($white, 0.05);\r\n$table-dark-hover-bg: rgba($white, 0.075);\r\n$table-dark-border-color: lighten($gray-900, 7.5%);\r\n$table-dark-color: $body-bg !default;\r\n\r\n// Buttons + Forms\r\n\r\n$input-btn-padding-y: 0.5rem !default;\r\n$input-btn-padding-x: 0.7rem !default;\r\n$input-btn-line-height: $shape-height-base !default;\r\n\r\n$input-btn-focus-width: 0 !default;\r\n$input-btn-focus-color: rgba($component-active-bg, 1);\r\n//$input-btn-focus-box-shadow:  0 4px 10px 0 rgba(0, 0, 0, 0.04);\r\n$input-btn-focus-box-shadow: none !default;\r\n\r\n$input-btn-padding-y-sm: 0.25rem !default;\r\n$input-btn-padding-x-sm: 0.5rem !default;\r\n$input-btn-line-height-sm: 1.35 !default;\r\n\r\n$input-btn-padding-y-lg: 0.875rem !default;\r\n$input-btn-padding-x-lg: 1rem !default;\r\n$input-btn-line-height-lg: 1.35 !default;\r\n\r\n$input-btn-border-width: 1px !default;\r\n\r\n$input-btn-font-size-sm: 0.75rem !default;\r\n$input-btn-font-size: 0.875rem !default;\r\n$input-btn-font-size-lg: 0.875rem !default;\r\n\r\n$input-padding-vertical: 11px !default;\r\n$input-padding-horizontal: 19px !default;\r\n\r\n// Buttons\r\n\r\n$btn-padding-y: 11px !default;\r\n$btn-padding-x: 40px !default;\r\n$btn-line-height: $line-height !default;\r\n\r\n$btn-padding-y-sm: 5px !default;\r\n$btn-padding-x-sm: 15px !default;\r\n$btn-line-height-sm: $input-btn-line-height-sm !default;\r\n\r\n$btn-padding-y-lg: 15px !default;\r\n$btn-padding-x-lg: 48px !default;\r\n$btn-line-height-lg: $input-btn-line-height-lg !default;\r\n\r\n$btn-border-width: $input-btn-border-width !default;\r\n\r\n$btn-font-size-lg: 1em !default;\r\n$btn-font-weight: 600 !default;\r\n$btn-text-transform: uppercase !default;\r\n$btn-letter-spacing: 0.025em !default;\r\n$btn-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n$btn-hover-box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);\r\n$btn-focus-box-shadow: $btn-hover-box-shadow !default;\r\n$btn-focus-width: $input-btn-focus-width !default;\r\n\r\n$btn-active-box-shadow: none !default;\r\n$btn-round-radius: 30px !default;\r\n\r\n// Forms\r\n\r\n$input-padding-y: $input-btn-padding-y !default;\r\n$input-padding-x: $input-btn-padding-x !default;\r\n$input-line-height: $input-btn-line-height !default;\r\n\r\n$input-padding-y-sm: $input-btn-padding-y-sm !default;\r\n$input-padding-x-sm: $input-btn-padding-x-sm !default;\r\n$input-line-height-sm: $input-btn-line-height-sm !default;\r\n\r\n$input-padding-y-lg: $input-btn-padding-y-lg !default;\r\n$input-padding-x-lg: $input-btn-padding-x-lg !default;\r\n$input-line-height-lg: $input-btn-line-height-lg !default;\r\n\r\n$input-border-radius: $border-radius !default;\r\n$input-border-radius-xl: $border-radius-xl !default;\r\n$input-border-radius-lg: $border-radius-lg !default;\r\n$input-border-radius-sm: $border-radius-sm !default;\r\n\r\n$input-bg: $transparent-bg !default;\r\n$input-disabled-bg: $gray-200 !default;\r\n\r\n$input-muted-bg: #edf0f5 !default;\r\n\r\n$input-alternative-box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);\r\n$input-focus-alternative-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\r\n\r\n$input-color: $opacity-8 !default;\r\n$input-border-color: #cad1d7 !default;\r\n$input-border-width: $input-btn-border-width !default;\r\n$input-box-shadow: none !default; // 0 1px 3px 0 $gray-400 !default;\r\n\r\n$input-focus-bg: $white !default;\r\n$input-focus-border-color: rgba(50, 151, 211, 0.25);\r\n$input-focus-color: $input-color !default;\r\n$input-focus-width: 0 !default;\r\n$input-focus-box-shadow: none !default; //0 1px 3px 0 $gray-500 !default;\r\n\r\n$input-placeholder-color: $gray-500 !default;\r\n$input-focus-placeholder-color: $gray-500 !default;\r\n\r\n$input-height-border: $input-border-width * 2 !default;\r\n$input-height-inner: ($font-size-base * $input-btn-line-height) + ($input-btn-padding-y * 2) !default;\r\n$input-height: calc(#{$input-height-inner} + #{$input-height-border}) !default;\r\n\r\n$input-transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);\r\n\r\n// Input groups\r\n\r\n$input-group-addon-color: $input-placeholder-color !default;\r\n$input-group-addon-bg: $input-bg !default;\r\n$input-group-addon-border-color: $input-border-color !default;\r\n\r\n$input-group-addon-focus-color: $input-focus-color !default;\r\n$input-group-addon-focus-bg: $input-focus-bg !default;\r\n$input-group-addon-focus-border-color: $input-focus-border-color !default;\r\n\r\n// Custom forms\r\n\r\n$custom-control-gutter: 1.75rem !default;\r\n$custom-control-spacer-x: 1rem !default;\r\n$custom-control-indicator-size: 1.25rem !default;\r\n\r\n$custom-control-indicator-bg: $input-bg !default;\r\n$custom-control-indicator-border-width: 1px !default;\r\n$custom-control-indicator-border-color: $input-border-color !default;\r\n$custom-control-indicator-box-shadow: none !default;\r\n\r\n$custom-control-indicator-focus-box-shadow: $custom-control-indicator-box-shadow !default;\r\n\r\n$custom-control-indicator-hover-color: $component-hover-color !default;\r\n$custom-control-indicator-hover-bg: $component-hover-bg !default;\r\n$custom-control-indicator-hover-border-color: $component-hover-border-color !default;\r\n\r\n$custom-control-indicator-active-color: $component-active-color !default;\r\n$custom-control-indicator-active-bg: $component-active-bg !default;\r\n$custom-control-indicator-active-border-color: $component-active-border-color !default;\r\n$custom-control-indicator-active-box-shadow: $custom-control-indicator-box-shadow !default;\r\n\r\n$custom-control-indicator-checked-color: $component-active-color !default;\r\n$custom-control-indicator-checked-bg: $component-active-bg !default;\r\n$custom-control-indicator-checked-border-color: $component-active-border-color !default;\r\n$custom-control-indicator-checked-box-shadow: $custom-control-indicator-box-shadow !default;\r\n$custom-control-indicator-checked-disabled-bg: rgba(theme-color('primary'), 0.5);\r\n\r\n$custom-control-indicator-disabled-bg: $gray-200 !default;\r\n$custom-control-label-disabled-color: $gray-600 !default;\r\n\r\n$custom-checkbox-indicator-border-radius: $border-radius-sm !default;\r\n//$custom-checkbox-indicator-icon-checked:        str-replace(url(\"data:image/svg+xml !default;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n$custom-toggle-slider-bg: #ddd !default;\r\n$custom-toggle-checked-bg: theme-color('primary') !default;\r\n\r\n// Form validation\r\n\r\n$form-feedback-valid-bg: lighten($success, 15%);\r\n$form-feedback-valid-color: theme-color('success') !default;\r\n$form-feedback-invalid-bg: lighten($warning, 15%);\r\n$form-feedback-invalid-color: theme-color('warning') !default;\r\n\r\n// Allows for customizing button radius independently from global border radius\r\n\r\n$btn-border-radius: $input-border-radius !default;\r\n$btn-border-radius-xl: $input-border-radius-xl !default;\r\n$btn-border-radius-lg: $input-border-radius-lg !default;\r\n$btn-border-radius-sm: $input-border-radius !default;\r\n\r\n// No UI Slider\r\n\r\n$noui-target-bg: #eceeef !default;\r\n$noui-target-thickness: 5px !default;\r\n$noui-target-border-radius: 5px !default;\r\n$noui-target-border-color: 0 !default;\r\n$noui-target-box-shadow: inset 0 1px 2px rgba(90, 97, 105, 0.1);\r\n\r\n$noui-slider-connect-bg: $primary !default;\r\n$noui-slider-connect-disabled-bg: #b2b2b2 !default;\r\n\r\n$noui-handle-width: 15px !default;\r\n$noui-handle-bg: theme-color('primary') !default;\r\n$noui-handle-border: 0 !default;\r\n$noui-handle-border-radius: 100% !default;\r\n\r\n$noui-origin-border-radius: 2px !default;\r\n\r\n// Dropdown\r\n\r\n$dropdown-bg: $white !default;\r\n$dropdown-border-width: 0 !default;\r\n$dropdown-border-color: rgba($black, 0.15);\r\n$dropdown-border-radius: $border-radius-xs !default;\r\n$dropdown-box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15),\r\n  0 5px 15px rgba(0, 0, 0, 0.1);\r\n\r\n$dropdown-link-active-color: $component-active-color !default;\r\n$dropdown-link-active-bg: $component-active-bg !default;\r\n\r\n// Navs\r\n\r\n$nav-link-padding-y: 0.5rem !default;\r\n$nav-link-padding-x: 1rem !default;\r\n$nav-link-color: $gray-700 !default;\r\n$nav-link-disabled-color: $gray-600 !default;\r\n\r\n$nav-pills-padding-y: 0.75rem !default;\r\n$nav-pills-padding-x: 1rem !default;\r\n\r\n$nav-pills-space-x: 1rem !default;\r\n\r\n$nav-pills-bg: $white;\r\n$nav-pills-border-width: 1px !default;\r\n$nav-pills-border-color: theme-color('primary') !default;\r\n$nav-pills-border-radius: $border-radius !default;\r\n\r\n$nav-pills-link-color: theme-color('primary') !default;\r\n$nav-pills-link-hover-color: darken(theme-color('primary'), 5%);\r\n$nav-pills-link-active-color: color-yiq(theme-color('primary'));\r\n$nav-pills-link-active-bg: theme-color('primary') !default;\r\n$nav-pills-box-shadow: $btn-box-shadow !default;\r\n\r\n// Navbar\r\n\r\n$navbar-transition: all 0.15s linear !default;\r\n$navbar-padding-y: 0.625rem !default;\r\n$navbar-padding-x: 0.9375rem !default;\r\n\r\n$navbar-nav-link-padding-x: 1rem !default;\r\n$navbar-nav-link-padding-y: 1rem !default;\r\n\r\n$navbar-nav-link-font-family: $font-family-alt !default;\r\n$navbar-nav-link-font-size: 0.9rem !default;\r\n$navbar-nav-link-font-weight: 400 !default;\r\n$navbar-nav-link-text-transform: normal !default;\r\n$navbar-nav-link-letter-spacing: 0 !default;\r\n$navbar-nav-link-border-radius: $border-radius !default;\r\n\r\n/* navbar color */\r\n$navbar-color: #1a1e34 !default;\r\n$navbar-dark-bg: transparent !default;\r\n$navbar-dark-hover-bg: rgba(255, 255, 255, 0.1);\r\n$navbar-dark-active-bg: rgba(255, 255, 255, 0.1);\r\n$navbar-dark-color: rgba($white, 0.95);\r\n$navbar-dark-hover-color: rgba($white, 0.65);\r\n$navbar-dark-active-color: rgba($white, 0.65);\r\n$navbar-dark-disabled-color: rgba($white, 0.25);\r\n$navbar-dark-toggler-border-color: transparent !default;\r\n\r\n$navbar-light-bg: transparent !default;\r\n$navbar-light-hover-bg: rgba(0, 0, 0, 0.1);\r\n$navbar-light-active-bg: rgba(0, 0, 0, 0.1);\r\n$navbar-light-color: rgba($black, 0.5);\r\n$navbar-light-hover-color: rgba($black, 0.7);\r\n$navbar-light-active-color: rgba($black, 0.9);\r\n$navbar-light-disabled-color: rgba($black, 0.3);\r\n$navbar-light-toggler-icon-bg: str-replace(url(\"data:image/svg+xml !default;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-light-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$navbar-light-toggler-border-color: transparent !default;\r\n$full-width: 100% !default;\r\n$navbar-padding: 10px 15px !default;\r\n\r\n// Alerts\r\n\r\n$alert-padding-y: 0.9rem !default;\r\n$alert-padding-x: 1.25rem !default;\r\n$alert-border-radius: $border-radius-sm !default;\r\n\r\n$alert-bg-level: -2 !default;\r\n$alert-border-level: -2 !default;\r\n$alert-color-level: 0 !default;\r\n\r\n// List group\r\n\r\n$list-group-bg: $white !default;\r\n$list-group-border-color: $border-color !default; //rgba($black, .125);\r\n$list-group-border-width: $border-width !default;\r\n$list-group-border-radius: $border-radius !default;\r\n\r\n$list-group-item-padding-y: 1rem !default;\r\n$list-group-item-padding-x: 1rem !default;\r\n\r\n$list-group-hover-bg: $gray-100 !default;\r\n$list-group-active-color: $component-active-color !default;\r\n$list-group-active-bg: $component-active-bg !default;\r\n$list-group-active-border-color: $list-group-active-bg !default;\r\n\r\n$list-group-disabled-color: $gray-600 !default;\r\n$list-group-disabled-bg: $list-group-bg !default;\r\n\r\n$list-group-action-color: $gray-700 !default;\r\n$list-group-action-hover-color: $list-group-action-color !default;\r\n\r\n$list-group-action-active-color: $list-group-action-color !default;\r\n$list-group-action-active-bg: $gray-200 !default;\r\n\r\n// Close\r\n\r\n$close-font-size: $font-size-base * 1.5 !default;\r\n$close-font-weight: $font-weight-bold !default;\r\n$close-bg: transparent !default;\r\n$close-hover-bg: transparent !default;\r\n$close-color: rgba(0, 0, 0, 0.6);\r\n$close-hover-color: rgba(0, 0, 0, 0.9);\r\n$close-text-shadow: none !default;\r\n\r\n// Popovers\r\n\r\n$popover-font-size: $font-size-sm !default;\r\n$popover-bg: $white !default;\r\n$popover-max-width: 276px !default;\r\n$popover-border-width: 1px !default;\r\n$popover-border-color: rgba($black, 0.05);\r\n$popover-border-radius: $border-radius-lg !default;\r\n$popover-box-shadow: 0px 0.5rem 2rem 0px rgba($black, 0.2);\r\n\r\n$popover-header-bg: $popover-bg !default;\r\n$popover-header-color: $headings-color !default;\r\n$popover-header-padding-y: 0.75rem !default;\r\n$popover-header-padding-x: 0.75rem !default;\r\n\r\n$popover-body-color: $body-color !default;\r\n$popover-body-padding-y: $popover-header-padding-y !default;\r\n$popover-body-padding-x: $popover-header-padding-x !default;\r\n\r\n$popover-arrow-width: 1.5rem !default;\r\n$popover-arrow-height: 0.75rem !default;\r\n$popover-arrow-color: $popover-bg !default;\r\n\r\n$popover-arrow-outer-color: transparent !default;\r\n\r\n// Breadcrumbs\r\n\r\n$breadcrumb-bg: $black-states !default;\r\n$breadcrumb-divider-color: $white !default;\r\n$breadcrumb-active-color: $white !default;\r\n\r\n// Badges\r\n\r\n$badge-font-size: $font-size-xs !default;\r\n$badge-font-weight: $font-weight-extra-bold !default;\r\n$badge-padding-y: 0.25rem !default;\r\n$badge-padding-x: 0.5rem !default;\r\n$badge-border-radius: $border-radius !default;\r\n$badge-text-transfom: uppercase;\r\n\r\n$badge-pill-padding-x: 0.875em !default;\r\n$badge-pill-border-radius: $border-radius-xl !default;\r\n\r\n$badge-circle-size: 2rem;\r\n\r\n// Pagination\r\n\r\n$pagination-padding-y: 0 !default;\r\n$pagination-padding-x: 0.6875rem !default;\r\n\r\n$pagination-color: $white !default;\r\n$pagination-bg: transparent !default;\r\n$pagination-border-width: $border-width !default;\r\n$pagination-border-color: $gray-300 !default;\r\n\r\n//$pagination-focus-box-shadow:       $btn-hover-box-shadow !default;\r\n\r\n$pagination-hover-color: $gray-600 !default;\r\n$pagination-hover-bg: $gray-300 !default;\r\n$pagination-hover-border-color: $gray-300 !default;\r\n\r\n$pagination-active-color: $component-active-color !default;\r\n$pagination-active-bg: $component-active-bg !default;\r\n$pagination-active-border-color: $pagination-active-bg !default;\r\n$pagination-active-box-shadow: $btn-hover-box-shadow !default;\r\n\r\n$pagination-disabled-color: $gray-600 !default;\r\n$pagination-disabled-bg: transparent !default;\r\n$pagination-disabled-border-color: $gray-300 !default;\r\n\r\n// Cards\r\n\r\n$card-spacer-y: 1.25rem !default;\r\n$card-spacer-x: 1.5rem !default;\r\n$card-border-width: $border-width !default;\r\n$card-border-radius: $border-radius-sm !default;\r\n$card-border-color: rgba($black, 0.05);\r\n$card-inner-border-radius: calc(#{$card-border-radius} - #{$card-border-width});\r\n$card-cap-bg: $gray-100 !default;\r\n$card-bg: $white !default;\r\n$card-black-background: #27293d !default;\r\n$card-img-overlay-padding: 1.25rem !default;\r\n\r\n//$card-group-margin:                 ($grid-gutter-width / 2);\r\n//$card-deck-margin:                  $card-group-margin !default;\r\n\r\n$card-columns-count: 3 !default;\r\n$card-columns-gap: 1.25rem !default;\r\n$card-columns-margin: $card-spacer-y !default;\r\n\r\n// Tooltips\r\n\r\n$tooltip-font-size: $font-size-sm !default;\r\n$tooltip-max-width: 200px !default;\r\n$tooltip-color: $black !default;\r\n$tooltip-bg: $white !default;\r\n$tooltip-border-radius: $border-radius !default;\r\n$tooltip-opacity: 0.9 !default;\r\n$tooltip-padding-y: 0.25rem !default;\r\n$tooltip-padding-x: 0.5rem !default;\r\n$tooltip-margin: 0 !default;\r\n\r\n$tooltip-arrow-width: 0.8rem !default;\r\n$tooltip-arrow-height: 0.4rem !default;\r\n$tooltip-arrow-color: $tooltip-bg !default;\r\n\r\n// Modals\r\n\r\n$modal-inner-padding: 24px 24px 16px 24px !default;\r\n\r\n$modal-lg: 80% !default;\r\n$modal-md: 500px !default;\r\n$modal-sm: 380px !default;\r\n$modal-title-line-height: 1.1;\r\n$modal-content-bg: $white !default;\r\n$modal-content-border-color: rgba($black, 0.2);\r\n$modal-content-border-width: 1px !default;\r\n$modal-content-border-radius: $border-radius-sm !default;\r\n$modal-content-box-shadow-xs: 0px 10px 50px 0px rgba(0, 0, 0, 0.5);\r\n$modal-content-box-shadow-sm-up: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);\r\n\r\n$modal-backdrop-bg: $black !default;\r\n$modal-backdrop-opacity: 0.16 !default;\r\n$modal-header-border-color: $gray-200 !default;\r\n$modal-footer-border-color: $modal-header-border-color !default;\r\n$modal-header-border-width: $modal-content-border-width !default;\r\n$modal-footer-border-width: $modal-header-border-width !default;\r\n$modal-header-padding: 24px 24px 0 24px !default;\r\n\r\n// Progress bars\r\n\r\n$progress-height: 0.5rem !default;\r\n$progress-bg: rgba(0, 0, 0, 0.3) !default;\r\n$progress-border-radius: $border-radius-xl !default;\r\n$progress-box-shadow: 0px 0px 0px 3px rgba(0, 0, 0, 0.3) !default;\r\n$progress-bar-color: $white !default;\r\n\r\n// Datepicker\r\n\r\n$datepicker-border-radius: $card-border-radius !default;\r\n$datepicker-dropdown-padding: 20px 22px !default;\r\n\r\n$datepicker-cell-transition: $transition-base !default;\r\n$datepicker-cell-hover-background: lighten($gray-400, 55%);\r\n$datepicker-cell-border-radius: 50% !default;\r\n$datepicker-cell-width: 36px !default;\r\n$datepicker-cell-height: 36px !default;\r\n\r\n$datepicker-disabled-cell-color: $gray-300 !default;\r\n$datepicker-disabled-old-new-color: $gray-500 !default;\r\n\r\n$datepicker-header-cell-border-radius: $border-radius !default;\r\n\r\n$datepicker-active-color: $white !default;\r\n$datepicker-active-background: theme-color('primary') !default;\r\n$datepicker-active-box-shadow: none !default;\r\n\r\n$datepicker-range-background: theme-color('primary') !default;\r\n$datepicker-range-cell-focused-background: darken($datepicker-range-background, 5%);\r\n$datepicker-range-color: $white !default;\r\n$datepicker-range-highlighted-bg: $gray-200 !default;\r\n\r\n$datepicker-dropdown-border: lighten($gray-400, 40%);\r\n$datepicker-dropdown-bg: $white !default;\r\n$datepicker-highlighted-bg: $datepicker-active-background !default;\r\n\r\n// Footer\r\n\r\n$footer-link-font-size: 0.85rem !default;\r\n$footer-bg: theme-color('secondary') !default;\r\n$footer-color: $gray-600 !default;\r\n$footer-link-color: $gray-600 !default;\r\n$footer-link-hover-color: $gray-700 !default;\r\n$footer-heading-color: $gray-600 !default;\r\n$footer-heading-font-size: $font-size-sm !default;\r\n",":root {\r\n  // Custom variable values only support SassScript inside `#{}`.\r\n  @each $color, $value in $colors {\r\n    --#{$color}: #{$value};\r\n  }\r\n\r\n  @each $color, $value in $theme-colors {\r\n    --#{$color}: #{$value};\r\n  }\r\n\r\n  @each $bp, $value in $grid-breakpoints {\r\n    --breakpoint-#{$bp}: #{$value};\r\n  }\r\n\r\n  // Use `inspect` for lists so that quoted items keep the quotes.\r\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\r\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\r\n  --font-family-monospace: #{inspect($font-family-monospace)};\r\n}\r\n","// stylelint-disable at-rule-no-vendor-prefix, declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\r\n\r\n// Reboot\r\n//\r\n// Normalization of HTML elements, manually forked from Normalize.css to remove\r\n// styles targeting irrelevant browsers while applying new styles.\r\n//\r\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\r\n\r\n// Document\r\n//\r\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\r\n// 2. Change the default font family in all browsers.\r\n// 3. Correct the line height in all browsers.\r\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\r\n// 5. Setting @viewport causes scrollbars to overlap content in IE11 and Edge, so\r\n//    we force a non-overlapping, non-auto-hiding scrollbar to counteract.\r\n// 6. Change the default tap highlight to be completely transparent in iOS.\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box; // 1\r\n}\r\n\r\nhtml {\r\n  font-family: sans-serif; // 2\r\n  line-height: 1.15; // 3\r\n  -webkit-text-size-adjust: 100%; // 4\r\n  -ms-text-size-adjust: 100%; // 4\r\n  -ms-overflow-style: scrollbar; // 5\r\n  -webkit-tap-highlight-color: rgba($black, 0); // 6\r\n}\r\n\r\n// IE10+ doesn't honor `<meta name=\"viewport\">` in some cases.\r\n@at-root {\r\n  @-ms-viewport {\r\n    width: device-width;\r\n  }\r\n}\r\n\r\n// stylelint-disable selector-list-comma-newline-after\r\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\r\narticle,\r\naside,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmain,\r\nnav,\r\nsection {\r\n  display: block;\r\n}\r\n// stylelint-enable selector-list-comma-newline-after\r\n\r\n// Body\r\n//\r\n// 1. Remove the margin in all browsers.\r\n// 2. As a best practice, apply a default `background-color`.\r\n// 3. Set an explicit initial text-align value so that we can later use the\r\n//    the `inherit` value on things like `<th>` elements.\r\n\r\nbody {\r\n  margin: 0; // 1\r\n  font-family: $font-family-base;\r\n  font-size: $font-size-base;\r\n  font-weight: $font-weight-base;\r\n  line-height: $line-height-base;\r\n  color: $body-color;\r\n  text-align: left; // 3\r\n  background-color: $body-bg; // 2\r\n}\r\n\r\n// Suppress the focus outline on elements that cannot be accessed via keyboard.\r\n// This prevents an unwanted focus outline from appearing around elements that\r\n// might still respond to pointer events.\r\n//\r\n// Credit: https://github.com/suitcss/base\r\n[tabindex='-1']:focus {\r\n  outline: 0 !important;\r\n}\r\n\r\n// Content grouping\r\n//\r\n// 1. Add the correct box sizing in Firefox.\r\n// 2. Show the overflow in Edge and IE.\r\n\r\nhr {\r\n  box-sizing: content-box; // 1\r\n  height: 0; // 1\r\n  overflow: visible; // 2\r\n}\r\n\r\n//\r\n// Typography\r\n//\r\n\r\n// Remove top margins from headings\r\n//\r\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\r\n// margin for easier control within type scales as it avoids margin collapsing.\r\n// stylelint-disable selector-list-comma-newline-after\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  margin-top: 0;\r\n  margin-bottom: $headings-margin-bottom;\r\n}\r\n// stylelint-enable selector-list-comma-newline-after\r\n\r\n// Reset margins on paragraphs\r\n//\r\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\r\n// bottom margin to use `rem` units instead of `em`.\r\np {\r\n  margin-top: 0;\r\n  margin-bottom: $paragraph-margin-bottom;\r\n}\r\n\r\n// Abbreviations\r\n//\r\n// 1. Remove the bottom border in Firefox 39-.\r\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\r\n// 3. Add explicit cursor to indicate changed behavior.\r\n// 4. Duplicate behavior to the data-* attribute for our tooltip plugin\r\n\r\nabbr[title],\r\nabbr[data-original-title] {\r\n  // 4\r\n  text-decoration: underline; // 2\r\n  text-decoration: underline dotted; // 2\r\n  cursor: help; // 3\r\n  border-bottom: 0; // 1\r\n}\r\n\r\naddress {\r\n  margin-bottom: 1rem;\r\n  font-style: normal;\r\n  line-height: inherit;\r\n}\r\n\r\nol,\r\nul,\r\ndl {\r\n  margin-top: 0;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\nol ol,\r\nul ul,\r\nol ul,\r\nul ol {\r\n  margin-bottom: 0;\r\n}\r\n\r\ndt {\r\n  font-weight: $dt-font-weight;\r\n}\r\n\r\ndd {\r\n  margin-bottom: 0.5rem;\r\n  margin-left: 0; // Undo browser default\r\n}\r\n\r\nblockquote {\r\n  margin: 0 0 1rem;\r\n}\r\n\r\ndfn {\r\n  font-style: italic; // Add the correct font style in Android 4.3-\r\n}\r\n\r\n// stylelint-disable font-weight-notation\r\nb,\r\nstrong {\r\n  font-weight: bolder; // Add the correct font weight in Chrome, Edge, and Safari\r\n}\r\n// stylelint-enable font-weight-notation\r\n\r\nsmall {\r\n  font-size: 80%; // Add the correct font size in all browsers\r\n}\r\n\r\n//\r\n// Prevent `sub` and `sup` elements from affecting the line height in\r\n// all browsers.\r\n//\r\n\r\nsub,\r\nsup {\r\n  position: relative;\r\n  font-size: 75%;\r\n  line-height: 0;\r\n  vertical-align: baseline;\r\n}\r\n\r\nsub {\r\n  bottom: -0.25em;\r\n}\r\nsup {\r\n  top: -0.5em;\r\n}\r\n\r\n//\r\n// Links\r\n//\r\n\r\na {\r\n  color: $link-color;\r\n  text-decoration: $link-decoration;\r\n  background-color: transparent; // Remove the gray background on active links in IE 10.\r\n  -webkit-text-decoration-skip: objects; // Remove gaps in links underline in iOS 8+ and Safari 8+.\r\n\r\n  @include hover {\r\n    color: $link-hover-color;\r\n    text-decoration: $link-hover-decoration;\r\n  }\r\n}\r\n\r\n// And undo these styles for placeholder links/named anchors (without href)\r\n// which have not been made explicitly keyboard-focusable (without tabindex).\r\n// It would be more straightforward to just use a[href] in previous block, but that\r\n// causes specificity issues in many other styles that are too complex to fix.\r\n// See https://github.com/twbs/bootstrap/issues/19402\r\n\r\na:not([href]):not([tabindex]) {\r\n  color: inherit;\r\n  text-decoration: none;\r\n\r\n  @include hover-focus {\r\n    color: inherit;\r\n    text-decoration: none;\r\n  }\r\n\r\n  &:focus {\r\n    outline: 0;\r\n  }\r\n}\r\n\r\n//\r\n// Code\r\n//\r\n\r\npre,\r\ncode,\r\nkbd,\r\nsamp {\r\n  font-family: $font-family-monospace;\r\n  font-size: 1em; // Correct the odd `em` font sizing in all browsers.\r\n}\r\n\r\npre {\r\n  // Remove browser default top margin\r\n  margin-top: 0;\r\n  // Reset browser default of `1em` to use `rem`s\r\n  margin-bottom: 1rem;\r\n  // Don't allow content to break outside\r\n  overflow: auto;\r\n  // We have @viewport set which causes scrollbars to overlap content in IE11 and Edge, so\r\n  // we force a non-overlapping, non-auto-hiding scrollbar to counteract.\r\n  -ms-overflow-style: scrollbar;\r\n}\r\n\r\n//\r\n// Figures\r\n//\r\n\r\nfigure {\r\n  // Apply a consistent margin strategy (matches our type styles).\r\n  margin: 0 0 1rem;\r\n}\r\n\r\n//\r\n// Images and content\r\n//\r\n\r\nimg {\r\n  vertical-align: middle;\r\n  border-style: none; // Remove the border on images inside links in IE 10-.\r\n}\r\n\r\nsvg {\r\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\r\n  // See https://github.com/twbs/bootstrap/issues/26878\r\n  overflow: hidden;\r\n  vertical-align: middle;\r\n}\r\n\r\n//\r\n// Tables\r\n//\r\n\r\ntable {\r\n  border-collapse: collapse; // Prevent double borders\r\n}\r\n\r\ncaption {\r\n  padding-top: $table-cell-padding;\r\n  padding-bottom: $table-cell-padding;\r\n  color: $table-caption-color;\r\n  text-align: left;\r\n  caption-side: bottom;\r\n}\r\n\r\nth {\r\n  // Matches default `<td>` alignment by inheriting from the `<body>`, or the\r\n  // closest parent with a set `text-align`.\r\n  text-align: inherit;\r\n}\r\n\r\n//\r\n// Forms\r\n//\r\n\r\nlabel {\r\n  // Allow labels to use `margin` for spacing.\r\n  display: inline-block;\r\n  margin-bottom: $label-margin-bottom;\r\n}\r\n\r\n// Remove the default `border-radius` that macOS Chrome adds.\r\n//\r\n// Details at https://github.com/twbs/bootstrap/issues/24093\r\nbutton {\r\n  border-radius: 0;\r\n}\r\n\r\n// Work around a Firefox/IE bug where the transparent `button` background\r\n// results in a loss of the default `button` focus styles.\r\n//\r\n// Credit: https://github.com/suitcss/base/\r\nbutton:focus {\r\n  // outline: 1px dotted;\r\n  // outline: 5px auto -webkit-focus-ring-color;\r\n}\r\n\r\ninput,\r\nbutton,\r\nselect,\r\noptgroup,\r\ntextarea {\r\n  margin: 0; // Remove the margin in Firefox and Safari\r\n  font-family: inherit;\r\n  font-size: inherit;\r\n  line-height: inherit;\r\n}\r\n\r\nbutton,\r\ninput {\r\n  overflow: visible; // Show the overflow in Edge\r\n}\r\n\r\nbutton,\r\nselect {\r\n  text-transform: none; // Remove the inheritance of text transform in Firefox\r\n}\r\n\r\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\r\n//    controls in Android 4.\r\n// 2. Correct the inability to style clickable types in iOS and Safari.\r\nbutton,\r\nhtml [type=\"button\"], // 1\r\n[type=\"reset\"],\r\n[type=\"submit\"] {\r\n  -webkit-appearance: button; // 2\r\n}\r\n\r\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\r\nbutton::-moz-focus-inner,\r\n[type='button']::-moz-focus-inner,\r\n[type='reset']::-moz-focus-inner,\r\n[type='submit']::-moz-focus-inner {\r\n  padding: 0;\r\n  border-style: none;\r\n}\r\n\r\ninput[type='radio'],\r\ninput[type='checkbox'] {\r\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\r\n  padding: 0; // 2. Remove the padding in IE 10-\r\n}\r\n\r\ninput[type='date'],\r\ninput[type='time'],\r\ninput[type='datetime-local'],\r\ninput[type='month'] {\r\n  // Remove the default appearance of temporal inputs to avoid a Mobile Safari\r\n  // bug where setting a custom line-height prevents text from being vertically\r\n  // centered within the input.\r\n  // See https://bugs.webkit.org/show_bug.cgi?id=139848\r\n  // and https://github.com/twbs/bootstrap/issues/11266\r\n  -webkit-appearance: listbox;\r\n}\r\n\r\ntextarea {\r\n  overflow: auto; // Remove the default vertical scrollbar in IE.\r\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\r\n  resize: vertical;\r\n}\r\n\r\nfieldset {\r\n  // Browsers set a default `min-width: min-content;` on fieldsets,\r\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\r\n  // So we reset that to ensure fieldsets behave more like a standard block element.\r\n  // See https://github.com/twbs/bootstrap/issues/12359\r\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\r\n  min-width: 0;\r\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\r\n  padding: 0;\r\n  margin: 0;\r\n  border: 0;\r\n}\r\n\r\n// 1. Correct the text wrapping in Edge and IE.\r\n// 2. Correct the color inheritance from `fieldset` elements in IE.\r\nlegend {\r\n  display: block;\r\n  width: 100%;\r\n  max-width: 100%; // 1\r\n  padding: 0;\r\n  margin-bottom: 0.5rem;\r\n  font-size: 1.5rem;\r\n  line-height: inherit;\r\n  color: inherit; // 2\r\n  white-space: normal; // 1\r\n}\r\n\r\nprogress {\r\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\r\n}\r\n\r\n// Correct the cursor style of increment and decrement buttons in Chrome.\r\n[type='number']::-webkit-inner-spin-button,\r\n[type='number']::-webkit-outer-spin-button {\r\n  height: auto;\r\n}\r\n\r\n[type='search'] {\r\n  // This overrides the extra rounded corners on search inputs in iOS so that our\r\n  // `.form-control` class can properly style them. Note that this cannot simply\r\n  // be added to `.form-control` as it's not specific enough. For details, see\r\n  // https://github.com/twbs/bootstrap/issues/11586.\r\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\r\n  -webkit-appearance: none;\r\n}\r\n\r\n//\r\n// Remove the inner padding and cancel buttons in Chrome and Safari on macOS.\r\n//\r\n\r\n[type='search']::-webkit-search-cancel-button,\r\n[type='search']::-webkit-search-decoration {\r\n  -webkit-appearance: none;\r\n}\r\n\r\n//\r\n// 1. Correct the inability to style clickable types in iOS and Safari.\r\n// 2. Change font properties to `inherit` in Safari.\r\n//\r\n\r\n::-webkit-file-upload-button {\r\n  font: inherit; // 2\r\n  -webkit-appearance: button; // 1\r\n}\r\n\r\n//\r\n// Correct element displays\r\n//\r\n\r\noutput {\r\n  display: inline-block;\r\n}\r\n\r\nsummary {\r\n  display: list-item; // Add the correct display in all browsers\r\n  cursor: pointer;\r\n}\r\n\r\ntemplate {\r\n  display: none; // Add the correct display in IE\r\n}\r\n\r\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\r\n// Needed for proper display in IE 10-.\r\n[hidden] {\r\n  display: none !important;\r\n}\r\n","// Variables\r\n//\r\n// Variables should follow the `$component-state-property-size` formula for\r\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\r\n\r\n\r\n//\r\n// Color system\r\n//\r\n\r\n$white:    #fff !default;\r\n$gray-100: #f8f9fa !default;\r\n$gray-200: #e9ecef !default;\r\n$gray-300: #dee2e6 !default;\r\n$gray-400: #ced4da !default;\r\n$gray-500: #adb5bd !default;\r\n$gray-600: #6c757d !default;\r\n$gray-700: #495057 !default;\r\n$gray-800: #343a40 !default;\r\n$gray-900: #212529 !default;\r\n$black:    #000 !default;\r\n\r\n$grays: () !default;\r\n// stylelint-disable-next-line scss/dollar-variable-default\r\n$grays: map-merge(\r\n  (\r\n    \"100\": $gray-100,\r\n    \"200\": $gray-200,\r\n    \"300\": $gray-300,\r\n    \"400\": $gray-400,\r\n    \"500\": $gray-500,\r\n    \"600\": $gray-600,\r\n    \"700\": $gray-700,\r\n    \"800\": $gray-800,\r\n    \"900\": $gray-900\r\n  ),\r\n  $grays\r\n);\r\n\r\n\r\n$blue:    #007bff !default;\r\n$indigo:  #6610f2 !default;\r\n$purple:  #6f42c1 !default;\r\n$pink:    #e83e8c !default;\r\n$red:     #dc3545 !default;\r\n$orange:  #fd7e14 !default;\r\n$yellow:  #ffc107 !default;\r\n$green:   #28a745 !default;\r\n$teal:    #20c997 !default;\r\n$cyan:    #17a2b8 !default;\r\n\r\n$colors: () !default;\r\n// stylelint-disable-next-line scss/dollar-variable-default\r\n$colors: map-merge(\r\n  (\r\n    \"blue\":       $blue,\r\n    \"indigo\":     $indigo,\r\n    \"purple\":     $purple,\r\n    \"pink\":       $pink,\r\n    \"red\":        $red,\r\n    \"orange\":     $orange,\r\n    \"yellow\":     $yellow,\r\n    \"green\":      $green,\r\n    \"teal\":       $teal,\r\n    \"cyan\":       $cyan,\r\n    \"white\":      $white,\r\n    \"gray\":       $gray-600,\r\n    \"gray-dark\":  $gray-800\r\n  ),\r\n  $colors\r\n);\r\n\r\n$primary:       $blue !default;\r\n$secondary:     $gray-600 !default;\r\n$success:       $green !default;\r\n$info:          $cyan !default;\r\n$warning:       $yellow !default;\r\n$danger:        $red !default;\r\n$light:         $gray-100 !default;\r\n$dark:          $gray-800 !default;\r\n\r\n$theme-colors: () !default;\r\n// stylelint-disable-next-line scss/dollar-variable-default\r\n$theme-colors: map-merge(\r\n  (\r\n    \"primary\":    $primary,\r\n    \"secondary\":  $secondary,\r\n    \"success\":    $success,\r\n    \"info\":       $info,\r\n    \"warning\":    $warning,\r\n    \"danger\":     $danger,\r\n    \"light\":      $light,\r\n    \"dark\":       $dark\r\n  ),\r\n  $theme-colors\r\n);\r\n\r\n// Set a specific jump point for requesting color jumps\r\n$theme-color-interval:      8% !default;\r\n\r\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\r\n$yiq-contrasted-threshold:  150 !default;\r\n\r\n// Customize the light and dark text colors for use in our YIQ color contrast function.\r\n$yiq-text-dark:             $gray-900 !default;\r\n$yiq-text-light:            $white !default;\r\n\r\n// Options\r\n//\r\n// Quickly modify global styling by enabling or disabling optional features.\r\n\r\n$enable-caret:              true !default;\r\n$enable-rounded:            true !default;\r\n$enable-shadows:            false !default;\r\n$enable-gradients:          false !default;\r\n$enable-transitions:        true !default;\r\n$enable-hover-media-query:  false !default; // Deprecated, no longer affects any compiled CSS\r\n$enable-grid-classes:       true !default;\r\n$enable-print-styles:       true !default;\r\n\r\n\r\n// Spacing\r\n//\r\n// Control the default styling of most Bootstrap elements by modifying these\r\n// variables. Mostly focused on spacing.\r\n// You can add more entries to the $spacers map, should you need more variation.\r\n\r\n$spacer: 1rem !default;\r\n$spacers: () !default;\r\n// stylelint-disable-next-line scss/dollar-variable-default\r\n$spacers: map-merge(\r\n  (\r\n    0: 0,\r\n    1: ($spacer * .25),\r\n    2: ($spacer * .5),\r\n    3: $spacer,\r\n    4: ($spacer * 1.5),\r\n    5: ($spacer * 3)\r\n  ),\r\n  $spacers\r\n);\r\n\r\n// This variable affects the `.h-*` and `.w-*` classes.\r\n$sizes: () !default;\r\n// stylelint-disable-next-line scss/dollar-variable-default\r\n$sizes: map-merge(\r\n  (\r\n    25: 25%,\r\n    50: 50%,\r\n    75: 75%,\r\n    100: 100%,\r\n    auto: auto\r\n  ),\r\n  $sizes\r\n);\r\n\r\n// Body\r\n//\r\n// Settings for the `<body>` element.\r\n\r\n$body-bg:                   $white !default;\r\n$body-color:                $gray-900 !default;\r\n\r\n// Links\r\n//\r\n// Style anchor elements.\r\n\r\n$link-color:                theme-color(\"primary\") !default;\r\n$link-decoration:           none !default;\r\n$link-hover-color:          darken($link-color, 15%) !default;\r\n$link-hover-decoration:     underline !default;\r\n\r\n// Paragraphs\r\n//\r\n// Style p element.\r\n\r\n$paragraph-margin-bottom:   1rem !default;\r\n\r\n\r\n// Grid breakpoints\r\n//\r\n// Define the minimum dimensions at which your layout will change,\r\n// adapting to different screen sizes, for use in media queries.\r\n\r\n$grid-breakpoints: (\r\n  xs: 0,\r\n  sm: 576px,\r\n  md: 768px,\r\n  lg: 992px,\r\n  xl: 1200px\r\n) !default;\r\n\r\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\r\n@include _assert-starts-at-zero($grid-breakpoints);\r\n\r\n\r\n// Grid containers\r\n//\r\n// Define the maximum width of `.container` for different screen sizes.\r\n\r\n$container-max-widths: (\r\n  sm: 540px,\r\n  md: 720px,\r\n  lg: 960px,\r\n  xl: 1140px\r\n) !default;\r\n\r\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\r\n\r\n\r\n// Grid columns\r\n//\r\n// Set the number of columns and specify the width of the gutters.\r\n\r\n$grid-columns:                12 !default;\r\n$grid-gutter-width:           30px !default;\r\n\r\n// Components\r\n//\r\n// Define common padding and border radius sizes and more.\r\n\r\n$line-height-lg:              1.5 !default;\r\n$line-height-sm:              1.5 !default;\r\n\r\n$border-width:                1px !default;\r\n$border-color:                $gray-300 !default;\r\n\r\n$border-radius:               .25rem !default;\r\n$border-radius-lg:            .3rem !default;\r\n$border-radius-sm:            .2rem !default;\r\n\r\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\r\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\r\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\r\n\r\n$component-active-color:      $white !default;\r\n$component-active-bg:         theme-color(\"primary\") !default;\r\n\r\n$caret-width:                 .3em !default;\r\n\r\n$transition-base:             all .2s ease-in-out !default;\r\n$transition-fade:             opacity .15s linear !default;\r\n$transition-collapse:         height .35s ease !default;\r\n\r\n\r\n// Fonts\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\r\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\r\n$font-family-base:            $font-family-sans-serif !default;\r\n// stylelint-enable value-keyword-case\r\n\r\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\r\n$font-size-lg:                ($font-size-base * 1.25) !default;\r\n$font-size-sm:                ($font-size-base * .875) !default;\r\n\r\n$font-weight-light:           300 !default;\r\n$font-weight-normal:          400 !default;\r\n$font-weight-bold:            700 !default;\r\n\r\n$font-weight-base:            $font-weight-normal !default;\r\n$line-height-base:            1.5 !default;\r\n\r\n$h1-font-size:                $font-size-base * 2.5 !default;\r\n$h2-font-size:                $font-size-base * 2 !default;\r\n$h3-font-size:                $font-size-base * 1.75 !default;\r\n$h4-font-size:                $font-size-base * 1.5 !default;\r\n$h5-font-size:                $font-size-base * 1.25 !default;\r\n$h6-font-size:                $font-size-base !default;\r\n\r\n$headings-margin-bottom:      ($spacer / 2) !default;\r\n$headings-font-family:        inherit !default;\r\n$headings-font-weight:        500 !default;\r\n$headings-line-height:        1.2 !default;\r\n$headings-color:              inherit !default;\r\n\r\n$display1-size:               6rem !default;\r\n$display2-size:               5.5rem !default;\r\n$display3-size:               4.5rem !default;\r\n$display4-size:               3.5rem !default;\r\n\r\n$display1-weight:             300 !default;\r\n$display2-weight:             300 !default;\r\n$display3-weight:             300 !default;\r\n$display4-weight:             300 !default;\r\n$display-line-height:         $headings-line-height !default;\r\n\r\n$lead-font-size:              ($font-size-base * 1.25) !default;\r\n$lead-font-weight:            300 !default;\r\n\r\n$small-font-size:             80% !default;\r\n\r\n$text-muted:                  $gray-600 !default;\r\n\r\n$blockquote-small-color:      $gray-600 !default;\r\n$blockquote-font-size:        ($font-size-base * 1.25) !default;\r\n\r\n$hr-border-color:             rgba($black, .1) !default;\r\n$hr-border-width:             $border-width !default;\r\n\r\n$mark-padding:                .2em !default;\r\n\r\n$dt-font-weight:              $font-weight-bold !default;\r\n\r\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\r\n$nested-kbd-font-weight:      $font-weight-bold !default;\r\n\r\n$list-inline-padding:         .5rem !default;\r\n\r\n$mark-bg:                     #fcf8e3 !default;\r\n\r\n$hr-margin-y:                 $spacer !default;\r\n\r\n\r\n// Tables\r\n//\r\n// Customizes the `.table` component with basic values, each used across all table variations.\r\n\r\n$table-cell-padding:          .75rem !default;\r\n$table-cell-padding-sm:       .3rem !default;\r\n\r\n$table-bg:                    transparent !default;\r\n$table-accent-bg:             rgba($black, .05) !default;\r\n$table-hover-bg:              rgba($black, .075) !default;\r\n$table-active-bg:             $table-hover-bg !default;\r\n\r\n$table-border-width:          $border-width !default;\r\n$table-border-color:          $gray-300 !default;\r\n\r\n$table-head-bg:               $gray-200 !default;\r\n$table-head-color:            $gray-700 !default;\r\n\r\n$table-dark-bg:               $gray-900 !default;\r\n$table-dark-accent-bg:        rgba($white, .05) !default;\r\n$table-dark-hover-bg:         rgba($white, .075) !default;\r\n$table-dark-border-color:     lighten($gray-900, 7.5%) !default;\r\n$table-dark-color:            $body-bg !default;\r\n\r\n$table-striped-order:         odd !default;\r\n\r\n$table-caption-color:         $text-muted !default;\r\n\r\n// Buttons + Forms\r\n//\r\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\r\n\r\n$input-btn-padding-y:         .375rem !default;\r\n$input-btn-padding-x:         .75rem !default;\r\n$input-btn-line-height:       $line-height-base !default;\r\n\r\n$input-btn-focus-width:       .2rem !default;\r\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\r\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\r\n\r\n$input-btn-padding-y-sm:      .25rem !default;\r\n$input-btn-padding-x-sm:      .5rem !default;\r\n$input-btn-line-height-sm:    $line-height-sm !default;\r\n\r\n$input-btn-padding-y-lg:      .5rem !default;\r\n$input-btn-padding-x-lg:      1rem !default;\r\n$input-btn-line-height-lg:    $line-height-lg !default;\r\n\r\n$input-btn-border-width:      $border-width !default;\r\n\r\n\r\n// Buttons\r\n//\r\n// For each of Bootstrap's buttons, define text, background, and border color.\r\n\r\n$btn-padding-y:               $input-btn-padding-y !default;\r\n$btn-padding-x:               $input-btn-padding-x !default;\r\n$btn-line-height:             $input-btn-line-height !default;\r\n\r\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\r\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\r\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\r\n\r\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\r\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\r\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\r\n\r\n$btn-border-width:            $input-btn-border-width !default;\r\n\r\n$btn-font-weight:             $font-weight-normal !default;\r\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\r\n$btn-focus-width:             $input-btn-focus-width !default;\r\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\r\n$btn-disabled-opacity:        .65 !default;\r\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\r\n\r\n$btn-link-disabled-color:     $gray-600 !default;\r\n\r\n$btn-block-spacing-y:         .5rem !default;\r\n\r\n// Allows for customizing button radius independently from global border radius\r\n$btn-border-radius:           $border-radius !default;\r\n$btn-border-radius-lg:        $border-radius-lg !default;\r\n$btn-border-radius-sm:        $border-radius-sm !default;\r\n\r\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\r\n\r\n\r\n// Forms\r\n\r\n$label-margin-bottom:                   .5rem !default;\r\n\r\n$input-padding-y:                       $input-btn-padding-y !default;\r\n$input-padding-x:                       $input-btn-padding-x !default;\r\n$input-line-height:                     $input-btn-line-height !default;\r\n\r\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\r\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\r\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\r\n\r\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\r\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\r\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\r\n\r\n$input-bg:                              $white !default;\r\n$input-disabled-bg:                     $gray-200 !default;\r\n\r\n$input-color:                           $gray-700 !default;\r\n$input-border-color:                    $gray-400 !default;\r\n$input-border-width:                    $input-btn-border-width !default;\r\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\r\n\r\n$input-border-radius:                   $border-radius !default;\r\n$input-border-radius-lg:                $border-radius-lg !default;\r\n$input-border-radius-sm:                $border-radius-sm !default;\r\n\r\n$input-focus-bg:                        $input-bg !default;\r\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\r\n$input-focus-color:                     $input-color !default;\r\n$input-focus-width:                     $input-btn-focus-width !default;\r\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\r\n\r\n$input-placeholder-color:               $gray-600 !default;\r\n$input-plaintext-color:                 $body-color !default;\r\n\r\n$input-height-border:                   $input-border-width * 2 !default;\r\n\r\n$input-height-inner:                    ($font-size-base * $input-btn-line-height) + ($input-btn-padding-y * 2) !default;\r\n$input-height:                          calc(#{$input-height-inner} + #{$input-height-border}) !default;\r\n\r\n$input-height-inner-sm:                 ($font-size-sm * $input-btn-line-height-sm) + ($input-btn-padding-y-sm * 2) !default;\r\n$input-height-sm:                       calc(#{$input-height-inner-sm} + #{$input-height-border}) !default;\r\n\r\n$input-height-inner-lg:                 ($font-size-lg * $input-btn-line-height-lg) + ($input-btn-padding-y-lg * 2) !default;\r\n$input-height-lg:                       calc(#{$input-height-inner-lg} + #{$input-height-border}) !default;\r\n\r\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\r\n\r\n$form-text-margin-top:                  .25rem !default;\r\n\r\n$form-check-input-gutter:               1.25rem !default;\r\n$form-check-input-margin-y:             .3rem !default;\r\n$form-check-input-margin-x:             .25rem !default;\r\n\r\n$form-check-inline-margin-x:            .75rem !default;\r\n$form-check-inline-input-margin-x:      .3125rem !default;\r\n\r\n$form-group-margin-bottom:              1rem !default;\r\n\r\n$input-group-addon-color:               $input-color !default;\r\n$input-group-addon-bg:                  $gray-200 !default;\r\n$input-group-addon-border-color:        $input-border-color !default;\r\n\r\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\r\n\r\n$custom-control-gutter:                 1.5rem !default;\r\n$custom-control-spacer-x:               1rem !default;\r\n\r\n$custom-control-indicator-size:         1rem !default;\r\n$custom-control-indicator-bg:           $gray-300 !default;\r\n$custom-control-indicator-bg-size:      50% 50% !default;\r\n$custom-control-indicator-box-shadow:   inset 0 .25rem .25rem rgba($black, .1) !default;\r\n\r\n$custom-control-indicator-disabled-bg:          $gray-200 !default;\r\n$custom-control-label-disabled-color:           $gray-600 !default;\r\n\r\n$custom-control-indicator-checked-color:        $component-active-color !default;\r\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\r\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\r\n$custom-control-indicator-checked-box-shadow:   none !default;\r\n\r\n$custom-control-indicator-focus-box-shadow:     0 0 0 1px $body-bg, $input-btn-focus-box-shadow !default;\r\n\r\n$custom-control-indicator-active-color:         $component-active-color !default;\r\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\r\n$custom-control-indicator-active-box-shadow:    none !default;\r\n\r\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\r\n$custom-checkbox-indicator-icon-checked:        str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n$custom-checkbox-indicator-indeterminate-bg:          $component-active-bg !default;\r\n$custom-checkbox-indicator-indeterminate-color:       $custom-control-indicator-checked-color !default;\r\n$custom-checkbox-indicator-icon-indeterminate:        str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$custom-checkbox-indicator-indeterminate-box-shadow:  none !default;\r\n\r\n$custom-radio-indicator-border-radius:          50% !default;\r\n$custom-radio-indicator-icon-checked:           str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='#{$custom-control-indicator-checked-color}'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n$custom-select-padding-y:           .375rem !default;\r\n$custom-select-padding-x:           .75rem !default;\r\n$custom-select-height:              $input-height !default;\r\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\r\n$custom-select-line-height:         $input-btn-line-height !default;\r\n$custom-select-color:               $input-color !default;\r\n$custom-select-disabled-color:      $gray-600 !default;\r\n$custom-select-bg:                  $input-bg !default;\r\n$custom-select-disabled-bg:         $gray-200 !default;\r\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\r\n$custom-select-indicator-color:     $gray-800 !default;\r\n$custom-select-indicator:           str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$custom-select-border-width:        $input-btn-border-width !default;\r\n$custom-select-border-color:        $input-border-color !default;\r\n$custom-select-border-radius:       $border-radius !default;\r\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\r\n\r\n$custom-select-focus-border-color:  $input-focus-border-color !default;\r\n$custom-select-focus-width:         $input-btn-focus-width !default;\r\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width rgba($custom-select-focus-border-color, .5) !default;\r\n\r\n$custom-select-font-size-sm:        75% !default;\r\n$custom-select-height-sm:           $input-height-sm !default;\r\n\r\n$custom-select-font-size-lg:        125% !default;\r\n$custom-select-height-lg:           $input-height-lg !default;\r\n\r\n$custom-range-track-width:          100% !default;\r\n$custom-range-track-height:         .5rem !default;\r\n$custom-range-track-cursor:         pointer !default;\r\n$custom-range-track-bg:             $gray-300 !default;\r\n$custom-range-track-border-radius:  1rem !default;\r\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\r\n\r\n$custom-range-thumb-width:                   1rem !default;\r\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\r\n$custom-range-thumb-bg:                      $component-active-bg !default;\r\n$custom-range-thumb-border:                  0 !default;\r\n$custom-range-thumb-border-radius:           1rem !default;\r\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\r\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-btn-focus-box-shadow !default;\r\n$custom-range-thumb-focus-box-shadow-width:  $input-btn-focus-width !default; // For focus box shadow issue in IE/Edge\r\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\r\n\r\n$custom-file-height:                $input-height !default;\r\n$custom-file-height-inner:          $input-height-inner !default;\r\n$custom-file-focus-border-color:    $input-focus-border-color !default;\r\n$custom-file-focus-box-shadow:      $input-btn-focus-box-shadow !default;\r\n$custom-file-disabled-bg:           $input-disabled-bg !default;\r\n\r\n$custom-file-padding-y:             $input-btn-padding-y !default;\r\n$custom-file-padding-x:             $input-btn-padding-x !default;\r\n$custom-file-line-height:           $input-btn-line-height !default;\r\n$custom-file-color:                 $input-color !default;\r\n$custom-file-bg:                    $input-bg !default;\r\n$custom-file-border-width:          $input-btn-border-width !default;\r\n$custom-file-border-color:          $input-border-color !default;\r\n$custom-file-border-radius:         $input-border-radius !default;\r\n$custom-file-box-shadow:            $input-box-shadow !default;\r\n$custom-file-button-color:          $custom-file-color !default;\r\n$custom-file-button-bg:             $input-group-addon-bg !default;\r\n$custom-file-text: (\r\n  en: \"Browse\"\r\n) !default;\r\n\r\n\r\n// Form validation\r\n$form-feedback-margin-top:          $form-text-margin-top !default;\r\n$form-feedback-font-size:           $small-font-size !default;\r\n$form-feedback-valid-color:         theme-color(\"success\") !default;\r\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\r\n\r\n\r\n// Dropdowns\r\n//\r\n// Dropdown menu container and contents.\r\n\r\n$dropdown-min-width:                10rem !default;\r\n$dropdown-padding-y:                .5rem !default;\r\n$dropdown-spacer:                   .125rem !default;\r\n$dropdown-bg:                       $white !default;\r\n$dropdown-border-color:             rgba($black, .15) !default;\r\n$dropdown-border-radius:            $border-radius !default;\r\n$dropdown-border-width:             $border-width !default;\r\n$dropdown-divider-bg:               $gray-200 !default;\r\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\r\n\r\n$dropdown-link-color:               $gray-900 !default;\r\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\r\n$dropdown-link-hover-bg:            $gray-100 !default;\r\n\r\n$dropdown-link-active-color:        $component-active-color !default;\r\n$dropdown-link-active-bg:           $component-active-bg !default;\r\n\r\n$dropdown-link-disabled-color:      $gray-600 !default;\r\n\r\n$dropdown-item-padding-y:           .25rem !default;\r\n$dropdown-item-padding-x:           1.5rem !default;\r\n\r\n$dropdown-header-color:             $gray-600 !default;\r\n\r\n\r\n// Z-index master list\r\n//\r\n// Warning: Avoid customizing these values. They're used for a bird's eye view\r\n// of components dependent on the z-axis and are designed to all work together.\r\n\r\n$zindex-dropdown:                   1000 !default;\r\n$zindex-sticky:                     1020 !default;\r\n$zindex-fixed:                      1030 !default;\r\n$zindex-modal-backdrop:             1040 !default;\r\n$zindex-modal:                      1050 !default;\r\n$zindex-popover:                    1060 !default;\r\n$zindex-tooltip:                    1070 !default;\r\n\r\n// Navs\r\n\r\n$nav-link-padding-y:                .5rem !default;\r\n$nav-link-padding-x:                1rem !default;\r\n$nav-link-disabled-color:           $gray-600 !default;\r\n\r\n$nav-tabs-border-color:             $gray-300 !default;\r\n$nav-tabs-border-width:             $border-width !default;\r\n$nav-tabs-border-radius:            $border-radius !default;\r\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\r\n$nav-tabs-link-active-color:        $gray-700 !default;\r\n$nav-tabs-link-active-bg:           $body-bg !default;\r\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\r\n\r\n$nav-pills-border-radius:           $border-radius !default;\r\n$nav-pills-link-active-color:       $component-active-color !default;\r\n$nav-pills-link-active-bg:          $component-active-bg !default;\r\n\r\n$nav-divider-color:                 $gray-200 !default;\r\n$nav-divider-margin-y:              ($spacer / 2) !default;\r\n\r\n// Navbar\r\n\r\n$navbar-padding-y:                  ($spacer / 2) !default;\r\n$navbar-padding-x:                  $spacer !default;\r\n\r\n$navbar-nav-link-padding-x:         .5rem !default;\r\n\r\n$navbar-brand-font-size:            $font-size-lg !default;\r\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\r\n$nav-link-height:                   ($font-size-base * $line-height-base + $nav-link-padding-y * 2) !default;\r\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\r\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) / 2 !default;\r\n\r\n$navbar-toggler-padding-y:          .25rem !default;\r\n$navbar-toggler-padding-x:          .75rem !default;\r\n$navbar-toggler-font-size:          $font-size-lg !default;\r\n$navbar-toggler-border-radius:      $btn-border-radius !default;\r\n\r\n$navbar-dark-color:                 rgba($white, .5) !default;\r\n$navbar-dark-hover-color:           rgba($white, .75) !default;\r\n$navbar-dark-active-color:          $white !default;\r\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\r\n$navbar-dark-toggler-icon-bg:       str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-dark-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\r\n\r\n$navbar-light-color:                rgba($black, .5) !default;\r\n$navbar-light-hover-color:          rgba($black, .7) !default;\r\n$navbar-light-active-color:         rgba($black, .9) !default;\r\n$navbar-light-disabled-color:       rgba($black, .3) !default;\r\n$navbar-light-toggler-icon-bg:      str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$navbar-light-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\r\n\r\n// Pagination\r\n\r\n$pagination-padding-y:              .5rem !default;\r\n$pagination-padding-x:              .75rem !default;\r\n$pagination-padding-y-sm:           .25rem !default;\r\n$pagination-padding-x-sm:           .5rem !default;\r\n$pagination-padding-y-lg:           .75rem !default;\r\n$pagination-padding-x-lg:           1.5rem !default;\r\n$pagination-line-height:            1.25 !default;\r\n\r\n$pagination-color:                  $link-color !default;\r\n$pagination-bg:                     $white !default;\r\n$pagination-border-width:           $border-width !default;\r\n$pagination-border-color:           $gray-300 !default;\r\n\r\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\r\n$pagination-focus-outline:          0 !default;\r\n\r\n$pagination-hover-color:            $link-hover-color !default;\r\n$pagination-hover-bg:               $gray-200 !default;\r\n$pagination-hover-border-color:     $gray-300 !default;\r\n\r\n$pagination-active-color:           $component-active-color !default;\r\n$pagination-active-bg:              $component-active-bg !default;\r\n$pagination-active-border-color:    $pagination-active-bg !default;\r\n\r\n$pagination-disabled-color:         $gray-600 !default;\r\n$pagination-disabled-bg:            $white !default;\r\n$pagination-disabled-border-color:  $gray-300 !default;\r\n\r\n\r\n// Jumbotron\r\n\r\n$jumbotron-padding:                 2rem !default;\r\n$jumbotron-bg:                      $gray-200 !default;\r\n\r\n\r\n// Cards\r\n\r\n$card-spacer-y:                     .75rem !default;\r\n$card-spacer-x:                     1.25rem !default;\r\n$card-border-width:                 $border-width !default;\r\n$card-border-radius:                $border-radius !default;\r\n$card-border-color:                 rgba($black, .125) !default;\r\n$card-inner-border-radius:          calc(#{$card-border-radius} - #{$card-border-width}) !default;\r\n$card-cap-bg:                       rgba($black, .03) !default;\r\n$card-bg:                           $white !default;\r\n\r\n$card-img-overlay-padding:          1.25rem !default;\r\n\r\n$card-group-margin:                 ($grid-gutter-width / 2) !default;\r\n$card-deck-margin:                  $card-group-margin !default;\r\n\r\n$card-columns-count:                3 !default;\r\n$card-columns-gap:                  1.25rem !default;\r\n$card-columns-margin:               $card-spacer-y !default;\r\n\r\n\r\n// Tooltips\r\n\r\n$tooltip-font-size:                 $font-size-sm !default;\r\n$tooltip-max-width:                 200px !default;\r\n$tooltip-color:                     $white !default;\r\n$tooltip-bg:                        $black !default;\r\n$tooltip-border-radius:             $border-radius !default;\r\n$tooltip-opacity:                   .9 !default;\r\n$tooltip-padding-y:                 .25rem !default;\r\n$tooltip-padding-x:                 .5rem !default;\r\n$tooltip-margin:                    0 !default;\r\n\r\n$tooltip-arrow-width:               .8rem !default;\r\n$tooltip-arrow-height:              .4rem !default;\r\n$tooltip-arrow-color:               $tooltip-bg !default;\r\n\r\n\r\n// Popovers\r\n\r\n$popover-font-size:                 $font-size-sm !default;\r\n$popover-bg:                        $white !default;\r\n$popover-max-width:                 276px !default;\r\n$popover-border-width:              $border-width !default;\r\n$popover-border-color:              rgba($black, .2) !default;\r\n$popover-border-radius:             $border-radius-lg !default;\r\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\r\n\r\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\r\n$popover-header-color:              $headings-color !default;\r\n$popover-header-padding-y:          .5rem !default;\r\n$popover-header-padding-x:          .75rem !default;\r\n\r\n$popover-body-color:                $body-color !default;\r\n$popover-body-padding-y:            $popover-header-padding-y !default;\r\n$popover-body-padding-x:            $popover-header-padding-x !default;\r\n\r\n$popover-arrow-width:               1rem !default;\r\n$popover-arrow-height:              .5rem !default;\r\n$popover-arrow-color:               $popover-bg !default;\r\n\r\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\r\n\r\n\r\n// Badges\r\n\r\n$badge-font-size:                   75% !default;\r\n$badge-font-weight:                 $font-weight-bold !default;\r\n$badge-padding-y:                   .25em !default;\r\n$badge-padding-x:                   .4em !default;\r\n$badge-border-radius:               $border-radius !default;\r\n\r\n$badge-pill-padding-x:              .6em !default;\r\n// Use a higher than normal value to ensure completely rounded edges when\r\n// customizing padding or font-size on labels.\r\n$badge-pill-border-radius:          10rem !default;\r\n\r\n\r\n// Modals\r\n\r\n// Padding applied to the modal body\r\n$modal-inner-padding:               1rem !default;\r\n\r\n$modal-dialog-margin:               .5rem !default;\r\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\r\n\r\n$modal-title-line-height:           $line-height-base !default;\r\n\r\n$modal-content-bg:                  $white !default;\r\n$modal-content-border-color:        rgba($black, .2) !default;\r\n$modal-content-border-width:        $border-width !default;\r\n$modal-content-border-radius:       $border-radius-lg !default;\r\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\r\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\r\n\r\n$modal-backdrop-bg:                 $black !default;\r\n$modal-backdrop-opacity:            .5 !default;\r\n$modal-header-border-color:         $gray-200 !default;\r\n$modal-footer-border-color:         $modal-header-border-color !default;\r\n$modal-header-border-width:         $modal-content-border-width !default;\r\n$modal-footer-border-width:         $modal-header-border-width !default;\r\n$modal-header-padding:              1rem !default;\r\n\r\n$modal-lg:                          800px !default;\r\n$modal-md:                          500px !default;\r\n$modal-sm:                          300px !default;\r\n\r\n$modal-transition:                  transform .3s ease-out !default;\r\n\r\n\r\n// Alerts\r\n//\r\n// Define alert colors, border radius, and padding.\r\n\r\n$alert-padding-y:                   .75rem !default;\r\n$alert-padding-x:                   1.25rem !default;\r\n$alert-margin-bottom:               1rem !default;\r\n$alert-border-radius:               $border-radius !default;\r\n$alert-link-font-weight:            $font-weight-bold !default;\r\n$alert-border-width:                $border-width !default;\r\n\r\n$alert-bg-level:                    -10 !default;\r\n$alert-border-level:                -9 !default;\r\n$alert-color-level:                 6 !default;\r\n\r\n\r\n// Progress bars\r\n\r\n$progress-height:                   1rem !default;\r\n$progress-font-size:                ($font-size-base * .75) !default;\r\n$progress-bg:                       $gray-200 !default;\r\n$progress-border-radius:            $border-radius !default;\r\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\r\n$progress-bar-color:                $white !default;\r\n$progress-bar-bg:                   theme-color(\"primary\") !default;\r\n$progress-bar-animation-timing:     1s linear infinite !default;\r\n$progress-bar-transition:           width .6s ease !default;\r\n\r\n// List group\r\n\r\n$list-group-bg:                     $white !default;\r\n$list-group-border-color:           rgba($black, .125) !default;\r\n$list-group-border-width:           $border-width !default;\r\n$list-group-border-radius:          $border-radius !default;\r\n\r\n$list-group-item-padding-y:         .75rem !default;\r\n$list-group-item-padding-x:         1.25rem !default;\r\n\r\n$list-group-hover-bg:               $gray-100 !default;\r\n$list-group-active-color:           $component-active-color !default;\r\n$list-group-active-bg:              $component-active-bg !default;\r\n$list-group-active-border-color:    $list-group-active-bg !default;\r\n\r\n$list-group-disabled-color:         $gray-600 !default;\r\n$list-group-disabled-bg:            $list-group-bg !default;\r\n\r\n$list-group-action-color:           $gray-700 !default;\r\n$list-group-action-hover-color:     $list-group-action-color !default;\r\n\r\n$list-group-action-active-color:    $body-color !default;\r\n$list-group-action-active-bg:       $gray-200 !default;\r\n\r\n\r\n// Image thumbnails\r\n\r\n$thumbnail-padding:                 .25rem !default;\r\n$thumbnail-bg:                      $body-bg !default;\r\n$thumbnail-border-width:            $border-width !default;\r\n$thumbnail-border-color:            $gray-300 !default;\r\n$thumbnail-border-radius:           $border-radius !default;\r\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\r\n\r\n\r\n// Figures\r\n\r\n$figure-caption-font-size:          90% !default;\r\n$figure-caption-color:              $gray-600 !default;\r\n\r\n\r\n// Breadcrumbs\r\n\r\n$breadcrumb-padding-y:              .75rem !default;\r\n$breadcrumb-padding-x:              1rem !default;\r\n$breadcrumb-item-padding:           .5rem !default;\r\n\r\n$breadcrumb-margin-bottom:          1rem !default;\r\n\r\n$breadcrumb-bg:                     $gray-200 !default;\r\n$breadcrumb-divider-color:          $gray-600 !default;\r\n$breadcrumb-active-color:           $gray-600 !default;\r\n$breadcrumb-divider:                quote(\"/\") !default;\r\n\r\n$breadcrumb-border-radius:          $border-radius !default;\r\n\r\n\r\n// Carousel\r\n\r\n$carousel-control-color:            $white !default;\r\n$carousel-control-width:            15% !default;\r\n$carousel-control-opacity:          .5 !default;\r\n\r\n$carousel-indicator-width:          30px !default;\r\n$carousel-indicator-height:         3px !default;\r\n$carousel-indicator-spacer:         3px !default;\r\n$carousel-indicator-active-bg:      $white !default;\r\n\r\n$carousel-caption-width:            70% !default;\r\n$carousel-caption-color:            $white !default;\r\n\r\n$carousel-control-icon-width:       20px !default;\r\n\r\n$carousel-control-prev-icon-bg:     str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n$carousel-control-next-icon-bg:     str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\r\n\r\n$carousel-transition:               transform .6s ease !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\r\n\r\n\r\n// Close\r\n\r\n$close-font-size:                   $font-size-base * 1.5 !default;\r\n$close-font-weight:                 $font-weight-bold !default;\r\n$close-color:                       $black !default;\r\n$close-text-shadow:                 0 1px 0 $white !default;\r\n\r\n// Code\r\n\r\n$code-font-size:                    87.5% !default;\r\n$code-color:                        $pink !default;\r\n\r\n$kbd-padding-y:                     .2rem !default;\r\n$kbd-padding-x:                     .4rem !default;\r\n$kbd-font-size:                     $code-font-size !default;\r\n$kbd-color:                         $white !default;\r\n$kbd-bg:                            $gray-900 !default;\r\n\r\n$pre-color:                         $gray-900 !default;\r\n$pre-scrollable-max-height:         340px !default;\r\n\r\n\r\n// Printing\r\n$print-page-size:                   a3 !default;\r\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\r\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\r\n//\r\n// Originally added during our alphas and maintained during betas, this mixin was\r\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\r\n// would persist after initial touch.\r\n//\r\n// For backward compatibility, we've kept these mixins and updated them to\r\n// always return their regular pseudo-classes instead of a shimmed media query.\r\n//\r\n// Issue: https://github.com/twbs/bootstrap/issues/25195\r\n\r\n@mixin hover {\r\n  &:hover { @content; }\r\n}\r\n\r\n@mixin hover-focus {\r\n  &:hover,\r\n  &:focus {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin plain-hover-focus {\r\n  &,\r\n  &:hover,\r\n  &:focus {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin hover-focus-active {\r\n  &:hover,\r\n  &:focus,\r\n  &:active {\r\n    @content;\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important, selector-list-comma-newline-after\r\n\r\n//\r\n// Headings\r\n//\r\n\r\nh1, h2, h3, h4, h5, h6,\r\n.h1, .h2, .h3, .h4, .h5, .h6 {\r\n  margin-bottom: $headings-margin-bottom;\r\n  font-family: $headings-font-family;\r\n  font-weight: $headings-font-weight;\r\n  line-height: $headings-line-height;\r\n  color: $headings-color;\r\n}\r\n\r\nh1, .h1 { font-size: $h1-font-size; }\r\nh2, .h2 { font-size: $h2-font-size; }\r\nh3, .h3 { font-size: $h3-font-size; }\r\nh4, .h4 { font-size: $h4-font-size; }\r\nh5, .h5 { font-size: $h5-font-size; }\r\nh6, .h6 { font-size: $h6-font-size; }\r\n\r\n.lead {\r\n  font-size: $lead-font-size;\r\n  font-weight: $lead-font-weight;\r\n}\r\n\r\n// Type display classes\r\n.display-1 {\r\n  font-size: $display1-size;\r\n  font-weight: $display1-weight;\r\n  line-height: $display-line-height;\r\n}\r\n.display-2 {\r\n  font-size: $display2-size;\r\n  font-weight: $display2-weight;\r\n  line-height: $display-line-height;\r\n}\r\n.display-3 {\r\n  font-size: $display3-size;\r\n  font-weight: $display3-weight;\r\n  line-height: $display-line-height;\r\n}\r\n.display-4 {\r\n  font-size: $display4-size;\r\n  font-weight: $display4-weight;\r\n  line-height: $display-line-height;\r\n}\r\n\r\n\r\n//\r\n// Horizontal rules\r\n//\r\n\r\nhr {\r\n  margin-top: $hr-margin-y;\r\n  margin-bottom: $hr-margin-y;\r\n  border: 0;\r\n  border-top: $hr-border-width solid $hr-border-color;\r\n}\r\n\r\n\r\n//\r\n// Emphasis\r\n//\r\n\r\nsmall,\r\n.small {\r\n  font-size: $small-font-size;\r\n  font-weight: $font-weight-normal;\r\n}\r\n\r\nmark,\r\n.mark {\r\n  padding: $mark-padding;\r\n  background-color: $mark-bg;\r\n}\r\n\r\n\r\n//\r\n// Lists\r\n//\r\n\r\n.list-unstyled {\r\n  @include list-unstyled;\r\n}\r\n\r\n// Inline turns list items into inline-block\r\n.list-inline {\r\n  @include list-unstyled;\r\n}\r\n.list-inline-item {\r\n  display: inline-block;\r\n\r\n  &:not(:last-child) {\r\n    margin-right: $list-inline-padding;\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Misc\r\n//\r\n\r\n// Builds on `abbr`\r\n.initialism {\r\n  font-size: 90%;\r\n  text-transform: uppercase;\r\n}\r\n\r\n// Blockquotes\r\n.blockquote {\r\n  margin-bottom: $spacer;\r\n  font-size: $blockquote-font-size;\r\n}\r\n\r\n.blockquote-footer {\r\n  display: block;\r\n  font-size: 80%; // back to default font-size\r\n  color: $blockquote-small-color;\r\n\r\n  &::before {\r\n    content: \"\\2014 \\00A0\"; // em dash, nbsp\r\n  }\r\n}\r\n","// Lists\r\n\r\n// Unstyled keeps list items block level, just removes default browser padding and list-style\r\n@mixin list-unstyled {\r\n  padding-left: 0;\r\n  list-style: none;\r\n}\r\n","// Responsive images (ensure images don't scale beyond their parents)\r\n//\r\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\r\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\r\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\r\n// which weren't expecting the images within themselves to be involuntarily resized.\r\n// See also https://github.com/twbs/bootstrap/issues/18178\r\n.img-fluid {\r\n  @include img-fluid;\r\n}\r\n\r\n\r\n// Image thumbnails\r\n.img-thumbnail {\r\n  padding: $thumbnail-padding;\r\n  background-color: $thumbnail-bg;\r\n  border: $thumbnail-border-width solid $thumbnail-border-color;\r\n  @include border-radius($thumbnail-border-radius);\r\n  @include box-shadow($thumbnail-box-shadow);\r\n\r\n  // Keep them at most 100% wide\r\n  @include img-fluid;\r\n}\r\n\r\n//\r\n// Figures\r\n//\r\n\r\n.figure {\r\n  // Ensures the caption's text aligns with the image.\r\n  display: inline-block;\r\n}\r\n\r\n.figure-img {\r\n  margin-bottom: ($spacer / 2);\r\n  line-height: 1;\r\n}\r\n\r\n.figure-caption {\r\n  font-size: $figure-caption-font-size;\r\n  color: $figure-caption-color;\r\n}\r\n","// Image Mixins\r\n// - Responsive image\r\n// - Retina image\r\n\r\n\r\n// Responsive image\r\n//\r\n// Keep images from scaling beyond the width of their parents.\r\n\r\n@mixin img-fluid {\r\n  // Part 1: Set a maximum relative to the parent\r\n  max-width: 100%;\r\n  // Part 2: Override the height to auto, otherwise images will be stretched\r\n  // when setting a width and height attribute on the img element.\r\n  height: auto;\r\n}\r\n\r\n\r\n// Retina image\r\n//\r\n// Short retina mixin for setting background-image and -size.\r\n\r\n// stylelint-disable indentation, media-query-list-comma-newline-after\r\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\r\n  background-image: url($file-1x);\r\n\r\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\r\n  // but doesn't convert dppx=>dpi.\r\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\r\n  // Compatibility info: https://caniuse.com/#feat=css-media-resolution\r\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\r\n  only screen and (min-resolution: 2dppx) { // Standardized\r\n    background-image: url($file-2x);\r\n    background-size: $width-1x $height-1x;\r\n  }\r\n}\r\n","// Single side border-radius\r\n\r\n@mixin border-radius($radius: $border-radius) {\r\n  @if $enable-rounded {\r\n    border-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-top-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-left-radius: $radius;\r\n    border-top-right-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-right-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-right-radius: $radius;\r\n    border-bottom-right-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-bottom-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-bottom-right-radius: $radius;\r\n    border-bottom-left-radius: $radius;\r\n  }\r\n}\r\n\r\n@mixin border-left-radius($radius) {\r\n  @if $enable-rounded {\r\n    border-top-left-radius: $radius;\r\n    border-bottom-left-radius: $radius;\r\n  }\r\n}\r\n","@mixin box-shadow($shadow...) {\r\n  @if $enable-shadows {\r\n    box-shadow: $shadow;\r\n  }\r\n}\r\n","// Inline code\r\ncode {\r\n  font-size: $code-font-size;\r\n  color: $code-color;\r\n  word-break: break-word;\r\n\r\n  // Streamline the style when inside anchors to avoid broken underline and more\r\n  a > & {\r\n    color: inherit;\r\n  }\r\n}\r\n\r\n// User input typically entered via keyboard\r\nkbd {\r\n  padding: $kbd-padding-y $kbd-padding-x;\r\n  font-size: $kbd-font-size;\r\n  color: $kbd-color;\r\n  background-color: $kbd-bg;\r\n  @include border-radius($border-radius-sm);\r\n  @include box-shadow($kbd-box-shadow);\r\n\r\n  kbd {\r\n    padding: 0;\r\n    font-size: 100%;\r\n    font-weight: $nested-kbd-font-weight;\r\n    @include box-shadow(none);\r\n  }\r\n}\r\n\r\n// Blocks of code\r\npre {\r\n  display: block;\r\n  font-size: $code-font-size;\r\n  color: $pre-color;\r\n\r\n  // Account for some code outputs that place code tags in pre tags\r\n  code {\r\n    font-size: inherit;\r\n    color: inherit;\r\n    word-break: normal;\r\n  }\r\n}\r\n\r\n// Enable scrollable blocks of code\r\n.pre-scrollable {\r\n  max-height: $pre-scrollable-max-height;\r\n  overflow-y: scroll;\r\n}\r\n","// Container widths\r\n//\r\n// Set the container width, and override it for fixed navbars in media queries.\r\n\r\n@if $enable-grid-classes {\r\n  .container {\r\n    @include make-container();\r\n    @include make-container-max-widths();\r\n  }\r\n}\r\n\r\n// Fluid container\r\n//\r\n// Utilizes the mixin meant for fixed width containers, but with 100% width for\r\n// fluid, full width layouts.\r\n\r\n@if $enable-grid-classes {\r\n  .container-fluid {\r\n    @include make-container();\r\n  }\r\n}\r\n\r\n// Row\r\n//\r\n// Rows contain and clear the floats of your columns.\r\n\r\n@if $enable-grid-classes {\r\n  .row {\r\n    @include make-row();\r\n  }\r\n\r\n  // Remove the negative margin from default .row, then the horizontal padding\r\n  // from all immediate children columns (to prevent runaway style inheritance).\r\n  .no-gutters {\r\n    margin-right: 0;\r\n    margin-left: 0;\r\n\r\n    > .col,\r\n    > [class*=\"col-\"] {\r\n      padding-right: 0;\r\n      padding-left: 0;\r\n    }\r\n  }\r\n}\r\n\r\n// Columns\r\n//\r\n// Common styles for small and large grid columns\r\n\r\n@if $enable-grid-classes {\r\n  @include make-grid-columns();\r\n}\r\n","/// Grid system\r\n//\r\n// Generate semantic grid columns with these mixins.\r\n\r\n@mixin make-container() {\r\n  width: 100%;\r\n  padding-right: ($grid-gutter-width / 2);\r\n  padding-left: ($grid-gutter-width / 2);\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n\r\n// For each breakpoint, define the maximum width of the container in a media query\r\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\r\n  @each $breakpoint, $container-max-width in $max-widths {\r\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\r\n      max-width: $container-max-width;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin make-row() {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-right: ($grid-gutter-width / -2);\r\n  margin-left: ($grid-gutter-width / -2);\r\n  margin-top: 15px;\r\n}\r\n\r\n@mixin make-col-ready() {\r\n  position: relative;\r\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\r\n  // always setting `width: 100%;`. This works because we use `flex` values\r\n  // later on to override this initial width.\r\n  width: 100%;\r\n  min-height: 1px; // Prevent collapsing\r\n  padding-right: ($grid-gutter-width / 2);\r\n  padding-left: ($grid-gutter-width / 2);\r\n}\r\n\r\n@mixin make-col($size, $columns: $grid-columns) {\r\n  flex: 0 0 percentage($size / $columns);\r\n  // Add a `max-width` to ensure content within each column does not blow out\r\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\r\n  // do not appear to require this.\r\n  max-width: percentage($size / $columns);\r\n}\r\n\r\n@mixin make-col-offset($size, $columns: $grid-columns) {\r\n  $num: $size / $columns;\r\n  margin-left: if($num == 0, 0, percentage($num));\r\n}\r\n","// Breakpoint viewport sizes and media queries.\r\n//\r\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\r\n//\r\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\r\n//\r\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\r\n\r\n// Name of the next breakpoint, or null for the last breakpoint.\r\n//\r\n//    >> breakpoint-next(sm)\r\n//    md\r\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    md\r\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\r\n//    md\r\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\r\n  $n: index($breakpoint-names, $name);\r\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\r\n}\r\n\r\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\r\n//\r\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    576px\r\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\r\n  $min: map-get($breakpoints, $name);\r\n  @return if($min != 0, $min, null);\r\n}\r\n\r\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\r\n// The maximum value is calculated as the minimum of the next one less 0.02px\r\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\r\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\r\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\r\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\r\n//\r\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    767.98px\r\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\r\n  $next: breakpoint-next($name, $breakpoints);\r\n  @return if($next, breakpoint-min($next, $breakpoints) - .02px, null);\r\n}\r\n\r\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\r\n// Useful for making responsive utilities.\r\n//\r\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    \"\"  (Returns a blank string)\r\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\r\n//    \"-sm\"\r\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\r\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\r\n}\r\n\r\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\r\n// Makes the @content apply to the given breakpoint and wider.\r\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\r\n  $min: breakpoint-min($name, $breakpoints);\r\n  @if $min {\r\n    @media (min-width: $min) {\r\n      @content;\r\n    }\r\n  } @else {\r\n    @content;\r\n  }\r\n}\r\n\r\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\r\n// Makes the @content apply to the given breakpoint and narrower.\r\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\r\n  $max: breakpoint-max($name, $breakpoints);\r\n  @if $max {\r\n    @media (max-width: $max) {\r\n      @content;\r\n    }\r\n  } @else {\r\n    @content;\r\n  }\r\n}\r\n\r\n// Media that spans multiple breakpoint widths.\r\n// Makes the @content apply between the min and max breakpoints\r\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\r\n  $min: breakpoint-min($lower, $breakpoints);\r\n  $max: breakpoint-max($upper, $breakpoints);\r\n\r\n  @if $min != null and $max != null {\r\n    @media (min-width: $min) and (max-width: $max) {\r\n      @content;\r\n    }\r\n  } @else if $max == null {\r\n    @include media-breakpoint-up($lower, $breakpoints) {\r\n      @content;\r\n    }\r\n  } @else if $min == null {\r\n    @include media-breakpoint-down($upper, $breakpoints) {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n\r\n// Media between the breakpoint's minimum and maximum widths.\r\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\r\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\r\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\r\n  $min: breakpoint-min($name, $breakpoints);\r\n  $max: breakpoint-max($name, $breakpoints);\r\n\r\n  @if $min != null and $max != null {\r\n    @media (min-width: $min) and (max-width: $max) {\r\n      @content;\r\n    }\r\n  } @else if $max == null {\r\n    @include media-breakpoint-up($name, $breakpoints) {\r\n      @content;\r\n    }\r\n  } @else if $min == null {\r\n    @include media-breakpoint-down($name, $breakpoints) {\r\n      @content;\r\n    }\r\n  }\r\n}\r\n","// Framework grid generation\r\n//\r\n// Used only by Bootstrap to generate the correct number of grid classes given\r\n// any value of `$grid-columns`.\r\n\r\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\r\n  // Common properties for all breakpoints\r\n  %grid-column {\r\n    position: relative;\r\n    width: 100%;\r\n    min-height: 1px; // Prevent columns from collapsing when empty\r\n    padding-right: ($gutter / 2);\r\n    padding-left: ($gutter / 2);\r\n  }\r\n\r\n  @each $breakpoint in map-keys($breakpoints) {\r\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\r\n\r\n    // Allow columns to stretch full width below their breakpoints\r\n    @for $i from 1 through $columns {\r\n      .col#{$infix}-#{$i} {\r\n        @extend %grid-column;\r\n      }\r\n    }\r\n    .col#{$infix},\r\n    .col#{$infix}-auto {\r\n      @extend %grid-column;\r\n    }\r\n\r\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\r\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\r\n      .col#{$infix} {\r\n        flex-basis: 0;\r\n        flex-grow: 1;\r\n        max-width: 100%;\r\n      }\r\n      .col#{$infix}-auto {\r\n        flex: 0 0 auto;\r\n        width: auto;\r\n        max-width: none; // Reset earlier grid tiers\r\n      }\r\n\r\n      @for $i from 1 through $columns {\r\n        .col#{$infix}-#{$i} {\r\n          @include make-col($i, $columns);\r\n        }\r\n      }\r\n\r\n      .order#{$infix}-first { order: -1; }\r\n\r\n      .order#{$infix}-last { order: $columns + 1; }\r\n\r\n      @for $i from 0 through $columns {\r\n        .order#{$infix}-#{$i} { order: $i; }\r\n      }\r\n\r\n      // `$columns - 1` because offsetting by the width of an entire row isn't possible\r\n      @for $i from 0 through ($columns - 1) {\r\n        @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\r\n          .offset#{$infix}-#{$i} {\r\n            @include make-col-offset($i, $columns);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","//\r\n// Basic Bootstrap table\r\n//\r\n\r\n.table {\r\n  width: 100%;\r\n  margin-bottom: $spacer;\r\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\r\n\r\n  th,\r\n  td {\r\n    padding: $table-cell-padding;\r\n    vertical-align: top;\r\n    border-top: $table-border-width solid $table-border-color;\r\n  }\r\n\r\n  thead th {\r\n    vertical-align: bottom;\r\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\r\n  }\r\n\r\n  tbody + tbody {\r\n    border-top: (2 * $table-border-width) solid $table-border-color;\r\n  }\r\n\r\n  .table {\r\n    background-color: $body-bg;\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Condensed table w/ half padding\r\n//\r\n\r\n.table-sm {\r\n  th,\r\n  td {\r\n    padding: $table-cell-padding-sm;\r\n  }\r\n}\r\n\r\n\r\n// Border versions\r\n//\r\n// Add or remove borders all around the table and between all the columns.\r\n\r\n.table-bordered {\r\n  border: $table-border-width solid $table-border-color;\r\n\r\n  th,\r\n  td {\r\n    border: $table-border-width solid $table-border-color;\r\n  }\r\n\r\n  thead {\r\n    th,\r\n    td {\r\n      border-bottom-width: (2 * $table-border-width);\r\n    }\r\n  }\r\n}\r\n\r\n.table-borderless {\r\n  th,\r\n  td,\r\n  thead th,\r\n  tbody + tbody {\r\n    border: 0;\r\n  }\r\n}\r\n\r\n// Zebra-striping\r\n//\r\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\r\n\r\n.table-striped {\r\n  tbody tr:nth-of-type(#{$table-striped-order}) {\r\n    background-color: $table-accent-bg;\r\n  }\r\n}\r\n\r\n\r\n// Hover effect\r\n//\r\n// Placed here since it has to come after the potential zebra striping\r\n\r\n.table-hover {\r\n  tbody tr {\r\n    @include hover {\r\n      background-color: $table-hover-bg;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Table backgrounds\r\n//\r\n// Exact selectors below required to override `.table-striped` and prevent\r\n// inheritance to nested tables.\r\n\r\n@each $color, $value in $theme-colors {\r\n  @include table-row-variant($color, theme-color-level($color, -9));\r\n}\r\n\r\n@include table-row-variant(active, $table-active-bg);\r\n\r\n\r\n// Dark styles\r\n//\r\n// Same table markup, but inverted color scheme: dark background and light text.\r\n\r\n// stylelint-disable-next-line no-duplicate-selectors\r\n.table {\r\n  .thead-dark {\r\n    th {\r\n      color: $table-dark-color;\r\n      background-color: $table-dark-bg;\r\n      border-color: $table-dark-border-color;\r\n    }\r\n  }\r\n\r\n  .thead-light {\r\n    th {\r\n      color: $table-head-color;\r\n      background-color: $table-head-bg;\r\n      border-color: $table-border-color;\r\n    }\r\n  }\r\n}\r\n\r\n.table-dark {\r\n  color: $table-dark-color;\r\n  background-color: $table-dark-bg;\r\n\r\n  th,\r\n  td,\r\n  thead th {\r\n    border-color: $table-dark-border-color;\r\n  }\r\n\r\n  &.table-bordered {\r\n    border: 0;\r\n  }\r\n\r\n  &.table-striped {\r\n    tbody tr:nth-of-type(odd) {\r\n      background-color: $table-dark-accent-bg;\r\n    }\r\n  }\r\n\r\n  &.table-hover {\r\n    tbody tr {\r\n      @include hover {\r\n        background-color: $table-dark-hover-bg;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Responsive tables\r\n//\r\n// Generate series of `.table-responsive-*` classes for configuring the screen\r\n// size of where your table will overflow.\r\n\r\n.table-responsive {\r\n  @each $breakpoint in map-keys($grid-breakpoints) {\r\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\r\n    $infix: breakpoint-infix($next, $grid-breakpoints);\r\n\r\n    &#{$infix} {\r\n      @include media-breakpoint-down($breakpoint) {\r\n        display: block;\r\n        width: 100%;\r\n        overflow-x: auto;\r\n        -webkit-overflow-scrolling: touch;\r\n        -ms-overflow-style: -ms-autohiding-scrollbar; // See https://github.com/twbs/bootstrap/pull/10057\r\n\r\n        // Prevent double border on horizontal scroll due to use of `display: block;`\r\n        > .table-bordered {\r\n          border: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Tables\r\n\r\n@mixin table-row-variant($state, $background) {\r\n  // Exact selectors below required to override `.table-striped` and prevent\r\n  // inheritance to nested tables.\r\n  .table-#{$state} {\r\n    &,\r\n    > th,\r\n    > td {\r\n      background-color: $background;\r\n    }\r\n  }\r\n\r\n  // Hover states for `.table-hover`\r\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\r\n  .table-hover {\r\n    $hover-background: darken($background, 5%);\r\n\r\n    .table-#{$state} {\r\n      @include hover {\r\n        background-color: $hover-background;\r\n\r\n        > td,\r\n        > th {\r\n          background-color: $hover-background;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// stylelint-disable selector-no-qualifying-type\r\n\r\n//\r\n// Textual form controls\r\n//\r\n\r\n.form-control {\r\n  display: block;\r\n  width: 100%;\r\n  height: $input-height;\r\n  padding: $input-padding-y $input-padding-x;\r\n  font-size: $font-size-base;\r\n  line-height: $input-line-height;\r\n  color: $input-color;\r\n  background-color: $input-bg;\r\n  background-clip: padding-box;\r\n  border: $input-border-width solid $input-border-color;\r\n\r\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\r\n  @if $enable-rounded {\r\n    // Manually use the if/else instead of the mixin to account for iOS override\r\n    border-radius: $input-border-radius;\r\n  } @else {\r\n    // Otherwise undo the iOS default\r\n    border-radius: 0;\r\n  }\r\n\r\n  @include box-shadow($input-box-shadow);\r\n  @include transition($input-transition);\r\n\r\n  // Unstyle the caret on `<select>`s in IE10+.\r\n  &::-ms-expand {\r\n    background-color: transparent;\r\n    border: 0;\r\n  }\r\n\r\n  // Customize the `:focus` state to imitate native WebKit styles.\r\n  @include form-control-focus();\r\n\r\n  // Placeholder\r\n  &::placeholder {\r\n    color: $input-placeholder-color;\r\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\r\n    opacity: 1;\r\n  }\r\n\r\n  // Disabled and read-only inputs\r\n  //\r\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\r\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\r\n  // don't honor that edge case; we style them as disabled anyway.\r\n  &:disabled,\r\n  &[readonly] {\r\n    background-color: $input-disabled-bg;\r\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\nselect.form-control {\r\n  &:focus::-ms-value {\r\n    // Suppress the nested default white text on blue background highlight given to\r\n    // the selected option text when the (still closed) <select> receives focus\r\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\r\n    // match the appearance of the native widget.\r\n    // See https://github.com/twbs/bootstrap/issues/19398.\r\n    color: $input-color;\r\n    background-color: $input-bg;\r\n  }\r\n}\r\n\r\n// Make file inputs better match text inputs by forcing them to new lines.\r\n.form-control-file,\r\n.form-control-range {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n\r\n//\r\n// Labels\r\n//\r\n\r\n// For use with horizontal and inline forms, when you need the label (or legend)\r\n// text to align with the form controls.\r\n.col-form-label {\r\n  padding-top: calc(#{$input-padding-y} + #{$input-border-width});\r\n  padding-bottom: calc(#{$input-padding-y} + #{$input-border-width});\r\n  margin-bottom: 0; // Override the `<label>/<legend>` default\r\n  font-size: inherit; // Override the `<legend>` default\r\n  line-height: $line-height-sm;\r\n}\r\n\r\n.col-form-label-lg {\r\n  padding-top: calc(#{$input-padding-y-lg} + #{$input-border-width});\r\n  padding-bottom: calc(#{$input-padding-y-lg} + #{$input-border-width});\r\n  font-size: $font-size-lg;\r\n  line-height: $input-line-height-lg;\r\n}\r\n\r\n.col-form-label-sm {\r\n  padding-top: calc(#{$input-padding-y-sm} + #{$input-border-width});\r\n  padding-bottom: calc(#{$input-padding-y-sm} + #{$input-border-width});\r\n  font-size: $font-size-sm;\r\n  line-height: $input-line-height-sm;\r\n}\r\n\r\n\r\n// Readonly controls as plain text\r\n//\r\n// Apply class to a readonly input to make it appear like regular plain\r\n// text (without any border, background color, focus indicator)\r\n\r\n.form-control-plaintext {\r\n  display: block;\r\n  width: 100%;\r\n  padding-top: $input-padding-y;\r\n  padding-bottom: $input-padding-y;\r\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\r\n  line-height: $input-line-height;\r\n  color: $input-plaintext-color;\r\n  background-color: transparent;\r\n  border: solid transparent;\r\n  border-width: $input-border-width 0;\r\n\r\n  &.form-control-sm,\r\n  &.form-control-lg {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n\r\n// Form control sizing\r\n//\r\n// Build on `.form-control` with modifier classes to decrease or increase the\r\n// height and font-size of form controls.\r\n//\r\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\r\n\r\n.form-control-sm {\r\n  height: $input-height-sm;\r\n  padding: $input-padding-y-sm $input-padding-x-sm;\r\n  font-size: $font-size-sm;\r\n  line-height: $input-line-height-sm;\r\n  @include border-radius($input-border-radius-sm);\r\n}\r\n\r\n.form-control-lg {\r\n  height: $input-height-lg;\r\n  padding: $input-padding-y-lg $input-padding-x-lg;\r\n  font-size: $font-size-lg;\r\n  line-height: $input-line-height-lg;\r\n  @include border-radius($input-border-radius-lg);\r\n}\r\n\r\n// stylelint-disable no-duplicate-selectors\r\nselect.form-control {\r\n  &[size],\r\n  &[multiple] {\r\n    height: auto;\r\n  }\r\n}\r\n\r\ntextarea.form-control {\r\n  height: auto;\r\n}\r\n// stylelint-enable no-duplicate-selectors\r\n\r\n// Form groups\r\n//\r\n// Designed to help with the organization and spacing of vertical forms. For\r\n// horizontal forms, use the predefined grid classes.\r\n\r\n.form-group {\r\n  margin-bottom: $form-group-margin-bottom;\r\n}\r\n\r\n.form-text {\r\n  display: block;\r\n  margin-top: $form-text-margin-top;\r\n}\r\n\r\n\r\n// Form grid\r\n//\r\n// Special replacement for our grid system's `.row` for tighter form layouts.\r\n\r\n.form-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-right: -5px;\r\n  margin-left: -5px;\r\n\r\n  > .col,\r\n  > [class*=\"col-\"] {\r\n    padding-right: 5px;\r\n    padding-left: 5px;\r\n  }\r\n}\r\n\r\n\r\n// Checkboxes and radios\r\n//\r\n// Indent the labels to position radios/checkboxes as hanging controls.\r\n\r\n.form-check {\r\n  position: relative;\r\n  display: block;\r\n  padding-left: $form-check-input-gutter;\r\n}\r\n\r\n.form-check-input {\r\n  position: absolute;\r\n  margin-top: $form-check-input-margin-y;\r\n  margin-left: -$form-check-input-gutter;\r\n\r\n  &:disabled ~ .form-check-label {\r\n    color: $text-muted;\r\n  }\r\n}\r\n\r\n.form-check-label {\r\n  margin-bottom: 0; // Override default `<label>` bottom margin\r\n}\r\n\r\n.form-check-inline {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding-left: 0; // Override base .form-check\r\n  margin-right: $form-check-inline-margin-x;\r\n\r\n  // Undo .form-check-input defaults and add some `margin-right`.\r\n  .form-check-input {\r\n    position: static;\r\n    margin-top: 0;\r\n    margin-right: $form-check-inline-input-margin-x;\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n\r\n// Form validation\r\n//\r\n// Provide feedback to users when form field values are valid or invalid. Works\r\n// primarily for client-side validation via scoped `:invalid` and `:valid`\r\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\r\n// server side validation.\r\n\r\n@include form-validation-state(\"valid\", $form-feedback-valid-color);\r\n@include form-validation-state(\"invalid\", $form-feedback-invalid-color);\r\n\r\n// Inline forms\r\n//\r\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\r\n// forms begin stacked on extra small (mobile) devices and then go inline when\r\n// viewports reach <768px.\r\n//\r\n// Requires wrapping inputs and labels with `.form-group` for proper display of\r\n// default HTML form controls and our custom form controls (e.g., input groups).\r\n\r\n.form-inline {\r\n  display: flex;\r\n  flex-flow: row wrap;\r\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\r\n\r\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\r\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\r\n  // so we force that here.\r\n  .form-check {\r\n    width: 100%;\r\n  }\r\n\r\n  // Kick in the inline\r\n  @include media-breakpoint-up(sm) {\r\n    label {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    // Inline-block all the things for \"inline\"\r\n    .form-group {\r\n      display: flex;\r\n      flex: 0 0 auto;\r\n      flex-flow: row wrap;\r\n      align-items: center;\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    // Allow folks to *not* use `.form-group`\r\n    .form-control {\r\n      display: inline-block;\r\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\r\n      vertical-align: middle;\r\n    }\r\n\r\n    // Make static controls behave like regular ones\r\n    .form-control-plaintext {\r\n      display: inline-block;\r\n    }\r\n\r\n    .input-group,\r\n    .custom-select {\r\n      width: auto;\r\n    }\r\n\r\n    // Remove default margin on radios/checkboxes that were used for stacking, and\r\n    // then undo the floating of radios and checkboxes to match.\r\n    .form-check {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      width: auto;\r\n      padding-left: 0;\r\n    }\r\n    .form-check-input {\r\n      position: relative;\r\n      margin-top: 0;\r\n      margin-right: $form-check-input-margin-x;\r\n      margin-left: 0;\r\n    }\r\n\r\n    .custom-control {\r\n      align-items: center;\r\n      justify-content: center;\r\n    }\r\n    .custom-control-label {\r\n      margin-bottom: 0;\r\n    }\r\n  }\r\n}\r\n","@mixin transition($transition...) {\r\n  @if $enable-transitions {\r\n    @if length($transition) == 0 {\r\n      transition: $transition-base;\r\n    } @else {\r\n      transition: $transition;\r\n    }\r\n  }\r\n\r\n  @media screen and (prefers-reduced-motion: reduce) {\r\n    transition: none;\r\n  }\r\n}\r\n","// Form control focus state\r\n//\r\n// Generate a customized focus state and for any input with the specified color,\r\n// which defaults to the `$input-focus-border-color` variable.\r\n//\r\n// We highly encourage you to not customize the default value, but instead use\r\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\r\n// WebKit's default styles, but applicable to a wider range of browsers. Its\r\n// usability and accessibility should be taken into account with any change.\r\n//\r\n// Example usage: change the default blue border and shadow to white for better\r\n// contrast against a dark gray background.\r\n@mixin form-control-focus() {\r\n  &:focus {\r\n    color: $input-focus-color;\r\n    background-color: $input-focus-bg;\r\n    border-color: $input-focus-border-color;\r\n    outline: 0;\r\n    // Avoid using mixin so we can pass custom focus shadow properly\r\n    @if $enable-shadows {\r\n      box-shadow: $input-box-shadow, $input-focus-box-shadow;\r\n    } @else {\r\n      box-shadow: $input-focus-box-shadow;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n@mixin form-validation-state($state, $color) {\r\n  .#{$state}-feedback {\r\n    display: none;\r\n    width: 100%;\r\n    margin-top: $form-feedback-margin-top;\r\n    font-size: $form-feedback-font-size;\r\n    color: $color;\r\n  }\r\n\r\n  .#{$state}-tooltip {\r\n    position: absolute;\r\n    top: 100%;\r\n    z-index: 5;\r\n    display: none;\r\n    max-width: 100%; // Contain to parent when possible\r\n    padding: $tooltip-padding-y $tooltip-padding-x;\r\n    margin-top: .1rem;\r\n    font-size: $tooltip-font-size;\r\n    line-height: $line-height-base;\r\n    color: color-yiq($color);\r\n    background-color: rgba($color, $tooltip-opacity);\r\n    @include border-radius($tooltip-border-radius);\r\n  }\r\n\r\n  .form-control,\r\n  .custom-select {\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      border-color: $color;\r\n\r\n      &:focus {\r\n        border-color: $color;\r\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\r\n      }\r\n\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n    }\r\n  }\r\n\r\n  .form-control-file {\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n    }\r\n  }\r\n\r\n  .form-check-input {\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      ~ .form-check-label {\r\n        color: $color;\r\n      }\r\n\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n    }\r\n  }\r\n\r\n  .custom-control-input {\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      ~ .custom-control-label {\r\n        color: $color;\r\n\r\n        &::before {\r\n          background-color: lighten($color, 25%);\r\n        }\r\n      }\r\n\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n\r\n      &:checked {\r\n        ~ .custom-control-label::before {\r\n          @include gradient-bg(lighten($color, 10%));\r\n        }\r\n      }\r\n\r\n      &:focus {\r\n        ~ .custom-control-label::before {\r\n          box-shadow: 0 0 0 1px $body-bg, 0 0 0 $input-focus-width rgba($color, .25);\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  // custom file\r\n  .custom-file-input {\r\n    .was-validated &:#{$state},\r\n    &.is-#{$state} {\r\n      ~ .custom-file-label {\r\n        border-color: $color;\r\n\r\n        &::after { border-color: inherit; }\r\n      }\r\n\r\n      ~ .#{$state}-feedback,\r\n      ~ .#{$state}-tooltip {\r\n        display: block;\r\n      }\r\n\r\n      &:focus {\r\n        ~ .custom-file-label {\r\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Gradients\r\n\r\n@mixin gradient-bg($color) {\r\n  @if $enable-gradients {\r\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\r\n  } @else {\r\n    background-color: $color;\r\n  }\r\n}\r\n\r\n// Horizontal gradient, from left to right\r\n//\r\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\r\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\r\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\r\n  background-repeat: repeat-x;\r\n}\r\n\r\n// Vertical gradient, from top to bottom\r\n//\r\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\r\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\r\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\r\n  background-repeat: repeat-x;\r\n}\r\n\r\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\r\n  background-image: linear-gradient($deg, $start-color, $end-color);\r\n  background-repeat: repeat-x;\r\n}\r\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\r\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\r\n  background-repeat: no-repeat;\r\n}\r\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\r\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\r\n  background-repeat: no-repeat;\r\n}\r\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\r\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\r\n  background-repeat: no-repeat;\r\n}\r\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\r\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\r\n}\r\n","// stylelint-disable selector-no-qualifying-type\r\n\r\n//\r\n// Base styles\r\n//\r\n\r\n.btn {\r\n  display: inline-block;\r\n  font-weight: $btn-font-weight;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  vertical-align: middle;\r\n  user-select: none;\r\n  border: $btn-border-width solid transparent;\r\n  @include button-size($btn-padding-y, $btn-padding-x, $font-size-base, $btn-line-height, $btn-border-radius);\r\n  @include transition($btn-transition);\r\n\r\n  // Share hover and focus styles\r\n  @include hover-focus {\r\n    text-decoration: none;\r\n  }\r\n\r\n  &:focus,\r\n  &.focus {\r\n    outline: 0;\r\n    box-shadow: $btn-focus-box-shadow;\r\n  }\r\n\r\n  // Disabled comes first so active can properly restyle\r\n  &.disabled,\r\n  &:disabled {\r\n    opacity: $btn-disabled-opacity;\r\n    @include box-shadow(none);\r\n  }\r\n\r\n  // Opinionated: add \"hand\" cursor to non-disabled .btn elements\r\n  &:not(:disabled):not(.disabled) {\r\n    cursor: pointer;\r\n  }\r\n\r\n  &:not(:disabled):not(.disabled):active,\r\n  &:not(:disabled):not(.disabled).active {\r\n    @include box-shadow($btn-active-box-shadow);\r\n\r\n    &:focus {\r\n      @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\r\n    }\r\n  }\r\n}\r\n\r\n// Future-proof disabling of clicks on `<a>` elements\r\na.btn.disabled,\r\nfieldset:disabled a.btn {\r\n  pointer-events: none;\r\n}\r\n\r\n\r\n//\r\n// Alternate buttons\r\n//\r\n\r\n@each $color, $value in $theme-colors {\r\n  .btn-#{$color} {\r\n    @include button-variant($value, $value);\r\n  }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  .btn-outline-#{$color} {\r\n    @include button-outline-variant($value);\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Link buttons\r\n//\r\n\r\n// Make a button look and behave like a link\r\n.btn-link {\r\n  font-weight: $font-weight-normal;\r\n  color: $link-color;\r\n  background-color: transparent;\r\n\r\n  @include hover {\r\n    color: $link-hover-color;\r\n    text-decoration: $link-hover-decoration;\r\n    background-color: transparent;\r\n    border-color: transparent;\r\n  }\r\n\r\n  &:focus,\r\n  &.focus {\r\n    text-decoration: $link-hover-decoration;\r\n    border-color: transparent;\r\n    box-shadow: none;\r\n  }\r\n\r\n  &:disabled,\r\n  &.disabled {\r\n    color: $btn-link-disabled-color;\r\n    pointer-events: none;\r\n  }\r\n\r\n  // No need for an active state here\r\n}\r\n\r\n\r\n//\r\n// Button Sizes\r\n//\r\n\r\n.btn-lg {\r\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\r\n}\r\n\r\n.btn-sm {\r\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\r\n}\r\n\r\n\r\n//\r\n// Block button\r\n//\r\n\r\n.btn-block {\r\n  display: block;\r\n  width: 100%;\r\n\r\n  // Vertically space out multiple block buttons\r\n  + .btn-block {\r\n    margin-top: $btn-block-spacing-y;\r\n  }\r\n}\r\n\r\n// Specificity overrides\r\ninput[type=\"submit\"],\r\ninput[type=\"reset\"],\r\ninput[type=\"button\"] {\r\n  &.btn-block {\r\n    width: 100%;\r\n  }\r\n}\r\n","// Button variants\r\n//\r\n// Easily pump out default styles, as well as :hover, :focus, :active,\r\n// and disabled options for all buttons\r\n\r\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\r\n  color: color-yiq($background);\r\n  @include gradient-bg($background);\r\n  border-color: $border;\r\n  @include box-shadow($btn-box-shadow);\r\n\r\n  @include hover {\r\n    color: color-yiq($hover-background);\r\n    @include gradient-bg($hover-background);\r\n    border-color: $hover-border;\r\n  }\r\n\r\n  &:focus,\r\n  &.focus {\r\n    // Avoid using mixin so we can pass custom focus shadow properly\r\n    @if $enable-shadows {\r\n      box-shadow: $btn-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\r\n    } @else {\r\n      box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\r\n    }\r\n  }\r\n\r\n  // Disabled comes first so active can properly restyle\r\n  &.disabled,\r\n  &:disabled {\r\n    color: color-yiq($background);\r\n    background-color: $background;\r\n    border-color: $border;\r\n  }\r\n\r\n  &:not(:disabled):not(.disabled):active,\r\n  &:not(:disabled):not(.disabled).active,\r\n  .show > &.dropdown-toggle {\r\n    color: color-yiq($active-background);\r\n    background-color: $active-background;\r\n    @if $enable-gradients {\r\n      background-image: none; // Remove the gradient for the pressed/active state\r\n    }\r\n    border-color: $active-border;\r\n\r\n    &:focus {\r\n      // Avoid using mixin so we can pass custom focus shadow properly\r\n      @if $enable-shadows {\r\n        box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\r\n      } @else {\r\n        box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\r\n  color: $color;\r\n  background-color: transparent;\r\n  background-image: none;\r\n  border-color: $color;\r\n\r\n  &:hover {\r\n    color: $color-hover;\r\n    background-color: $active-background;\r\n    border-color: $active-border;\r\n  }\r\n\r\n  &:focus,\r\n  &.focus {\r\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\r\n  }\r\n\r\n  &.disabled,\r\n  &:disabled {\r\n    color: $color;\r\n    background-color: transparent;\r\n  }\r\n\r\n  &:not(:disabled):not(.disabled):active,\r\n  &:not(:disabled):not(.disabled).active,\r\n  .show > &.dropdown-toggle {\r\n    color: color-yiq($active-background);\r\n    background-color: $active-background;\r\n    border-color: $active-border;\r\n\r\n    &:focus {\r\n      // Avoid using mixin so we can pass custom focus shadow properly\r\n      @if $enable-shadows and $btn-active-box-shadow != none {\r\n        box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5);\r\n      } @else {\r\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Button sizes\r\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\r\n  padding: $padding-y $padding-x;\r\n  font-size: $font-size;\r\n  line-height: $line-height;\r\n  // Manually declare to provide an override to the browser default\r\n  @if $enable-rounded {\r\n    border-radius: $border-radius;\r\n  } @else {\r\n    border-radius: 0;\r\n  }\r\n}\r\n","// stylelint-disable selector-no-qualifying-type\r\n\r\n.fade {\r\n  @include transition($transition-fade);\r\n\r\n  &:not(.show) {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.collapse {\r\n  &:not(.show) {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.collapsing {\r\n  position: relative;\r\n  height: 0;\r\n  overflow: hidden;\r\n  @include transition($transition-collapse);\r\n}\r\n","// The dropdown wrapper (`<div>`)\r\n.dropup,\r\n.dropright,\r\n.dropdown,\r\n.dropleft {\r\n  position: relative;\r\n}\r\n\r\n.dropdown-toggle {\r\n  // Generate the caret automatically\r\n  @include caret;\r\n}\r\n\r\n// The dropdown menu\r\n.dropdown-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  z-index: $zindex-dropdown;\r\n  display: none; // none by default, but block on \"open\" of the menu\r\n  float: left;\r\n  min-width: $dropdown-min-width;\r\n  padding: $dropdown-padding-y 0;\r\n  margin: $dropdown-spacer 0 0; // override default ul\r\n  font-size: $font-size-base; // Redeclare because nesting can cause inheritance issues\r\n  color: $body-color;\r\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\r\n  list-style: none;\r\n  background-color: $dropdown-bg;\r\n  background-clip: padding-box;\r\n  border: $dropdown-border-width solid $dropdown-border-color;\r\n  @include border-radius($dropdown-border-radius);\r\n  @include box-shadow($dropdown-box-shadow);\r\n}\r\n\r\n.dropdown-menu-right {\r\n  right: 0;\r\n  left: auto;\r\n}\r\n\r\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\r\n// Just add .dropup after the standard .dropdown class and you're set.\r\n.dropup {\r\n  .dropdown-menu {\r\n    top: auto;\r\n    bottom: 100%;\r\n    margin-top: 0;\r\n    margin-bottom: $dropdown-spacer;\r\n  }\r\n\r\n  .dropdown-toggle {\r\n    @include caret(up);\r\n  }\r\n}\r\n\r\n.dropright {\r\n  .dropdown-menu {\r\n    top: 0;\r\n    right: auto;\r\n    left: 100%;\r\n    margin-top: 0;\r\n    margin-left: $dropdown-spacer;\r\n  }\r\n\r\n  .dropdown-toggle {\r\n    @include caret(right);\r\n    &::after {\r\n      vertical-align: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.dropleft {\r\n  .dropdown-menu {\r\n    top: 0;\r\n    right: 100%;\r\n    left: auto;\r\n    margin-top: 0;\r\n    margin-right: $dropdown-spacer;\r\n  }\r\n\r\n  .dropdown-toggle {\r\n    @include caret(left);\r\n    &::before {\r\n      vertical-align: 0;\r\n    }\r\n  }\r\n}\r\n\r\n// When enabled Popper.js, reset basic dropdown position\r\n// stylelint-disable no-duplicate-selectors\r\n.dropdown-menu {\r\n  &[x-placement^=\"top\"],\r\n  &[x-placement^=\"right\"],\r\n  &[x-placement^=\"bottom\"],\r\n  &[x-placement^=\"left\"] {\r\n    right: auto;\r\n    bottom: auto;\r\n  }\r\n}\r\n// stylelint-enable no-duplicate-selectors\r\n\r\n// Dividers (basically an `<hr>`) within the dropdown\r\n.dropdown-divider {\r\n  @include nav-divider($dropdown-divider-bg);\r\n}\r\n\r\n// Links, buttons, and more within the dropdown menu\r\n//\r\n// `<button>`-specific styles are denoted with `// For <button>s`\r\n.dropdown-item {\r\n  display: block;\r\n  width: 100%; // For `<button>`s\r\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\r\n  clear: both;\r\n  font-weight: $font-weight-normal;\r\n  color: $dropdown-link-color;\r\n  text-align: inherit; // For `<button>`s\r\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\r\n  background-color: transparent; // For `<button>`s\r\n  border: 0; // For `<button>`s\r\n\r\n  @include hover-focus {\r\n    color: $dropdown-link-hover-color;\r\n    text-decoration: none;\r\n    @include gradient-bg($dropdown-link-hover-bg);\r\n  }\r\n\r\n  &.active,\r\n  &:active {\r\n    color: $dropdown-link-active-color;\r\n    text-decoration: none;\r\n    @include gradient-bg($dropdown-link-active-bg);\r\n  }\r\n\r\n  &.disabled,\r\n  &:disabled {\r\n    color: $dropdown-link-disabled-color;\r\n    background-color: transparent;\r\n    // Remove CSS gradients if they're enabled\r\n    @if $enable-gradients {\r\n      background-image: none;\r\n    }\r\n  }\r\n}\r\n\r\n.dropdown-menu.show {\r\n  display: block;\r\n}\r\n\r\n// Dropdown section headers\r\n.dropdown-header {\r\n  display: block;\r\n  padding: $dropdown-padding-y $dropdown-item-padding-x;\r\n  margin-bottom: 0; // for use with heading elements\r\n  font-size: $font-size-sm;\r\n  color: $dropdown-header-color;\r\n  white-space: nowrap; // as with > li > a\r\n}\r\n\r\n// Dropdown text\r\n.dropdown-item-text {\r\n  display: block;\r\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\r\n  color: $dropdown-link-color;\r\n}\r\n","@mixin caret-down {\r\n  border-top: $caret-width solid;\r\n  border-right: $caret-width solid transparent;\r\n  border-bottom: 0;\r\n  border-left: $caret-width solid transparent;\r\n}\r\n\r\n@mixin caret-up {\r\n  border-top: 0;\r\n  border-right: $caret-width solid transparent;\r\n  border-bottom: $caret-width solid;\r\n  border-left: $caret-width solid transparent;\r\n}\r\n\r\n@mixin caret-right {\r\n  border-top: $caret-width solid transparent;\r\n  border-right: 0;\r\n  border-bottom: $caret-width solid transparent;\r\n  border-left: $caret-width solid;\r\n}\r\n\r\n@mixin caret-left {\r\n  border-top: $caret-width solid transparent;\r\n  border-right: $caret-width solid;\r\n  border-bottom: $caret-width solid transparent;\r\n}\r\n\r\n@mixin caret($direction: down) {\r\n  @if $enable-caret {\r\n    &::after {\r\n      display: inline-block;\r\n      width: 0;\r\n      height: 0;\r\n      margin-left: $caret-width * .85;\r\n      vertical-align: $caret-width * .85;\r\n      content: \"\";\r\n      @if $direction == down {\r\n        @include caret-down;\r\n      } @else if $direction == up {\r\n        @include caret-up;\r\n      } @else if $direction == right {\r\n        @include caret-right;\r\n      }\r\n    }\r\n\r\n    @if $direction == left {\r\n      &::after {\r\n        display: none;\r\n      }\r\n\r\n      &::before {\r\n        display: inline-block;\r\n        width: 0;\r\n        height: 0;\r\n        margin-right: $caret-width * .85;\r\n        vertical-align: $caret-width * .85;\r\n        content: \"\";\r\n        @include caret-left;\r\n      }\r\n    }\r\n\r\n    &:empty::after {\r\n      margin-left: 0;\r\n    }\r\n  }\r\n}\r\n","// Horizontal dividers\r\n//\r\n// Dividers (basically an hr) within dropdowns and nav lists\r\n\r\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y) {\r\n  height: 0;\r\n  margin: $margin-y 0;\r\n  overflow: hidden;\r\n  border-top: 1px solid $color;\r\n}\r\n","// stylelint-disable selector-no-qualifying-type\r\n\r\n// Make the div behave like a button\r\n.btn-group,\r\n.btn-group-vertical {\r\n  position: relative;\r\n  display: inline-flex;\r\n  vertical-align: middle; // match .btn alignment given font-size hack above\r\n\r\n  > .btn {\r\n    position: relative;\r\n    flex: 0 1 auto;\r\n\r\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\r\n    // the borders properly\r\n    @include hover {\r\n      z-index: 1;\r\n    }\r\n    &:focus,\r\n    &:active,\r\n    &.active {\r\n      z-index: 1;\r\n    }\r\n  }\r\n\r\n  // Prevent double borders when buttons are next to each other\r\n  .btn + .btn,\r\n  .btn + .btn-group,\r\n  .btn-group + .btn,\r\n  .btn-group + .btn-group {\r\n    margin-left: -$btn-border-width;\r\n  }\r\n}\r\n\r\n// Optional: Group multiple button groups together for a toolbar\r\n.btn-toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n\r\n  .input-group {\r\n    width: auto;\r\n  }\r\n}\r\n\r\n.btn-group {\r\n  > .btn:first-child {\r\n    margin-left: 0;\r\n  }\r\n\r\n  // Reset rounded corners\r\n  > .btn:not(:last-child):not(.dropdown-toggle),\r\n  > .btn-group:not(:last-child) > .btn {\r\n    @include border-right-radius(0);\r\n  }\r\n\r\n  > .btn:not(:first-child),\r\n  > .btn-group:not(:first-child) > .btn {\r\n    @include border-left-radius(0);\r\n  }\r\n}\r\n\r\n// Sizing\r\n//\r\n// Remix the default button sizing classes into new ones for easier manipulation.\r\n\r\n.btn-group-sm > .btn { @extend .btn-sm; }\r\n.btn-group-lg > .btn { @extend .btn-lg; }\r\n\r\n\r\n//\r\n// Split button dropdowns\r\n//\r\n\r\n.dropdown-toggle-split {\r\n  padding-right: $btn-padding-x * .75;\r\n  padding-left: $btn-padding-x * .75;\r\n\r\n  &::after,\r\n  .dropup &::after,\r\n  .dropright &::after {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .dropleft &::before {\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n.btn-sm + .dropdown-toggle-split {\r\n  padding-right: $btn-padding-x-sm * .75;\r\n  padding-left: $btn-padding-x-sm * .75;\r\n}\r\n\r\n.btn-lg + .dropdown-toggle-split {\r\n  padding-right: $btn-padding-x-lg * .75;\r\n  padding-left: $btn-padding-x-lg * .75;\r\n}\r\n\r\n\r\n// The clickable button for toggling the menu\r\n// Set the same inset shadow as the :active state\r\n.btn-group.show .dropdown-toggle {\r\n  @include box-shadow($btn-active-box-shadow);\r\n\r\n  // Show no shadow for `.btn-link` since it has no other button styles.\r\n  &.btn-link {\r\n    @include box-shadow(none);\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Vertical button groups\r\n//\r\n\r\n.btn-group-vertical {\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n\r\n  .btn,\r\n  .btn-group {\r\n    width: 100%;\r\n  }\r\n\r\n  > .btn + .btn,\r\n  > .btn + .btn-group,\r\n  > .btn-group + .btn,\r\n  > .btn-group + .btn-group {\r\n    margin-top: -$btn-border-width;\r\n    margin-left: 0;\r\n  }\r\n\r\n  // Reset rounded corners\r\n  > .btn:not(:last-child):not(.dropdown-toggle),\r\n  > .btn-group:not(:last-child) > .btn {\r\n    @include border-bottom-radius(0);\r\n  }\r\n\r\n  > .btn:not(:first-child),\r\n  > .btn-group:not(:first-child) > .btn {\r\n    @include border-top-radius(0);\r\n  }\r\n}\r\n\r\n\r\n// Checkbox and radio options\r\n//\r\n// In order to support the browser's form validation feedback, powered by the\r\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\r\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\r\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\r\n// certain cases which is prevented by using `clip` and `pointer-events`.\r\n// This way, we ensure a DOM element is visible to position the popover from.\r\n//\r\n// See https://github.com/twbs/bootstrap/pull/12794 and\r\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\r\n\r\n.btn-group-toggle {\r\n  > .btn,\r\n  > .btn-group > .btn {\r\n    margin-bottom: 0; // Override default `<label>` value\r\n\r\n    input[type=\"radio\"],\r\n    input[type=\"checkbox\"] {\r\n      position: absolute;\r\n      clip: rect(0, 0, 0, 0);\r\n      pointer-events: none;\r\n    }\r\n  }\r\n}\r\n","// stylelint-disable selector-no-qualifying-type\r\n\r\n//\r\n// Base styles\r\n//\r\n\r\n.input-group {\r\n  position: relative;\r\n  display: flex;\r\n  flex-wrap: wrap; // For form validation feedback\r\n  align-items: stretch;\r\n  width: 100%;\r\n\r\n  > .form-control,\r\n  > .custom-select,\r\n  > .custom-file {\r\n    position: relative; // For focus state's z-index\r\n    flex: 1 1 auto;\r\n    // Add width 1% and flex-basis auto to ensure that button will not wrap out\r\n    // the column. Applies to IE Edge+ and Firefox. Chrome does not require this.\r\n    width: 1%;\r\n    margin-bottom: 0;\r\n\r\n    + .form-control,\r\n    + .custom-select,\r\n    + .custom-file {\r\n      margin-left: -$input-border-width;\r\n    }\r\n  }\r\n\r\n  // Bring the \"active\" form control to the top of surrounding elements\r\n  > .form-control:focus,\r\n  > .custom-select:focus,\r\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\r\n    z-index: 3;\r\n  }\r\n\r\n  // Bring the custom file input above the label\r\n  > .custom-file .custom-file-input:focus {\r\n    z-index: 4;\r\n  }\r\n\r\n  > .form-control,\r\n  > .custom-select {\r\n    &:not(:last-child) { @include border-right-radius(0); }\r\n    &:not(:first-child) { @include border-left-radius(0); }\r\n  }\r\n\r\n  // Custom file inputs have more complex markup, thus requiring different\r\n  // border-radius overrides.\r\n  > .custom-file {\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    &:not(:last-child) .custom-file-label,\r\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\r\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\r\n  }\r\n}\r\n\r\n\r\n// Prepend and append\r\n//\r\n// While it requires one extra layer of HTML for each, dedicated prepend and\r\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\r\n// 3) support HTML5 form validation.\r\n\r\n.input-group-prepend,\r\n.input-group-append {\r\n  display: flex;\r\n\r\n  // Ensure buttons are always above inputs for more visually pleasing borders.\r\n  // This isn't needed for `.input-group-text` since it shares the same border-color\r\n  // as our inputs.\r\n  .btn {\r\n    position: relative;\r\n    z-index: 2;\r\n  }\r\n\r\n  .btn + .btn,\r\n  .btn + .input-group-text,\r\n  .input-group-text + .input-group-text,\r\n  .input-group-text + .btn {\r\n    margin-left: -$input-border-width;\r\n  }\r\n}\r\n\r\n.input-group-prepend { margin-right: -$input-border-width; }\r\n.input-group-append { margin-left: -$input-border-width; }\r\n\r\n\r\n// Textual addons\r\n//\r\n// Serves as a catch-all element for any text or radio/checkbox input you wish\r\n// to prepend or append to an input.\r\n\r\n.input-group-text {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: $input-padding-y $input-padding-x;\r\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\r\n  font-size: $font-size-base; // Match inputs\r\n  font-weight: $font-weight-normal;\r\n  line-height: $input-line-height;\r\n  color: $input-group-addon-color;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  background-color: $input-group-addon-bg;\r\n  border: $input-border-width solid $input-group-addon-border-color;\r\n  @include border-radius($input-border-radius);\r\n\r\n  // Nuke default margins from checkboxes and radios to vertically center within.\r\n  input[type=\"radio\"],\r\n  input[type=\"checkbox\"] {\r\n    margin-top: 0;\r\n  }\r\n}\r\n\r\n\r\n// Sizing\r\n//\r\n// Remix the default form control sizing classes into new ones for easier\r\n// manipulation.\r\n\r\n.input-group-lg > .form-control,\r\n.input-group-lg > .input-group-prepend > .input-group-text,\r\n.input-group-lg > .input-group-append > .input-group-text,\r\n.input-group-lg > .input-group-prepend > .btn,\r\n.input-group-lg > .input-group-append > .btn {\r\n  height: $input-height-lg;\r\n  padding: $input-padding-y-lg $input-padding-x-lg;\r\n  font-size: $font-size-lg;\r\n  line-height: $input-line-height-lg;\r\n  @include border-radius($input-border-radius-lg);\r\n}\r\n\r\n.input-group-sm > .form-control,\r\n.input-group-sm > .input-group-prepend > .input-group-text,\r\n.input-group-sm > .input-group-append > .input-group-text,\r\n.input-group-sm > .input-group-prepend > .btn,\r\n.input-group-sm > .input-group-append > .btn {\r\n  height: $input-height-sm;\r\n  padding: $input-padding-y-sm $input-padding-x-sm;\r\n  font-size: $font-size-sm;\r\n  line-height: $input-line-height-sm;\r\n  @include border-radius($input-border-radius-sm);\r\n}\r\n\r\n\r\n// Prepend and append rounded corners\r\n//\r\n// These rulesets must come after the sizing ones to properly override sm and lg\r\n// border-radius values when extending. They're more specific than we'd like\r\n// with the `.input-group >` part, but without it, we cannot override the sizing.\r\n\r\n\r\n.input-group > .input-group-prepend > .btn,\r\n.input-group > .input-group-prepend > .input-group-text,\r\n.input-group > .input-group-append:not(:last-child) > .btn,\r\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\r\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\r\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\r\n  @include border-right-radius(0);\r\n}\r\n\r\n.input-group > .input-group-append > .btn,\r\n.input-group > .input-group-append > .input-group-text,\r\n.input-group > .input-group-prepend:not(:first-child) > .btn,\r\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\r\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\r\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\r\n  @include border-left-radius(0);\r\n}\r\n","// Embedded icons from Open Iconic.\r\n// Released under MIT and copyright 2014 Waybury.\r\n// https://useiconic.com/open\r\n\r\n\r\n// Checkboxes and radios\r\n//\r\n// Base class takes care of all the key behavioral aspects.\r\n\r\n.custom-control {\r\n  position: relative;\r\n  display: block;\r\n  min-height: ($font-size-base * $line-height-base);\r\n  padding-left: $custom-control-gutter;\r\n}\r\n\r\n.custom-control-inline {\r\n  display: inline-flex;\r\n  margin-right: $custom-control-spacer-x;\r\n}\r\n\r\n.custom-control-input {\r\n  position: absolute;\r\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\r\n  opacity: 0;\r\n\r\n  &:checked ~ .custom-control-label::before {\r\n    color: $custom-control-indicator-checked-color;\r\n    @include gradient-bg($custom-control-indicator-checked-bg);\r\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\r\n  }\r\n\r\n  &:focus ~ .custom-control-label::before {\r\n    // the mixin is not used here to make sure there is feedback\r\n    box-shadow: $custom-control-indicator-focus-box-shadow;\r\n  }\r\n\r\n  &:active ~ .custom-control-label::before {\r\n    color: $custom-control-indicator-active-color;\r\n    background-color: $custom-control-indicator-active-bg;\r\n    @include box-shadow($custom-control-indicator-active-box-shadow);\r\n  }\r\n\r\n  &:disabled {\r\n    ~ .custom-control-label {\r\n      color: $custom-control-label-disabled-color;\r\n\r\n      &::before {\r\n        background-color: $custom-control-indicator-disabled-bg;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Custom control indicators\r\n//\r\n// Build the custom controls out of pseudo-elements.\r\n\r\n.custom-control-label {\r\n  position: relative;\r\n  margin-bottom: 0;\r\n\r\n  // Background-color and (when enabled) gradient\r\n  &::before {\r\n    position: absolute;\r\n    top: (($font-size-base * $line-height-base - $custom-control-indicator-size) / 2);\r\n    left: -$custom-control-gutter;\r\n    display: block;\r\n    width: $custom-control-indicator-size;\r\n    height: $custom-control-indicator-size;\r\n    pointer-events: none;\r\n    content: \"\";\r\n    user-select: none;\r\n    background-color: $custom-control-indicator-bg;\r\n    @include box-shadow($custom-control-indicator-box-shadow);\r\n  }\r\n\r\n  // Foreground (icon)\r\n  &::after {\r\n    position: absolute;\r\n    top: (($font-size-base * $line-height-base - $custom-control-indicator-size) / 2);\r\n    left: -$custom-control-gutter;\r\n    display: block;\r\n    width: $custom-control-indicator-size;\r\n    height: $custom-control-indicator-size;\r\n    content: \"\";\r\n    background-repeat: no-repeat;\r\n    background-position: center center;\r\n    background-size: $custom-control-indicator-bg-size;\r\n  }\r\n}\r\n\r\n\r\n// Checkboxes\r\n//\r\n// Tweak just a few things for checkboxes.\r\n\r\n.custom-checkbox {\r\n  .custom-control-label::before {\r\n    @include border-radius($custom-checkbox-indicator-border-radius);\r\n  }\r\n\r\n  .custom-control-input:checked ~ .custom-control-label {\r\n    &::before {\r\n      @include gradient-bg($custom-control-indicator-checked-bg);\r\n    }\r\n    &::after {\r\n      background-image: $custom-checkbox-indicator-icon-checked;\r\n    }\r\n  }\r\n\r\n  .custom-control-input:indeterminate ~ .custom-control-label {\r\n    &::before {\r\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\r\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\r\n    }\r\n    &::after {\r\n      background-image: $custom-checkbox-indicator-icon-indeterminate;\r\n    }\r\n  }\r\n\r\n  .custom-control-input:disabled {\r\n    &:checked ~ .custom-control-label::before {\r\n      background-color: $custom-control-indicator-checked-disabled-bg;\r\n    }\r\n    &:indeterminate ~ .custom-control-label::before {\r\n      background-color: $custom-control-indicator-checked-disabled-bg;\r\n    }\r\n  }\r\n}\r\n\r\n// Radios\r\n//\r\n// Tweak just a few things for radios.\r\n\r\n.custom-radio {\r\n  .custom-control-label::before {\r\n    border-radius: $custom-radio-indicator-border-radius;\r\n  }\r\n\r\n  .custom-control-input:checked ~ .custom-control-label {\r\n    &::before {\r\n      @include gradient-bg($custom-control-indicator-checked-bg);\r\n    }\r\n    &::after {\r\n      background-image: $custom-radio-indicator-icon-checked;\r\n    }\r\n  }\r\n\r\n  .custom-control-input:disabled {\r\n    &:checked ~ .custom-control-label::before {\r\n      background-color: $custom-control-indicator-checked-disabled-bg;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Select\r\n//\r\n// Replaces the browser default select with a custom one, mostly pulled from\r\n// https://primer.github.io/.\r\n//\r\n\r\n.custom-select {\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: $custom-select-height;\r\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\r\n  line-height: $custom-select-line-height;\r\n  color: $custom-select-color;\r\n  vertical-align: middle;\r\n  background: $custom-select-bg $custom-select-indicator no-repeat right $custom-select-padding-x center;\r\n  background-size: $custom-select-bg-size;\r\n  border: $custom-select-border-width solid $custom-select-border-color;\r\n  @if $enable-rounded {\r\n    border-radius: $custom-select-border-radius;\r\n  } @else {\r\n    border-radius: 0;\r\n  }\r\n  @include box-shadow($custom-select-box-shadow);\r\n  appearance: none;\r\n\r\n  &:focus {\r\n    border-color: $custom-select-focus-border-color;\r\n    outline: 0;\r\n    @if $enable-shadows {\r\n      box-shadow: $custom-select-box-shadow, $custom-select-focus-box-shadow;\r\n    } @else {\r\n      box-shadow: $custom-select-focus-box-shadow;\r\n    }\r\n\r\n    &::-ms-value {\r\n      // For visual consistency with other platforms/browsers,\r\n      // suppress the default white text on blue background highlight given to\r\n      // the selected option text when the (still closed) <select> receives focus\r\n      // in IE and (under certain conditions) Edge.\r\n      // See https://github.com/twbs/bootstrap/issues/19398.\r\n      color: $input-color;\r\n      background-color: $input-bg;\r\n    }\r\n  }\r\n\r\n  &[multiple],\r\n  &[size]:not([size=\"1\"]) {\r\n    height: auto;\r\n    padding-right: $custom-select-padding-x;\r\n    background-image: none;\r\n  }\r\n\r\n  &:disabled {\r\n    color: $custom-select-disabled-color;\r\n    background-color: $custom-select-disabled-bg;\r\n  }\r\n\r\n  // Hides the default caret in IE11\r\n  &::-ms-expand {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.custom-select-sm {\r\n  height: $custom-select-height-sm;\r\n  padding-top: $custom-select-padding-y;\r\n  padding-bottom: $custom-select-padding-y;\r\n  font-size: $custom-select-font-size-sm;\r\n}\r\n\r\n.custom-select-lg {\r\n  height: $custom-select-height-lg;\r\n  padding-top: $custom-select-padding-y;\r\n  padding-bottom: $custom-select-padding-y;\r\n  font-size: $custom-select-font-size-lg;\r\n}\r\n\r\n\r\n// File\r\n//\r\n// Custom file input.\r\n\r\n.custom-file {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: $custom-file-height;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.custom-file-input {\r\n  position: relative;\r\n  z-index: 2;\r\n  width: 100%;\r\n  height: $custom-file-height;\r\n  margin: 0;\r\n  opacity: 0;\r\n\r\n  &:focus ~ .custom-file-label {\r\n    border-color: $custom-file-focus-border-color;\r\n    box-shadow: $custom-file-focus-box-shadow;\r\n\r\n    &::after {\r\n      border-color: $custom-file-focus-border-color;\r\n    }\r\n  }\r\n\r\n  &:disabled ~ .custom-file-label {\r\n    background-color: $custom-file-disabled-bg;\r\n  }\r\n\r\n  @each $lang, $value in $custom-file-text {\r\n    &:lang(#{$lang}) ~ .custom-file-label::after {\r\n      content: $value;\r\n    }\r\n  }\r\n}\r\n\r\n.custom-file-label {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  z-index: 1;\r\n  height: $custom-file-height;\r\n  padding: $custom-file-padding-y $custom-file-padding-x;\r\n  line-height: $custom-file-line-height;\r\n  color: $custom-file-color;\r\n  background-color: $custom-file-bg;\r\n  border: $custom-file-border-width solid $custom-file-border-color;\r\n  @include border-radius($custom-file-border-radius);\r\n  @include box-shadow($custom-file-box-shadow);\r\n\r\n  &::after {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    z-index: 3;\r\n    display: block;\r\n    height: $custom-file-height-inner;\r\n    padding: $custom-file-padding-y $custom-file-padding-x;\r\n    line-height: $custom-file-line-height;\r\n    color: $custom-file-button-color;\r\n    content: \"Browse\";\r\n    @include gradient-bg($custom-file-button-bg);\r\n    border-left: $custom-file-border-width solid $custom-file-border-color;\r\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\r\n  }\r\n}\r\n\r\n// Range\r\n//\r\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\r\n// elements cannot be mixed. As such, there are no shared styles for focus or\r\n// active states on prefixed selectors.\r\n\r\n.custom-range {\r\n  width: 100%;\r\n  padding-left: 0; // Firefox specific\r\n  background-color: transparent;\r\n  appearance: none;\r\n\r\n  &:focus {\r\n    outline: none;\r\n\r\n    // Pseudo-elements must be split across multiple rulesets to have an affect.\r\n    // No box-shadow() mixin for focus accessibility.\r\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\r\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\r\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\r\n  }\r\n\r\n  &::-moz-focus-outer {\r\n    border: 0;\r\n  }\r\n\r\n  &::-webkit-slider-thumb {\r\n    width: $custom-range-thumb-width;\r\n    height: $custom-range-thumb-height;\r\n    margin-top: (($custom-range-track-height - $custom-range-thumb-height) / 2); // Webkit specific\r\n    @include gradient-bg($custom-range-thumb-bg);\r\n    border: $custom-range-thumb-border;\r\n    @include border-radius($custom-range-thumb-border-radius);\r\n    @include box-shadow($custom-range-thumb-box-shadow);\r\n    @include transition($custom-forms-transition);\r\n    appearance: none;\r\n\r\n    &:active {\r\n      @include gradient-bg($custom-range-thumb-active-bg);\r\n    }\r\n  }\r\n\r\n  &::-webkit-slider-runnable-track {\r\n    width: $custom-range-track-width;\r\n    height: $custom-range-track-height;\r\n    color: transparent; // Why?\r\n    cursor: $custom-range-track-cursor;\r\n    background-color: $custom-range-track-bg;\r\n    border-color: transparent;\r\n    @include border-radius($custom-range-track-border-radius);\r\n    @include box-shadow($custom-range-track-box-shadow);\r\n  }\r\n\r\n  &::-moz-range-thumb {\r\n    width: $custom-range-thumb-width;\r\n    height: $custom-range-thumb-height;\r\n    @include gradient-bg($custom-range-thumb-bg);\r\n    border: $custom-range-thumb-border;\r\n    @include border-radius($custom-range-thumb-border-radius);\r\n    @include box-shadow($custom-range-thumb-box-shadow);\r\n    @include transition($custom-forms-transition);\r\n    appearance: none;\r\n\r\n    &:active {\r\n      @include gradient-bg($custom-range-thumb-active-bg);\r\n    }\r\n  }\r\n\r\n  &::-moz-range-track {\r\n    width: $custom-range-track-width;\r\n    height: $custom-range-track-height;\r\n    color: transparent;\r\n    cursor: $custom-range-track-cursor;\r\n    background-color: $custom-range-track-bg;\r\n    border-color: transparent; // Firefox specific?\r\n    @include border-radius($custom-range-track-border-radius);\r\n    @include box-shadow($custom-range-track-box-shadow);\r\n  }\r\n\r\n  &::-ms-thumb {\r\n    width: $custom-range-thumb-width;\r\n    height: $custom-range-thumb-height;\r\n    margin-top: 0; // Edge specific\r\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\r\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\r\n    @include gradient-bg($custom-range-thumb-bg);\r\n    border: $custom-range-thumb-border;\r\n    @include border-radius($custom-range-thumb-border-radius);\r\n    @include box-shadow($custom-range-thumb-box-shadow);\r\n    @include transition($custom-forms-transition);\r\n    appearance: none;\r\n\r\n    &:active {\r\n      @include gradient-bg($custom-range-thumb-active-bg);\r\n    }\r\n  }\r\n\r\n  &::-ms-track {\r\n    width: $custom-range-track-width;\r\n    height: $custom-range-track-height;\r\n    color: transparent;\r\n    cursor: $custom-range-track-cursor;\r\n    background-color: transparent;\r\n    border-color: transparent;\r\n    border-width: ($custom-range-thumb-height * .5);\r\n    @include box-shadow($custom-range-track-box-shadow);\r\n  }\r\n\r\n  &::-ms-fill-lower {\r\n    background-color: $custom-range-track-bg;\r\n    @include border-radius($custom-range-track-border-radius);\r\n  }\r\n\r\n  &::-ms-fill-upper {\r\n    margin-right: 15px; // arbitrary?\r\n    background-color: $custom-range-track-bg;\r\n    @include border-radius($custom-range-track-border-radius);\r\n  }\r\n}\r\n\r\n.custom-control-label::before,\r\n.custom-file-label,\r\n.custom-select {\r\n  @include transition($custom-forms-transition);\r\n}\r\n","// Base class\r\n//\r\n// Kickstart any navigation component with a set of style resets. Works with\r\n// `<nav>`s or `<ul>`s.\r\n\r\n.nav {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n}\r\n\r\n.nav-link {\r\n  display: block;\r\n  padding: $nav-link-padding-y $nav-link-padding-x;\r\n\r\n  @include hover-focus {\r\n    text-decoration: none;\r\n  }\r\n\r\n  // Disabled state lightens text\r\n  &.disabled {\r\n    color: $nav-link-disabled-color;\r\n  }\r\n}\r\n\r\n//\r\n// Tabs\r\n//\r\n\r\n.nav-tabs {\r\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\r\n\r\n  .nav-item {\r\n    margin-bottom: -$nav-tabs-border-width;\r\n  }\r\n\r\n  .nav-link {\r\n    border: $nav-tabs-border-width solid transparent;\r\n    @include border-top-radius($nav-tabs-border-radius);\r\n\r\n    @include hover-focus {\r\n      border-color: $nav-tabs-link-hover-border-color;\r\n    }\r\n\r\n    &.disabled {\r\n      color: $nav-link-disabled-color;\r\n      background-color: transparent;\r\n      border-color: transparent;\r\n    }\r\n  }\r\n\r\n  .nav-link.active,\r\n  .nav-item.show .nav-link {\r\n    color: $nav-tabs-link-active-color;\r\n    background-color: $nav-tabs-link-active-bg;\r\n    border-color: $nav-tabs-link-active-border-color;\r\n  }\r\n\r\n  .dropdown-menu {\r\n    // Make dropdown border overlap tab border\r\n    margin-top: -$nav-tabs-border-width;\r\n    // Remove the top rounded corners here since there is a hard edge above the menu\r\n    @include border-top-radius(0);\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Pills\r\n//\r\n\r\n.nav-pills {\r\n  .nav-link {\r\n    @include border-radius($nav-pills-border-radius);\r\n  }\r\n\r\n  .nav-link.active,\r\n  .show > .nav-link {\r\n    color: $nav-pills-link-active-color;\r\n    background-color: $nav-pills-link-active-bg;\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Justified variants\r\n//\r\n\r\n.nav-fill {\r\n  .nav-item {\r\n    flex: 1 1 auto;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.nav-justified {\r\n  .nav-item {\r\n    flex-basis: 0;\r\n    flex-grow: 1;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n\r\n// Tabbable tabs\r\n//\r\n// Hide tabbable panes to start, show them when `.active`\r\n\r\n.tab-content {\r\n  > .tab-pane {\r\n    display: none;\r\n  }\r\n  > .active {\r\n    display: block;\r\n  }\r\n}\r\n","// Contents\r\n//\r\n// Navbar\r\n// Navbar brand\r\n// Navbar nav\r\n// Navbar text\r\n// Navbar divider\r\n// Responsive navbar\r\n// Navbar position\r\n// Navbar themes\r\n\r\n\r\n// Navbar\r\n//\r\n// Provide a static navbar from which we expand to create full-width, fixed, and\r\n// other navbar variations.\r\n\r\n.navbar {\r\n  position: relative;\r\n  display: flex;\r\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\r\n  align-items: center;\r\n  justify-content: space-between; // space out brand from logo\r\n  padding: $navbar-padding-y $navbar-padding-x;\r\n\r\n  // Because flex properties aren't inherited, we need to redeclare these first\r\n  // few properties so that content nested within behave properly.\r\n  > .container,\r\n  > .container-fluid {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n  }\r\n}\r\n\r\n\r\n// Navbar brand\r\n//\r\n// Used for brand, project, or site names.\r\n\r\n.navbar-brand {\r\n  display: inline-block;\r\n  padding-top: $navbar-brand-padding-y;\r\n  padding-bottom: $navbar-brand-padding-y;\r\n  margin-right: $navbar-padding-x;\r\n  font-size: $navbar-brand-font-size;\r\n  line-height: inherit;\r\n  white-space: nowrap;\r\n\r\n  @include hover-focus {\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n\r\n// Navbar nav\r\n//\r\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\r\n\r\n.navbar-nav {\r\n  display: flex;\r\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n\r\n  .nav-link {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n\r\n  .dropdown-menu {\r\n    position: static;\r\n    float: none;\r\n  }\r\n}\r\n\r\n\r\n// Navbar text\r\n//\r\n//\r\n\r\n.navbar-text {\r\n  display: inline-block;\r\n  padding-top: $nav-link-padding-y;\r\n  padding-bottom: $nav-link-padding-y;\r\n}\r\n\r\n\r\n// Responsive navbar\r\n//\r\n// Custom styles for responsive collapsing and toggling of navbar contents.\r\n// Powered by the collapse Bootstrap JavaScript plugin.\r\n\r\n// When collapsed, prevent the toggleable navbar contents from appearing in\r\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\r\n// on the `.navbar` parent.\r\n.navbar-collapse {\r\n  flex-basis: 100%;\r\n  flex-grow: 1;\r\n  // For always expanded or extra full navbars, ensure content aligns itself\r\n  // properly vertically. Can be easily overridden with flex utilities.\r\n  align-items: center;\r\n}\r\n\r\n// Button for toggling the navbar when in its collapsed state\r\n.navbar-toggler {\r\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\r\n  font-size: $navbar-toggler-font-size;\r\n  line-height: 1;\r\n  background-color: transparent; // remove default button style\r\n  border: $border-width solid transparent; // remove default button style\r\n  @include border-radius($navbar-toggler-border-radius);\r\n\r\n  @include hover-focus {\r\n    text-decoration: none;\r\n  }\r\n\r\n  // Opinionated: add \"hand\" cursor to non-disabled .navbar-toggler elements\r\n  &:not(:disabled):not(.disabled) {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n// Keep as a separate element so folks can easily override it with another icon\r\n// or image file as needed.\r\n.navbar-toggler-icon {\r\n  display: inline-block;\r\n  width: 1.5em;\r\n  height: 1.5em;\r\n  vertical-align: middle;\r\n  content: \"\";\r\n  background: no-repeat center center;\r\n  background-size: 100% 100%;\r\n}\r\n\r\n// Generate series of `.navbar-expand-*` responsive classes for configuring\r\n// where your navbar collapses.\r\n.navbar-expand {\r\n  @each $breakpoint in map-keys($grid-breakpoints) {\r\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\r\n    $infix: breakpoint-infix($next, $grid-breakpoints);\r\n\r\n    &#{$infix} {\r\n      @include media-breakpoint-down($breakpoint) {\r\n        > .container,\r\n        > .container-fluid {\r\n          padding-right: 0;\r\n          padding-left: 0;\r\n        }\r\n      }\r\n\r\n      @include media-breakpoint-up($next) {\r\n        flex-flow: row nowrap;\r\n        justify-content: flex-start;\r\n\r\n        .navbar-nav {\r\n          flex-direction: row;\r\n\r\n          .dropdown-menu {\r\n            position: absolute;\r\n          }\r\n\r\n          .nav-link {\r\n            padding-right: $navbar-nav-link-padding-x;\r\n            padding-left: $navbar-nav-link-padding-x;\r\n          }\r\n        }\r\n\r\n        // For nesting containers, have to redeclare for alignment purposes\r\n        > .container,\r\n        > .container-fluid {\r\n          flex-wrap: nowrap;\r\n        }\r\n\r\n        .navbar-collapse {\r\n          display: flex !important;  // stylelint-disable-line declaration-no-important\r\n\r\n          // Changes flex-bases to auto because of an IE10 bug\r\n          flex-basis: auto;\r\n        }\r\n\r\n        .navbar-toggler {\r\n          display: none;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Navbar themes\r\n//\r\n// Styles for switching between navbars with light or dark background.\r\n\r\n// Dark links against a light background\r\n.navbar-light {\r\n  .navbar-brand {\r\n    color: $navbar-light-active-color;\r\n\r\n    @include hover-focus {\r\n      color: $navbar-light-active-color;\r\n    }\r\n  }\r\n\r\n  .navbar-nav {\r\n    .nav-link {\r\n      color: $navbar-light-color;\r\n\r\n      @include hover-focus {\r\n        color: $navbar-light-hover-color;\r\n      }\r\n\r\n      &.disabled {\r\n        color: $navbar-light-disabled-color;\r\n      }\r\n    }\r\n\r\n    .show > .nav-link,\r\n    .active > .nav-link,\r\n    .nav-link.show,\r\n    .nav-link.active {\r\n      color: $navbar-light-active-color;\r\n    }\r\n  }\r\n\r\n  .navbar-toggler {\r\n    color: $navbar-light-color;\r\n    border-color: $navbar-light-toggler-border-color;\r\n  }\r\n\r\n  .navbar-toggler-icon {\r\n    background-image: $navbar-light-toggler-icon-bg;\r\n  }\r\n\r\n  .navbar-text {\r\n    color: $navbar-light-color;\r\n    a {\r\n      color: $navbar-light-active-color;\r\n\r\n      @include hover-focus {\r\n        color: $navbar-light-active-color;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// White links against a dark background\r\n.navbar-dark {\r\n  .navbar-brand {\r\n    color: $navbar-dark-active-color;\r\n\r\n    @include hover-focus {\r\n      color: $navbar-dark-active-color;\r\n    }\r\n  }\r\n\r\n  .navbar-nav {\r\n    .nav-link {\r\n      color: $navbar-dark-color;\r\n\r\n      @include hover-focus {\r\n        color: $navbar-dark-hover-color;\r\n      }\r\n\r\n      &.disabled {\r\n        color: $navbar-dark-disabled-color;\r\n      }\r\n    }\r\n\r\n    .show > .nav-link,\r\n    .active > .nav-link,\r\n    .nav-link.show,\r\n    .nav-link.active {\r\n      color: $navbar-dark-active-color;\r\n    }\r\n  }\r\n\r\n  .navbar-toggler {\r\n    color: $navbar-dark-color;\r\n    border-color: $navbar-dark-toggler-border-color;\r\n  }\r\n\r\n  .navbar-toggler-icon {\r\n    background-image: $navbar-dark-toggler-icon-bg;\r\n  }\r\n\r\n  .navbar-text {\r\n    color: $navbar-dark-color;\r\n    a {\r\n      color: $navbar-dark-active-color;\r\n\r\n      @include hover-focus {\r\n        color: $navbar-dark-active-color;\r\n      }\r\n    }\r\n  }\r\n}\r\n","//\r\n// Base styles\r\n//\r\n\r\n.card {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  word-wrap: break-word;\r\n  background-color: $card-bg;\r\n  background-clip: border-box;\r\n  border: $card-border-width solid $card-border-color;\r\n  @include border-radius($card-border-radius);\r\n\r\n  > hr {\r\n    margin-right: 0;\r\n    margin-left: 0;\r\n  }\r\n\r\n  > .list-group:first-child {\r\n    .list-group-item:first-child {\r\n      @include border-top-radius($card-border-radius);\r\n    }\r\n  }\r\n\r\n  > .list-group:last-child {\r\n    .list-group-item:last-child {\r\n      @include border-bottom-radius($card-border-radius);\r\n    }\r\n  }\r\n}\r\n\r\n.card-body {\r\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\r\n  // as much space as possible, ensuring footers are aligned to the bottom.\r\n  flex: 1 1 auto;\r\n  padding: $card-spacer-x;\r\n}\r\n\r\n.card-title {\r\n  margin-bottom: $card-spacer-y;\r\n}\r\n\r\n.card-subtitle {\r\n  margin-top: -($card-spacer-y / 2);\r\n  margin-bottom: 0;\r\n}\r\n\r\n.card-text:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.card-link {\r\n  @include hover {\r\n    text-decoration: none;\r\n  }\r\n\r\n  + .card-link {\r\n    margin-left: $card-spacer-x;\r\n  }\r\n}\r\n\r\n//\r\n// Optional textual caps\r\n//\r\n\r\n.card-header {\r\n  padding: $card-spacer-y $card-spacer-x;\r\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\r\n  background-color: $card-cap-bg;\r\n  border-bottom: $card-border-width solid $card-border-color;\r\n\r\n  &:first-child {\r\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\r\n  }\r\n\r\n  + .list-group {\r\n    .list-group-item:first-child {\r\n      border-top: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.card-footer {\r\n  padding: $card-spacer-y $card-spacer-x;\r\n  background-color: $card-cap-bg;\r\n  border-top: $card-border-width solid $card-border-color;\r\n\r\n  &:last-child {\r\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Header navs\r\n//\r\n\r\n.card-header-tabs {\r\n  margin-right: -($card-spacer-x / 2);\r\n  margin-bottom: -$card-spacer-y;\r\n  margin-left: -($card-spacer-x / 2);\r\n  border-bottom: 0;\r\n}\r\n\r\n.card-header-pills {\r\n  margin-right: -($card-spacer-x / 2);\r\n  margin-left: -($card-spacer-x / 2);\r\n}\r\n\r\n// Card image\r\n.card-img-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  padding: $card-img-overlay-padding;\r\n}\r\n\r\n.card-img {\r\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\r\n  @include border-radius($card-inner-border-radius);\r\n}\r\n\r\n// Card image caps\r\n.card-img-top {\r\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\r\n  @include border-top-radius($card-inner-border-radius);\r\n}\r\n\r\n.card-img-bottom {\r\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\r\n  @include border-bottom-radius($card-inner-border-radius);\r\n}\r\n\r\n\r\n// Card deck\r\n\r\n.card-deck {\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  .card {\r\n    margin-bottom: $card-deck-margin;\r\n  }\r\n\r\n  @include media-breakpoint-up(sm) {\r\n    flex-flow: row wrap;\r\n    margin-right: -$card-deck-margin;\r\n    margin-left: -$card-deck-margin;\r\n\r\n    .card {\r\n      display: flex;\r\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\r\n      flex: 1 0 0%;\r\n      flex-direction: column;\r\n      margin-right: $card-deck-margin;\r\n      margin-bottom: 0; // Override the default\r\n      margin-left: $card-deck-margin;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Card groups\r\n//\r\n\r\n.card-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  // The child selector allows nested `.card` within `.card-group`\r\n  // to display properly.\r\n  > .card {\r\n    margin-bottom: $card-group-margin;\r\n  }\r\n\r\n  @include media-breakpoint-up(sm) {\r\n    flex-flow: row wrap;\r\n    // The child selector allows nested `.card` within `.card-group`\r\n    // to display properly.\r\n    > .card {\r\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\r\n      flex: 1 0 0%;\r\n      margin-bottom: 0;\r\n\r\n      + .card {\r\n        margin-left: 0;\r\n        border-left: 0;\r\n      }\r\n\r\n      // Handle rounded corners\r\n      @if $enable-rounded {\r\n        &:first-child {\r\n          @include border-right-radius(0);\r\n\r\n          .card-img-top,\r\n          .card-header {\r\n            border-top-right-radius: 0;\r\n          }\r\n          .card-img-bottom,\r\n          .card-footer {\r\n            border-bottom-right-radius: 0;\r\n          }\r\n        }\r\n\r\n        &:last-child {\r\n          @include border-left-radius(0);\r\n\r\n          .card-img-top,\r\n          .card-header {\r\n            border-top-left-radius: 0;\r\n          }\r\n          .card-img-bottom,\r\n          .card-footer {\r\n            border-bottom-left-radius: 0;\r\n          }\r\n        }\r\n\r\n        &:only-child {\r\n          @include border-radius($card-border-radius);\r\n\r\n          .card-img-top,\r\n          .card-header {\r\n            @include border-top-radius($card-border-radius);\r\n          }\r\n          .card-img-bottom,\r\n          .card-footer {\r\n            @include border-bottom-radius($card-border-radius);\r\n          }\r\n        }\r\n\r\n        &:not(:first-child):not(:last-child):not(:only-child) {\r\n          @include border-radius(0);\r\n\r\n          .card-img-top,\r\n          .card-img-bottom,\r\n          .card-header,\r\n          .card-footer {\r\n            @include border-radius(0);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Columns\r\n//\r\n\r\n.card-columns {\r\n  .card {\r\n    margin-bottom: $card-columns-margin;\r\n  }\r\n\r\n  @include media-breakpoint-up(sm) {\r\n    column-count: $card-columns-count;\r\n    column-gap: $card-columns-gap;\r\n    orphans: 1;\r\n    widows: 1;\r\n\r\n    .card {\r\n      display: inline-block; // Don't let them vertically span multiple columns\r\n      width: 100%; // Don't let their width change\r\n    }\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Accordion\r\n//\r\n\r\n.accordion {\r\n  .card:not(:first-of-type):not(:last-of-type) {\r\n    border-bottom: 0;\r\n    border-radius: 0;\r\n  }\r\n\r\n  .card:not(:first-of-type) {\r\n    .card-header:first-child {\r\n      border-radius: 0;\r\n    }\r\n  }\r\n\r\n  .card:first-of-type {\r\n    border-bottom: 0;\r\n    border-bottom-right-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n  }\r\n\r\n  .card:last-of-type {\r\n    border-top-left-radius: 0;\r\n    border-top-right-radius: 0;\r\n  }\r\n}\r\n",".breadcrumb {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\r\n  margin-bottom: $breadcrumb-margin-bottom;\r\n  list-style: none;\r\n  background-color: $breadcrumb-bg;\r\n  @include border-radius($breadcrumb-border-radius);\r\n}\r\n\r\n.breadcrumb-item {\r\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\r\n  + .breadcrumb-item {\r\n    padding-left: $breadcrumb-item-padding;\r\n\r\n    &::before {\r\n      display: inline-block; // Suppress underlining of the separator in modern browsers\r\n      padding-right: $breadcrumb-item-padding;\r\n      color: $breadcrumb-divider-color;\r\n      content: $breadcrumb-divider;\r\n    }\r\n  }\r\n\r\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\r\n  // without `<ul>`s. The `::before` pseudo-element generates an element\r\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\r\n  //\r\n  // To trick IE into suppressing the underline, we give the pseudo-element an\r\n  // underline and then immediately remove it.\r\n  + .breadcrumb-item:hover::before {\r\n    text-decoration: underline;\r\n  }\r\n  // stylelint-disable-next-line no-duplicate-selectors\r\n  + .breadcrumb-item:hover::before {\r\n    text-decoration: none;\r\n  }\r\n\r\n  &.active {\r\n    color: $breadcrumb-active-color;\r\n  }\r\n}\r\n",".pagination {\r\n  display: flex;\r\n  @include list-unstyled();\r\n  @include border-radius();\r\n}\r\n\r\n.page-link {\r\n  position: relative;\r\n  display: block;\r\n  padding: $pagination-padding-y $pagination-padding-x;\r\n  margin-left: -$pagination-border-width;\r\n  line-height: $pagination-line-height;\r\n  color: $pagination-color;\r\n  background-color: $pagination-bg;\r\n  border: $pagination-border-width solid $pagination-border-color;\r\n\r\n  &:hover {\r\n    z-index: 2;\r\n    color: $pagination-hover-color;\r\n    text-decoration: none;\r\n    background-color: $pagination-hover-bg;\r\n    border-color: $pagination-hover-border-color;\r\n  }\r\n\r\n  &:focus {\r\n    z-index: 2;\r\n    outline: $pagination-focus-outline;\r\n    box-shadow: $pagination-focus-box-shadow;\r\n  }\r\n\r\n  // Opinionated: add \"hand\" cursor to non-disabled .page-link elements\r\n  &:not(:disabled):not(.disabled) {\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n.page-item {\r\n  &:first-child {\r\n    .page-link {\r\n      margin-left: 0;\r\n      @include border-left-radius($border-radius);\r\n    }\r\n  }\r\n  &:last-child {\r\n    .page-link {\r\n      @include border-right-radius($border-radius);\r\n    }\r\n  }\r\n\r\n  &.active .page-link {\r\n    z-index: 1;\r\n    color: $pagination-active-color;\r\n    background-color: $pagination-active-bg;\r\n    border-color: $pagination-active-border-color;\r\n  }\r\n\r\n  &.disabled .page-link {\r\n    color: $pagination-disabled-color;\r\n    pointer-events: none;\r\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\r\n    cursor: auto;\r\n    background-color: $pagination-disabled-bg;\r\n    border-color: $pagination-disabled-border-color;\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Sizing\r\n//\r\n\r\n.pagination-lg {\r\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $border-radius-lg);\r\n}\r\n\r\n.pagination-sm {\r\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $border-radius-sm);\r\n}\r\n","// Pagination\r\n\r\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\r\n  .page-link {\r\n    padding: $padding-y $padding-x;\r\n    font-size: $font-size;\r\n    line-height: $line-height;\r\n  }\r\n\r\n  .page-item {\r\n    &:first-child {\r\n      .page-link {\r\n        @include border-left-radius($border-radius);\r\n      }\r\n    }\r\n    &:last-child {\r\n      .page-link {\r\n        @include border-right-radius($border-radius);\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Base class\r\n//\r\n// Requires one of the contextual, color modifier classes for `color` and\r\n// `background-color`.\r\n\r\n.badge {\r\n  display: inline-block;\r\n  padding: $badge-padding-y $badge-padding-x;\r\n  font-size: $badge-font-size;\r\n  font-weight: $badge-font-weight;\r\n  line-height: 1;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  vertical-align: baseline;\r\n  @include border-radius($badge-border-radius);\r\n\r\n  // Empty badges collapse automatically\r\n  &:empty {\r\n    display: none;\r\n  }\r\n}\r\n\r\n// Quick fix for badges in buttons\r\n.btn .badge {\r\n  position: relative;\r\n  top: -1px;\r\n}\r\n\r\n// Pill badges\r\n//\r\n// Make them extra rounded with a modifier to replace v3's badges.\r\n\r\n.badge-pill {\r\n  padding-right: $badge-pill-padding-x;\r\n  padding-left: $badge-pill-padding-x;\r\n  @include border-radius($badge-pill-border-radius);\r\n}\r\n\r\n// Colors\r\n//\r\n// Contextual variations (linked badges get darker on :hover).\r\n\r\n@each $color, $value in $theme-colors {\r\n  .badge-#{$color} {\r\n    @include badge-variant($value);\r\n  }\r\n}\r\n","@mixin badge-variant($bg) {\r\n  color: color-yiq($bg);\r\n  background-color: $bg;\r\n\r\n  &[href] {\r\n    @include hover-focus {\r\n      color: color-yiq($bg);\r\n      text-decoration: none;\r\n      background-color: darken($bg, 10%);\r\n    }\r\n  }\r\n}\r\n",".jumbotron {\r\n  padding: $jumbotron-padding ($jumbotron-padding / 2);\r\n  margin-bottom: $jumbotron-padding;\r\n  background-color: $jumbotron-bg;\r\n  @include border-radius($border-radius-lg);\r\n\r\n  @include media-breakpoint-up(sm) {\r\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\r\n  }\r\n}\r\n\r\n.jumbotron-fluid {\r\n  padding-right: 0;\r\n  padding-left: 0;\r\n  @include border-radius(0);\r\n}\r\n","//\r\n// Base styles\r\n//\r\n\r\n.alert {\r\n  position: relative;\r\n  padding: $alert-padding-y $alert-padding-x;\r\n  margin-bottom: $alert-margin-bottom;\r\n  border: $alert-border-width solid transparent;\r\n  @include border-radius($alert-border-radius);\r\n}\r\n\r\n// Headings for larger alerts\r\n.alert-heading {\r\n  // Specified to prevent conflicts of changing $headings-color\r\n  color: inherit;\r\n}\r\n\r\n// Provide class for links that match alerts\r\n.alert-link {\r\n  font-weight: $alert-link-font-weight;\r\n}\r\n\r\n\r\n// Dismissible alerts\r\n//\r\n// Expand the right padding and account for the close button's positioning.\r\n\r\n.alert-dismissible {\r\n  padding-right: ($close-font-size + $alert-padding-x * 2);\r\n\r\n  // Adjust close link position\r\n  .close {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    padding: $alert-padding-y $alert-padding-x;\r\n    color: inherit;\r\n  }\r\n}\r\n\r\n\r\n// Alternate styles\r\n//\r\n// Generate contextual modifier classes for colorizing the alert.\r\n\r\n@each $color, $value in $theme-colors {\r\n  .alert-#{$color} {\r\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\r\n  }\r\n}\r\n","@mixin alert-variant($background, $border, $color) {\r\n  color: $color;\r\n  @include gradient-bg($background);\r\n  border-color: $border;\r\n\r\n  hr {\r\n    border-top-color: darken($border, 5%);\r\n  }\r\n\r\n  .alert-link {\r\n    color: darken($color, 10%);\r\n  }\r\n}\r\n","@keyframes progress-bar-stripes {\r\n  from { background-position: $progress-height 0; }\r\n  to { background-position: 0 0; }\r\n}\r\n\r\n.progress {\r\n  display: flex;\r\n  height: $progress-height;\r\n  overflow: hidden; // force rounded corners by cropping it\r\n  font-size: $progress-font-size;\r\n  background-color: $progress-bg;\r\n  @include border-radius($progress-border-radius);\r\n  @include box-shadow($progress-box-shadow);\r\n}\r\n\r\n.progress-bar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  color: $progress-bar-color;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  background-color: $progress-bar-bg;\r\n  @include transition($progress-bar-transition);\r\n}\r\n\r\n.progress-bar-striped {\r\n  @include gradient-striped();\r\n  background-size: $progress-height $progress-height;\r\n}\r\n\r\n.progress-bar-animated {\r\n  animation: progress-bar-stripes $progress-bar-animation-timing;\r\n}\r\n",".media {\r\n  display: flex;\r\n  align-items: flex-start;\r\n}\r\n\r\n.media-body {\r\n  flex: 1;\r\n}\r\n","// Base class\r\n//\r\n// Easily usable on <ul>, <ol>, or <div>.\r\n\r\n.list-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  // No need to set list-style: none; since .list-group-item is block level\r\n  padding-left: 0; // reset padding because ul and ol\r\n  margin-bottom: 0;\r\n}\r\n\r\n\r\n// Interactive list items\r\n//\r\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\r\n// list items. Includes an extra `.active` modifier class for selected items.\r\n\r\n.list-group-item-action {\r\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\r\n  color: $list-group-action-color;\r\n  text-align: inherit; // For `<button>`s (anchors inherit)\r\n\r\n  // Hover state\r\n  @include hover-focus {\r\n    color: $list-group-action-hover-color;\r\n    text-decoration: none;\r\n    background-color: $list-group-hover-bg;\r\n  }\r\n\r\n  &:active {\r\n    color: $list-group-action-active-color;\r\n    background-color: $list-group-action-active-bg;\r\n  }\r\n}\r\n\r\n\r\n// Individual list items\r\n//\r\n// Use on `li`s or `div`s within the `.list-group` parent.\r\n\r\n.list-group-item {\r\n  position: relative;\r\n  display: block;\r\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\r\n  // Place the border on the list items and negative margin up for better styling\r\n  margin-bottom: -$list-group-border-width;\r\n  background-color: $list-group-bg;\r\n  border: $list-group-border-width solid $list-group-border-color;\r\n\r\n  &:first-child {\r\n    @include border-top-radius($list-group-border-radius);\r\n  }\r\n\r\n  &:last-child {\r\n    margin-bottom: 0;\r\n    @include border-bottom-radius($list-group-border-radius);\r\n  }\r\n\r\n  @include hover-focus {\r\n    z-index: 1; // Place hover/active items above their siblings for proper border styling\r\n    text-decoration: none;\r\n  }\r\n\r\n  &.disabled,\r\n  &:disabled {\r\n    color: $list-group-disabled-color;\r\n    background-color: $list-group-disabled-bg;\r\n  }\r\n\r\n  // Include both here for `<a>`s and `<button>`s\r\n  &.active {\r\n    z-index: 2; // Place active items above their siblings for proper border styling\r\n    color: $list-group-active-color;\r\n    background-color: $list-group-active-bg;\r\n    border-color: $list-group-active-border-color;\r\n  }\r\n}\r\n\r\n\r\n// Flush list items\r\n//\r\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\r\n// useful within other components (e.g., cards).\r\n\r\n.list-group-flush {\r\n  .list-group-item {\r\n    border-right: 0;\r\n    border-left: 0;\r\n    @include border-radius(0);\r\n  }\r\n\r\n  &:first-child {\r\n    .list-group-item:first-child {\r\n      border-top: 0;\r\n    }\r\n  }\r\n\r\n  &:last-child {\r\n    .list-group-item:last-child {\r\n      border-bottom: 0;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Contextual variants\r\n//\r\n// Add modifier classes to change text and background color on individual items.\r\n// Organizationally, this must come after the `:hover` states.\r\n\r\n@each $color, $value in $theme-colors {\r\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\r\n}\r\n","// List Groups\r\n\r\n@mixin list-group-item-variant($state, $background, $color) {\r\n  .list-group-item-#{$state} {\r\n    color: $color;\r\n    background-color: $background;\r\n\r\n    &.list-group-item-action {\r\n      @include hover-focus {\r\n        color: $color;\r\n        background-color: darken($background, 5%);\r\n      }\r\n\r\n      &.active {\r\n        color: $white;\r\n        background-color: $color;\r\n        border-color: $color;\r\n      }\r\n    }\r\n  }\r\n}\r\n",".close {\r\n  float: right;\r\n  font-size: $close-font-size;\r\n  font-weight: $close-font-weight;\r\n  line-height: 1;\r\n  color: $close-color;\r\n  text-shadow: $close-text-shadow;\r\n  opacity: .5;\r\n\r\n  &:not(:disabled):not(.disabled) {\r\n\r\n    @include hover-focus {\r\n      color: $close-color;\r\n      text-decoration: none;\r\n      opacity: .75;\r\n    }\r\n\r\n    // Opinionated: add \"hand\" cursor to non-disabled .close elements\r\n    cursor: pointer;\r\n  }\r\n}\r\n\r\n// Additional properties for button version\r\n// iOS requires the button element instead of an anchor tag.\r\n// If you want the anchor version, it requires `href=\"#\"`.\r\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\r\n\r\n// stylelint-disable property-no-vendor-prefix, selector-no-qualifying-type\r\nbutton.close {\r\n  padding: 0;\r\n  background-color: transparent;\r\n  border: 0;\r\n  -webkit-appearance: none;\r\n}\r\n// stylelint-enable\r\n","// .modal-open      - body class for killing the scroll\r\n// .modal           - container to scroll within\r\n// .modal-dialog    - positioning shell for the actual modal\r\n// .modal-content   - actual modal w/ bg and corners and stuff\r\n\r\n\r\n.modal-open {\r\n  // Kill the scroll on the body\r\n  overflow: hidden;\r\n\r\n  .modal {\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n  }\r\n}\r\n\r\n// Container that the modal scrolls within\r\n.modal {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: $zindex-modal;\r\n  display: none;\r\n  overflow: hidden;\r\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\r\n  // https://github.com/twbs/bootstrap/pull/10951.\r\n  outline: 0;\r\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\r\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\r\n  // See also https://github.com/twbs/bootstrap/issues/17695\r\n}\r\n\r\n// Shell div to position the modal with bottom padding\r\n.modal-dialog {\r\n  position: relative;\r\n  width: auto;\r\n  margin: $modal-dialog-margin;\r\n  // allow clicks to pass through for custom click handling to close modal\r\n  pointer-events: none;\r\n\r\n  // When fading in the modal, animate it to slide down\r\n  .modal.fade & {\r\n    @include transition($modal-transition);\r\n    transform: translate(0, -25%);\r\n  }\r\n  .modal.show & {\r\n    transform: translate(0, 0);\r\n  }\r\n}\r\n\r\n.modal-dialog-centered {\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: calc(100% - (#{$modal-dialog-margin} * 2));\r\n\r\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\r\n  &::before {\r\n    display: block; // IE10\r\n    height: calc(100vh - (#{$modal-dialog-margin} * 2));\r\n    content: \"\";\r\n  }\r\n}\r\n\r\n// Actual modal\r\n.modal-content {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\r\n  // counteract the pointer-events: none; in the .modal-dialog\r\n  pointer-events: auto;\r\n  background-color: $modal-content-bg;\r\n  background-clip: padding-box;\r\n  border: $modal-content-border-width solid $modal-content-border-color;\r\n  @include border-radius($modal-content-border-radius);\r\n  @include box-shadow($modal-content-box-shadow-xs);\r\n  // Remove focus outline from opened modal\r\n  outline: 0;\r\n}\r\n\r\n// Modal background\r\n.modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: $zindex-modal-backdrop;\r\n  background-color: $modal-backdrop-bg;\r\n\r\n  // Fade for backdrop\r\n  &.fade { opacity: 0; }\r\n  &.show { opacity: $modal-backdrop-opacity; }\r\n}\r\n\r\n// Modal header\r\n// Top section of the modal w/ title and dismiss\r\n.modal-header {\r\n  display: flex;\r\n  align-items: flex-start; // so the close btn always stays on the upper right corner\r\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\r\n  padding: $modal-header-padding;\r\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\r\n  @include border-top-radius($modal-content-border-radius);\r\n\r\n  .close {\r\n    padding: $modal-header-padding;\r\n    // auto on the left force icon to the right even when there is no .modal-title\r\n    margin: (-$modal-header-padding) (-$modal-header-padding) (-$modal-header-padding) auto;\r\n  }\r\n}\r\n\r\n// Title text within header\r\n.modal-title {\r\n  margin-bottom: 0;\r\n  line-height: $modal-title-line-height;\r\n}\r\n\r\n// Modal body\r\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\r\n.modal-body {\r\n  position: relative;\r\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\r\n  // when should there be a fixed height on `.modal-dialog`.\r\n  flex: 1 1 auto;\r\n  padding: $modal-inner-padding;\r\n}\r\n\r\n// Footer (for actions)\r\n.modal-footer {\r\n  display: flex;\r\n  align-items: center; // vertically center\r\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\r\n  padding: $modal-inner-padding;\r\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\r\n\r\n  // Easily place margin between footer elements\r\n  > :not(:first-child) { margin-left: .25rem; }\r\n  > :not(:last-child) { margin-right: .25rem; }\r\n}\r\n\r\n// Measure scrollbar width for padding body during modal show/hide\r\n.modal-scrollbar-measure {\r\n  position: absolute;\r\n  top: -9999px;\r\n  width: 50px;\r\n  height: 50px;\r\n  overflow: scroll;\r\n}\r\n\r\n// Scale up the modal\r\n@include media-breakpoint-up(sm) {\r\n  // Automatically set modal's width for larger viewports\r\n  .modal-dialog {\r\n    max-width: $modal-md;\r\n    margin: $modal-dialog-margin-y-sm-up auto;\r\n  }\r\n\r\n  .modal-dialog-centered {\r\n    min-height: calc(100% - (#{$modal-dialog-margin-y-sm-up} * 2));\r\n\r\n    &::before {\r\n      height: calc(100vh - (#{$modal-dialog-margin-y-sm-up} * 2));\r\n    }\r\n\r\n  }\r\n\r\n  .modal-content {\r\n    @include box-shadow($modal-content-box-shadow-sm-up);\r\n  }\r\n\r\n  .modal-sm { max-width: $modal-sm; }\r\n\r\n}\r\n\r\n@include media-breakpoint-up(lg) {\r\n  .modal-lg { max-width: $modal-lg; }\r\n}\r\n","// Base class\r\n.tooltip {\r\n  position: absolute;\r\n  z-index: $zindex-tooltip;\r\n  display: block;\r\n  margin: $tooltip-margin;\r\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\r\n  // So reset our font and text properties to avoid inheriting weird values.\r\n  @include reset-text();\r\n  font-size: $tooltip-font-size;\r\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\r\n  word-wrap: break-word;\r\n  opacity: 0;\r\n\r\n  &.show { opacity: $tooltip-opacity; }\r\n\r\n  .arrow {\r\n    position: absolute;\r\n    display: block;\r\n    width: $tooltip-arrow-width;\r\n    height: $tooltip-arrow-height;\r\n\r\n    &::before {\r\n      position: absolute;\r\n      content: \"\";\r\n      border-color: transparent;\r\n      border-style: solid;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-top {\r\n  padding: $tooltip-arrow-height 0;\r\n\r\n  .arrow {\r\n    bottom: 0;\r\n\r\n    &::before {\r\n      top: 0;\r\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\r\n      border-top-color: $tooltip-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-right {\r\n  padding: 0 $tooltip-arrow-height;\r\n\r\n  .arrow {\r\n    left: 0;\r\n    width: $tooltip-arrow-height;\r\n    height: $tooltip-arrow-width;\r\n\r\n    &::before {\r\n      right: 0;\r\n      border-width: ($tooltip-arrow-width / 2) $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\r\n      border-right-color: $tooltip-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-bottom {\r\n  padding: $tooltip-arrow-height 0;\r\n\r\n  .arrow {\r\n    top: 0;\r\n\r\n    &::before {\r\n      bottom: 0;\r\n      border-width: 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\r\n      border-bottom-color: $tooltip-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-left {\r\n  padding: 0 $tooltip-arrow-height;\r\n\r\n  .arrow {\r\n    right: 0;\r\n    width: $tooltip-arrow-height;\r\n    height: $tooltip-arrow-width;\r\n\r\n    &::before {\r\n      left: 0;\r\n      border-width: ($tooltip-arrow-width / 2) 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\r\n      border-left-color: $tooltip-arrow-color;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-tooltip-auto {\r\n  &[x-placement^=\"top\"] {\r\n    @extend .bs-tooltip-top;\r\n  }\r\n  &[x-placement^=\"right\"] {\r\n    @extend .bs-tooltip-right;\r\n  }\r\n  &[x-placement^=\"bottom\"] {\r\n    @extend .bs-tooltip-bottom;\r\n  }\r\n  &[x-placement^=\"left\"] {\r\n    @extend .bs-tooltip-left;\r\n  }\r\n}\r\n\r\n// Wrapper for the tooltip content\r\n.tooltip-inner {\r\n  max-width: $tooltip-max-width;\r\n  padding: $tooltip-padding-y $tooltip-padding-x;\r\n  color: $tooltip-color;\r\n  text-align: center;\r\n  background-color: $tooltip-bg;\r\n  @include border-radius($tooltip-border-radius);\r\n}\r\n","@mixin reset-text {\r\n  font-family: $font-family-base;\r\n  // We deliberately do NOT reset font-size or word-wrap.\r\n  font-style: normal;\r\n  font-weight: $font-weight-normal;\r\n  line-height: $line-height-base;\r\n  text-align: left; // Fallback for where `start` is not supported\r\n  text-align: start; // stylelint-disable-line declaration-block-no-duplicate-properties\r\n  text-decoration: none;\r\n  text-shadow: none;\r\n  text-transform: none;\r\n  letter-spacing: normal;\r\n  word-break: normal;\r\n  word-spacing: normal;\r\n  white-space: normal;\r\n  line-break: auto;\r\n}\r\n",".popover {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: $zindex-popover;\r\n  display: block;\r\n  max-width: $popover-max-width;\r\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\r\n  // So reset our font and text properties to avoid inheriting weird values.\r\n  @include reset-text();\r\n  font-size: $popover-font-size;\r\n  // Allow breaking very long words so they don't overflow the popover's bounds\r\n  word-wrap: break-word;\r\n  background-color: $popover-bg;\r\n  background-clip: padding-box;\r\n  border: $popover-border-width solid $popover-border-color;\r\n  @include border-radius($popover-border-radius);\r\n  @include box-shadow($popover-box-shadow);\r\n\r\n  .arrow {\r\n    position: absolute;\r\n    display: block;\r\n    width: $popover-arrow-width;\r\n    height: $popover-arrow-height;\r\n    margin: 0 $border-radius-lg;\r\n\r\n    &::before,\r\n    &::after {\r\n      position: absolute;\r\n      display: block;\r\n      content: \"\";\r\n      border-color: transparent;\r\n      border-style: solid;\r\n    }\r\n  }\r\n}\r\n\r\n.bs-popover-top {\r\n  margin-bottom: $popover-arrow-height;\r\n\r\n  .arrow {\r\n    bottom: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\r\n  }\r\n\r\n  .arrow::before,\r\n  .arrow::after {\r\n    border-width: $popover-arrow-height ($popover-arrow-width / 2) 0;\r\n  }\r\n\r\n  .arrow::before {\r\n    bottom: 0;\r\n    border-top-color: $popover-arrow-outer-color;\r\n  }\r\n\r\n  .arrow::after {\r\n    bottom: $popover-border-width;\r\n    border-top-color: $popover-arrow-color;\r\n  }\r\n}\r\n\r\n.bs-popover-right {\r\n  margin-left: $popover-arrow-height;\r\n\r\n  .arrow {\r\n    left: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\r\n    width: $popover-arrow-height;\r\n    height: $popover-arrow-width;\r\n    margin: $border-radius-lg 0; // make sure the arrow does not touch the popover's rounded corners\r\n  }\r\n\r\n  .arrow::before,\r\n  .arrow::after {\r\n    border-width: ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2) 0;\r\n  }\r\n\r\n  .arrow::before {\r\n    left: 0;\r\n    border-right-color: $popover-arrow-outer-color;\r\n  }\r\n\r\n  .arrow::after {\r\n    left: $popover-border-width;\r\n    border-right-color: $popover-arrow-color;\r\n  }\r\n}\r\n\r\n.bs-popover-bottom {\r\n  margin-top: $popover-arrow-height;\r\n\r\n  .arrow {\r\n    top: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\r\n  }\r\n\r\n  .arrow::before,\r\n  .arrow::after {\r\n    border-width: 0 ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2);\r\n  }\r\n\r\n  .arrow::before {\r\n    top: 0;\r\n    border-bottom-color: $popover-arrow-outer-color;\r\n  }\r\n\r\n  .arrow::after {\r\n    top: $popover-border-width;\r\n    border-bottom-color: $popover-arrow-color;\r\n  }\r\n\r\n  // This will remove the popover-header's border just below the arrow\r\n  .popover-header::before {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 50%;\r\n    display: block;\r\n    width: $popover-arrow-width;\r\n    margin-left: ($popover-arrow-width / -2);\r\n    content: \"\";\r\n    border-bottom: $popover-border-width solid $popover-header-bg;\r\n  }\r\n}\r\n\r\n.bs-popover-left {\r\n  margin-right: $popover-arrow-height;\r\n\r\n  .arrow {\r\n    right: calc((#{$popover-arrow-height} + #{$popover-border-width}) * -1);\r\n    width: $popover-arrow-height;\r\n    height: $popover-arrow-width;\r\n    margin: $border-radius-lg 0; // make sure the arrow does not touch the popover's rounded corners\r\n  }\r\n\r\n  .arrow::before,\r\n  .arrow::after {\r\n    border-width: ($popover-arrow-width / 2) 0 ($popover-arrow-width / 2) $popover-arrow-height;\r\n  }\r\n\r\n  .arrow::before {\r\n    right: 0;\r\n    border-left-color: $popover-arrow-outer-color;\r\n  }\r\n\r\n  .arrow::after {\r\n    right: $popover-border-width;\r\n    border-left-color: $popover-arrow-color;\r\n  }\r\n}\r\n\r\n.bs-popover-auto {\r\n  &[x-placement^=\"top\"] {\r\n    @extend .bs-popover-top;\r\n  }\r\n  &[x-placement^=\"right\"] {\r\n    @extend .bs-popover-right;\r\n  }\r\n  &[x-placement^=\"bottom\"] {\r\n    @extend .bs-popover-bottom;\r\n  }\r\n  &[x-placement^=\"left\"] {\r\n    @extend .bs-popover-left;\r\n  }\r\n}\r\n\r\n\r\n// Offset the popover to account for the popover arrow\r\n.popover-header {\r\n  padding: $popover-header-padding-y $popover-header-padding-x;\r\n  margin-bottom: 0; // Reset the default from Reboot\r\n  font-size: $font-size-base;\r\n  color: $popover-header-color;\r\n  background-color: $popover-header-bg;\r\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\r\n  $offset-border-width: calc(#{$border-radius-lg} - #{$popover-border-width});\r\n  @include border-top-radius($offset-border-width);\r\n\r\n  &:empty {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.popover-body {\r\n  padding: $popover-body-padding-y $popover-body-padding-x;\r\n  color: $popover-body-color;\r\n}\r\n","// Notes on the classes:\r\n//\r\n// 1. The .carousel-item-left and .carousel-item-right is used to indicate where\r\n//    the active slide is heading.\r\n// 2. .active.carousel-item is the current slide.\r\n// 3. .active.carousel-item-left and .active.carousel-item-right is the current\r\n//    slide in its in-transition state. Only one of these occurs at a time.\r\n// 4. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\r\n//    is the upcoming slide in transition.\r\n\r\n.carousel {\r\n  position: relative;\r\n}\r\n\r\n.carousel-inner {\r\n  position: relative;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.carousel-item {\r\n  position: relative;\r\n  display: none;\r\n  align-items: center;\r\n  width: 100%;\r\n  backface-visibility: hidden;\r\n  perspective: 1000px;\r\n}\r\n\r\n.carousel-item.active,\r\n.carousel-item-next,\r\n.carousel-item-prev {\r\n  display: block;\r\n  @include transition($carousel-transition);\r\n}\r\n\r\n.carousel-item-next,\r\n.carousel-item-prev {\r\n  position: absolute;\r\n  top: 0;\r\n}\r\n\r\n.carousel-item-next.carousel-item-left,\r\n.carousel-item-prev.carousel-item-right {\r\n  transform: translateX(0);\r\n\r\n  @supports (transform-style: preserve-3d) {\r\n    transform: translate3d(0, 0, 0);\r\n  }\r\n}\r\n\r\n.carousel-item-next,\r\n.active.carousel-item-right {\r\n  transform: translateX(100%);\r\n\r\n  @supports (transform-style: preserve-3d) {\r\n    transform: translate3d(100%, 0, 0);\r\n  }\r\n}\r\n\r\n.carousel-item-prev,\r\n.active.carousel-item-left {\r\n  transform: translateX(-100%);\r\n\r\n  @supports (transform-style: preserve-3d) {\r\n    transform: translate3d(-100%, 0, 0);\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Alternate transitions\r\n//\r\n\r\n.carousel-fade {\r\n  .carousel-item {\r\n    opacity: 0;\r\n    transition-duration: .6s;\r\n    transition-property: opacity;\r\n  }\r\n\r\n  .carousel-item.active,\r\n  .carousel-item-next.carousel-item-left,\r\n  .carousel-item-prev.carousel-item-right {\r\n    opacity: 1;\r\n  }\r\n\r\n  .active.carousel-item-left,\r\n  .active.carousel-item-right {\r\n    opacity: 0;\r\n  }\r\n\r\n  .carousel-item-next,\r\n  .carousel-item-prev,\r\n  .carousel-item.active,\r\n  .active.carousel-item-left,\r\n  .active.carousel-item-prev {\r\n    transform: translateX(0);\r\n\r\n    @supports (transform-style: preserve-3d) {\r\n      transform: translate3d(0, 0, 0);\r\n    }\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Left/right controls for nav\r\n//\r\n\r\n.carousel-control-prev,\r\n.carousel-control-next {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  // Use flex for alignment (1-3)\r\n  display: flex; // 1. allow flex styles\r\n  align-items: center; // 2. vertically center contents\r\n  justify-content: center; // 3. horizontally center contents\r\n  width: $carousel-control-width;\r\n  color: $carousel-control-color;\r\n  text-align: center;\r\n  opacity: $carousel-control-opacity;\r\n  // We can't have a transition here because WebKit cancels the carousel\r\n  // animation if you trip this while in the middle of another animation.\r\n\r\n  // Hover/focus state\r\n  @include hover-focus {\r\n    color: $carousel-control-color;\r\n    text-decoration: none;\r\n    outline: 0;\r\n    opacity: .9;\r\n  }\r\n}\r\n.carousel-control-prev {\r\n  left: 0;\r\n  @if $enable-gradients {\r\n    background: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\r\n  }\r\n}\r\n.carousel-control-next {\r\n  right: 0;\r\n  @if $enable-gradients {\r\n    background: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\r\n  }\r\n}\r\n\r\n// Icons for within\r\n.carousel-control-prev-icon,\r\n.carousel-control-next-icon {\r\n  display: inline-block;\r\n  width: $carousel-control-icon-width;\r\n  height: $carousel-control-icon-width;\r\n  background: transparent no-repeat center center;\r\n  background-size: 100% 100%;\r\n}\r\n.carousel-control-prev-icon {\r\n  background-image: $carousel-control-prev-icon-bg;\r\n}\r\n.carousel-control-next-icon {\r\n  background-image: $carousel-control-next-icon-bg;\r\n}\r\n\r\n\r\n// Optional indicator pips\r\n//\r\n// Add an ordered list with the following class and add a list item for each\r\n// slide your carousel holds.\r\n\r\n.carousel-indicators {\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 10px;\r\n  left: 0;\r\n  z-index: 15;\r\n  display: flex;\r\n  justify-content: center;\r\n  padding-left: 0; // override <ol> default\r\n  // Use the .carousel-control's width as margin so we don't overlay those\r\n  margin-right: $carousel-control-width;\r\n  margin-left: $carousel-control-width;\r\n  list-style: none;\r\n\r\n  li {\r\n    position: relative;\r\n    flex: 0 1 auto;\r\n    width: $carousel-indicator-width;\r\n    height: $carousel-indicator-height;\r\n    margin-right: $carousel-indicator-spacer;\r\n    margin-left: $carousel-indicator-spacer;\r\n    text-indent: -999px;\r\n    cursor: pointer;\r\n    background-color: rgba($carousel-indicator-active-bg, .5);\r\n\r\n    // Use pseudo classes to increase the hit area by 10px on top and bottom.\r\n    &::before {\r\n      position: absolute;\r\n      top: -10px;\r\n      left: 0;\r\n      display: inline-block;\r\n      width: 100%;\r\n      height: 10px;\r\n      content: \"\";\r\n    }\r\n    &::after {\r\n      position: absolute;\r\n      bottom: -10px;\r\n      left: 0;\r\n      display: inline-block;\r\n      width: 100%;\r\n      height: 10px;\r\n      content: \"\";\r\n    }\r\n  }\r\n\r\n  .active {\r\n    background-color: $carousel-indicator-active-bg;\r\n  }\r\n}\r\n\r\n\r\n// Optional captions\r\n//\r\n//\r\n\r\n.carousel-caption {\r\n  position: absolute;\r\n  right: ((100% - $carousel-caption-width) / 2);\r\n  bottom: 20px;\r\n  left: ((100% - $carousel-caption-width) / 2);\r\n  z-index: 10;\r\n  padding-top: 20px;\r\n  padding-bottom: 20px;\r\n  color: $carousel-caption-color;\r\n  text-align: center;\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n.align-baseline    { vertical-align: baseline !important; } // Browser default\r\n.align-top         { vertical-align: top !important; }\r\n.align-middle      { vertical-align: middle !important; }\r\n.align-bottom      { vertical-align: bottom !important; }\r\n.align-text-bottom { vertical-align: text-bottom !important; }\r\n.align-text-top    { vertical-align: text-top !important; }\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Contextual backgrounds\r\n\r\n@mixin bg-variant($parent, $color) {\r\n  #{$parent} {\r\n    background-color: $color !important;\r\n  }\r\n  a#{$parent},\r\n  button#{$parent} {\r\n    @include hover-focus {\r\n      background-color: darken($color, 10%) !important;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin bg-gradient-variant($parent, $color) {\r\n  #{$parent} {\r\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n@each $color, $value in $theme-colors {\r\n  @include bg-variant(\".bg-#{$color}\", $value);\r\n}\r\n\r\n@if $enable-gradients {\r\n  @each $color, $value in $theme-colors {\r\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\r\n  }\r\n}\r\n\r\n.bg-white {\r\n  background-color: $white !important;\r\n}\r\n\r\n.bg-transparent {\r\n  background-color: transparent !important;\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n//\r\n// Border\r\n//\r\n\r\n.border         { border: $border-width solid $border-color !important; }\r\n.border-top     { border-top: $border-width solid $border-color !important; }\r\n.border-right   { border-right: $border-width solid $border-color !important; }\r\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\r\n.border-left    { border-left: $border-width solid $border-color !important; }\r\n\r\n.border-0        { border: 0 !important; }\r\n.border-top-0    { border-top: 0 !important; }\r\n.border-right-0  { border-right: 0 !important; }\r\n.border-bottom-0 { border-bottom: 0 !important; }\r\n.border-left-0   { border-left: 0 !important; }\r\n\r\n@each $color, $value in $theme-colors {\r\n  .border-#{$color} {\r\n    border-color: $value !important;\r\n  }\r\n}\r\n\r\n.border-white {\r\n  border-color: $white !important;\r\n}\r\n\r\n//\r\n// Border-radius\r\n//\r\n\r\n.rounded {\r\n  border-radius: $border-radius !important;\r\n}\r\n.rounded-top {\r\n  border-top-left-radius: $border-radius !important;\r\n  border-top-right-radius: $border-radius !important;\r\n}\r\n.rounded-right {\r\n  border-top-right-radius: $border-radius !important;\r\n  border-bottom-right-radius: $border-radius !important;\r\n}\r\n.rounded-bottom {\r\n  border-bottom-right-radius: $border-radius !important;\r\n  border-bottom-left-radius: $border-radius !important;\r\n}\r\n.rounded-left {\r\n  border-top-left-radius: $border-radius !important;\r\n  border-bottom-left-radius: $border-radius !important;\r\n}\r\n\r\n.rounded-circle {\r\n  border-radius: 50% !important;\r\n}\r\n\r\n.rounded-0 {\r\n  border-radius: 0 !important;\r\n}\r\n","@mixin clearfix() {\r\n  &::after {\r\n    display: block;\r\n    clear: both;\r\n    content: \"\";\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n//\r\n// Utilities for common `display` values\r\n//\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    .d#{$infix}-none         { display: none !important; }\r\n    .d#{$infix}-inline       { display: inline !important; }\r\n    .d#{$infix}-inline-block { display: inline-block !important; }\r\n    .d#{$infix}-block        { display: block !important; }\r\n    .d#{$infix}-table        { display: table !important; }\r\n    .d#{$infix}-table-row    { display: table-row !important; }\r\n    .d#{$infix}-table-cell   { display: table-cell !important; }\r\n    .d#{$infix}-flex         { display: flex !important; }\r\n    .d#{$infix}-inline-flex  { display: inline-flex !important; }\r\n  }\r\n}\r\n\r\n\r\n//\r\n// Utilities for toggling `display` in print\r\n//\r\n\r\n@media print {\r\n  .d-print-none         { display: none !important; }\r\n  .d-print-inline       { display: inline !important; }\r\n  .d-print-inline-block { display: inline-block !important; }\r\n  .d-print-block        { display: block !important; }\r\n  .d-print-table        { display: table !important; }\r\n  .d-print-table-row    { display: table-row !important; }\r\n  .d-print-table-cell   { display: table-cell !important; }\r\n  .d-print-flex         { display: flex !important; }\r\n  .d-print-inline-flex  { display: inline-flex !important; }\r\n}\r\n","// Credit: Nicolas Gallagher and SUIT CSS.\r\n\r\n.embed-responsive {\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0;\r\n  overflow: hidden;\r\n\r\n  &::before {\r\n    display: block;\r\n    content: \"\";\r\n  }\r\n\r\n  .embed-responsive-item,\r\n  iframe,\r\n  embed,\r\n  object,\r\n  video {\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    border: 0;\r\n  }\r\n}\r\n\r\n.embed-responsive-21by9 {\r\n  &::before {\r\n    padding-top: percentage(9 / 21);\r\n  }\r\n}\r\n\r\n.embed-responsive-16by9 {\r\n  &::before {\r\n    padding-top: percentage(9 / 16);\r\n  }\r\n}\r\n\r\n.embed-responsive-4by3 {\r\n  &::before {\r\n    padding-top: percentage(3 / 4);\r\n  }\r\n}\r\n\r\n.embed-responsive-1by1 {\r\n  &::before {\r\n    padding-top: percentage(1 / 1);\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Flex variation\r\n//\r\n// Custom styles for additional flex alignment options.\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    .flex#{$infix}-row            { flex-direction: row !important; }\r\n    .flex#{$infix}-column         { flex-direction: column !important; }\r\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\r\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\r\n\r\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\r\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\r\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\r\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\r\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\r\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\r\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\r\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\r\n\r\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\r\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\r\n    .justify-content#{$infix}-center  { justify-content: center !important; }\r\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\r\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\r\n\r\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\r\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\r\n    .align-items#{$infix}-center   { align-items: center !important; }\r\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\r\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\r\n\r\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\r\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\r\n    .align-content#{$infix}-center  { align-content: center !important; }\r\n    .align-content#{$infix}-between { align-content: space-between !important; }\r\n    .align-content#{$infix}-around  { align-content: space-around !important; }\r\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\r\n\r\n    .align-self#{$infix}-auto     { align-self: auto !important; }\r\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\r\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\r\n    .align-self#{$infix}-center   { align-self: center !important; }\r\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\r\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\r\n  }\r\n}\r\n","@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    .float#{$infix}-left  { @include float-left; }\r\n    .float#{$infix}-right { @include float-right; }\r\n    .float#{$infix}-none  { @include float-none; }\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n@mixin float-left {\r\n  float: left !important;\r\n}\r\n@mixin float-right {\r\n  float: right !important;\r\n}\r\n@mixin float-none {\r\n  float: none !important;\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Common values\r\n\r\n// Sass list not in variables since it's not intended for customization.\r\n// stylelint-disable-next-line scss/dollar-variable-default\r\n$positions: static, relative, absolute, fixed, sticky;\r\n\r\n@each $position in $positions {\r\n  .position-#{$position} { position: $position !important; }\r\n}\r\n\r\n// Shorthand\r\n\r\n.fixed-top {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  z-index: $zindex-fixed;\r\n}\r\n\r\n.fixed-bottom {\r\n  position: fixed;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: $zindex-fixed;\r\n}\r\n\r\n.sticky-top {\r\n  @supports (position: sticky) {\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: $zindex-sticky;\r\n  }\r\n}\r\n","//\r\n// Screenreaders\r\n//\r\n\r\n.sr-only {\r\n  @include sr-only();\r\n}\r\n\r\n.sr-only-focusable {\r\n  @include sr-only-focusable();\r\n}\r\n","// Only display content to screen readers\r\n//\r\n// See: https://a11yproject.com/posts/how-to-hide-content/\r\n// See: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\r\n\r\n@mixin sr-only {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n  border: 0;\r\n}\r\n\r\n// Use in conjunction with .sr-only to only display content when it's focused.\r\n//\r\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\r\n//\r\n// Credit: HTML5 Boilerplate\r\n\r\n@mixin sr-only-focusable {\r\n  &:active,\r\n  &:focus {\r\n    position: static;\r\n    width: auto;\r\n    height: auto;\r\n    overflow: visible;\r\n    clip: auto;\r\n    white-space: normal;\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\r\n.shadow { box-shadow: $box-shadow !important; }\r\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\r\n.shadow-none { box-shadow: none !important; }\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Width and height\r\n\r\n@each $prop, $abbrev in (width: w, height: h) {\r\n  @each $size, $length in $sizes {\r\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\r\n  }\r\n}\r\n\r\n.mw-100 { max-width: 100% !important; }\r\n.mh-100 { max-height: 100% !important; }\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Margin and Padding\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    @each $prop, $abbrev in (margin: m, padding: p) {\r\n      @each $size, $length in $spacers {\r\n\r\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\r\n        .#{$abbrev}t#{$infix}-#{$size},\r\n        .#{$abbrev}y#{$infix}-#{$size} {\r\n          #{$prop}-top: $length !important;\r\n        }\r\n        .#{$abbrev}r#{$infix}-#{$size},\r\n        .#{$abbrev}x#{$infix}-#{$size} {\r\n          #{$prop}-right: $length !important;\r\n        }\r\n        .#{$abbrev}b#{$infix}-#{$size},\r\n        .#{$abbrev}y#{$infix}-#{$size} {\r\n          #{$prop}-bottom: $length !important;\r\n        }\r\n        .#{$abbrev}l#{$infix}-#{$size},\r\n        .#{$abbrev}x#{$infix}-#{$size} {\r\n          #{$prop}-left: $length !important;\r\n        }\r\n      }\r\n    }\r\n\r\n    // Some special margin utils\r\n    .m#{$infix}-auto { margin: auto !important; }\r\n    .mt#{$infix}-auto,\r\n    .my#{$infix}-auto {\r\n      margin-top: auto !important;\r\n    }\r\n    .mr#{$infix}-auto,\r\n    .mx#{$infix}-auto {\r\n      margin-right: auto !important;\r\n    }\r\n    .mb#{$infix}-auto,\r\n    .my#{$infix}-auto {\r\n      margin-bottom: auto !important;\r\n    }\r\n    .ml#{$infix}-auto,\r\n    .mx#{$infix}-auto {\r\n      margin-left: auto !important;\r\n    }\r\n  }\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n//\r\n// Text\r\n//\r\n\r\n.text-monospace { font-family: $font-family-monospace; }\r\n\r\n// Alignment\r\n\r\n.text-justify  { text-align: justify !important; }\r\n.text-nowrap   { white-space: nowrap !important; }\r\n.text-truncate { @include text-truncate; }\r\n\r\n// Responsive alignment\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n  @include media-breakpoint-up($breakpoint) {\r\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n    .text#{$infix}-left   { text-align: left !important; }\r\n    .text#{$infix}-right  { text-align: right !important; }\r\n    .text#{$infix}-center { text-align: center !important; }\r\n  }\r\n}\r\n\r\n// Transformation\r\n\r\n.text-lowercase  { text-transform: lowercase !important; }\r\n.text-uppercase  { text-transform: uppercase !important; }\r\n.text-capitalize { text-transform: capitalize !important; }\r\n\r\n// Weight and italics\r\n\r\n.font-weight-light  { font-weight: $font-weight-light !important; }\r\n.font-weight-normal { font-weight: $font-weight-normal !important; }\r\n.font-weight-bold   { font-weight: $font-weight-bold !important; }\r\n.font-italic        { font-style: italic !important; }\r\n\r\n// Contextual colors\r\n\r\n.text-white { color: $white !important; }\r\n\r\n@each $color, $value in $theme-colors {\r\n  @include text-emphasis-variant(\".text-#{$color}\", $value);\r\n}\r\n\r\n.text-body { color: $body-color !important; }\r\n.text-muted { color: $text-muted !important; }\r\n\r\n.text-black-50 { color: rgba($black, .5) !important; }\r\n.text-white-50 { color: rgba($white, .5) !important; }\r\n\r\n// Misc\r\n\r\n.text-hide {\r\n  @include text-hide($ignore-warning: true);\r\n}\r\n","// Text truncate\r\n// Requires inline-block or block for proper styling\r\n\r\n@mixin text-truncate() {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Typography\r\n\r\n@mixin text-emphasis-variant($parent, $color) {\r\n  #{$parent} {\r\n    color: $color !important;\r\n  }\r\n  a#{$parent} {\r\n    @include hover-focus {\r\n      color: darken($color, 10%) !important;\r\n    }\r\n  }\r\n}\r\n","// CSS image replacement\r\n@mixin text-hide($ignore-warning: false) {\r\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\r\n  font: 0/0 a;\r\n  color: transparent;\r\n  text-shadow: none;\r\n  background-color: transparent;\r\n  border: 0;\r\n\r\n  @if ($ignore-warning != true) {\r\n    @warn \"The `text-hide()` mixin has been deprecated as of v4.1.0. It will be removed entirely in v5.\";\r\n  }\r\n}\r\n","//\r\n// Visibility utilities\r\n//\r\n\r\n.visible {\r\n  @include invisible(visible);\r\n}\r\n\r\n.invisible {\r\n  @include invisible(hidden);\r\n}\r\n","// stylelint-disable declaration-no-important\r\n\r\n// Visibility\r\n\r\n@mixin invisible($visibility) {\r\n  visibility: $visibility !important;\r\n}\r\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\r\n\r\n// Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css\r\n\r\n// ==========================================================================\r\n// Print styles.\r\n// Inlined to avoid the additional HTTP request:\r\n// https://www.phpied.com/delay-loading-your-print-css/\r\n// ==========================================================================\r\n\r\n@if $enable-print-styles {\r\n  @media print {\r\n    *,\r\n    *::before,\r\n    *::after {\r\n      // Bootstrap specific; comment out `color` and `background`\r\n      //color: $black !important; // Black prints faster\r\n      text-shadow: none !important;\r\n      //background: transparent !important;\r\n      box-shadow: none !important;\r\n    }\r\n\r\n    a {\r\n      &:not(.btn) {\r\n        text-decoration: underline;\r\n      }\r\n    }\r\n\r\n    // Bootstrap specific; comment the following selector out\r\n    //a[href]::after {\r\n    //  content: \" (\" attr(href) \")\";\r\n    //}\r\n\r\n    abbr[title]::after {\r\n      content: \" (\" attr(title) \")\";\r\n    }\r\n\r\n    // Bootstrap specific; comment the following selector out\r\n    //\r\n    // Don't show links that are fragment identifiers,\r\n    // or use the `javascript:` pseudo protocol\r\n    //\r\n\r\n    //a[href^=\"#\"]::after,\r\n    //a[href^=\"javascript:\"]::after {\r\n    // content: \"\";\r\n    //}\r\n\r\n    pre {\r\n      white-space: pre-wrap !important;\r\n    }\r\n    pre,\r\n    blockquote {\r\n      border: $border-width solid $gray-500;   // Bootstrap custom code; using `$border-width` instead of 1px\r\n      page-break-inside: avoid;\r\n    }\r\n\r\n    //\r\n    // Printing Tables:\r\n    // http://css-discuss.incutio.com/wiki/Printing_Tables\r\n    //\r\n\r\n    thead {\r\n      display: table-header-group;\r\n    }\r\n\r\n    tr,\r\n    img {\r\n      page-break-inside: avoid;\r\n    }\r\n\r\n    p,\r\n    h2,\r\n    h3 {\r\n      orphans: 3;\r\n      widows: 3;\r\n    }\r\n\r\n    h2,\r\n    h3 {\r\n      page-break-after: avoid;\r\n    }\r\n\r\n    // Bootstrap specific changes start\r\n\r\n    // Specify a size and min-width to make printing closer across browsers.\r\n    // We don't set margin here because it breaks `size` in Chrome. We also\r\n    // don't use `!important` on `size` as it breaks in Chrome.\r\n    @page {\r\n      size: $print-page-size;\r\n    }\r\n    body {\r\n      min-width: $print-body-min-width !important;\r\n    }\r\n    .container {\r\n      min-width: $print-body-min-width !important;\r\n    }\r\n\r\n    // Bootstrap components\r\n    .navbar {\r\n      display: none;\r\n    }\r\n    .badge {\r\n      border: $border-width solid $black;\r\n    }\r\n\r\n    .table {\r\n      border-collapse: collapse !important;\r\n\r\n      td,\r\n      th {\r\n        background-color: $white !important;\r\n      }\r\n    }\r\n\r\n    .table-bordered {\r\n      th,\r\n      td {\r\n        border: 1px solid $gray-300 !important;\r\n      }\r\n    }\r\n\r\n    .table-dark {\r\n      color: inherit;\r\n\r\n      th,\r\n      td,\r\n      thead th,\r\n      tbody + tbody {\r\n        border-color: $table-border-color;\r\n      }\r\n    }\r\n\r\n    .table .thead-dark th {\r\n      color: inherit;\r\n      border-color: $table-border-color;\r\n    }\r\n\r\n    // Bootstrap specific changes end\r\n  }\r\n}\r\n",".alert{\r\n    border: 0;\r\n    color: $white;\r\n\r\n    .alert-link{\r\n      color: $white;\r\n    }\r\n\r\n    &.alert-success{\r\n      background-color: darken($success, 10%);\r\n    }\r\n\r\n    i.fa,\r\n    i.tim-icons{\r\n        font-size: $font-paragraph;\r\n    }\r\n\r\n    .close{\r\n        color: $white;\r\n        opacity: .9;\r\n        text-shadow: none;\r\n        line-height: 0;\r\n        outline: 0;\r\n        &::after{\r\n          display: inline-block;\r\n          font: normal normal normal 1em/1 'Nucleo';\r\n          vertical-align: middle;\r\n          speak: none;\r\n          text-transform: none;\r\n          -webkit-font-smoothing: antialiased;\r\n          font-size: 1rem;\r\n          content: \"\\ea48\"\r\n        }\r\n        span {\r\n          display: none !important;\r\n        }\r\n    }\r\n\r\n    span[data-notify=\"icon\"]{\r\n      font-size: 22px;\r\n      display: block;\r\n      left: 19px;\r\n      position: absolute;\r\n      top: 50%;\r\n      margin-top: -11px;\r\n    }\r\n\r\n    button.close{\r\n      position: absolute;\r\n      right: 15px;\r\n      top: 50%;\r\n      margin-top: -13px;\r\n      width: 25px;\r\n      height: 25px;\r\n      padding: 3px;\r\n    }\r\n\r\n    .close ~ span{\r\n        display: block;\r\n        max-width: 89%;\r\n    }\r\n\r\n    &.alert-with-icon{\r\n        padding-left: 65px;\r\n    }\r\n}\r\n\r\n.alert-dismissible {\r\n    padding-right: 1.25rem;\r\n    .close {\r\n\r\n        &:hover,\r\n        &:focus {\r\n            color: rgba($white, .9);\r\n            opacity: 1 !important;\r\n        }\r\n\r\n        @include media-breakpoint-down(xs) {\r\n            top: 1rem;\r\n            right: .5rem;\r\n        }\r\n\r\n        &>span:not(.sr-only) {\r\n            font-size: 1.5rem;\r\n            background-color: transparent;\r\n            color: rgba($white, .6);\r\n        }\r\n\r\n        &:hover,\r\n        &:focus {\r\n            &>span:not(.sr-only) {\r\n                background-color: transparent;\r\n                color: rgba($white, .9);\r\n            }\r\n        }\r\n    }\r\n    &.animated {\r\n      z-index: 9999;\r\n      .close {\r\n        right: 10px;\r\n      }\r\n    }\r\n}\r\n",".badge + .badge {\r\n  margin-left: 5px;\r\n}\r\n",".btn,\r\n.navbar .navbar-nav > a.btn{\r\n    border-width: $border-thick;\r\n    border: none;\r\n    position: relative;\r\n    overflow: hidden;\r\n    margin:4px 1px;\r\n    border-radius: $border-radius-lg;\r\n    cursor: pointer;\r\n\r\n    @include btn-styles($default, $default-states);\r\n\r\n    &:hover,\r\n    &:focus{\r\n        @include opacity(1);\r\n        outline: 0 !important;\r\n    }\r\n    &:active,\r\n    &.active,\r\n    .open > &.dropdown-toggle {\r\n         @include box-shadow(none);\r\n         outline: 0 !important;\r\n    }\r\n\r\n    .badge{\r\n      margin: 0;\r\n    }\r\n\r\n    &.btn-icon {\r\n        // see above for color variations\r\n        height: $icon-size-regular;\r\n        min-width: $icon-size-regular;\r\n        width: $icon-size-regular;\r\n        padding: 0;\r\n        font-size: $icon-font-size-regular;\r\n        overflow: hidden;\r\n        position: relative;\r\n        line-height: normal;\r\n\r\n        &.btn-simple{\r\n            padding: 0;\r\n        }\r\n\r\n        &.btn-sm{\r\n            height: $icon-size-sm;\r\n            min-width: $icon-size-sm;\r\n            width: $icon-size-sm;\r\n\r\n            .fa,\r\n            .far,\r\n            .fas,\r\n            .tim-icons{\r\n                font-size: $icon-font-size-sm;\r\n            }\r\n        }\r\n\r\n        &.btn-lg{\r\n            height: $icon-size-lg;\r\n            min-width: $icon-size-lg;\r\n            width: $icon-size-lg;\r\n\r\n            .fa,\r\n            .far,\r\n            .fas,\r\n            .tim-icons{\r\n                font-size: $icon-font-size-lg;\r\n            }\r\n        }\r\n\r\n        &:not(.btn-footer) .tim-icons,\r\n        &:not(.btn-footer) .fa,\r\n        &:not(.btn-footer) .far,\r\n        &:not(.btn-footer) .fas{\r\n            position: absolute;\r\n            font-size: 1em;\r\n            top: 50%;\r\n            left: 50%;\r\n            transform: translate(-12px, -12px);\r\n            line-height: 1.5626rem;\r\n            width: 24px;\r\n        }\r\n\r\n    }\r\n\r\n    &:not(.btn-icon) .tim-icons{\r\n        position: relative;\r\n        top: 1px;\r\n    }\r\n\r\n    span{\r\n      position: relative;\r\n      display: block;\r\n    }\r\n\r\n  &.btn-link.dropdown-toggle {\r\n    color: $dark-gray;\r\n  }\r\n\r\n  &.dropdown-toggle:after {\r\n    margin-left: 30px !important;\r\n  }\r\n}\r\n\r\n// Apply the mixin to the buttons\r\n// .btn-default { @include btn-styles($default-color, $default-states-color); }\r\n.btn-primary { @include btn-styles($primary, $primary-states);\r\n\r\n              }\r\n.btn-success { @include btn-styles($success, $success-states);\r\n\r\n              }\r\n.btn-info    { @include btn-styles($info, $info-states);\r\n\r\n              }\r\n.btn-warning { @include btn-styles($warning, $warning-states);\r\n                &:not(:disabled):not(.disabled):active{\r\n                  color: $white;\r\n                }\r\n              }\r\n.btn-danger  { @include btn-styles($danger, $danger-states);\r\n\r\n              }\r\n.btn-neutral { @include btn-styles($white, $white); }\r\n\r\n.btn{\r\n     &:disabled,\r\n     &[disabled],\r\n     &.disabled{\r\n        @include opacity(.5);\r\n        pointer-events: none;\r\n    }\r\n}\r\n.btn-simple{\r\n    border: $border;\r\n    border-color: $default;\r\n    box-shadow: none;\r\n    padding: $padding-btn-vertical - 1 $padding-round-horizontal - 1;\r\n    background-color: $transparent-bg;\r\n}\r\n\r\n.btn-simple,\r\n.btn-link{\r\n    &.disabled,\r\n    &:disabled,\r\n    &[disabled],\r\n    fieldset[disabled] & {\r\n        &,\r\n        &:hover,\r\n        &:focus,\r\n        &.focus,\r\n        &:active,\r\n        &.active {\r\n            background: $transparent-bg;\r\n        }\r\n    }\r\n}\r\n\r\n.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active{\r\n  box-shadow: 2px 2px 6px rgba(0,0,0,.4);\r\n}\r\n.btn-link{\r\n    border: $none;\r\n    box-shadow: none;\r\n    padding: $padding-base-vertical $padding-base-horizontal;\r\n    background: $transparent-bg;\r\n    color: $gray-300;\r\n    font-weight: $font-weight-bold;\r\n\r\n  &:hover {\r\n    box-shadow: none !important;\r\n    transform: none !important;\r\n  }\r\n}\r\n\r\n.btn-lg{\r\n   @include btn-size($btn-padding-y-lg, $btn-padding-x-lg, $font-size-base, $border-radius-lg);\r\n}\r\n.btn-sm{\r\n    @include btn-size($btn-padding-y-sm, $btn-padding-x-sm, $font-size-base, $border-radius-sm);\r\n}\r\n\r\n.btn-wd {\r\n    min-width: 140px;\r\n}\r\n.btn-group.select{\r\n    width: 100%;\r\n}\r\n\r\n.btn-group {\r\n  .btn.active {\r\n    box-shadow: 2px 2px 6px rgba(0,0,0,.4);\r\n    transform: translateY(-1px);\r\n    -webkit-transform: translateY(-1px);\r\n  }\r\n}\r\n\r\n\r\n.btn-group.select .btn{\r\n    text-align: left;\r\n}\r\n.btn-group.select .caret{\r\n    position: absolute;\r\n    top: 50%;\r\n    margin-top: -1px;\r\n    right: 8px;\r\n}\r\n\r\n.btn-group .btn.active {\r\n    box-shadow: 2px 2px 6px rgba(0,0,0,.4);\r\n    transform: translateY(-1px);\r\n    -webkit-transform: translateY(-1px);\r\n}\r\n\r\n.btn-round{\r\n    border-width: $border-thin;\r\n    border-radius: $btn-round-radius;\r\n\r\n    &.btn-simple{\r\n        padding: $padding-btn-vertical - 1  $padding-round-horizontal - 1;\r\n    }\r\n}\r\n\r\n.no-caret {\r\n  &.dropdown-toggle::after {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.btn-secondary:not(:disabled):not(.disabled):active,\r\n.btn-secondary:not(:disabled):not(.disabled).active,\r\n.show > .btn-secondary.dropdown-toggle {\r\n    color: $white;\r\n}\r\n\r\n.btn-group label.btn.active {\r\n    transform: translateY(0);\r\n    -webkit-transform: translateY(0);\r\n}\r\n\r\n.btn + .btn {\r\n  margin-left: 5px;\r\n}\r\n","\r\n@mixin transform-translate-x($value){\r\n     -webkit-transform:  translate3d($value, 0, 0);\r\n        -moz-transform: translate3d($value, 0, 0);\r\n        -o-transform: translate3d($value, 0, 0);\r\n        -ms-transform: translate3d($value, 0, 0);\r\n        transform: translate3d($value, 0, 0);\r\n}\r\n\r\n@mixin transform-translate-y($value){\r\n     -webkit-transform:  translate3d(0,$value,0);\r\n        -moz-transform: translate3d(0,$value,0);\r\n        -o-transform: translate3d(0,$value,0);\r\n        -ms-transform: translate3d(0,$value,0);\r\n        transform: translate3d(0,$value,0);\r\n}\r\n\r\n@mixin transitions($time, $type){\r\n    -webkit-transition: all $time $type;\r\n    -moz-transition: all $time $type;\r\n    -o-transition: all $time $type;\r\n    -ms-transition: all $time $type;\r\n    transition: all $time $type;\r\n}\r\n\r\n@mixin diagonal-gradient($start-color, $end-color){\r\n  background: $start-color;\r\n  background-image: -webkit-linear-gradient(to bottom left, $start-color, $end-color, $start-color);\r\n  background-image: -o-linear-gradient(to bottom left, $start-color, $end-color, $start-color);\r\n  background-image: -moz-linear-gradient(to bottom left, $start-color, $end-color, $start-color);\r\n  background-image: linear-gradient(to bottom left, $start-color, $end-color, $start-color);\r\n  background-size: 210% 210%;\r\n  background-position: top right;\r\n}\r\n\r\n@mixin bar-animation($type){\r\n     -webkit-animation: $type 500ms linear 0s;\r\n     -moz-animation: $type 500ms linear 0s;\r\n     animation: $type 500ms 0s;\r\n     -webkit-animation-fill-mode: forwards;\r\n     -moz-animation-fill-mode: forwards;\r\n     animation-fill-mode: forwards;\r\n}\r\n\r\n@mixin rotate-180(){\r\n    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\r\n    -webkit-transform: rotate(180deg);\r\n    -ms-transform: rotate(180deg);\r\n    transform: rotate(180deg);\r\n}\r\n\r\n@mixin transform-translate-y-dropdown($value) {\r\n    -webkit-transform:  translate3d(0,$value,0) !important;\r\n       -moz-transform: translate3d(0,$value,0) !important;\r\n       -o-transform: translate3d(0,$value,0) !important;\r\n       -ms-transform: translate3d(0,$value,0) !important;\r\n       transform: translate3d(0,$value,0) !important;\r\n}\r\n\r\n@mixin linear-gradient($color, $states-color){\r\n    background: $color;\r\n    background: -webkit-linear-gradient(0deg, $color 0%, $states-color 100%);\r\n    background: -o-linear-gradient(0deg, $color 0%, $states-color 100%);\r\n    background: -moz-linear-gradient(0deg, $color 0%, $states-color 100%);\r\n    background: linear-gradient(0deg, $color 0%, $states-color 100%);\r\n}\r\n\r\n@mixin linear-gradient-right($color, $states-color){\r\n    background: $color;\r\n    background: -webkit-linear-gradient(to right, $color 0%, $states-color 100%);\r\n    background: -o-linear-gradient(to right, $color 0%, $states-color 100%);\r\n    background: -moz-linear-gradient(to right, $color 0%, $states-color 100%);\r\n    background: linear-gradient(to right, $color 0%, $states-color 100%);\r\n}\r\n\r\n@mixin sidebar-color($color){\r\n  &:after{\r\n    background: $color;\r\n  }\r\n\r\n  .nav li.active > a{\r\n    color: $color;\r\n\r\n    i{\r\n      color: $color;\r\n    }\r\n  }\r\n}\r\n\r\n@mixin transition-input-focus-color() {\r\n    -webkit-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\r\n    -moz-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\r\n    -o-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\r\n    -ms-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\r\n    transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;\r\n}\r\n\r\n@mixin topbar-x-rotation(){\r\n    @keyframes topbar-x {\r\n      0% {top: 0px; transform: rotate(0deg); }\r\n      45% {top: 6px; transform: rotate(145deg); }\r\n      75% {transform: rotate(130deg); }\r\n      100% {transform: rotate(135deg); }\r\n    }\r\n    @-webkit-keyframes topbar-x {\r\n      0% {top: 0px; -webkit-transform: rotate(0deg); }\r\n      45% {top: 6px; -webkit-transform: rotate(145deg); }\r\n      75% {-webkit-transform: rotate(130deg); }\r\n      100% { -webkit-transform: rotate(135deg); }\r\n    }\r\n    @-moz-keyframes topbar-x {\r\n      0% {top: 0px; -moz-transform: rotate(0deg); }\r\n      45% {top: 6px; -moz-transform: rotate(145deg); }\r\n      75% {-moz-transform: rotate(130deg); }\r\n      100% { -moz-transform: rotate(135deg); }\r\n    }\r\n}\r\n\r\n@mixin topbar-back-rotation(){\r\n    @keyframes topbar-back {\r\n      0% { top: 6px; transform: rotate(135deg); }\r\n      45% { transform: rotate(-10deg); }\r\n      75% { transform: rotate(5deg); }\r\n      100% { top: 0px; transform: rotate(0); }\r\n    }\r\n\r\n    @-webkit-keyframes topbar-back {\r\n      0% { top: 6px; -webkit-transform: rotate(135deg); }\r\n      45% { -webkit-transform: rotate(-10deg); }\r\n      75% { -webkit-transform: rotate(5deg); }\r\n      100% { top: 0px; -webkit-transform: rotate(0); }\r\n    }\r\n\r\n    @-moz-keyframes topbar-back {\r\n      0% { top: 6px; -moz-transform: rotate(135deg); }\r\n      45% { -moz-transform: rotate(-10deg); }\r\n      75% { -moz-transform: rotate(5deg); }\r\n      100% { top: 0px; -moz-transform: rotate(0); }\r\n    }\r\n}\r\n\r\n@mixin bottombar-x-rotation(){\r\n    @keyframes bottombar-x {\r\n      0% {bottom: 0px; transform: rotate(0deg);}\r\n      45% {bottom: 6px; transform: rotate(-145deg);}\r\n      75% {transform: rotate(-130deg);}\r\n      100% {transform: rotate(-135deg);}\r\n    }\r\n    @-webkit-keyframes bottombar-x {\r\n      0% {bottom: 0px; -webkit-transform: rotate(0deg);}\r\n      45% {bottom: 6px; -webkit-transform: rotate(-145deg);}\r\n      75% {-webkit-transform: rotate(-130deg);}\r\n      100% {-webkit-transform: rotate(-135deg);}\r\n    }\r\n    @-moz-keyframes bottombar-x {\r\n      0% {bottom: 0px; -moz-transform: rotate(0deg);}\r\n      45% {bottom: 6px; -moz-transform: rotate(-145deg);}\r\n      75% {-moz-transform: rotate(-130deg);}\r\n      100% {-moz-transform: rotate(-135deg);}\r\n    }\r\n}\r\n\r\n@mixin bottombar-back-rotation{\r\n    @keyframes bottombar-back {\r\n      0% { bottom: 6px;transform: rotate(-135deg);}\r\n      45% { transform: rotate(10deg);}\r\n      75% { transform: rotate(-5deg);}\r\n      100% { bottom: 0px;transform: rotate(0);}\r\n    }\r\n    @-webkit-keyframes bottombar-back {\r\n      0% {bottom: 6px;-webkit-transform: rotate(-135deg);}\r\n      45% {-webkit-transform: rotate(10deg);}\r\n      75% {-webkit-transform: rotate(-5deg);}\r\n      100% {bottom: 0px;-webkit-transform: rotate(0);}\r\n    }\r\n    @-moz-keyframes bottombar-back {\r\n      0% {bottom: 6px;-moz-transform: rotate(-135deg);}\r\n      45% {-moz-transform: rotate(10deg);}\r\n      75% {-moz-transform: rotate(-5deg);}\r\n      100% {bottom: 0px;-moz-transform: rotate(0);}\r\n    }\r\n\r\n}\r\n\r\n\r\n@mixin nc-rotate($degrees, $rotation) {\r\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=#{$rotation});\r\n  -webkit-transform: rotate($degrees);\r\n  -moz-transform: rotate($degrees);\r\n  -ms-transform: rotate($degrees);\r\n  -o-transform: rotate($degrees);\r\n  transform: rotate($degrees);\r\n}\r\n\r\n@mixin nc-flip($horiz, $vert, $rotation) {\r\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=#{$rotation});\r\n  -webkit-transform: scale($horiz, $vert);\r\n  -moz-transform: scale($horiz, $vert);\r\n  -ms-transform: scale($horiz, $vert);\r\n  -o-transform: scale($horiz, $vert);\r\n  transform: scale($horiz, $vert);\r\n}\r\n","@mixin btn-styles($btn-color, $btn-states-color) {\r\n  @include diagonal-gradient($btn-color, $btn-states-color);\r\n    background-color: $btn-color;\r\n    transition: all 0.15s ease;\r\n    box-shadow: none;\r\n    &.animation-on-hover:hover{\r\n      background-position: bottom left;\r\n      transition:0.3s ease-in-out;\r\n    }\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active,\r\n    &.active,\r\n    &:active:focus,\r\n    &:active:hover,\r\n    &.active:focus,\r\n    &.active:hover\r\n     {\r\n        // background-color: $btn-states-color !important;\r\n        // background-image: linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\r\n        // background-image: -webkit-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\r\n        // background-image: -o-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\r\n        // background-image: -moz-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\r\n        color: $white;\r\n        box-shadow: none;\r\n    }\r\n\r\n    &:active{\r\n      box-shadow: none !important;\r\n      transform: translateY(1px) !important;\r\n      transition: all .15s ease;\r\n    }\r\n\r\n    &:not([data-action]):hover{\r\n\r\n        box-shadow:  2px 2px 6px rgba(0,0,0,0.4);\r\n        transform: translateY(-1px);\r\n        -webkit-transform: translateY(-1px);\r\n    }\r\n\r\n    &.disabled,\r\n    &:disabled,\r\n    &[disabled],\r\n    fieldset[disabled] & {\r\n        &,\r\n        &:hover,\r\n        &:focus,\r\n        &.focus,\r\n        &:active,\r\n        &.active {\r\n            background-color: $btn-color;\r\n            border-color: $btn-color;\r\n        }\r\n    }\r\n\r\n    // btn-neutral style\r\n    @if $btn-color == $white{\r\n        color: $primary;\r\n\r\n        &.btn-danger{\r\n            color: $danger;\r\n\r\n            &:hover,\r\n            &:focus,\r\n            &:active,\r\n            &:active:focus{\r\n                color: $danger-states;\r\n            }\r\n        }\r\n\r\n        &.btn-info{\r\n            color: $info;\r\n\r\n            &:hover,\r\n            &:focus,\r\n            &:active,\r\n            &:active:focus{\r\n                color: $info-states;\r\n            }\r\n        }\r\n\r\n        &.btn-warning{\r\n            color: $warning;\r\n\r\n            &:hover,\r\n            &:focus,\r\n            &:active,\r\n            &:active:focus{\r\n                color: $warning-states;\r\n            }\r\n        }\r\n\r\n        &.btn-success{\r\n            color: $success;\r\n\r\n            &:hover,\r\n            &:focus,\r\n            &:active,\r\n            &:active:focus{\r\n                color: $success-states;\r\n            }\r\n        }\r\n\r\n        &.btn-default{\r\n            color: $default;\r\n\r\n            &:hover,\r\n            &:focus,\r\n            &:active,\r\n            &:active:focus{\r\n                color: $default-states;\r\n            }\r\n        }\r\n\r\n        &.active,\r\n        &:active,\r\n        &:active:focus,\r\n        &:active:hover,\r\n        &.active:focus,\r\n        &.active:hover,\r\n        .show > &.dropdown-toggle,\r\n        .show > &.dropdown-toggle:focus,\r\n        .show > &.dropdown-toggle:hover {\r\n            background-color: $white;\r\n            color: $primary-states;\r\n            box-shadow: none;\r\n        }\r\n\r\n        &:hover,\r\n        &:focus{\r\n            color: $primary-states;\r\n\r\n            &:not(.nav-link){\r\n                box-shadow: none;\r\n            }\r\n\r\n        }\r\n\r\n    } @else {\r\n        color: $white;\r\n    }\r\n\r\n    &.btn-simple{\r\n        color: $btn-color;\r\n        border-color: $btn-color;\r\n        background: $transparent-bg;\r\n\r\n        &:hover,\r\n        &:focus,\r\n        &:active,\r\n        &:not(:disabled):not(.disabled):active{\r\n            color: $btn-color;\r\n            border-color: $btn-color;\r\n            background-color: $transparent-bg !important;\r\n            background-image: none !important;\r\n            box-shadow: none;\r\n        }\r\n\r\n        &.active{\r\n          border-color: $btn-color !important;\r\n          &:hover,\r\n          &:focus,\r\n          &:active,\r\n          &:not(:disabled):not(.disabled):active{\r\n              color: $white;\r\n              border-color: $btn-color;\r\n              background-image: linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\r\n              background-image: -webkit-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\r\n              background-image: -o-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\r\n              background-image: -moz-linear-gradient(to bottom left, $btn-color, $btn-states-color, $btn-color) !important;\r\n              background-color: $btn-states-color !important;\r\n              box-shadow: none;\r\n          }\r\n        }\r\n    }\r\n\r\n    &.btn-link{\r\n        color: $btn-color;\r\n        &:hover,\r\n        &:focus,\r\n        &:active{\r\n            background-color: $transparent-bg !important;\r\n            background-image: none !important;\r\n            color: $white !important;\r\n            text-decoration: none;\r\n            box-shadow: none;\r\n        }\r\n    }\r\n}\r\n\r\n@mixin button-variant($background, $border, $hover-background: darken($background, 0%), $hover-border: darken($border, 0%), $active-background: darken($background, 10%), $active-border: darken($border, 0%)) {\r\n    color: color-yiq($background);\r\n    @include gradient-bg($background);\r\n    border-color: $border;\r\n    @include box-shadow($btn-box-shadow);\r\n\r\n    @include hover {\r\n        color: color-yiq($hover-background);\r\n        @include gradient-bg($hover-background);\r\n        border-color: $hover-border;\r\n    }\r\n\r\n    &:focus,\r\n    &.focus {\r\n        // Avoid using mixin so we can pass custom focus shadow properly\r\n        @if $enable-shadows {\r\n            box-shadow: $btn-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\r\n        }\r\n        @else {\r\n            box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\r\n        }\r\n    } // Disabled comes first so active can properly restyle\r\n    &.disabled,\r\n    &:disabled {\r\n        color: color-yiq($background);\r\n        background-color: $background;\r\n        border-color: $border;\r\n    }\r\n\r\n    &:not(:disabled):not(.disabled):active,\r\n    &:not(:disabled):not(.disabled).active,\r\n    .show>&.dropdown-toggle {\r\n        color: color-yiq($active-background);\r\n        background-color: $active-background;\r\n        @if $enable-gradients {\r\n            background-image: none; // Remove the gradient for the pressed/active state\r\n        }\r\n        border-color: $active-border;\r\n\r\n        &:focus {\r\n            // Avoid using mixin so we can pass custom focus shadow properly\r\n            @if $enable-shadows {\r\n                box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($border, .5);\r\n            }\r\n            @else {\r\n                box-shadow: 0 0 0 $btn-focus-width rgba($border, .5);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\r\n    color: $color;\r\n    background-color: transparent;\r\n    background-image: none;\r\n    border-color: $color;\r\n\r\n    &:hover {\r\n        color: $color-hover;\r\n        background-color: $active-background;\r\n        border-color: $active-border;\r\n    }\r\n\r\n    &:focus,\r\n    &.focus {\r\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\r\n    }\r\n\r\n    &.disabled,\r\n    &:disabled {\r\n        color: $color;\r\n        background-color: transparent;\r\n    }\r\n\r\n    &:not(:disabled):not(.disabled):active,\r\n    &:not(:disabled):not(.disabled).active,\r\n    .show>&.dropdown-toggle {\r\n        color: color-yiq($active-background);\r\n        background-color: $active-background;\r\n        border-color: $active-border;\r\n\r\n        &:focus {\r\n            // Avoid using mixin so we can pass custom focus shadow properly\r\n            @if $enable-shadows and $btn-active-box-shadow !=none {\r\n                box-shadow: $btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5);\r\n            }\r\n            @else {\r\n                box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Button sizes\r\n@mixin btn-size($padding-vertical, $padding-horizontal, $font-size, $border){\r\n   font-size: $font-size;\r\n   border-radius: $border;\r\n   padding: $padding-vertical $padding-horizontal;\r\n\r\n   &.btn-simple{\r\n       padding: $padding-vertical - 1 $padding-horizontal - 1;\r\n   }\r\n\r\n}\r\n\r\n// for social buttons\r\n@mixin social-buttons-color ($color, $state-color){\r\n  @include diagonal-gradient($color, darken($color,20%));\r\n    //background-color: $color;\r\n    color: $white;\r\n    background-size: 210% 210%;\r\n    background-position: top right;\r\n    background-repeat: space;\r\n\r\n    &:focus,\r\n    &:active,\r\n    &:hover{\r\n        background-color: $state-color;\r\n        background-image: linear-gradient(to bottom left, $color, darken($color,20%), $color) !important;\r\n        background-image: -webkit-linear-gradient(to bottom left, $color, darken($color,20%), $color) !important;\r\n        background-image: -o-linear-gradient(to bottom left, $color, darken($color,20%), $color) !important;\r\n        background-image: -moz-linear-gradient(to bottom left, $color, darken($color,20%), $color) !important;\r\n        color: $white;\r\n    }\r\n\r\n    &.btn-simple{\r\n        color: $state-color;\r\n        background-color: $transparent-bg;\r\n        background-image: none !important;\r\n        box-shadow: none;\r\n        border-color: $state-color;\r\n\r\n        &:hover,\r\n        &:focus,\r\n        &:active{\r\n            color: $state-color;\r\n            border-color: $state-color;\r\n        }\r\n    }\r\n\r\n    &.btn-neutral{\r\n        color: $color;\r\n        background-color: $white;\r\n\r\n\r\n        &:hover,\r\n        &:focus,\r\n        &:active{\r\n            color: $state-color;\r\n        }\r\n    }\r\n}\r\n","// Opacity\r\n\r\n@mixin opacity($opacity) {\r\n  opacity: $opacity;\r\n  // IE8 filter\r\n  $opacity-ie: ($opacity * 100);\r\n  filter: #{alpha(opacity=$opacity-ie)};\r\n}\r\n",".dropdown-menu {\r\n    border: 0;\r\n    box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\r\n    border-radius: $border-radius-xs;\r\n    @include transitions($fast-transition-time, $transition-linear);\r\n\r\n    &.dropdown-menu-right {\r\n      &:before, &:after {\r\n        left:auto;\r\n        right: 10px;\r\n      }\r\n    }\r\n\r\n    &.dropdown-black {\r\n      background: linear-gradient(to bottom, $black 0%, $black-states 100%);\r\n      border: 1px solid $default;\r\n      .dropdown-item {\r\n        color: rgba(255, 255, 255, 0.7);\r\n      }\r\n\r\n      .dropdown-divider {\r\n        border-color: $default;\r\n      }\r\n\r\n      &:before {\r\n        color: $black;\r\n        z-index: 2;\r\n      }\r\n\r\n      &:after {\r\n        display: inline-block;\r\n        position: absolute;\r\n        width: 0;\r\n        height: 0;\r\n        z-index: 1;\r\n        vertical-align: middle;\r\n        content: \"\";\r\n        top: -6px;\r\n        left: 10px;\r\n        right: auto;\r\n        color: $default;\r\n        border-bottom: .4em solid;\r\n        border-right: .4em solid transparent;\r\n        border-left: .4em solid transparent;\r\n      }\r\n\r\n      &.dropdown-menu-right {\r\n        &:after {\r\n          left: auto;\r\n          right: 10px;\r\n        }\r\n      }\r\n\r\n      .dropup & {\r\n        &:after {\r\n          color: $black-states;\r\n          z-index: 2;\r\n        }\r\n\r\n        &:before {\r\n          display: inline-block;\r\n          position: absolute;\r\n          width: 0;\r\n          height: 0;\r\n          vertical-align: middle;\r\n          content: \"\";\r\n          top: auto;\r\n          bottom: -6px;\r\n          right: auto;\r\n          left: 10px;\r\n          color: $dark-background;\r\n          border-top: .4em solid;\r\n          border-right: .4em solid transparent;\r\n          border-left: .4em solid transparent;\r\n          border-bottom: none;\r\n          z-index: 1;\r\n        }\r\n      }\r\n    }\r\n\r\n    i {\r\n        margin-right: 5px;\r\n        position: relative;\r\n        top: 1px;\r\n    }\r\n\r\n    .tim-icons {\r\n        margin-right: 10px;\r\n        position: relative;\r\n        top: 4px;\r\n        font-size: 18px;\r\n        margin-top: -5px;\r\n        opacity: .5;\r\n    }\r\n\r\n    .dropdown-item {\r\n        &.active,\r\n        &:active{\r\n            color: inherit;\r\n        }\r\n    }\r\n\r\n    .dropup & {\r\n        &:before {\r\n            display: none;\r\n        }\r\n\r\n        &:after {\r\n          display: inline-block;\r\n          position: absolute;\r\n          width: 0;\r\n          height: 0;\r\n          vertical-align: middle;\r\n          content: \"\";\r\n          top: auto;\r\n          bottom: -5px;\r\n          right: auto;\r\n          left: 10px;\r\n          color: $white;\r\n          border-top: .4em solid;\r\n          border-right: .4em solid transparent;\r\n          border-left: .4em solid transparent;\r\n          border-bottom: none;\r\n        }\r\n\r\n        &.dropdown-menu-right {\r\n          &:after, &:before {\r\n            right: 10px;\r\n            left: auto;\r\n          }\r\n        }\r\n    }\r\n\r\n\r\n\r\n    &:before {\r\n      display: inline-block;\r\n      position: absolute;\r\n      width: 0;\r\n      height: 0;\r\n      vertical-align: middle;\r\n      content: \"\";\r\n      top: -5px;\r\n      left: 10px;\r\n      right: auto;\r\n      color: $white;\r\n      border-bottom: .4em solid;\r\n      border-right: .4em solid transparent;\r\n      border-left: .4em solid transparent;\r\n    }\r\n\r\n\r\n\r\n    &.dropdown-menu-right {\r\n      right: 0 !important;\r\n      left: auto !important;\r\n    }\r\n\r\n    .dropdown-item,\r\n    .bootstrap-select &.inner li a {\r\n      font-size: $font-size-sm;\r\n      padding-top: .6rem;\r\n      padding-bottom: .6rem;\r\n      margin-top: 5px;\r\n      @include transitions($fast-transition-time, $transition-linear);\r\n\r\n      &:hover,\r\n      &:focus {\r\n        background-color: $opacity-gray-3;\r\n      }\r\n\r\n      &.disabled,\r\n      &:disabled {\r\n        color: $default-opacity;\r\n\r\n        &:hover,\r\n        &:focus {\r\n          background-color: transparent;\r\n          box-shadow: none;\r\n        }\r\n      }\r\n    }\r\n\r\n\r\n    .dropdown-divider {\r\n        background-color: $opacity-gray-5;\r\n    }\r\n\r\n    .dropdown-header:not([href]) {\r\n        color: $default-opacity;\r\n        font-size: $font-size-xs;\r\n        text-transform: uppercase;\r\n        font-weight: $font-weight-bold;\r\n    }\r\n\r\n    &.dropdown-primary {\r\n        @include dropdown-colors(darken($primary, 3%),$opacity-8,$white, $opacity-2);\r\n    }\r\n\r\n    &.dropdown-info {\r\n        @include dropdown-colors(darken($info, 3%),$opacity-8,$white, $opacity-2);\r\n    }\r\n\r\n    &.dropdown-danger {\r\n        @include dropdown-colors(darken($danger, 3%),$opacity-8,$white, $opacity-2);\r\n    }\r\n\r\n    &.dropdown-success {\r\n        @include dropdown-colors(darken($success, 3%),$opacity-8,$white, $opacity-2);\r\n    }\r\n\r\n    &.dropdown-warning {\r\n        @include dropdown-colors(darken($warning, 3%),$opacity-8,$white, $opacity-2);\r\n    }\r\n\r\n    .dropdown &,\r\n    .dropup:not(.bootstrap-select) &,\r\n    .bootstrap-select &:not(.inner),\r\n    &.bootstrap-datetimepicker-widget.bottom {\r\n        @include transform-translate-y-dropdown(-20px);\r\n        visibility: hidden;\r\n        display: block;\r\n        @include opacity(0);\r\n        top: 100% !important;\r\n    }\r\n\r\n    &.bootstrap-datetimepicker-widget.top {\r\n      @include transform-translate-y-dropdown(-20px);\r\n      visibility: hidden;\r\n      display: block;\r\n      @include opacity(0);\r\n    }\r\n\r\n    &.bootstrap-datetimepicker-widget.top,\r\n    &.bootstrap-datetimepicker-widget.bottom {\r\n        @include transform-translate-y-dropdown(-20px);\r\n    }\r\n\r\n    .bootstrap-select.dropup &:not(.inner){\r\n        @include transform-translate-y-dropdown(25px);\r\n    }\r\n\r\n    .dropup:not(.bootstrap-select) &{\r\n        @include transform-translate-y-dropdown(20px);\r\n        top: auto !important;\r\n        bottom: 100%;\r\n    }\r\n\r\n    .dropdown.show &,\r\n    .bootstrap-select.show &:not(.inner),\r\n    &.bootstrap-datetimepicker-widget.top.open,\r\n    &.bootstrap-datetimepicker-widget.bottom.open,\r\n    .dropup.show:not(.bootstrap-select) &,\r\n    .navbar .dropdown.show &{\r\n        @include opacity(1);\r\n        visibility: visible;\r\n        @include transform-translate-y-dropdown(1px);\r\n    }\r\n\r\n    &.bootstrap-datetimepicker-widget.top.open,\r\n    &.bootstrap-datetimepicker-widget.bottom.open{\r\n        @include transform-translate-y-dropdown(0px);\r\n    }\r\n\r\n    .dropup.show:not(.bootstrap-select) &{\r\n        @include transform-translate-y-dropdown(-2px);\r\n    }\r\n\r\n    &.dropdown-navbar{\r\n      left: -80px;\r\n      &:before, &:after{\r\n        left: auto;\r\n        right: 17px;\r\n      }\r\n    }\r\n\r\n\r\n}\r\n\r\n.btn{\r\n    cursor: pointer;\r\n\r\n    &.dropdown-toggle[data-toggle=\"dropdown\"]{\r\n        padding:10px;\r\n        margin: 0;\r\n        margin-bottom: 5px;\r\n\r\n        &:after{\r\n          content: \"\";\r\n          margin-left: 5px;\r\n        }\r\n\r\n    }\r\n\r\n    span.bs-caret{\r\n      display: none;\r\n    }\r\n\r\n    &.btn-link{\r\n      &.dropdown-toggle{\r\n        height: 22px;\r\n        padding: 0;\r\n        margin-right: 5px;\r\n      }\r\n    }\r\n}\r\n\r\n.dropdown-toggle:after{\r\n\r\n  content: unset;\r\n\r\n}\r\n\r\n.btn:not(:disabled):not(.disabled).active:focus,\r\n .btn:not(:disabled):not(.disabled):active:focus,\r\n .show>.btn.dropdown-toggle:focus{\r\n   box-shadow: none;\r\n }\r\n\r\n\r\n// Dropown: Sizes\r\n\r\n.dropdown-menu-sm {\r\n    min-width: 100px;\r\n    border: $border-radius-lg;\r\n}\r\n\r\n.dropdown-menu-lg {\r\n    min-width: 260px;\r\n    border-radius: $border-radius-lg;\r\n}\r\n\r\n.dropdown-menu-xl {\r\n    min-width: 450px;\r\n    border-radius: $border-radius-lg;\r\n}\r\n\r\n@media screen and (max-width: 991px){\r\n  .dropdown-toggle:after{\r\n    display: inline-block;\r\n    width: 0;\r\n    height: 0;\r\n    margin-left: .255em;\r\n    vertical-align: .255em;\r\n    content: \"\";\r\n    border-top: .3em solid;\r\n    border-right: .3em solid transparent;\r\n    border-bottom: 0;\r\n    border-left: .3em solid transparent;\r\n  }\r\n\r\n}\r\n\r\n\r\n@media screen and (min-width: 992px){\r\n  .dropdown-menu .dropdown-item{\r\n      color: $dark-gray;\r\n  }\r\n}\r\n","@mixin dropdown-colors($brand-color, $dropdown-header-color, $dropdown-color, $background-color ) {\r\n    background-color: $brand-color;\r\n\r\n    &:before{\r\n        color: $brand-color;\r\n    }\r\n\r\n    .dropdown-header:not([href]):not([tabindex]){\r\n        color: $dropdown-header-color;\r\n    }\r\n\r\n    .dropdown-item{\r\n        color: $dropdown-color;\r\n\r\n        &:hover,\r\n        &:focus{\r\n            background-color: $background-color;\r\n        }\r\n    }\r\n\r\n    .dropdown-divider{\r\n        background-color: $background-color;\r\n    }\r\n\r\n  \r\n}\r\n",".footer {\r\n  padding: 24px 0 24px 250px;\r\n\r\n  [class*='container-'] {\r\n    padding: 0;\r\n  }\r\n\r\n  .nav {\r\n    display: inline-block;\r\n    float: left;\r\n    margin-bottom: 0;\r\n    padding-left: 30px;\r\n    list-style: none;\r\n  }\r\n\r\n  .nav-item {\r\n    display: inline-block;\r\n\r\n    &:first-child a {\r\n      padding-left: 0;\r\n    }\r\n  }\r\n\r\n  .nav-link {\r\n    color: $white;\r\n    padding: 0 $padding-base-vertical;\r\n    font-size: $font-size-sm;\r\n    text-transform: uppercase;\r\n    text-decoration: none;\r\n\r\n    &:hover {\r\n      text-decoration: none;\r\n    }\r\n  }\r\n\r\n  .copyright {\r\n    font-size: $font-size-sm;\r\n    line-height: 1.8;\r\n    color: $white;\r\n  }\r\n\r\n  &:after {\r\n    display: table;\r\n    clear: both;\r\n    content: ' ';\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .footer {\r\n    padding-left: 0px;\r\n\r\n    .copyright {\r\n      text-align: right;\r\n      margin-right: 15px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 992px) {\r\n  .footer {\r\n    .copyright {\r\n      float: right;\r\n      padding-right: 30px;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .footer {\r\n    nav {\r\n      display: block;\r\n      margin-bottom: 5px;\r\n      float: none;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 576px) {\r\n  .footer {\r\n    text-align: center;\r\n    .copyright {\r\n      text-align: center;\r\n    }\r\n\r\n    .nav {\r\n      float: none;\r\n      padding-left: 0;\r\n    }\r\n  }\r\n}\r\n","/* Form controls */\r\n@include form-control-placeholder(#6c757c, 1);\r\n\r\n.form-control{\r\n  border-color: lighten($black,5%);\r\n  border-radius: $border-radius-lg;\r\n  font-size: $font-size-sm;\r\n  @include transition-input-focus-color();\r\n\r\n\r\n  &:focus{\r\n    border-color: $primary;\r\n    background-color: $input-bg;\r\n    @include box-shadow(none);\r\n\r\n    & + .input-group-append .input-group-text,\r\n    & ~ .input-group-append .input-group-text,\r\n    & + .input-group-prepend .input-group-text,\r\n    & ~ .input-group-prepend .input-group-text{\r\n        border: 1px solid $primary;\r\n        border-left: none;\r\n        background-color: $transparent-bg;\r\n    }\r\n  }\r\n\r\n  .has-success &,\r\n  .has-error &,\r\n  .has-success &:focus,\r\n  .has-error &:focus{\r\n      @include box-shadow(none);\r\n  }\r\n\r\n  .has-danger &,\r\n  .has-success &{\r\n      &.form-control-success,\r\n      &.form-control-danger{\r\n          background-image: none;\r\n      }\r\n  }\r\n\r\n  & + .form-control-feedback{\r\n      border-radius: $border-radius-lg;\r\n      margin-top: -7px;\r\n      position: absolute;\r\n      right: 10px;\r\n      top: 50%;\r\n      vertical-align: middle;\r\n  }\r\n\r\n  .open &{\r\n      border-radius: $border-radius-lg $border-radius-lg 0 0;\r\n      border-bottom-color: $transparent-bg;\r\n  }\r\n\r\n  & + .input-group-append .input-group-text,\r\n  & + .input-group-prepend .input-group-text{\r\n      background-color: $white;\r\n  }\r\n\r\n}\r\n\r\n.has-success .input-group-append .input-group-text,\r\n.has-success .input-group-prepend .input-group-text,\r\n.has-success .form-control{\r\n    border-color: lighten($black,5%);\r\n}\r\n\r\n.has-success .form-control:focus,\r\n.has-success.input-group-focus .input-group-append .input-group-text,\r\n.has-success.input-group-focus .input-group-prepend .input-group-text{\r\n  border-color: darken($success, 10%);\r\n}\r\n\r\n.has-danger .form-control,\r\n.has-danger .input-group-append .input-group-text,\r\n.has-danger .input-group-prepend .input-group-text,\r\n.has-danger.input-group-focus .input-group-prepend .input-group-text,\r\n.has-danger.input-group-focus .input-group-append .input-group-text{\r\n    border-color: lighten($danger-states,5%);\r\n    color: $danger-states;\r\n    background-color: rgba(222,222,222, .1);\r\n\r\n    &:focus{\r\n        background-color: $transparent-bg;\r\n    }\r\n}\r\n\r\n.has-success,\r\n.has-danger{\r\n    &:after{\r\n        font-family: 'nucleo';\r\n        content: \"\\ea1b\";\r\n        display: inline-block;\r\n        position: absolute;\r\n        right: 20px;\r\n        top: 13px;\r\n        color: $success;\r\n        font-size: 11px;\r\n    }\r\n\r\n    &.form-control-lg{\r\n      &:after{\r\n        font-size: 13px;\r\n        top: 24px;\r\n      }\r\n    }\r\n\r\n    &.has-label{\r\n      &:after{\r\n        top: 37px;\r\n      }\r\n    }\r\n\r\n\r\n    &.form-check:after{\r\n      display: none !important;\r\n    }\r\n\r\n    &.form-check .form-check-label{\r\n      color: $success;\r\n    }\r\n}\r\n\r\n.has-danger{\r\n  &:after{\r\n    content: \"\\ea48\";\r\n    color: $danger-states;\r\n  }\r\n\r\n  &.form-check .form-check-label{\r\n    color: $danger-states;\r\n  }\r\n}\r\n","@mixin input-size($padding-vertical, $padding-horizontal){\r\n    padding: $padding-vertical $padding-horizontal;\r\n}\r\n\r\n@mixin form-control-placeholder($color, $opacity){\r\n   .form-control::-moz-placeholder{\r\n       color: $color;\r\n       @include opacity(1);\r\n   }\r\n   .form-control:-moz-placeholder{\r\n       color: $color;\r\n       @include opacity(1);\r\n   }\r\n   .form-control::-webkit-input-placeholder{\r\n       color: $color;\r\n       @include opacity(1);\r\n   }\r\n   .form-control:-ms-input-placeholder{\r\n       color: $color;\r\n       @include opacity(1);\r\n   }\r\n}\r\n\r\n@mixin placeholder() {\r\n  &::-moz-placeholder {@content; } // Firefox\r\n  &:-ms-input-placeholder {@content; } // Internet Explorer 10+\r\n  &::-webkit-input-placeholder  {@content; } // Safari and Chrome\r\n}\r\n\r\n@mixin light-form(){\r\n    border-radius: 0;\r\n    border:0;\r\n    padding: 0;\r\n    background-color: transparent;\r\n\r\n}\r\n\r\n\r\n@mixin form-control-lg-padding($padding-vertical, $padding-horizontal) {\r\n    .form-group.no-border.form-control-lg,\r\n    .input-group.no-border.form-control-lg{\r\n        .input-group-append .input-group-text{\r\n            padding: $padding-vertical 0 $padding-vertical $padding-horizontal;\r\n        }\r\n\r\n        .form-control{\r\n            padding: $padding-vertical $padding-horizontal;\r\n\r\n            & + .input-group-prepend .input-group-text,\r\n            & + .input-group-append .input-group-text{\r\n                padding: $padding-vertical $padding-horizontal $padding-vertical 0;\r\n            }\r\n\r\n\r\n        }\r\n    }\r\n\r\n    .form-group.form-control-lg,\r\n    .input-group.form-control-lg{\r\n        .form-control{\r\n            padding: $padding-vertical - 1 $padding-horizontal - 1;\r\n            height: 100%;\r\n\r\n            & + .input-group-prepend .input-group-text,\r\n            & + .input-group-append .input-group-text{\r\n                padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical - 1 0;\r\n            }\r\n        }\r\n\r\n        .input-group-prepend .input-group-text,\r\n        .input-group-append .input-group-text{\r\n            padding: $padding-vertical - 1 0 $padding-vertical $padding-horizontal - 1;\r\n\r\n            & + .form-control{\r\n                padding: $padding-vertical  $padding-horizontal - 1 $padding-vertical $padding-horizontal - 3;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n@mixin input-base-padding($padding-vertical, $padding-horizontal) {\r\n    .form-group.no-border,\r\n    .input-group.no-border{\r\n        .form-control{\r\n            padding: $padding-vertical $padding-horizontal;\r\n\r\n            & + .input-group-prepend .input-group-text,\r\n            & + .input-group-append .input-group-text{\r\n                padding: $padding-vertical $padding-horizontal $padding-vertical 0;\r\n            }\r\n        }\r\n\r\n        .input-group-prepend .input-group-text,\r\n        .input-group-append .input-group-text{\r\n            padding: $padding-vertical 0 $padding-vertical $padding-horizontal;\r\n        }\r\n    }\r\n\r\n    .form-group,\r\n    .input-group{\r\n        .form-control{\r\n            padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical - 1 $padding-horizontal - 1;\r\n\r\n            & + .input-group-prepend .input-group-text,\r\n            & + .input-group-append .input-group-text{\r\n                padding: $padding-vertical - 1 $padding-horizontal - 1 $padding-vertical - 1 0;\r\n            }\r\n        }\r\n\r\n        .input-group-prepend .input-group-text,\r\n        .input-group-append .input-group-text{\r\n            padding: $padding-vertical - 1 0 $padding-vertical - 1 $padding-horizontal - 1;\r\n\r\n            & + .form-control,\r\n            & ~ .form-control{\r\n                padding:$padding-vertical - 1 $padding-horizontal $padding-vertical $padding-horizontal - 3;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n//color1 = $opacity-5\r\n//color2 = $opacity-8\r\n//color3 = $white-color\r\n//color4 = $transparent-bg\r\n//color5 = $opacity-1\r\n//color6 = $opacity-2\r\n\r\n\r\n@mixin input-coloured-bg($color1, $color2, $color3, $color4, $color5, $color6) {\r\n    @include form-control-placeholder(rgba($white, 0.4), 1);\r\n\r\n    .form-control{\r\n        border-color: $color1;\r\n        color: $color2;\r\n\r\n        &:focus{\r\n            border-color: $color3;\r\n            background-color: $color4;\r\n            color: $color3;\r\n        }\r\n    }\r\n\r\n    .has-success,\r\n    .has-danger{\r\n        &:after{\r\n            color: $color3;\r\n        }\r\n    }\r\n\r\n    .has-danger{\r\n        .form-control{\r\n            background-color: $color4;\r\n        }\r\n    }\r\n\r\n    .input-group-prepend{\r\n      margin-right: 0;\r\n    }\r\n\r\n    .input-group-prepend .input-group-text,\r\n    .input-group-append .input-group-text{\r\n        background-color: rgba($background-black, 0.2);\r\n        border-color: $color1;\r\n        color: $color2;\r\n\r\n\r\n    }\r\n\r\n    .input-group-focus{\r\n        .input-group-prepend .input-group-text,\r\n        .input-group-append .input-group-text{\r\n            background-color: rgba($background-black, 0.3);\r\n            border-color: $color3;\r\n            color: $color3;\r\n        }\r\n    }\r\n\r\n    .form-group.no-border,\r\n    .input-group.no-border{\r\n        .form-control{\r\n            background-color: rgba($background-black,0.2);\r\n            color: $color2;\r\n\r\n            &:focus,\r\n            &:active,\r\n            &:active{\r\n                background-color: rgba($background-black,0.3);\r\n                color: $color3;\r\n            }\r\n        }\r\n\r\n        .form-control + .input-group-prepend .input-group-text,\r\n        .form-control + .input-group-append .input-group-text{\r\n            background-color: rgba($background-black,0.2);;\r\n\r\n            &:focus,\r\n            &:active,\r\n            &:active{\r\n                background-color: rgba($background-black,0.3);\r\n                color: $color3;\r\n            }\r\n        }\r\n\r\n        .form-control{\r\n            &:focus{\r\n                & + .input-group-prepend .input-group-text,\r\n                & + .input-group-append .input-group-text{\r\n                    background-color: rgba($background-black, 0.3);\r\n                    color: $color3;\r\n                }\r\n            }\r\n        }\r\n\r\n        .input-group-prepend .input-group-text,\r\n        .input-group-append .input-group-text{\r\n            background-color: rgba($background-black, 0.2);\r\n            border: none;\r\n            color: $color2;\r\n        }\r\n\r\n        &.input-group-focus{\r\n            .input-group-prepend .input-group-text,\r\n            .input-group-append .input-group-text{\r\n                background-color: rgba($background-black, 0.3);\r\n                color: $color3;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n","img{\r\n    max-width: 100%;\r\n    border-radius: $border-radius-sm;\r\n}\r\n.img-raised{\r\n    box-shadow: $box-shadow-raised;\r\n}\r\n","// Modals\r\n// Design element Dialogs\r\n// --------------------------------------------------\r\n.modal-content {\r\n  border: 0;\r\n\r\n  // Modal header\r\n  // Top section of the modal w/ title and dismiss\r\n\r\n  .modal-header {\r\n    border-bottom: none;\r\n\r\n    & button {\r\n        position: absolute;\r\n        right: 27px;\r\n        top: 24px;\r\n        outline: 0;\r\n        padding: 1rem;\r\n        margin: -1rem -1rem -1rem auto;\r\n    }\r\n    .title{\r\n        color: $black;\r\n        margin-top: 5px;\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    .modal-title{\r\n      color: $black;\r\n    }\r\n\r\n    i.tim-icons {\r\n      font-size: 16px;\r\n    }\r\n  }\r\n\r\n\r\n  // Modal body\r\n  // Where all modal content resides (sibling of .modal-header and .modal-footer)\r\n  .modal-body {\r\n    line-height: 1.9;\r\n\r\n    p{\r\n      color: $black;\r\n    }\r\n  }\r\n  // Footer (for actions)\r\n  .modal-footer {\r\n    border-top: 0;\r\n    -webkit-justify-content: space-between; /* Safari 6.1+ */\r\n    justify-content: space-between;\r\n\r\n    button {\r\n      margin: 0;\r\n      padding-left: 16px;\r\n      padding-right: 16px;\r\n      width: auto;\r\n\r\n      &.pull-left {\r\n        padding-left: 5px;\r\n        padding-right: 5px;\r\n        position: relative;\r\n        left: -5px;\r\n      }\r\n    }\r\n\r\n  }\r\n  .modal-body + .modal-footer {\r\n    padding-top: 0;\r\n  }\r\n}\r\n.modal-backdrop {\r\n  background: rgba(0,0,0,0.3);\r\n}\r\n\r\n.modal{\r\n\r\n    &.modal-default{\r\n        @include modal-colors($white, $black);\r\n    }\r\n\r\n    &.modal-primary{\r\n        @include modal-colors($primary, $white);\r\n    }\r\n\r\n    &.modal-danger{\r\n        @include modal-colors($danger, $white);\r\n    }\r\n\r\n    &.modal-warning{\r\n        @include modal-colors($warning, $white);\r\n    }\r\n\r\n    &.modal-success{\r\n        @include modal-colors($success, $white);\r\n    }\r\n\r\n    &.modal-info{\r\n        @include modal-colors($info, $white);\r\n    }\r\n\r\n    .modal-header .close{\r\n        color: $danger;\r\n        text-shadow: none;\r\n\r\n        &:hover,\r\n        &:focus{\r\n            opacity: 1;\r\n        }\r\n    }\r\n\r\n    &.modal-black{\r\n      .modal-content{\r\n        background: linear-gradient(to bottom, $black 0%, $black-states 100%);\r\n        color: rgba($white, 0.8);\r\n        .modal-header{\r\n          .modal-title, .title{\r\n            color: rgba($white, 0.9);\r\n          }\r\n        }\r\n        .modal-body{\r\n          p{\r\n            color: rgba($white, 0.8);\r\n          }\r\n        }\r\n      }\r\n      h1, h2, h3, h4, h5, h6, p{\r\n        color: $white;\r\n      }\r\n    }\r\n}\r\n\r\n.modal-search{\r\n  .modal-dialog{\r\n    margin: 20px auto;\r\n    max-width: 650px;\r\n    input{\r\n      border: none;\r\n      font-size: 17px;\r\n      font-weight: 100;\r\n    }\r\n    span{\r\n      font-size: 35px;\r\n      color: $search-gray;\r\n    }\r\n  }\r\n  .modal-content{\r\n    .modal-header{\r\n      padding: 24px;\r\n    }\r\n  }\r\n\r\n  .modal-header .close{\r\n    color: $dark-background;\r\n    top: 30px !important;\r\n  }\r\n\r\n  .modal-footer{\r\n    border-top: 2px solid #f9f9f9;\r\n    margin: 0px 25px 20px;\r\n  }\r\n}\r\n","@mixin modal-colors($bg-color, $color) {\r\n    .modal-content{\r\n        background-color: $bg-color;\r\n        color: $color;\r\n    }\r\n\r\n    .modal-body p{\r\n      color: rgba($white, 0.8);\r\n    }\r\n\r\n    //inputs\r\n    @include input-coloured-bg($opacity-5, $white, $white, $transparent-bg, $opacity-1, $opacity-2);\r\n\r\n\r\n}\r\n",".navbar {\r\n  padding: 10px 30px 10px 15px;\r\n  width: 100%;\r\n  z-index: 1050;\r\n  background: $navbar-color;\r\n\r\n  .photo {\r\n    display: inline-block;\r\n    height: 30px;\r\n    width: 30px;\r\n    border-radius: 50%;\r\n    vertical-align: middle;\r\n    overflow: hidden;\r\n      img{\r\n        width: 100%;\r\n      }\r\n  }\r\n\r\n  .navbar-wrapper {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n  .navbar-text {\r\n    color: $white;\r\n  }\r\n\r\n  .btn{\r\n    margin: 0 5px 0 10px;\r\n  }\r\n\r\n  &.navbar-absolute{\r\n    position: absolute;\r\n    z-index: 1050;\r\n  }\r\n\r\n\r\n  &.navbar-transparent{\r\n    background: transparent !important;\r\n  }\r\n\r\n  &.bg-white{\r\n    .navbar-nav{\r\n      .search-bar.input-group{\r\n        i{\r\n          color: $black;\r\n        }\r\n      }\r\n\r\n      .search-bar.input-group .form-control{\r\n        background: rgba($black,0.1);\r\n        border-radius: 4px;\r\n      }\r\n\r\n      a.nav-link{\r\n        color: $black !important;\r\n        p{\r\n          color: $black;\r\n        }\r\n      }\r\n\r\n    }\r\n\r\n    .navbar-text, .navbar-brand{\r\n      color: $black;\r\n    }\r\n\r\n    .form-control {\r\n      color: $black !important;\r\n    }\r\n\r\n    .form-control::placeholder {\r\n      color: $dark-gray !important;\r\n    }\r\n\r\n  }\r\n\r\n  &.bg-dark {\r\n    background: $black !important;\r\n  }\r\n\r\n  &.bg-primary {\r\n    background-color: $primary !important;\r\n  }\r\n\r\n  &.bg-warning {\r\n    background-color: $warning !important;\r\n  }\r\n\r\n  &.bg-info {\r\n    background-color: $info !important;\r\n  }\r\n\r\n  &.bg-success {\r\n    background-color: darken($success, 10%) !important;\r\n  }\r\n\r\n  &.bg-danger {\r\n    background-color: $danger !important;\r\n  }\r\n\r\n  .navbar-brand {\r\n    position: fixed;\r\n    padding-top: 0;\r\n    padding-bottom:0;\r\n    color: $white;\r\n    margin-left: 0px;\r\n    margin-top: 3px;\r\n    text-transform: uppercase;\r\n    font-size: $font-paragraph;\r\n  }\r\n\r\n  .navbar-toggle button:focus, .navbar-toggler{\r\n    outline: none;\r\n  }\r\n\r\n}\r\n\r\n.navbar-minimize-fixed {\r\n\tposition: fixed;\r\n  margin-left: 40px;\r\n  margin-top: 14px;\r\n\ttransition: 0.3s ease;\r\n\tcolor: white;\r\n\tz-index: 20;\r\n\topacity: 0;\r\n\ttransition: 0.2s ease;\r\n\tbutton{\r\n\t\ti {\r\n\t\t\tfont-size: 20px;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.notification {\r\n  background: $danger;\r\n\tcolor: $white;\r\n\tborder-radius: $border-radius-xl;\r\n\theight: 6px;\r\n\twidth: 6px;\r\n\tposition: absolute;\r\n\ttext-align: center;\r\n\tfont-size: 12px;\r\n\tfont-weight: 800;\r\n  top: 10px;\r\n  right: 10px;\r\n\tborder: 1px solid $danger;\r\n}\r\n\r\n.navbar-nav li{\r\n  padding: 0 10px;\r\n  a{\r\n    color: $white;\r\n  }\r\n  i{\r\n    vertical-align: middle;\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 991px){\r\n  .navbar{\r\n      .container-fluid{\r\n          padding-right: 15px;\r\n          padding-left: 15px;\r\n      }\r\n\r\n      .navbar-collapse{\r\n        .input-group{\r\n          margin: 0;\r\n          margin-top: 5px;\r\n        }\r\n      }\r\n\r\n      .navbar-nav{\r\n\r\n        .btn{\r\n          margin-left: -3px;\r\n          display: flex;\r\n\r\n          i {\r\n            margin-right: 12px;\r\n          }\r\n\r\n          span {\r\n            margin: 0;\r\n            text-transform: uppercase;\r\n            font-weight: 300;\r\n\r\n            &,\r\n            &:hover,\r\n            &:focus,\r\n            &:active,\r\n            &:active:focus {\r\n              color: $black !important;\r\n            }\r\n          }\r\n        }\r\n\r\n          a.nav-link{\r\n            i{\r\n              opacity: 1;\r\n              margin-left: 4px;\r\n              margin-right: 5px;\r\n            }\r\n            p{\r\n              display: inline-block;\r\n              text-transform: uppercase;\r\n              margin-left: 7px;\r\n            }\r\n          }\r\n\r\n          .modal-search .modal-dialog{\r\n            padding: 0 40px;\r\n          }\r\n          .dropdown{\r\n            margin: 5px 0;\r\n            .nav-link{\r\n              padding-bottom: 0;\r\n            }\r\n            .dropdown-menu{\r\n              .dropdown-item{\r\n                margin-top: 0;\r\n                padding-left: 24px;\r\n              }\r\n            }\r\n          }\r\n      }\r\n\r\n      .dropdown.show .dropdown-menu{\r\n          display: block;\r\n\r\n      }\r\n\r\n      .dropdown .dropdown-menu{\r\n          display: none;\r\n          li a{\r\n            color: $black;\r\n          }\r\n      }\r\n\r\n      .dropdown.show .dropdown-menu,\r\n      .dropdown .dropdown-menu{\r\n          background-color: transparent;\r\n          border: 0;\r\n          transition: none;\r\n          -webkit-box-shadow: none;\r\n          box-shadow: none;\r\n          width: auto;\r\n          margin: 0px 1rem;\r\n          margin-top: 0px;\r\n\r\n          &:before{\r\n              display: none;\r\n          }\r\n      }\r\n\r\n      .dropdown-menu .dropdown-item:focus,\r\n      .dropdown-menu .dropdown-item:hover{\r\n          color: $white;\r\n      }\r\n\r\n      &.bg-white .dropdown-menu .dropdown-item:focus,\r\n      &.bg-white .dropdown-menu .dropdown-item:hover{\r\n          color: $default;\r\n      }\r\n\r\n      button.navbar-toggler[data-target=\"#navigation\"]{\r\n        padding-top: 0;\r\n      }\r\n\r\n      .navbar-toggler-bar{\r\n          display: block;\r\n          position: relative;\r\n          width: 22px;\r\n          height: 1px;\r\n          border-radius: 1px;\r\n          background: $white;\r\n\r\n          &.navbar-kebab{\r\n            height: 4px;\r\n            width: 4px;\r\n            margin-bottom: 3px;\r\n            border-radius: 50%;\r\n          }\r\n\r\n          & + .navbar-toggler-bar{\r\n              margin-top: 7px;\r\n          }\r\n\r\n          & + .navbar-toggler-bar.navbar-kebab{\r\n              margin-top: 0px;\r\n          }\r\n\r\n          &.bar2{\r\n              width: 17px;\r\n              transition: width .2s linear;\r\n          }\r\n      }\r\n\r\n      &.bg-white:not(.navbar-transparent) .navbar-toggler-bar{\r\n          background-color: $default;\r\n      }\r\n\r\n      & .toggled .navbar-toggler-bar{\r\n          width: 24px;\r\n\r\n          & + .navbar-toggler-bar{\r\n              margin-top: 5px;\r\n          }\r\n      }\r\n\r\n      .navbar-brand{\r\n        margin-left: 20px;\r\n        position: relative;\r\n      }\r\n  }\r\n\r\n  .navbar-nav{\r\n      .nav-link{\r\n          i.fa,\r\n          i.tim-icons{\r\n              opacity: .5;\r\n          }\r\n      }\r\n  }\r\n\r\n  .bar1,\r\n  .bar2,\r\n  .bar3 {\r\n    outline: 1px solid transparent;\r\n  }\r\n  .bar1 {\r\n    top: 0px;\r\n    @include bar-animation($topbar-back);\r\n  }\r\n  .bar2 {\r\n    opacity: 1;\r\n  }\r\n  .bar3 {\r\n    bottom: 0px;\r\n    @include bar-animation($bottombar-back);\r\n  }\r\n  .toggled .bar1 {\r\n    top: 6px;\r\n    @include bar-animation($topbar-x);\r\n  }\r\n  .toggled .bar2 {\r\n    opacity: 0;\r\n  }\r\n  .toggled .bar3 {\r\n    bottom: 6px;\r\n    @include bar-animation($bottombar-x);\r\n  }\r\n\r\n  @include topbar-x-rotation();\r\n  @include topbar-back-rotation();\r\n  @include bottombar-x-rotation();\r\n  @include bottombar-back-rotation();\r\n\r\n  @-webkit-keyframes fadeIn {\r\n    0% {opacity: 0;}\r\n    100% {opacity: 1;}\r\n  }\r\n  @-moz-keyframes fadeIn {\r\n    0% {opacity: 0;}\r\n    100% {opacity: 1;}\r\n  }\r\n  @keyframes fadeIn {\r\n    0% {opacity: 0;}\r\n    100% {opacity: 1;}\r\n  }\r\n\r\n}\r\n\r\n@media screen and (min-width: 992px) {\r\n  .navbar-collapse {\r\n    background: none !important;\r\n  }\r\n\r\n  .navbar .navbar-toggle {\r\n    display: none;\r\n  }\r\n\r\n  .navbar-nav {\r\n    .nav-link {\r\n      &.profile-photo {\r\n        padding: 0;\r\n        margin: 7px $padding-base-horizontal;\r\n      }\r\n    }\r\n  }\r\n\r\n  .navbar {\r\n    .caret {\r\n      position: absolute;\r\n      left: 80%;\r\n      top: 55%;\r\n      margin-left: 0;\r\n    }\r\n  }\r\n    .navbar-expand-lg .navbar-nav .nav-link {\r\n      padding-right: 0.5rem;\r\n      padding-left: 0.5rem;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 576px){\r\n  .navbar[class*='navbar-toggleable-'] .container{\r\n      margin-left: 0;\r\n      margin-right: 0;\r\n  }\r\n  .navbar .navbar-wrapper {\r\n    .navbar-toggle{\r\n      transition: all 1s;\r\n    }\r\n  }\r\n  .navbar .navbar-wrapper {\r\n    .navbar-toggle.toggled{\r\n      left: -20px;\r\n      position: relative;\r\n      right: unset;\r\n      transition: all 1s;\r\n    }\r\n  }\r\n  .rtl {\r\n    .navbar .navbar-wrapper {\r\n      .navbar-toggle.toggled{\r\n        right: -35px;\r\n        position: relative;\r\n        left: unset;\r\n        transition: all 1s;\r\n      }\r\n    }\r\n  }\r\n}\r\n","body {\r\n  -moz-osx-font-smoothing: grayscale;\r\n  -webkit-font-smoothing: antialiased;\r\n}\r\n\r\nh1, h2, h3, h4, h5, h6,\r\n.h1, .h2, .h3, .h4, .h5, .h6 {\r\n  line-height: $headings-line-height;\r\n\r\n}\r\np{\r\n  font-weight: $font-weight-light;\r\n}\r\n\r\nbutton,\r\ninput,\r\noptgroup,\r\nselect,\r\ntextarea{\r\n    font-family: $font-family-base;\r\n}\r\n.card{\r\n  h1,h2,h3,h4,h5,h6,p{\r\n    color: $opacity-8;\r\n  }\r\n}\r\nh1,h2,h3,h4,h5,h6{\r\n    font-weight: $font-weight-normal;\r\n    color: $opacity-8;\r\n}\r\n\r\na{\r\n    color: $primary-states;\r\n    font-weight: $font-weight-light;\r\n    &:hover,\r\n    &:focus{\r\n        color: $primary;\r\n    }\r\n}\r\nh1, .h1 {\r\n    line-height: 1.05;\r\n    margin-bottom: $margin-base-vertical * 2;\r\n\r\n    small{\r\n        font-weight: $font-weight-bold;\r\n        text-transform: uppercase;\r\n        opacity: .8;\r\n    }\r\n\r\n}\r\nh2, .h2{\r\n    margin-bottom: $margin-base-vertical * 2;\r\n    line-height: 1.2;\r\n\r\n}\r\nh3, .h3{\r\n    margin-bottom: $margin-base-vertical * 2;\r\n    line-height: 1.4em;\r\n}\r\nh4, .h4{\r\n    line-height: 1.45em;\r\n    margin-bottom: $margin-base-vertical;\r\n\r\n    & + .category,\r\n    &.title + .category{\r\n        margin-top: -10px;\r\n    }\r\n}\r\nh5, .h5 {\r\n    line-height: 1.4em;\r\n    margin-bottom: 15px;\r\n}\r\nh6, .h6{\r\n    text-transform: uppercase;\r\n    font-weight: $font-weight-bold;\r\n}\r\np{\r\n    color: $opacity-8;\r\n    margin-bottom: 5px;\r\n\r\n    &.description{\r\n        font-size: 1.14em;\r\n    }\r\n}\r\n\r\n\r\n.title{\r\n    font-weight: $font-weight-bold;\r\n    &.title-up{\r\n        text-transform: uppercase;\r\n\r\n        a{\r\n            color: $black;\r\n            text-decoration: none;\r\n        }\r\n    }\r\n    & + .category{\r\n        margin-top: -10px;\r\n    }\r\n}\r\n\r\n.description,\r\n.card-description,\r\n.footer-big p,\r\n.card .footer .stats{\r\n    color: $dark-gray;\r\n    font-weight: $font-weight-light;\r\n}\r\n.category,\r\n.card-category{\r\n    text-transform: capitalize;\r\n    font-weight: $font-weight-normal;\r\n    color: rgba($white, 0.6);\r\n    font-size: $font-size-sm;\r\n}\r\n\r\n.card-category{\r\n    font-size: $font-size-sm;\r\n}\r\n\r\n.blockquote{\r\n    border-left: none;\r\n    border: 1px solid $default;\r\n    padding: 20px;\r\n    font-size: $blockquote-font-size;\r\n    line-height: 1.8;\r\n\r\n    small{\r\n        color: $default;\r\n        font-size: $font-size-sm;\r\n        text-transform: uppercase;\r\n    }\r\n\r\n    &.blockquote-primary{\r\n        border-color: $primary;\r\n        color: $primary;\r\n\r\n        small{\r\n            color: $primary;\r\n        }\r\n    }\r\n\r\n    &.blockquote-danger{\r\n        border-color: $danger;\r\n        color: $danger;\r\n\r\n        small{\r\n            color: $danger;\r\n        }\r\n    }\r\n\r\n    &.blockquote-white{\r\n        border-color: $opacity-8;\r\n        color: $white;\r\n\r\n        small{\r\n            color: $opacity-8;\r\n        }\r\n    }\r\n}\r\n\r\nul li, ol li{\r\n  color: $white;\r\n}\r\n\r\npre{\r\n  color: $opacity-8;\r\n}\r\n\r\nhr{\r\n  border-top: 1px solid rgba(0,0,0,0.1);\r\n  margin-top: $spacer;\r\n  margin-bottom: $spacer;\r\n}\r\n",".table{\r\n  > tbody > tr > td {\r\n    color: rgba(255, 255, 255, 0.7) !important;\r\n\r\n    .photo {\r\n      height: 30px;\r\n      width: 30px;\r\n      border-radius: 50%;\r\n      overflow: hidden;\r\n      margin: 0 auto;\r\n\r\n      img {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n\r\n  > tbody > tr.table-success > td{\r\n    background-color: darken($success,10%);\r\n  }\r\n\r\n  > tbody > tr.table-info > td{\r\n    background-color: $info;\r\n  }\r\n\r\n  > tbody > tr.table-primary > td{\r\n    background-color: $primary;\r\n  }\r\n\r\n  > tbody > tr.table-warning > td{\r\n    background-color: $warning;\r\n  }\r\n  > tbody > tr.table-danger > td{\r\n    background-color: $danger;\r\n  }\r\n\r\n    .img-wrapper{\r\n      width: 40px;\r\n      height: 40px;\r\n      border-radius: 50%;\r\n      overflow: hidden;\r\n      margin: 0 auto;\r\n    }\r\n\r\n    .img-row{\r\n      max-width: 60px;\r\n      width: 60px;\r\n    }\r\n\r\n    .form-check{\r\n        margin: 0;\r\n        margin-top: 5px;\r\n\r\n        & label .form-check-sign::before,\r\n        & label .form-check-sign::after{\r\n            top: -17px;\r\n            left: 4px;\r\n        }\r\n    }\r\n\r\n    .btn{\r\n        margin: 0;\r\n    }\r\n\r\n    small,.small{\r\n      font-weight: 300;\r\n    }\r\n\r\n    .card-tasks .card-body &{\r\n        margin-bottom: 0;\r\n\r\n        > thead > tr > th,\r\n        > tbody > tr > th,\r\n        > tfoot > tr > th,\r\n        > thead > tr > td,\r\n        > tbody > tr > td,\r\n        > tfoot > tr > td{\r\n            padding-top: 5px;\r\n            padding-bottom: 5px;\r\n        }\r\n    }\r\n\r\n   > thead > tr > th{\r\n       border-bottom-width: 1px;\r\n       font-size: 12px;\r\n       text-transform: uppercase;\r\n       font-weight: $font-weight-extra-bold;\r\n       border: 0;\r\n       color: rgba($white, 0.7);\r\n   }\r\n\r\n   .radio,\r\n   .checkbox{\r\n       margin-top: 0;\r\n       margin-bottom: 0;\r\n       padding: 0;\r\n       width: 15px;\r\n\r\n       .icons{\r\n           position: relative;\r\n       }\r\n\r\n        label{\r\n            &:after,\r\n            &:before{\r\n                top: -17px;\r\n                left: -3px;\r\n            }\r\n        }\r\n   }\r\n   > thead > tr > th,\r\n   > tbody > tr > th,\r\n   > tfoot > tr > th,\r\n   > thead > tr > td,\r\n   > tbody > tr > td,\r\n   > tfoot > tr > td{\r\n       border-color: rgba(255, 255, 255, 0.1);\r\n       padding: 12px 7px;\r\n       vertical-align: middle;\r\n   }\r\n\r\n   &.table-shopping tbody tr:last-child td{\r\n      border: none;\r\n   }\r\n\r\n   .th-description{\r\n       max-width: 150px;\r\n   }\r\n   .td-price{\r\n       font-size: 26px;\r\n       font-weight: $font-weight-light;\r\n       margin-top: 5px;\r\n       position: relative;\r\n       top: 4px;\r\n       text-align: right;\r\n   }\r\n   .td-total{\r\n        font-weight: $font-weight-bold;\r\n        font-size: $h5-font-size;\r\n        padding-top: 20px;\r\n        text-align: right;\r\n    }\r\n\r\n   .td-actions .btn{\r\n    margin: 0px;\r\n    }\r\n\r\n    > tbody > tr{\r\n        position: relative;\r\n    }\r\n\r\n    > tfoot > tr {\r\n      color: hsla(0,0%,100%,.7);\r\n      text-transform: uppercase;\r\n    }\r\n}\r\n\r\n.table-responsive{\r\n  overflow: scroll;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n#tables .table-responsive{\r\n    margin-bottom: 30px;\r\n}\r\n",".form-check{\r\n margin-top: .5rem;\r\n padding-left: 0;\r\n}\r\n\r\n.form-check .form-check-label{\r\n  display: inline-block;\r\n  position: relative;\r\n  cursor: pointer;\r\n  padding-left: 25px;\r\n  line-height: 18px;\r\n  margin-bottom: 0;\r\n  -webkit-transition: color 0.3s linear;\r\n  -moz-transition: color 0.3s linear;\r\n  -o-transition: color 0.3s linear;\r\n  -ms-transition: color 0.3s linear;\r\n  transition: color 0.3s linear;\r\n}\r\n.radio .form-check-sign{\r\n    padding-left: 28px;\r\n}\r\n\r\n.form-check-radio.form-check-inline .form-check-label {\r\n  padding-left: 5px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.form-check .form-check-sign::before,\r\n.form-check .form-check-sign::after{\r\n  content: \" \";\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 17px;\r\n  height: 17px;\r\n  left: 0;\r\n  cursor: pointer;\r\n  border-radius: 3px;\r\n  top: 0;\r\n  border: 1px solid darken($dark-gray,10%);\r\n  -webkit-transition: opacity 0.3s linear;\r\n  -moz-transition: opacity 0.3s linear;\r\n  -o-transition: opacity 0.3s linear;\r\n  -ms-transition: opacity 0.3s linear;\r\n  transition: opacity 0.3s linear;\r\n}\r\n\r\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::before,\r\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::before{\r\n  border: none;\r\n  background-color: $primary;\r\n}\r\n\r\n .form-check .form-check-sign::after{\r\n  font-family: 'nucleo';\r\n  content: \"\\ea1b\";\r\n  top: 0px;\r\n  text-align: center;\r\n  font-size: 14px;\r\n  opacity: 0;\r\n  color: $white;\r\n  font-weight: $font-weight-bold;\r\n  border: 0;\r\n  background-color: inherit;\r\n}\r\n\r\n.form-check.disabled .form-check-label,\r\n.form-check.disabled .form-check-label {\r\n    color: $dark-gray;\r\n    opacity: .5;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.form-check input[type=\"checkbox\"],\r\n.radio input[type=\"radio\"]{\r\n  opacity: 0;\r\n  position: absolute;\r\n  visibility: hidden;\r\n}\r\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::after{\r\n  opacity: 1;\r\n  font-size: 10px;\r\n  margin-top: 0;\r\n}\r\n\r\n\r\n.form-check input[type=\"checkbox\"]+ .form-check-sign::after{\r\n  opacity: 0;\r\n  font-size: 10px;\r\n  margin-top: 0;\r\n}\r\n\r\n.form-control input[type=\"checkbox\"]:disabled + .form-check-sign::before,\r\n.checkbox input[type=\"checkbox\"]:disabled + .form-check-sign::after{\r\n    cursor: not-allowed;\r\n}\r\n\r\n.form-check input[type=\"checkbox\"]:disabled + .form-check-sign,\r\n.form-check input[type=\"radio\"]:disabled + .form-check-sign{\r\n    pointer-events: none;\r\n}\r\n\r\n.form-check-radio .form-check-label{\r\n  padding-top: 3px;\r\n}\r\n.form-check-radio .form-check-sign::before,\r\n.form-check-radio .form-check-sign::after{\r\n  content: \" \";\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 50%;\r\n  border: 1px solid darken($dark-gray,10%);\r\n  display: inline-block;\r\n  position: absolute;\r\n  left: 0px;\r\n  top: 3px;\r\n  padding: 1px;\r\n  -webkit-transition: opacity 0.3s linear;\r\n  -moz-transition: opacity 0.3s linear;\r\n  -o-transition: opacity 0.3s linear;\r\n  -ms-transition: opacity 0.3s linear;\r\n  transition: opacity 0.3s linear;\r\n}\r\n\r\n.form-check-radio input[type=\"radio\"] + .form-check-sign:after,\r\n.form-check-radio input[type=\"radio\"] {\r\n    opacity: 0;\r\n}\r\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\r\n    width: 6px;\r\n    height: 6px;\r\n    background-color: $primary;\r\n    border-color: $primary;\r\n    top: 9px;\r\n    left: 6px;\r\n    opacity: 1;\r\n}\r\n\r\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::before {\r\n  border-color: $primary;\r\n}\r\n\r\n\r\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after{\r\n    opacity: 1;\r\n}\r\n\r\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign {\r\n  color: $dark-gray;\r\n}\r\n\r\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::before,\r\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::after {\r\n  color: $dark-gray;\r\n}\r\n",".fixed-plugin{\r\n    position: fixed;\r\n    right: 0;\r\n    width: 64px;\r\n    background: rgba(0,0,0,.3);\r\n    z-index: 1031;\r\n    border-radius: 8px 0 0 8px;\r\n    text-align: center;\r\n    top: 130px;\r\n\r\n    li > a,\r\n    .badge{\r\n        transition: all .34s;\r\n        -webkit-transition: all .34s;\r\n        -moz-transition: all .34s;\r\n    }\r\n\r\n    .fa-cog{\r\n        color: $white;\r\n        padding: 10px;\r\n        border-radius: 0 0 6px 6px;\r\n        width: auto;\r\n    }\r\n\r\n    .dropdown-menu{\r\n        right: 80px;\r\n        left: auto !important;\r\n        top: -52px !important;\r\n        width: 290px;\r\n        border-radius: 0.1875rem;\r\n        padding: 0 10px;\r\n        background: linear-gradient($black, $black-states);\r\n    }\r\n\r\n    .dropdown .dropdown-menu .tim-icons{\r\n      top: 5px;\r\n    }\r\n\r\n    .dropdown-menu:after,\r\n    .dropdown-menu:before{\r\n        right: 10px;\r\n        margin-left: auto;\r\n        left: auto;\r\n    }\r\n\r\n    .fa-circle-thin{\r\n        color: $white;\r\n    }\r\n\r\n    .active .fa-circle-thin{\r\n        color: $active-blue;\r\n    }\r\n\r\n    .dropdown-menu > .active > a,\r\n    .dropdown-menu > .active > a:hover,\r\n    .dropdown-menu > .active > a:focus{\r\n        color: $active-gray;\r\n        text-align: center;\r\n    }\r\n\r\n    img{\r\n        border-radius: 0;\r\n        width: 100%;\r\n        height: 100px;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    .dropdown-menu li > a:hover,\r\n    .dropdown-menu li > a:focus{\r\n        box-shadow: none;\r\n    }\r\n\r\n    .badge{\r\n        border: 2px solid $white;\r\n        border-radius: 50%;\r\n        cursor: pointer;\r\n        display: inline-block;\r\n        height: 23px;\r\n        margin-right: 5px;\r\n        position: relative;\r\n        width: 23px;\r\n    }\r\n\r\n    .badge.active,\r\n    .badge:hover{\r\n        border-color: $black-states;\r\n    }\r\n\r\n    .light-badge, .dark-badge{\r\n      margin:0;\r\n      border: 1px solid $info;\r\n      &:hover{\r\n        border: 1px solid $info;\r\n      }\r\n    }\r\n\r\n    .light-badge{\r\n      background: $white;\r\n      &:hover{\r\n        background: $white;\r\n      }\r\n    }\r\n\r\n    .dark-badge{\r\n      background: $black;\r\n      &:hover{\r\n        background: $black;\r\n      }\r\n    }\r\n\r\n    h5{\r\n      margin: 10px;\r\n    }\r\n\r\n    .dropdown-menu li{\r\n        display: block;\r\n        padding: 18px 2px;\r\n        width: 25%;\r\n        float: left;\r\n    }\r\n\r\n    li.adjustments-line,\r\n    li.header-title,\r\n    li.button-container{\r\n        width: 100%;\r\n        height: 50px;\r\n        min-height: inherit;\r\n    }\r\n\r\n    li.button-container{\r\n        height: auto;\r\n\r\n        div{\r\n            margin-bottom: 5px;\r\n        }\r\n    }\r\n\r\n    #sharrreTitle{\r\n        text-align: center;\r\n        padding: 10px 0;\r\n        height: 50px;\r\n    }\r\n\r\n    li.header-title{\r\n        color: $white;\r\n        height: 30px;\r\n        line-height: 25px;\r\n        font-size: 12px;\r\n        font-weight: 600;\r\n        text-align: center;\r\n        text-transform: uppercase;\r\n    }\r\n\r\n    .adjustments-line{\r\n\r\n        a{\r\n            color: transparent;\r\n\r\n            .badge-colors{\r\n                position: relative;\r\n                top: -2px;\r\n            }\r\n\r\n            a:hover,\r\n            a:focus{\r\n                color: transparent;\r\n            }\r\n        }\r\n\r\n        .togglebutton{\r\n            text-align: center;\r\n\r\n            .label-switch{\r\n              position: relative;\r\n              left: -10px;\r\n              font-size: $font-size-xs;\r\n              color: $white;\r\n\r\n              &.label-right{\r\n                left: 10px;\r\n              }\r\n            }\r\n\r\n            .toggle{\r\n                margin-right: 0;\r\n            }\r\n        }\r\n\r\n        .color-label{\r\n          position: relative;\r\n          top: -7px;\r\n          font-size: $font-size-xs;\r\n          color: $white;\r\n        }\r\n\r\n        .dropdown-menu > li.adjustments-line > a{\r\n              padding-right: 0;\r\n              padding-left: 0;\r\n              border-bottom: 1px solid #ddd;\r\n              border-radius: 0;\r\n              margin: 0;\r\n        }\r\n    }\r\n\r\n\r\n\r\n    .dropdown-menu{\r\n        > li{\r\n            & > a.img-holder{\r\n                  font-size: $font-paragraph;\r\n                  text-align: center;\r\n                  border-radius: 10px;\r\n                  background-color: $white;\r\n                  border: 3px solid $white;\r\n                  padding-left: 0;\r\n                  padding-right: 0;\r\n                  opacity: 1;\r\n                  cursor: pointer;\r\n                  display: block;\r\n                  max-height: 100px;\r\n                  overflow: hidden;\r\n                  padding: 0;\r\n\r\n                  img{\r\n                     margin-top: auto;\r\n                  }\r\n            }\r\n\r\n            a.switch-trigger:hover,\r\n            & > a.switch-trigger:focus{\r\n                background-color: transparent;\r\n            }\r\n\r\n            &:hover,\r\n            &:focus{\r\n                > a.img-holder{\r\n                    border-color: rgba(0, 187, 255, 0.53);;\r\n                }\r\n            }\r\n        }\r\n\r\n        > .active > a.img-holder,\r\n        > .active > a.img-holder{\r\n            border-color: $active-blue;\r\n            background-color: $white;\r\n        }\r\n\r\n    }\r\n\r\n    .btn-social{\r\n        width: 50%;\r\n        display: block;\r\n        width: 48%;\r\n        float: left;\r\n        font-weight: 600;\r\n    }\r\n\r\n    .btn-social{\r\n        i{\r\n            margin-right: 5px;\r\n        }\r\n\r\n        &:first-child{\r\n            margin-right: 2%;\r\n        }\r\n    }\r\n\r\n    .dropdown{\r\n        .dropdown-menu{\r\n             -webkit-transform: translateY(-15%);\r\n             -moz-transform: translateY(-15%);\r\n             -o-transform: translateY(-15%);\r\n             -ms-transform: translateY(-15%);\r\n             transform: translateY(-15%);\r\n             top: 27px;\r\n             opacity: 0;\r\n\r\n             transform-origin: 0 0;\r\n\r\n             &:before{\r\n                 border-bottom: .4em solid rgba(0, 0, 0, 0);\r\n                 border-left: .4em solid rgba(0,0,0,0.2);\r\n                 border-top: .4em solid rgba(0,0,0,0);\r\n                 right: -16px;\r\n                 top: 46px;\r\n             }\r\n\r\n             &:after{\r\n                 border-bottom: .4em solid rgba(0, 0, 0, 0);\r\n                 border-left: .4em solid $black;\r\n                 border-top: .4em solid rgba(0,0,0,0);\r\n                 right: -16px;\r\n             }\r\n\r\n             &:before,\r\n             &:after{\r\n                 content: \"\";\r\n                 display: inline-block;\r\n                 position: absolute;\r\n                 top: 74px;\r\n                 width: 16px;\r\n                 transform: translateY(-50%);\r\n                 -webkit-transform: translateY(-50%);\r\n                 -moz-transform: translateY(-50%);\r\n             }\r\n        }\r\n\r\n        &.show .dropdown-menu{\r\n             opacity: 1;\r\n\r\n             -webkit-transform: translateY(-13%);\r\n             -moz-transform: translateY(-13%);\r\n             -o-transform: translateY(-13%);\r\n             -ms-transform: translateY(-13%);\r\n             transform: translateY(-13%);\r\n\r\n             transform-origin: 0 0;\r\n        }\r\n    }\r\n\r\n    .bootstrap-switch{\r\n        margin:0;\r\n    }\r\n}\r\n",".wrapper {\r\n  // position: relative;\r\n  top: 0;\r\n  // height: 100vh;\r\n  min-height: 100vh;\r\n\r\n  &.wrapper-full-page {\r\n    min-height: 100vh;\r\n    height: auto;\r\n  }\r\n}\r\n\r\n.sidebar-wrapper ul li div.collapse ul li div.collapse ul li a,\r\n.sidebar-wrapper ul li div.collapse ul li div.collapsing ul li a,\r\n.sidebar-wrapper ul li div.collapsing ul li div.collapse ul li a {\r\n  margin-left: 25px;\r\n}\r\n.sidebar,\r\n.off-canvas-sidebar {\r\n  @include linear-gradient($primary-states, $primary);\r\n  height: calc(100vh - 90px);\r\n  width: 230px;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 1;\r\n  background-size: cover;\r\n  background-position: center center;\r\n  display: block;\r\n  box-shadow: 0px 0px 45px 0px rgba(0, 0, 0, 0.6);\r\n  margin-top: 70px;\r\n  // margin-left: 20px;\r\n  border-radius: 5px;\r\n\r\n  .sidebar-wrapper {\r\n    width: $full-width;\r\n    min-height: 100%;\r\n    max-height: calc(100vh - 705px);\r\n    z-index: 4;\r\n    position: relative;\r\n    overflow: auto;\r\n\r\n    .dropdown .dropdown-backdrop {\r\n      display: none !important;\r\n    }\r\n\r\n    .navbar-form {\r\n      border: none;\r\n    }\r\n\r\n    > .nav,\r\n    .user .info {\r\n      [data-toggle='collapse'] ~ div > ul > li > a {\r\n        span {\r\n          display: inline-block;\r\n          // @extend .animation-transition-general;\r\n        }\r\n\r\n        .sidebar-normal {\r\n          margin: 0;\r\n          position: relative;\r\n          transform: translateX(0px);\r\n          opacity: 1;\r\n          white-space: nowrap;\r\n          display: block;\r\n          line-height: 23px;\r\n          z-index: 1;\r\n          color: $opacity-8;\r\n        }\r\n\r\n        .sidebar-mini-icon {\r\n          text-transform: uppercase;\r\n          width: 34px;\r\n          margin-right: 10px;\r\n          margin-left: 0px;\r\n          font-size: 12px;\r\n          text-align: center;\r\n          line-height: 25px;\r\n          position: relative;\r\n          float: left;\r\n          z-index: 1;\r\n          display: inherit;\r\n          line-height: 24px;\r\n          color: $opacity-8;\r\n        }\r\n\r\n        i {\r\n          font-size: 17px;\r\n          line-height: 20px;\r\n          width: 26px;\r\n        }\r\n      }\r\n    }\r\n\r\n    [data-toggle='collapse'] ~ div > ul > li:hover > a {\r\n      .sidebar-mini-icon,\r\n      .sidebar-normal {\r\n        color: $white;\r\n      }\r\n    }\r\n\r\n    .nav [data-toggle='collapse'] ~ div > ul > li > a .sidebar-mini-icon {\r\n      opacity: 0;\r\n    }\r\n  }\r\n\r\n  .navbar-minimize {\r\n    position: absolute;\r\n    right: 20px;\r\n    top: 2px;\r\n    opacity: 1;\r\n\r\n    // @extend .animation-transition-general;\r\n  }\r\n  .logo-tim {\r\n    border-radius: 50%;\r\n    border: 1px solid #333;\r\n    display: block;\r\n    height: 61px;\r\n    width: 61px;\r\n    float: left;\r\n    overflow: hidden;\r\n\r\n    img {\r\n      width: 60px;\r\n      height: 60px;\r\n    }\r\n  }\r\n\r\n  .nav {\r\n    margin-top: 20px;\r\n    display: block;\r\n\r\n    .caret {\r\n      top: 14px;\r\n      position: absolute;\r\n      right: 10px;\r\n    }\r\n\r\n    li {\r\n      > a + div .nav {\r\n        margin-top: 5px;\r\n        li > a {\r\n          margin-top: 0px;\r\n          padding: 8px 8px;\r\n        }\r\n      }\r\n\r\n      > a {\r\n        margin: 10px 15px 0;\r\n        border-radius: $btn-round-radius;\r\n        color: $white;\r\n        display: block;\r\n        text-decoration: none;\r\n        position: relative;\r\n        text-transform: uppercase;\r\n        cursor: pointer;\r\n        font-size: $font-size-xs;\r\n        padding: 10px 8px;\r\n        line-height: $line-height-lg;\r\n      }\r\n\r\n      &:first-child > a {\r\n        margin: 0 15px;\r\n      }\r\n\r\n      &:hover:not(.active) > a,\r\n      &:focus:not(.active) > a {\r\n        p,\r\n        i {\r\n          color: $white;\r\n        }\r\n      }\r\n\r\n      &:hover:not(.active) > a i,\r\n      &:focus:not(.active) > a i {\r\n        color: $white;\r\n      }\r\n\r\n      &.active > a:not([data-toggle='collapse']) {\r\n        background: transparent;\r\n\r\n        i,\r\n        p {\r\n          color: white;\r\n        }\r\n\r\n        &:before {\r\n          content: ' ';\r\n          position: absolute;\r\n          height: 6px;\r\n          width: 6px;\r\n          top: 22px;\r\n          left: -4px;\r\n          background: $white;\r\n          border-radius: 50%;\r\n        }\r\n      }\r\n\r\n      &.active > a[data-toggle='collapse'] {\r\n        background: transparent;\r\n        box-shadow: none;\r\n        color: $white;\r\n\r\n        i {\r\n          color: $white;\r\n        }\r\n\r\n        & + div .nav .active a {\r\n          box-shadow: none;\r\n          .sidebar-mini-icon,\r\n          .sidebar-normal {\r\n            color: $white;\r\n            font-weight: $font-weight-normal;\r\n          }\r\n\r\n          &:before {\r\n            content: ' ';\r\n            position: absolute;\r\n            height: 6px;\r\n            width: 6px;\r\n            top: 17px;\r\n            left: -4px;\r\n            background: $white;\r\n            border-radius: 50%;\r\n          }\r\n        }\r\n        &:before {\r\n          content: ' ';\r\n          position: absolute;\r\n          height: 6px;\r\n          width: 6px;\r\n          top: 22px;\r\n          left: -4px;\r\n          background: rgba($white, 0.6);\r\n          border-radius: 50%;\r\n        }\r\n      }\r\n    }\r\n\r\n    p {\r\n      margin: 0;\r\n      line-height: 30px;\r\n      position: relative;\r\n      display: block;\r\n      height: auto;\r\n      white-space: nowrap;\r\n      @extend .animation-transition-general;\r\n    }\r\n\r\n    i {\r\n      font-size: 20px;\r\n      float: left;\r\n      margin-right: 12px;\r\n      line-height: 30px;\r\n      width: 34px;\r\n      text-align: center;\r\n      color: $opacity-8;\r\n      position: relative;\r\n    }\r\n  }\r\n\r\n  .logo {\r\n    position: relative;\r\n    padding: $padding-base-vertical $padding-base-horizontal;\r\n    z-index: 4;\r\n\r\n    a.logo-mini,\r\n    a.logo-normal {\r\n      @extend .animation-transition-general;\r\n    }\r\n\r\n    a.logo-mini {\r\n      opacity: 1;\r\n      float: left;\r\n      width: 34px;\r\n      text-align: center;\r\n      margin-left: 12px;\r\n      margin-right: 12px;\r\n      img {\r\n        border-radius: 50%;\r\n        width: 30px;\r\n      }\r\n    }\r\n\r\n    a.logo-normal {\r\n      display: block;\r\n      opacity: 1;\r\n      @include transform-translate-x(0px);\r\n    }\r\n\r\n    &:after {\r\n      content: '';\r\n      position: absolute;\r\n      bottom: 0;\r\n      right: 15px;\r\n      height: 1px;\r\n      width: calc(100% - 30px);\r\n      background: $opacity-5;\r\n    }\r\n\r\n    p {\r\n      float: left;\r\n      font-size: 20px;\r\n      margin: 10px 10px;\r\n      color: $white;\r\n      line-height: 20px;\r\n      font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\r\n    }\r\n\r\n    .simple-text {\r\n      text-transform: uppercase;\r\n      padding: $padding-base-vertical 0;\r\n      display: block;\r\n      white-space: nowrap;\r\n      // font-size: $font-size-base;\r\n      color: $white;\r\n      text-decoration: none;\r\n      font-weight: $font-weight-normal;\r\n      line-height: 30px;\r\n      overflow: hidden;\r\n    }\r\n  }\r\n\r\n  .logo-tim {\r\n    border-radius: 50%;\r\n    border: 1px solid #333;\r\n    display: block;\r\n    height: 61px;\r\n    width: 61px;\r\n    float: left;\r\n    overflow: hidden;\r\n\r\n    img {\r\n      width: 60px;\r\n      height: 60px;\r\n    }\r\n  }\r\n\r\n  &[data='blue'] {\r\n    @include linear-gradient($info-states, $info);\r\n  }\r\n  &[data='green'] {\r\n    @include linear-gradient($success-states, $success);\r\n  }\r\n\r\n  .user {\r\n    padding-bottom: 20px;\r\n    margin: 20px auto 0;\r\n    position: relative;\r\n\r\n    &:after {\r\n      content: '';\r\n      position: absolute;\r\n      bottom: 0;\r\n      right: 15px;\r\n      height: 1px;\r\n      width: calc(100% - 30px);\r\n      background: $opacity-5;\r\n    }\r\n\r\n    .photo {\r\n      width: 34px;\r\n      height: 34px;\r\n      overflow: hidden;\r\n      float: left;\r\n      z-index: 5;\r\n      margin-right: 10px;\r\n      border-radius: 50%;\r\n      margin-left: 23px;\r\n      box-shadow: $box-shadow-raised;\r\n      @extend .animation-transition-general;\r\n\r\n      img {\r\n        width: $full-width;\r\n      }\r\n    }\r\n\r\n    a {\r\n      color: $white;\r\n      text-decoration: none;\r\n      padding: $padding-base-vertical 15px;\r\n      white-space: nowrap;\r\n      @extend .animation-transition-general;\r\n    }\r\n\r\n    .info {\r\n      > a {\r\n        display: block;\r\n        line-height: 18px;\r\n\r\n        > span {\r\n          @extend .animation-transition-general;\r\n          display: block;\r\n          position: relative;\r\n          opacity: 1;\r\n        }\r\n      }\r\n\r\n      .caret {\r\n        position: absolute;\r\n        top: 8px;\r\n        right: 18px;\r\n      }\r\n    }\r\n  }\r\n\r\n  transition: 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);\r\n}\r\n\r\n.visible-on-sidebar-regular {\r\n  display: inline-block !important;\r\n}\r\n.visible-on-sidebar-mini {\r\n  display: none !important;\r\n}\r\n\r\n.off-canvas-sidebar {\r\n  .nav {\r\n    > li > a,\r\n    > li > a:hover {\r\n      color: $white;\r\n    }\r\n\r\n    > li > a:focus {\r\n      background: rgba(200, 200, 200, 0.2);\r\n    }\r\n  }\r\n}\r\n\r\n.main-panel {\r\n  position: relative;\r\n  float: right;\r\n  width: $full-width;\r\n  min-height: 100vh;\r\n  // border-top: 2px solid $primary;\r\n  background: linear-gradient($background-black, $background-states-black);\r\n\r\n  @include transitions(0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\r\n\r\n  // &[data=\"blue\"]{\r\n  //   border-top: 2px solid $info;\r\n  // }\r\n\r\n  // &[data=\"green\"]{\r\n  //   border-top: 2px solid $success;\r\n  // }\r\n\r\n  // &[data=\"primary\"]{\r\n  //   border-top: 2px solid $primary;\r\n  // }\r\n\r\n  > .content {\r\n    // padding: 0px 30px 30px 280px;\r\n    // min-height: calc(100vh - 70px);\r\n  }\r\n\r\n  > .navbar {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .header {\r\n    margin-bottom: 50px;\r\n  }\r\n}\r\n\r\n.perfect-scrollbar-on {\r\n  .main-panel {\r\n    height: 100%;\r\n    max-height: 100%;\r\n  }\r\n}\r\n\r\n.sidebar,\r\n.main-panel,\r\n.sidebar-wrapper {\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n@media (min-width: 991px) {\r\n  .sidebar,\r\n  .main-panel,\r\n  .sidebar-wrapper {\r\n    -webkit-transition-property: top, bottom, width;\r\n    transition-property: top, bottom, width;\r\n    -webkit-transition-duration: 0.2s, 0.2s, 0.35s;\r\n    transition-duration: 0.2s, 0.2s, 0.35s;\r\n    -webkit-transition-timing-function: linear, linear, ease;\r\n    transition-timing-function: linear, linear, ease;\r\n  }\r\n\r\n  .sidebar-mini {\r\n    .visible-on-sidebar-regular {\r\n      display: none !important;\r\n    }\r\n    .visible-on-sidebar-mini {\r\n      display: inline-block !important;\r\n    }\r\n\r\n    .sidebar {\r\n      width: 80px;\r\n\r\n      .sidebar-wrapper {\r\n        width: 100% !important;\r\n      }\r\n    }\r\n\r\n    .sidebar {\r\n      display: block;\r\n      z-index: 1030;\r\n      box-shadow: $sidebar-box-shadow;\r\n\r\n      .logo {\r\n        a.logo-normal {\r\n          opacity: 0;\r\n          @include transform-translate-x(-25px);\r\n        }\r\n      }\r\n\r\n      .sidebar-wrapper {\r\n        > .nav [data-toggle='collapse'] ~ div > ul > li > a .sidebar-normal,\r\n        .user .info [data-toggle='collapse'] ~ div > ul > li > a .sidebar-normal,\r\n        .user .info > a > span,\r\n        > .nav li > a p {\r\n          @include transform-translate-x(-25px);\r\n          opacity: 0;\r\n        }\r\n      }\r\n\r\n      .nav [data-toggle='collapse'] ~ div > ul > li > a .sidebar-mini-icon {\r\n        opacity: 1;\r\n      }\r\n    }\r\n\r\n    .sidebar:hover {\r\n      width: 260px;\r\n\r\n      .logo {\r\n        a.logo-normal {\r\n          opacity: 1;\r\n          @include transform-translate-x(0);\r\n        }\r\n      }\r\n\r\n      .navbar-minimize {\r\n        opacity: 1;\r\n      }\r\n      .sidebar-wrapper {\r\n        width: 260px;\r\n\r\n        > .nav li > a p,\r\n        > .nav [data-toggle='collapse'] ~ div > ul > li > a .sidebar-normal,\r\n        .user .info [data-toggle='collapse'] ~ div > ul > li > a .sidebar-normal,\r\n        .user .info > a > span {\r\n          @include transform-translate-x(0px);\r\n          opacity: 1;\r\n        }\r\n      }\r\n\r\n      .nav [data-toggle='collapse'] ~ div > ul > li > a .sidebar-mini-icon {\r\n        opacity: 0;\r\n      }\r\n    }\r\n\r\n    .main-panel {\r\n      > .content {\r\n        padding-left: 130px;\r\n        padding-right: 50px;\r\n      }\r\n    }\r\n\r\n    footer {\r\n      padding-left: 0px;\r\n    }\r\n  }\r\n\r\n  .navbar-minimize {\r\n    button {\r\n      margin-left: 10px;\r\n      i {\r\n        color: $white;\r\n        font-size: 20px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.panel-header {\r\n  height: 260px;\r\n  padding-top: 80px;\r\n  padding-bottom: 45px;\r\n  // background: #141e30; /* fallback for old browsers */\r\n  // background: -webkit-gradient(linear, left top, right top, from(#0c2646), color-stop(60%, #204065), to(#2a5788));\r\n  // background: linear-gradient(to right, #0c2646 0%, #204065 60%, #2a5788 100%);\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  .header {\r\n    .title {\r\n      color: $white;\r\n    }\r\n    .category {\r\n      max-width: 600px;\r\n      color: $opacity-5;\r\n      margin: 0 auto;\r\n      font-size: 13px;\r\n\r\n      a {\r\n        color: $white;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.panel-header-sm {\r\n  height: 135px;\r\n}\r\n\r\n.panel-header-lg {\r\n  height: 380px;\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n  .sidebar {\r\n    position: fixed;\r\n    display: block;\r\n    top: 0;\r\n    height: 100%;\r\n    width: 260px;\r\n    right: auto;\r\n    left: 0;\r\n    margin: 0;\r\n    border-radius: 0;\r\n    z-index: 1032;\r\n    visibility: visible;\r\n    overflow-y: visible;\r\n    padding: 0;\r\n    @include transition(0.5s cubic-bezier(0.685, 0.0473, 0.346, 1));\r\n    @include transform-translate-x(-260px);\r\n  }\r\n\r\n  .wrapper {\r\n    @include transition(0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\r\n  }\r\n\r\n  .main-panel {\r\n    width: 100%;\r\n    .content {\r\n      padding-left: 30px;\r\n    }\r\n  }\r\n\r\n  .nav-open {\r\n    .main-panel {\r\n      right: 0;\r\n      @include transform-translate-x(260px);\r\n    }\r\n\r\n    .sidebar {\r\n      @include transition(0.5s cubic-bezier(0.685, 0.0473, 0.346, 1));\r\n      @include transform-translate-x(0px);\r\n      &:before {\r\n        content: unset;\r\n      }\r\n    }\r\n\r\n    body {\r\n      position: relative;\r\n      overflow-x: hidden;\r\n    }\r\n\r\n    .menu-on-right {\r\n      .main-panel {\r\n        @include transform-translate-x(-260px);\r\n      }\r\n\r\n      .navbar-collapse,\r\n      .sidebar {\r\n        @include transform-translate-x(0px);\r\n      }\r\n\r\n      #bodyClick {\r\n        right: 260px;\r\n        left: auto;\r\n      }\r\n    }\r\n    .fixed-plugin {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .menu-on-right {\r\n    .sidebar {\r\n      left: auto;\r\n      right: 0;\r\n      @include transform-translate-x(260px);\r\n    }\r\n  }\r\n\r\n  #bodyClick {\r\n    height: 100%;\r\n    width: 100%;\r\n    position: fixed;\r\n    opacity: 1;\r\n    top: 0;\r\n    right: 0;\r\n    left: 260px;\r\n    content: '';\r\n    z-index: 9999;\r\n    overflow-x: hidden;\r\n    background-color: transparent;\r\n    @include transition(0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\r\n  }\r\n  .navbar .dropdown-menu {\r\n    position: static !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .main-panel .content {\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n  }\r\n}\r\n","\r\n/* Animations */\r\n.nav-pills .nav-link,\r\n.navbar,\r\n.nav-tabs .nav-link,\r\n.sidebar .nav a,\r\n.sidebar .nav a i,\r\n.sidebar .nav p,\r\n.navbar-collapse .navbar-nav .nav-link,\r\n.animation-transition-general,\r\n.tag,\r\n.tag [data-role=\"remove\"],\r\n.animation-transition-general{\r\n    @include transitions($general-transition-time, $transition-ease);\r\n}\r\n\r\n//transition for dropdown caret\r\n.bootstrap-switch-label:before,\r\n.caret{\r\n    @include transitions($fast-transition-time, $transition-ease);\r\n}\r\n\r\n.dropdown-toggle[aria-expanded=\"true\"]:after,\r\na[data-toggle=\"collapse\"][aria-expanded=\"true\"] .caret,\r\n.card-collapse .card a[data-toggle=\"collapse\"][aria-expanded=\"true\"] i,\r\n.card-collapse .card a[data-toggle=\"collapse\"].expanded i{\r\n    @include rotate-180();\r\n}\r\n\r\n.caret{\r\n  width: 0;\r\n  height: 0;\r\n  vertical-align: middle;\r\n  border-top: 4px dashed;\r\n  border-right: 4px solid transparent;\r\n  border-left: 4px solid transparent;\r\n  margin-top: -5px;\r\n  position: absolute;\r\n  top: 30px;\r\n  margin-left: 5px;\r\n}\r\n\r\n.pull-left{\r\n  float: left;\r\n}\r\n.pull-right{\r\n  float: right;\r\n}\r\n\r\n\r\n// card user profile page\r\n\r\n.card {\r\n  form {\r\n    label + .form-control {\r\n      margin-bottom: 20px;\r\n    }\r\n  }\r\n}\r\n\r\n.card {\r\n  .map-title {\r\n    color: $white;\r\n  }\r\n\r\n  &.card-chart {\r\n    .gmnoprint,\r\n    .gm-style-cc {\r\n      display: none !important;\r\n    }\r\n  }\r\n}\r\n\r\n// documentation\r\n\r\n.bd-docs {\r\n\r\n  h1,h2,h3,h4,h5,h6,p,ul li,ol li{\r\n    color:#2c2c2c;\r\n  }\r\n\r\n\r\n  .bd-content>table>thead>tr>th {\r\n    color: $black;\r\n\r\n  }\r\n\r\n  .blockquote, .blockquote p, .card p{\r\n    color: rgba($white,0.8);\r\n  }\r\n  .bd-example {\r\n    background: linear-gradient(#1e1e2f,#1e1e24);\r\n\r\n  }\r\n\r\n  .navbar {\r\n    border-top: none;\r\n\r\n    .navbar-nav .nav-link {\r\n      color: rgba(255,255,255,.8) !important;\r\n    }\r\n  }\r\n\r\n  .bd-example {\r\n\r\n    .btn{\r\n      margin: 4px 0;\r\n    }\r\n    .btn .badge {\r\n      display: inline-block;\r\n    }\r\n\r\n    .tim-icons{\r\n      color: $white;\r\n    }\r\n\r\n    .popover .popover-header {\r\n    color: hsla(0,0%,71%,.6);\r\n  }\r\n\r\n\r\n    .popover-body {\r\n      p {\r\n        color: $gray-900;\r\n      }\r\n    }\r\n\r\n    &.tooltip-demo p{\r\n      color: rgba($white,.8);\r\n    }\r\n  }\r\n\r\n  .card.card-body,\r\n  .card .card-body {\r\n    color: hsla(0,0%,100%,.8);\r\n  }\r\n\r\n  label,\r\n  .form-check {\r\n    color: hsla(0,0%,100%,.8);\r\n  }\r\n\r\n  .form-check + .btn {\r\n    margin-top: 20px;\r\n  }\r\n\r\n  .bd-example,\r\n  table {\r\n    thead th {\r\n      color: hsla(0,0%,100%,.8);\r\n    }\r\n\r\n    h1, h2, h3, h4, h5, h6,\r\n    .h1, .h2, .h3, .h4, .h5, .h6 {\r\n      color: hsla(0,0%,100%,.8);\r\n    }\r\n\r\n    .datepicker{\r\n      thead th, table thead th,.tim-icons{\r\n        color: $primary;\r\n      }\r\n\r\n    }\r\n\r\n    .picker-switch .tim-icons{\r\n      color: $primary;\r\n    }\r\n  }\r\n\r\n  .footer {\r\n    .container-fluid > nav {\r\n      display: inline-block;\r\n    }\r\n  }\r\n}\r\n.modal.show .modal-dialog {\r\n  -webkit-transform: translate(0,30%);\r\n  transform: translate(0,30%);\r\n}\r\n\r\ncode {\r\n  color: $pink;\r\n}\r\n\r\n@media screen and (max-width: 991px){\r\n    .profile-photo .profile-photo-small{\r\n        margin-left: -2px;\r\n    }\r\n\r\n    .button-dropdown{\r\n        display: none;\r\n    }\r\n\r\n    #searchModal .modal-dialog{\r\n      margin: 20px;\r\n    }\r\n\r\n    #minimizeSidebar{\r\n        display: none;\r\n    }\r\n\r\n}\r\n\r\n\r\n@media screen and (max-width: 768px){\r\n\r\n    .landing-page .section-story-overview .image-container:nth-child(2){\r\n        margin-left: 0;\r\n        margin-bottom: 30px;\r\n    }\r\n\r\n}\r\n\r\n@media screen and (max-width: 576px){\r\n    .page-header{\r\n        .container h6.category-absolute{\r\n            width: 90%;\r\n        }\r\n    }\r\n\r\n    .form-horizontal .col-form-label, .form-horizontal .label-on-right{\r\n      text-align: inherit;\r\n      padding-top: 0;\r\n      code{\r\n        padding: 0 10px;\r\n      }\r\n    }\r\n\r\n}\r\n",".rtl {\r\n  .sidebar,\r\n  .bootstrap-navbar{\r\n    right: 0;\r\n    left: auto;\r\n    margin-right: 20px;\r\n    margin-left: 0;\r\n\r\n    .nav{\r\n        i{\r\n          float: right;\r\n          margin-left: 15px;\r\n          margin-right: 0;\r\n        }\r\n\r\n        p{\r\n          margin-right: 45px;\r\n          text-align: right;\r\n        }\r\n\r\n        .caret{\r\n          left: 11px;\r\n          right: auto;\r\n        }\r\n    }\r\n\r\n    .logo{\r\n        a.logo-mini{\r\n          float: right;\r\n          margin-right: 20px;\r\n          margin-left: 10px;\r\n        }\r\n\r\n        .simple-text{\r\n          text-align: right;\r\n        }\r\n    }\r\n\r\n    .sidebar-wrapper .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-mini-icon,\r\n    .sidebar-wrapper .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-mini-icon{\r\n      float: right;\r\n      margin-left: 15px;\r\n      margin-right: 0;\r\n    }\r\n\r\n    .sidebar-wrapper > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\r\n    .sidebar-wrapper .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal{\r\n      text-align: right;\r\n    }\r\n\r\n    &:before{\r\n      right: 30px;\r\n      left: auto;\r\n    }\r\n  }\r\n\r\n  .main-panel .content{\r\n    padding: 80px 280px 30px 30px;\r\n  }\r\n\r\n  .footer{\r\n    padding: 24px 300px 24px 0;\r\n  }\r\n\r\n  .dropdown-toggle:after{\r\n    margin-right: .255em;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .dropdown-menu.dropdown-menu-right.dropdown-navbar{\r\n    right: -220px !important;\r\n    left: auto;\r\n\r\n    &:before{\r\n      right: auto;\r\n      left: 35px;\r\n    }\r\n  }\r\n\r\n  .notification{\r\n    left: 40px;\r\n    right: auto;\r\n  }\r\n\r\n  .dropdown-menu{\r\n    right: auto;\r\n    left: 0;\r\n  }\r\n\r\n\r\n  .minimize-sidebar{\r\n    float: right;\r\n  }\r\n\r\n  .alert{\r\n    left: 0;\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n      button.close{\r\n        left: 10px !important;\r\n        right: auto !important;\r\n      }\r\n\r\n      span[data-notify=\"icon\"]{\r\n        right: 15px;\r\n        left: auto;\r\n      }\r\n\r\n\r\n\r\n      &.alert-with-icon{\r\n        padding-right: 65px;\r\n        padding-left: 15px;\r\n      }\r\n\r\n      &.alert-with-icon i[data-notify=\"icon\"]{\r\n        right: 15px;\r\n        left: auto;\r\n      }\r\n  }\r\n\r\n  .search-bar{\r\n    margin-left: 0;\r\n  }\r\n\r\n  .modal-search .modal-header .close{\r\n    margin-right: auto;\r\n    left: 10px;\r\n  }\r\n\r\n\r\n  @media (min-width: 991px){\r\n    &.sidebar-mini .main-panel .content {\r\n      padding-right: 130px;\r\n      padding-left: 50px;\r\n    }\r\n\r\n    &.sidebar-mini footer{\r\n      padding-right: 130px;\r\n      padding-left: 50px;\r\n    }\r\n\r\n    .navbar-minimize button{\r\n      margin-right: -5px;\r\n    }\r\n  }\r\n\r\n\r\n\r\n  @media screen and (max-width: 991px){\r\n\r\n    .sidebar{\r\n      margin-right: 0;\r\n    }\r\n    .main-panel .content{\r\n      padding-right: 50px;\r\n    }\r\n\r\n    #bodyClick{\r\n      right: 260px;\r\n      left: auto;\r\n    }\r\n\r\n    .footer{\r\n      padding-right: 15px;\r\n    }\r\n  }\r\n\r\n  .navbar {\r\n    .navbar-nav {\r\n      padding-right: 0;\r\n      a.nav-link {\r\n        text-align: right;\r\n        p{\r\n          margin-right: 7px;\r\n        }\r\n      }\r\n\r\n      .btn {\r\n        margin-right: 0;\r\n        padding: 0;\r\n        i{\r\n          margin-left: 4px;\r\n          margin-right: 5px;\r\n        }\r\n      }\r\n\r\n      .search-bar span{\r\n        margin-right: 10px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .ps__rail-y {\r\n    right: auto !important;\r\n    left: 0;\r\n  }\r\n\r\n  .main-panel {\r\n    position: fixed;\r\n    height: 100%;\r\n    overflow-y: scroll;\r\n    overflow-x: hidden;\r\n  }\r\n  .fixed-plugin {\r\n    border-radius: 0 8px 8px 0;\r\n    left: 0;\r\n    right: unset;\r\n    .dropdown-menu {\r\n      left: 80px !important;\r\n      right: auto !important;\r\n      &:before,&:after {\r\n        left: 10px;\r\n        margin-right: auto;\r\n        right: auto;\r\n      }\r\n      &:before {\r\n        right: unset;\r\n        left: -16px;\r\n        border-left: unset;\r\n        border-right: .4em solid rgba(0,0,0,.2);\r\n      }\r\n      &:after {\r\n        right: unset;\r\n        left: -16px;\r\n        border-left: unset;\r\n        border-right: .4em solid $black;\r\n      }\r\n    }\r\n  }\r\n  .sidebar .nav li.active > a:not([data-toggle=\"collapse\"]):before, .off-canvas-sidebar .nav li.active > a:not([data-toggle=\"collapse\"]):before{\r\n    left: unset;\r\n    right: -4px;\r\n  }\r\n}\r\n\r\n\r\n@media screen and (max-width: 768px){\r\n\r\n  .rtl .main-panel .content{\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n  }\r\n\r\n}\r\n",".form-group.has-danger .error,\r\n.input-group.has-danger .error {\r\n  color: $danger-states;\r\n}\r\n\r\n\r\n.form-group.has-success .error,\r\n.input-group.has-success .error {\r\n  color: $success;\r\n}\r\n\r\n@include form-control-lg-padding($padding-lg-vertical, $padding-input-horizontal);\r\n@include input-base-padding($padding-input-vertical, $padding-input-horizontal);\r\n\r\n.form-group.no-border,\r\n.input-group.no-border{\r\n    .form-control,\r\n    .form-control + .input-group-prepend .input-group-text,\r\n    .form-control + .input-group-append .input-group-text{\r\n\r\n        background-color: lighten($black,1%);\r\n        border: medium none;\r\n        &:focus,\r\n        &:active,\r\n        &:active{\r\n            border: medium none;\r\n            background-color: lighten($black,2%);\r\n        }\r\n    }\r\n\r\n    .form-control{\r\n        &:focus{\r\n            & + .input-group-prepend .input-group-text,\r\n            & + .input-group-append .input-group-text{\r\n                background-color: lighten($black,2%);\r\n            }\r\n        }\r\n    }\r\n\r\n    .input-group-prepend .input-group-text,\r\n    .input-group-append .input-group-text{\r\n        background-color: lighten($black,1%);;\r\n        border: none;\r\n    }\r\n}\r\n\r\n.has-error{\r\n    .form-control-feedback, .control-label{\r\n        color: $danger-states;\r\n    }\r\n}\r\n.has-success{\r\n    .form-control-feedback, .control-label{\r\n        color: $success;\r\n    }\r\n}\r\n\r\n.input-group-append .input-group-text,\r\n.input-group-prepend .input-group-text {\r\n    background-color: transparent;\r\n    border: 1px solid lighten($black,5%);\r\n    border-radius: $border-radius-lg;\r\n    color: $white;\r\n\r\n    & i{\r\n      opacity: .5;\r\n    }\r\n\r\n    @include transition-input-focus-color();\r\n\r\n    .has-danger.input-group-focus &{\r\n        background-color: $transparent-bg;\r\n    }\r\n\r\n    .has-success &{\r\n        background-color: $transparent-bg;\r\n    }\r\n    .has-danger .form-control:focus + &{\r\n        color: $danger-states;\r\n    }\r\n    .has-success .form-control:focus + &{\r\n        color: $success;\r\n    }\r\n\r\n    & + .form-control,\r\n    & ~ .form-control{\r\n        @include input-size($padding-base-vertical - 1, $padding-base-horizontal);\r\n        padding-left: 18px;\r\n    }\r\n\r\n    i{\r\n        width: 17px;\r\n    }\r\n}\r\n\r\n.input-group-append,\r\n.input-group-prepend .input-group-text,\r\n.input-group-prepend .input-group-text {\r\n    background-color: transparent;\r\n    border: 1px solid lighten($black,5%);\r\n    border-radius: $border-radius-lg;\r\n    color: $white;\r\n    margin: 0;\r\n}\r\n\r\n.input-group-append .input-group-text{\r\n  border-left: none;\r\n}\r\n.input-group-prepend .input-group-text{\r\n  border-right: none;\r\n}\r\n\r\n.input-group-focus{\r\n    .input-group-prepend .input-group-text,\r\n    .input-group-append .input-group-text{\r\n        background-color: $white;\r\n        border-color: $primary;\r\n        background-color: $transparent-bg;\r\n        border-color: $primary;\r\n    }\r\n\r\n    &.no-border{\r\n        .input-group-prepend .input-group-text,\r\n        .input-group-append .input-group-text{\r\n            background-color: lighten($black,2%);\r\n        }\r\n    }\r\n}\r\n\r\n.input-group,\r\n.form-group{\r\n    margin-bottom: 10px;\r\n    position: relative;\r\n\r\n    .form-control-static{\r\n        margin-top: 9px;\r\n    }\r\n}\r\n\r\n.input-group[disabled]{\r\n    .input-group-prepend .input-group-text,\r\n    .input-group-append .input-group-text{\r\n        background-color: $light-gray;\r\n    }\r\n}\r\n\r\n.input-group .form-control:not(:first-child):not(:last-child), .input-group-btn:not(:first-child):not(:last-child){\r\n    border-radius: $border-radius-lg;\r\n    border-top-left-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n    border-left: 0 none;\r\n}\r\n\r\n.input-group .form-control:first-child,\r\n.input-group-btn:first-child > .dropdown-toggle,\r\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {\r\n    border-right: 0 none;\r\n}\r\n.input-group .form-control:last-child,\r\n.input-group-btn:last-child > .dropdown-toggle,\r\n.input-group-btn:first-child > .btn:not(:first-child) {\r\n    border-left: 0 none;\r\n}\r\n.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {\r\n    background-color: $black-states;\r\n    color: $default;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.input-group-btn .btn{\r\n    border-width: $border-thin;\r\n    padding: $padding-btn-vertical  $padding-base-horizontal;\r\n}\r\n.input-group-btn .btn-default:not(.btn-fill){\r\n    border-color: $medium-gray;\r\n}\r\n\r\n.input-group-btn:last-child > .btn{\r\n    margin-left: 0;\r\n}\r\n\r\ntextarea.form-control{\r\n    max-width: 100%;\r\n    max-height: 80px;\r\n    padding: 10px 10px 0 0;\r\n    resize: none;\r\n    line-height: 2;\r\n}\r\n\r\n.has-success,\r\n.has-danger{\r\n\r\n    &.form-group .form-control,\r\n    &.form-group.no-border .form-control{\r\n        padding-right: $input-padding-horizontal + 21;\r\n    }\r\n}\r\n\r\n.form.form-newsletter .form-group{\r\n    float: left;\r\n    width: 78%;\r\n    margin-right: 2%;\r\n    margin-top: 9px;\r\n}\r\n\r\n.input-group .input-group-btn{\r\n    padding: 0 12px;\r\n}\r\n\r\n// Input files - hide actual input - requires specific markup in the sample.\r\n.form-group input[type=file] {\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 100;\r\n}\r\n\r\n.form-text{\r\n    font-size: $font-size-sm;\r\n    color: rgba($white,0.8);\r\n}\r\n\r\n.form-control-lg{\r\n    padding: 0;\r\n    font-size: inherit;\r\n    line-height: 0;\r\n    border-radius: 0;\r\n\r\n    .form-control {\r\n      height: calc(2.875rem + 2px);\r\n    }\r\n}\r\n\r\n.form-horizontal{\r\n    .col-form-label,\r\n    .label-on-right{\r\n        padding: 10px 5px 0 15px;\r\n        text-align: right;\r\n        max-width: 180px;\r\n    }\r\n\r\n    .checkbox-radios{\r\n        margin-bottom: 15px;\r\n\r\n        .form-check:first-child{\r\n           margin-top: 8px;\r\n       }\r\n    }\r\n\r\n    .label-on-right{\r\n        text-align: left;\r\n        padding: 10px 15px 0 5px;\r\n    }\r\n\r\n    .form-check-inline{\r\n        margin-top: 6px;\r\n        .form-check-label{\r\n          margin-right: 1.5rem;\r\n        }\r\n    }\r\n}\r\n\r\n.search-bar{\r\n    margin-left: $margin-lg-vertical;\r\n      .btn{\r\n        margin: 0;\r\n      }\r\n       &.input-group{\r\n           border-radius: 25px;\r\n           z-index: 4;\r\n           margin-bottom: 0;\r\n           height: 43px;\r\n           padding-right: 5px;\r\n           .input-group-addon{\r\n              padding: 10px;\r\n               background: transparent;\r\n               border: none;\r\n               color: rgba(255, 255, 255, 0.7);\r\n\r\n           }\r\n\r\n           i{\r\n               font-size: 20px;\r\n               color: $white;\r\n               margin-top: 0 !important;\r\n           }\r\n           input{\r\n               background: transparent;\r\n               border:none !important;\r\n               border-radius: 0;\r\n               padding: 12px !important;\r\n               font-size: 12px;\r\n               opacity: 0.5;\r\n               &:focus{\r\n                   background: transparent;\r\n               }\r\n           }\r\n           .form-control{\r\n               opacity: 1;\r\n               color: $white;\r\n               &::placeholder{\r\n                 color: white;\r\n               }\r\n           }\r\n       }\r\n   }\r\n\r\n   .modal-search .modal-dialog{\r\n     max-width: 1000px;\r\n     margin: 20px auto;\r\n     .form-control{\r\n       border: none;\r\n       color: $black;\r\n       &::placeholder{\r\n         color: $black;\r\n       }\r\n     }\r\n   }\r\n\r\n.input-group-prepend{\r\n  margin-right: 0;\r\n}\r\n.input-group-prepend,\r\n.input-group-append {\r\n  .tim-icons {\r\n    font-size: $font-paragraph;\r\n  }\r\n}\r\n","/*\r\n * Container style\r\n */\r\n.ps {\r\n  overflow: hidden !important;\r\n  overflow-anchor: none;\r\n  -ms-overflow-style: none;\r\n  touch-action: auto;\r\n  -ms-touch-action: auto;\r\n}\r\n\r\n/*\r\n * Scrollbar rail styles\r\n */\r\n.ps__rail-x {\r\n  display: none;\r\n  opacity: 0;\r\n  transition: background-color .2s linear, opacity .2s linear;\r\n  -webkit-transition: background-color .2s linear, opacity .2s linear;\r\n  height: 15px;\r\n  /* there must be 'bottom' or 'top' for ps__rail-x */\r\n  bottom: 0px;\r\n  /* please don't change 'position' */\r\n  position: absolute;\r\n}\r\n\r\n.ps__rail-y {\r\n  display: none;\r\n  opacity: 0;\r\n  transition: background-color .2s linear, opacity .2s linear;\r\n  -webkit-transition: background-color .2s linear, opacity .2s linear;\r\n  width: 15px;\r\n  /* there must be 'right' or 'left' for ps__rail-y */\r\n  right: 0;\r\n  /* please don't change 'position' */\r\n  position: absolute;\r\n}\r\n\r\n.ps--active-x > .ps__rail-x,\r\n.ps--active-y > .ps__rail-y {\r\n  display: block;\r\n  background-color: transparent;\r\n}\r\n\r\n.ps:hover > .ps__rail-x,\r\n.ps:hover > .ps__rail-y,\r\n.ps--focus > .ps__rail-x,\r\n.ps--focus > .ps__rail-y,\r\n.ps--scrolling-x > .ps__rail-x,\r\n.ps--scrolling-y > .ps__rail-y {\r\n  opacity: 0.6;\r\n}\r\n\r\n.ps .ps__rail-x:hover,\r\n.ps .ps__rail-y:hover,\r\n.ps .ps__rail-x:focus,\r\n.ps .ps__rail-y:focus,\r\n.ps .ps__rail-x.ps--clicking,\r\n.ps .ps__rail-y.ps--clicking {\r\n  background-color: #eee;\r\n  opacity: 0.9;\r\n}\r\n\r\n/*\r\n * Scrollbar thumb styles\r\n */\r\n.ps__thumb-x {\r\n  background-color: #aaa;\r\n  border-radius: 6px;\r\n  transition: background-color .2s linear, height .2s ease-in-out;\r\n  -webkit-transition: background-color .2s linear, height .2s ease-in-out;\r\n  height: 6px;\r\n  /* there must be 'bottom' for ps__thumb-x */\r\n  bottom: 2px;\r\n  /* please don't change 'position' */\r\n  position: absolute;\r\n}\r\n\r\n.ps__thumb-y {\r\n  background-color: #aaa;\r\n  border-radius: 6px;\r\n  transition: background-color .2s linear, width .2s ease-in-out;\r\n  -webkit-transition: background-color .2s linear, width .2s ease-in-out;\r\n  width: 6px;\r\n  /* there must be 'right' for ps__thumb-y */\r\n  right: 2px;\r\n  /* please don't change 'position' */\r\n  position: absolute;\r\n}\r\n\r\n.ps__rail-x:hover > .ps__thumb-x,\r\n.ps__rail-x:focus > .ps__thumb-x,\r\n.ps__rail-x.ps--clicking .ps__thumb-x {\r\n  background-color: #999;\r\n  height: 11px;\r\n}\r\n\r\n.ps__rail-y:hover > .ps__thumb-y,\r\n.ps__rail-y:focus > .ps__thumb-y,\r\n.ps__rail-y.ps--clicking .ps__thumb-y {\r\n  background-color: #999;\r\n  width: 11px;\r\n}\r\n\r\n/* MS supports */\r\n@supports (-ms-overflow-style: none) {\r\n  .ps {\r\n    overflow: auto !important;\r\n  }\r\n}\r\n\r\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\r\n  .ps {\r\n    overflow: auto !important;\r\n  }\r\n}\r\n",".react-notification-alert-container{\r\n  z-index: 1051;\r\n  position: fixed;\r\n}\r\n",".white-content{\r\n\r\n  background: $light-bg;\r\n\r\n  .navbar.navbar-transparent .navbar-brand{\r\n    color: $black-states;\r\n  }\r\n\r\n  .navbar.navbar-transparent .navbar-toggler-bar{\r\n    background: $black-states;\r\n  }\r\n  .navbar.navbar-transparent .navbar-nav li a:not(.dropdown-item){\r\n      color: $black-states;\r\n      & i{\r\n        color: $black-states;\r\n      }\r\n  }\r\n\r\n  .navbar.navbar-transparent .navbar-minimize button i{\r\n    color: $black-states;\r\n  }\r\n\r\n  .navbar.navbar-transparent .search-bar.input-group i{\r\n    color: $black-states;\r\n  }\r\n  .navbar.navbar-transparent .search-bar.input-group .form-control{\r\n    color: $default;\r\n    &::placeholder{\r\n      color: $dark-gray;\r\n    }\r\n  }\r\n\r\n  .sidebar{\r\n    box-shadow: 0 2px 22px 0 rgba(0,0,0,.1), 0 4px 20px 0 rgba(0,0,0,.15);\r\n    p{\r\n      color: $opacity-8;\r\n    }\r\n  }\r\n\r\n  .main-panel{\r\n    background: $light-bg;\r\n  }\r\n\r\n  h1, h2, h3, h4, h5, h6, p, ol li, ul li, pre {\r\n    color: $black-states;\r\n  }\r\n\r\n  .font-icon-detail i{\r\n    color: $black;\r\n  }\r\n\r\n  .btn:not([data-action]):hover{\r\n    box-shadow:  0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);\r\n  }\r\n\r\n  .btn-neutral.btn-link{\r\n    color: rgba($black, 0.7);\r\n  }\r\n\r\n  //style for inputs\r\n\r\n  @include form-control-placeholder(rgba($black,0.4), 1);\r\n    .has-danger{\r\n      .form-control, .input-group-prepend .input-group-text{\r\n        border-color: $danger-states;\r\n      }\r\n    }\r\n\r\n    .input-group-prepend .input-group-text{\r\n      border-color: rgba($black-states,0.5);\r\n      color: $black-states;\r\n    }\r\n\r\n    .form-control{\r\n      color: $black;\r\n      border-color: rgba($black-states,0.5);\r\n      &:focus{\r\n        border-color: $primary;\r\n      }\r\n    }\r\n\r\n  .form-group.no-border,\r\n  .input-group.no-border{\r\n      .form-control,\r\n      .form-control + .input-group-prepend .input-group-text,\r\n      .form-control + .input-group-append .input-group-text,\r\n      .input-group-prepend .input-group-text,\r\n      .input-group-append .input-group-text{\r\n          background-color: $opacity-gray-3;\r\n          &:focus,\r\n          &:active,\r\n          &:active{\r\n              background-color: $opacity-gray-5;\r\n          }\r\n      }\r\n\r\n      .form-control{\r\n          &:focus{\r\n              & + .input-group-prepend .input-group-text,\r\n              & + .input-group-append .input-group-text{\r\n\r\n                  background-color: $transparent-bg;\r\n              }\r\n          }\r\n      }\r\n\r\n\r\n  }\r\n\r\n  .input-group[disabled]{\r\n      .input-group-prepend .input-group-text,\r\n      .input-group-append .input-group-text{\r\n          background-color: $black;\r\n      }\r\n  }\r\n\r\n  .form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control{\r\n    background: $light-gray;\r\n    border-color: rgba($black-states,0.3);\r\n  }\r\n\r\n  .input-group-focus{\r\n      .input-group-prepend .input-group-text,\r\n      .input-group-append .input-group-text,\r\n      .form-control{\r\n        border-color: $primary;\r\n      }\r\n\r\n      &.no-border{\r\n          .input-group-prepend .input-group-text,\r\n          .input-group-append .input-group-text{\r\n\r\n              background-color: $opacity-gray-5;\r\n          }\r\n      }\r\n  }\r\n  .input-group-prepend .input-group-text {\r\n      border-right: none;\r\n  }\r\n\r\n  .input-group-append .input-group-text {\r\n      border-left: none;\r\n  }\r\n\r\n  .has-danger .form-control:focus, .has-success.input-group-focus .input-group-append .input-group-text, .has-success.input-group-focus .input-group-prepend .input-group-text {\r\n    border-color: $danger-states;\r\n  }\r\n\r\n  .has-success .form-control:focus, .has-success.input-group-focus .input-group-append .input-group-text, .has-success.input-group-focus .input-group-prepend .input-group-text {\r\n    border-color: darken($success, 10%);\r\n  }\r\n\r\n  .btn.btn-link{\r\n    &:hover,&:active, &:focus{\r\n      color: $dark-gray !important;\r\n    }\r\n  }\r\n\r\n  .btn-group .btn.active{\r\n    box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);\r\n  }\r\n\r\n  .card:not(.card-white){\r\n    background: $white;\r\n    box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.05);\r\n    .card-header{\r\n      color: $black;\r\n      a[data-toggle=\"collapse\"]{\r\n        color: $black;\r\n      }\r\n    }\r\n    .card-header .card-title, .card-body .card-title{\r\n      color: $black-states;\r\n    }\r\n\r\n    .card-body{\r\n      .card-category, .card-description{\r\n        color: $black-states;\r\n      }\r\n    }\r\n\r\n\r\n    label:not(.btn){\r\n      color: $default;\r\n    }\r\n\r\n\r\n     &.nav-pills .nav-item .nav-link {\r\n        color: $nav-gray;\r\n        background-color: hsla(0,0%,87%,.3);\r\n        &:not(.active):hover{\r\n          background: hsla(0,0%,87%,.5);\r\n        }\r\n        &.active{\r\n          color: $white;\r\n\r\n        }\r\n    }\r\n\r\n    .tab-content .tab-pane {\r\n        color: $nav-gray;\r\n    }\r\n\r\n\r\n    .card{\r\n      box-shadow: none;\r\n    }\r\n\r\n    &.card-plain{\r\n      background: $transparent-bg;\r\n      box-shadow: none;\r\n    }\r\n\r\n    &.card-tasks{\r\n      .card-body{\r\n        i{\r\n          color: rgba(34,42,66,0.7);\r\n          &:hover{\r\n            color: $black;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .table{\r\n\r\n      > tbody > tr > td {\r\n        color: rgba($black, 0.7) !important;\r\n\r\n    }\r\n\r\n    > thead > tr > th,\r\n    > tbody > tr > th,\r\n    > tfoot > tr > th,\r\n    > thead > tr > td,\r\n    > tbody > tr > td,\r\n    > tfoot > tr > td{\r\n        border-color: rgba($black, 0.2);\r\n        padding: 12px 7px;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    > thead > tr > th, button.btn-neutral.btn-link{\r\n      color: rgba($black, 0.7);\r\n    }\r\n  }\r\n\r\n  .footer ul li a{\r\n    color: $black-states;\r\n  }\r\n\r\n  .footer .copyright{\r\n    color: $black-states;\r\n  }\r\n\r\n  .progress-container, .progress-container.progress.sm{\r\n      .progress{\r\n        background: rgba($black,0.1);\r\n        box-shadow: 0 0 0 3px rgba($black,0.1);\r\n        .progress-value{\r\n          color: $default;\r\n        }\r\n      }\r\n\r\n      .progress-badge{\r\n        color: $black-states;\r\n      }\r\n  }\r\n\r\n   .full-page{\r\n     background: $light-bg;\r\n\r\n     h1, h2, h3, h4, h5, h6, p, ol li, ul li, pre {\r\n       color: $black-states;\r\n     }\r\n\r\n     .description{\r\n       color: $dark-gray;\r\n     }\r\n\r\n     .footer ul li a{\r\n       color: $black-states;\r\n     }\r\n\r\n     .footer .copyright{\r\n       color: $black-states;\r\n     }\r\n   }\r\n\r\n   .nav-pills .nav-item .nav-link:not(.active){\r\n     background: darken($light-bg,10%);\r\n     color: $black-states;\r\n     &:hover{\r\n       background: darken($white,20%);\r\n\r\n     }\r\n   }\r\n}\r\n",".card{\r\n    background: $card-black-background;\r\n    border: 0;\r\n    position: relative;\r\n    width: 100%;\r\n    margin-bottom: 30px;\r\n    box-shadow: $box-shadow;\r\n\r\n\r\n    label{\r\n      color: rgba($white, 0.6);\r\n    }\r\n\r\n    .card-title {\r\n      margin-bottom: .75rem;\r\n    }\r\n\r\n    .card-body{\r\n      padding: 15px;\r\n\r\n      &.table-full-width{\r\n        padding-left: 0;\r\n        padding-right: 0;\r\n      }\r\n\r\n      .card-title{\r\n        color: $white;\r\n        text-transform: inherit;\r\n        font-weight: $font-weight-light;\r\n        margin-bottom: .75rem;\r\n      }\r\n\r\n      .card-description, .card-category{\r\n        color: rgba($white, 0.6);\r\n      }\r\n\r\n    }\r\n\r\n    .card-header{\r\n      &:not([data-background-color]){\r\n        background-color: transparent;\r\n      }\r\n      padding: 15px 15px 0;\r\n      border: 0;\r\n      color: rgba($white,0.8);\r\n\r\n      .card-title{\r\n          color: $white;\r\n          font-weight: 100;\r\n      }\r\n\r\n      .card-category{\r\n        color: $dark-gray;\r\n        margin-bottom: 5px;\r\n        font-weight: 300;\r\n      }\r\n    }\r\n\r\n    .map{\r\n        border-radius: $border-radius-sm;\r\n\r\n        &.map-big{\r\n          height: 420px;\r\n        }\r\n    }\r\n\r\n    &.card-white{\r\n      background: $white;\r\n\r\n      .card-title{\r\n        color: $black;\r\n      }\r\n      .card-category, .stats{\r\n        color: $card-stats-gray;\r\n      }\r\n\r\n      //style for inputs\r\n\r\n      @include form-control-placeholder(rgba($black,0.4), 1);\r\n        .has-danger{\r\n          .form-control, .input-group-prepend .input-group-text{\r\n            border-color: $danger-states;\r\n          }\r\n        }\r\n\r\n        .input-group-prepend .input-group-text{\r\n          border-color: rgba($black-states,0.2);\r\n          color: $black-states;\r\n        }\r\n\r\n        .form-control{\r\n          color: $black;\r\n          border-color: rgba($black-states,0.2);\r\n          &:focus{\r\n            border-color: $primary;\r\n          }\r\n        }\r\n        label:not(.btn){\r\n          color: $default;\r\n        }\r\n\r\n      .form-group.no-border,\r\n      .input-group.no-border {\r\n          .form-control,\r\n          .form-control + .input-group-prepend .input-group-text,\r\n          .form-control + .input-group-append .input-group-text,\r\n          .input-group-prepend .input-group-text,\r\n          .input-group-append .input-group-text{\r\n            background-color: $opacity-gray-3;\r\n              &:focus,\r\n              &:active,\r\n              &:active{\r\n                background-color: $opacity-gray-5;\r\n              }\r\n          }\r\n\r\n          .form-control {\r\n              &:focus {\r\n                  & + .input-group-prepend .input-group-text,\r\n                  & + .input-group-append .input-group-text{\r\n                    background-color: $transparent-bg;\r\n                  }\r\n              }\r\n          }\r\n\r\n\r\n      }\r\n\r\n      .input-group[disabled]{\r\n          .input-group-prepend .input-group-text,\r\n          .input-group-append .input-group-text{\r\n              background-color: $black;\r\n          }\r\n      }\r\n\r\n      .form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control{\r\n        background: $light-gray;\r\n        border-color: rgba($black-states,0.3);\r\n      }\r\n\r\n      .input-group-focus{\r\n          .input-group-prepend .input-group-text,\r\n          .input-group-append .input-group-text,\r\n          .form-control{\r\n            background-color: $white;\r\n            border-color: $primary;\r\n          }\r\n\r\n          &.no-border{\r\n              .input-group-prepend .input-group-text,\r\n              .input-group-append .input-group-text{\r\n\r\n                  background-color: $opacity-gray-5;\r\n              }\r\n          }\r\n      }\r\n      .input-group-prepend .input-group-text {\r\n          border-right: none;\r\n      }\r\n\r\n      .input-group-append .input-group-text {\r\n          border-left: none;\r\n      }\r\n\r\n      .has-danger .form-control:focus, .has-success.input-group-focus .input-group-append .input-group-text, .has-success.input-group-focus .input-group-prepend .input-group-text {\r\n        border-color: $danger-states;\r\n      }\r\n\r\n      .has-success .form-control:focus, .has-success.input-group-focus .input-group-append .input-group-text, .has-success.input-group-focus .input-group-prepend .input-group-text {\r\n        border-color: darken($success, 10%);\r\n      }\r\n    }\r\n\r\n\r\n    &.card-plain {\r\n      background: transparent;\r\n      box-shadow: none;\r\n    }\r\n\r\n    .image{\r\n        overflow: hidden;\r\n        height: 200px;\r\n        position: relative;\r\n    }\r\n\r\n    .avatar{\r\n        width: 30px;\r\n        height: 30px;\r\n        overflow: hidden;\r\n        border-radius: 50%;\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    label{\r\n        font-size: $font-size-sm;\r\n        margin-bottom: 5px;\r\n\r\n    }\r\n\r\n    .card-footer{\r\n        background-color: transparent;\r\n        border: 0;\r\n        padding: 15px;\r\n\r\n\r\n        .stats{\r\n            i{\r\n                margin-right: 5px;\r\n                position: relative;\r\n\r\n            }\r\n        }\r\n\r\n        h6{\r\n          margin-bottom: 0;\r\n          padding: 7px 0;\r\n        }\r\n    }\r\n}\r\n\r\n.card-body{\r\n  padding: $card-spacer-y;\r\n}\r\n\r\n@include media-breakpoint-down(sm) {\r\n  .card.card-chart .card-header {\r\n    .btn-group-toggle .tim-icons {\r\n      font-size: .875rem;\r\n      top: -1px;\r\n    }\r\n  }\r\n}\r\n",".card-chart {\r\n  overflow: hidden;\r\n  .card-header {\r\n    .card-title {\r\n      i {\r\n        font-size: 16px;\r\n        margin-right: 5px;\r\n        margin-bottom: 3px;\r\n      }\r\n    }\r\n    .card-category {\r\n      margin-bottom: 5px;\r\n    }\r\n  }\r\n  .card-body {\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n    .tab-space {\r\n      padding: 0;\r\n    }\r\n  }\r\n  .table {\r\n    margin-bottom: 0;\r\n\r\n    td {\r\n      border-top: none;\r\n      border-bottom: 1px solid rgba($white, 0.1);\r\n    }\r\n  }\r\n\r\n  .card-progress {\r\n    margin-top: 30px;\r\n    padding: 0 10px;\r\n  }\r\n\r\n  .chart-area {\r\n    // height: 220px;\r\n    // height: 360px;\r\n    width: 100%;\r\n  }\r\n  .card-footer {\r\n    margin-top: 15px;\r\n\r\n    .stats {\r\n      color: $dark-gray;\r\n    }\r\n  }\r\n\r\n  .dropdown {\r\n    position: absolute;\r\n    right: 20px;\r\n    top: 20px;\r\n\r\n    .btn {\r\n      margin: 0;\r\n    }\r\n  }\r\n\r\n  &.card-chart-pie {\r\n    .chart-area {\r\n      padding: 10px 0 25px;\r\n      height: auto;\r\n    }\r\n\r\n    .card-title {\r\n      margin-bottom: 10px;\r\n      i {\r\n        font-size: 1rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n",".map {\r\n  height: 500px;\r\n}\r\n",".card-user {\r\n  overflow: hidden;\r\n    .image {\r\n        height: 120px;\r\n    }\r\n\r\n    .author {\r\n        text-align: center;\r\n        text-transform: none;\r\n        margin-top: 25px;\r\n\r\n        a +  p.description {\r\n            margin-top: -7px;\r\n        }\r\n\r\n        .block {\r\n          position: absolute;\r\n          height: 100px;\r\n          width: 250px;\r\n          &.block-one {\r\n            @include linear-gradient-right(rgba($primary,0.6), rgba($primary,0));\r\n            @include nc-rotate(150deg,10);\r\n            margin-top: -90px;\r\n            margin-left: -50px;\r\n          }\r\n\r\n          &.block-two {\r\n            @include linear-gradient-right(rgba($primary,0.6), rgba($primary,0));\r\n            @include nc-rotate(30deg,10);\r\n            margin-top: -40px;\r\n            margin-left: -100px;\r\n          }\r\n\r\n          &.block-three {\r\n            @include linear-gradient-right(rgba($primary,0.6), rgba($primary,0));\r\n            @include nc-rotate(170deg,10);\r\n            margin-top: -70px;\r\n            right: -45px;\r\n\r\n          }\r\n\r\n          &.block-four {\r\n            @include linear-gradient-right(rgba($primary,0.6), rgba($primary,0));\r\n            @include nc-rotate(150deg,10);\r\n            margin-top: -25px;\r\n            right: -45px;\r\n\r\n          }\r\n        }\r\n    }\r\n\r\n    .avatar {\r\n      width: 124px;\r\n      height: 124px;\r\n      border: 5px solid lighten($black,5%);\r\n      border-bottom-color: $transparent-bg;\r\n      background-color: $transparent-bg;\r\n      position: relative;\r\n    }\r\n\r\n    .card-body {\r\n        min-height: 240px;\r\n    }\r\n\r\n    hr {\r\n        margin: 5px 15px;\r\n    }\r\n\r\n    .button-container {\r\n        margin-bottom: 6px;\r\n        text-align: center;\r\n    }\r\n\r\n    .card-description {\r\n      margin-top: 30px;\r\n    }\r\n}\r\n",".card-tasks {\r\n  height: 473px;\r\n\r\n  .table-full-width {\r\n    max-height: 410px;\r\n    position: relative;\r\n  }\r\n\r\n  .card-header {\r\n    .title {\r\n      margin-right: 20px;\r\n      font-weight: $font-weight-normal;\r\n    }\r\n\r\n    .dropdown {\r\n      float: right;\r\n      color: darken($white, 20%);\r\n    }\r\n  }\r\n\r\n  .card-body {\r\n    i {\r\n      color: $dark-gray;\r\n      font-size: 1.4em;\r\n      &:hover {\r\n        color: $white;\r\n      }\r\n    }\r\n  }\r\n}\r\n",".card-plain {\r\n  background: transparent;\r\n  box-shadow: none;\r\n\r\n  .card-header,\r\n  .card-footer {\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n    background-color: transparent;\r\n  }\r\n\r\n  &:not(.card-subcategories).card-body {\r\n      padding-left: 0;\r\n      padding-right: 0;\r\n  }\r\n}\r\n","select.form-control option {\r\n   color: #888;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
